var pp = Object.create;
var $o = Object.defineProperty;
var _p = Object.getOwnPropertyDescriptor;
var nl = (e, r) => (r = Symbol[e]) ? r : Symbol.for("Symbol." + e), jn = (e) => {
  throw TypeError(e);
};
var al = (e, r, t) => r in e ? $o(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t;
var tl = (e, r) => $o(e, "name", { value: r, configurable: !0 });
var ol = (e) => [, , , pp((e == null ? void 0 : e[nl("metadata")]) ?? null)], il = ["class", "method", "getter", "setter", "accessor", "field", "value", "get", "set"], ha = (e) => e !== void 0 && typeof e != "function" ? jn("Function expected") : e, gp = (e, r, t, n, a) => ({ kind: il[e], name: r, metadata: n, addInitializer: (o) => t._ ? jn("Already initialized") : a.push(ha(o || null)) }), Xo = (e, r) => al(r, nl("metadata"), e[3]), sl = (e, r, t, n) => {
  for (var a = 0, o = e[r >> 1], s = o && o.length; a < s; a++) r & 1 ? o[a].call(t) : n = o[a].call(t, n);
  return n;
}, Zo = (e, r, t, n, a, o) => {
  var s, l, c, u, d, p = r & 7, _ = !!(r & 8), g = !!(r & 16), f = p > 3 ? e.length + 1 : p ? _ ? 1 : 2 : 0, w = il[p + 5], k = p > 3 && (e[f - 1] = []), m = e[f] || (e[f] = []), h = p && (!g && !_ && (a = a.prototype), p < 5 && (p > 3 || !g) && _p(p < 4 ? a : { get [t]() {
    return O(this, o);
  }, set [t](y) {
    return be(this, o, y);
  } }, t));
  p ? g && p < 4 && tl(o, (p > 2 ? "set " : p > 1 ? "get " : "") + t) : tl(a, t);
  for (var v = n.length - 1; v >= 0; v--)
    u = gp(p, t, c = {}, e[3], m), p && (u.static = _, u.private = g, d = u.access = { has: g ? (y) => fp(a, y) : (y) => t in y }, p ^ 3 && (d.get = g ? (y) => (p ^ 1 ? O : or)(y, a, p ^ 4 ? o : h.get) : (y) => y[t]), p > 2 && (d.set = g ? (y, E) => be(y, a, E, p ^ 4 ? o : h.set) : (y, E) => y[t] = E)), l = (0, n[v])(p ? p < 4 ? g ? o : h[w] : p > 4 ? void 0 : { get: h.get, set: h.set } : a, u), c._ = 1, p ^ 4 || l === void 0 ? ha(l) && (p > 4 ? k.unshift(l) : p ? g ? o = l : h[w] = l : a = l) : typeof l != "object" || l === null ? jn("Object expected") : (ha(s = l.get) && (h.get = s), ha(s = l.set) && (h.set = s), ha(s = l.init) && k.unshift(s));
  return p || Xo(e, a), h && $o(a, t, h), g ? p ^ 4 ? o : h : a;
}, U = (e, r, t) => al(e, typeof r != "symbol" ? r + "" : r, t), Jo = (e, r, t) => r.has(e) || jn("Cannot " + t), fp = (e, r) => Object(r) !== r ? jn('Cannot use the "in" operator on this value') : e.has(r), O = (e, r, t) => (Jo(e, r, "read from private field"), t ? t.call(e) : r.get(e)), ke = (e, r, t) => r.has(e) ? jn("Cannot add the same private member more than once") : r instanceof WeakSet ? r.add(e) : r.set(e, t), be = (e, r, t, n) => (Jo(e, r, "write to private field"), n ? n.call(e, t) : r.set(e, t), t), or = (e, r, t) => (Jo(e, r, "access private method"), t);
const mp = "5";
var Ac;
typeof window < "u" && ((Ac = window.__svelte ?? (window.__svelte = {})).v ?? (Ac.v = /* @__PURE__ */ new Set())).add(mp);
const hp = 1, yp = 2, zc = 4, bp = 8, vp = 16, kp = 1, wp = 2, Pp = 4, xp = 8, Ep = 16, Sp = 1, Tp = 2, Ip = 4, Mc = 1, Dp = 2, ur = Symbol(), Cp = "http://www.w3.org/1999/xhtml", Ap = "http://www.w3.org/2000/svg", qp = "@attach", Fi = !1;
var jo = Array.isArray, Fp = Array.prototype.indexOf, No = Array.from, jc = Object.defineProperty, en = Object.getOwnPropertyDescriptor, Nc = Object.getOwnPropertyDescriptors, zp = Object.prototype, Mp = Array.prototype, gs = Object.getPrototypeOf, ll = Object.isExtensible;
function Bn(e) {
  return typeof e == "function";
}
const Fe = () => {
};
function jp(e) {
  return e();
}
function go(e) {
  for (var r = 0; r < e.length; r++)
    e[r]();
}
function Oc() {
  var e, r, t = new Promise((n, a) => {
    e = n, r = a;
  });
  return { promise: t, resolve: e, reject: r };
}
function Oo(e, r) {
  if (Array.isArray(e))
    return e;
  if (r === void 0 || !(Symbol.iterator in e))
    return Array.from(e);
  const t = [];
  for (const n of e)
    if (t.push(n), t.length === r) break;
  return t;
}
const br = 2, fo = 4, Va = 8, fs = 1 << 24, Ft = 16, Wt = 32, Tn = 64, ms = 128, Qr = 512, hr = 1024, Sr = 2048, zt = 4096, Rr = 8192, Bt = 16384, Lo = 32768, At = 65536, cl = 1 << 17, Lc = 1 << 18, ca = 1 << 19, Bc = 1 << 20, Nt = 1 << 25, Ia = 32768, zi = 1 << 21, hs = 1 << 22, rn = 1 << 23, Tt = Symbol("$state"), Uc = Symbol("legacy props"), Np = Symbol(""), Rn = new class extends Error {
  constructor() {
    super(...arguments);
    U(this, "name", "StaleReactionError");
    U(this, "message", "The reaction that called `getAbortSignal()` was re-run or destroyed");
  }
}();
function ys(e) {
  throw new Error("https://svelte.dev/e/lifecycle_outside_component");
}
function Op() {
  throw new Error("https://svelte.dev/e/async_derived_orphan");
}
function Lp(e) {
  throw new Error("https://svelte.dev/e/effect_in_teardown");
}
function Bp() {
  throw new Error("https://svelte.dev/e/effect_in_unowned_derived");
}
function Up(e) {
  throw new Error("https://svelte.dev/e/effect_orphan");
}
function Rp() {
  throw new Error("https://svelte.dev/e/effect_update_depth_exceeded");
}
function Vp(e) {
  throw new Error("https://svelte.dev/e/props_invalid_value");
}
function Hp() {
  throw new Error("https://svelte.dev/e/state_descriptors_fixed");
}
function Wp() {
  throw new Error("https://svelte.dev/e/state_prototype_fixed");
}
function Yp() {
  throw new Error("https://svelte.dev/e/state_unsafe_mutation");
}
function Gp() {
  throw new Error("https://svelte.dev/e/svelte_boundary_reset_onerror");
}
function Kp() {
  console.warn("https://svelte.dev/e/select_multiple_invalid_value");
}
function $p() {
  console.warn("https://svelte.dev/e/svelte_boundary_reset_noop");
}
function Rc(e) {
  return e === this.v;
}
function bs(e, r) {
  return e != e ? r == r : e !== r || e !== null && typeof e == "object" || typeof e == "function";
}
function Vc(e) {
  return !bs(e, this.v);
}
let ua = !1, Xp = !1;
function Zp() {
  ua = !0;
}
let Le = null;
function na(e) {
  Le = e;
}
function Be(e) {
  return (
    /** @type {T} */
    Hc().get(e)
  );
}
function ir(e, r) {
  return Hc().set(e, r), r;
}
function re(e, r = !1, t) {
  Le = {
    p: Le,
    i: !1,
    c: null,
    e: null,
    s: e,
    x: null,
    l: ua && !r ? { s: null, u: null, $: [] } : null
  };
}
function te(e) {
  var r = (
    /** @type {ComponentContext} */
    Le
  ), t = r.e;
  if (t !== null) {
    r.e = null;
    for (var n of t)
      uu(n);
  }
  return e !== void 0 && (r.x = e), r.i = !0, Le = r.p, e ?? /** @type {T} */
  {};
}
function Ha() {
  return !ua || Le !== null && Le.l === null;
}
function Hc(e) {
  return Le === null && ys(), Le.c ?? (Le.c = new Map(Jp(Le) || void 0));
}
function Jp(e) {
  let r = e.p;
  for (; r !== null; ) {
    const t = r.c;
    if (t !== null)
      return t;
    r = r.p;
  }
  return null;
}
let Vn = [];
function Qp() {
  var e = Vn;
  Vn = [], go(e);
}
function sn(e) {
  if (Vn.length === 0) {
    var r = Vn;
    queueMicrotask(() => {
      r === Vn && Qp();
    });
  }
  Vn.push(e);
}
function Wc(e) {
  var r = ze;
  if (r === null)
    return Ie.f |= rn, e;
  if ((r.f & Lo) === 0) {
    if ((r.f & ms) === 0)
      throw e;
    r.b.error(e);
  } else
    aa(e, r);
}
function aa(e, r) {
  for (; r !== null; ) {
    if ((r.f & ms) !== 0)
      try {
        r.b.error(e);
        return;
      } catch (t) {
        e = t;
      }
    r = r.parent;
  }
  throw e;
}
const e_ = -7169;
function sr(e, r) {
  e.f = e.f & e_ | r;
}
function vs(e) {
  (e.f & Qr) !== 0 || e.deps === null ? sr(e, hr) : sr(e, zt);
}
function Yc(e) {
  if (e !== null)
    for (const r of e)
      (r.f & br) === 0 || (r.f & Ia) === 0 || (r.f ^= Ia, Yc(
        /** @type {Derived} */
        r.deps
      ));
}
function Gc(e, r, t) {
  (e.f & Sr) !== 0 ? r.add(e) : (e.f & zt) !== 0 && t.add(e), Yc(e.deps), sr(e, hr);
}
const Ja = /* @__PURE__ */ new Set();
let Ve = null, fr = null, kt = [], ks = null, Mi = !1;
var $n, Xn, fn, mn, Na, Zn, Jn, et, ji, Ni, Kc, $c;
const Ao = class Ao {
  constructor() {
    ke(this, et);
    U(this, "committed", !1);
    /**
     * The current values of any sources that are updated in this batch
     * They keys of this map are identical to `this.#previous`
     * @type {Map<Source, any>}
     */
    U(this, "current", /* @__PURE__ */ new Map());
    /**
     * The values of any sources that are updated in this batch _before_ those updates took place.
     * They keys of this map are identical to `this.#current`
     * @type {Map<Source, any>}
     */
    U(this, "previous", /* @__PURE__ */ new Map());
    /**
     * When the batch is committed (and the DOM is updated), we need to remove old branches
     * and append new ones by calling the functions added inside (if/each/key/etc) blocks
     * @type {Set<() => void>}
     */
    ke(this, $n, /* @__PURE__ */ new Set());
    /**
     * If a fork is discarded, we need to destroy any effects that are no longer needed
     * @type {Set<(batch: Batch) => void>}
     */
    ke(this, Xn, /* @__PURE__ */ new Set());
    /**
     * The number of async effects that are currently in flight
     */
    ke(this, fn, 0);
    /**
     * The number of async effects that are currently in flight, _not_ inside a pending boundary
     */
    ke(this, mn, 0);
    /**
     * A deferred that resolves when the batch is committed, used with `settled()`
     * TODO replace with Promise.withResolvers once supported widely enough
     * @type {{ promise: Promise<void>, resolve: (value?: any) => void, reject: (reason: unknown) => void } | null}
     */
    ke(this, Na, null);
    /**
     * Deferred effects (which run after async work has completed) that are DIRTY
     * @type {Set<Effect>}
     */
    ke(this, Zn, /* @__PURE__ */ new Set());
    /**
     * Deferred effects that are MAYBE_DIRTY
     * @type {Set<Effect>}
     */
    ke(this, Jn, /* @__PURE__ */ new Set());
    /**
     * A set of branches that still exist, but will be destroyed when this batch
     * is committed — we skip over these during `process`
     * @type {Set<Effect>}
     */
    U(this, "skipped_effects", /* @__PURE__ */ new Set());
    U(this, "is_fork", !1);
  }
  is_deferred() {
    return this.is_fork || O(this, mn) > 0;
  }
  /**
   *
   * @param {Effect[]} root_effects
   */
  process(r) {
    var a;
    kt = [], this.apply();
    var t = [], n = [];
    for (const o of r)
      or(this, et, ji).call(this, o, t, n);
    this.is_fork || or(this, et, Kc).call(this), this.is_deferred() ? (or(this, et, Ni).call(this, n), or(this, et, Ni).call(this, t)) : (Ve = null, ul(n), ul(t), (a = O(this, Na)) == null || a.resolve()), fr = null;
  }
  /**
   * Associate a change to a given source with the current
   * batch, noting its previous and current values
   * @param {Source} source
   * @param {any} value
   */
  capture(r, t) {
    t !== ur && !this.previous.has(r) && this.previous.set(r, t), (r.f & rn) === 0 && (this.current.set(r, r.v), fr == null || fr.set(r, r.v));
  }
  activate() {
    Ve = this, this.apply();
  }
  deactivate() {
    Ve === this && (Ve = null, fr = null);
  }
  flush() {
    if (this.activate(), kt.length > 0) {
      if (r_(), Ve !== null && Ve !== this)
        return;
    } else O(this, fn) === 0 && this.process([]);
    this.deactivate();
  }
  discard() {
    for (const r of O(this, Xn)) r(this);
    O(this, Xn).clear();
  }
  /**
   *
   * @param {boolean} blocking
   */
  increment(r) {
    be(this, fn, O(this, fn) + 1), r && be(this, mn, O(this, mn) + 1);
  }
  /**
   *
   * @param {boolean} blocking
   */
  decrement(r) {
    be(this, fn, O(this, fn) - 1), r && be(this, mn, O(this, mn) - 1), this.revive();
  }
  revive() {
    for (const r of O(this, Zn))
      O(this, Jn).delete(r), sr(r, Sr), Ht(r);
    for (const r of O(this, Jn))
      sr(r, zt), Ht(r);
    this.flush();
  }
  /** @param {() => void} fn */
  oncommit(r) {
    O(this, $n).add(r);
  }
  /** @param {(batch: Batch) => void} fn */
  ondiscard(r) {
    O(this, Xn).add(r);
  }
  settled() {
    return (O(this, Na) ?? be(this, Na, Oc())).promise;
  }
  static ensure() {
    if (Ve === null) {
      const r = Ve = new Ao();
      Ja.add(Ve), Ao.enqueue(() => {
        Ve === r && r.flush();
      });
    }
    return Ve;
  }
  /** @param {() => void} task */
  static enqueue(r) {
    sn(r);
  }
  apply() {
  }
};
$n = new WeakMap(), Xn = new WeakMap(), fn = new WeakMap(), mn = new WeakMap(), Na = new WeakMap(), Zn = new WeakMap(), Jn = new WeakMap(), et = new WeakSet(), /**
 * Traverse the effect tree, executing effects or stashing
 * them for later execution as appropriate
 * @param {Effect} root
 * @param {Effect[]} effects
 * @param {Effect[]} render_effects
 */
ji = function(r, t, n) {
  r.f ^= hr;
  for (var a = r.first, o = null; a !== null; ) {
    var s = a.f, l = (s & (Wt | Tn)) !== 0, c = l && (s & hr) !== 0, u = c || (s & Rr) !== 0 || this.skipped_effects.has(a);
    if (!u && a.fn !== null) {
      l ? a.f ^= hr : o !== null && (s & (fo | Va | fs)) !== 0 ? o.b.defer_effect(a) : (s & fo) !== 0 ? t.push(a) : _a(a) && ((s & Ft) !== 0 && O(this, Zn).add(a), ia(a));
      var d = a.first;
      if (d !== null) {
        a = d;
        continue;
      }
    }
    var p = a.parent;
    for (a = a.next; a === null && p !== null; )
      p === o && (o = null), a = p.next, p = p.parent;
  }
}, /**
 * @param {Effect[]} effects
 */
Ni = function(r) {
  for (var t = 0; t < r.length; t += 1)
    Gc(r[t], O(this, Zn), O(this, Jn));
}, Kc = function() {
  if (O(this, mn) === 0) {
    for (const r of O(this, $n)) r();
    O(this, $n).clear();
  }
  O(this, fn) === 0 && or(this, et, $c).call(this);
}, $c = function() {
  var a;
  if (Ja.size > 1) {
    this.previous.clear();
    var r = fr, t = !0;
    for (const o of Ja) {
      if (o === this) {
        t = !1;
        continue;
      }
      const s = [];
      for (const [c, u] of this.current) {
        if (o.current.has(c))
          if (t && u !== o.current.get(c))
            o.current.set(c, u);
          else
            continue;
        s.push(c);
      }
      if (s.length === 0)
        continue;
      const l = [...o.current.keys()].filter((c) => !this.current.has(c));
      if (l.length > 0) {
        var n = kt;
        kt = [];
        const c = /* @__PURE__ */ new Set(), u = /* @__PURE__ */ new Map();
        for (const d of s)
          Xc(d, l, c, u);
        if (kt.length > 0) {
          Ve = o, o.apply();
          for (const d of kt)
            or(a = o, et, ji).call(a, d, [], []);
          o.deactivate();
        }
        kt = n;
      }
    }
    Ve = null, fr = r;
  }
  this.committed = !0, Ja.delete(this);
};
let Ot = Ao;
function r_() {
  var e = wn;
  Mi = !0;
  var r = null;
  try {
    var t = 0;
    for (ho(!0); kt.length > 0; ) {
      var n = Ot.ensure();
      if (t++ > 1e3) {
        var a, o;
        t_();
      }
      n.process(kt), tn.clear();
    }
  } finally {
    Mi = !1, ho(e), ks = null;
  }
}
function t_() {
  try {
    Rp();
  } catch (e) {
    aa(e, ks);
  }
}
let ot = null;
function ul(e) {
  var r = e.length;
  if (r !== 0) {
    for (var t = 0; t < r; ) {
      var n = e[t++];
      if ((n.f & (Bt | Rr)) === 0 && _a(n) && (ot = /* @__PURE__ */ new Set(), ia(n), n.deps === null && n.first === null && n.nodes === null && (n.teardown === null && n.ac === null ? fu(n) : n.fn = null), (ot == null ? void 0 : ot.size) > 0)) {
        tn.clear();
        for (const a of ot) {
          if ((a.f & (Bt | Rr)) !== 0) continue;
          const o = [a];
          let s = a.parent;
          for (; s !== null; )
            ot.has(s) && (ot.delete(s), o.push(s)), s = s.parent;
          for (let l = o.length - 1; l >= 0; l--) {
            const c = o[l];
            (c.f & (Bt | Rr)) === 0 && ia(c);
          }
        }
        ot.clear();
      }
    }
    ot = null;
  }
}
function Xc(e, r, t, n) {
  if (!t.has(e) && (t.add(e), e.reactions !== null))
    for (const a of e.reactions) {
      const o = a.f;
      (o & br) !== 0 ? Xc(
        /** @type {Derived} */
        a,
        r,
        t,
        n
      ) : (o & (hs | Ft)) !== 0 && (o & Sr) === 0 && Zc(a, r, n) && (sr(a, Sr), Ht(
        /** @type {Effect} */
        a
      ));
    }
}
function Zc(e, r, t) {
  const n = t.get(e);
  if (n !== void 0) return n;
  if (e.deps !== null)
    for (const a of e.deps) {
      if (r.includes(a))
        return !0;
      if ((a.f & br) !== 0 && Zc(
        /** @type {Derived} */
        a,
        r,
        t
      ))
        return t.set(
          /** @type {Derived} */
          a,
          !0
        ), !0;
    }
  return t.set(e, !1), !1;
}
function Ht(e) {
  for (var r = ks = e; r.parent !== null; ) {
    r = r.parent;
    var t = r.f;
    if (Mi && r === ze && (t & Ft) !== 0 && (t & Lc) === 0)
      return;
    if ((t & (Tn | Wt)) !== 0) {
      if ((t & hr) === 0) return;
      r.f ^= hr;
    }
  }
  kt.push(r);
}
function Jc(e) {
  let r = 0, t = xn(0), n;
  return () => {
    Ps() && (i(t), Ka(() => (r === 0 && (n = Ue(() => e(() => xa(t)))), r += 1, () => {
      sn(() => {
        r -= 1, r === 0 && (n == null || n(), n = void 0, xa(t));
      });
    })));
  };
}
var n_ = At | ca | ms;
function Qc(e, r, t) {
  new a_(e, r, t);
}
var $r, _s, Pt, hn, xt, Xr, Dr, Et, Mt, Xt, yn, Zt, bn, Qn, ea, Jt, qo, pr, o_, i_, Oi, uo, po, Li;
class a_ {
  /**
   * @param {TemplateNode} node
   * @param {BoundaryProps} props
   * @param {((anchor: Node) => void)} children
   */
  constructor(r, t, n) {
    ke(this, pr);
    /** @type {Boundary | null} */
    U(this, "parent");
    U(this, "is_pending", !1);
    /** @type {TemplateNode} */
    ke(this, $r);
    /** @type {TemplateNode | null} */
    ke(this, _s, null);
    /** @type {BoundaryProps} */
    ke(this, Pt);
    /** @type {((anchor: Node) => void)} */
    ke(this, hn);
    /** @type {Effect} */
    ke(this, xt);
    /** @type {Effect | null} */
    ke(this, Xr, null);
    /** @type {Effect | null} */
    ke(this, Dr, null);
    /** @type {Effect | null} */
    ke(this, Et, null);
    /** @type {DocumentFragment | null} */
    ke(this, Mt, null);
    /** @type {TemplateNode | null} */
    ke(this, Xt, null);
    ke(this, yn, 0);
    ke(this, Zt, 0);
    ke(this, bn, !1);
    /** @type {Set<Effect>} */
    ke(this, Qn, /* @__PURE__ */ new Set());
    /** @type {Set<Effect>} */
    ke(this, ea, /* @__PURE__ */ new Set());
    /**
     * A source containing the number of pending async deriveds/expressions.
     * Only created if `$effect.pending()` is used inside the boundary,
     * otherwise updating the source results in needless `Batch.ensure()`
     * calls followed by no-op flushes
     * @type {Source<number> | null}
     */
    ke(this, Jt, null);
    ke(this, qo, Jc(() => (be(this, Jt, xn(O(this, yn))), () => {
      be(this, Jt, null);
    })));
    be(this, $r, r), be(this, Pt, t), be(this, hn, n), this.parent = /** @type {Effect} */
    ze.b, this.is_pending = !!O(this, Pt).pending, be(this, xt, pa(() => {
      ze.b = this;
      {
        var a = or(this, pr, Oi).call(this);
        try {
          be(this, Xr, Cr(() => n(a)));
        } catch (o) {
          this.error(o);
        }
        O(this, Zt) > 0 ? or(this, pr, po).call(this) : this.is_pending = !1;
      }
      return () => {
        var o;
        (o = O(this, Xt)) == null || o.remove();
      };
    }, n_));
  }
  /**
   * Defer an effect inside a pending boundary until the boundary resolves
   * @param {Effect} effect
   */
  defer_effect(r) {
    Gc(r, O(this, Qn), O(this, ea));
  }
  /**
   * Returns `false` if the effect exists inside a boundary whose pending snippet is shown
   * @returns {boolean}
   */
  is_rendered() {
    return !this.is_pending && (!this.parent || this.parent.is_rendered());
  }
  has_pending_snippet() {
    return !!O(this, Pt).pending;
  }
  /**
   * Update the source that powers `$effect.pending()` inside this boundary,
   * and controls when the current `pending` snippet (if any) is removed.
   * Do not call from inside the class
   * @param {1 | -1} d
   */
  update_pending_count(r) {
    or(this, pr, Li).call(this, r), be(this, yn, O(this, yn) + r), O(this, Jt) && oa(O(this, Jt), O(this, yn));
  }
  get_effect_pending() {
    return O(this, qo).call(this), i(
      /** @type {Source<number>} */
      O(this, Jt)
    );
  }
  /** @param {unknown} error */
  error(r) {
    var t = O(this, Pt).onerror;
    let n = O(this, Pt).failed;
    if (O(this, bn) || !t && !n)
      throw r;
    O(this, Xr) && (yr(O(this, Xr)), be(this, Xr, null)), O(this, Dr) && (yr(O(this, Dr)), be(this, Dr, null)), O(this, Et) && (yr(O(this, Et)), be(this, Et, null));
    var a = !1, o = !1;
    const s = () => {
      if (a) {
        $p();
        return;
      }
      a = !0, o && Gp(), Ot.ensure(), be(this, yn, 0), O(this, Et) !== null && kn(O(this, Et), () => {
        be(this, Et, null);
      }), this.is_pending = this.has_pending_snippet(), be(this, Xr, or(this, pr, uo).call(this, () => (be(this, bn, !1), Cr(() => O(this, hn).call(this, O(this, $r)))))), O(this, Zt) > 0 ? or(this, pr, po).call(this) : this.is_pending = !1;
    };
    var l = Ie;
    try {
      qr(null), o = !0, t == null || t(r, s), o = !1;
    } catch (c) {
      aa(c, O(this, xt) && O(this, xt).parent);
    } finally {
      qr(l);
    }
    n && sn(() => {
      be(this, Et, or(this, pr, uo).call(this, () => {
        Ot.ensure(), be(this, bn, !0);
        try {
          return Cr(() => {
            n(
              O(this, $r),
              () => r,
              () => s
            );
          });
        } catch (c) {
          return aa(
            c,
            /** @type {Effect} */
            O(this, xt).parent
          ), null;
        } finally {
          be(this, bn, !1);
        }
      }));
    });
  }
}
$r = new WeakMap(), _s = new WeakMap(), Pt = new WeakMap(), hn = new WeakMap(), xt = new WeakMap(), Xr = new WeakMap(), Dr = new WeakMap(), Et = new WeakMap(), Mt = new WeakMap(), Xt = new WeakMap(), yn = new WeakMap(), Zt = new WeakMap(), bn = new WeakMap(), Qn = new WeakMap(), ea = new WeakMap(), Jt = new WeakMap(), qo = new WeakMap(), pr = new WeakSet(), o_ = function() {
  try {
    be(this, Xr, Cr(() => O(this, hn).call(this, O(this, $r))));
  } catch (r) {
    this.error(r);
  }
}, i_ = function() {
  const r = O(this, Pt).pending;
  r && (be(this, Dr, Cr(() => r(O(this, $r)))), Ot.enqueue(() => {
    var t = or(this, pr, Oi).call(this);
    be(this, Xr, or(this, pr, uo).call(this, () => (Ot.ensure(), Cr(() => O(this, hn).call(this, t))))), O(this, Zt) > 0 ? or(this, pr, po).call(this) : (kn(
      /** @type {Effect} */
      O(this, Dr),
      () => {
        be(this, Dr, null);
      }
    ), this.is_pending = !1);
  }));
}, Oi = function() {
  var r = O(this, $r);
  return this.is_pending && (be(this, Xt, It()), O(this, $r).before(O(this, Xt)), r = O(this, Xt)), r;
}, /**
 * @param {() => Effect | null} fn
 */
uo = function(r) {
  var t = ze, n = Ie, a = Le;
  qt(O(this, xt)), qr(O(this, xt)), na(O(this, xt).ctx);
  try {
    return r();
  } catch (o) {
    return Wc(o), null;
  } finally {
    qt(t), qr(n), na(a);
  }
}, po = function() {
  const r = (
    /** @type {(anchor: Node) => void} */
    O(this, Pt).pending
  );
  O(this, Xr) !== null && (be(this, Mt, document.createDocumentFragment()), O(this, Mt).append(
    /** @type {TemplateNode} */
    O(this, Xt)
  ), yu(O(this, Xr), O(this, Mt))), O(this, Dr) === null && be(this, Dr, Cr(() => r(O(this, $r))));
}, /**
 * Updates the pending count associated with the currently visible pending snippet,
 * if any, such that we can replace the snippet with content once work is done
 * @param {1 | -1} d
 */
Li = function(r) {
  var t;
  if (!this.has_pending_snippet()) {
    this.parent && or(t = this.parent, pr, Li).call(t, r);
    return;
  }
  if (be(this, Zt, O(this, Zt) + r), O(this, Zt) === 0) {
    this.is_pending = !1;
    for (const n of O(this, Qn))
      sr(n, Sr), Ht(n);
    for (const n of O(this, ea))
      sr(n, zt), Ht(n);
    O(this, Qn).clear(), O(this, ea).clear(), O(this, Dr) && kn(O(this, Dr), () => {
      be(this, Dr, null);
    }), O(this, Mt) && (O(this, $r).before(O(this, Mt)), be(this, Mt, null));
  }
};
function eu(e, r, t, n) {
  const a = Ha() ? Wa : Ut;
  if (t.length === 0 && e.length === 0) {
    n(r.map(a));
    return;
  }
  var o = Ve, s = (
    /** @type {Effect} */
    ze
  ), l = s_();
  function c() {
    Promise.all(t.map((u) => /* @__PURE__ */ l_(u))).then((u) => {
      l();
      try {
        n([...r.map(a), ...u]);
      } catch (d) {
        (s.f & Bt) === 0 && aa(d, s);
      }
      o == null || o.deactivate(), mo();
    }).catch((u) => {
      aa(u, s);
    });
  }
  e.length > 0 ? Promise.all(e).then(() => {
    l();
    try {
      return c();
    } finally {
      o == null || o.deactivate(), mo();
    }
  }) : c();
}
function s_() {
  var e = ze, r = Ie, t = Le, n = Ve;
  return function(o = !0) {
    qt(e), qr(r), na(t), o && (n == null || n.activate());
  };
}
function mo() {
  qt(null), qr(null), na(null);
}
// @__NO_SIDE_EFFECTS__
function Wa(e) {
  var r = br | Sr, t = Ie !== null && (Ie.f & br) !== 0 ? (
    /** @type {Derived} */
    Ie
  ) : null;
  return ze !== null && (ze.f |= ca), {
    ctx: Le,
    deps: null,
    effects: null,
    equals: Rc,
    f: r,
    fn: e,
    reactions: null,
    rv: 0,
    v: (
      /** @type {V} */
      ur
    ),
    wv: 0,
    parent: t ?? ze,
    ac: null
  };
}
// @__NO_SIDE_EFFECTS__
function l_(e, r, t) {
  let n = (
    /** @type {Effect | null} */
    ze
  );
  n === null && Op();
  var a = (
    /** @type {Boundary} */
    n.b
  ), o = (
    /** @type {Promise<V>} */
    /** @type {unknown} */
    void 0
  ), s = xn(
    /** @type {V} */
    ur
  ), l = !Ie, c = /* @__PURE__ */ new Map();
  return b_(() => {
    var g;
    var u = Oc();
    o = u.promise;
    try {
      Promise.resolve(e()).then(u.resolve, u.reject).then(() => {
        d === Ve && d.committed && d.deactivate(), mo();
      });
    } catch (f) {
      u.reject(f), mo();
    }
    var d = (
      /** @type {Batch} */
      Ve
    );
    if (l) {
      var p = a.is_rendered();
      a.update_pending_count(1), d.increment(p), (g = c.get(d)) == null || g.reject(Rn), c.delete(d), c.set(d, u);
    }
    const _ = (f, w = void 0) => {
      if (d.activate(), w)
        w !== Rn && (s.f |= rn, oa(s, w));
      else {
        (s.f & rn) !== 0 && (s.f ^= rn), oa(s, f);
        for (const [k, m] of c) {
          if (c.delete(k), k === d) break;
          m.reject(Rn);
        }
      }
      l && (a.update_pending_count(-1), d.decrement(p));
    };
    u.promise.then(_, (f) => _(null, f || "unknown"));
  }), da(() => {
    for (const u of c.values())
      u.reject(Rn);
  }), new Promise((u) => {
    function d(p) {
      function _() {
        p === o ? u(s) : d(o);
      }
      p.then(_, _);
    }
    d(o);
  });
}
// @__NO_SIDE_EFFECTS__
function b(e) {
  const r = /* @__PURE__ */ Wa(e);
  return bu(r), r;
}
// @__NO_SIDE_EFFECTS__
function Ut(e) {
  const r = /* @__PURE__ */ Wa(e);
  return r.equals = Vc, r;
}
function ru(e) {
  var r = e.effects;
  if (r !== null) {
    e.effects = null;
    for (var t = 0; t < r.length; t += 1)
      yr(
        /** @type {Effect} */
        r[t]
      );
  }
}
function c_(e) {
  for (var r = e.parent; r !== null; ) {
    if ((r.f & br) === 0)
      return (r.f & Bt) === 0 ? (
        /** @type {Effect} */
        r
      ) : null;
    r = r.parent;
  }
  return null;
}
function ws(e) {
  var r, t = ze;
  qt(c_(e));
  try {
    e.f &= ~Ia, ru(e), r = Pu(e);
  } finally {
    qt(t);
  }
  return r;
}
function tu(e) {
  var r = ws(e);
  if (!e.equals(r) && (e.wv = ku(), (!(Ve != null && Ve.is_fork) || e.deps === null) && (e.v = r, e.deps === null))) {
    sr(e, hr);
    return;
  }
  an || (fr !== null ? (Ps() || Ve != null && Ve.is_fork) && fr.set(e, r) : vs(e));
}
let Bi = /* @__PURE__ */ new Set();
const tn = /* @__PURE__ */ new Map();
let nu = !1;
function xn(e, r) {
  var t = {
    f: 0,
    // TODO ideally we could skip this altogether, but it causes type errors
    v: e,
    reactions: null,
    equals: Rc,
    rv: 0,
    wv: 0
  };
  return t;
}
// @__NO_SIDE_EFFECTS__
function X(e, r) {
  const t = xn(e);
  return bu(t), t;
}
// @__NO_SIDE_EFFECTS__
function Or(e, r = !1, t = !0) {
  var a;
  const n = xn(e);
  return r || (n.equals = Vc), ua && t && Le !== null && Le.l !== null && ((a = Le.l).s ?? (a.s = [])).push(n), n;
}
function L(e, r, t = !1) {
  Ie !== null && // since we are untracking the function inside `$inspect.with` we need to add this check
  // to ensure we error if state is set inside an inspect effect
  (!st || (Ie.f & cl) !== 0) && Ha() && (Ie.f & (br | Ft | hs | cl)) !== 0 && !(Er != null && Er.includes(e)) && Yp();
  let n = t ? $e(r) : r;
  return oa(e, n);
}
function oa(e, r) {
  if (!e.equals(r)) {
    var t = e.v;
    an ? tn.set(e, r) : tn.set(e, t), e.v = r;
    var n = Ot.ensure();
    if (n.capture(e, t), (e.f & br) !== 0) {
      const a = (
        /** @type {Derived} */
        e
      );
      (e.f & Sr) !== 0 && ws(a), vs(a);
    }
    e.wv = ku(), au(e, Sr), Ha() && ze !== null && (ze.f & hr) !== 0 && (ze.f & (Wt | Tn)) === 0 && (Kr === null ? k_([e]) : Kr.push(e)), !n.is_fork && Bi.size > 0 && !nu && u_();
  }
  return r;
}
function u_() {
  nu = !1;
  var e = wn;
  ho(!0);
  const r = Array.from(Bi);
  try {
    for (const t of r)
      (t.f & hr) !== 0 && sr(t, zt), _a(t) && ia(t);
  } finally {
    ho(e);
  }
  Bi.clear();
}
function xa(e) {
  L(e, e.v + 1);
}
function au(e, r) {
  var t = e.reactions;
  if (t !== null)
    for (var n = Ha(), a = t.length, o = 0; o < a; o++) {
      var s = t[o], l = s.f;
      if (!(!n && s === ze)) {
        var c = (l & Sr) === 0;
        if (c && sr(s, r), (l & br) !== 0) {
          var u = (
            /** @type {Derived} */
            s
          );
          fr == null || fr.delete(u), (l & Ia) === 0 && (l & Qr && (s.f |= Ia), au(u, zt));
        } else c && ((l & Ft) !== 0 && ot !== null && ot.add(
          /** @type {Effect} */
          s
        ), Ht(
          /** @type {Effect} */
          s
        ));
      }
    }
}
function $e(e) {
  if (typeof e != "object" || e === null || Tt in e)
    return e;
  const r = gs(e);
  if (r !== zp && r !== Mp)
    return e;
  var t = /* @__PURE__ */ new Map(), n = jo(e), a = /* @__PURE__ */ X(0), o = Pn, s = (l) => {
    if (Pn === o)
      return l();
    var c = Ie, u = Pn;
    qr(null), gl(o);
    var d = l();
    return qr(c), gl(u), d;
  };
  return n && t.set("length", /* @__PURE__ */ X(
    /** @type {any[]} */
    e.length
  )), new Proxy(
    /** @type {any} */
    e,
    {
      defineProperty(l, c, u) {
        (!("value" in u) || u.configurable === !1 || u.enumerable === !1 || u.writable === !1) && Hp();
        var d = t.get(c);
        return d === void 0 ? d = s(() => {
          var p = /* @__PURE__ */ X(u.value);
          return t.set(c, p), p;
        }) : L(d, u.value, !0), !0;
      },
      deleteProperty(l, c) {
        var u = t.get(c);
        if (u === void 0) {
          if (c in l) {
            const d = s(() => /* @__PURE__ */ X(ur));
            t.set(c, d), xa(a);
          }
        } else
          L(u, ur), xa(a);
        return !0;
      },
      get(l, c, u) {
        var g;
        if (c === Tt)
          return e;
        var d = t.get(c), p = c in l;
        if (d === void 0 && (!p || (g = en(l, c)) != null && g.writable) && (d = s(() => {
          var f = $e(p ? l[c] : ur), w = /* @__PURE__ */ X(f);
          return w;
        }), t.set(c, d)), d !== void 0) {
          var _ = i(d);
          return _ === ur ? void 0 : _;
        }
        return Reflect.get(l, c, u);
      },
      getOwnPropertyDescriptor(l, c) {
        var u = Reflect.getOwnPropertyDescriptor(l, c);
        if (u && "value" in u) {
          var d = t.get(c);
          d && (u.value = i(d));
        } else if (u === void 0) {
          var p = t.get(c), _ = p == null ? void 0 : p.v;
          if (p !== void 0 && _ !== ur)
            return {
              enumerable: !0,
              configurable: !0,
              value: _,
              writable: !0
            };
        }
        return u;
      },
      has(l, c) {
        var _;
        if (c === Tt)
          return !0;
        var u = t.get(c), d = u !== void 0 && u.v !== ur || Reflect.has(l, c);
        if (u !== void 0 || ze !== null && (!d || (_ = en(l, c)) != null && _.writable)) {
          u === void 0 && (u = s(() => {
            var g = d ? $e(l[c]) : ur, f = /* @__PURE__ */ X(g);
            return f;
          }), t.set(c, u));
          var p = i(u);
          if (p === ur)
            return !1;
        }
        return d;
      },
      set(l, c, u, d) {
        var v;
        var p = t.get(c), _ = c in l;
        if (n && c === "length")
          for (var g = u; g < /** @type {Source<number>} */
          p.v; g += 1) {
            var f = t.get(g + "");
            f !== void 0 ? L(f, ur) : g in l && (f = s(() => /* @__PURE__ */ X(ur)), t.set(g + "", f));
          }
        if (p === void 0)
          (!_ || (v = en(l, c)) != null && v.writable) && (p = s(() => /* @__PURE__ */ X(void 0)), L(p, $e(u)), t.set(c, p));
        else {
          _ = p.v !== ur;
          var w = s(() => $e(u));
          L(p, w);
        }
        var k = Reflect.getOwnPropertyDescriptor(l, c);
        if (k != null && k.set && k.set.call(d, u), !_) {
          if (n && typeof c == "string") {
            var m = (
              /** @type {Source<number>} */
              t.get("length")
            ), h = Number(c);
            Number.isInteger(h) && h >= m.v && L(m, h + 1);
          }
          xa(a);
        }
        return !0;
      },
      ownKeys(l) {
        i(a);
        var c = Reflect.ownKeys(l).filter((p) => {
          var _ = t.get(p);
          return _ === void 0 || _.v !== ur;
        });
        for (var [u, d] of t)
          d.v !== ur && !(u in l) && c.push(u);
        return c;
      },
      setPrototypeOf() {
        Wp();
      }
    }
  );
}
function dl(e) {
  try {
    if (e !== null && typeof e == "object" && Tt in e)
      return e[Tt];
  } catch {
  }
  return e;
}
function d_(e, r) {
  return Object.is(dl(e), dl(r));
}
var pl, ou, iu, su;
function p_() {
  if (pl === void 0) {
    pl = window, ou = /Firefox/.test(navigator.userAgent);
    var e = Element.prototype, r = Node.prototype, t = Text.prototype;
    iu = en(r, "firstChild").get, su = en(r, "nextSibling").get, ll(e) && (e.__click = void 0, e.__className = void 0, e.__attributes = null, e.__style = void 0, e.__e = void 0), ll(t) && (t.__t = void 0);
  }
}
function It(e = "") {
  return document.createTextNode(e);
}
// @__NO_SIDE_EFFECTS__
function Br(e) {
  return (
    /** @type {TemplateNode | null} */
    iu.call(e)
  );
}
// @__NO_SIDE_EFFECTS__
function Ya(e) {
  return (
    /** @type {TemplateNode | null} */
    su.call(e)
  );
}
function F(e, r) {
  return /* @__PURE__ */ Br(e);
}
function Q(e, r = !1) {
  {
    var t = /* @__PURE__ */ Br(e);
    return t instanceof Comment && t.data === "" ? /* @__PURE__ */ Ya(t) : t;
  }
}
function V(e, r = 1, t = !1) {
  let n = e;
  for (; r--; )
    n = /** @type {TemplateNode} */
    /* @__PURE__ */ Ya(n);
  return n;
}
function __(e) {
  e.textContent = "";
}
function lu() {
  return !1;
}
function g_(e, r) {
  if (r) {
    const t = document.body;
    e.autofocus = !0, sn(() => {
      document.activeElement === t && e.focus();
    });
  }
}
function Ga(e) {
  var r = Ie, t = ze;
  qr(null), qt(null);
  try {
    return e();
  } finally {
    qr(r), qt(t);
  }
}
function cu(e) {
  ze === null && (Ie === null && Up(), Bp()), an && Lp();
}
function f_(e, r) {
  var t = r.last;
  t === null ? r.last = r.first = e : (t.next = e, e.prev = t, r.last = e);
}
function ut(e, r, t) {
  var n = ze;
  n !== null && (n.f & Rr) !== 0 && (e |= Rr);
  var a = {
    ctx: Le,
    deps: null,
    nodes: null,
    f: e | Sr | Qr,
    first: null,
    fn: r,
    last: null,
    next: null,
    parent: n,
    b: n && n.b,
    prev: null,
    teardown: null,
    wv: 0,
    ac: null
  };
  if (t)
    try {
      ia(a), a.f |= Lo;
    } catch (l) {
      throw yr(a), l;
    }
  else r !== null && Ht(a);
  var o = a;
  if (t && o.deps === null && o.teardown === null && o.nodes === null && o.first === o.last && // either `null`, or a singular child
  (o.f & ca) === 0 && (o = o.first, (e & Ft) !== 0 && (e & At) !== 0 && o !== null && (o.f |= At)), o !== null && (o.parent = n, n !== null && f_(o, n), Ie !== null && (Ie.f & br) !== 0 && (e & Tn) === 0)) {
    var s = (
      /** @type {Derived} */
      Ie
    );
    (s.effects ?? (s.effects = [])).push(o);
  }
  return a;
}
function Ps() {
  return Ie !== null && !st;
}
function da(e) {
  const r = ut(Va, null, !1);
  return sr(r, hr), r.teardown = e, r;
}
function xr(e) {
  cu();
  var r = (
    /** @type {Effect} */
    ze.f
  ), t = !Ie && (r & Wt) !== 0 && (r & Lo) === 0;
  if (t) {
    var n = (
      /** @type {ComponentContext} */
      Le
    );
    (n.e ?? (n.e = [])).push(e);
  } else
    return uu(e);
}
function uu(e) {
  return ut(fo | Bc, e, !1);
}
function m_(e) {
  return cu(), ut(Va | Bc, e, !0);
}
function h_(e) {
  Ot.ensure();
  const r = ut(Tn | ca, e, !0);
  return (t = {}) => new Promise((n) => {
    t.outro ? kn(r, () => {
      yr(r), n(void 0);
    }) : (yr(r), n(void 0));
  });
}
function In(e) {
  return ut(fo, e, !1);
}
function dt(e, r) {
  var t = (
    /** @type {ComponentContextLegacy} */
    Le
  ), n = { effect: null, ran: !1, deps: e };
  t.l.$.push(n), n.effect = Ka(() => {
    e(), !n.ran && (n.ran = !0, Ue(r));
  });
}
function y_() {
  var e = (
    /** @type {ComponentContextLegacy} */
    Le
  );
  Ka(() => {
    for (var r of e.l.$) {
      r.deps();
      var t = r.effect;
      (t.f & hr) !== 0 && t.deps !== null && sr(t, zt), _a(t) && ia(t), r.ran = !1;
    }
  });
}
function b_(e) {
  return ut(hs | ca, e, !0);
}
function Ka(e, r = 0) {
  return ut(Va | r, e, !0);
}
function R(e, r = [], t = [], n = []) {
  eu(n, r, t, (a) => {
    ut(Va, () => e(...a.map(i)), !0);
  });
}
function pa(e, r = 0) {
  var t = ut(Ft | r, e, !0);
  return t;
}
function du(e, r = 0) {
  var t = ut(fs | r, e, !0);
  return t;
}
function Cr(e) {
  return ut(Wt | ca, e, !0);
}
function pu(e) {
  var r = e.teardown;
  if (r !== null) {
    const t = an, n = Ie;
    _l(!0), qr(null);
    try {
      r.call(null);
    } finally {
      _l(t), qr(n);
    }
  }
}
function _u(e, r = !1) {
  var t = e.first;
  for (e.first = e.last = null; t !== null; ) {
    const a = t.ac;
    a !== null && Ga(() => {
      a.abort(Rn);
    });
    var n = t.next;
    (t.f & Tn) !== 0 ? t.parent = null : yr(t, r), t = n;
  }
}
function v_(e) {
  for (var r = e.first; r !== null; ) {
    var t = r.next;
    (r.f & Wt) === 0 && yr(r), r = t;
  }
}
function yr(e, r = !0) {
  var t = !1;
  (r || (e.f & Lc) !== 0) && e.nodes !== null && e.nodes.end !== null && (gu(
    e.nodes.start,
    /** @type {TemplateNode} */
    e.nodes.end
  ), t = !0), _u(e, r && !t), yo(e, 0), sr(e, Bt);
  var n = e.nodes && e.nodes.t;
  if (n !== null)
    for (const o of n)
      o.stop();
  pu(e);
  var a = e.parent;
  a !== null && a.first !== null && fu(e), e.next = e.prev = e.teardown = e.ctx = e.deps = e.fn = e.nodes = e.ac = null;
}
function gu(e, r) {
  for (; e !== null; ) {
    var t = e === r ? null : /* @__PURE__ */ Ya(e);
    e.remove(), e = t;
  }
}
function fu(e) {
  var r = e.parent, t = e.prev, n = e.next;
  t !== null && (t.next = n), n !== null && (n.prev = t), r !== null && (r.first === e && (r.first = n), r.last === e && (r.last = t));
}
function kn(e, r, t = !0) {
  var n = [];
  mu(e, n, !0);
  var a = () => {
    t && yr(e), r && r();
  }, o = n.length;
  if (o > 0) {
    var s = () => --o || a();
    for (var l of n)
      l.out(s);
  } else
    a();
}
function mu(e, r, t) {
  if ((e.f & Rr) === 0) {
    e.f ^= Rr;
    var n = e.nodes && e.nodes.t;
    if (n !== null)
      for (const l of n)
        (l.is_global || t) && r.push(l);
    for (var a = e.first; a !== null; ) {
      var o = a.next, s = (a.f & At) !== 0 || // If this is a branch effect without a block effect parent,
      // it means the parent block effect was pruned. In that case,
      // transparency information was transferred to the branch effect.
      (a.f & Wt) !== 0 && (e.f & Ft) !== 0;
      mu(a, r, s ? t : !1), a = o;
    }
  }
}
function xs(e) {
  hu(e, !0);
}
function hu(e, r) {
  if ((e.f & Rr) !== 0) {
    e.f ^= Rr, (e.f & hr) === 0 && (sr(e, Sr), Ht(e));
    for (var t = e.first; t !== null; ) {
      var n = t.next, a = (t.f & At) !== 0 || (t.f & Wt) !== 0;
      hu(t, a ? r : !1), t = n;
    }
    var o = e.nodes && e.nodes.t;
    if (o !== null)
      for (const s of o)
        (s.is_global || r) && s.in();
  }
}
function yu(e, r) {
  if (e.nodes)
    for (var t = e.nodes.start, n = e.nodes.end; t !== null; ) {
      var a = t === n ? null : /* @__PURE__ */ Ya(t);
      r.append(t), t = a;
    }
}
let wn = !1;
function ho(e) {
  wn = e;
}
let an = !1;
function _l(e) {
  an = e;
}
let Ie = null, st = !1;
function qr(e) {
  Ie = e;
}
let ze = null;
function qt(e) {
  ze = e;
}
let Er = null;
function bu(e) {
  Ie !== null && (Er === null ? Er = [e] : Er.push(e));
}
let Pr = null, jr = 0, Kr = null;
function k_(e) {
  Kr = e;
}
let vu = 1, Da = 0, Pn = Da;
function gl(e) {
  Pn = e;
}
function ku() {
  return ++vu;
}
function _a(e) {
  var r = e.f;
  if ((r & Sr) !== 0)
    return !0;
  if (r & br && (e.f &= -32769), (r & zt) !== 0) {
    for (var t = (
      /** @type {Value[]} */
      e.deps
    ), n = t.length, a = 0; a < n; a++) {
      var o = t[a];
      if (_a(
        /** @type {Derived} */
        o
      ) && tu(
        /** @type {Derived} */
        o
      ), o.wv > e.wv)
        return !0;
    }
    (r & Qr) !== 0 && // During time traveling we don't want to reset the status so that
    // traversal of the graph in the other batches still happens
    fr === null && sr(e, hr);
  }
  return !1;
}
function wu(e, r, t = !0) {
  var n = e.reactions;
  if (n !== null && !(Er != null && Er.includes(e)))
    for (var a = 0; a < n.length; a++) {
      var o = n[a];
      (o.f & br) !== 0 ? wu(
        /** @type {Derived} */
        o,
        r,
        !1
      ) : r === o && (t ? sr(o, Sr) : (o.f & hr) !== 0 && sr(o, zt), Ht(
        /** @type {Effect} */
        o
      ));
    }
}
function Pu(e) {
  var f;
  var r = Pr, t = jr, n = Kr, a = Ie, o = Er, s = Le, l = st, c = Pn, u = e.f;
  Pr = /** @type {null | Value[]} */
  null, jr = 0, Kr = null, Ie = (u & (Wt | Tn)) === 0 ? e : null, Er = null, na(e.ctx), st = !1, Pn = ++Da, e.ac !== null && (Ga(() => {
    e.ac.abort(Rn);
  }), e.ac = null);
  try {
    e.f |= zi;
    var d = (
      /** @type {Function} */
      e.fn
    ), p = d(), _ = e.deps;
    if (Pr !== null) {
      var g;
      if (yo(e, jr), _ !== null && jr > 0)
        for (_.length = jr + Pr.length, g = 0; g < Pr.length; g++)
          _[jr + g] = Pr[g];
      else
        e.deps = _ = Pr;
      if (Ps() && (e.f & Qr) !== 0)
        for (g = jr; g < _.length; g++)
          ((f = _[g]).reactions ?? (f.reactions = [])).push(e);
    } else _ !== null && jr < _.length && (yo(e, jr), _.length = jr);
    if (Ha() && Kr !== null && !st && _ !== null && (e.f & (br | zt | Sr)) === 0)
      for (g = 0; g < /** @type {Source[]} */
      Kr.length; g++)
        wu(
          Kr[g],
          /** @type {Effect} */
          e
        );
    return a !== null && a !== e && (Da++, Kr !== null && (n === null ? n = Kr : n.push(.../** @type {Source[]} */
    Kr))), (e.f & rn) !== 0 && (e.f ^= rn), p;
  } catch (w) {
    return Wc(w);
  } finally {
    e.f ^= zi, Pr = r, jr = t, Kr = n, Ie = a, Er = o, na(s), st = l, Pn = c;
  }
}
function w_(e, r) {
  let t = r.reactions;
  if (t !== null) {
    var n = Fp.call(t, e);
    if (n !== -1) {
      var a = t.length - 1;
      a === 0 ? t = r.reactions = null : (t[n] = t[a], t.pop());
    }
  }
  if (t === null && (r.f & br) !== 0 && // Destroying a child effect while updating a parent effect can cause a dependency to appear
  // to be unused, when in fact it is used by the currently-updating parent. Checking `new_deps`
  // allows us to skip the expensive work of disconnecting and immediately reconnecting it
  (Pr === null || !Pr.includes(r))) {
    var o = (
      /** @type {Derived} */
      r
    );
    (o.f & Qr) !== 0 && (o.f ^= Qr, o.f &= -32769), vs(o), ru(o), yo(o, 0);
  }
}
function yo(e, r) {
  var t = e.deps;
  if (t !== null)
    for (var n = r; n < t.length; n++)
      w_(e, t[n]);
}
function ia(e) {
  var r = e.f;
  if ((r & Bt) === 0) {
    sr(e, hr);
    var t = ze, n = wn;
    ze = e, wn = !0;
    try {
      (r & (Ft | fs)) !== 0 ? v_(e) : _u(e), pu(e);
      var a = Pu(e);
      e.teardown = typeof a == "function" ? a : null, e.wv = vu;
      var o;
      Fi && Xp && (e.f & Sr) !== 0 && e.deps;
    } finally {
      wn = n, ze = t;
    }
  }
}
function i(e) {
  var r = e.f, t = (r & br) !== 0;
  if (Ie !== null && !st) {
    var n = ze !== null && (ze.f & Bt) !== 0;
    if (!n && !(Er != null && Er.includes(e))) {
      var a = Ie.deps;
      if ((Ie.f & zi) !== 0)
        e.rv < Da && (e.rv = Da, Pr === null && a !== null && a[jr] === e ? jr++ : Pr === null ? Pr = [e] : Pr.includes(e) || Pr.push(e));
      else {
        (Ie.deps ?? (Ie.deps = [])).push(e);
        var o = e.reactions;
        o === null ? e.reactions = [Ie] : o.includes(Ie) || o.push(Ie);
      }
    }
  }
  if (an && tn.has(e))
    return tn.get(e);
  if (t) {
    var s = (
      /** @type {Derived} */
      e
    );
    if (an) {
      var l = s.v;
      return ((s.f & hr) === 0 && s.reactions !== null || Eu(s)) && (l = ws(s)), tn.set(s, l), l;
    }
    var c = (s.f & Qr) === 0 && !st && Ie !== null && (wn || (Ie.f & Qr) !== 0), u = s.deps === null;
    _a(s) && (c && (s.f |= Qr), tu(s)), c && !u && xu(s);
  }
  if (fr != null && fr.has(e))
    return fr.get(e);
  if ((e.f & rn) !== 0)
    throw e.v;
  return e.v;
}
function xu(e) {
  if (e.deps !== null) {
    e.f |= Qr;
    for (const r of e.deps)
      (r.reactions ?? (r.reactions = [])).push(e), (r.f & br) !== 0 && (r.f & Qr) === 0 && xu(
        /** @type {Derived} */
        r
      );
  }
}
function Eu(e) {
  if (e.v === ur) return !0;
  if (e.deps === null) return !1;
  for (const r of e.deps)
    if (tn.has(r) || (r.f & br) !== 0 && Eu(
      /** @type {Derived} */
      r
    ))
      return !0;
  return !1;
}
function Ue(e) {
  var r = st;
  try {
    return st = !0, e();
  } finally {
    st = r;
  }
}
function P_(e, r) {
  var t = {};
  for (var n in e)
    r.includes(n) || (t[n] = e[n]);
  for (var a of Object.getOwnPropertySymbols(e))
    Object.propertyIsEnumerable.call(e, a) && !r.includes(a) && (t[a] = e[a]);
  return t;
}
function Ye(e) {
  if (!(typeof e != "object" || !e || e instanceof EventTarget)) {
    if (Tt in e)
      Ui(e);
    else if (!Array.isArray(e))
      for (let r in e) {
        const t = e[r];
        typeof t == "object" && t && Tt in t && Ui(t);
      }
  }
}
function Ui(e, r = /* @__PURE__ */ new Set()) {
  if (typeof e == "object" && e !== null && // We don't want to traverse DOM elements
  !(e instanceof EventTarget) && !r.has(e)) {
    r.add(e), e instanceof Date && e.getTime();
    for (let n in e)
      try {
        Ui(e[n], r);
      } catch {
      }
    const t = gs(e);
    if (t !== Object.prototype && t !== Array.prototype && t !== Map.prototype && t !== Set.prototype && t !== Date.prototype) {
      const n = Nc(t);
      for (let a in n) {
        const o = n[a].get;
        if (o)
          try {
            o.call(e);
          } catch {
          }
      }
    }
  }
}
const Su = /* @__PURE__ */ new Set(), Ri = /* @__PURE__ */ new Set();
function Es(e, r, t, n = {}) {
  function a(o) {
    if (n.capture || ka.call(r, o), !o.cancelBubble)
      return Ga(() => t == null ? void 0 : t.call(this, o));
  }
  return e.startsWith("pointer") || e.startsWith("touch") || e === "wheel" ? sn(() => {
    r.addEventListener(e, a, n);
  }) : r.addEventListener(e, a, n), a;
}
function x_(e, r, t, n = {}) {
  var a = Es(r, e, t, n);
  return () => {
    e.removeEventListener(r, a, n);
  };
}
function Ur(e, r, t, n, a) {
  var o = { capture: n, passive: a }, s = Es(e, r, t, o);
  (r === document.body || // @ts-ignore
  r === window || // @ts-ignore
  r === document || // Firefox has quirky behavior, it can happen that we still get "canplay" events when the element is already removed
  r instanceof HTMLMediaElement) && da(() => {
    r.removeEventListener(e, s, o);
  });
}
function $a(e) {
  for (var r = 0; r < e.length; r++)
    Su.add(e[r]);
  for (var t of Ri)
    t(e);
}
let fl = null;
function ka(e) {
  var k;
  var r = this, t = (
    /** @type {Node} */
    r.ownerDocument
  ), n = e.type, a = ((k = e.composedPath) == null ? void 0 : k.call(e)) || [], o = (
    /** @type {null | Element} */
    a[0] || e.target
  );
  fl = e;
  var s = 0, l = fl === e && e.__root;
  if (l) {
    var c = a.indexOf(l);
    if (c !== -1 && (r === document || r === /** @type {any} */
    window)) {
      e.__root = r;
      return;
    }
    var u = a.indexOf(r);
    if (u === -1)
      return;
    c <= u && (s = c);
  }
  if (o = /** @type {Element} */
  a[s] || e.target, o !== r) {
    jc(e, "currentTarget", {
      configurable: !0,
      get() {
        return o || t;
      }
    });
    var d = Ie, p = ze;
    qr(null), qt(null);
    try {
      for (var _, g = []; o !== null; ) {
        var f = o.assignedSlot || o.parentNode || /** @type {any} */
        o.host || null;
        try {
          var w = o["__" + n];
          w != null && (!/** @type {any} */
          o.disabled || // DOM could've been updated already by the time this is reached, so we check this as well
          // -> the target could not have been disabled because it emits the event in the first place
          e.target === o) && w.call(o, e);
        } catch (m) {
          _ ? g.push(m) : _ = m;
        }
        if (e.cancelBubble || f === r || f === null)
          break;
        o = f;
      }
      if (_) {
        for (let m of g)
          queueMicrotask(() => {
            throw m;
          });
        throw _;
      }
    } finally {
      e.__root = r, delete e.currentTarget, qr(d), qt(p);
    }
  }
}
function Ss(e) {
  var r = document.createElement("template");
  return r.innerHTML = e.replaceAll("<!>", "<!---->"), r.content;
}
function on(e, r) {
  var t = (
    /** @type {Effect} */
    ze
  );
  t.nodes === null && (t.nodes = { start: e, end: r, a: null, t: null });
}
// @__NO_SIDE_EFFECTS__
function B(e, r) {
  var t = (r & Mc) !== 0, n = (r & Dp) !== 0, a, o = !e.startsWith("<!>");
  return () => {
    a === void 0 && (a = Ss(o ? e : "<!>" + e), t || (a = /** @type {TemplateNode} */
    /* @__PURE__ */ Br(a)));
    var s = (
      /** @type {TemplateNode} */
      n || ou ? document.importNode(a, !0) : a.cloneNode(!0)
    );
    if (t) {
      var l = (
        /** @type {TemplateNode} */
        /* @__PURE__ */ Br(s)
      ), c = (
        /** @type {TemplateNode} */
        s.lastChild
      );
      on(l, c);
    } else
      on(s, s);
    return s;
  };
}
// @__NO_SIDE_EFFECTS__
function E_(e, r, t = "svg") {
  var n = !e.startsWith("<!>"), a = (r & Mc) !== 0, o = `<${t}>${n ? e : "<!>" + e}</${t}>`, s;
  return () => {
    if (!s) {
      var l = (
        /** @type {DocumentFragment} */
        Ss(o)
      ), c = (
        /** @type {Element} */
        /* @__PURE__ */ Br(l)
      );
      if (a)
        for (s = document.createDocumentFragment(); /* @__PURE__ */ Br(c); )
          s.appendChild(
            /** @type {TemplateNode} */
            /* @__PURE__ */ Br(c)
          );
      else
        s = /** @type {Element} */
        /* @__PURE__ */ Br(c);
    }
    var u = (
      /** @type {TemplateNode} */
      s.cloneNode(!0)
    );
    if (a) {
      var d = (
        /** @type {TemplateNode} */
        /* @__PURE__ */ Br(u)
      ), p = (
        /** @type {TemplateNode} */
        u.lastChild
      );
      on(d, p);
    } else
      on(u, u);
    return u;
  };
}
// @__NO_SIDE_EFFECTS__
function nr(e, r) {
  return /* @__PURE__ */ E_(e, r, "svg");
}
function De(e = "") {
  {
    var r = It(e + "");
    return on(r, r), r;
  }
}
function ve() {
  var e = document.createDocumentFragment(), r = document.createComment(""), t = It();
  return e.append(r, t), on(r, t), e;
}
function T(e, r) {
  e !== null && e.before(
    /** @type {Node} */
    r
  );
}
function S_(e) {
  return e.endsWith("capture") && e !== "gotpointercapture" && e !== "lostpointercapture";
}
const T_ = [
  "beforeinput",
  "click",
  "change",
  "dblclick",
  "contextmenu",
  "focusin",
  "focusout",
  "input",
  "keydown",
  "keyup",
  "mousedown",
  "mousemove",
  "mouseout",
  "mouseover",
  "mouseup",
  "pointerdown",
  "pointermove",
  "pointerout",
  "pointerover",
  "pointerup",
  "touchend",
  "touchmove",
  "touchstart"
];
function I_(e) {
  return T_.includes(e);
}
const D_ = {
  // no `class: 'className'` because we handle that separately
  formnovalidate: "formNoValidate",
  ismap: "isMap",
  nomodule: "noModule",
  playsinline: "playsInline",
  readonly: "readOnly",
  defaultvalue: "defaultValue",
  defaultchecked: "defaultChecked",
  srcobject: "srcObject",
  novalidate: "noValidate",
  allowfullscreen: "allowFullscreen",
  disablepictureinpicture: "disablePictureInPicture",
  disableremoteplayback: "disableRemotePlayback"
};
function C_(e) {
  return e = e.toLowerCase(), D_[e] ?? e;
}
const A_ = ["touchstart", "touchmove"];
function q_(e) {
  return A_.includes(e);
}
let bo = !0;
function Qa(e) {
  bo = e;
}
function me(e, r) {
  var t = r == null ? "" : typeof r == "object" ? r + "" : r;
  t !== (e.__t ?? (e.__t = e.nodeValue)) && (e.__t = t, e.nodeValue = t + "");
}
function Ea(e, r) {
  return F_(e, r);
}
const Nn = /* @__PURE__ */ new Map();
function F_(e, { target: r, anchor: t, props: n = {}, events: a, context: o, intro: s = !0 }) {
  p_();
  var l = /* @__PURE__ */ new Set(), c = (p) => {
    for (var _ = 0; _ < p.length; _++) {
      var g = p[_];
      if (!l.has(g)) {
        l.add(g);
        var f = q_(g);
        r.addEventListener(g, ka, { passive: f });
        var w = Nn.get(g);
        w === void 0 ? (document.addEventListener(g, ka, { passive: f }), Nn.set(g, 1)) : Nn.set(g, w + 1);
      }
    }
  };
  c(No(Su)), Ri.add(c);
  var u = void 0, d = h_(() => {
    var p = t ?? r.appendChild(It());
    return Qc(
      /** @type {TemplateNode} */
      p,
      {
        pending: () => {
        }
      },
      (_) => {
        if (o) {
          re({});
          var g = (
            /** @type {ComponentContext} */
            Le
          );
          g.c = o;
        }
        a && (n.$$events = a), bo = s, u = e(_, n) || {}, bo = !0, o && te();
      }
    ), () => {
      var f;
      for (var _ of l) {
        r.removeEventListener(_, ka);
        var g = (
          /** @type {number} */
          Nn.get(_)
        );
        --g === 0 ? (document.removeEventListener(_, ka), Nn.delete(_)) : Nn.set(_, g);
      }
      Ri.delete(c), p !== t && ((f = p.parentNode) == null || f.removeChild(p));
    };
  });
  return Vi.set(u, d), u;
}
let Vi = /* @__PURE__ */ new WeakMap();
function _o(e, r) {
  const t = Vi.get(e);
  return t ? (Vi.delete(e), t(r)) : Promise.resolve();
}
var it, St, Lr, vn, Oa, La, Fo;
class Bo {
  /**
   * @param {TemplateNode} anchor
   * @param {boolean} transition
   */
  constructor(r, t = !0) {
    /** @type {TemplateNode} */
    U(this, "anchor");
    /** @type {Map<Batch, Key>} */
    ke(this, it, /* @__PURE__ */ new Map());
    /**
     * Map of keys to effects that are currently rendered in the DOM.
     * These effects are visible and actively part of the document tree.
     * Example:
     * ```
     * {#if condition}
     * 	foo
     * {:else}
     * 	bar
     * {/if}
     * ```
     * Can result in the entries `true->Effect` and `false->Effect`
     * @type {Map<Key, Effect>}
     */
    ke(this, St, /* @__PURE__ */ new Map());
    /**
     * Similar to #onscreen with respect to the keys, but contains branches that are not yet
     * in the DOM, because their insertion is deferred.
     * @type {Map<Key, Branch>}
     */
    ke(this, Lr, /* @__PURE__ */ new Map());
    /**
     * Keys of effects that are currently outroing
     * @type {Set<Key>}
     */
    ke(this, vn, /* @__PURE__ */ new Set());
    /**
     * Whether to pause (i.e. outro) on change, or destroy immediately.
     * This is necessary for `<svelte:element>`
     */
    ke(this, Oa, !0);
    ke(this, La, () => {
      var r = (
        /** @type {Batch} */
        Ve
      );
      if (O(this, it).has(r)) {
        var t = (
          /** @type {Key} */
          O(this, it).get(r)
        ), n = O(this, St).get(t);
        if (n)
          xs(n), O(this, vn).delete(t);
        else {
          var a = O(this, Lr).get(t);
          a && (O(this, St).set(t, a.effect), O(this, Lr).delete(t), a.fragment.lastChild.remove(), this.anchor.before(a.fragment), n = a.effect);
        }
        for (const [o, s] of O(this, it)) {
          if (O(this, it).delete(o), o === r)
            break;
          const l = O(this, Lr).get(s);
          l && (yr(l.effect), O(this, Lr).delete(s));
        }
        for (const [o, s] of O(this, St)) {
          if (o === t || O(this, vn).has(o)) continue;
          const l = () => {
            if (Array.from(O(this, it).values()).includes(o)) {
              var u = document.createDocumentFragment();
              yu(s, u), u.append(It()), O(this, Lr).set(o, { effect: s, fragment: u });
            } else
              yr(s);
            O(this, vn).delete(o), O(this, St).delete(o);
          };
          O(this, Oa) || !n ? (O(this, vn).add(o), kn(s, l, !1)) : l();
        }
      }
    });
    /**
     * @param {Batch} batch
     */
    ke(this, Fo, (r) => {
      O(this, it).delete(r);
      const t = Array.from(O(this, it).values());
      for (const [n, a] of O(this, Lr))
        t.includes(n) || (yr(a.effect), O(this, Lr).delete(n));
    });
    this.anchor = r, be(this, Oa, t);
  }
  /**
   *
   * @param {any} key
   * @param {null | ((target: TemplateNode) => void)} fn
   */
  ensure(r, t) {
    var n = (
      /** @type {Batch} */
      Ve
    ), a = lu();
    if (t && !O(this, St).has(r) && !O(this, Lr).has(r))
      if (a) {
        var o = document.createDocumentFragment(), s = It();
        o.append(s), O(this, Lr).set(r, {
          effect: Cr(() => t(s)),
          fragment: o
        });
      } else
        O(this, St).set(
          r,
          Cr(() => t(this.anchor))
        );
    if (O(this, it).set(n, r), a) {
      for (const [l, c] of O(this, St))
        l === r ? n.skipped_effects.delete(c) : n.skipped_effects.add(c);
      for (const [l, c] of O(this, Lr))
        l === r ? n.skipped_effects.delete(c.effect) : n.skipped_effects.add(c.effect);
      n.oncommit(O(this, La)), n.ondiscard(O(this, Fo));
    } else
      O(this, La).call(this);
  }
}
it = new WeakMap(), St = new WeakMap(), Lr = new WeakMap(), vn = new WeakMap(), Oa = new WeakMap(), La = new WeakMap(), Fo = new WeakMap();
function Xe(e, r, ...t) {
  var n = new Bo(e);
  pa(() => {
    const a = r() ?? null;
    n.ensure(a, a && ((o) => a(o, ...t)));
  }, At);
}
function _r(e) {
  Le === null && ys(), ua && Le.l !== null ? z_(Le).m.push(e) : xr(() => {
    const r = Ue(e);
    if (typeof r == "function") return (
      /** @type {() => void} */
      r
    );
  });
}
function ln(e) {
  Le === null && ys(), _r(() => () => Ue(e));
}
function z_(e) {
  var r = (
    /** @type {ComponentContextLegacy} */
    e.l
  );
  return r.u ?? (r.u = { a: [], b: [], m: [] });
}
function W(e, r, t = !1) {
  var n = new Bo(e), a = t ? At : 0;
  function o(s, l) {
    n.ensure(s, l);
  }
  pa(() => {
    var s = !1;
    r((l, c = !0) => {
      s = !0, o(c, l);
    }), s || o(!1, null);
  }, a);
}
function Rt(e, r) {
  return r;
}
function M_(e, r, t) {
  for (var n = [], a = r.length, o, s = r.length, l = 0; l < a; l++) {
    let p = r[l];
    kn(
      p,
      () => {
        if (o) {
          if (o.pending.delete(p), o.done.add(p), o.pending.size === 0) {
            var _ = (
              /** @type {Set<EachOutroGroup>} */
              e.outrogroups
            );
            Hi(No(o.done)), _.delete(o), _.size === 0 && (e.outrogroups = null);
          }
        } else
          s -= 1;
      },
      !1
    );
  }
  if (s === 0) {
    var c = n.length === 0 && t !== null;
    if (c) {
      var u = (
        /** @type {Element} */
        t
      ), d = (
        /** @type {Element} */
        u.parentNode
      );
      __(d), d.append(u), e.items.clear();
    }
    Hi(r, !c);
  } else
    o = {
      pending: new Set(r),
      done: /* @__PURE__ */ new Set()
    }, (e.outrogroups ?? (e.outrogroups = /* @__PURE__ */ new Set())).add(o);
}
function Hi(e, r = !0) {
  for (var t = 0; t < e.length; t++)
    yr(e[t], r);
}
var ml;
function Dt(e, r, t, n, a, o = null) {
  var s = e, l = /* @__PURE__ */ new Map(), c = (r & zc) !== 0;
  if (c) {
    var u = (
      /** @type {Element} */
      e
    );
    s = u.appendChild(It());
  }
  var d = null, p = /* @__PURE__ */ Ut(() => {
    var m = t();
    return jo(m) ? m : m == null ? [] : No(m);
  }), _, g = !0;
  function f() {
    k.fallback = d, j_(k, _, s, r, n), d !== null && (_.length === 0 ? (d.f & Nt) === 0 ? xs(d) : (d.f ^= Nt, wa(d, null, s)) : kn(d, () => {
      d = null;
    }));
  }
  var w = pa(() => {
    _ = /** @type {V[]} */
    i(p);
    for (var m = _.length, h = /* @__PURE__ */ new Set(), v = (
      /** @type {Batch} */
      Ve
    ), y = lu(), E = 0; E < m; E += 1) {
      var S = _[E], P = n(S, E), x = g ? null : l.get(P);
      x ? (x.v && oa(x.v, S), x.i && oa(x.i, E), y && v.skipped_effects.delete(x.e)) : (x = N_(
        l,
        g ? s : ml ?? (ml = It()),
        S,
        P,
        E,
        a,
        r,
        t
      ), g || (x.e.f |= Nt), l.set(P, x)), h.add(P);
    }
    if (m === 0 && o && !d && (g ? d = Cr(() => o(s)) : (d = Cr(() => o(ml ?? (ml = It()))), d.f |= Nt)), !g)
      if (y) {
        for (const [I, q] of l)
          h.has(I) || v.skipped_effects.add(q.e);
        v.oncommit(f), v.ondiscard(() => {
        });
      } else
        f();
    i(p);
  }), k = { effect: w, items: l, outrogroups: null, fallback: d };
  g = !1;
}
function j_(e, r, t, n, a) {
  var q, N, M, D, j, Y, A, C, z;
  var o = (n & bp) !== 0, s = r.length, l = e.items, c = e.effect.first, u, d = null, p, _ = [], g = [], f, w, k, m;
  if (o)
    for (m = 0; m < s; m += 1)
      f = r[m], w = a(f, m), k = /** @type {EachItem} */
      l.get(w).e, (k.f & Nt) === 0 && ((N = (q = k.nodes) == null ? void 0 : q.a) == null || N.measure(), (p ?? (p = /* @__PURE__ */ new Set())).add(k));
  for (m = 0; m < s; m += 1) {
    if (f = r[m], w = a(f, m), k = /** @type {EachItem} */
    l.get(w).e, e.outrogroups !== null)
      for (const G of e.outrogroups)
        G.pending.delete(k), G.done.delete(k);
    if ((k.f & Nt) !== 0)
      if (k.f ^= Nt, k === c)
        wa(k, null, t);
      else {
        var h = d ? d.next : c;
        k === e.effect.last && (e.effect.last = k.prev), k.prev && (k.prev.next = k.next), k.next && (k.next.prev = k.prev), Kt(e, d, k), Kt(e, k, h), wa(k, h, t), d = k, _ = [], g = [], c = d.next;
        continue;
      }
    if ((k.f & Rr) !== 0 && (xs(k), o && ((D = (M = k.nodes) == null ? void 0 : M.a) == null || D.unfix(), (p ?? (p = /* @__PURE__ */ new Set())).delete(k))), k !== c) {
      if (u !== void 0 && u.has(k)) {
        if (_.length < g.length) {
          var v = g[0], y;
          d = v.prev;
          var E = _[0], S = _[_.length - 1];
          for (y = 0; y < _.length; y += 1)
            wa(_[y], v, t);
          for (y = 0; y < g.length; y += 1)
            u.delete(g[y]);
          Kt(e, E.prev, S.next), Kt(e, d, E), Kt(e, S, v), c = v, d = S, m -= 1, _ = [], g = [];
        } else
          u.delete(k), wa(k, c, t), Kt(e, k.prev, k.next), Kt(e, k, d === null ? e.effect.first : d.next), Kt(e, d, k), d = k;
        continue;
      }
      for (_ = [], g = []; c !== null && c !== k; )
        (u ?? (u = /* @__PURE__ */ new Set())).add(c), g.push(c), c = c.next;
      if (c === null)
        continue;
    }
    (k.f & Nt) === 0 && _.push(k), d = k, c = k.next;
  }
  if (e.outrogroups !== null) {
    for (const G of e.outrogroups)
      G.pending.size === 0 && (Hi(No(G.done)), (j = e.outrogroups) == null || j.delete(G));
    e.outrogroups.size === 0 && (e.outrogroups = null);
  }
  if (c !== null || u !== void 0) {
    var P = [];
    if (u !== void 0)
      for (k of u)
        (k.f & Rr) === 0 && P.push(k);
    for (; c !== null; )
      (c.f & Rr) === 0 && c !== e.fallback && P.push(c), c = c.next;
    var x = P.length;
    if (x > 0) {
      var I = (n & zc) !== 0 && s === 0 ? t : null;
      if (o) {
        for (m = 0; m < x; m += 1)
          (A = (Y = P[m].nodes) == null ? void 0 : Y.a) == null || A.measure();
        for (m = 0; m < x; m += 1)
          (z = (C = P[m].nodes) == null ? void 0 : C.a) == null || z.fix();
      }
      M_(e, P, I);
    }
  }
  o && sn(() => {
    var G, H;
    if (p !== void 0)
      for (k of p)
        (H = (G = k.nodes) == null ? void 0 : G.a) == null || H.apply();
  });
}
function N_(e, r, t, n, a, o, s, l) {
  var c = (s & hp) !== 0 ? (s & vp) === 0 ? /* @__PURE__ */ Or(t, !1, !1) : xn(t) : null, u = (s & yp) !== 0 ? xn(a) : null;
  return {
    v: c,
    i: u,
    e: Cr(() => (o(r, c ?? t, u ?? a, l), () => {
      e.delete(n);
    }))
  };
}
function wa(e, r, t) {
  if (e.nodes)
    for (var n = e.nodes.start, a = e.nodes.end, o = r && (r.f & Nt) === 0 ? (
      /** @type {EffectNodes} */
      r.nodes.start
    ) : t; n !== null; ) {
      var s = (
        /** @type {TemplateNode} */
        /* @__PURE__ */ Ya(n)
      );
      if (o.before(n), n === a)
        return;
      n = s;
    }
}
function Kt(e, r, t) {
  r === null ? e.effect.first = t : r.next = t, t === null ? e.effect.last = r : t.prev = r;
}
function cn(e, r, t = !1, n = !1, a = !1) {
  var o = e, s = "";
  R(() => {
    var l = (
      /** @type {Effect} */
      ze
    );
    if (s !== (s = r() ?? "") && (l.nodes !== null && (gu(
      l.nodes.start,
      /** @type {TemplateNode} */
      l.nodes.end
    ), l.nodes = null), s !== "")) {
      var c = s + "";
      t ? c = `<svg>${c}</svg>` : n && (c = `<math>${c}</math>`);
      var u = Ss(c);
      if ((t || n) && (u = /** @type {Element} */
      /* @__PURE__ */ Br(u)), on(
        /** @type {TemplateNode} */
        /* @__PURE__ */ Br(u),
        /** @type {TemplateNode} */
        u.lastChild
      ), t || n)
        for (; /* @__PURE__ */ Br(u); )
          o.before(
            /** @type {TemplateNode} */
            /* @__PURE__ */ Br(u)
          );
      else
        o.before(u);
    }
  });
}
function O_(e, r, t) {
  var n = new Bo(e);
  pa(() => {
    var a = r() ?? null;
    n.ensure(a, a && ((o) => t(o, a)));
  }, At);
}
const L_ = () => performance.now(), jt = {
  // don't access requestAnimationFrame eagerly outside method
  // this allows basic testing of user code without JSDOM
  // bunder will eval and remove ternary when the user's app is built
  tick: (
    /** @param {any} _ */
    (e) => requestAnimationFrame(e)
  ),
  now: () => L_(),
  tasks: /* @__PURE__ */ new Set()
};
function Tu() {
  const e = jt.now();
  jt.tasks.forEach((r) => {
    r.c(e) || (jt.tasks.delete(r), r.f());
  }), jt.tasks.size !== 0 && jt.tick(Tu);
}
function B_(e) {
  let r;
  return jt.tasks.size === 0 && jt.tick(Tu), {
    promise: new Promise((t) => {
      jt.tasks.add(r = { c: e, f: t });
    }),
    abort() {
      jt.tasks.delete(r);
    }
  };
}
function eo(e, r) {
  Ga(() => {
    e.dispatchEvent(new CustomEvent(r));
  });
}
function U_(e) {
  if (e === "float") return "cssFloat";
  if (e === "offset") return "cssOffset";
  if (e.startsWith("--")) return e;
  const r = e.split("-");
  return r.length === 1 ? r[0] : r[0] + r.slice(1).map(
    /** @param {any} word */
    (t) => t[0].toUpperCase() + t.slice(1)
  ).join("");
}
function hl(e) {
  const r = {}, t = e.split(";");
  for (const n of t) {
    const [a, o] = n.split(":");
    if (!a || o === void 0) break;
    const s = U_(a.trim());
    r[s] = o.trim();
  }
  return r;
}
const R_ = (e) => e;
function Iu(e, r, t, n) {
  var v;
  var a = (e & Sp) !== 0, o = (e & Tp) !== 0, s = a && o, l = (e & Ip) !== 0, c = s ? "both" : a ? "in" : "out", u, d = r.inert, p = r.style.overflow, _, g;
  function f() {
    return Ga(() => u ?? (u = t()(r, (n == null ? void 0 : n()) ?? /** @type {P} */
    {}, {
      direction: c
    })));
  }
  var w = {
    is_global: l,
    in() {
      var y;
      if (r.inert = d, !a) {
        g == null || g.abort(), (y = g == null ? void 0 : g.reset) == null || y.call(g);
        return;
      }
      o || _ == null || _.abort(), eo(r, "introstart"), _ = Wi(r, f(), g, 1, () => {
        eo(r, "introend"), _ == null || _.abort(), _ = u = void 0, r.style.overflow = p;
      });
    },
    out(y) {
      if (!o) {
        y == null || y(), u = void 0;
        return;
      }
      r.inert = !0, eo(r, "outrostart"), g = Wi(r, f(), _, 0, () => {
        eo(r, "outroend"), y == null || y();
      });
    },
    stop: () => {
      _ == null || _.abort(), g == null || g.abort();
    }
  }, k = (
    /** @type {Effect & { nodes: EffectNodes }} */
    ze
  );
  if (((v = k.nodes).t ?? (v.t = [])).push(w), a && bo) {
    var m = l;
    if (!m) {
      for (var h = (
        /** @type {Effect | null} */
        k.parent
      ); h && (h.f & At) !== 0; )
        for (; (h = h.parent) && (h.f & Ft) === 0; )
          ;
      m = !h || (h.f & Lo) !== 0;
    }
    m && In(() => {
      Ue(() => w.in());
    });
  }
}
function Wi(e, r, t, n, a) {
  var o = n === 1;
  if (Bn(r)) {
    var s, l = !1;
    return sn(() => {
      if (!l) {
        var k = r({ direction: o ? "in" : "out" });
        s = Wi(e, k, t, n, a);
      }
    }), {
      abort: () => {
        l = !0, s == null || s.abort();
      },
      deactivate: () => s.deactivate(),
      reset: () => s.reset(),
      t: () => s.t()
    };
  }
  if (t == null || t.deactivate(), !(r != null && r.duration))
    return a(), {
      abort: Fe,
      deactivate: Fe,
      reset: Fe,
      t: () => n
    };
  const { delay: c = 0, css: u, tick: d, easing: p = R_ } = r;
  var _ = [];
  if (o && t === void 0 && (d && d(0, 1), u)) {
    var g = hl(u(0, 1));
    _.push(g, g);
  }
  var f = () => 1 - n, w = e.animate(_, { duration: c, fill: "forwards" });
  return w.onfinish = () => {
    w.cancel();
    var k = (t == null ? void 0 : t.t()) ?? 1 - n;
    t == null || t.abort();
    var m = n - k, h = (
      /** @type {number} */
      r.duration * Math.abs(m)
    ), v = [];
    if (h > 0) {
      var y = !1;
      if (u)
        for (var E = Math.ceil(h / 16.666666666666668), S = 0; S <= E; S += 1) {
          var P = k + m * p(S / E), x = hl(u(P, 1 - P));
          v.push(x), y || (y = x.overflow === "hidden");
        }
      y && (e.style.overflow = "hidden"), f = () => {
        var I = (
          /** @type {number} */
          /** @type {globalThis.Animation} */
          w.currentTime
        );
        return k + m * p(I / h);
      }, d && B_(() => {
        if (w.playState !== "running") return !1;
        var I = f();
        return d(I, 1 - I), !0;
      });
    }
    w = e.animate(v, { duration: h, fill: "forwards" }), w.onfinish = () => {
      f = () => n, d == null || d(n, 1 - n), a();
    };
  }, {
    abort: () => {
      w && (w.cancel(), w.effect = null, w.onfinish = Fe);
    },
    deactivate: () => {
      a = Fe;
    },
    reset: () => {
      n === 0 && (d == null || d(1, 0));
    },
    t: () => f()
  };
}
function Ts(e, r, t, n, a, o) {
  var s = null, l = (
    /** @type {TemplateNode} */
    e
  ), c = new Bo(l, !1);
  pa(() => {
    const u = r() || null;
    var d = u === "svg" ? Ap : null;
    if (u === null) {
      c.ensure(null, null), Qa(!0);
      return;
    }
    return c.ensure(u, (p) => {
      if (u) {
        if (s = d ? document.createElementNS(d, u) : document.createElement(u), on(s, s), n) {
          var _ = s.appendChild(It());
          n(s, _);
        }
        ze.nodes.end = s, p.before(s);
      }
    }), Qa(!0), () => {
      u && Qa(!1);
    };
  }, At), da(() => {
    Qa(!0);
  });
}
function ie(e, r) {
  In(() => {
    var t = e.getRootNode(), n = (
      /** @type {ShadowRoot} */
      t.host ? (
        /** @type {ShadowRoot} */
        t
      ) : (
        /** @type {Document} */
        t.head ?? /** @type {Document} */
        t.ownerDocument.head
      )
    );
    if (!n.querySelector("#" + r.hash)) {
      const a = document.createElement("style");
      a.id = r.hash, a.textContent = r.code, n.appendChild(a);
    }
  });
}
function V_(e, r, t) {
  In(() => {
    var n = Ue(() => r(e, t == null ? void 0 : t()) || {});
    if (t && (n != null && n.update)) {
      var a = !1, o = (
        /** @type {any} */
        {}
      );
      Ka(() => {
        var s = t();
        Ye(s), a && bs(o, s) && (o = s, n.update(s));
      }), a = !0;
    }
    if (n != null && n.destroy)
      return () => (
        /** @type {Function} */
        n.destroy()
      );
  });
}
function H_(e, r) {
  var t = void 0, n;
  du(() => {
    t !== (t = r()) && (n && (yr(n), n = null), t && (n = Cr(() => {
      In(() => (
        /** @type {(node: Element) => void} */
        t(e)
      ));
    })));
  });
}
function Du(e) {
  var r, t, n = "";
  if (typeof e == "string" || typeof e == "number") n += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var a = e.length;
    for (r = 0; r < a; r++) e[r] && (t = Du(e[r])) && (n && (n += " "), n += t);
  } else for (t in e) e[t] && (n && (n += " "), n += t);
  return n;
}
function W_() {
  for (var e, r, t = 0, n = "", a = arguments.length; t < a; t++) (e = arguments[t]) && (r = Du(e)) && (n && (n += " "), n += r);
  return n;
}
function Is(e) {
  return typeof e == "object" ? W_(e) : e ?? "";
}
const yl = [...` 	
\r\f \v\uFEFF`];
function Y_(e, r, t) {
  var n = e == null ? "" : "" + e;
  if (r && (n = n ? n + " " + r : r), t) {
    for (var a in t)
      if (t[a])
        n = n ? n + " " + a : a;
      else if (n.length)
        for (var o = a.length, s = 0; (s = n.indexOf(a, s)) >= 0; ) {
          var l = s + o;
          (s === 0 || yl.includes(n[s - 1])) && (l === n.length || yl.includes(n[l])) ? n = (s === 0 ? "" : n.substring(0, s)) + n.substring(l + 1) : s = l;
        }
  }
  return n === "" ? null : n;
}
function bl(e, r = !1) {
  var t = r ? " !important;" : ";", n = "";
  for (var a in e) {
    var o = e[a];
    o != null && o !== "" && (n += " " + a + ": " + o + t);
  }
  return n;
}
function Qo(e) {
  return e[0] !== "-" || e[1] !== "-" ? e.toLowerCase() : e;
}
function G_(e, r) {
  if (r) {
    var t = "", n, a;
    if (Array.isArray(r) ? (n = r[0], a = r[1]) : n = r, e) {
      e = String(e).replaceAll(/\s*\/\*.*?\*\/\s*/g, "").trim();
      var o = !1, s = 0, l = !1, c = [];
      n && c.push(...Object.keys(n).map(Qo)), a && c.push(...Object.keys(a).map(Qo));
      var u = 0, d = -1;
      const w = e.length;
      for (var p = 0; p < w; p++) {
        var _ = e[p];
        if (l ? _ === "/" && e[p - 1] === "*" && (l = !1) : o ? o === _ && (o = !1) : _ === "/" && e[p + 1] === "*" ? l = !0 : _ === '"' || _ === "'" ? o = _ : _ === "(" ? s++ : _ === ")" && s--, !l && o === !1 && s === 0) {
          if (_ === ":" && d === -1)
            d = p;
          else if (_ === ";" || p === w - 1) {
            if (d !== -1) {
              var g = Qo(e.substring(u, d).trim());
              if (!c.includes(g)) {
                _ !== ";" && p++;
                var f = e.substring(u, p).trim();
                t += " " + f + ";";
              }
            }
            u = p + 1, d = -1;
          }
        }
      }
    }
    return n && (t += bl(n)), a && (t += bl(a, !0)), t = t.trim(), t === "" ? null : t;
  }
  return e == null ? null : String(e);
}
function rr(e, r, t, n, a, o) {
  var s = e.__className;
  if (s !== t || s === void 0) {
    var l = Y_(t, n, o);
    l == null ? e.removeAttribute("class") : r ? e.className = l : e.setAttribute("class", l), e.__className = t;
  } else if (o && a !== o)
    for (var c in o) {
      var u = !!o[c];
      (a == null || u !== !!a[c]) && e.classList.toggle(c, u);
    }
  return o;
}
function ei(e, r = {}, t, n) {
  for (var a in t) {
    var o = t[a];
    r[a] !== o && (t[a] == null ? e.style.removeProperty(a) : e.style.setProperty(a, o, n));
  }
}
function Pe(e, r, t, n) {
  var a = e.__style;
  if (a !== r) {
    var o = G_(r, n);
    o == null ? e.removeAttribute("style") : e.style.cssText = o, e.__style = r;
  } else n && (Array.isArray(n) ? (ei(e, t == null ? void 0 : t[0], n[0]), ei(e, t == null ? void 0 : t[1], n[1], "important")) : ei(e, t, n));
  return n;
}
function Yi(e, r, t = !1) {
  if (e.multiple) {
    if (r == null)
      return;
    if (!jo(r))
      return Kp();
    for (var n of e.options)
      n.selected = r.includes(vl(n));
    return;
  }
  for (n of e.options) {
    var a = vl(n);
    if (d_(a, r)) {
      n.selected = !0;
      return;
    }
  }
  (!t || r !== void 0) && (e.selectedIndex = -1);
}
function K_(e) {
  var r = new MutationObserver(() => {
    Yi(e, e.__value);
  });
  r.observe(e, {
    // Listen to option element changes
    childList: !0,
    subtree: !0,
    // because of <optgroup>
    // Listen to option element value attribute changes
    // (doesn't get notified of select value changes,
    // because that property is not reflected as an attribute)
    attributes: !0,
    attributeFilter: ["value"]
  }), da(() => {
    r.disconnect();
  });
}
function vl(e) {
  return "__value" in e ? e.__value : e.value;
}
const ya = Symbol("class"), ba = Symbol("style"), Cu = Symbol("is custom element"), Au = Symbol("is html");
function $_(e, r) {
  r ? e.hasAttribute("selected") || e.setAttribute("selected", "") : e.removeAttribute("selected");
}
function oe(e, r, t, n) {
  var a = qu(e);
  a[r] !== (a[r] = t) && (r === "loading" && (e[Np] = t), t == null ? e.removeAttribute(r) : typeof t != "string" && Fu(e).includes(r) ? e[r] = t : e.setAttribute(r, t));
}
function X_(e, r, t, n, a = !1, o = !1) {
  var s = qu(e), l = s[Cu], c = !s[Au], u = r || {}, d = e.tagName === "OPTION";
  for (var p in r)
    p in t || (t[p] = null);
  t.class ? t.class = Is(t.class) : (n || t[ya]) && (t.class = null), t[ba] && (t.style ?? (t.style = null));
  var _ = Fu(e);
  for (const v in t) {
    let y = t[v];
    if (d && v === "value" && y == null) {
      e.value = e.__value = "", u[v] = y;
      continue;
    }
    if (v === "class") {
      var g = e.namespaceURI === "http://www.w3.org/1999/xhtml";
      rr(e, g, y, n, r == null ? void 0 : r[ya], t[ya]), u[v] = y, u[ya] = t[ya];
      continue;
    }
    if (v === "style") {
      Pe(e, y, r == null ? void 0 : r[ba], t[ba]), u[v] = y, u[ba] = t[ba];
      continue;
    }
    var f = u[v];
    if (!(y === f && !(y === void 0 && e.hasAttribute(v)))) {
      u[v] = y;
      var w = v[0] + v[1];
      if (w !== "$$")
        if (w === "on") {
          const E = {}, S = "$$" + v;
          let P = v.slice(2);
          var k = I_(P);
          if (S_(P) && (P = P.slice(0, -7), E.capture = !0), !k && f) {
            if (y != null) continue;
            e.removeEventListener(P, u[S], E), u[S] = null;
          }
          if (y != null)
            if (k)
              e[`__${P}`] = y, $a([P]);
            else {
              let x = function(I) {
                u[v].call(this, I);
              };
              u[S] = Es(P, e, x, E);
            }
          else k && (e[`__${P}`] = void 0);
        } else if (v === "style")
          oe(e, v, y);
        else if (v === "autofocus")
          g_(
            /** @type {HTMLElement} */
            e,
            !!y
          );
        else if (!l && (v === "__value" || v === "value" && y != null))
          e.value = e.__value = y;
        else if (v === "selected" && d)
          $_(
            /** @type {HTMLOptionElement} */
            e,
            y
          );
        else {
          var m = v;
          c || (m = C_(m));
          var h = m === "defaultValue" || m === "defaultChecked";
          if (y == null && !l && !h)
            if (s[v] = null, m === "value" || m === "checked") {
              let E = (
                /** @type {HTMLInputElement} */
                e
              );
              const S = r === void 0;
              if (m === "value") {
                let P = E.defaultValue;
                E.removeAttribute(m), E.defaultValue = P, E.value = E.__value = S ? P : null;
              } else {
                let P = E.defaultChecked;
                E.removeAttribute(m), E.defaultChecked = P, E.checked = S ? P : !1;
              }
            } else
              e.removeAttribute(v);
          else h || _.includes(m) && (l || typeof y != "string") ? (e[m] = y, m in s && (s[m] = ur)) : typeof y != "function" && oe(e, m, y);
        }
    }
  }
  return u;
}
function Ds(e, r, t = [], n = [], a = [], o, s = !1, l = !1) {
  eu(a, t, n, (c) => {
    var u = void 0, d = {}, p = e.nodeName === "SELECT", _ = !1;
    if (du(() => {
      var f = r(...c.map(i)), w = X_(
        e,
        u,
        f,
        o,
        s,
        l
      );
      _ && p && "value" in f && Yi(
        /** @type {HTMLSelectElement} */
        e,
        f.value
      );
      for (let m of Object.getOwnPropertySymbols(d))
        f[m] || yr(d[m]);
      for (let m of Object.getOwnPropertySymbols(f)) {
        var k = f[m];
        m.description === qp && (!u || k !== u[m]) && (d[m] && yr(d[m]), d[m] = Cr(() => H_(e, () => k))), w[m] = k;
      }
      u = w;
    }), p) {
      var g = (
        /** @type {HTMLSelectElement} */
        e
      );
      In(() => {
        Yi(
          g,
          /** @type {Record<string | symbol, any>} */
          u.value,
          !0
        ), K_(g);
      });
    }
    _ = !0;
  });
}
function qu(e) {
  return (
    /** @type {Record<string | symbol, unknown>} **/
    // @ts-expect-error
    e.__attributes ?? (e.__attributes = {
      [Cu]: e.nodeName.includes("-"),
      [Au]: e.namespaceURI === Cp
    })
  );
}
var kl = /* @__PURE__ */ new Map();
function Fu(e) {
  var r = e.getAttribute("is") || e.nodeName, t = kl.get(r);
  if (t) return t;
  kl.set(r, t = []);
  for (var n, a = e, o = Element.prototype; o !== a; ) {
    n = Nc(a);
    for (var s in n)
      n[s].set && t.push(s);
    a = gs(a);
  }
  return t;
}
var Qt, ra, Ba, zo, zu;
const Mo = class Mo {
  /** @param {ResizeObserverOptions} options */
  constructor(r) {
    ke(this, zo);
    /** */
    ke(this, Qt, /* @__PURE__ */ new WeakMap());
    /** @type {ResizeObserver | undefined} */
    ke(this, ra);
    /** @type {ResizeObserverOptions} */
    ke(this, Ba);
    be(this, Ba, r);
  }
  /**
   * @param {Element} element
   * @param {(entry: ResizeObserverEntry) => any} listener
   */
  observe(r, t) {
    var n = O(this, Qt).get(r) || /* @__PURE__ */ new Set();
    return n.add(t), O(this, Qt).set(r, n), or(this, zo, zu).call(this).observe(r, O(this, Ba)), () => {
      var a = O(this, Qt).get(r);
      a.delete(t), a.size === 0 && (O(this, Qt).delete(r), O(this, ra).unobserve(r));
    };
  }
};
Qt = new WeakMap(), ra = new WeakMap(), Ba = new WeakMap(), zo = new WeakSet(), zu = function() {
  return O(this, ra) ?? be(this, ra, new ResizeObserver(
    /** @param {any} entries */
    (r) => {
      for (var t of r) {
        Mo.entries.set(t.target, t);
        for (var n of O(this, Qt).get(t.target) || [])
          n(t);
      }
    }
  ));
}, /** @static */
U(Mo, "entries", /* @__PURE__ */ new WeakMap());
let vo = Mo;
var Z_ = /* @__PURE__ */ new vo({
  box: "content-box"
}), J_ = /* @__PURE__ */ new vo({
  box: "border-box"
});
function Mu(e, r, t) {
  var n = Z_, a = n.observe(
    e,
    /** @param {any} entry */
    (o) => t(o[r])
  );
  da(a);
}
function Cs(e, r, t) {
  var n = J_.observe(e, () => t(e[r]));
  In(() => (Ue(() => t(e[r])), n));
}
function wl(e, r) {
  return e === r || (e == null ? void 0 : e[Tt]) === r;
}
function Uo(e = {}, r, t, n) {
  return In(() => {
    var a, o;
    return Ka(() => {
      a = o, o = [], Ue(() => {
        e !== t(...o) && (r(e, ...o), a && wl(t(...a), e) && r(null, ...a));
      });
    }), () => {
      sn(() => {
        o && wl(t(...o), e) && r(null, ...o);
      });
    };
  }), e;
}
function Dn(e = !1) {
  const r = (
    /** @type {ComponentContextLegacy} */
    Le
  ), t = r.l.u;
  if (!t) return;
  let n = () => Ye(r.s);
  if (e) {
    let a = 0, o = (
      /** @type {Record<string, any>} */
      {}
    );
    const s = /* @__PURE__ */ Wa(() => {
      let l = !1;
      const c = r.s;
      for (const u in c)
        c[u] !== o[u] && (o[u] = c[u], l = !0);
      return l && a++, a;
    });
    n = () => i(s);
  }
  t.b.length && m_(() => {
    Pl(r, n), go(t.b);
  }), xr(() => {
    const a = Ue(() => t.m.map(jp));
    return () => {
      for (const o of a)
        typeof o == "function" && o();
    };
  }), t.a.length && xr(() => {
    Pl(r, n), go(t.a);
  });
}
function Pl(e, r) {
  if (e.l.s)
    for (const t of e.l.s) i(t);
  r();
}
function ju(e, r) {
  var o;
  var t = (
    /** @type {Record<string, Function[] | Function>} */
    (o = e.$$events) == null ? void 0 : o[r.type]
  ), n = jo(t) ? t.slice() : t == null ? [] : [t];
  for (var a of n)
    a.call(this, r);
}
function As(e, r, t) {
  if (e == null)
    return r(void 0), t && t(void 0), Fe;
  const n = Ue(
    () => e.subscribe(
      r,
      // @ts-expect-error
      t
    )
  );
  return n.unsubscribe ? () => n.unsubscribe() : n;
}
const On = [];
function Ct(e, r) {
  return {
    subscribe: Vr(e, r).subscribe
  };
}
function Vr(e, r = Fe) {
  let t = null;
  const n = /* @__PURE__ */ new Set();
  function a(l) {
    if (bs(e, l) && (e = l, t)) {
      const c = !On.length;
      for (const u of n)
        u[1](), On.push(u, e);
      if (c) {
        for (let u = 0; u < On.length; u += 2)
          On[u][0](On[u + 1]);
        On.length = 0;
      }
    }
  }
  function o(l) {
    a(l(
      /** @type {T} */
      e
    ));
  }
  function s(l, c = Fe) {
    const u = [l, c];
    return n.add(u), n.size === 1 && (t = r(a, o) || Fe), l(
      /** @type {T} */
      e
    ), () => {
      n.delete(u), n.size === 0 && t && (t(), t = null);
    };
  }
  return { set: a, update: o, subscribe: s };
}
function lt(e, r, t) {
  const n = !Array.isArray(e), a = n ? [e] : e;
  if (!a.every(Boolean))
    throw new Error("derived() expects stores as input, got a falsy value");
  const o = r.length < 2;
  return Ct(t, (s, l) => {
    let c = !1;
    const u = [];
    let d = 0, p = Fe;
    const _ = () => {
      if (d)
        return;
      p();
      const f = r(n ? u[0] : u, s, l);
      o ? s(f) : p = typeof f == "function" ? f : Fe;
    }, g = a.map(
      (f, w) => As(
        f,
        (k) => {
          u[w] = k, d &= ~(1 << w), c && _();
        },
        () => {
          d |= 1 << w;
        }
      )
    );
    return c = !0, _(), function() {
      go(g), p(), c = !1;
    };
  });
}
function Q_(e) {
  let r;
  return As(e, (t) => r = t)(), r;
}
let ro = !1, Gi = Symbol();
function he(e, r, t) {
  const n = t[r] ?? (t[r] = {
    store: null,
    source: /* @__PURE__ */ Or(void 0),
    unsubscribe: Fe
  });
  if (n.store !== e && !(Gi in t))
    if (n.unsubscribe(), n.store = e ?? null, e == null)
      n.source.v = void 0, n.unsubscribe = Fe;
    else {
      var a = !0;
      n.unsubscribe = As(e, (o) => {
        a ? n.source.v = o : L(n.source, o);
      }), a = !1;
    }
  return e && Gi in t ? Q_(e) : i(n.source);
}
function xl(e, r) {
  return e.set(r), r;
}
function je() {
  const e = {};
  function r() {
    da(() => {
      for (var t in e)
        e[t].unsubscribe();
      jc(e, Gi, {
        enumerable: !1,
        value: !0
      });
    });
  }
  return [e, r];
}
function eg(e) {
  var r = ro;
  try {
    return ro = !1, [e(), ro];
  } finally {
    ro = r;
  }
}
const rg = {
  get(e, r) {
    if (!e.exclude.includes(r))
      return e.props[r];
  },
  set(e, r) {
    return !1;
  },
  getOwnPropertyDescriptor(e, r) {
    if (!e.exclude.includes(r) && r in e.props)
      return {
        enumerable: !0,
        configurable: !0,
        value: e.props[r]
      };
  },
  has(e, r) {
    return e.exclude.includes(r) ? !1 : r in e.props;
  },
  ownKeys(e) {
    return Reflect.ownKeys(e.props).filter((r) => !e.exclude.includes(r));
  }
};
// @__NO_SIDE_EFFECTS__
function cr(e, r, t) {
  return new Proxy(
    { props: e, exclude: r },
    rg
  );
}
const tg = {
  get(e, r) {
    let t = e.props.length;
    for (; t--; ) {
      let n = e.props[t];
      if (Bn(n) && (n = n()), typeof n == "object" && n !== null && r in n) return n[r];
    }
  },
  set(e, r, t) {
    let n = e.props.length;
    for (; n--; ) {
      let a = e.props[n];
      Bn(a) && (a = a());
      const o = en(a, r);
      if (o && o.set)
        return o.set(t), !0;
    }
    return !1;
  },
  getOwnPropertyDescriptor(e, r) {
    let t = e.props.length;
    for (; t--; ) {
      let n = e.props[t];
      if (Bn(n) && (n = n()), typeof n == "object" && n !== null && r in n) {
        const a = en(n, r);
        return a && !a.configurable && (a.configurable = !0), a;
      }
    }
  },
  has(e, r) {
    if (r === Tt || r === Uc) return !1;
    for (let t of e.props)
      if (Bn(t) && (t = t()), t != null && r in t) return !0;
    return !1;
  },
  ownKeys(e) {
    const r = [];
    for (let t of e.props)
      if (Bn(t) && (t = t()), !!t) {
        for (const n in t)
          r.includes(n) || r.push(n);
        for (const n of Object.getOwnPropertySymbols(t))
          r.includes(n) || r.push(n);
      }
    return r;
  }
};
function He(...e) {
  return new Proxy({ props: e }, tg);
}
function K(e, r, t, n) {
  var v;
  var a = !ua || (t & wp) !== 0, o = (t & xp) !== 0, s = (t & Ep) !== 0, l = (
    /** @type {V} */
    n
  ), c = !0, u = () => (c && (c = !1, l = s ? Ue(
    /** @type {() => V} */
    n
  ) : (
    /** @type {V} */
    n
  )), l), d;
  if (o) {
    var p = Tt in e || Uc in e;
    d = ((v = en(e, r)) == null ? void 0 : v.set) ?? (p && r in e ? (y) => e[r] = y : void 0);
  }
  var _, g = !1;
  o ? [_, g] = eg(() => (
    /** @type {V} */
    e[r]
  )) : _ = /** @type {V} */
  e[r], _ === void 0 && n !== void 0 && (_ = u(), d && (a && Vp(), d(_)));
  var f;
  if (a ? f = () => {
    var y = (
      /** @type {V} */
      e[r]
    );
    return y === void 0 ? u() : (c = !0, y);
  } : f = () => {
    var y = (
      /** @type {V} */
      e[r]
    );
    return y !== void 0 && (l = /** @type {V} */
    void 0), y === void 0 ? l : y;
  }, a && (t & Pp) === 0)
    return f;
  if (d) {
    var w = e.$$legacy;
    return (
      /** @type {() => V} */
      function(y, E) {
        return arguments.length > 0 ? ((!a || !E || w || g) && d(E ? f() : y), y) : f();
      }
    );
  }
  var k = !1, m = ((t & kp) !== 0 ? Wa : Ut)(() => (k = !1, f()));
  o && i(m);
  var h = (
    /** @type {Effect} */
    ze
  );
  return (
    /** @type {() => V} */
    function(y, E) {
      if (arguments.length > 0) {
        const S = E ? i(m) : a && o ? $e(y) : y;
        return L(m, S), k = !0, l !== void 0 && (l = S), y;
      }
      return an && k || (h.f & Bt) !== 0 ? m.v : i(m);
    }
  );
}
var Ge = /* @__PURE__ */ ((e) => (e[e.UnknownError = 0] = "UnknownError", e[e.UserCancelledError = 1] = "UserCancelledError", e[e.StoreProblemError = 2] = "StoreProblemError", e[e.PurchaseNotAllowedError = 3] = "PurchaseNotAllowedError", e[e.PurchaseInvalidError = 4] = "PurchaseInvalidError", e[e.ProductNotAvailableForPurchaseError = 5] = "ProductNotAvailableForPurchaseError", e[e.ProductAlreadyPurchasedError = 6] = "ProductAlreadyPurchasedError", e[e.ReceiptAlreadyInUseError = 7] = "ReceiptAlreadyInUseError", e[e.InvalidReceiptError = 8] = "InvalidReceiptError", e[e.MissingReceiptFileError = 9] = "MissingReceiptFileError", e[e.NetworkError = 10] = "NetworkError", e[e.InvalidCredentialsError = 11] = "InvalidCredentialsError", e[e.UnexpectedBackendResponseError = 12] = "UnexpectedBackendResponseError", e[e.InvalidAppUserIdError = 14] = "InvalidAppUserIdError", e[e.OperationAlreadyInProgressError = 15] = "OperationAlreadyInProgressError", e[e.UnknownBackendError = 16] = "UnknownBackendError", e[e.InvalidAppleSubscriptionKeyError = 17] = "InvalidAppleSubscriptionKeyError", e[e.IneligibleError = 18] = "IneligibleError", e[e.InsufficientPermissionsError = 19] = "InsufficientPermissionsError", e[e.PaymentPendingError = 20] = "PaymentPendingError", e[e.InvalidSubscriberAttributesError = 21] = "InvalidSubscriberAttributesError", e[e.LogOutWithAnonymousUserError = 22] = "LogOutWithAnonymousUserError", e[e.ConfigurationError = 23] = "ConfigurationError", e[e.UnsupportedError = 24] = "UnsupportedError", e[e.EmptySubscriberAttributesError = 25] = "EmptySubscriberAttributesError", e[e.CustomerInfoError = 28] = "CustomerInfoError", e[e.SignatureVerificationError = 36] = "SignatureVerificationError", e[e.InvalidEmailError = 38] = "InvalidEmailError", e[e.TestStoreSimulatedPurchaseError = 42] = "TestStoreSimulatedPurchaseError", e))(Ge || {});
class Kn {
  // This is the message shown to developers. It is not intended to be displayed to end customers.
  static getPublicMessage(r) {
    switch (r) {
      case 0:
        return "Unknown error.";
      case 1:
        return "Purchase was cancelled.";
      case 2:
        return "There was a problem with the store.";
      case 3:
        return "The device or user is not allowed to make the purchase.";
      case 4:
        return "One or more of the arguments provided are invalid.";
      case 5:
        return "The product is not available for purchase.";
      case 6:
        return "This product is already active for the user.";
      case 7:
        return "There is already another active subscriber using the same receipt.";
      case 8:
        return "The receipt is not valid.";
      case 9:
        return "The receipt is missing.";
      case 10:
        return "Error performing request. Please check your network connection and try again.";
      case 11:
        return "There was a credentials issue. Check the underlying error for more details.";
      case 12:
        return "Received unexpected response from the backend.";
      case 14:
        return "The app user id is not valid.";
      case 15:
        return "The operation is already in progress.";
      case 16:
        return "There was an unknown backend error.";
      case 17:
        return "Apple Subscription Key is invalid or not present. In order to provide subscription offers, you must first generate a subscription key. Please see https://docs.revenuecat.com/docs/ios-subscription-offers for more info.";
      case 18:
        return "The User is ineligible for that action.";
      case 19:
        return "App does not have sufficient permissions to make purchases.";
      case 20:
        return "The payment is pending.";
      case 21:
        return "One or more of the attributes sent could not be saved.";
      case 22:
        return "Called logOut but the current user is anonymous.";
      case 23:
        return "There is an issue with your configuration. Check the underlying error for more details.";
      case 24:
        return "There was a problem with the operation. Looks like we doesn't support that yet. Check the underlying error for more details.";
      case 25:
        return "A request for subscriber attributes returned none.";
      case 28:
        return "There was a problem related to the customer info.";
      case 36:
        return "Request failed signature verification. Please see https://rev.cat/trusted-entitlements for more info.";
      case 38:
        return "Email is not valid. Please provide a valid email address.";
      case 42:
        return "Purchase failure simulated successfully in Test Store.";
    }
  }
  static getErrorCodeForBackendErrorCode(r) {
    switch (r) {
      case 7101:
      case 7773:
      case 7898:
      case 7899:
      case 7900:
      case 7901:
        return 2;
      case 7102:
        return 7;
      case 7103:
        return 8;
      case 7107:
      case 7224:
      case 7225:
      case 7967:
        return 11;
      case 7105:
      case 7106:
      case 7814:
      case 7877:
      case 7878:
        return 4;
      case 7772:
        return 6;
      case 7220:
        return 14;
      case 7259:
        return 28;
      case 7229:
        return 2;
      case 7230:
      case 7e3:
        return 23;
      case 7231:
        return 2;
      case 7232:
        return 18;
      case 7263:
      case 7264:
        return 21;
      case 7104:
      case 7234:
      case 7226:
      case 7110:
        return 12;
      case 7662:
        return 24;
      case 7012:
      case 7834:
      case 7879:
        return 38;
    }
  }
  static convertCodeToBackendErrorCode(r) {
    return r in Hn ? r : null;
  }
  static convertPurchaseFlowErrorCodeToErrorCode(r) {
    switch (r) {
      case ee.ErrorSettingUpPurchase:
        return 2;
      case ee.ErrorChargingPayment:
        return 20;
      case ee.NetworkError:
        return 10;
      case ee.MissingEmailError:
        return 4;
      case ee.AlreadyPurchasedError:
        return 6;
      case ee.InvalidPaddleAPIKeyError:
        return 11;
      default:
        return 0;
    }
  }
}
var Hn = /* @__PURE__ */ ((e) => (e[e.BackendInvalidPlatform = 7e3] = "BackendInvalidPlatform", e[e.BackendInvalidEmail = 7012] = "BackendInvalidEmail", e[e.BackendStoreProblem = 7101] = "BackendStoreProblem", e[e.BackendCannotTransferPurchase = 7102] = "BackendCannotTransferPurchase", e[e.BackendInvalidReceiptToken = 7103] = "BackendInvalidReceiptToken", e[e.BackendInvalidAppStoreSharedSecret = 7104] = "BackendInvalidAppStoreSharedSecret", e[e.BackendInvalidPaymentModeOrIntroPriceNotProvided = 7105] = "BackendInvalidPaymentModeOrIntroPriceNotProvided", e[e.BackendProductIdForGoogleReceiptNotProvided = 7106] = "BackendProductIdForGoogleReceiptNotProvided", e[e.BackendInvalidPlayStoreCredentials = 7107] = "BackendInvalidPlayStoreCredentials", e[e.BackendInternalServerError = 7110] = "BackendInternalServerError", e[e.BackendEmptyAppUserId = 7220] = "BackendEmptyAppUserId", e[e.BackendInvalidAuthToken = 7224] = "BackendInvalidAuthToken", e[e.BackendInvalidAPIKey = 7225] = "BackendInvalidAPIKey", e[e.BackendBadRequest = 7226] = "BackendBadRequest", e[e.BackendPlayStoreQuotaExceeded = 7229] = "BackendPlayStoreQuotaExceeded", e[e.BackendPlayStoreInvalidPackageName = 7230] = "BackendPlayStoreInvalidPackageName", e[e.BackendPlayStoreGenericError = 7231] = "BackendPlayStoreGenericError", e[e.BackendUserIneligibleForPromoOffer = 7232] = "BackendUserIneligibleForPromoOffer", e[e.BackendInvalidAppleSubscriptionKey = 7234] = "BackendInvalidAppleSubscriptionKey", e[e.BackendSubscriberNotFound = 7259] = "BackendSubscriberNotFound", e[e.BackendInvalidSubscriberAttributes = 7263] = "BackendInvalidSubscriberAttributes", e[e.BackendInvalidSubscriberAttributesBody = 7264] = "BackendInvalidSubscriberAttributesBody", e[e.BackendProductIDsMalformed = 7662] = "BackendProductIDsMalformed", e[e.BackendAlreadySubscribedError = 7772] = "BackendAlreadySubscribedError", e[e.BackendPaymentGatewayGenericError = 7773] = "BackendPaymentGatewayGenericError", e[e.BackendOfferNotFound = 7814] = "BackendOfferNotFound", e[e.BackendNoMXRecordsFound = 7834] = "BackendNoMXRecordsFound", e[e.BackendInvalidOperationSession = 7877] = "BackendInvalidOperationSession", e[e.BackendPurchaseCannotBeCompleted = 7878] = "BackendPurchaseCannotBeCompleted", e[e.BackendEmailIsRequired = 7879] = "BackendEmailIsRequired", e[e.BackendGatewaySetupErrorStripeTaxNotActive = 7898] = "BackendGatewaySetupErrorStripeTaxNotActive", e[e.BackendGatewaySetupErrorInvalidTaxOriginAddress = 7899] = "BackendGatewaySetupErrorInvalidTaxOriginAddress", e[e.BackendGatewaySetupErrorMissingRequiredPermission = 7900] = "BackendGatewaySetupErrorMissingRequiredPermission", e[e.BackendGatewaySetupErrorSandboxModeOnly = 7901] = "BackendGatewaySetupErrorSandboxModeOnly", e[e.BackendInvalidPaddleAPIKey = 7967] = "BackendInvalidPaddleAPIKey", e))(Hn || {});
class Oe extends Error {
  constructor(t, n, a, o) {
    super(n);
    U(this, "toString", () => `PurchasesError(code: ${Ge[this.errorCode]}, message: ${this.message})`);
    this.errorCode = t, this.underlyingErrorMessage = a, this.extra = o;
  }
  /** @internal */
  static getForBackendError(t, n) {
    const a = Kn.getErrorCodeForBackendErrorCode(t);
    return new Oe(
      a,
      Kn.getPublicMessage(a),
      n,
      { backendErrorCode: t }
    );
  }
  /** @internal */
  static getForPurchasesFlowError(t) {
    return new Oe(
      Kn.convertPurchaseFlowErrorCodeToErrorCode(
        t.errorCode
      ),
      t.message,
      t.underlyingErrorMessage
    );
  }
}
class ng extends Error {
  constructor() {
    super("Purchases must be configured before calling getInstance");
  }
}
var Lt = /* @__PURE__ */ ((e) => (e.Started = "started", e.InProgress = "in_progress", e.Succeeded = "succeeded", e.Failed = "failed", e))(Lt || {}), Un = /* @__PURE__ */ ((e) => (e[e.SetupIntentCreationFailed = 1] = "SetupIntentCreationFailed", e[e.PaymentMethodCreationFailed = 2] = "PaymentMethodCreationFailed", e[e.PaymentChargeFailed = 3] = "PaymentChargeFailed", e[e.SetupIntentCompletionFailed = 4] = "SetupIntentCompletionFailed", e[e.AlreadyPurchased = 5] = "AlreadyPurchased", e))(Un || {}), Mr = /* @__PURE__ */ ((e) => (e[e.Silent = 0] = "Silent", e[e.Error = 1] = "Error", e[e.Warn = 2] = "Warn", e[e.Info = 3] = "Info", e[e.Debug = 4] = "Debug", e[e.Verbose = 5] = "Verbose", e))(Mr || {});
class se {
  static setLogLevel(r) {
    this.logLevel = r;
  }
  static setLogHandler(r) {
    this.logHandler = r;
  }
  static log(r, t = this.logLevel) {
    const n = `[Purchases] ${r}`;
    if (!(this.logLevel < t || t === Mr.Silent)) {
      if (this.logHandler !== null) {
        this.logHandler(t, n);
        return;
      }
      switch (t) {
        case Mr.Error:
          console.error(n);
          break;
        case Mr.Warn:
          console.warn(n);
          break;
        case Mr.Info:
          console.info(n);
          break;
        case Mr.Debug:
          console.debug(n);
          break;
        case Mr.Verbose:
          console.debug(n);
          break;
      }
    }
  }
  static errorLog(r) {
    this.log(r, Mr.Error);
  }
  static warnLog(r) {
    this.log(r, Mr.Warn);
  }
  static infoLog(r) {
    this.log(r, Mr.Info);
  }
  static debugLog(r) {
    this.log(r, Mr.Debug);
  }
  static verboseLog(r) {
    this.log(r, Mr.Verbose);
  }
}
U(se, "logLevel", Mr.Silent), U(se, "logHandler", null);
function Nu(e) {
  var r;
  return e.operation.redemption_info ? {
    redeemUrl: ((r = e.operation.redemption_info) == null ? void 0 : r.redeem_url) ?? null
  } : null;
}
function Ou(e, r) {
  if (e == null) {
    r(
      new ae(
        ee.UnknownError,
        "Got an error status but error field is empty."
      )
    );
    return;
  }
  switch (e.code) {
    case Un.SetupIntentCreationFailed:
      r(
        new ae(
          ee.ErrorSettingUpPurchase,
          "Setup intent creation failed"
        )
      );
      return;
    case Un.PaymentMethodCreationFailed:
      r(
        new ae(
          ee.ErrorSettingUpPurchase,
          "Payment method creation failed"
        )
      );
      return;
    case Un.PaymentChargeFailed:
      r(
        new ae(
          ee.ErrorChargingPayment,
          "Payment charge failed"
        )
      );
      return;
    case Un.SetupIntentCompletionFailed:
      r(
        new ae(
          ee.ErrorSettingUpPurchase,
          "Setup intent completion failed"
        )
      );
      return;
    case Un.AlreadyPurchased:
      r(
        new ae(
          ee.AlreadyPurchasedError,
          "Purchased was already completed"
        )
      );
      return;
    default:
      r(
        new ae(
          ee.UnknownError,
          "Unknown error code received"
        )
      );
      return;
  }
}
var ee = /* @__PURE__ */ ((e) => (e[e.ErrorSettingUpPurchase = 0] = "ErrorSettingUpPurchase", e[e.ErrorChargingPayment = 1] = "ErrorChargingPayment", e[e.UnknownError = 2] = "UnknownError", e[e.NetworkError = 3] = "NetworkError", e[e.MissingEmailError = 4] = "MissingEmailError", e[e.AlreadyPurchasedError = 5] = "AlreadyPurchasedError", e[e.StripeTaxNotActive = 6] = "StripeTaxNotActive", e[e.StripeInvalidTaxOriginAddress = 7] = "StripeInvalidTaxOriginAddress", e[e.StripeMissingRequiredPermission = 8] = "StripeMissingRequiredPermission", e[e.InvalidPaddleAPIKeyError = 9] = "InvalidPaddleAPIKeyError", e))(ee || {});
class ae extends Error {
  constructor(r, t, n, a, o, s) {
    super(t), this.errorCode = r, this.underlyingErrorMessage = n, this.purchasesErrorCode = a, this.extra = o, this.displayPurchaseFlowErrorCode = s;
  }
  getErrorCode() {
    var t;
    const r = ((t = this.extra) == null ? void 0 : t.backendErrorCode) ?? this.purchasesErrorCode;
    return this.displayPurchaseFlowErrorCode ? this.errorCode ?? r : r ?? this.errorCode;
  }
  static fromPurchasesError(r, t, n = !1) {
    var o;
    let a;
    return r.errorCode === Ge.ProductAlreadyPurchasedError ? a = 5 : r.errorCode === Ge.InvalidEmailError ? a = 4 : r.errorCode === Ge.NetworkError ? a = 3 : a = ae.fromBackendErrorCode((o = r.extra) == null ? void 0 : o.backendErrorCode) ?? t, new ae(
      a,
      r.message,
      r.underlyingErrorMessage,
      r.errorCode,
      r.extra,
      n
    );
  }
  static fromBackendErrorCode(r) {
    switch (r) {
      case Hn.BackendGatewaySetupErrorStripeTaxNotActive:
        return 6;
      case Hn.BackendGatewaySetupErrorInvalidTaxOriginAddress:
        return 7;
      case Hn.BackendGatewaySetupErrorMissingRequiredPermission:
        return 8;
      case Hn.BackendInvalidPaddleAPIKey:
        return 9;
      default:
        return null;
    }
  }
}
class ag {
  constructor(r, t, n = 10) {
    U(this, "operationSessionId", null);
    U(this, "backend");
    U(this, "eventsTracker");
    U(this, "maxNumberAttempts");
    U(this, "waitMSBetweenAttempts", 1e3);
    this.backend = r, this.eventsTracker = t, this.maxNumberAttempts = n;
  }
  async prepareCheckout(r, t) {
    try {
      return await this.backend.postCheckoutPrepare(
        r,
        t
      );
    } catch (n) {
      if (n instanceof Oe)
        throw ae.fromPurchasesError(
          n,
          0
          /* ErrorSettingUpPurchase */
        );
      {
        const a = "Unknown error preparing purchase: " + String(n);
        throw se.errorLog(a), new ae(
          2,
          a
        );
      }
    }
  }
  async checkoutStart(r, t, n, a, o, s, l, c) {
    try {
      const u = this.eventsTracker.getTraceId(), d = l == null ? void 0 : l.stepId, p = await this.backend.postCheckoutStart(
        r,
        t,
        a,
        n,
        u,
        o,
        s,
        d,
        c
      );
      return this.operationSessionId = p.operation_session_id, p;
    } catch (u) {
      if (u instanceof Oe)
        throw ae.fromPurchasesError(
          u,
          0
          /* ErrorSettingUpPurchase */
        );
      {
        const d = "Unknown error starting purchase: " + String(u);
        throw se.errorLog(d), new ae(
          2,
          d
        );
      }
    }
  }
  async checkoutCalculateTax(r, t, n) {
    const a = this.operationSessionId;
    if (!a)
      throw new ae(
        0,
        "No purchase started"
      );
    try {
      return await this.backend.postCheckoutCalculateTax(
        a,
        r,
        t,
        n
      );
    } catch (o) {
      if (o instanceof Oe)
        throw ae.fromPurchasesError(
          o,
          0
          /* ErrorSettingUpPurchase */
        );
      {
        const s = "Unknown error calculating tax: " + String(o);
        throw se.errorLog(s), new ae(
          2,
          s
        );
      }
    }
  }
  async checkoutComplete(r) {
    const t = this.operationSessionId;
    if (!t)
      throw new ae(
        0,
        "No purchase started"
      );
    try {
      return await this.backend.postCheckoutComplete(t, r);
    } catch (n) {
      if (n instanceof Oe)
        throw ae.fromPurchasesError(
          n,
          0
          /* ErrorSettingUpPurchase */
        );
      {
        const a = "Unknown error starting purchase: " + String(n);
        throw se.errorLog(a), new ae(
          2,
          a
        );
      }
    }
  }
  async pollCurrentPurchaseForCompletion() {
    const r = this.operationSessionId;
    if (!r)
      throw new ae(
        0,
        "No purchase in progress"
      );
    return new Promise((t, n) => {
      const a = (o = 1) => {
        if (o > this.maxNumberAttempts) {
          this.clearPurchaseInProgress(), n(
            new ae(
              2,
              "Max attempts reached trying to get successful purchase status"
            )
          );
          return;
        }
        this.backend.getCheckoutStatus(r).then((s) => {
          const l = s.operation.store_transaction_identifier, c = s.operation.product_identifier, u = s.operation.purchase_date ? isNaN(Date.parse(s.operation.purchase_date)) ? null : new Date(s.operation.purchase_date) : null;
          switch (s.operation.status) {
            case Lt.Started:
            case Lt.InProgress:
              setTimeout(
                () => a(o + 1),
                this.waitMSBetweenAttempts
              );
              break;
            case Lt.Succeeded:
              if (this.clearPurchaseInProgress(), !l || !c || !u) {
                n(
                  new ae(
                    2,
                    "Missing required fields in operation response."
                  )
                );
                return;
              }
              t({
                redemptionInfo: Nu(s),
                operationSessionId: r,
                storeTransactionIdentifier: l,
                productIdentifier: c,
                purchaseDate: u
              });
              return;
            case Lt.Failed:
              this.clearPurchaseInProgress(), Ou(
                s.operation.error,
                n
              );
          }
        }).catch((s) => {
          const l = ae.fromPurchasesError(
            s,
            3
            /* NetworkError */
          );
          n(l);
        });
      };
      a();
    });
  }
  clearPurchaseInProgress() {
    this.operationSessionId = null;
  }
}
const vr = "rcb-ui-translator", Ar = "en", og = {
  "periods.week": "{{amount}} week",
  "periods.month": "{{amount}} month",
  "periods.year": "{{amount}} year",
  "periods.day": "{{amount}} day",
  "periods.weekShort": "{{amount}}wk",
  "periods.monthShort": "{{amount}}mo",
  "periods.yearShort": "{{amount}}yr",
  "periods.dayShort": "{{amount}}d",
  "periods.lifetime": "lifetime",
  "periods.weekPlural": "{{amount}} weeks",
  "periods.monthPlural": "{{amount}} months",
  "periods.yearPlural": "{{amount}} years",
  "periods.dayPlural": "{{amount}} days",
  "periods.weekFrequency": "weekly",
  "periods.monthFrequency": "monthly",
  "periods.yearFrequency": "yearly",
  "periods.dayFrequency": "daily",
  "periods.perWeekFrequency": "per week",
  "periods.perMonthFrequency": "per month",
  "periods.perYearFrequency": "per year",
  "periods.perDayFrequency": "per day",
  "periods.unknownFrequency": "unknown",
  "periods.weekFrequencyPlural": "every {{amount}} weeks",
  "periods.monthFrequencyPlural": "every {{amount}} months",
  "periods.yearFrequencyPlural": "every {{amount}} years",
  "periods.dayFrequencyPlural": "every {{amount}} days",
  "product_info.subscribe_to": "Subscribe to",
  "product_info.product_title": "{{productTitle}}",
  "product_info.product_description": "{{productDescription}}",
  "product_info.product_price": "{{productPrice}}",
  "product_info.free_trial_duration": "Try free for {{trialDuration}}",
  "product_info.price_after_free_trial": "After trial ends, on {{renewalDate}}",
  "product_info.intro_price_phase_after_trial": "Then {{introPriceDuration}} for {{introPrice}}",
  "product_info.intro_price_phase": "First {{introPriceDuration}} for {{introPrice}}",
  "product_info.intro_price_phase_paid_once": "paid once",
  "product_info.price_after_intro_price": "After {{introPriceDuration}}, on {{renewalDate}}",
  "product_info.after_trial": "after trial",
  "product_info.after": "after",
  "product_info.total_due_today": "Total due today",
  "product_info.renewal_frequency": "Renews {{frequency}}",
  "product_info.continues_until_cancelled": "Continues until cancelled",
  "product_info.cancel_anytime": "Cancel anytime",
  "payment_entry_page.payment_step_title": "Secure checkout by RevenueCat",
  "payment_entry_page.trial_subscription_terms_info": "After your trial ends, you will be charged {{price}} {{perFrequency}} starting {{renewalDate}}. You can cancel any time before this date.",
  "payment_entry_page.subscription_terms_info": "By subscribing, you agree to allow {{appName}} to charge you according to their terms until you cancel.",
  "payment_entry_page.otp_terms_info": "By purchasing, you agree to allow {{appName}} to charge you according to their terms.",
  "payment_entry_page.terms_link_label": "Terms",
  "payment_entry_page.subscription_info": "Subscription renews automatically. Cancel anytime.",
  "payment_entry_page.button_pay": "Pay now",
  "payment_entry_page.button_start_trial": "Start trial",
  "payment_entry_page.button_with_price": "Pay {{formattedPrice}}",
  "payment_entry_page.button_payment_method": "Pay {{formattedPrice}} with {{paymentMethod}}",
  "payment_entry_page.express_checkout_divider": "OR PAY BY CARD",
  "loading_page.processing_payment": "Processing payment",
  "loading_page.keep_page_open": "The process is almost done. Keep this page open.",
  "success_page.purchase_successful": "Payment complete",
  "success_page.button_close": "Continue",
  "error_page.close_button_title": "Go to {{appName}}",
  "error_page.if_error_persists": "If it persists, please contact ",
  "error_page.trouble_accessing": "If you're having trouble accessing your purchase, reach out to support on ",
  "error_page.error_title_already_subscribed": "You already subscribed to {{productTitle}}",
  "error_page.error_title_already_purchased": "You already purchased {{productTitle}}",
  "error_page.error_title_other_errors": "Something went wrong",
  "error_page.error_message_already_subscribed": "You can't subscribe to this product again.",
  "error_page.error_message_already_purchased": "You can't purchase this product again.",
  "error_page.error_title_stripe_tax_not_active": "Stripe Tax not active",
  "error_page.error_title_stripe_invalid_tax_origin_address": "Invalid tax origin address",
  "error_page.error_title_stripe_missing_required_permission": "Missing Stripe permission",
  "error_page.error_message_missing_email_error": "Email is required to complete the purchase.",
  "error_page.error_message_invalid_email_error": "The email address {{email}} couldn't be verified. Please provide a valid email address.",
  "error_page.error_message_network_error": "Network error. Please check your internet connection.",
  "error_page.error_message_error_charging_payment": "Payment failed.",
  "error_page.error_message_error_setting_up_purchase": "Purchase not started due to an error (error code: {{errorCode}}).",
  "error_page.error_message_invalid_tax_location": "We couldn't verify your billing address. Please double-check that the postal code and country are correct.",
  "error_page.error_message_unknown_error": "An unknown error occurred (error code: {{errorCode}}).",
  "error_page.error_message_stripe_tax_not_active": "The purchase failed because Stripe Tax isn’t enabled. In production, purchases will work without taxes applied.",
  "error_page.error_message_stripe_invalid_tax_origin_address": "The purchase failed because the tax origin address is invalid. In production, purchases will work without taxes applied.",
  "error_page.error_message_stripe_missing_required_permission": "The purchase failed because the Stripe app lacks a required permission. In production, purchases will work without taxes applied.",
  "error_page.error_only_in_sandbox": "This message appears only in sandbox.",
  "error_page.button_try_again": "Try again",
  "error_page.button_close": "Close",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}%",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "pricing_dropdown.show_details": "Show details",
  "pricing_dropdown.hide_details": "Hide details",
  "pricing_table.trial_ends": "After trial ends, on {{formattedTrialEndDate}}",
  "pricing_table.total_excluding_tax": "Total excluding tax",
  "pricing_table.total_due_today": "Total due today",
  "pricing_table.subtotal": "Subtotal",
  "pricing_table.discount": "Discount",
  "pricing_table.tax": "Tax",
  "pricing_table.enter_billing_address_to_calculate": "Enter billing address to calculate",
  "pricing_table.enter_postal_code_to_calculate": "Enter zip code to calculate",
  "pricing_table.enter_state_or_postal_code_to_calculate": "Enter state or postal code to calculate",
  "navbar_header.details": "Details",
  "navbar_header.back_button": "Back",
  "price_update.title": "Price update",
  "price_update.base_message": "The total price was updated with tax based on your billing address. Please review and try again. Your card will only be charged once.",
  "price_update.trial_message": "The subscription price was updated to include tax based on your billing address. Free trial still applies. Review and try again.",
  "apple_pay.free_trial": "Free Trial"
}, ig = {
  "periods.week": "{{amount}} semana",
  "periods.month": "{{amount}} mes",
  "periods.year": "{{amount}} año",
  "periods.day": "{{amount}} día",
  "periods.weekShort": "{{amount}} sem",
  "periods.monthShort": "{{amount}}mes",
  "periods.yearShort": "{{amount}}año",
  "periods.dayShort": "{{amount}}d",
  "periods.lifetime": "de por vida",
  "periods.weekPlural": "{{amount}} semanas",
  "periods.monthPlural": "{{amount}} meses",
  "periods.yearPlural": "{{amount}} años",
  "periods.dayPlural": "{{amount}} días",
  "periods.weekFrequency": "semanal",
  "periods.monthFrequency": "mensual",
  "periods.yearFrequency": "anual",
  "periods.dayFrequency": "diaria",
  "periods.perWeekFrequency": "por semana",
  "periods.perMonthFrequency": "por mes",
  "periods.perYearFrequency": "por año",
  "periods.perDayFrequency": "por día",
  "periods.unknownFrequency": "desconocida",
  "periods.weekFrequencyPlural": "cada {{amount}} semanas",
  "periods.monthFrequencyPlural": "cada {{amount}} meses",
  "periods.yearFrequencyPlural": "cada {{amount}} años",
  "periods.dayFrequencyPlural": "cada {{amount}} días",
  "product_info.product_title": "{{productTitle}}",
  "product_info.product_description": "{{productDescription}}",
  "product_info.product_price": "{{productPrice}}",
  "product_info.free_trial_duration": "{{trialDuration}} prueba gratuita",
  "product_info.price_after_free_trial": "Después de que termine el periodo de prueba, el {{renewalDate}}",
  "product_info.renewal_frequency": "Se renueva {{frequency}}",
  "product_info.continues_until_cancelled": "Continua hasta que se cancele",
  "product_info.cancel_anytime": "Cancelar en cualquier momento",
  "payment_entry_page.payment_step_title": "Pago seguro mediante RevenueCat",
  "payment_entry_page.button_pay": "Pagar ahora",
  "payment_entry_page.button_start_trial": "Comenzar prueba",
  "success_page.purchase_successful": "Pago completado",
  "success_page.button_close": "Continuar",
  "error_page.if_error_persists": "Si el error persiste, contacta con ",
  "error_page.error_title_already_subscribed": "Ya te has suscrito a {{productTitle}}",
  "error_page.error_title_already_purchased": "Ya has comprado {{productTitle}}",
  "error_page.error_title_other_errors": "Algo salió mal",
  "error_page.error_message_already_subscribed": "No puedes suscribirte a este producto de nuevo.",
  "error_page.error_message_already_purchased": "No puedes comprar este producto de nuevo.",
  "error_page.error_message_missing_email_error": "Se requiere un correo electrónico para completar la compra.",
  "error_page.error_message_network_error": "Error de red. Por favor, comprueba tu conexión a internet.",
  "error_page.error_message_error_charging_payment": "Pago fallido.",
  "error_page.error_message_error_setting_up_purchase": "No se pudo iniciar la compra debido a un error (código de error: {{errorCode}}).",
  "error_page.error_message_invalid_tax_location": "No pudimos verificar tu dirección de facturación. Por favor, verifica que el código postal y el país sean correctos.",
  "error_page.error_message_unknown_error": "Ocurrió un error desconocido (código de error: {{errorCode}}).",
  "error_page.button_try_again": "Intentar de nuevo",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}%",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "product_info.total_due_today": "Total a pagar hoy",
  "product_info.subscribe_to": "Suscribirse a",
  "navbar_header.details": "Detalles",
  "navbar_header.back_button": "Atrás",
  "pricing_dropdown.show_details": "Mostrar detalles",
  "pricing_dropdown.hide_details": "Ocultar detalles",
  "pricing_table.tax": "Impuestos",
  "pricing_table.trial_ends": "Después de que finalice la prueba, el {{formattedTrialEndDate}}",
  "pricing_table.total_due_today": "Total a pagar hoy",
  "pricing_table.total_excluding_tax": "Total sin impuestos",
  "pricing_table.enter_billing_address_to_calculate": "Introduce la dirección de facturación para calcular",
  "pricing_table.enter_state_or_postal_code_to_calculate": "Introduce el estado o el código postal para calcular",
  "pricing_table.enter_postal_code_to_calculate": "Introduce el código postal para calcular",
  "error_page.error_message_invalid_email_error": "La dirección de correo electrónico {{email}} no se pudo verificar. Por favor, proporciona una dirección de correo electrónico válida.",
  "payment_entry_page.button_payment_method": "Pagar {{formattedPrice}} con {{paymentMethod}}",
  "payment_entry_page.button_with_price": "Pagar {{formattedPrice}}",
  "price_update.title": "Actualización de precio",
  "price_update.base_message": "El precio total se actualizó con impuestos según su dirección de facturación. Revise e intente nuevamente. Solo se efectuará un cobro en su tarjeta.",
  "price_update.trial_message": "El precio de la suscripción se actualizó para incluir impuestos según su dirección de facturación. La prueba gratuita sigue aplicándose. Revise e intente nuevamente.",
  "payment_entry_page.express_checkout_divider": "O PAGA CON TARJETA",
  "error_page.trouble_accessing": "Si tiene problemas para acceder a su compra, póngase en contacto con el servicio de asistencia en ",
  "error_page.close_button_title": "Ir a {{appName}}",
  "error_page.error_title_stripe_missing_required_permission": "Falta permiso de Stripe",
  "error_page.button_close": "Cerrar",
  "error_page.error_message_stripe_invalid_tax_origin_address": "La compra falló porque la dirección de origen fiscal no es válida. En producción, las compras funcionarán sin impuestos aplicados.",
  "error_page.error_message_stripe_tax_not_active": "La compra falló porque Stripe Tax no está habilitado. En producción, las compras funcionarán sin impuestos aplicados.",
  "error_page.error_only_in_sandbox": "Este mensaje aparece solo en el entorno de pruebas.",
  "error_page.error_message_stripe_missing_required_permission": "La compra falló porque la aplicación Stripe carece de un permiso necesario. En producción, las compras funcionarán sin impuestos aplicados.",
  "error_page.error_title_stripe_tax_not_active": "Stripe Tax no está activo",
  "error_page.error_title_stripe_invalid_tax_origin_address": "Dirección de origen fiscal no válida",
  "apple_pay.free_trial": "Prueba gratuita",
  "product_info.price_after_intro_price": "Después de {{introPriceDuration}}, el {{renewalDate}}",
  "product_info.after_trial": "después del período de prueba",
  "product_info.after": "después de",
  "product_info.intro_price_phase_after_trial": "Luego, {{introPriceDuration}} por {{introPrice}}",
  "product_info.intro_price_phase": "Primero, {{introPriceDuration}} por {{introPrice}}",
  "product_info.intro_price_phase_paid_once": "pago único",
  "payment_entry_page.trial_subscription_terms_info": "Una vez finalizado el período de prueba, se te cobrarán {{price}} {{perFrequency}} a partir del {{renewalDate}}. Puedes cancelar en cualquier momento antes de esta fecha.",
  "payment_entry_page.subscription_info": "La suscripción se renueva automáticamente. Cancela en cualquier momento.",
  "payment_entry_page.otp_terms_info": "Al comprar, aceptas que {{appName}} te cobre de acuerdo con sus términos.",
  "payment_entry_page.terms_link_label": "Términos",
  "payment_entry_page.subscription_terms_info": "Al suscribirte, aceptas que {{appName}} te cobre de acuerdo con sus términos hasta que canceles.",
  "loading_page.keep_page_open": "El proceso está casi terminado. Mantén esta página abierta.",
  "loading_page.processing_payment": "Procesando el pago",
  "pricing_table.discount": "Descuento",
  "pricing_table.subtotal": "Subtotal"
}, sg = {
  "periods.week": "{{amount}} settimana",
  "periods.month": "{{amount}} mese",
  "periods.year": "{{amount}} anno",
  "periods.day": "{{amount}} giorno",
  "periods.weekShort": "{{amount}}sett",
  "periods.monthShort": "{{amount}}mese",
  "periods.yearShort": "{{amount}}anno",
  "periods.dayShort": "{{amount}}g",
  "periods.lifetime": "a vita",
  "periods.weekPlural": "{{amount}} settimane",
  "periods.monthPlural": "{{amount}} mesi",
  "periods.yearPlural": "{{amount}} anni",
  "periods.dayPlural": "{{amount}} giorni",
  "periods.weekFrequency": "settimanale",
  "periods.monthFrequency": "mensile",
  "periods.yearFrequency": "annuale",
  "periods.dayFrequency": "giornaliero",
  "periods.perWeekFrequency": "a settimana",
  "periods.perMonthFrequency": "al mese",
  "periods.perYearFrequency": "all'anno",
  "periods.perDayFrequency": "al giorno",
  "periods.unknownFrequency": "sconosciuto",
  "periods.weekFrequencyPlural": "ogni {{amount}} settimane",
  "periods.monthFrequencyPlural": "ogni {{amount}} mesi",
  "periods.yearFrequencyPlural": "ogni {{amount}} anni",
  "periods.dayFrequencyPlural": "ogni {{amount}} giorni",
  "product_info.product_title": "{{productTitle}}",
  "product_info.product_description": "{{productDescription}}",
  "product_info.product_price": "{{productPrice}}",
  "product_info.free_trial_duration": "{{trialDuration}} prova gratuita",
  "product_info.price_after_free_trial": "Dopo la fine della prova, il {{renewalDate}}",
  "product_info.renewal_frequency": "Si rinnova {{frequency}}",
  "product_info.continues_until_cancelled": "Continua fino a disdetta",
  "product_info.cancel_anytime": "Disdici in qualsiasi momento",
  "payment_entry_page.payment_step_title": "Pagamento sicuro tramite RevenueCat",
  "payment_entry_page.button_pay": "Paga ora",
  "payment_entry_page.button_start_trial": "Inizia la prova",
  "success_page.purchase_successful": "Pagamento completato",
  "success_page.button_close": "Continua",
  "error_page.if_error_persists": "Se l'errore persiste, contatta ",
  "error_page.error_title_already_subscribed": "Hai già un abbonamento a {{productTitle}}",
  "error_page.error_title_already_purchased": "Hai già acquistato {{productTitle}}",
  "error_page.error_title_other_errors": "Qualcosa è andato storto",
  "error_page.error_message_already_subscribed": "Non puoi abbonarti di nuovo a questo prodotto.",
  "error_page.error_message_already_purchased": "Non puoi acquistare di nuovo questo prodotto.",
  "error_page.error_message_missing_email_error": "L'email è necessaria per completare l'acquisto.",
  "error_page.error_message_network_error": "Errore di rete. Verifica la connessione internet.",
  "error_page.error_message_error_charging_payment": "Pagamento fallito.",
  "error_page.error_message_error_setting_up_purchase": "Acquisto non avviato a causa di un errore (codice errore: {{errorCode}}).",
  "error_page.error_message_invalid_tax_location": "Non siamo riusciti a verificare il tuo indirizzo di fatturazione. Per favore, controlla che il codice postale e il paese siano corretti.",
  "error_page.error_message_unknown_error": "Si è verificato un errore sconosciuto (codice errore: {{errorCode}}).",
  "error_page.button_try_again": "Riprova",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}%",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "product_info.total_due_today": "Totale dovuto oggi",
  "product_info.subscribe_to": "Abbonati a",
  "navbar_header.details": "Dettagli",
  "navbar_header.back_button": "Indietro",
  "pricing_dropdown.show_details": "Mostra dettagli",
  "pricing_dropdown.hide_details": "Nascondi dettagli",
  "pricing_table.tax": "Tasse",
  "pricing_table.trial_ends": "Al termine del periodo di prova, il {{formattedTrialEndDate}}",
  "pricing_table.total_due_today": "Totale dovuto oggi",
  "pricing_table.total_excluding_tax": "Totale tasse escluse",
  "pricing_table.enter_billing_address_to_calculate": "Inserisci l'indirizzo di fatturazione per calcolare",
  "pricing_table.enter_state_or_postal_code_to_calculate": "Inserisci la regione o il codice postale per calcolare",
  "pricing_table.enter_postal_code_to_calculate": "Inserisci il codice postale per calcolare",
  "error_page.error_message_invalid_email_error": "L'indirizzo email {{email}} non può essere verificato. Si prega di fornire un indirizzo email valido.",
  "payment_entry_page.button_payment_method": "Paga {{formattedPrice}} con {{paymentMethod}}",
  "payment_entry_page.button_with_price": "Paga {{formattedPrice}}",
  "price_update.title": "Aggiornamento prezzo",
  "price_update.base_message": "Il prezzo totale è stato aggiornato con le tasse in base al tuo indirizzo di fatturazione. Rivedi e riprova. L'addebito sulla tua carta avverrà solo una volta.",
  "price_update.trial_message": "Il prezzo dell'abbonamento è stato aggiornato per includere le tasse in base al tuo indirizzo di fatturazione. La prova gratuita è ancora valida. Controlla e riprova.",
  "payment_entry_page.express_checkout_divider": "OPPURE PAGA CON CARTA",
  "error_page.trouble_accessing": "Se hai problemi ad accedere al tuo acquisto, contatta l'assistenza all'indirizzo ",
  "error_page.close_button_title": "Vai a {{appName}}",
  "error_page.error_title_stripe_missing_required_permission": "Autorizzazione Stripe mancante",
  "error_page.button_close": "Chiudi",
  "error_page.error_message_stripe_invalid_tax_origin_address": "L'acquisto non è andato a buon fine perché l'indirizzo di origine fiscale non è valido. In produzione, gli acquisti verranno effettuati senza l'applicazione delle imposte e questo errore non sarà visibile.",
  "error_page.error_message_stripe_tax_not_active": "L'acquisto non è andato a buon fine perché Stripe Tax non è abilitato. In produzione, gli acquisti verranno effettuati senza l'applicazione delle imposte e questo errore non sarà visibile.",
  "error_page.error_only_in_sandbox": "Questo messaggio viene visualizzato solo in sandbox.",
  "error_page.error_message_stripe_missing_required_permission": "L'acquisto non è andato a buon fine perché l'app Stripe non dispone dell'autorizzazione necessaria. In produzione, gli acquisti verranno effettuati senza l'applicazione delle imposte e questo errore non sarà visibile.",
  "error_page.error_title_stripe_tax_not_active": "Stripe Tax non attivo",
  "error_page.error_title_stripe_invalid_tax_origin_address": "Indirizzo di origine fiscale non valido",
  "apple_pay.free_trial": "Prova gratuita",
  "product_info.price_after_intro_price": "Dopo {{introPriceDuration}}, il {{renewalDate}}",
  "product_info.after_trial": "dopo il periodo di prova",
  "product_info.after": "dopo",
  "product_info.intro_price_phase_after_trial": "Poi {{introPriceDuration}} a {{introPrice}}",
  "product_info.intro_price_phase": "Prima {{introPriceDuration}} a {{introPrice}}",
  "product_info.intro_price_phase_paid_once": "pagato una volta",
  "payment_entry_page.trial_subscription_terms_info": "Al termine del periodo di prova, ti verranno addebitati {{price}} {{perFrequency}} a partire dal {{renewalDate}}. Puoi annullare in qualsiasi momento prima di questa data.",
  "payment_entry_page.subscription_info": "L'abbonamento si rinnova automaticamente. Annulla in qualsiasi momento.",
  "payment_entry_page.otp_terms_info": "Acquistando, accetti che {{appName}} ti addebiti l'importo in base ai suoi termini.",
  "payment_entry_page.terms_link_label": "Termini",
  "payment_entry_page.subscription_terms_info": "Abbonandoti, accetti che {{appName}} ti addebiti l'importo secondo i suoi termini fino all'annullamento.",
  "loading_page.keep_page_open": "Il processo è quasi terminato. Mantieni questa pagina aperta.",
  "loading_page.processing_payment": "Elaborazione del pagamento",
  "pricing_table.discount": "Sconto",
  "pricing_table.subtotal": "Subtotale"
}, lg = {
  "periods.week": "{{amount}} أسبوع",
  "periods.month": "{{amount}} شهر",
  "periods.year": "{{amount}} سنة",
  "periods.day": "{{amount}} يوم",
  "periods.weekShort": "{{amount}}أسبوع",
  "periods.monthShort": "{{amount}}شهر",
  "periods.yearShort": "{{amount}}سنة",
  "periods.dayShort": "{{amount}}يوم",
  "periods.lifetime": "مدى الحياة",
  "periods.weekPlural": "{{amount}} أسابيع",
  "periods.monthPlural": "{{amount}} أشهر",
  "periods.yearPlural": "{{amount}} سنوات",
  "periods.dayPlural": "{{amount}} أيام",
  "periods.weekFrequency": "أسبوعيًا",
  "periods.monthFrequency": "شهريًا",
  "periods.yearFrequency": "سنويًا",
  "periods.dayFrequency": "يوميًا",
  "periods.perWeekFrequency": "في الأسبوع",
  "periods.perMonthFrequency": "في الشهر",
  "periods.perYearFrequency": "في السنة",
  "periods.perDayFrequency": "في اليوم",
  "periods.unknownFrequency": "غير معروف",
  "periods.weekFrequencyPlural": "كل {{amount}} أسابيع",
  "periods.monthFrequencyPlural": "كل {{amount}} أشهر",
  "periods.yearFrequencyPlural": "كل {{amount}} سنوات",
  "periods.dayFrequencyPlural": "كل {{amount}} أيام",
  "product_info.product_title": "{{productTitle}}",
  "product_info.product_description": "{{productDescription}}",
  "product_info.product_price": "{{productPrice}}",
  "product_info.free_trial_duration": "{{trialDuration}} تجربة مجانية",
  "product_info.price_after_free_trial": "بعد انتهاء التجربة، في {{renewalDate}}",
  "product_info.renewal_frequency": "يتم التجديد {{frequency}}",
  "product_info.continues_until_cancelled": "يستمر حتى يتم إلغاؤه",
  "product_info.cancel_anytime": "يمكن الإلغاء في أي وقت",
  "payment_entry_page.payment_step_title": "الدفع الآمن عبر RevenueCat",
  "payment_entry_page.button_pay": "ادفع الآن",
  "payment_entry_page.button_start_trial": "ابدأ التجربة",
  "success_page.purchase_successful": "تم الدفع بنجاح",
  "success_page.button_close": "متابعة",
  "error_page.if_error_persists": "إذا استمرت المشكلة، يرجى الاتصال بـ ",
  "error_page.error_title_already_subscribed": "أنت مشترك بالفعل في {{productTitle}}",
  "error_page.error_title_already_purchased": "لقد اشتريت {{productTitle}} بالفعل",
  "error_page.error_title_other_errors": "حدث خطأ ما",
  "error_page.error_message_already_subscribed": "لا يمكنك الاشتراك في هذا المنتج مرة أخرى.",
  "error_page.error_message_already_purchased": "لا يمكنك شراء هذا المنتج مرة أخرى.",
  "error_page.error_message_missing_email_error": "يُطلب البريد الإلكتروني لإتمام عملية الشراء.",
  "error_page.error_message_network_error": "خطأ في الشبكة. يرجى التحقق من اتصال الإنترنت.",
  "error_page.error_message_error_charging_payment": "فشل الدفع.",
  "error_page.error_message_error_setting_up_purchase": "لم تبدأ عملية الشراء بسبب خطأ (رمز الخطأ: {{errorCode}}).",
  "error_page.error_message_invalid_tax_location": "لم نتمكن من التحقق من عنوان الفوترة الخاص بك. يرجى التحقق مرة أخرى من الرمز البريدي والبلد للتأكد من صحتهما.",
  "error_page.error_message_unknown_error": "حدث خطأ غير معروف (رمز الخطأ: {{errorCode}}).",
  "error_page.button_try_again": "حاول مرة أخرى",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}%",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "product_info.total_due_today": "إجمالي المبلغ المستحق اليوم",
  "product_info.subscribe_to": "اشترك في",
  "navbar_header.details": "تفاصيل",
  "navbar_header.back_button": "عودة",
  "pricing_dropdown.show_details": "إظهار التفاصيل",
  "pricing_dropdown.hide_details": "إخفاء التفاصيل",
  "pricing_table.tax": "الضريبة",
  "pricing_table.trial_ends": "بعد انتهاء الفترة التجريبية، في {{formattedTrialEndDate}}",
  "pricing_table.total_due_today": "الإجمالي المستحق اليوم",
  "pricing_table.total_excluding_tax": "الإجمالي باستثناء الضريبة",
  "pricing_table.enter_billing_address_to_calculate": "أدخل عنوان إرسال الفواتير لحسابها",
  "pricing_table.enter_state_or_postal_code_to_calculate": "أدخل الولاية أو الرمز البريدي للحساب",
  "pricing_table.enter_postal_code_to_calculate": "أدخل الرمز البريدي للحساب",
  "error_page.error_message_invalid_email_error": "تعذر التحقق من عنوان البريد الإلكتروني {{email}}. يرجى تقديم عنوان بريد إلكتروني صالح.",
  "payment_entry_page.button_payment_method": "ادفع {{formattedPrice}} باستخدام {{paymentMethod}}",
  "payment_entry_page.button_with_price": "ادفع {{formattedPrice}}",
  "price_update.title": "تحديث السعر",
  "price_update.base_message": "تم تحديث السعر الإجمالي مع الضريبة بناءً على عنوان إرسال الفواتير الخاص بك. يرجى المراجعة والمحاولة مرة أخرى. لن يتم تحصيل رسوم من بطاقتك إلا مرة واحدة.",
  "price_update.trial_message": "تم تحديث سعر الاشتراك ليشمل الضرائب بناءً على عنوان الفوترة الخاص بك. فترة التجربة المجانية لا تزال سارية. يرجى التحقق والمحاولة مرة أخرى.",
  "payment_entry_page.express_checkout_divider": "أو ادفع بواسطة البطاقة",
  "error_page.trouble_accessing": "إذا كنت تواجه مشكلة في الوصول إلى عملية الشراء، فتواصل مع الدعم على ",
  "error_page.close_button_title": "اذهب إلى {{appName}}",
  "error_page.error_title_stripe_missing_required_permission": "إذن Stripe مفقود",
  "error_page.button_close": "إغلاق",
  "error_page.error_message_stripe_invalid_tax_origin_address": "فشلت عملية الشراء لأن عنوان المنشأ الضريبي غير صالح. في مرحلة الإنتاج، ستعمل عمليات الشراء بدون تطبيق الضرائب.",
  "error_page.error_message_stripe_tax_not_active": "فشلت عملية الشراء لأن ضريبة Stripe غير مفعلة. في مرحلة الإنتاج، ستعمل عمليات الشراء بدون تطبيق الضرائب.",
  "error_page.error_only_in_sandbox": "تظهر هذه الرسالة فقط في البيئة التجريبية.",
  "error_page.error_message_stripe_missing_required_permission": "فشلت عملية الشراء لأن تطبيق Stripe يفتقر إلى إذن مطلوب. في مرحلة الإنتاج، ستعمل عمليات الشراء بدون تطبيق الضرائب.",
  "error_page.error_title_stripe_tax_not_active": "ضريبة Stripe غير نشطة",
  "error_page.error_title_stripe_invalid_tax_origin_address": "عنوان منشأ ضريبي غير صالح",
  "apple_pay.free_trial": "تجربة مجانية",
  "product_info.price_after_intro_price": "بعد {{introPriceDuration}}، في {{renewalDate}}",
  "product_info.after_trial": "بعد الفترة التجريبية",
  "product_info.after": "بعد",
  "product_info.intro_price_phase_after_trial": "ثم {{introPriceDuration}} مقابل {{introPrice}}",
  "product_info.intro_price_phase": "أولاً {{introPriceDuration}} مقابل {{introPrice}}",
  "product_info.intro_price_phase_paid_once": "تدفع مرة واحدة",
  "payment_entry_page.trial_subscription_terms_info": "بعد انتهاء الفترة التجريبية، سيتم محاسبتك بمبلغ {{price}} {{perFrequency}} بدءًا من {{renewalDate}}. يمكنك الإلغاء في أي وقت قبل هذا التاريخ.",
  "payment_entry_page.subscription_info": "يتم تجديد الاشتراك تلقائيًا. يمكنك الإلغاء في أي وقت.",
  "payment_entry_page.otp_terms_info": "بالشراء، أنت توافق على السماح لتطبيق {{appName}} بتحصيل الرسوم منك وفقًا لشروطه.",
  "payment_entry_page.terms_link_label": "الشروط",
  "payment_entry_page.subscription_terms_info": "بالاشتراك، فإنك توافق على السماح لـ {{appName}} بتحصيل رسوم منك وفقًا لشروطها حتى تقوم بالإلغاء.",
  "loading_page.keep_page_open": "العملية شارفت على الانتهاء. أبقِ هذه الصفحة مفتوحة.",
  "loading_page.processing_payment": "جاري معالجة الدفع",
  "pricing_table.discount": "خصم",
  "pricing_table.subtotal": "المجموع الفرعي"
}, cg = {
  "periods.week": "{{amount}} setmana",
  "periods.month": "{{amount}} mes",
  "periods.year": "{{amount}} any",
  "periods.day": "{{amount}} dia",
  "periods.weekShort": "{{amount}}set",
  "periods.monthShort": "{{amount}}mes",
  "periods.yearShort": "{{amount}}any",
  "periods.dayShort": "{{amount}}d",
  "periods.lifetime": "de per vida",
  "periods.weekPlural": "{{amount}} setmanes",
  "periods.monthPlural": "{{amount}} mesos",
  "periods.yearPlural": "{{amount}} anys",
  "periods.dayPlural": "{{amount}} dies",
  "periods.weekFrequency": "setmanal",
  "periods.monthFrequency": "mensual",
  "periods.yearFrequency": "anual",
  "periods.dayFrequency": "diari",
  "periods.perWeekFrequency": "per setmana",
  "periods.perMonthFrequency": "per mes",
  "periods.perYearFrequency": "per any",
  "periods.perDayFrequency": "per dia",
  "periods.unknownFrequency": "desconeguda",
  "periods.weekFrequencyPlural": "cada {{amount}} setmanes",
  "periods.monthFrequencyPlural": "cada {{amount}} mesos",
  "periods.yearFrequencyPlural": "cada {{amount}} anys",
  "periods.dayFrequencyPlural": "cada {{amount}} dies",
  "product_info.product_title": "{{productTitle}}",
  "product_info.product_description": "{{productDescription}}",
  "product_info.product_price": "{{productPrice}}",
  "product_info.free_trial_duration": "{{trialDuration}} de prova gratuïta",
  "product_info.price_after_free_trial": "Després del període de prova, el {{renewalDate}}",
  "product_info.renewal_frequency": "Es renova {{frequency}}",
  "product_info.continues_until_cancelled": "Continua fins que es cancel·li",
  "product_info.cancel_anytime": "Cancel·la en qualsevol moment",
  "payment_entry_page.payment_step_title": "Pagament segur amb RevenueCat",
  "payment_entry_page.button_pay": "Paga ara",
  "payment_entry_page.button_start_trial": "Comença la prova",
  "success_page.purchase_successful": "Pagament complet",
  "success_page.button_close": "Continua",
  "error_page.if_error_persists": "Si l'error persisteix, contacta amb ",
  "error_page.error_title_already_subscribed": "Ja us heu subscrit a {{productTitle}}",
  "error_page.error_title_already_purchased": "Ja heu comprat {{productTitle}}",
  "error_page.error_title_other_errors": "Alguna cosa ha anat malament",
  "error_page.error_message_already_subscribed": "No us podeu subscriure a aquest producte de nou.",
  "error_page.error_message_already_purchased": "No podeu comprar aquest producte de nou.",
  "error_page.error_message_missing_email_error": "Es necessita un correu electrònic per completar la compra.",
  "error_page.error_message_network_error": "Error de xarxa. Comprova la teva connexió a internet.",
  "error_page.error_message_error_charging_payment": "El pagament ha fallat.",
  "error_page.error_message_error_setting_up_purchase": "No s'ha iniciat la compra a causa d'un error (codi d'error: {{errorCode}}).",
  "error_page.error_message_invalid_tax_location": "No hem pogut verificar la vostra adreça de facturació. Si us plau, verifiqueu de nou el codi postal i el país per assegurar-vos que són correctes.",
  "error_page.error_message_unknown_error": "S'ha produït un error desconegut (codi d'error: {{errorCode}}).",
  "error_page.button_try_again": "Torna a intentar-ho",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}%",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "product_info.total_due_today": "Total a pagar avui",
  "product_info.subscribe_to": "Subscriu-te a",
  "navbar_header.details": "Detalls",
  "navbar_header.back_button": "Enrere",
  "pricing_dropdown.show_details": "Mostra detalls",
  "pricing_dropdown.hide_details": "Amaga detalls",
  "pricing_table.tax": "Impostos",
  "pricing_table.trial_ends": "Després que finalitzi la prova, el {{formattedTrialEndDate}}",
  "pricing_table.total_due_today": "Total a pagar avui",
  "pricing_table.total_excluding_tax": "Total sense impostos",
  "pricing_table.enter_billing_address_to_calculate": "Introduïu l'adreça de facturació per calcular",
  "pricing_table.enter_state_or_postal_code_to_calculate": "Introduïu la província o el codi postal per calcular",
  "pricing_table.enter_postal_code_to_calculate": "Introduïu el codi postal per calcular",
  "error_page.error_message_invalid_email_error": "No s'ha pogut verificar l'adreça de correu electrònic {{email}}. Si us plau, proporcioneu una adreça de correu electrònic vàlida.",
  "payment_entry_page.button_payment_method": "Paga {{formattedPrice}} amb {{paymentMethod}}",
  "payment_entry_page.button_with_price": "Paga {{formattedPrice}}",
  "price_update.title": "Actualització de preu",
  "price_update.base_message": "El preu total s'ha actualitzat amb els impostos segons la vostra adreça de facturació. Reviseu-ho i torneu-ho a provar. Només es carregarà la vostra targeta una vegada.",
  "price_update.trial_message": "El preu de la subscripció s'ha actualitzat per incloure els impostos segons la seva adreça de facturació. El període de prova gratuït segueix vigent. Si us plau, comprovi-ho i torni-ho a provar.",
  "payment_entry_page.express_checkout_divider": "O PAGUEU AMB TARGETA",
  "error_page.trouble_accessing": "Si teniu problemes per accedir a la vostra compra, poseu-vos en contacte amb el servei d'assistència a ",
  "error_page.close_button_title": "Vés a {{appName}}",
  "error_page.error_title_stripe_missing_required_permission": "Falta el permís de Stripe",
  "error_page.button_close": "Tanca",
  "error_page.error_message_stripe_invalid_tax_origin_address": "La compra ha fallat perquè l'adreça d'origen fiscal no és vàlida. En producció, les compres funcionaran sense impostos aplicats.",
  "error_page.error_message_stripe_tax_not_active": "La compra ha fallat perquè Stripe Tax no està activat. En producció, les compres funcionaran sense impostos aplicats.",
  "error_page.error_only_in_sandbox": "Aquest missatge apareix només a l'entorn de proves.",
  "error_page.error_message_stripe_missing_required_permission": "La compra ha fallat perquè l'aplicació Stripe no té un permís necessari. En producció, les compres funcionaran sense impostos aplicats.",
  "error_page.error_title_stripe_tax_not_active": "Stripe Tax no està actiu",
  "error_page.error_title_stripe_invalid_tax_origin_address": "Adreça d'origen fiscal no vàlida",
  "apple_pay.free_trial": "Prova gratuïta",
  "product_info.price_after_intro_price": "Després de {{introPriceDuration}}, el {{renewalDate}}",
  "product_info.after_trial": "després del període de prova",
  "product_info.after": "després de",
  "product_info.intro_price_phase_after_trial": "Després {{introPriceDuration}} per {{introPrice}}",
  "product_info.intro_price_phase": "Primer {{introPriceDuration}} per {{introPrice}}",
  "product_info.intro_price_phase_paid_once": "pagat un cop",
  "payment_entry_page.trial_subscription_terms_info": "Un cop finalitzat el període de prova, se us cobrarà {{price}} {{perFrequency}} a partir del {{renewalDate}}. Podeu cancel·lar-ho en qualsevol moment abans d'aquesta data.",
  "payment_entry_page.subscription_info": "La subscripció es renova automàticament. Cancel·leu-la quan vulgueu.",
  "payment_entry_page.otp_terms_info": "En comprar, accepteu que {{appName}} us cobri d'acord amb les seves condicions.",
  "payment_entry_page.terms_link_label": "Condicions",
  "payment_entry_page.subscription_terms_info": "En subscriure-us, accepteu que {{appName}} us cobri d'acord amb les seves condicions fins que ho cancel·leu.",
  "loading_page.keep_page_open": "El procés està gairebé acabat. Mantingueu aquesta pàgina oberta.",
  "loading_page.processing_payment": "S'està processant el pagament",
  "pricing_table.discount": "Descompte",
  "pricing_table.subtotal": "Subtotal"
}, ug = {
  "periods.week": "{{amount}} 周",
  "periods.month": "{{amount}} 月",
  "periods.year": "{{amount}} 年",
  "periods.day": "{{amount}} 天",
  "periods.weekShort": "{{amount}}周",
  "periods.monthShort": "{{amount}}月",
  "periods.yearShort": "{{amount}}年",
  "periods.dayShort": "{{amount}}天",
  "periods.lifetime": "终身",
  "periods.weekPlural": "{{amount}} 周",
  "periods.monthPlural": "{{amount}} 个月",
  "periods.yearPlural": "{{amount}} 年",
  "periods.dayPlural": "{{amount}} 天",
  "periods.weekFrequency": "每周",
  "periods.monthFrequency": "每月",
  "periods.yearFrequency": "每年",
  "periods.dayFrequency": "每天",
  "periods.perWeekFrequency": "每周",
  "periods.perMonthFrequency": "每月",
  "periods.perYearFrequency": "每年",
  "periods.perDayFrequency": "每天",
  "periods.unknownFrequency": "未知",
  "periods.weekFrequencyPlural": "每 {{amount}} 周",
  "periods.monthFrequencyPlural": "每 {{amount}} 个月",
  "periods.yearFrequencyPlural": "每 {{amount}} 年",
  "periods.dayFrequencyPlural": "每 {{amount}} 天",
  "product_info.product_title": "{{productTitle}}",
  "product_info.product_description": "{{productDescription}}",
  "product_info.product_price": "{{productPrice}}",
  "product_info.free_trial_duration": "{{trialDuration}} 天免费试用",
  "product_info.price_after_free_trial": "试用期结束后，于 {{renewalDate}}",
  "product_info.renewal_frequency": "续订 {{frequency}}",
  "product_info.continues_until_cancelled": "持续到取消",
  "product_info.cancel_anytime": "随时取消",
  "payment_entry_page.payment_step_title": "RevenueCat 安全结账",
  "payment_entry_page.button_pay": "立即支付",
  "payment_entry_page.button_start_trial": "开始试用",
  "success_page.purchase_successful": "支付完成",
  "success_page.button_close": "继续",
  "error_page.if_error_persists": "如果错误仍然存在，请联系 ",
  "error_page.error_title_already_subscribed": "您已订阅 {{productTitle}}",
  "error_page.error_title_already_purchased": "您已购买 {{productTitle}}",
  "error_page.error_title_other_errors": "出现错误",
  "error_page.error_message_already_subscribed": "您不能再次订阅此产品。",
  "error_page.error_message_already_purchased": "您不能再次购买此产品。",
  "error_page.error_message_missing_email_error": "完成购买需要邮箱地址。",
  "error_page.error_message_network_error": "网络错误。请检查您的互联网连接。",
  "error_page.error_message_error_charging_payment": "支付失败。",
  "error_page.error_message_error_setting_up_purchase": "由于错误，购买未启动（错误代码：{{errorCode}}）。",
  "error_page.error_message_invalid_tax_location": "我们无法验证您的账单地址。请仔细检查邮政编码和国家是否正确。",
  "error_page.error_message_unknown_error": "发生未知错误（错误代码：{{errorCode}}）。",
  "error_page.button_try_again": "重试",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}%",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "product_info.total_due_today": "今天应付总额",
  "product_info.subscribe_to": "订阅",
  "navbar_header.details": "详情",
  "navbar_header.back_button": "返回",
  "pricing_dropdown.show_details": "显示详情",
  "pricing_dropdown.hide_details": "隐藏详情",
  "pricing_table.tax": "税",
  "pricing_table.trial_ends": "试用期结束后，于{{formattedTrialEndDate}}",
  "pricing_table.total_due_today": "今日应付总额",
  "pricing_table.total_excluding_tax": "总计（不含税）",
  "pricing_table.enter_billing_address_to_calculate": "输入账单地址以计算",
  "pricing_table.enter_state_or_postal_code_to_calculate": "输入州或邮政编码以计算",
  "pricing_table.enter_postal_code_to_calculate": "输入邮政编码以计算",
  "error_page.error_message_invalid_email_error": "无法验证电子邮件地址{{email}}。请提供有效的电子邮件地址。",
  "payment_entry_page.button_payment_method": "使用{{paymentMethod}}支付{{formattedPrice}}",
  "payment_entry_page.button_with_price": "支付{{formattedPrice}}",
  "price_update.title": "价格更新",
  "price_update.base_message": "总价已根据您的账单地址更新了税费。请查看并重试。您的银行卡只会扣款一次。",
  "price_update.trial_message": "根据您的账单地址，订阅价格已更新为含税价格。免费试用仍然有效。请查看并重试。",
  "payment_entry_page.express_checkout_divider": "或使用银行卡支付",
  "error_page.trouble_accessing": "如果您在访问购买项目时遇到问题，请通过以下方式联系支持：",
  "error_page.close_button_title": "前往{{appName}}",
  "error_page.error_title_stripe_missing_required_permission": "缺少Stripe权限",
  "error_page.button_close": "关闭",
  "error_page.error_message_stripe_invalid_tax_origin_address": "购买失败，因为税务起始地址无效。在生产环境中，购买将在不应用税款的情况下进行。",
  "error_page.error_message_stripe_tax_not_active": "购买失败，因为Stripe Tax未启用。在生产环境中，购买将在不应用税款的情况下进行。",
  "error_page.error_only_in_sandbox": "此消息仅在沙盒中显示。",
  "error_page.error_message_stripe_missing_required_permission": "购买失败，因为Stripe应用程序缺少必需的权限。在生产环境中，购买将在不应用税款的情况下进行。",
  "error_page.error_title_stripe_tax_not_active": "Stripe Tax未激活",
  "error_page.error_title_stripe_invalid_tax_origin_address": "税务起始地址无效",
  "apple_pay.free_trial": "免费试用",
  "product_info.price_after_intro_price": "在{{introPriceDuration}}之后，于{{renewalDate}}开始",
  "product_info.after_trial": "试用后",
  "product_info.after": "之后",
  "product_info.intro_price_phase_after_trial": "然后{{introPriceDuration}}，价格为{{introPrice}}",
  "product_info.intro_price_phase": "首先{{introPriceDuration}}，价格为{{introPrice}}",
  "product_info.intro_price_phase_paid_once": "一次性支付",
  "payment_entry_page.trial_subscription_terms_info": "试用期结束后，您将被收取 {{price}} {{perFrequency}}，从 {{renewalDate}} 开始。您可以在此日期之前的任何时间取消。",
  "payment_entry_page.subscription_info": "订阅自动续订。随时取消。",
  "payment_entry_page.otp_terms_info": "购买即表示您同意允许{{appName}}根据其条款向您收费。",
  "payment_entry_page.terms_link_label": "条款",
  "payment_entry_page.subscription_terms_info": "订阅即表示您同意允许 {{appName}} 按照其条款向您收费，直到您取消订阅。",
  "loading_page.keep_page_open": "流程即将完成。请保持此页面打开。",
  "loading_page.processing_payment": "正在处理付款",
  "pricing_table.discount": "折扣",
  "pricing_table.subtotal": "小计"
}, dg = {
  "periods.week": "{{amount}} 週",
  "periods.month": "{{amount}} 個月",
  "periods.year": "{{amount}} 年",
  "periods.day": "{{amount}} 天",
  "periods.weekShort": "{{amount}}週",
  "periods.monthShort": "{{amount}}月",
  "periods.yearShort": "{{amount}}年",
  "periods.dayShort": "{{amount}}天",
  "periods.lifetime": "終身",
  "periods.weekPlural": "{{amount}} 週",
  "periods.monthPlural": "{{amount}} 個月",
  "periods.yearPlural": "{{amount}} 年",
  "periods.dayPlural": "{{amount}} 天",
  "periods.weekFrequency": "每週",
  "periods.monthFrequency": "每月",
  "periods.yearFrequency": "每年",
  "periods.dayFrequency": "每天",
  "periods.perWeekFrequency": "每週",
  "periods.perMonthFrequency": "每月",
  "periods.perYearFrequency": "每年",
  "periods.perDayFrequency": "每天",
  "periods.unknownFrequency": "未知",
  "periods.weekFrequencyPlural": "每 {{amount}} 週",
  "periods.monthFrequencyPlural": "每 {{amount}} 個月",
  "periods.yearFrequencyPlural": "每 {{amount}} 年",
  "periods.dayFrequencyPlural": "每 {{amount}} 天",
  "product_info.product_title": "{{productTitle}}",
  "product_info.product_description": "{{productDescription}}",
  "product_info.product_price": "{{productPrice}}",
  "product_info.free_trial_duration": "{{trialDuration}} 天免費試用",
  "product_info.price_after_free_trial": "試用期結束後，於 {{renewalDate}}",
  "product_info.renewal_frequency": "每 {{frequency}} 續約",
  "product_info.continues_until_cancelled": "持續到取消",
  "product_info.cancel_anytime": "隨時取消",
  "payment_entry_page.payment_step_title": "RevenueCat 安全結帳",
  "payment_entry_page.button_pay": "立即付款",
  "payment_entry_page.button_start_trial": "開始試用",
  "success_page.purchase_successful": "付款完成",
  "success_page.button_close": "繼續",
  "error_page.if_error_persists": "如果錯誤持續存在，請聯絡 ",
  "error_page.error_title_already_subscribed": "您已經訂閱 {{productTitle}}",
  "error_page.error_title_already_purchased": "您已經購買 {{productTitle}}",
  "error_page.error_title_other_errors": "發生錯誤",
  "error_page.error_message_already_subscribed": "您無法再次訂閱此產品。",
  "error_page.error_message_already_purchased": "您無法再次購買此產品。",
  "error_page.error_message_missing_email_error": "完成購買需要電子郵件地址。",
  "error_page.error_message_network_error": "網路錯誤。請檢查您的網路連線。",
  "error_page.error_message_error_charging_payment": "付款失敗。",
  "error_page.error_message_error_setting_up_purchase": "由於發生錯誤，購買未啟動（錯誤代碼：{{errorCode}}）。",
  "error_page.error_message_invalid_tax_location": "我們無法驗證您的帳單地址。請仔細檢查郵遞區號和國家是否正確。",
  "error_page.error_message_unknown_error": "發生不明錯誤（錯誤代碼：{{errorCode}}）。",
  "error_page.button_try_again": "再試一次",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}%",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}} ({{formattedPricePerMonth}}/{{monthPeriod}})",
  "product_info.total_due_today": "今日應付總額",
  "product_info.subscribe_to": "訂閱",
  "navbar_header.details": "詳細資訊",
  "navbar_header.back_button": "返回",
  "pricing_dropdown.show_details": "顯示詳細資訊",
  "pricing_dropdown.hide_details": "隱藏詳細資訊",
  "pricing_table.tax": "稅金",
  "pricing_table.trial_ends": "試用期結束後，於 {{formattedTrialEndDate}}",
  "pricing_table.total_due_today": "今日應付總額",
  "pricing_table.total_excluding_tax": "總計（不含稅）",
  "pricing_table.enter_billing_address_to_calculate": "輸入帳單地址以計算",
  "pricing_table.enter_state_or_postal_code_to_calculate": "輸入州或郵政編碼以計算",
  "pricing_table.enter_postal_code_to_calculate": "輸入郵政編碼以計算",
  "error_page.error_message_invalid_email_error": "無法驗證電子郵件地址 {{email}}。請提供有效的電子郵件地址。",
  "payment_entry_page.button_payment_method": "使用 {{paymentMethod}} 支付 {{formattedPrice}}",
  "payment_entry_page.button_with_price": "支付 {{formattedPrice}}",
  "price_update.title": "價格更新",
  "price_update.base_message": "總價已根據您的帳單地址更新稅金。請檢查後重試。您的信用卡只會被收取一次費用。",
  "price_update.trial_message": "根據您的帳單地址，訂閱價格已更新為含稅價格。免費試用仍然有效。請查看並重試。",
  "payment_entry_page.express_checkout_divider": "或以信用卡付款",
  "error_page.trouble_accessing": "如果您在存取購買項目時遇到問題，請透過以下方式聯絡支援人員：",
  "error_page.close_button_title": "前往{{appName}}",
  "error_page.error_title_stripe_missing_required_permission": "缺少 Stripe 權限",
  "error_page.button_close": "關閉",
  "error_page.error_message_stripe_invalid_tax_origin_address": "購買失敗，因為稅務起始地址無效。在正式環境中，購買將在不套用稅金的情況下運作。",
  "error_page.error_message_stripe_tax_not_active": "購買失敗，因為 Stripe Tax 未啟用。在正式環境中，購買將在不套用稅金的情況下運作。",
  "error_page.error_only_in_sandbox": "此訊息僅在沙盒中顯示。",
  "error_page.error_message_stripe_missing_required_permission": "購買失敗，因為 Stripe 應用程式缺少必要的權限。在正式環境中，購買將在不套用稅金的情況下運作。",
  "error_page.error_title_stripe_tax_not_active": "Stripe Tax 未啟用",
  "error_page.error_title_stripe_invalid_tax_origin_address": "無效的稅務起始地址",
  "apple_pay.free_trial": "免費試用",
  "product_info.price_after_intro_price": "在 {{introPriceDuration}} 之後，於 {{renewalDate}}",
  "product_info.after_trial": "試用期後",
  "product_info.after": "之後",
  "product_info.intro_price_phase_after_trial": "然後 {{introPriceDuration}}，價格為 {{introPrice}}",
  "product_info.intro_price_phase": "首先 {{introPriceDuration}}，價格為 {{introPrice}}",
  "product_info.intro_price_phase_paid_once": "一次性支付",
  "payment_entry_page.trial_subscription_terms_info": "在您的試用期結束後，您將被收取 {{price}} {{perFrequency}}，從 {{renewalDate}} 開始。您可以隨時在此日期之前取消。",
  "payment_entry_page.subscription_info": "訂閱會自動續訂。隨時取消。",
  "payment_entry_page.otp_terms_info": "購買即表示您同意授權 {{appName}} 根據其條款向您收費。",
  "payment_entry_page.terms_link_label": "條款",
  "payment_entry_page.subscription_terms_info": "訂閱即表示您同意允許 {{appName}} 根據其條款向您收費，直到您取消為止。",
  "loading_page.keep_page_open": "程序即將完成。請保持此頁面開啟。",
  "loading_page.processing_payment": "正在處理付款",
  "pricing_table.discount": "折扣",
  "pricing_table.subtotal": "小計"
}, pg = {
  "periods.week": "{{amount}} tjedan",
  "periods.month": "{{amount}} mjesec",
  "periods.year": "{{amount}} godina",
  "periods.day": "{{amount}} dan",
  "periods.weekShort": "{{amount}}tj",
  "periods.monthShort": "{{amount}}mj",
  "periods.yearShort": "{{amount}}g",
  "periods.dayShort": "{{amount}}d",
  "periods.lifetime": "doživotno",
  "periods.weekPlural": "{{amount}} tjedana",
  "periods.monthPlural": "{{amount}} mjeseci",
  "periods.yearPlural": "{{amount}} godina",
  "periods.dayPlural": "{{amount}} dana",
  "periods.weekFrequency": "tjedno",
  "periods.monthFrequency": "mjesečno",
  "periods.yearFrequency": "godišnje",
  "periods.dayFrequency": "dnevno",
  "periods.perWeekFrequency": "tjedno",
  "periods.perMonthFrequency": "mjesečno",
  "periods.perYearFrequency": "godišnje",
  "periods.perDayFrequency": "dnevno",
  "periods.unknownFrequency": "nepoznato",
  "periods.weekFrequencyPlural": "svakih {{amount}} tjedana",
  "periods.monthFrequencyPlural": "svakih {{amount}} mjeseci",
  "periods.yearFrequencyPlural": "svakih {{amount}} godina",
  "periods.dayFrequencyPlural": "svakih {{amount}} dana",
  "product_info.product_title": "{{productTitle}}",
  "product_info.product_description": "{{productDescription}}",
  "product_info.product_price": "{{productPrice}}",
  "product_info.free_trial_duration": "{{trialDuration}} besplatno probno razdoblje",
  "product_info.price_after_free_trial": "Nakon isteka probnog razdoblja, {{renewalDate}}",
  "product_info.renewal_frequency": "Obnavlja se {{frequency}}",
  "product_info.continues_until_cancelled": "Nastavlja se dok se ne otkaže",
  "product_info.cancel_anytime": "Otkažite u bilo kojem trenutku",
  "payment_entry_page.payment_step_title": "Sigurna naplata putem RevenueCat",
  "payment_entry_page.button_pay": "Plati sada",
  "payment_entry_page.button_start_trial": "Počni probno razdoblje",
  "success_page.purchase_successful": "Uplata je uspješna",
  "success_page.button_close": "Nastavi",
  "error_page.if_error_persists": "Ako se pogreška nastavi, obratite se ",
  "error_page.error_title_already_subscribed": "Već ste pretplaćeni na {{productTitle}}",
  "error_page.error_title_already_purchased": "Već ste kupili {{productTitle}}",
  "error_page.error_title_other_errors": "Nešto je pošlo po zlu",
  "error_page.error_message_already_subscribed": "Ne možete se ponovno pretplatiti na ovaj proizvod.",
  "error_page.error_message_already_purchased": "Ne možete ponovno kupiti ovaj proizvod.",
  "error_page.error_message_missing_email_error": "E-pošta je potrebna za dovršetak kupnje.",
  "error_page.error_message_network_error": "Mrežna pogreška. Provjerite internetsku vezu.",
  "error_page.error_message_error_charging_payment": "Plaćanje nije uspjelo.",
  "error_page.error_message_error_setting_up_purchase": "Kupnja nije započela zbog pogreške (kod pogreške: {{errorCode}}).",
  "error_page.error_message_invalid_tax_location": "Nismo mogli potvrditi vašu adresu za naplatu. Molimo provjerite poštanski broj i državu kako biste bili sigurni da su točni.",
  "error_page.error_message_unknown_error": "Došlo je do nepoznate pogreške (kod pogreške: {{errorCode}}).",
  "error_page.button_try_again": "Pokušaj ponovno",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}%",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "product_info.total_due_today": "Ukupno dospijeće danas",
  "product_info.subscribe_to": "Pretplatite se",
  "navbar_header.details": "Detalji",
  "navbar_header.back_button": "Natrag",
  "pricing_dropdown.show_details": "Prikaži detalje",
  "pricing_dropdown.hide_details": "Sakrij detalje",
  "pricing_table.tax": "Porez",
  "pricing_table.trial_ends": "Nakon isteka probnog razdoblja, {{formattedTrialEndDate}}",
  "pricing_table.total_due_today": "Ukupan iznos dospijeća danas",
  "pricing_table.total_excluding_tax": "Ukupno bez poreza",
  "pricing_table.enter_billing_address_to_calculate": "Unesite adresu za naplatu za izračun",
  "pricing_table.enter_state_or_postal_code_to_calculate": "Unesite državu ili poštanski broj za izračun",
  "pricing_table.enter_postal_code_to_calculate": "Unesite poštanski broj za izračun",
  "error_page.error_message_invalid_email_error": "Adresa e-pošte {{email}} nije se mogla potvrditi. Molimo unesite valjanu adresu e-pošte.",
  "payment_entry_page.button_payment_method": "Plati {{formattedPrice}} putem {{paymentMethod}}",
  "payment_entry_page.button_with_price": "Plati {{formattedPrice}}",
  "price_update.title": "Ažuriranje cijene",
  "price_update.base_message": "Ukupna cijena je ažurirana s porezom na temelju vaše adrese za naplatu. Pregledajte i pokušajte ponovo. Vaša kartica bit će naplaćena samo jednom.",
  "price_update.trial_message": "Cijena pretplate je ažurirana da uključi poreze na temelju vaše adrese za naplatu. Besplatno probno razdoblje i dalje vrijedi. Molimo provjerite i pokušajte ponovno.",
  "payment_entry_page.express_checkout_divider": "ILI PLATITE KARTICOM",
  "error_page.trouble_accessing": "Ako imate problema s pristupom kupnji, obratite se podršci na ",
  "error_page.close_button_title": "Idi na {{appName}}",
  "error_page.error_title_stripe_missing_required_permission": "Nedostaje Stripe dopuštenje",
  "error_page.button_close": "Zatvori",
  "error_page.error_message_stripe_invalid_tax_origin_address": "Kupnja nije uspjela jer je adresa poreznog podrijetla nevažeća. U produkciji će kupnje funkcionirati bez primijenjenih poreza.",
  "error_page.error_message_stripe_tax_not_active": "Kupnja nije uspjela jer Stripe Tax nije omogućen. U produkciji će kupnje funkcionirati bez primijenjenih poreza.",
  "error_page.error_only_in_sandbox": "Ova se poruka pojavljuje samo u sandboxu.",
  "error_page.error_message_stripe_missing_required_permission": "Kupnja nije uspjela jer Stripe aplikaciji nedostaje potrebno dopuštenje. U produkciji će kupnje funkcionirati bez primijenjenih poreza.",
  "error_page.error_title_stripe_tax_not_active": "Stripe Tax nije aktivan",
  "error_page.error_title_stripe_invalid_tax_origin_address": "Nevažeća adresa poreznog podrijetla",
  "apple_pay.free_trial": "Besplatna proba",
  "product_info.price_after_intro_price": "Nakon {{introPriceDuration}}, na {{renewalDate}}",
  "product_info.after_trial": "nakon probnog perioda",
  "product_info.after": "nakon",
  "product_info.intro_price_phase_after_trial": "Zatim {{introPriceDuration}} za {{introPrice}}",
  "product_info.intro_price_phase": "Prvo {{introPriceDuration}} za {{introPrice}}",
  "product_info.intro_price_phase_paid_once": "plaća se jednokratno",
  "payment_entry_page.trial_subscription_terms_info": "Nakon isteka probnog razdoblja, bit će vam naplaćeno {{price}} {{perFrequency}} počevši od {{renewalDate}}. Možete otkazati bilo kada prije tog datuma.",
  "payment_entry_page.subscription_info": "Pretplata se automatski obnavlja. Otkažite bilo kada.",
  "payment_entry_page.otp_terms_info": "Kupnjom pristajete dopustiti aplikaciji {{appName}} da vam naplati u skladu s njihovim uvjetima.",
  "payment_entry_page.terms_link_label": "Uvjeti",
  "payment_entry_page.subscription_terms_info": "Pretplatom se slažete da ćete dopustiti {{appName}} da vam naplaćuje u skladu s njihovim uvjetima dok ne otkažete.",
  "loading_page.keep_page_open": "Proces je skoro gotov. Ostavite ovu stranicu otvorenom.",
  "loading_page.processing_payment": "Obrada uplate",
  "pricing_table.discount": "Popust",
  "pricing_table.subtotal": "Međuzbroj"
}, _g = {
  "periods.week": "{{amount}} týden",
  "periods.month": "{{amount}} měsíc",
  "periods.year": "{{amount}} rok",
  "periods.day": "{{amount}} den",
  "periods.weekShort": "{{amount}}týd",
  "periods.monthShort": "{{amount}}měs",
  "periods.yearShort": "{{amount}}rok",
  "periods.dayShort": "{{amount}}d",
  "periods.lifetime": "doživotně",
  "periods.weekPlural": "{{amount}} týdnů",
  "periods.monthPlural": "{{amount}} měsíců",
  "periods.yearPlural": "{{amount}} let",
  "periods.dayPlural": "{{amount}} dnů",
  "periods.weekFrequency": "týdně",
  "periods.monthFrequency": "měsíčně",
  "periods.yearFrequency": "ročně",
  "periods.dayFrequency": "denně",
  "periods.perWeekFrequency": "týdně",
  "periods.perMonthFrequency": "měsíčně",
  "periods.perYearFrequency": "ročně",
  "periods.perDayFrequency": "denně",
  "periods.unknownFrequency": "neznámé",
  "periods.weekFrequencyPlural": "každých {{amount}} týdnů",
  "periods.monthFrequencyPlural": "každých {{amount}} měsíců",
  "periods.yearFrequencyPlural": "každých {{amount}} let",
  "periods.dayFrequencyPlural": "každých {{amount}} dnů",
  "product_info.product_title": "{{productTitle}}",
  "product_info.product_description": "{{productDescription}}",
  "product_info.product_price": "{{productPrice}}",
  "product_info.free_trial_duration": "{{trialDuration}} zkušební verze zdarma",
  "product_info.price_after_free_trial": "Po skončení zkušební verze, {{renewalDate}}",
  "product_info.renewal_frequency": "Obnovuje se {{frequency}}",
  "product_info.continues_until_cancelled": "Pokračuje, dokud není zrušeno",
  "product_info.cancel_anytime": "Zrušit kdykoli",
  "payment_entry_page.payment_step_title": "Bezpečné placení přes RevenueCat",
  "payment_entry_page.button_pay": "Platit nyní",
  "payment_entry_page.button_start_trial": "Spustit zkušební verzi",
  "success_page.purchase_successful": "Platba dokončena",
  "success_page.button_close": "Pokračovat",
  "error_page.if_error_persists": "Pokud chyba přetrvává, kontaktujte ",
  "error_page.error_title_already_subscribed": "Již máte předplatné pro {{productTitle}}",
  "error_page.error_title_already_purchased": "Již jste zakoupili {{productTitle}}",
  "error_page.error_title_other_errors": "Něco se pokazilo",
  "error_page.error_message_already_subscribed": "Nemůžete si znovu předplatit tento produkt.",
  "error_page.error_message_already_purchased": "Tento produkt si nemůžete znovu zakoupit.",
  "error_page.error_message_missing_email_error": "Pro dokončení nákupu je vyžadován e-mail.",
  "error_page.error_message_network_error": "Síťová chyba. Zkontrolujte prosím své internetové připojení.",
  "error_page.error_message_error_charging_payment": "Platba selhala.",
  "error_page.error_message_error_setting_up_purchase": "Nákup nebyl zahájen z důvodu chyby (kód chyby: {{errorCode}}).",
  "error_page.error_message_invalid_tax_location": "Nemohli jsme ověřit vaši fakturační adresu. Zkontrolujte prosím, zda je poštovní směrovací číslo a země správné.",
  "error_page.error_message_unknown_error": "Došlo k neznámé chybě (kód chyby: {{errorCode}}).",
  "error_page.button_try_again": "Zkusit znovu",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}%",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "product_info.total_due_today": "Celkem dnes k zaplacení",
  "product_info.subscribe_to": "Předplatit",
  "navbar_header.details": "Podrobnosti",
  "navbar_header.back_button": "Zpět",
  "pricing_dropdown.show_details": "Zobrazit podrobnosti",
  "pricing_dropdown.hide_details": "Skrýt podrobnosti",
  "pricing_table.tax": "Daň",
  "pricing_table.trial_ends": "Po skončení zkušební doby, dne {{formattedTrialEndDate}}",
  "pricing_table.total_due_today": "Celkem splatné dnes",
  "pricing_table.total_excluding_tax": "Celkem bez daně",
  "pricing_table.enter_billing_address_to_calculate": "Zadejte fakturační adresu pro výpočet",
  "pricing_table.enter_state_or_postal_code_to_calculate": "Zadejte stát nebo PSČ pro výpočet",
  "pricing_table.enter_postal_code_to_calculate": "Zadejte PSČ pro výpočet",
  "error_page.error_message_invalid_email_error": "E-mailová adresa {{email}} nemohla být ověřena. Zadejte prosím platnou e-mailovou adresu.",
  "payment_entry_page.button_payment_method": "Zaplatit {{formattedPrice}} pomocí {{paymentMethod}}",
  "payment_entry_page.button_with_price": "Zaplatit {{formattedPrice}}",
  "price_update.title": "Aktualizace ceny",
  "price_update.base_message": "Celková cena byla aktualizována o daň na základě vaší fakturační adresy. Zkontrolujte ji a zkuste to znovu. Vaše karta bude stržena pouze jednou.",
  "price_update.trial_message": "Cena předplatného byla aktualizována včetně daní na základě vaší fakturační adresy. Bezplatná zkušební doba stále platí. Prosím, zkontrolujte a zkuste to znovu.",
  "payment_entry_page.express_checkout_divider": "NEBO ZAPLATIT KARTOU",
  "error_page.trouble_accessing": "Pokud máte potíže s přístupem k zakoupenému obsahu, kontaktujte podporu na ",
  "error_page.close_button_title": "Přejít na {{appName}}",
  "error_page.error_title_stripe_missing_required_permission": "Chybí oprávnění Stripe",
  "error_page.button_close": "Zavřít",
  "error_page.error_message_stripe_invalid_tax_origin_address": "Nákup se nezdařil, protože adresa původu daně je neplatná. V produkčním prostředí budou nákupy fungovat bez uplatnění daní.",
  "error_page.error_message_stripe_tax_not_active": "Nákup se nezdařil, protože Stripe Tax není aktivní. V produkčním prostředí budou nákupy fungovat bez uplatnění daní.",
  "error_page.error_only_in_sandbox": "Tato zpráva se zobrazuje pouze v sandboxu.",
  "error_page.error_message_stripe_missing_required_permission": "Nákup se nezdařil, protože aplikaci Stripe chybí požadované oprávnění. V produkčním prostředí budou nákupy fungovat bez uplatnění daní.",
  "error_page.error_title_stripe_tax_not_active": "Stripe Tax není aktivní",
  "error_page.error_title_stripe_invalid_tax_origin_address": "Neplatná adresa původu daně",
  "apple_pay.free_trial": "Zkušební verze zdarma",
  "product_info.price_after_intro_price": "Po {{introPriceDuration}}, dne {{renewalDate}}",
  "product_info.after_trial": "po zkušební době",
  "product_info.after": "po",
  "product_info.intro_price_phase_after_trial": "Poté {{introPriceDuration}} za {{introPrice}}",
  "product_info.intro_price_phase": "Nejprve {{introPriceDuration}} za {{introPrice}}",
  "product_info.intro_price_phase_paid_once": "placeno jednorázově",
  "payment_entry_page.trial_subscription_terms_info": "Po skončení zkušebního období vám bude účtováno {{price}} {{perFrequency}} počínaje {{renewalDate}}. Před tímto datem můžete kdykoli zrušit.",
  "payment_entry_page.subscription_info": "Předplatné se automaticky obnovuje. Zrušit můžete kdykoli.",
  "payment_entry_page.otp_terms_info": "Zakoupením souhlasíte s tím, že umožníte aplikaci {{appName}} účtovat vám poplatky v souladu s jejími podmínkami.",
  "payment_entry_page.terms_link_label": "Podmínky",
  "payment_entry_page.subscription_terms_info": "Přihlášením k odběru souhlasíte s tím, že společnost {{appName}} vám bude účtovat poplatky v souladu s jejími podmínkami, dokud odběr nezrušíte.",
  "loading_page.keep_page_open": "Probíhá dokončování procesu. Nechte tuto stránku otevřenou.",
  "loading_page.processing_payment": "Probíhá zpracování platby",
  "pricing_table.discount": "Sleva",
  "pricing_table.subtotal": "Mezisoučet"
}, gg = {
  "periods.week": "{{amount}} uge",
  "periods.month": "{{amount}} måned",
  "periods.year": "{{amount}} år",
  "periods.day": "{{amount}} dag",
  "periods.weekShort": "{{amount}}ug",
  "periods.monthShort": "{{amount}}md",
  "periods.yearShort": "{{amount}}år",
  "periods.dayShort": "{{amount}}d",
  "periods.lifetime": "livstid",
  "periods.weekPlural": "{{amount}} uger",
  "periods.monthPlural": "{{amount}} måneder",
  "periods.yearPlural": "{{amount}} år",
  "periods.dayPlural": "{{amount}} dage",
  "periods.weekFrequency": "ugentligt",
  "periods.monthFrequency": "månedligt",
  "periods.yearFrequency": "årligt",
  "periods.dayFrequency": "dagligt",
  "periods.perWeekFrequency": "pr. uge",
  "periods.perMonthFrequency": "pr. måned",
  "periods.perYearFrequency": "pr. år",
  "periods.perDayFrequency": "pr. dag",
  "periods.unknownFrequency": "ukendt",
  "periods.weekFrequencyPlural": "hver {{amount}} uger",
  "periods.monthFrequencyPlural": "hver {{amount}} måneder",
  "periods.yearFrequencyPlural": "hver {{amount}} år",
  "periods.dayFrequencyPlural": "hver {{amount}} dage",
  "product_info.product_title": "{{productTitle}}",
  "product_info.product_description": "{{productDescription}}",
  "product_info.product_price": "{{productPrice}}",
  "product_info.free_trial_duration": "{{trialDuration}} gratis prøveperiode",
  "product_info.price_after_free_trial": "Efter prøveperioden slutter, den {{renewalDate}}",
  "product_info.renewal_frequency": "Fornyes {{frequency}}",
  "product_info.continues_until_cancelled": "Fortsætter indtil annulleret",
  "product_info.cancel_anytime": "Annuller når som helst",
  "payment_entry_page.payment_step_title": "Sikker betaling via RevenueCat",
  "payment_entry_page.button_pay": "Betal nu",
  "payment_entry_page.button_start_trial": "Start prøveperiode",
  "success_page.purchase_successful": "Betaling gennemført",
  "success_page.button_close": "Fortsæt",
  "error_page.if_error_persists": "Hvis fejlen fortsætter, kontakt venligst ",
  "error_page.error_title_already_subscribed": "Du abonnerer allerede på {{productTitle}}",
  "error_page.error_title_already_purchased": "Du har allerede købt {{productTitle}}",
  "error_page.error_title_other_errors": "Noget gik galt",
  "error_page.error_message_already_subscribed": "Du kan ikke abonnere på dette produkt igen.",
  "error_page.error_message_already_purchased": "Du kan ikke købe dette produkt igen.",
  "error_page.error_message_missing_email_error": "Email er påkrævet for at gennemføre købet.",
  "error_page.error_message_network_error": "Netværksfejl. Kontroller din internetforbindelse.",
  "error_page.error_message_error_charging_payment": "Betalingen mislykkedes.",
  "error_page.error_message_error_setting_up_purchase": "Køb ikke startet på grund af en fejl (fejlkode: {{errorCode}}).",
  "error_page.error_message_invalid_tax_location": "Vi kunne ikke bekræfte din faktureringsadresse. Kontroller venligst, at postnummeret og landet er korrekte.",
  "error_page.error_message_unknown_error": "Der opstod en ukendt fejl (fejlkode: {{errorCode}}).",
  "error_page.button_try_again": "Prøv igen",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}%",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "product_info.total_due_today": "Samlet beløb for i dag",
  "product_info.subscribe_to": "Abonner på",
  "navbar_header.details": "Detaljer",
  "navbar_header.back_button": "Tilbage",
  "pricing_dropdown.show_details": "Vis detaljer",
  "pricing_dropdown.hide_details": "Skjul detaljer",
  "pricing_table.tax": "Moms",
  "pricing_table.trial_ends": "Efter prøveperioden slutter, den {{formattedTrialEndDate}}",
  "pricing_table.total_due_today": "Samlet beløb forfalden i dag",
  "pricing_table.total_excluding_tax": "Samlet beløb eksklusive moms",
  "pricing_table.enter_billing_address_to_calculate": "Indtast faktureringsadresse for at beregne",
  "pricing_table.enter_state_or_postal_code_to_calculate": "Indtast stat eller postnummer for at beregne",
  "pricing_table.enter_postal_code_to_calculate": "Indtast postnummer for at beregne",
  "error_page.error_message_invalid_email_error": "E-mailadressen {{email}} kunne ikke bekræftes. Angiv en gyldig e-mailadresse.",
  "payment_entry_page.button_payment_method": "Betal {{formattedPrice}} med {{paymentMethod}}",
  "payment_entry_page.button_with_price": "Betal {{formattedPrice}}",
  "price_update.title": "Prisopdatering",
  "price_update.base_message": "Den samlede pris er blevet opdateret med moms baseret på din faktureringsadresse. Gennemgå og prøv igen. Dit kort vil kun blive debiteret én gang.",
  "price_update.trial_message": "Abonnementsprisen er opdateret for at inkludere skatter baseret på din faktureringsadresse. Den gratis prøveperiode gælder stadig. Kontroller venligst og prøv igen.",
  "payment_entry_page.express_checkout_divider": "ELLER BETAL MED KORT",
  "error_page.trouble_accessing": "Hvis du har problemer med at få adgang til dit køb, kan du kontakte support på ",
  "error_page.close_button_title": "Gå til {{appName}}",
  "error_page.error_title_stripe_missing_required_permission": "Manglende Stripe-tilladelse",
  "error_page.button_close": "Luk",
  "error_page.error_message_stripe_invalid_tax_origin_address": "Købet mislykkedes, fordi skatteoprindelsesadressen er ugyldig. I produktion vil køb fungere uden påførte skatter.",
  "error_page.error_message_stripe_tax_not_active": "Købet mislykkedes, fordi Stripe Tax ikke er aktiveret. I produktion vil køb fungere uden påførte skatter.",
  "error_page.error_only_in_sandbox": "Denne meddelelse vises kun i sandkassen.",
  "error_page.error_message_stripe_missing_required_permission": "Købet mislykkedes, fordi Stripe-appen mangler en påkrævet tilladelse. I produktion vil køb fungere uden påførte skatter.",
  "error_page.error_title_stripe_tax_not_active": "Stripe Tax er ikke aktiv",
  "error_page.error_title_stripe_invalid_tax_origin_address": "Ugyldig skatteoprindelsesadresse",
  "apple_pay.free_trial": "Gratis prøveperiode",
  "product_info.price_after_intro_price": "Efter {{introPriceDuration}}, den {{renewalDate}}",
  "product_info.after_trial": "efter prøveperiode",
  "product_info.after": "efter",
  "product_info.intro_price_phase_after_trial": "Derefter {{introPriceDuration}} for {{introPrice}}",
  "product_info.intro_price_phase": "Først {{introPriceDuration}} for {{introPrice}}",
  "product_info.intro_price_phase_paid_once": "betales én gang",
  "payment_entry_page.trial_subscription_terms_info": "Efter din prøveperiode slutter, vil du blive opkrævet {{price}} {{perFrequency}} fra og med {{renewalDate}}. Du kan opsige når som helst før denne dato.",
  "payment_entry_page.subscription_info": "Abonnementet fornys automatisk. Opsig når som helst.",
  "payment_entry_page.otp_terms_info": "Ved at købe accepterer du, at {{appName}} kan debitere dig i overensstemmelse med deres vilkår.",
  "payment_entry_page.terms_link_label": "Vilkår",
  "payment_entry_page.subscription_terms_info": "Ved at abonnere accepterer du, at {{appName}} kan opkræve dig i henhold til deres vilkår, indtil du opsiger.",
  "loading_page.keep_page_open": "Processen er næsten færdig. Hold denne side åben.",
  "loading_page.processing_payment": "Behandler betaling",
  "pricing_table.discount": "Rabat",
  "pricing_table.subtotal": "Subtotal"
}, fg = {
  "periods.week": "{{amount}} week",
  "periods.month": "{{amount}} maand",
  "periods.year": "{{amount}} jaar",
  "periods.day": "{{amount}} dag",
  "periods.weekShort": "{{amount}}wk",
  "periods.monthShort": "{{amount}}maand",
  "periods.yearShort": "{{amount}}jr",
  "periods.dayShort": "{{amount}}d",
  "periods.lifetime": "levenslang",
  "periods.weekPlural": "{{amount}} weken",
  "periods.monthPlural": "{{amount}} maanden",
  "periods.yearPlural": "{{amount}} jaren",
  "periods.dayPlural": "{{amount}} dagen",
  "periods.weekFrequency": "wekelijks",
  "periods.monthFrequency": "maandelijks",
  "periods.yearFrequency": "jaarlijks",
  "periods.dayFrequency": "dagelijks",
  "periods.perWeekFrequency": "per week",
  "periods.perMonthFrequency": "per maand",
  "periods.perYearFrequency": "per jaar",
  "periods.perDayFrequency": "per dag",
  "periods.unknownFrequency": "onbekend",
  "periods.weekFrequencyPlural": "elke {{amount}} weken",
  "periods.monthFrequencyPlural": "elke {{amount}} maanden",
  "periods.yearFrequencyPlural": "elke {{amount}} jaren",
  "periods.dayFrequencyPlural": "elke {{amount}} dagen",
  "product_info.product_title": "{{productTitle}}",
  "product_info.product_description": "{{productDescription}}",
  "product_info.product_price": "{{productPrice}}",
  "product_info.free_trial_duration": "{{trialDuration}} gratis proefperiode",
  "product_info.price_after_free_trial": "Na afloop van de proefperiode, op {{renewalDate}}",
  "product_info.renewal_frequency": "Wordt verlengd {{frequency}}",
  "product_info.continues_until_cancelled": "Wordt voortgezet tot annulering",
  "product_info.cancel_anytime": "Annuleer op elk gewenst moment",
  "payment_entry_page.payment_step_title": "Veilige afrekening via RevenueCat",
  "payment_entry_page.button_pay": "Nu betalen",
  "payment_entry_page.button_start_trial": "Start proefperiode",
  "success_page.purchase_successful": "Betaling voltooid",
  "success_page.button_close": "Doorgaan",
  "error_page.if_error_persists": "Neem contact op met  als de fout aanhoudt",
  "error_page.error_title_already_subscribed": "Je bent al geabonneerd op {{productTitle}}",
  "error_page.error_title_already_purchased": "Je hebt {{productTitle}} al gekocht",
  "error_page.error_title_other_errors": "Er is iets misgegaan",
  "error_page.error_message_already_subscribed": "Je kunt je niet opnieuw abonneren op dit product.",
  "error_page.error_message_already_purchased": "Je kunt dit product niet opnieuw kopen.",
  "error_page.error_message_missing_email_error": "Een e-mailadres is vereist om de aankoop te voltooien.",
  "error_page.error_message_network_error": "Netwerkfout. Controleer uw internetverbinding.",
  "error_page.error_message_error_charging_payment": "Betaling mislukt.",
  "error_page.error_message_error_setting_up_purchase": "Aankoop niet gestart vanwege een fout (foutcode: {{errorCode}}).",
  "error_page.error_message_invalid_tax_location": "We konden uw factuuradres niet verifiëren. Controleer of de postcode en het land correct zijn.",
  "error_page.error_message_unknown_error": "Er is een onbekende fout opgetreden (foutcode: {{errorCode}}).",
  "error_page.button_try_again": "Opnieuw proberen",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}%",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "product_info.total_due_today": "Totaal te betalen vandaag",
  "product_info.subscribe_to": "Abonneren op",
  "navbar_header.details": "Details",
  "navbar_header.back_button": "Terug",
  "pricing_dropdown.show_details": "Toon details",
  "pricing_dropdown.hide_details": "Verberg details",
  "pricing_table.tax": "Btw",
  "pricing_table.trial_ends": "Na afloop van de proefperiode, op {{formattedTrialEndDate}}",
  "pricing_table.total_due_today": "Totaal vandaag te betalen",
  "pricing_table.total_excluding_tax": "Totaal exclusief btw",
  "pricing_table.enter_billing_address_to_calculate": "Voer het factuuradres in om te berekenen",
  "pricing_table.enter_state_or_postal_code_to_calculate": "Voer provincie of postcode in om te berekenen",
  "pricing_table.enter_postal_code_to_calculate": "Voer postcode in om te berekenen",
  "error_page.error_message_invalid_email_error": "Het e-mailadres {{email}} kon niet worden geverifieerd. Geef een geldig e-mailadres op.",
  "payment_entry_page.button_payment_method": "Betaal {{formattedPrice}} met {{paymentMethod}}",
  "payment_entry_page.button_with_price": "Betaal {{formattedPrice}}",
  "price_update.title": "Prijsupdate",
  "price_update.base_message": "De totale prijs is bijgewerkt met belasting op basis van uw factuuradres. Controleer en probeer het opnieuw. Uw kaart wordt slechts één keer belast.",
  "price_update.trial_message": "De abonnementsprijs is bijgewerkt om belastingen op te nemen op basis van uw factuuradres. De gratis proefperiode blijft van toepassing. Controleer en probeer het opnieuw.",
  "payment_entry_page.express_checkout_divider": "OF BETAAL MET EEN KAART",
  "error_page.trouble_accessing": "Als je problemen hebt met het verkrijgen van toegang tot je aankoop, neem dan contact op met de ondersteuning via ",
  "error_page.close_button_title": "Ga naar {{appName}}",
  "error_page.error_title_stripe_missing_required_permission": "Ontbrekende Stripe-toestemming",
  "error_page.button_close": "Sluiten",
  "error_page.error_message_stripe_invalid_tax_origin_address": "De aankoop is mislukt omdat het belastingoorsprongadres ongeldig is. In productie werken aankopen zonder toegepaste belastingen.",
  "error_page.error_message_stripe_tax_not_active": "De aankoop is mislukt omdat Stripe Tax niet is ingeschakeld. In productie werken aankopen zonder toegepaste belastingen.",
  "error_page.error_only_in_sandbox": "Dit bericht verschijnt alleen in de sandbox.",
  "error_page.error_message_stripe_missing_required_permission": "De aankoop is mislukt omdat de Stripe-app een vereiste toestemming mist. In productie werken aankopen zonder toegepaste belastingen.",
  "error_page.error_title_stripe_tax_not_active": "Stripe Tax niet actief",
  "error_page.error_title_stripe_invalid_tax_origin_address": "Ongeldig belastingoorsprongadres",
  "apple_pay.free_trial": "Gratis proefperiode",
  "product_info.price_after_intro_price": "Na {{introPriceDuration}}, op {{renewalDate}}",
  "product_info.after_trial": "na proefperiode",
  "product_info.after": "na",
  "product_info.intro_price_phase_after_trial": "Daarna {{introPriceDuration}} voor {{introPrice}}",
  "product_info.intro_price_phase": "Eerst {{introPriceDuration}} voor {{introPrice}}",
  "product_info.intro_price_phase_paid_once": "eenmalig betaald",
  "payment_entry_page.trial_subscription_terms_info": "Na afloop van uw proefperiode wordt {{price}} {{perFrequency}} in rekening gebracht, beginnend op {{renewalDate}}. U kunt op elk moment vóór deze datum annuleren.",
  "payment_entry_page.subscription_info": "Abonnement wordt automatisch verlengd. Annuleer op elk moment.",
  "payment_entry_page.otp_terms_info": "Door de aankoop ga je ermee akkoord dat {{appName}} kosten in rekening brengt volgens hun voorwaarden.",
  "payment_entry_page.terms_link_label": "Voorwaarden",
  "payment_entry_page.subscription_terms_info": "Door u te abonneren, stemt u ermee in dat {{appName}} u kosten in rekening brengt volgens hun voorwaarden totdat u annuleert.",
  "loading_page.keep_page_open": "Het proces is bijna voltooid. Houd deze pagina open.",
  "loading_page.processing_payment": "Betaling verwerken",
  "pricing_table.discount": "Korting",
  "pricing_table.subtotal": "Subtotaal"
}, mg = {
  "periods.week": "{{amount}} viikko",
  "periods.month": "{{amount}} kuukausi",
  "periods.year": "{{amount}} vuosi",
  "periods.day": "{{amount}} päivä",
  "periods.weekShort": "{{amount}}vk",
  "periods.monthShort": "{{amount}}kk",
  "periods.yearShort": "{{amount}}v",
  "periods.dayShort": "{{amount}}p",
  "periods.lifetime": "elämäaika",
  "periods.weekPlural": "{{amount}} viikkoa",
  "periods.monthPlural": "{{amount}} kuukautta",
  "periods.yearPlural": "{{amount}} vuotta",
  "periods.dayPlural": "{{amount}} päivää",
  "periods.weekFrequency": "viikoittain",
  "periods.monthFrequency": "kuukausittain",
  "periods.yearFrequency": "vuosittain",
  "periods.dayFrequency": "päivittäin",
  "periods.perWeekFrequency": "viikossa",
  "periods.perMonthFrequency": "kuukaudessa",
  "periods.perYearFrequency": "vuodessa",
  "periods.perDayFrequency": "päivässä",
  "periods.unknownFrequency": "tuntematon",
  "periods.weekFrequencyPlural": "joka {{amount}} viikko",
  "periods.monthFrequencyPlural": "joka {{amount}} kuukausi",
  "periods.yearFrequencyPlural": "joka {{amount}} vuosi",
  "periods.dayFrequencyPlural": "joka {{amount}} päivä",
  "product_info.product_title": "{{productTitle}}",
  "product_info.product_description": "{{productDescription}}",
  "product_info.product_price": "{{productPrice}}",
  "product_info.free_trial_duration": "{{trialDuration}} ilmainen kokeilujakso",
  "product_info.price_after_free_trial": "Kokeilujakson päätyttyä, {{renewalDate}}",
  "product_info.renewal_frequency": "Uusiutuu {{frequency}}",
  "product_info.continues_until_cancelled": "Jatkuu, kunnes peruutetaan",
  "product_info.cancel_anytime": "Peruuta milloin tahansa",
  "payment_entry_page.payment_step_title": "Suojautunut kassatoiminto RevenueCatin kautta",
  "payment_entry_page.button_pay": "Maksa nyt",
  "payment_entry_page.button_start_trial": "Aloita kokeilujakso",
  "success_page.purchase_successful": "Maksaminen onnistui",
  "success_page.button_close": "Jatka",
  "error_page.if_error_persists": "Jos virhe jatkuu, ota yhteyttä ",
  "error_page.error_title_already_subscribed": "Olet jo tilannut tuotteen {{productTitle}}",
  "error_page.error_title_already_purchased": "Olet jo ostanut tuotteen {{productTitle}}",
  "error_page.error_title_other_errors": "Jokin meni pieleen",
  "error_page.error_message_already_subscribed": "Et voi tilata tätä tuotetta uudelleen.",
  "error_page.error_message_already_purchased": "Et voi ostaa tätä tuotetta uudelleen.",
  "error_page.error_message_missing_email_error": "Sähköpostiosoite tarvitaan ostoksen loppuun saattamiseksi.",
  "error_page.error_message_network_error": "Verkkovirhe. Tarkista internet-yhteytesi.",
  "error_page.error_message_error_charging_payment": "Maksaminen epäonnistui.",
  "error_page.error_message_error_setting_up_purchase": "Ostoa ei aloitettu virheen vuoksi (virhekoodi: {{errorCode}}).",
  "error_page.error_message_invalid_tax_location": "Emme voineet vahvistaa laskutusosoitettasi. Tarkista, että postinumero ja maa ovat oikein.",
  "error_page.error_message_unknown_error": "Tapahtui tuntematon virhe (virhekoodi: {{errorCode}}).",
  "error_page.button_try_again": "Yritä uudelleen",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}%",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}} ({{formattedPricePerMonth}}/{{monthPeriod}})",
  "product_info.total_due_today": "Maksettava summa tänään",
  "product_info.subscribe_to": "Tilaa",
  "navbar_header.details": "Yksityiskohdat",
  "navbar_header.back_button": "Takaisin",
  "pricing_dropdown.show_details": "Näytä tiedot",
  "pricing_dropdown.hide_details": "Piilota tiedot",
  "pricing_table.tax": "Vero",
  "pricing_table.trial_ends": "Kokeilujakson päätyttyä, {{formattedTrialEndDate}}",
  "pricing_table.total_due_today": "Maksettava summa tänään",
  "pricing_table.total_excluding_tax": "Veroton kokonaissumma",
  "pricing_table.enter_billing_address_to_calculate": "Syötä laskutusosoite laskeaksesi",
  "pricing_table.enter_state_or_postal_code_to_calculate": "Syötä osavaltio tai postinumero laskeaksesi",
  "pricing_table.enter_postal_code_to_calculate": "Syötä postinumero laskeaksesi",
  "error_page.error_message_invalid_email_error": "Sähköpostiosoitetta {{email}} ei voitu vahvistaa. Anna kelvollinen sähköpostiosoite.",
  "payment_entry_page.button_payment_method": "Maksa {{formattedPrice}} käyttämällä {{paymentMethod}}",
  "payment_entry_page.button_with_price": "Maksa {{formattedPrice}}",
  "price_update.title": "Hinnan päivitys",
  "price_update.base_message": "Kokonaishinta on päivitetty verolla laskutusosoitteesi perusteella. Tarkista ja yritä uudelleen. Korttiasi veloitetaan vain kerran.",
  "price_update.trial_message": "Tilauksen hinta on päivitetty sisältämään verot laskutusosoitteesi perusteella. Ilmainen kokeilujakso on edelleen voimassa. Tarkista ja yritä uudelleen.",
  "payment_entry_page.express_checkout_divider": "TAI MAKSA KORTILLA",
  "error_page.trouble_accessing": "Jos sinulla on ongelmia ostoksesi käyttämisessä, ota yhteyttä tukeen osoitteessa ",
  "error_page.close_button_title": "Siirry sovellukseen {{appName}}",
  "error_page.error_title_stripe_missing_required_permission": "Puuttuva Stripe-käyttöoikeus",
  "error_page.button_close": "Sulje",
  "error_page.error_message_stripe_invalid_tax_origin_address": "Osto epäonnistui, koska veron alkuperäosoite on virheellinen. Tuotantoympäristössä ostot toimivat ilman veroja.",
  "error_page.error_message_stripe_tax_not_active": "Osto epäonnistui, koska Stripe Tax ei ole käytössä. Tuotantoympäristössä ostot toimivat ilman veroja.",
  "error_page.error_only_in_sandbox": "Tämä viesti näkyy vain hiekkalaatikossa.",
  "error_page.error_message_stripe_missing_required_permission": "Osto epäonnistui, koska Stripe-sovellukselta puuttuu vaadittu käyttöoikeus. Tuotantoympäristössä ostot toimivat ilman veroja.",
  "error_page.error_title_stripe_tax_not_active": "Stripe Tax ei ole aktiivinen",
  "error_page.error_title_stripe_invalid_tax_origin_address": "Virheellinen veron alkuperäosoite",
  "apple_pay.free_trial": "Ilmainen kokeilu",
  "product_info.price_after_intro_price": "{{introPriceDuration}} jälkeen, {{renewalDate}}",
  "product_info.after_trial": "kokeilujakson jälkeen",
  "product_info.after": "jälkeen",
  "product_info.intro_price_phase_after_trial": "Sitten {{introPriceDuration}} hintaan {{introPrice}}",
  "product_info.intro_price_phase": "Ensimmäiset {{introPriceDuration}} hintaan {{introPrice}}",
  "product_info.intro_price_phase_paid_once": "maksetaan kerran",
  "payment_entry_page.trial_subscription_terms_info": "Kokeilujakson päätyttyä sinulta veloitetaan {{price}} {{perFrequency}} alkaen {{renewalDate}}. Voit peruuttaa milloin tahansa ennen tätä päivämäärää.",
  "payment_entry_page.subscription_info": "Tilaus uusiutuu automaattisesti. Peruuta milloin tahansa.",
  "payment_entry_page.otp_terms_info": "Ostamalla hyväksyt, että {{appName}} veloittaa sinua heidän ehtojensa mukaisesti.",
  "payment_entry_page.terms_link_label": "Ehdot",
  "payment_entry_page.subscription_terms_info": "Tilaamalla hyväksyt, että {{appName}} veloittaa sinulta ehtojensa mukaisesti, kunnes peruutat tilauksen.",
  "loading_page.keep_page_open": "Prosessi on melkein valmis. Pidä tämä sivu auki.",
  "loading_page.processing_payment": "Maksua käsitellään",
  "pricing_table.discount": "Alennus",
  "pricing_table.subtotal": "Välisumma"
}, hg = {
  "periods.week": "{{amount}} semaine",
  "periods.month": "{{amount}} mois",
  "periods.year": "{{amount}} an",
  "periods.day": "{{amount}} jour",
  "periods.weekShort": "{{amount}}sem",
  "periods.monthShort": "{{amount}}mois",
  "periods.yearShort": "{{amount}}an",
  "periods.dayShort": "{{amount}}j",
  "periods.lifetime": "à vie",
  "periods.weekPlural": "{{amount}} semaines",
  "periods.monthPlural": "{{amount}} mois",
  "periods.yearPlural": "{{amount}} ans",
  "periods.dayPlural": "{{amount}} jours",
  "periods.weekFrequency": "hebdomadaire",
  "periods.monthFrequency": "mensuel",
  "periods.yearFrequency": "annuel",
  "periods.dayFrequency": "quotidien",
  "periods.perWeekFrequency": "par semaine",
  "periods.perMonthFrequency": "par mois",
  "periods.perYearFrequency": "par an",
  "periods.perDayFrequency": "par jour",
  "periods.unknownFrequency": "inconnu",
  "periods.weekFrequencyPlural": "toutes les {{amount}} semaines",
  "periods.monthFrequencyPlural": "tous les {{amount}} mois",
  "periods.yearFrequencyPlural": "tous les {{amount}} ans",
  "periods.dayFrequencyPlural": "tous les {{amount}} jours",
  "product_info.product_title": "{{productTitle}}",
  "product_info.product_description": "{{productDescription}}",
  "product_info.product_price": "{{productPrice}}",
  "product_info.free_trial_duration": "{{trialDuration}} essai gratuit",
  "product_info.price_after_free_trial": "Après la fin de l'essai, le {{renewalDate}}",
  "product_info.renewal_frequency": "Renouvellement {{frequency}}",
  "product_info.continues_until_cancelled": "Continue jusqu'à annulation",
  "product_info.cancel_anytime": "Annulez à tout moment",
  "payment_entry_page.payment_step_title": "Paiement sécurisé par RevenueCat",
  "payment_entry_page.button_pay": "Payer maintenant",
  "payment_entry_page.button_start_trial": "Commencer l'essai",
  "success_page.purchase_successful": "Paiement effectué",
  "success_page.button_close": "Continuer",
  "error_page.if_error_persists": "Si l'erreur persiste, veuillez contacter ",
  "error_page.error_title_already_subscribed": "Vous êtes déjà abonné à {{productTitle}}",
  "error_page.error_title_already_purchased": "Vous avez déjà acheté {{productTitle}}",
  "error_page.error_title_other_errors": "Une erreur s'est produite",
  "error_page.error_message_already_subscribed": "Vous ne pouvez pas vous abonner à nouveau à ce produit.",
  "error_page.error_message_already_purchased": "Vous ne pouvez pas acheter ce produit à nouveau.",
  "error_page.error_message_missing_email_error": "L'adresse e-mail est requise pour effectuer l'achat.",
  "error_page.error_message_network_error": "Erreur réseau. Veuillez vérifier votre connexion Internet.",
  "error_page.error_message_error_charging_payment": "Échec du paiement.",
  "error_page.error_message_error_setting_up_purchase": "L'achat n'a pas pu démarrer en raison d'une erreur (code d'erreur : {{errorCode}}).",
  "error_page.error_message_invalid_tax_location": "Nous n'avons pas pu vérifier votre adresse de facturation. Veuillez vérifier que le code postal et le pays sont corrects.",
  "error_page.error_message_unknown_error": "Une erreur inconnue s'est produite (code d'erreur : {{errorCode}}).",
  "error_page.button_try_again": "Réessayer",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}%",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}} ({{formattedPricePerMonth}}/{{monthPeriod}})",
  "product_info.total_due_today": "Total dû aujourd'hui",
  "product_info.subscribe_to": "S'abonner à",
  "navbar_header.details": "Détails",
  "navbar_header.back_button": "Retour",
  "pricing_dropdown.show_details": "Afficher les détails",
  "pricing_dropdown.hide_details": "Masquer les détails",
  "pricing_table.tax": "Taxe",
  "pricing_table.trial_ends": "Après la fin de l'essai, le {{formattedTrialEndDate}}",
  "pricing_table.total_due_today": "Total dû aujourd'hui",
  "pricing_table.total_excluding_tax": "Total hors taxes",
  "pricing_table.enter_billing_address_to_calculate": "Saisir l'adresse de facturation pour calculer",
  "pricing_table.enter_state_or_postal_code_to_calculate": "Entrez l'état ou le code postal pour calculer",
  "pricing_table.enter_postal_code_to_calculate": "Entrez le code postal pour calculer",
  "error_page.error_message_invalid_email_error": "L'adresse e-mail {{email}} n'a pas pu être vérifiée. Veuillez fournir une adresse e-mail valide.",
  "payment_entry_page.button_payment_method": "Payer {{formattedPrice}} avec {{paymentMethod}}",
  "payment_entry_page.button_with_price": "Payer {{formattedPrice}}",
  "price_update.title": "Mise à jour du prix",
  "price_update.base_message": "Le prix total a été mis à jour avec la taxe en fonction de votre adresse de facturation. Veuillez vérifier et réessayer. Votre carte ne sera débitée qu'une seule fois.",
  "price_update.trial_message": "Le prix de l'abonnement a été mis à jour pour inclure les taxes en fonction de votre adresse de facturation. La période d'essai gratuit reste applicable. Veuillez vérifier et réessayer.",
  "payment_entry_page.express_checkout_divider": "OU PAYER PAR CARTE",
  "error_page.trouble_accessing": "Si vous avez des difficultés à accéder à votre achat, contactez le support à l'adresse suivante : ",
  "error_page.close_button_title": "Aller sur {{appName}}",
  "error_page.error_title_stripe_missing_required_permission": "Autorisation Stripe manquante",
  "error_page.button_close": "Fermer",
  "error_page.error_message_stripe_invalid_tax_origin_address": "L'achat a échoué car l'adresse d'origine de la taxe n'est pas valide. En production, les achats fonctionneront sans taxes appliquées.",
  "error_page.error_message_stripe_tax_not_active": "L'achat a échoué car Stripe Tax n'est pas activé. En production, les achats fonctionneront sans taxes appliquées.",
  "error_page.error_only_in_sandbox": "Ce message apparaît uniquement dans l'environnement de test.",
  "error_page.error_message_stripe_missing_required_permission": "L'achat a échoué car l'application Stripe ne dispose pas d'une autorisation requise. En production, les achats fonctionneront sans taxes appliquées.",
  "error_page.error_title_stripe_tax_not_active": "Stripe Tax non actif",
  "error_page.error_title_stripe_invalid_tax_origin_address": "Adresse d'origine de la taxe non valide",
  "apple_pay.free_trial": "Essai gratuit",
  "product_info.price_after_intro_price": "Après {{introPriceDuration}}, le {{renewalDate}}",
  "product_info.after_trial": "après l'essai",
  "product_info.after": "après",
  "product_info.intro_price_phase_after_trial": "Puis {{introPriceDuration}} pour {{introPrice}}",
  "product_info.intro_price_phase": "{{introPriceDuration}} pour {{introPrice}} au départ",
  "product_info.intro_price_phase_paid_once": "payé une fois",
  "payment_entry_page.trial_subscription_terms_info": "Après la fin de votre essai, vous serez facturé {{price}} {{perFrequency}} à partir du {{renewalDate}}. Vous pouvez annuler à tout moment avant cette date.",
  "payment_entry_page.subscription_info": "L'abonnement est renouvelé automatiquement. Annulez à tout moment.",
  "payment_entry_page.otp_terms_info": "En achetant, vous acceptez d'autoriser {{appName}} à vous facturer conformément à ses conditions.",
  "payment_entry_page.terms_link_label": "Conditions",
  "payment_entry_page.subscription_terms_info": "En vous abonnant, vous acceptez d'autoriser {{appName}} à vous facturer conformément à ses conditions jusqu'à ce que vous annuliez.",
  "loading_page.keep_page_open": "Le processus est presque terminé. Veuillez garder cette page ouverte.",
  "loading_page.processing_payment": "Paiement en cours",
  "pricing_table.discount": "Remise",
  "pricing_table.subtotal": "Sous-total"
}, yg = {
  "periods.week": "{{amount}} Woche",
  "periods.month": "{{amount}} Monat",
  "periods.year": "{{amount}} Jahr",
  "periods.day": "{{amount}} Tag",
  "periods.weekShort": "{{amount}}Wo",
  "periods.monthShort": "{{amount}}Mo",
  "periods.yearShort": "{{amount}}J",
  "periods.dayShort": "{{amount}}T",
  "periods.lifetime": "lebenslang",
  "periods.weekPlural": "{{amount}} Wochen",
  "periods.monthPlural": "{{amount}} Monate",
  "periods.yearPlural": "{{amount}} Jahre",
  "periods.dayPlural": "{{amount}} Tage",
  "periods.weekFrequency": "wöchentlich",
  "periods.monthFrequency": "monatlich",
  "periods.yearFrequency": "jährlich",
  "periods.dayFrequency": "täglich",
  "periods.perWeekFrequency": "pro Woche",
  "periods.perMonthFrequency": "pro Monat",
  "periods.perYearFrequency": "pro Jahr",
  "periods.perDayFrequency": "pro Tag",
  "periods.unknownFrequency": "unbekannt",
  "periods.weekFrequencyPlural": "alle {{amount}} Wochen",
  "periods.monthFrequencyPlural": "alle {{amount}} Monate",
  "periods.yearFrequencyPlural": "alle {{amount}} Jahre",
  "periods.dayFrequencyPlural": "alle {{amount}} Tage",
  "product_info.product_title": "{{productTitle}}",
  "product_info.product_description": "{{productDescription}}",
  "product_info.product_price": "{{productPrice}}",
  "product_info.free_trial_duration": "{{trialDuration}} kostenlose Testversion",
  "product_info.price_after_free_trial": "Nach Ablauf der Testversion, am {{renewalDate}}",
  "product_info.renewal_frequency": "Verlängert sich {{frequency}}",
  "product_info.continues_until_cancelled": "Läuft bis zur Kündigung",
  "product_info.cancel_anytime": "Jederzeit kündbar",
  "payment_entry_page.payment_step_title": "Sicherer Checkout über RevenueCat",
  "payment_entry_page.button_pay": "Jetzt bezahlen",
  "payment_entry_page.button_start_trial": "Testversion starten",
  "success_page.purchase_successful": "Zahlung abgeschlossen",
  "success_page.button_close": "Weiter",
  "error_page.if_error_persists": "Wenn der Fehler weiterhin besteht, wenden Sie sich bitte an ",
  "error_page.error_title_already_subscribed": "Du hast {{productTitle}} bereits abonniert",
  "error_page.error_title_already_purchased": "Du hast {{productTitle}} bereits gekauft",
  "error_page.error_title_other_errors": "Etwas ist schief gelaufen",
  "error_page.error_message_already_subscribed": "Du kannst dieses Produkt nicht erneut abonnieren.",
  "error_page.error_message_already_purchased": "Du kannst dieses Produkt nicht erneut kaufen.",
  "error_page.error_message_missing_email_error": "Für den Kauf ist eine E-Mail-Adresse erforderlich.",
  "error_page.error_message_network_error": "Netzwerkfehler. Bitte überprüfen Sie Ihre Internetverbindung.",
  "error_page.error_message_error_charging_payment": "Zahlung fehlgeschlagen.",
  "error_page.error_message_error_setting_up_purchase": "Der Kauf wurde aufgrund eines Fehlers nicht gestartet (Fehlercode: {{errorCode}}).",
  "error_page.error_message_invalid_tax_location": "Wir konnten Ihre Rechnungsadresse nicht überprüfen. Bitte überprüfen Sie, ob die Postleitzahl und das Land korrekt sind.",
  "error_page.error_message_unknown_error": "Ein unbekannter Fehler ist aufgetreten (Fehlercode: {{errorCode}}).",
  "error_page.button_try_again": "Erneut versuchen",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}%",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}} ({{formattedPricePerMonth}}/{{monthPeriod}})",
  "product_info.total_due_today": "Heute fälliger Gesamtbetrag",
  "product_info.subscribe_to": "Abonnieren",
  "navbar_header.details": "Details",
  "navbar_header.back_button": "Zurück",
  "pricing_dropdown.show_details": "Details anzeigen",
  "pricing_dropdown.hide_details": "Details ausblenden",
  "pricing_table.tax": "Steuer",
  "pricing_table.trial_ends": "Nach Ablauf der Testphase, am {{formattedTrialEndDate}}",
  "pricing_table.total_due_today": "Heute fälliger Gesamtbetrag",
  "pricing_table.total_excluding_tax": "Gesamtbetrag ohne Steuer",
  "pricing_table.enter_billing_address_to_calculate": "Rechnungsadresse eingeben, um zu berechnen",
  "pricing_table.enter_state_or_postal_code_to_calculate": "Bundesland oder Postleitzahl zur Berechnung eingeben",
  "pricing_table.enter_postal_code_to_calculate": "Postleitzahl zur Berechnung eingeben",
  "error_page.error_message_invalid_email_error": "Die E-Mail-Adresse {{email}} konnte nicht verifiziert werden. Bitte gib eine gültige E-Mail-Adresse an.",
  "payment_entry_page.button_payment_method": "Mit {{paymentMethod}} für {{formattedPrice}} bezahlen",
  "payment_entry_page.button_with_price": "{{formattedPrice}} bezahlen",
  "price_update.title": "Preisaktualisierung",
  "price_update.base_message": "Der Gesamtpreis wurde basierend auf Ihrer Rechnungsadresse mit Steuern aktualisiert. Bitte überprüfen Sie ihn und versuchen Sie es erneut. Ihre Karte wird erst belastet, wenn alles korrekt ist.",
  "price_update.trial_message": "Der Abonnementpreis wurde aktualisiert, um Steuern basierend auf Ihrer Rechnungsadresse einzuschließen. Die kostenlose Testphase gilt weiterhin. Bitte überprüfen Sie und versuchen Sie es erneut.",
  "payment_entry_page.express_checkout_divider": "ODER MIT KARTE ZAHLEN",
  "error_page.trouble_accessing": "Wenn Sie Probleme beim Zugriff auf Ihren Kauf haben, wenden Sie sich an den Support unter ",
  "error_page.close_button_title": "Zu {{appName}} gehen",
  "error_page.error_title_stripe_missing_required_permission": "Fehlende Stripe-Berechtigung",
  "error_page.button_close": "Schließen",
  "error_page.error_message_stripe_invalid_tax_origin_address": "Der Kauf ist fehlgeschlagen, da die Steuerursprungsadresse ungültig ist. In der Produktion funktionieren Käufe ohne angewendete Steuern.",
  "error_page.error_message_stripe_tax_not_active": "Der Kauf ist fehlgeschlagen, da Stripe Tax nicht aktiviert ist. In der Produktion funktionieren Käufe ohne angewendete Steuern.",
  "error_page.error_only_in_sandbox": "Diese Meldung wird nur in der Sandbox angezeigt.",
  "error_page.error_message_stripe_missing_required_permission": "Der Kauf ist fehlgeschlagen, da der Stripe-App eine erforderliche Berechtigung fehlt. In der Produktion funktionieren Käufe ohne angewendete Steuern.",
  "error_page.error_title_stripe_tax_not_active": "Stripe Tax ist nicht aktiv",
  "error_page.error_title_stripe_invalid_tax_origin_address": "Ungültige Steuerursprungsadresse",
  "apple_pay.free_trial": "Kostenlose Testversion",
  "product_info.price_after_intro_price": "Nach {{introPriceDuration}}, am {{renewalDate}}",
  "product_info.after_trial": "nach Testphase",
  "product_info.after": "nach",
  "product_info.intro_price_phase_after_trial": "Danach {{introPriceDuration}} für {{introPrice}}",
  "product_info.intro_price_phase": "Zuerst {{introPriceDuration}} für {{introPrice}}",
  "product_info.intro_price_phase_paid_once": "einmalig bezahlt",
  "payment_entry_page.trial_subscription_terms_info": "Nach Ablauf Ihres Testzeitraums werden Ihnen {{price}} {{perFrequency}} ab dem {{renewalDate}} berechnet. Sie können jederzeit vor diesem Datum kündigen.",
  "payment_entry_page.subscription_info": "Das Abonnement verlängert sich automatisch. Jederzeit kündbar.",
  "payment_entry_page.otp_terms_info": "Mit dem Kauf erklären Sie sich einverstanden, dass {{appName}} Ihnen Gebühren gemäß ihren Bedingungen berechnet.",
  "payment_entry_page.terms_link_label": "Bedingungen",
  "payment_entry_page.subscription_terms_info": "Mit dem Abonnieren erklären Sie sich damit einverstanden, dass {{appName}} Ihnen gemäß ihren Bedingungen Gebühren berechnet, bis Sie kündigen.",
  "loading_page.keep_page_open": "Der Vorgang ist fast abgeschlossen. Bitte lassen Sie diese Seite geöffnet.",
  "loading_page.processing_payment": "Zahlung wird verarbeitet",
  "pricing_table.discount": "Rabatt",
  "pricing_table.subtotal": "Zwischensumme"
}, bg = {
  "periods.week": "{{amount}} εβδομάδα",
  "periods.month": "{{amount}} μήνας",
  "periods.year": "{{amount}} χρόνος",
  "periods.day": "{{amount}} ημέρα",
  "periods.weekShort": "{{amount}} εβδ.",
  "periods.monthShort": "{{amount}} μήν.",
  "periods.yearShort": "{{amount}} έτ.",
  "periods.dayShort": "{{amount}} ημ.",
  "periods.lifetime": "διάρκεια ζωής",
  "periods.weekPlural": "{{amount}} εβδομάδες",
  "periods.monthPlural": "{{amount}} μήνες",
  "periods.yearPlural": "{{amount}} χρόνια",
  "periods.dayPlural": "{{amount}} ημέρες",
  "periods.weekFrequency": "εβδομαδιαία",
  "periods.monthFrequency": "μηνιαία",
  "periods.yearFrequency": "ετήσια",
  "periods.dayFrequency": "καθημερινά",
  "periods.perWeekFrequency": "ανά εβδομάδα",
  "periods.perMonthFrequency": "ανά μήνα",
  "periods.perYearFrequency": "ανά έτος",
  "periods.perDayFrequency": "ανά ημέρα",
  "periods.unknownFrequency": "άγνωστο",
  "periods.weekFrequencyPlural": "κάθε {{amount}} εβδομάδες",
  "periods.monthFrequencyPlural": "κάθε {{amount}} μήνες",
  "periods.yearFrequencyPlural": "κάθε {{amount}} χρόνια",
  "periods.dayFrequencyPlural": "κάθε {{amount}} ημέρες",
  "product_info.subscribe_to": "Εγγραφείτε στο",
  "product_info.product_title": "{{productTitle}}",
  "product_info.product_description": "{{productDescription}}",
  "product_info.product_price": "{{productPrice}}",
  "product_info.free_trial_duration": "Δωρεάν για {{trialDuration}}",
  "product_info.price_after_free_trial": "Μετά τη λήξη της δοκιμής, στις {{renewalDate}}",
  "product_info.total_due_today": "Σύνολο πληρωτέο σήμερα",
  "product_info.renewal_frequency": "Ανανεώνεται {{frequency}}",
  "product_info.continues_until_cancelled": "Συνεχίζεται μέχρι την ακύρωση",
  "product_info.cancel_anytime": "Ακύρωση ανά πάσα στιγμή",
  "payment_entry_page.payment_step_title": "Ασφαλής ολοκλήρωση αγοράς από την RevenueCat",
  "payment_entry_page.button_pay": "Πληρωμή τώρα",
  "payment_entry_page.button_start_trial": "Έναρξη δοκιμής",
  "success_page.purchase_successful": "Η πληρωμή ολοκληρώθηκε",
  "success_page.button_close": "Συνέχεια",
  "error_page.if_error_persists": "Εάν το σφάλμα παραμένει, επικοινωνήστε με ",
  "error_page.error_title_already_subscribed": "Έχετε ήδη εγγραφεί στο {{productTitle}}",
  "error_page.error_title_already_purchased": "Έχετε ήδη αγοράσει το {{productTitle}}",
  "error_page.error_title_other_errors": "Κάτι πήγε στραβά",
  "error_page.error_message_already_subscribed": "Δεν μπορείτε να εγγραφείτε ξανά σε αυτό το προϊόν.",
  "error_page.error_message_already_purchased": "Δεν μπορείτε να αγοράσετε ξανά αυτό το προϊόν.",
  "error_page.error_message_missing_email_error": "Απαιτείται email για την ολοκλήρωση της αγοράς.",
  "error_page.error_message_network_error": "Σφάλμα δικτύου. Ελέγξτε τη σύνδεσή σας στο διαδίκτυο.",
  "error_page.error_message_error_charging_payment": "Η πληρωμή απέτυχε.",
  "error_page.error_message_error_setting_up_purchase": "Η αγορά δεν ξεκίνησε λόγω σφάλματος (κωδικός σφάλματος: {{errorCode}}).",
  "error_page.error_message_invalid_tax_location": "Δεν μπορέσαμε να επαληθεύσουμε τη διεύθυνση χρέωσής σας. Παρακαλούμε ελέγξτε ξανά τον ταχυδρομικό κώδικα και τη χώρα για να βεβαιωθείτε ότι είναι σωστά.",
  "error_page.error_message_unknown_error": "Παρουσιάστηκε ένα άγνωστο σφάλμα (κωδικός σφάλματος: {{errorCode}}).",
  "error_page.button_try_again": "Προσπαθήστε ξανά",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}%",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "navbar_header.details": "Λεπτομέρειες",
  "navbar_header.back_button": "Πίσω",
  "pricing_dropdown.show_details": "Εμφάνιση λεπτομερειών",
  "pricing_dropdown.hide_details": "Απόκρυψη λεπτομερειών",
  "pricing_table.tax": "Φόρος",
  "pricing_table.trial_ends": "Μετά τη λήξη της δοκιμαστικής περιόδου, στις {{formattedTrialEndDate}}",
  "pricing_table.total_due_today": "Σύνολο πληρωτέο σήμερα",
  "pricing_table.total_excluding_tax": "Σύνολο χωρίς φόρο",
  "pricing_table.enter_billing_address_to_calculate": "Εισαγάγετε τη διεύθυνση χρέωσης για να υπολογιστεί",
  "pricing_table.enter_state_or_postal_code_to_calculate": "Εισαγάγετε την πολιτεία ή τον ταχυδρομικό κώδικα για να υπολογιστεί",
  "pricing_table.enter_postal_code_to_calculate": "Εισαγάγετε τον ταχυδρομικό κώδικα για να υπολογιστεί",
  "error_page.error_message_invalid_email_error": "Η διεύθυνση email {{email}} δεν μπόρεσε να επαληθευτεί. Παρακαλώ δώστε μια έγκυρη διεύθυνση email.",
  "payment_entry_page.button_payment_method": "Πληρωμή {{formattedPrice}} με {{paymentMethod}}",
  "payment_entry_page.button_with_price": "Πληρωμή {{formattedPrice}}",
  "price_update.title": "Ενημέρωση τιμής",
  "price_update.base_message": "Η συνολική τιμή ενημερώθηκε με τον φόρο βάσει της διεύθυνσης χρέωσής σας. Ελέγξτε και δοκιμάστε ξανά. Η κάρτα σας θα χρεωθεί μόνο μία φορά.",
  "price_update.trial_message": "Η τιμή της συνδρομής ενημερώθηκε για να συμπεριλάβει τους φόρους βάσει της διεύθυνσης χρέωσής σας. Η δωρεάν δοκιμαστική περίοδος εξακολουθεί να ισχύει. Παρακαλώ ελέγξτε και δοκιμάστε ξανά.",
  "payment_entry_page.express_checkout_divider": "Ή ΠΛΗΡΩΣΤΕ ΜΕ ΚΑΡΤΑ",
  "error_page.trouble_accessing": "Εάν αντιμετωπίζετε προβλήματα πρόσβασης στην αγορά σας, επικοινωνήστε με την υποστήριξη στο ",
  "error_page.close_button_title": "Μετάβαση στο {{appName}}",
  "error_page.error_title_stripe_missing_required_permission": "Λείπει άδεια Stripe",
  "error_page.button_close": "Κλείσιμο",
  "error_page.error_message_stripe_invalid_tax_origin_address": "Η αγορά απέτυχε επειδή η διεύθυνση προέλευσης φόρου δεν είναι έγκυρη. Στην παραγωγή, οι αγορές θα λειτουργούν χωρίς να εφαρμόζονται φόροι.",
  "error_page.error_message_stripe_tax_not_active": "Η αγορά απέτυχε επειδή το Stripe Tax δεν είναι ενεργοποιημένο. Στην παραγωγή, οι αγορές θα λειτουργούν χωρίς να εφαρμόζονται φόροι.",
  "error_page.error_only_in_sandbox": "Αυτό το μήνυμα εμφανίζεται μόνο στο sandbox.",
  "error_page.error_message_stripe_missing_required_permission": "Η αγορά απέτυχε επειδή η εφαρμογή Stripe δεν διαθέτει την απαιτούμενη άδεια. Στην παραγωγή, οι αγορές θα λειτουργούν χωρίς να εφαρμόζονται φόροι.",
  "error_page.error_title_stripe_tax_not_active": "Το Stripe Tax δεν είναι ενεργό",
  "error_page.error_title_stripe_invalid_tax_origin_address": "Μη έγκυρη διεύθυνση προέλευσης φόρου",
  "apple_pay.free_trial": "Δωρεάν δοκιμή",
  "product_info.price_after_intro_price": "Μετά από {{introPriceDuration}}, στις {{renewalDate}}",
  "product_info.after_trial": "μετά τη δοκιμή",
  "product_info.after": "μετά",
  "product_info.intro_price_phase_after_trial": "Έπειτα {{introPriceDuration}} για {{introPrice}}",
  "product_info.intro_price_phase": "Αρχικά {{introPriceDuration}} για {{introPrice}}",
  "product_info.intro_price_phase_paid_once": "πληρωμένο εφάπαξ",
  "payment_entry_page.trial_subscription_terms_info": "Μετά τη λήξη της δοκιμαστικής περιόδου, θα χρεωθείτε {{price}} {{perFrequency}} ξεκινώντας από {{renewalDate}}. Μπορείτε να ακυρώσετε ανά πάσα στιγμή πριν από αυτήν την ημερομηνία.",
  "payment_entry_page.subscription_info": "Η συνδρομή ανανεώνεται αυτόματα. Ακυρώστε ανά πάσα στιγμή.",
  "payment_entry_page.otp_terms_info": "Με την αγορά, συμφωνείτε να επιτρέψετε στην {{appName}} να σας χρεώσει σύμφωνα με τους όρους της.",
  "payment_entry_page.terms_link_label": "Όροι",
  "payment_entry_page.subscription_terms_info": "Με την εγγραφή σας, συμφωνείτε να επιτρέψετε στην εφαρμογή {{appName}} να σας χρεώνει σύμφωνα με τους όρους της έως ότου ακυρώσετε.",
  "loading_page.keep_page_open": "Η διαδικασία σχεδόν ολοκληρώθηκε. Κρατήστε αυτή τη σελίδα ανοιχτή.",
  "loading_page.processing_payment": "Επεξεργασία πληρωμής",
  "pricing_table.discount": "Έκπτωση",
  "pricing_table.subtotal": "Υποσύνολο"
}, vg = {
  "periods.week": "{{amount}} שבוע",
  "periods.month": "{{amount}} חודש",
  "periods.year": "{{amount}} שנה",
  "periods.day": "{{amount}} יום",
  "periods.weekShort": "{{amount}}wk",
  "periods.monthShort": "{{amount}}mo",
  "periods.yearShort": "{{amount}}yr",
  "periods.dayShort": "{{amount}}d",
  "periods.lifetime": "למשך כל החיים",
  "periods.weekPlural": "{{amount}} שבועות",
  "periods.monthPlural": "{{amount}} חודשים",
  "periods.yearPlural": "{{amount}} שנים",
  "periods.dayPlural": "{{amount}} ימים",
  "periods.weekFrequency": "שבועי",
  "periods.monthFrequency": "חודשי",
  "periods.yearFrequency": "שנתי",
  "periods.dayFrequency": "יומי",
  "periods.perWeekFrequency": "לשבוע",
  "periods.perMonthFrequency": "לחודש",
  "periods.perYearFrequency": "לשנה",
  "periods.perDayFrequency": "ליום",
  "periods.unknownFrequency": "לא ידוע",
  "periods.weekFrequencyPlural": "כל {{amount}} שבועות",
  "periods.monthFrequencyPlural": "כל {{amount}} חודשים",
  "periods.yearFrequencyPlural": "כל {{amount}} שנים",
  "periods.dayFrequencyPlural": "כל {{amount}} ימים",
  "product_info.product_title": "{{productTitle}}",
  "product_info.product_description": "{{productDescription}}",
  "product_info.product_price": "{{productPrice}}",
  "product_info.free_trial_duration": "{{trialDuration}} ניסיון חינם",
  "product_info.price_after_free_trial": "לאחר סיום הניסיון, ב-{{renewalDate}}",
  "product_info.renewal_frequency": "מתחדש {{frequency}}",
  "product_info.continues_until_cancelled": "נמשך עד ביטול",
  "product_info.cancel_anytime": "ניתן לבטל בכל עת",
  "payment_entry_page.payment_step_title": "קופה מאובטחת באמצעות RevenueCat",
  "payment_entry_page.button_pay": "שלם עכשיו",
  "payment_entry_page.button_start_trial": "התחל ניסיון",
  "success_page.purchase_successful": "התשלום הושלם",
  "success_page.button_close": "המשך",
  "error_page.if_error_persists": "אם השגיאה נמשכת, אנא פנה אל ",
  "error_page.error_title_already_subscribed": "כבר נרשמת כמנוי ל-{{productTitle}}",
  "error_page.error_title_already_purchased": "כבר רכשת את {{productTitle}}",
  "error_page.error_title_other_errors": "משהו השתבש",
  "error_page.error_message_already_subscribed": "אינך יכול להירשם כמנוי למוצר זה שוב.",
  "error_page.error_message_already_purchased": "אינך יכול לרכוש מוצר זה שוב.",
  "error_page.error_message_missing_email_error": 'דוא"ל נדרש כדי להשלים את הרכישה.',
  "error_page.error_message_network_error": "שגיאת רשת. אנא בדוק את חיבור האינטרנט שלך.",
  "error_page.error_message_error_charging_payment": "התשלום נכשל.",
  "error_page.error_message_error_setting_up_purchase": "הרכישה לא הופעלה עקב שגיאה (קוד שגיאה: {{errorCode}}).",
  "error_page.error_message_invalid_tax_location": "לא הצלחנו לאמת את כתובת החיוב שלך. אנא בדוק שוב את המיקוד והמדינה כדי לוודא שהם נכונים.",
  "error_page.error_message_unknown_error": "אירעה שגיאה לא ידועה (קוד שגיאה: {{errorCode}}).",
  "error_page.button_try_again": "נסה שוב",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}%",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "product_info.total_due_today": 'סה"כ לתשלום היום',
  "product_info.subscribe_to": "הירשם כמנוי ל-",
  "navbar_header.details": "פרטים",
  "navbar_header.back_button": "חזרה",
  "pricing_dropdown.show_details": "הצג פרטים",
  "pricing_dropdown.hide_details": "הסתר פרטים",
  "pricing_table.tax": "מס",
  "pricing_table.trial_ends": "לאחר סיום תקופת הניסיון, בתאריך {{formattedTrialEndDate}}",
  "pricing_table.total_due_today": "סך הכל לתשלום היום",
  "pricing_table.total_excluding_tax": "סך הכל לא כולל מס",
  "pricing_table.enter_billing_address_to_calculate": "הזן כתובת לחיוב כדי לחשב",
  "pricing_table.enter_state_or_postal_code_to_calculate": "הזן מדינה או מיקוד לחישוב",
  "pricing_table.enter_postal_code_to_calculate": "הזן מיקוד לחישוב",
  "error_page.error_message_invalid_email_error": "לא ניתן לאמת את כתובת האימייל {{email}}. אנא ספק כתובת אימייל חוקית.",
  "payment_entry_page.button_payment_method": "שלם {{formattedPrice}} באמצעות {{paymentMethod}}",
  "payment_entry_page.button_with_price": "שלם {{formattedPrice}}",
  "price_update.title": "עדכון מחיר",
  "price_update.base_message": "המחיר הכולל עודכן עם מס בהתבסס על כתובת החיוב שלך. אנא בדוק שוב ונסה שוב. החיוב יתבצע רק פעם אחת.",
  "price_update.trial_message": "מחיר המנוי עודכן כדי לכלול מיסים בהתבסס על כתובת החיוב שלך. תקופת הניסיון החינמית עדיין תקפה. אנא בדוק ונסה שוב.",
  "payment_entry_page.express_checkout_divider": "או שלם באמצעות כרטיס",
  "error_page.trouble_accessing": "אם אתה מתקשה לגשת לרכישה שלך, פנה לתמיכה בכתובת ",
  "error_page.close_button_title": "עבור אל {{appName}}",
  "error_page.error_title_stripe_missing_required_permission": "חסרה הרשאה של Stripe",
  "error_page.button_close": "סגור",
  "error_page.error_message_stripe_invalid_tax_origin_address": "הרכישה נכשלה מכיוון שכתובת מקור המס אינה חוקית. בייצור, רכישות יעבדו ללא מסים.",
  "error_page.error_message_stripe_tax_not_active": "הרכישה נכשלה מכיוון שמס Stripe אינו מופעל. בייצור, רכישות יעבדו ללא מסים.",
  "error_page.error_only_in_sandbox": "הודעה זו מופיעה רק בארגז חול.",
  "error_page.error_message_stripe_missing_required_permission": "הרכישה נכשלה מכיוון שלאפליקציית Stripe חסרה הרשאה נדרשת. בייצור, רכישות יעבדו ללא מסים.",
  "error_page.error_title_stripe_tax_not_active": "מס Stripe לא פעיל",
  "error_page.error_title_stripe_invalid_tax_origin_address": "כתובת מקור מס לא חוקית",
  "apple_pay.free_trial": "תקופת ניסיון בחינם",
  "product_info.price_after_intro_price": "לאחר {{introPriceDuration}}, בתאריך {{renewalDate}}",
  "product_info.after_trial": "אחרי תקופת ניסיון",
  "product_info.after": "אחרי",
  "product_info.intro_price_phase_after_trial": "אחר כך {{introPriceDuration}} עבור {{introPrice}}",
  "product_info.intro_price_phase": "תחילה {{introPriceDuration}} עבור {{introPrice}}",
  "product_info.intro_price_phase_paid_once": "משולם פעם אחת",
  "payment_entry_page.trial_subscription_terms_info": "לאחר סיום תקופת הניסיון שלך, תחויב בסך {{price}} {{perFrequency}} החל מ-{{renewalDate}}. באפשרותך לבטל בכל עת לפני תאריך זה.",
  "payment_entry_page.subscription_info": "המנוי מתחדש אוטומטית. ניתן לבטל בכל עת.",
  "payment_entry_page.otp_terms_info": "ברכישה, אתה מסכים לאפשר ל-{{appName}} לחייב אותך בהתאם לתנאים שלהם.",
  "payment_entry_page.terms_link_label": "תנאים",
  "payment_entry_page.subscription_terms_info": "על ידי הרשמה כמנוי, אתה מסכים לאפשר ל-{{appName}} לחייב אותך בהתאם לתנאים שלהם עד שתבטל.",
  "loading_page.keep_page_open": "התהליך כמעט הסתיים. השאר דף זה פתוח.",
  "loading_page.processing_payment": "מעבד תשלום תבעה",
  "pricing_table.discount": "הנחה",
  "pricing_table.subtotal": "סכום ביניים"
}, kg = {
  "periods.week": "{{amount}} सप्ताह",
  "periods.month": "{{amount}} महीना",
  "periods.year": "{{amount}} वर्ष",
  "periods.day": "{{amount}} दिन",
  "periods.weekShort": "{{amount}}सप्ताह",
  "periods.monthShort": "{{amount}}महीना",
  "periods.yearShort": "{{amount}}वर्ष",
  "periods.dayShort": "{{amount}}दिन",
  "periods.lifetime": "लाइफ़टाइम",
  "periods.weekPlural": "{{amount}} सप्ताह",
  "periods.monthPlural": "{{amount}} महीने",
  "periods.yearPlural": "{{amount}} वर्ष",
  "periods.dayPlural": "{{amount}} दिन",
  "periods.weekFrequency": "साप्ताहिक",
  "periods.monthFrequency": "मासिक",
  "periods.yearFrequency": "वार्षिक",
  "periods.dayFrequency": "दैनिक",
  "periods.perWeekFrequency": "प्रति सप्ताह",
  "periods.perMonthFrequency": "प्रति माह",
  "periods.perYearFrequency": "प्रति वर्ष",
  "periods.perDayFrequency": "प्रति दिन",
  "periods.unknownFrequency": "अज्ञात",
  "periods.weekFrequencyPlural": "प्रत्येक {{amount}} सप्ताह",
  "periods.monthFrequencyPlural": "प्रत्येक {{amount}} महीने",
  "periods.yearFrequencyPlural": "प्रत्येक {{amount}} वर्ष",
  "periods.dayFrequencyPlural": "प्रत्येक {{amount}} दिन",
  "product_info.product_title": "{{productTitle}}",
  "product_info.product_description": "{{productDescription}}",
  "product_info.product_price": "{{productPrice}}",
  "product_info.free_trial_duration": "{{trialDuration}} निःशुल्क परीक्षण",
  "product_info.price_after_free_trial": "परीक्षण समाप्त होने के बाद, {{renewalDate}} को",
  "product_info.renewal_frequency": "{{frequency}} पर नवीनीकृत होता है",
  "product_info.continues_until_cancelled": "रद्द होने तक जारी रहता है",
  "product_info.cancel_anytime": "किसी भी समय रद्द करें",
  "payment_entry_page.payment_step_title": "RevenueCat द्वारा सुरक्षित चेकआउट",
  "payment_entry_page.button_pay": "अभी भुगतान करें",
  "payment_entry_page.button_start_trial": "परीक्षण प्रारंभ करें",
  "success_page.purchase_successful": "भुगतान पूर्ण",
  "success_page.button_close": "जारी रखें",
  "error_page.if_error_persists": "यदि त्रुटि बनी रहती है, तो कृपया संपर्क करें ",
  "error_page.error_title_already_subscribed": "आपने पहले ही {{productTitle}} की सदस्यता ले ली है",
  "error_page.error_title_already_purchased": "आपने पहले ही {{productTitle}} खरीद लिया है",
  "error_page.error_title_other_errors": "कुछ गलत हो गया",
  "error_page.error_message_already_subscribed": "आप इस उत्पाद की सदस्यता फिर से नहीं ले सकते.",
  "error_page.error_message_already_purchased": "आप इस उत्पाद को फिर से नहीं खरीद सकते.",
  "error_page.error_message_missing_email_error": "खरीद को पूरा करने के लिए ईमेल आवश्यक है।",
  "error_page.error_message_network_error": "नेटवर्क त्रुटि। कृपया अपना इंटरनेट कनेक्शन जांचें।",
  "error_page.error_message_error_charging_payment": "भुगतान विफल।",
  "error_page.error_message_error_setting_up_purchase": "किसी त्रुटि के कारण खरीदारी शुरू नहीं हुई (त्रुटि कोड: {{errorCode}})।",
  "error_page.error_message_invalid_tax_location": "हम आपके बिलिंग पते को सत्यापित नहीं कर सके। कृपया सुनिश्चित करें कि पिन कोड और देश सही हैं।",
  "error_page.error_message_unknown_error": "एक अज्ञात त्रुटि हुई (त्रुटि कोड: {{errorCode}})।",
  "error_page.button_try_again": "फिर से कोशिश करें",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}%",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "product_info.total_due_today": "आज देय कुल राशि",
  "product_info.subscribe_to": "सदस्यता लें",
  "navbar_header.details": "विवरण",
  "navbar_header.back_button": "वापस",
  "pricing_dropdown.show_details": "विवरण दिखाएँ",
  "pricing_dropdown.hide_details": "विवरण छिपाएँ",
  "pricing_table.tax": "कर",
  "pricing_table.trial_ends": "{{formattedTrialEndDate}} पर परीक्षण समाप्त होने के बाद",
  "pricing_table.total_due_today": "आज देय कुल",
  "pricing_table.total_excluding_tax": "कर को छोड़कर कुल",
  "pricing_table.enter_billing_address_to_calculate": "गणना करने के लिए बिलिंग पता दर्ज करें",
  "pricing_table.enter_state_or_postal_code_to_calculate": "गणना करने के लिए राज्य या ज़िप कोड दर्ज करें",
  "pricing_table.enter_postal_code_to_calculate": "गणना करने के लिए ज़िप कोड दर्ज करें",
  "error_page.error_message_invalid_email_error": "ईमेल पता {{email}} सत्यापित नहीं किया जा सका. कृपया एक मान्य ईमेल पता प्रदान करें.",
  "payment_entry_page.button_payment_method": "{{paymentMethod}} के साथ {{formattedPrice}} का भुगतान करें",
  "payment_entry_page.button_with_price": "{{formattedPrice}} का भुगतान करें",
  "price_update.title": "मूल्य अपडेट",
  "price_update.base_message": "आप के बिलिंग पते के आधार पर कुल कीमत कर के साथ अपडेट की गई थी। कृपया समीक्षा करें और फिर से प्रयास करें। आपके कार्ड से केवल एक बार शुल्क लिया जाएगा।",
  "price_update.trial_message": "सदस्यता मूल्य आपके बिलिंग पते के आधार पर करों को शामिल करने के लिए अपडेट किया गया है। निःशुल्क परीक्षण अवधि अभी भी लागू है। कृपया जांचें और पुनः प्रयास करें।",
  "payment_entry_page.express_checkout_divider": "या कार्ड से भुगतान करें",
  "error_page.trouble_accessing": "यदि आपको अपनी खरीदारी तक पहुंचने में परेशानी हो रही है, तो पर समर्थन के लिए संपर्क करें",
  "error_page.close_button_title": "{{appName}} पर जाएं",
  "error_page.error_title_stripe_missing_required_permission": "स्ट्राइप अनुमति गुम है",
  "error_page.button_close": "बंद करें",
  "error_page.error_message_stripe_invalid_tax_origin_address": "खरीदारी विफल रही क्योंकि कर उत्पत्ति पता अमान्य है. उत्पादन में, खरीदारी बिना करों के लागू किए काम करेगी.",
  "error_page.error_message_stripe_tax_not_active": "खरीदारी विफल रही क्योंकि स्ट्राइप टैक्स सक्षम नहीं है. उत्पादन में, खरीदारी बिना करों के लागू किए काम करेगी.",
  "error_page.error_only_in_sandbox": "यह संदेश केवल सैंडबॉक्स में दिखाई देता है.",
  "error_page.error_message_stripe_missing_required_permission": "खरीदारी विफल रही क्योंकि स्ट्राइप ऐप में आवश्यक अनुमति नहीं है. उत्पादन में, खरीदारी बिना करों के लागू किए काम करेगी.",
  "error_page.error_title_stripe_tax_not_active": "स्ट्राइप टैक्स सक्रिय नहीं है",
  "error_page.error_title_stripe_invalid_tax_origin_address": "अमान्य कर उत्पत्ति पता",
  "apple_pay.free_trial": "मुफ़्त ट्रायल",
  "product_info.price_after_intro_price": "{{introPriceDuration}} के बाद, {{renewalDate}} पर",
  "product_info.after_trial": "ट्रायल के बाद",
  "product_info.after": "के बाद",
  "product_info.intro_price_phase_after_trial": "फिर {{introPriceDuration}} के लिए {{introPrice}}",
  "product_info.intro_price_phase": "पहले {{introPriceDuration}} के लिए {{introPrice}}",
  "product_info.intro_price_phase_paid_once": "एक बार भुगतान किया गया",
  "payment_entry_page.trial_subscription_terms_info": "आपकी परीक्षण अवधि समाप्त होने के बाद, आपसे {{renewalDate}} से शुरू होकर {{price}} {{perFrequency}} शुल्क लिया जाएगा. आप इस तिथि से पहले कभी भी रद्द कर सकते हैं.",
  "payment_entry_page.subscription_info": "सदस्यता स्वतः नवीनीकृत हो जाती है. कभी भी रद्द करें.",
  "payment_entry_page.otp_terms_info": "खरीदकर, आप {{appName}} को उनकी शर्तों के अनुसार आपसे शुल्क लेने की अनुमति देने के लिए सहमत हैं.",
  "payment_entry_page.terms_link_label": "नियम",
  "payment_entry_page.subscription_terms_info": "सदस्यता लेकर, आप {{appName}} को रद्द करने तक उनकी शर्तों के अनुसार आपसे शुल्क लेने की अनुमति देने के लिए सहमत हैं.",
  "loading_page.keep_page_open": "प्रक्रिया लगभग पूरी हो चुकी है. इस पृष्ठ को खुला रखें.",
  "loading_page.processing_payment": "भुगतान संसाधित किया जा रहा है",
  "pricing_table.discount": "छूट",
  "pricing_table.subtotal": "उपकुल योग"
}, wg = {
  "periods.week": "{{amount}} hét",
  "periods.month": "{{amount}} hónap",
  "periods.year": "{{amount}} év",
  "periods.day": "{{amount}} nap",
  "periods.weekShort": "{{amount}}hét",
  "periods.monthShort": "{{amount}}hó",
  "periods.yearShort": "{{amount}}év",
  "periods.dayShort": "{{amount}}n",
  "periods.lifetime": "életre szóló",
  "periods.weekPlural": "{{amount}} hét",
  "periods.monthPlural": "{{amount}} hónap",
  "periods.yearPlural": "{{amount}} év",
  "periods.dayPlural": "{{amount}} nap",
  "periods.weekFrequency": "heti",
  "periods.monthFrequency": "havi",
  "periods.yearFrequency": "éves",
  "periods.dayFrequency": "napi",
  "periods.perWeekFrequency": "hetente",
  "periods.perMonthFrequency": "havonta",
  "periods.perYearFrequency": "évente",
  "periods.perDayFrequency": "naponta",
  "periods.unknownFrequency": "ismeretlen",
  "periods.weekFrequencyPlural": "minden {{amount}} hétben",
  "periods.monthFrequencyPlural": "minden {{amount}} hónapban",
  "periods.yearFrequencyPlural": "minden {{amount}} évben",
  "periods.dayFrequencyPlural": "minden {{amount}} napban",
  "product_info.product_title": "{{productTitle}}",
  "product_info.product_description": "{{productDescription}}",
  "product_info.product_price": "{{productPrice}}",
  "product_info.free_trial_duration": "{{trialDuration}} próbaidőszak",
  "product_info.price_after_free_trial": "A próbaidőszak vége után, {{renewalDate}}-kor",
  "product_info.renewal_frequency": "{{frequency}} gyakorisággal megújul",
  "product_info.continues_until_cancelled": "Folytatódik, amíg le nem mondják",
  "product_info.cancel_anytime": "Bármikor lemondható",
  "payment_entry_page.payment_step_title": "Biztonságos fizetés a RevenueCat-en keresztül",
  "payment_entry_page.button_pay": "Fizetés most",
  "payment_entry_page.button_start_trial": "Próbaidőszak indítása",
  "success_page.purchase_successful": "Fizetés sikeres",
  "success_page.button_close": "Tovább",
  "error_page.if_error_persists": "Ha a hiba továbbra is fennáll, kérjük, vedd fel a kapcsolatot ",
  "error_page.error_title_already_subscribed": "Már előfizettél a(z) {{productTitle}} termékre",
  "error_page.error_title_already_purchased": "Már megvásároltad a(z) {{productTitle}} terméket",
  "error_page.error_title_other_errors": "Valami hiba történt",
  "error_page.error_message_already_subscribed": "Nem fizethetsz elő újra erre a termékre.",
  "error_page.error_message_already_purchased": "Nem vásárolhatod meg újra ezt a terméket.",
  "error_page.error_message_missing_email_error": "Az email cím szükséges a vásárlás befejezéséhez.",
  "error_page.error_message_network_error": "Hálózati hiba. Kérjük, ellenőrizd az internetkapcsolatodat.",
  "error_page.error_message_error_charging_payment": "A fizetés sikertelen volt.",
  "error_page.error_message_error_setting_up_purchase": "Hiba miatt nem indult el a vásárlás (hibakód: {{errorCode}}).",
  "error_page.error_message_invalid_tax_location": "Nem tudtuk ellenőrizni a számlázási címét. Kérjük, ellenőrizze, hogy az irányítószám és az ország helyes-e.",
  "error_page.error_message_unknown_error": "Ismeretlen hiba történt (hibakód: {{errorCode}}).",
  "error_page.button_try_again": "Újrapróbálkozás",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}%",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "product_info.total_due_today": "Ma fizetendő összesen",
  "product_info.subscribe_to": "Feliratkozás erre:",
  "navbar_header.details": "Részletek",
  "navbar_header.back_button": "Vissza",
  "pricing_dropdown.show_details": "Részletek mutatása",
  "pricing_dropdown.hide_details": "Részletek elrejtése",
  "pricing_table.tax": "Adó",
  "pricing_table.trial_ends": "A próbaidőszak vége: {{formattedTrialEndDate}}",
  "pricing_table.total_due_today": "Ma fizetendő összeg",
  "pricing_table.total_excluding_tax": "Összesen adó nélkül",
  "pricing_table.enter_billing_address_to_calculate": "Adja meg a számlázási címet a számításhoz",
  "pricing_table.enter_state_or_postal_code_to_calculate": "Adja meg az államot vagy az irányítószámot a számításhoz",
  "pricing_table.enter_postal_code_to_calculate": "Adja meg az irányítószámot a számításhoz",
  "error_page.error_message_invalid_email_error": "A(z) {{email}} e-mail címet nem sikerült ellenőrizni. Kérjük, adj meg egy érvényes e-mail címet.",
  "payment_entry_page.button_payment_method": "Fizetés {{formattedPrice}} összeggel a következővel: {{paymentMethod}}",
  "payment_entry_page.button_with_price": "Fizetés {{formattedPrice}}",
  "price_update.title": "Ár frissítése",
  "price_update.base_message": "A teljes ár frissítve lett az adóval a számlázási címed alapján. Kérjük, tekintsd át és próbáld újra. A kártyádat csak egyszer terheljük meg.",
  "price_update.trial_message": "Az előfizetés ára adókkal együtt frissítésre került a számlázási címének megfelelően. Az ingyenes próbaidőszak továbbra is érvényes. Kérjük, ellenőrizze és próbálja újra.",
  "payment_entry_page.express_checkout_divider": "VAGY FIZESSEN KÁRTYÁVAL",
  "error_page.trouble_accessing": "Ha problémái vannak a vásárláshoz való hozzáféréssel, forduljon az ügyfélszolgálathoz a következő címen: ",
  "error_page.close_button_title": "Ugrás a(z) {{appName}} alkalmazáshoz",
  "error_page.error_title_stripe_missing_required_permission": "Hiányzó Stripe engedély",
  "error_page.button_close": "Bezárás",
  "error_page.error_message_stripe_invalid_tax_origin_address": "A vásárlás sikertelen volt, mert az adókiindulási cím érvénytelen. Éles környezetben a vásárlások adók alkalmazása nélkül fognak működni.",
  "error_page.error_message_stripe_tax_not_active": "A vásárlás sikertelen volt, mert a Stripe adó nincs engedélyezve. Éles környezetben a vásárlások adók alkalmazása nélkül fognak működni.",
  "error_page.error_only_in_sandbox": "Ez az üzenet csak a tesztkörnyezetben jelenik meg.",
  "error_page.error_message_stripe_missing_required_permission": "A vásárlás sikertelen volt, mert a Stripe alkalmazásból hiányzik egy szükséges engedély. Éles környezetben a vásárlások adók alkalmazása nélkül fognak működni.",
  "error_page.error_title_stripe_tax_not_active": "A Stripe adó nincs aktiválva",
  "error_page.error_title_stripe_invalid_tax_origin_address": "Érvénytelen adókiindulási cím",
  "apple_pay.free_trial": "Ingyenes próbaidőszak",
  "product_info.price_after_intro_price": "{{introPriceDuration}} után, {{renewalDate}} napján",
  "product_info.after_trial": "próbaidőszak után",
  "product_info.after": "utána",
  "product_info.intro_price_phase_after_trial": "Ezután {{introPriceDuration}} ideig {{introPrice}} áron",
  "product_info.intro_price_phase": "Először {{introPriceDuration}} ideig {{introPrice}} áron",
  "product_info.intro_price_phase_paid_once": "egyszeri fizetéssel",
  "payment_entry_page.trial_subscription_terms_info": "A próbaidőszak vége után {{price}} összeget számítunk fel {{perFrequency}} gyakorisággal, kezdve {{renewalDate}} dátummal. Ezt a dátumot megelőzően bármikor lemondhatod.",
  "payment_entry_page.subscription_info": "Az előfizetés automatikusan megújul. Bármikor lemondhatod.",
  "payment_entry_page.otp_terms_info": "A vásárlással elfogadod, hogy a {{appName}} az általa meghatározott feltételek szerint terheljen.",
  "payment_entry_page.terms_link_label": "Feltételek",
  "payment_entry_page.subscription_terms_info": "A feliratkozással elfogadod, hogy a {{appName}} az általa meghatározott feltételek szerint terheljen, amíg le nem mondod.",
  "loading_page.keep_page_open": "A folyamat majdnem befejeződött. Tartsa nyitva ezt az oldalt.",
  "loading_page.processing_payment": "Fizetés feldolgozása",
  "pricing_table.discount": "Kedvezmény",
  "pricing_table.subtotal": "Részösszeg"
}, Pg = {
  "periods.week": "{{amount}} minggu",
  "periods.month": "{{amount}} bulan",
  "periods.year": "{{amount}} tahun",
  "periods.day": "{{amount}} hari",
  "periods.weekShort": "{{amount}}mg",
  "periods.monthShort": "{{amount}}bl",
  "periods.yearShort": "{{amount}}th",
  "periods.dayShort": "{{amount}}h",
  "periods.lifetime": "seumur hidup",
  "periods.weekPlural": "{{amount}} minggu",
  "periods.monthPlural": "{{amount}} bulan",
  "periods.yearPlural": "{{amount}} tahun",
  "periods.dayPlural": "{{amount}} hari",
  "periods.weekFrequency": "mingguan",
  "periods.monthFrequency": "bulanan",
  "periods.yearFrequency": "tahunan",
  "periods.dayFrequency": "harian",
  "periods.perWeekFrequency": "per minggu",
  "periods.perMonthFrequency": "per bulan",
  "periods.perYearFrequency": "per tahun",
  "periods.perDayFrequency": "per hari",
  "periods.unknownFrequency": "tidak diketahui",
  "periods.weekFrequencyPlural": "setiap {{amount}} minggu",
  "periods.monthFrequencyPlural": "setiap {{amount}} bulan",
  "periods.yearFrequencyPlural": "setiap {{amount}} tahun",
  "periods.dayFrequencyPlural": "setiap {{amount}} hari",
  "product_info.product_title": "{{productTitle}}",
  "product_info.product_description": "{{productDescription}}",
  "product_info.product_price": "{{productPrice}}",
  "product_info.free_trial_duration": "{{trialDuration}} uji coba gratis",
  "product_info.price_after_free_trial": "Setelah uji coba berakhir, pada {{renewalDate}}",
  "product_info.renewal_frequency": "Diperbarui {{frequency}}",
  "product_info.continues_until_cancelled": "Berlanjut hingga dibatalkan",
  "product_info.cancel_anytime": "Batalkan kapan saja",
  "payment_entry_page.payment_step_title": "Pembayaran aman oleh RevenueCat",
  "payment_entry_page.button_pay": "Bayar sekarang",
  "payment_entry_page.button_start_trial": "Mulai Uji Coba",
  "success_page.purchase_successful": "Pembayaran selesai",
  "success_page.button_close": "Lanjutkan",
  "error_page.if_error_persists": "Jika kesalahan berlanjut, silakan hubungi ",
  "error_page.error_title_already_subscribed": "Anda sudah berlangganan ke {{productTitle}}",
  "error_page.error_title_already_purchased": "Anda sudah membeli {{productTitle}}",
  "error_page.error_title_other_errors": "Terjadi kesalahan",
  "error_page.error_message_already_subscribed": "Anda tidak dapat berlangganan produk ini lagi.",
  "error_page.error_message_already_purchased": "Anda tidak dapat membeli produk ini lagi.",
  "error_page.error_message_missing_email_error": "Email diperlukan untuk menyelesaikan pembelian.",
  "error_page.error_message_network_error": "Kesalahan jaringan. Periksa koneksi internet Anda.",
  "error_page.error_message_error_charging_payment": "Pembayaran gagal.",
  "error_page.error_message_error_setting_up_purchase": "Pembelian tidak dimulai karena kesalahan (kode kesalahan: {{errorCode}}).",
  "error_page.error_message_invalid_tax_location": "Kami tidak dapat memverifikasi alamat penagihan Anda. Harap periksa kembali kode pos dan negara untuk memastikan keduanya benar.",
  "error_page.error_message_unknown_error": "Terjadi kesalahan yang tidak diketahui (kode kesalahan: {{errorCode}}).",
  "error_page.button_try_again": "Coba lagi",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}%",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "product_info.total_due_today": "Total yang harus dibayar hari ini",
  "product_info.subscribe_to": "Berlangganan ke",
  "navbar_header.details": "Detail",
  "navbar_header.back_button": "Kembali",
  "pricing_dropdown.show_details": "Tampilkan detail",
  "pricing_dropdown.hide_details": "Sembunyikan detail",
  "pricing_table.tax": "Pajak",
  "pricing_table.trial_ends": "Setelah masa percobaan berakhir, pada {{formattedTrialEndDate}}",
  "pricing_table.total_due_today": "Total yang harus dibayar hari ini",
  "pricing_table.total_excluding_tax": "Total belum termasuk pajak",
  "pricing_table.enter_billing_address_to_calculate": "Masukkan alamat penagihan untuk menghitung",
  "pricing_table.enter_state_or_postal_code_to_calculate": "Masukkan negara bagian atau kode pos untuk menghitung",
  "pricing_table.enter_postal_code_to_calculate": "Masukkan kode pos untuk menghitung",
  "error_page.error_message_invalid_email_error": "Alamat email {{email}} tidak dapat diverifikasi. Harap berikan alamat email yang valid.",
  "payment_entry_page.button_payment_method": "Bayar {{formattedPrice}} dengan {{paymentMethod}}",
  "payment_entry_page.button_with_price": "Bayar {{formattedPrice}}",
  "price_update.title": "Pembaruan harga",
  "price_update.base_message": "Total harga telah diperbarui dengan pajak berdasarkan alamat penagihan Anda. Harap tinjau dan coba lagi. Kartu Anda hanya akan dikenakan biaya sekali.",
  "price_update.trial_message": "Harga langganan telah diperbarui untuk menyertakan pajak berdasarkan alamat penagihan Anda. Masa percobaan gratis masih berlaku. Silakan periksa dan coba lagi.",
  "payment_entry_page.express_checkout_divider": "ATAU BAYAR DENGAN KARTU",
  "error_page.trouble_accessing": "Jika Anda mengalami masalah dalam mengakses pembelian, hubungi dukungan di ",
  "error_page.close_button_title": "Pergi ke {{appName}}",
  "error_page.error_title_stripe_missing_required_permission": "Izin Stripe tidak ada",
  "error_page.button_close": "Tutup",
  "error_page.error_message_stripe_invalid_tax_origin_address": "Pembelian gagal karena alamat asal pajak tidak valid. Dalam produksi, pembelian akan berfungsi tanpa pajak yang diterapkan.",
  "error_page.error_message_stripe_tax_not_active": "Pembelian gagal karena Stripe Tax tidak diaktifkan. Dalam produksi, pembelian akan berfungsi tanpa pajak yang diterapkan.",
  "error_page.error_only_in_sandbox": "Pesan ini hanya muncul di sandbox.",
  "error_page.error_message_stripe_missing_required_permission": "Pembelian gagal karena aplikasi Stripe tidak memiliki izin yang diperlukan. Dalam produksi, pembelian akan berfungsi tanpa pajak yang diterapkan.",
  "error_page.error_title_stripe_tax_not_active": "Stripe Tax tidak aktif",
  "error_page.error_title_stripe_invalid_tax_origin_address": "Alamat asal pajak tidak valid",
  "apple_pay.free_trial": "Uji Coba Gratis",
  "product_info.price_after_intro_price": "Setelah {{introPriceDuration}}, pada {{renewalDate}}",
  "product_info.after_trial": "setelah uji coba",
  "product_info.after": "setelah",
  "product_info.intro_price_phase_after_trial": "Kemudian {{introPriceDuration}} dengan harga {{introPrice}}",
  "product_info.intro_price_phase": "Pertama {{introPriceDuration}} dengan harga {{introPrice}}",
  "product_info.intro_price_phase_paid_once": "dibayar sekali",
  "payment_entry_page.trial_subscription_terms_info": "Setelah masa percobaan Anda berakhir, Anda akan dikenakan biaya sebesar {{price}} {{perFrequency}} mulai {{renewalDate}}. Anda dapat membatalkan kapan saja sebelum tanggal ini.",
  "payment_entry_page.subscription_info": "Langganan diperpanjang secara otomatis. Batalkan kapan saja.",
  "payment_entry_page.otp_terms_info": "Dengan membeli, Anda setuju untuk mengizinkan {{appName}} menagih Anda sesuai dengan ketentuan mereka.",
  "payment_entry_page.terms_link_label": "Ketentuan",
  "payment_entry_page.subscription_terms_info": "Dengan berlangganan, Anda setuju untuk mengizinkan {{appName}} mengenakan biaya sesuai dengan ketentuan mereka hingga Anda membatalkan.",
  "loading_page.keep_page_open": "Prosesnya hampir selesai. Jangan tutup halaman ini.",
  "loading_page.processing_payment": "Pembayaran sedang diproses",
  "pricing_table.discount": "Diskon",
  "pricing_table.subtotal": "Subtotal"
}, xg = {
  "periods.week": "{{amount}}週間",
  "periods.month": "{{amount}}ヶ月",
  "periods.year": "{{amount}}年",
  "periods.day": "{{amount}}日",
  "periods.weekShort": "{{amount}}週",
  "periods.monthShort": "{{amount}}ヶ月",
  "periods.yearShort": "{{amount}}年",
  "periods.dayShort": "{{amount}}日",
  "periods.lifetime": "生涯",
  "periods.weekPlural": "{{amount}}週間",
  "periods.monthPlural": "{{amount}}ヶ月",
  "periods.yearPlural": "{{amount}}年",
  "periods.dayPlural": "{{amount}}日",
  "periods.weekFrequency": "毎週",
  "periods.monthFrequency": "毎月",
  "periods.yearFrequency": "毎年",
  "periods.dayFrequency": "毎日",
  "periods.perWeekFrequency": "週ごと",
  "periods.perMonthFrequency": "月ごと",
  "periods.perYearFrequency": "年ごと",
  "periods.perDayFrequency": "日ごと",
  "periods.unknownFrequency": "不明",
  "periods.weekFrequencyPlural": "{{amount}}週間ごと",
  "periods.monthFrequencyPlural": "{{amount}}ヶ月ごと",
  "periods.yearFrequencyPlural": "{{amount}}年ごと",
  "periods.dayFrequencyPlural": "{{amount}}日ごと",
  "product_info.product_title": "{{productTitle}}",
  "product_info.product_description": "{{productDescription}}",
  "product_info.product_price": "{{productPrice}}",
  "product_info.free_trial_duration": "{{trialDuration}}日間無料トライアル",
  "product_info.price_after_free_trial": "トライアル終了後、{{renewalDate}}に",
  "product_info.renewal_frequency": "{{frequency}}で更新",
  "product_info.continues_until_cancelled": "キャンセルされるまで継続されます",
  "product_info.cancel_anytime": "いつでもキャンセルできます",
  "payment_entry_page.payment_step_title": "RevenueCatによる安全なチェックアウト",
  "payment_entry_page.button_pay": "今すぐ支払う",
  "payment_entry_page.button_start_trial": "トライアルを開始",
  "success_page.purchase_successful": "支払いが完了しました",
  "success_page.button_close": "続行",
  "error_page.if_error_persists": "エラーが続く場合は、ご連絡ください。",
  "error_page.error_title_already_subscribed": "すでに{{productTitle}}を購読しています",
  "error_page.error_title_already_purchased": "すでに{{productTitle}}を購入しています",
  "error_page.error_title_other_errors": "エラーが発生しました",
  "error_page.error_message_already_subscribed": "この商品を再度購読することはできません。",
  "error_page.error_message_already_purchased": "この商品を再度購入することはできません。",
  "error_page.error_message_missing_email_error": "購入を完了するにはメールアドレスが必要です。",
  "error_page.error_message_network_error": "ネットワークエラーです。インターネット接続を確認してください。",
  "error_page.error_message_error_charging_payment": "支払いに失敗しました。",
  "error_page.error_message_error_setting_up_purchase": "エラーが発生したため、購入を開始できませんでした（エラーコード：{{errorCode}}）。",
  "error_page.error_message_invalid_tax_location": "請求先住所を確認できませんでした。郵便番号と国が正しいかご確認ください。",
  "error_page.error_message_unknown_error": "不明なエラーが発生しました（エラーコード：{{errorCode}}）。",
  "error_page.button_try_again": "再試行",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}%",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "product_info.total_due_today": "本日のお支払い合計",
  "product_info.subscribe_to": "購読する",
  "navbar_header.details": "詳細",
  "navbar_header.back_button": "戻る",
  "pricing_dropdown.show_details": "詳細を表示",
  "pricing_dropdown.hide_details": "詳細を隠す",
  "pricing_table.tax": "税金",
  "pricing_table.trial_ends": "トライアル終了後、{{formattedTrialEndDate}}",
  "pricing_table.total_due_today": "本日お支払いいただく合計金額",
  "pricing_table.total_excluding_tax": "税抜き合計",
  "pricing_table.enter_billing_address_to_calculate": "請求先住所を入力して計算",
  "pricing_table.enter_state_or_postal_code_to_calculate": "計算するには州または郵便番号を入力してください",
  "pricing_table.enter_postal_code_to_calculate": "計算するには郵便番号を入力してください",
  "error_page.error_message_invalid_email_error": "メールアドレス{{email}}を確認できませんでした。有効なメールアドレスを入力してください。",
  "payment_entry_page.button_payment_method": "{{paymentMethod}}で{{formattedPrice}}を支払う",
  "payment_entry_page.button_with_price": "{{formattedPrice}}を支払う",
  "price_update.title": "価格の更新",
  "price_update.base_message": "合計金額が、お客様の請求先住所に基づいて税金とともに更新されました。再度ご確認ください。カードへの請求は1回のみです。",
  "price_update.trial_message": "請求先住所に基づいて税金を含むサブスクリプション料金が更新されました。無料トライアルは引き続き適用されます。確認して再度お試しください。",
  "payment_entry_page.express_checkout_divider": "カードで支払う",
  "error_page.trouble_accessing": "購入へのアクセスに問題がある場合は、サポートにお問い合わせください: ",
  "error_page.close_button_title": "{{appName}} に移動",
  "error_page.error_title_stripe_missing_required_permission": "必要なStripeの権限がありません",
  "error_page.button_close": "閉じる",
  "error_page.error_message_stripe_invalid_tax_origin_address": "税の原産地住所が無効なため、購入に失敗しました。 本番環境では、税金が適用されなくても購入は可能です。",
  "error_page.error_message_stripe_tax_not_active": "Stripe Taxが有効になっていないため、購入に失敗しました。 本番環境では、税金が適用されなくても購入は可能です。",
  "error_page.error_only_in_sandbox": "このメッセージはサンドボックスでのみ表示されます。",
  "error_page.error_message_stripe_missing_required_permission": "Stripeアプリに必要な権限がないため、購入に失敗しました。 本番環境では、税金が適用されなくても購入は可能です。",
  "error_page.error_title_stripe_tax_not_active": "Stripe Taxが有効ではありません",
  "error_page.error_title_stripe_invalid_tax_origin_address": "税の原産地住所が無効です",
  "apple_pay.free_trial": "無料トライアル",
  "product_info.price_after_intro_price": "{{introPriceDuration}}の後、{{renewalDate}}に",
  "product_info.after_trial": "トライアル後",
  "product_info.after": "後",
  "product_info.intro_price_phase_after_trial": "その後、{{introPriceDuration}}間は{{introPrice}}",
  "product_info.intro_price_phase": "最初の{{introPriceDuration}}間は{{introPrice}}",
  "product_info.intro_price_phase_paid_once": "一回払い",
  "payment_entry_page.trial_subscription_terms_info": "トライアル期間が終了すると、{{renewalDate}}から{{price}} {{perFrequency}}が課金されます。この日より前にいつでもキャンセルできます。",
  "payment_entry_page.subscription_info": "サブスクリプションは自動的に更新されます。いつでもキャンセルできます。",
  "payment_entry_page.otp_terms_info": "購入することにより、{{appName}}が利用規約に基づいて料金を請求することに同意したことになります。",
  "payment_entry_page.terms_link_label": "利用規約",
  "payment_entry_page.subscription_terms_info": "サブスクリプションに登録すると、キャンセルするまで{{appName}}が利用規約に従って課金することを許可することに同意したことになります。",
  "loading_page.keep_page_open": "プロセスはほぼ完了です。このページを開いたままにしてください。",
  "loading_page.processing_payment": "お支払い手続き中",
  "pricing_table.discount": "割引",
  "pricing_table.subtotal": "小計"
}, Eg = {
  "periods.week": "{{amount}}주",
  "periods.month": "{{amount}}개월",
  "periods.year": "{{amount}}년",
  "periods.day": "{{amount}}일",
  "periods.weekShort": "{{amount}}주",
  "periods.monthShort": "{{amount}}개월",
  "periods.yearShort": "{{amount}}년",
  "periods.dayShort": "{{amount}}일",
  "periods.lifetime": "평생",
  "periods.weekPlural": "{{amount}}주",
  "periods.monthPlural": "{{amount}}개월",
  "periods.yearPlural": "{{amount}}년",
  "periods.dayPlural": "{{amount}}일",
  "periods.weekFrequency": "매주",
  "periods.monthFrequency": "매달",
  "periods.yearFrequency": "매년",
  "periods.dayFrequency": "매일",
  "periods.perWeekFrequency": "주당",
  "periods.perMonthFrequency": "월별",
  "periods.perYearFrequency": "연간",
  "periods.perDayFrequency": "매일",
  "periods.unknownFrequency": "알 수 없음",
  "periods.weekFrequencyPlural": "{{amount}}주마다",
  "periods.monthFrequencyPlural": "{{amount}}개월마다",
  "periods.yearFrequencyPlural": "{{amount}}년마다",
  "periods.dayFrequencyPlural": "{{amount}}일마다",
  "product_info.product_title": "{{productTitle}}",
  "product_info.product_description": "{{productDescription}}",
  "product_info.product_price": "{{productPrice}}",
  "product_info.free_trial_duration": "{{trialDuration}}일 무료 체험",
  "product_info.price_after_free_trial": "체험 종료 후, {{renewalDate}}에",
  "product_info.renewal_frequency": "{{frequency}}마다 갱신",
  "product_info.continues_until_cancelled": "취소될 때까지 계속됩니다.",
  "product_info.cancel_anytime": "언제든지 취소 가능",
  "payment_entry_page.payment_step_title": "RevenueCat을 통한 안전한 결제",
  "payment_entry_page.button_pay": "지금 결제",
  "payment_entry_page.button_start_trial": "체험 시작",
  "success_page.purchase_successful": "결제가 완료되었습니다.",
  "success_page.button_close": "계속",
  "error_page.if_error_persists": "오류가 지속되면 다음으로 문의하십시오.",
  "error_page.error_title_already_subscribed": "이미 {{productTitle}}을 구독하셨습니다",
  "error_page.error_title_already_purchased": "이미 {{productTitle}}을 구매하셨습니다",
  "error_page.error_title_other_errors": "문제가 발생했습니다.",
  "error_page.error_message_already_subscribed": "이 제품을 다시 구독할 수 없습니다.",
  "error_page.error_message_already_purchased": "이 제품을 다시 구매할 수 없습니다.",
  "error_page.error_message_missing_email_error": "구매를 완료하려면 이메일이 필요합니다.",
  "error_page.error_message_network_error": "네트워크 오류입니다. 인터넷 연결을 확인하십시오.",
  "error_page.error_message_error_charging_payment": "결제에 실패했습니다.",
  "error_page.error_message_error_setting_up_purchase": "오류로 인해 구매가 시작되지 않았습니다(오류 코드: {{errorCode}}).",
  "error_page.error_message_invalid_tax_location": "청구 주소를 확인할 수 없습니다. 우편번호와 국가가 정확한지 다시 한번 확인해 주세요.",
  "error_page.error_message_unknown_error": "알 수 없는 오류가 발생했습니다(오류 코드: {{errorCode}}).",
  "error_page.button_try_again": "다시 시도",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}%",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "product_info.total_due_today": "오늘 총 결제 금액",
  "product_info.subscribe_to": "구독하기",
  "navbar_header.details": "세부 정보",
  "navbar_header.back_button": "뒤로",
  "pricing_dropdown.show_details": "세부 정보 표시",
  "pricing_dropdown.hide_details": "세부 정보 숨기기",
  "pricing_table.tax": "세금",
  "pricing_table.trial_ends": "체험판 종료 후, {{formattedTrialEndDate}}",
  "pricing_table.total_due_today": "오늘 지불해야 할 총액",
  "pricing_table.total_excluding_tax": "세금 제외 총액",
  "pricing_table.enter_billing_address_to_calculate": "계산을 위해 청구지 주소를 입력하세요",
  "pricing_table.enter_state_or_postal_code_to_calculate": "주 또는 우편 번호를 입력하여 계산",
  "pricing_table.enter_postal_code_to_calculate": "우편 번호를 입력하여 계산",
  "error_page.error_message_invalid_email_error": "이메일 주소 {{email}}을(를) 확인할 수 없습니다. 유효한 이메일 주소를 제공해 주세요.",
  "payment_entry_page.button_payment_method": "{{paymentMethod}}으로 {{formattedPrice}} 결제",
  "payment_entry_page.button_with_price": "{{formattedPrice}} 결제",
  "price_update.title": "가격 업데이트",
  "price_update.base_message": "청구지 주소를 기준으로 세금이 포함된 총 가격이 업데이트되었습니다. 다시 확인하고 시도해 주세요. 카드는 한 번만 청구됩니다.",
  "price_update.trial_message": "청구 주소에 따라 세금이 포함된 구독 가격이 업데이트되었습니다. 무료 체험은 계속 적용됩니다. 확인하고 다시 시도해 주세요.",
  "payment_entry_page.express_checkout_divider": "또는 카드 결제",
  "error_page.trouble_accessing": "구매에 문제가 있는 경우 다음 주소로 지원팀에 문의하세요. ",
  "error_page.close_button_title": "{{appName}}으로 이동",
  "error_page.error_title_stripe_missing_required_permission": "필수 Stripe 권한 누락",
  "error_page.button_close": "닫기",
  "error_page.error_message_stripe_invalid_tax_origin_address": "세금 원산지 주소가 잘못되어 구매에 실패했습니다. 프로덕션 환경에서는 세금이 적용되지 않은 상태로 구매가 진행됩니다.",
  "error_page.error_message_stripe_tax_not_active": "Stripe Tax가 활성화되지 않아 구매에 실패했습니다. 프로덕션 환경에서는 세금이 적용되지 않은 상태로 구매가 진행됩니다.",
  "error_page.error_only_in_sandbox": "이 메시지는 샌드박스에서만 표시됩니다.",
  "error_page.error_message_stripe_missing_required_permission": "Stripe 앱에 필요한 권한이 없어 구매에 실패했습니다. 프로덕션 환경에서는 세금이 적용되지 않은 상태로 구매가 진행됩니다.",
  "error_page.error_title_stripe_tax_not_active": "Stripe Tax가 활성화되지 않음",
  "error_page.error_title_stripe_invalid_tax_origin_address": "잘못된 세금 원산지 주소",
  "apple_pay.free_trial": "무료 체험",
  "product_info.price_after_intro_price": "{{introPriceDuration}} 후 {{renewalDate}}에",
  "product_info.after_trial": "체험 후",
  "product_info.after": "후",
  "product_info.intro_price_phase_after_trial": "다음 {{introPriceDuration}} 동안 {{introPrice}}",
  "product_info.intro_price_phase": "처음 {{introPriceDuration}} 동안 {{introPrice}}",
  "product_info.intro_price_phase_paid_once": "1회 결제",
  "payment_entry_page.trial_subscription_terms_info": "체험 기간이 종료되면 {{renewalDate}}부터 {{price}} {{perFrequency}}가 청구됩니다. 이 날짜 전에는 언제든지 취소할 수 있습니다.",
  "payment_entry_page.subscription_info": "구독은 자동으로 갱신됩니다. 언제든지 취소할 수 있습니다.",
  "payment_entry_page.otp_terms_info": "구매하시면 {{appName}}의 약관에 따라 요금이 청구되는 것에 동의하는 것입니다.",
  "payment_entry_page.terms_link_label": "약관",
  "payment_entry_page.subscription_terms_info": "구독하면 취소할 때까지 {{appName}}이 약관에 따라 요금을 청구하는 데 동의하는 것입니다.",
  "loading_page.keep_page_open": "거의 완료되었습니다. 이 페이지를 계속 열어 두세요.",
  "loading_page.processing_payment": "결제 처리 중",
  "pricing_table.discount": "할인",
  "pricing_table.subtotal": "소계"
}, Sg = {
  "periods.week": "{{amount}} minggu",
  "periods.month": "{{amount}} bulan",
  "periods.year": "{{amount}} tahun",
  "periods.day": "{{amount}} hari",
  "periods.weekShort": "{{amount}}mg",
  "periods.monthShort": "{{amount}}bl",
  "periods.yearShort": "{{amount}}th",
  "periods.dayShort": "{{amount}}h",
  "periods.lifetime": "seumur hidup",
  "periods.weekPlural": "{{amount}} minggu",
  "periods.monthPlural": "{{amount}} bulan",
  "periods.yearPlural": "{{amount}} tahun",
  "periods.dayPlural": "{{amount}} hari",
  "periods.weekFrequency": "mingguan",
  "periods.monthFrequency": "bulanan",
  "periods.yearFrequency": "tahunan",
  "periods.dayFrequency": "harian",
  "periods.perWeekFrequency": "setiap minggu",
  "periods.perMonthFrequency": "setiap bulan",
  "periods.perYearFrequency": "setiap tahun",
  "periods.perDayFrequency": "setiap hari",
  "periods.unknownFrequency": "tidak diketahui",
  "periods.weekFrequencyPlural": "setiap {{amount}} minggu",
  "periods.monthFrequencyPlural": "setiap {{amount}} bulan",
  "periods.yearFrequencyPlural": "setiap {{amount}} tahun",
  "periods.dayFrequencyPlural": "setiap {{amount}} hari",
  "product_info.product_title": "{{productTitle}}",
  "product_info.product_description": "{{productDescription}}",
  "product_info.product_price": "{{productPrice}}",
  "product_info.free_trial_duration": "{{trialDuration}} percubaan percuma",
  "product_info.price_after_free_trial": "Selepas tamat percubaan, pada {{renewalDate}}",
  "product_info.renewal_frequency": "Diperbaharui {{frequency}}",
  "product_info.continues_until_cancelled": "Berterusan sehingga dibatalkan",
  "product_info.cancel_anytime": "Batal bila-bila masa",
  "payment_entry_page.payment_step_title": "Pembayaran selamat oleh RevenueCat",
  "payment_entry_page.button_pay": "Bayar sekarang",
  "payment_entry_page.button_start_trial": "Mula Percubaan",
  "success_page.purchase_successful": "Pembayaran selesai",
  "success_page.button_close": "Teruskan",
  "error_page.if_error_persists": "Jika ralat berterusan, sila hubungi ",
  "error_page.error_title_already_subscribed": "Anda sudah melanggan {{productTitle}}",
  "error_page.error_title_already_purchased": "Anda sudah membeli {{productTitle}}",
  "error_page.error_title_other_errors": "Ada sesuatu yang tidak kena",
  "error_page.error_message_already_subscribed": "Anda tidak boleh melanggan produk ini lagi.",
  "error_page.error_message_already_purchased": "Anda tidak boleh membeli produk ini lagi.",
  "error_page.error_message_missing_email_error": "Emel diperlukan untuk menyelesaikan pembelian.",
  "error_page.error_message_network_error": "Ralat rangkaian. Sila semak sambungan internet anda.",
  "error_page.error_message_error_charging_payment": "Pembayaran gagal.",
  "error_page.error_message_error_setting_up_purchase": "Pembelian tidak dimulakan disebabkan ralat (kod ralat: {{errorCode}}).",
  "error_page.error_message_invalid_tax_location": "Kami tidak dapat mengesahkan alamat bil anda. Sila semak sama ada poskod dan negara adalah betul.",
  "error_page.error_message_unknown_error": "Ralat yang tidak diketahui telah berlaku (kod ralat: {{errorCode}}).",
  "error_page.button_try_again": "Cuba lagi",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}%",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "product_info.total_due_today": "Jumlah yang perlu dibayar hari ini",
  "product_info.subscribe_to": "Langgan",
  "navbar_header.details": "Butiran",
  "navbar_header.back_button": "Kembali",
  "pricing_dropdown.show_details": "Tunjukkan butiran",
  "pricing_dropdown.hide_details": "Sembunyikan butiran",
  "pricing_table.tax": "Cukai",
  "pricing_table.trial_ends": "Selepas tempoh percubaan tamat, pada {{formattedTrialEndDate}}",
  "pricing_table.total_due_today": "Jumlah yang perlu dibayar hari ini",
  "pricing_table.total_excluding_tax": "Jumlah tidak termasuk cukai",
  "pricing_table.enter_billing_address_to_calculate": "Masukkan alamat pengebilan untuk mengira",
  "pricing_table.enter_state_or_postal_code_to_calculate": "Masukkan negeri atau poskod untuk mengira",
  "pricing_table.enter_postal_code_to_calculate": "Masukkan poskod untuk mengira",
  "error_page.error_message_invalid_email_error": "Alamat e-mel {{email}} tidak dapat disahkan. Sila berikan alamat e-mel yang sah.",
  "payment_entry_page.button_payment_method": "Bayar {{formattedPrice}} dengan {{paymentMethod}}",
  "payment_entry_page.button_with_price": "Bayar {{formattedPrice}}",
  "price_update.title": "Kemaskini harga",
  "price_update.base_message": "Jumlah harga telah dikemas kini dengan cukai berdasarkan alamat pengebilan anda. Sila semak dan cuba lagi. Kad anda hanya akan dicaj sekali.",
  "price_update.trial_message": "Harga langganan telah dikemas kini untuk memasukkan cukai berdasarkan alamat bil anda. Tempoh percubaan percuma masih terpakai. Sila semak dan cuba lagi.",
  "payment_entry_page.express_checkout_divider": "ATAU BAYAR DENGAN KAD",
  "error_page.trouble_accessing": "Jika anda menghadapi masalah untuk mengakses pembelian anda, hubungi sokongan di ",
  "error_page.close_button_title": "Pergi ke {{appName}}",
  "error_page.error_title_stripe_missing_required_permission": "Kebenaran Stripe hilang",
  "error_page.button_close": "Tutup",
  "error_page.error_message_stripe_invalid_tax_origin_address": "Pembelian gagal kerana alamat asal cukai tidak sah. Dalam pengeluaran, pembelian akan berfungsi tanpa cukai dikenakan.",
  "error_page.error_message_stripe_tax_not_active": "Pembelian gagal kerana Cukai Stripe tidak didayakan. Dalam pengeluaran, pembelian akan berfungsi tanpa cukai dikenakan.",
  "error_page.error_only_in_sandbox": "Mesej ini hanya muncul dalam kotak pasir.",
  "error_page.error_message_stripe_missing_required_permission": "Pembelian gagal kerana aplikasi Stripe kekurangan kebenaran yang diperlukan. Dalam pengeluaran, pembelian akan berfungsi tanpa cukai dikenakan.",
  "error_page.error_title_stripe_tax_not_active": "Cukai Stripe tidak aktif",
  "error_page.error_title_stripe_invalid_tax_origin_address": "Alamat asal cukai Stripe tidak sah",
  "apple_pay.free_trial": "Percubaan Percuma",
  "product_info.price_after_intro_price": "Selepas {{introPriceDuration}}, pada {{renewalDate}}",
  "product_info.after_trial": "selepas percubaan",
  "product_info.after": "selepas",
  "product_info.intro_price_phase_after_trial": "Kemudian {{introPriceDuration}} untuk {{introPrice}}",
  "product_info.intro_price_phase": "Pertama {{introPriceDuration}} untuk {{introPrice}}",
  "product_info.intro_price_phase_paid_once": "dibayar sekali",
  "payment_entry_page.trial_subscription_terms_info": "Selepas tempoh percubaan anda tamat, anda akan dikenakan bayaran sebanyak {{price}} {{perFrequency}} bermula {{renewalDate}}. Anda boleh membatalkan pada bila-bila masa sebelum tarikh ini.",
  "payment_entry_page.subscription_info": "Langganan diperbaharui secara automatik. Batalkan bila-bila masa.",
  "payment_entry_page.otp_terms_info": "Dengan membuat pembelian, anda bersetuju untuk membenarkan {{appName}} mengenakan bayaran kepada anda mengikut terma mereka.",
  "payment_entry_page.terms_link_label": "Terma",
  "payment_entry_page.subscription_terms_info": "Dengan melanggan, anda bersetuju untuk membenarkan {{appName}} mengenakan bayaran kepada anda mengikut terma mereka sehingga anda membatalkan.",
  "loading_page.keep_page_open": "Proses hampir selesai. Pastikan halaman ini dibuka.",
  "loading_page.processing_payment": "Memproses pembayaran",
  "pricing_table.discount": "Diskaun",
  "pricing_table.subtotal": "Subtotal"
}, Tg = {
  "periods.week": "{{amount}} uke",
  "periods.month": "{{amount}} måned",
  "periods.year": "{{amount}} år",
  "periods.day": "{{amount}} dag",
  "periods.weekShort": "{{amount}}uk",
  "periods.monthShort": "{{amount}}md",
  "periods.yearShort": "{{amount}}år",
  "periods.dayShort": "{{amount}}d",
  "periods.lifetime": "livstid",
  "periods.weekPlural": "{{amount}} uker",
  "periods.monthPlural": "{{amount}} måneder",
  "periods.yearPlural": "{{amount}} år",
  "periods.dayPlural": "{{amount}} dager",
  "periods.weekFrequency": "ukentlig",
  "periods.monthFrequency": "månedlig",
  "periods.yearFrequency": "årlig",
  "periods.dayFrequency": "daglig",
  "periods.perWeekFrequency": "per uke",
  "periods.perMonthFrequency": "per måned",
  "periods.perYearFrequency": "per år",
  "periods.perDayFrequency": "per dag",
  "periods.unknownFrequency": "ukjent",
  "periods.weekFrequencyPlural": "hver {{amount}} uker",
  "periods.monthFrequencyPlural": "hver {{amount}} måneder",
  "periods.yearFrequencyPlural": "hver {{amount}} år",
  "periods.dayFrequencyPlural": "hver {{amount}} dager",
  "product_info.product_title": "{{productTitle}}",
  "product_info.product_description": "{{productDescription}}",
  "product_info.product_price": "{{productPrice}}",
  "product_info.free_trial_duration": "{{trialDuration}} gratis prøveperiode",
  "product_info.price_after_free_trial": "Etter prøveperioden slutter, den {{renewalDate}}",
  "product_info.renewal_frequency": "Fornyes {{frequency}}",
  "product_info.continues_until_cancelled": "Varer til den avbestilles",
  "product_info.cancel_anytime": "Avbestille når som helst",
  "payment_entry_page.payment_step_title": "Sikker betaling via RevenueCat",
  "payment_entry_page.button_pay": "Betal nå",
  "payment_entry_page.button_start_trial": "Start prøveperiode",
  "success_page.purchase_successful": "Betalingen er fullført",
  "success_page.button_close": "Fortsett",
  "error_page.if_error_persists": "Hvis feilen vedvarer, vennligst kontakt ",
  "error_page.error_title_already_subscribed": "Du abonnerer allerede på {{productTitle}}",
  "error_page.error_title_already_purchased": "Du har allerede kjøpt {{productTitle}}",
  "error_page.error_title_other_errors": "Noe gikk galt",
  "error_page.error_message_already_subscribed": "Du kan ikke abonnere på dette produktet igjen.",
  "error_page.error_message_already_purchased": "Du kan ikke kjøpe dette produktet igjen.",
  "error_page.error_message_missing_email_error": "E-post er nødvendig for å fullføre kjøpet.",
  "error_page.error_message_network_error": "Nettverksfeil. Vennligst sjekk internettforbindelsen din.",
  "error_page.error_message_error_charging_payment": "Betalingen mislyktes.",
  "error_page.error_message_error_setting_up_purchase": "Kjøpet ble ikke startet på grunn av en feil (feilkode: {{errorCode}}).",
  "error_page.error_message_invalid_tax_location": "Vi kunne ikke bekrefte faktureringsadressen din. Vennligst sjekk at postnummeret og landet er korrekte.",
  "error_page.error_message_unknown_error": "En ukjent feil oppstod (feilkode: {{errorCode}}).",
  "error_page.button_try_again": "Prøv igjen",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}%",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}} ({{formattedPricePerMonth}}/{{monthPeriod}})",
  "product_info.total_due_today": "Totalt forfaller i dag",
  "product_info.subscribe_to": "Abonner på",
  "navbar_header.details": "Detaljer",
  "navbar_header.back_button": "Tilbake",
  "pricing_dropdown.show_details": "Vis detaljer",
  "pricing_dropdown.hide_details": "Skjul detaljer",
  "pricing_table.tax": "Skatt",
  "pricing_table.trial_ends": "Etter prøveperioden slutter, den {{formattedTrialEndDate}}",
  "pricing_table.total_due_today": "Totalt forfaller i dag",
  "pricing_table.total_excluding_tax": "Total eksklusive skatt",
  "pricing_table.enter_billing_address_to_calculate": "Oppgi faktureringsadresse for å beregne",
  "pricing_table.enter_state_or_postal_code_to_calculate": "Skriv inn stat eller postnummer for å beregne",
  "pricing_table.enter_postal_code_to_calculate": "Skriv inn postnummer for å beregne",
  "error_page.error_message_invalid_email_error": "E-postadressen {{email}} kunne ikke bekreftes. Vennligst oppgi en gyldig e-postadresse.",
  "payment_entry_page.button_payment_method": "Betal {{formattedPrice}} med {{paymentMethod}}",
  "payment_entry_page.button_with_price": "Betal {{formattedPrice}}",
  "price_update.title": "Prisoppdatering",
  "price_update.base_message": "Totalprisen er oppdatert med skatt basert på fakturaadressen din. Vennligst se gjennom og prøv igjen. Kortet ditt vil kun bli belastet én gang.",
  "price_update.trial_message": "Abonnementsprisen er oppdatert for å inkludere skatter basert på din fakturaadresse. Den gratis prøveperioden gjelder fortsatt. Vennligst sjekk og prøv igjen.",
  "payment_entry_page.express_checkout_divider": "ELLER BETAL MED KORT",
  "error_page.trouble_accessing": "Hvis du har problemer med å få tilgang til kjøpet ditt, kan du kontakte support på ",
  "error_page.close_button_title": "Gå til {{appName}}",
  "error_page.error_title_stripe_missing_required_permission": "Mangler Stripe-tillatelse",
  "error_page.button_close": "Lukk",
  "error_page.error_message_stripe_invalid_tax_origin_address": "Kjøpet mislyktes fordi skatteopprinnelsesadressen er ugyldig. I produksjon vil kjøp fungere uten at skatter brukes.",
  "error_page.error_message_stripe_tax_not_active": "Kjøpet mislyktes fordi Stripe Tax ikke er aktivert. I produksjon vil kjøp fungere uten at skatter brukes.",
  "error_page.error_only_in_sandbox": "Denne meldingen vises bare i sandkassen.",
  "error_page.error_message_stripe_missing_required_permission": "Kjøpet mislyktes fordi Stripe-appen mangler en nødvendig tillatelse. I produksjon vil kjøp fungere uten at skatter brukes.",
  "error_page.error_title_stripe_tax_not_active": "Stripe Tax er ikke aktivt",
  "error_page.error_title_stripe_invalid_tax_origin_address": "Ugyldig skatteopprinnelsesadresse",
  "apple_pay.free_trial": "Gratis prøveperiode",
  "product_info.price_after_intro_price": "Etter {{introPriceDuration}}, den {{renewalDate}}",
  "product_info.after_trial": "etter prøveperiode",
  "product_info.after": "etter",
  "product_info.intro_price_phase_after_trial": "Deretter {{introPriceDuration}} for {{introPrice}}",
  "product_info.intro_price_phase": "Først {{introPriceDuration}} for {{introPrice}}",
  "product_info.intro_price_phase_paid_once": "betales én gang",
  "payment_entry_page.trial_subscription_terms_info": "Etter at prøveperioden din er over, blir du belastet {{price}} {{perFrequency}} fra og med {{renewalDate}}. Du kan kansellere når som helst før denne datoen.",
  "payment_entry_page.subscription_info": "Abonnementet fornyes automatisk. Avbryt når som helst.",
  "payment_entry_page.otp_terms_info": "Ved å kjøpe godtar du at {{appName}} belaster deg i henhold til deres vilkår.",
  "payment_entry_page.terms_link_label": "Vilkår",
  "payment_entry_page.subscription_terms_info": "Ved å abonnere godtar du at {{appName}} belaster deg i henhold til deres vilkår til du kansellerer.",
  "loading_page.keep_page_open": "Prosessen er nesten ferdig. Hold denne siden åpen.",
  "loading_page.processing_payment": "Behandler betaling",
  "pricing_table.discount": "Rabatt",
  "pricing_table.subtotal": "Subtotal"
}, Ig = {
  "periods.week": "{{amount}} tydzień",
  "periods.month": "{{amount}} miesiąc",
  "periods.year": "{{amount}} rok",
  "periods.day": "{{amount}} dzień",
  "periods.weekShort": "{{amount}}tydz",
  "periods.monthShort": "{{amount}}mies",
  "periods.yearShort": "{{amount}}rok",
  "periods.dayShort": "{{amount}}d",
  "periods.lifetime": "dożywotnio",
  "periods.weekPlural": "{{amount}} tygodni",
  "periods.monthPlural": "{{amount}} miesięcy",
  "periods.yearPlural": "{{amount}} lat",
  "periods.dayPlural": "{{amount}} dni",
  "periods.weekFrequency": "tygodniowo",
  "periods.monthFrequency": "miesięcznie",
  "periods.yearFrequency": "rocznie",
  "periods.dayFrequency": "dziennie",
  "periods.perWeekFrequency": "na tydzień",
  "periods.perMonthFrequency": "na miesiąc",
  "periods.perYearFrequency": "na rok",
  "periods.perDayFrequency": "na dzień",
  "periods.unknownFrequency": "nieznany",
  "periods.weekFrequencyPlural": "co {{amount}} tygodni",
  "periods.monthFrequencyPlural": "co {{amount}} miesięcy",
  "periods.yearFrequencyPlural": "co {{amount}} lat",
  "periods.dayFrequencyPlural": "co {{amount}} dni",
  "product_info.product_title": "{{productTitle}}",
  "product_info.product_description": "{{productDescription}}",
  "product_info.product_price": "{{productPrice}}",
  "product_info.free_trial_duration": "{{trialDuration}} dni próbnych",
  "product_info.price_after_free_trial": "Po zakończeniu okresu próbnego, dnia {{renewalDate}}",
  "product_info.renewal_frequency": "Odnawialny co {{frequency}}",
  "product_info.continues_until_cancelled": "Kontynuowane do momentu anulowania",
  "product_info.cancel_anytime": "Możesz anulować w dowolnym momencie",
  "payment_entry_page.payment_step_title": "Bezpieczna płatność przez RevenueCat",
  "payment_entry_page.button_pay": "Zapłać teraz",
  "payment_entry_page.button_start_trial": "Rozpocznij okres próbny",
  "success_page.purchase_successful": "Płatność zakończona",
  "success_page.button_close": "Kontynuuj",
  "error_page.if_error_persists": "Jeśli błąd będzie się powtarzał, skontaktuj się z ",
  "error_page.error_title_already_subscribed": "Już subskrybujesz {{productTitle}}",
  "error_page.error_title_already_purchased": "Już zakupiłeś/aś {{productTitle}}",
  "error_page.error_title_other_errors": "Coś poszło nie tak",
  "error_page.error_message_already_subscribed": "Nie możesz ponownie subskrybować tego produktu.",
  "error_page.error_message_already_purchased": "Nie możesz ponownie zakupić tego produktu.",
  "error_page.error_message_missing_email_error": "Adres e-mail jest wymagany do dokonania zakupu.",
  "error_page.error_message_network_error": "Błąd sieci. Sprawdź połączenie internetowe.",
  "error_page.error_message_error_charging_payment": "Płatność nieudana.",
  "error_page.error_message_error_setting_up_purchase": "Zakup nie został rozpoczęty z powodu błędu (kod błędu: {{errorCode}}).",
  "error_page.error_message_invalid_tax_location": "Nie mogliśmy zweryfikować Twojego adresu rozliczeniowego. Sprawdź, czy kod pocztowy i kraj są poprawne.",
  "error_page.error_message_unknown_error": "Wystąpił nieznany błąd (kod błędu: {{errorCode}}).",
  "error_page.button_try_again": "Spróbuj ponownie",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}%",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "product_info.total_due_today": "Do zapłaty dzisiaj",
  "product_info.subscribe_to": "Subskrybuj",
  "navbar_header.details": "Szczegóły",
  "navbar_header.back_button": "Wstecz",
  "pricing_dropdown.show_details": "Pokaż szczegóły",
  "pricing_dropdown.hide_details": "Ukryj szczegóły",
  "pricing_table.tax": "Podatek",
  "pricing_table.trial_ends": "Po zakończeniu okresu próbnego, {{formattedTrialEndDate}}",
  "pricing_table.total_due_today": "Suma należna dzisiaj",
  "pricing_table.total_excluding_tax": "Suma bez podatku",
  "pricing_table.enter_billing_address_to_calculate": "Wprowadź adres rozliczeniowy, aby obliczyć",
  "pricing_table.enter_state_or_postal_code_to_calculate": "Wprowadź stan lub kod pocztowy, aby obliczyć",
  "pricing_table.enter_postal_code_to_calculate": "Wprowadź kod pocztowy, aby obliczyć",
  "error_page.error_message_invalid_email_error": "Nie można zweryfikować adresu e-mail {{email}}. Proszę podać prawidłowy adres e-mail.",
  "payment_entry_page.button_payment_method": "Zapłać {{formattedPrice}} przez {{paymentMethod}}",
  "payment_entry_page.button_with_price": "Zapłać {{formattedPrice}}",
  "price_update.title": "Aktualizacja ceny",
  "price_update.base_message": "Cena całkowita została zaktualizowana o podatek na podstawie Twojego adresu rozliczeniowego. Sprawdź i spróbuj ponownie. Twoja karta zostanie obciążona tylko raz.",
  "price_update.trial_message": "Cena subskrypcji została zaktualizowana o podatki na podstawie Twojego adresu rozliczeniowego. Okres próbny nadal obowiązuje. Sprawdź i spróbuj ponownie.",
  "payment_entry_page.express_checkout_divider": "LUB ZAPŁAĆ KARTĄ",
  "error_page.trouble_accessing": "Jeśli masz problemy z dostępem do zakupu, skontaktuj się z działem pomocy pod adresem ",
  "error_page.close_button_title": "Przejdź do {{appName}}",
  "error_page.error_title_stripe_missing_required_permission": "Brakujące uprawnienie Stripe",
  "error_page.button_close": "Zamknij",
  "error_page.error_message_stripe_invalid_tax_origin_address": "Zakup nie powiódł się, ponieważ adres pochodzenia podatku jest nieprawidłowy. W środowisku produkcyjnym zakupy będą działać bez naliczania podatków.",
  "error_page.error_message_stripe_tax_not_active": "Zakup nie powiódł się, ponieważ Stripe Tax nie jest włączony. W środowisku produkcyjnym zakupy będą działać bez naliczania podatków.",
  "error_page.error_only_in_sandbox": "Ta wiadomość pojawia się tylko w środowisku testowym.",
  "error_page.error_message_stripe_missing_required_permission": "Zakup nie powiódł się, ponieważ aplikacja Stripe nie ma wymaganego uprawnienia. W środowisku produkcyjnym zakupy będą działać bez naliczania podatków.",
  "error_page.error_title_stripe_tax_not_active": "Stripe Tax nieaktywny",
  "error_page.error_title_stripe_invalid_tax_origin_address": "Nieprawidłowy adres pochodzenia podatku",
  "apple_pay.free_trial": "Okres próbny",
  "product_info.price_after_intro_price": "Po {{introPriceDuration}}, od {{renewalDate}}",
  "product_info.after_trial": "po okresie próbnym",
  "product_info.after": "po",
  "product_info.intro_price_phase_after_trial": "Następnie {{introPriceDuration}} za {{introPrice}}",
  "product_info.intro_price_phase": "Najpierw {{introPriceDuration}} za {{introPrice}}",
  "product_info.intro_price_phase_paid_once": "płatne jednorazowo",
  "payment_entry_page.trial_subscription_terms_info": "Po zakończeniu okresu próbnego zostanie pobrana opłata w wysokości {{price}} {{perFrequency}} począwszy od {{renewalDate}}. Możesz anulować subskrypcję w dowolnym momencie przed tą datą.",
  "payment_entry_page.subscription_info": "Subskrypcja odnawia się automatycznie. Anuluj w dowolnym momencie.",
  "payment_entry_page.otp_terms_info": "Dokonując zakupu, zgadzasz się na obciążenie przez {{appName}} zgodnie z ich warunkami.",
  "payment_entry_page.terms_link_label": "Warunki",
  "payment_entry_page.subscription_terms_info": "Subskrybując, zgadzasz się na obciążanie przez {{appName}} zgodnie z ich warunkami do momentu anulowania.",
  "loading_page.keep_page_open": "Proces jest prawie zakończony. Pozostaw tę stronę otwartą.",
  "loading_page.processing_payment": "Przetwarzanie płatności",
  "pricing_table.discount": "Rabat",
  "pricing_table.subtotal": "Suma częściowa"
}, Dg = {
  "periods.week": "{{amount}} semana",
  "periods.month": "{{amount}} mês",
  "periods.year": "{{amount}} ano",
  "periods.day": "{{amount}} dia",
  "periods.weekShort": "{{amount}}sem",
  "periods.monthShort": "{{amount}}mês",
  "periods.yearShort": "{{amount}}ano",
  "periods.dayShort": "{{amount}}d",
  "periods.lifetime": "vitalício",
  "periods.weekPlural": "{{amount}} semanas",
  "periods.monthPlural": "{{amount}} meses",
  "periods.yearPlural": "{{amount}} anos",
  "periods.dayPlural": "{{amount}} dias",
  "periods.weekFrequency": "semanal",
  "periods.monthFrequency": "mensal",
  "periods.yearFrequency": "anual",
  "periods.dayFrequency": "diário",
  "periods.perWeekFrequency": "por semana",
  "periods.perMonthFrequency": "por mês",
  "periods.perYearFrequency": "por ano",
  "periods.perDayFrequency": "por dia",
  "periods.unknownFrequency": "desconhecido",
  "periods.weekFrequencyPlural": "a cada {{amount}} semanas",
  "periods.monthFrequencyPlural": "a cada {{amount}} meses",
  "periods.yearFrequencyPlural": "a cada {{amount}} anos",
  "periods.dayFrequencyPlural": "a cada {{amount}} dias",
  "product_info.product_title": "{{productTitle}}",
  "product_info.product_description": "{{productDescription}}",
  "product_info.product_price": "{{productPrice}}",
  "product_info.free_trial_duration": "{{trialDuration}} teste grátis",
  "product_info.price_after_free_trial": "Após o término do teste, em {{renewalDate}}",
  "product_info.renewal_frequency": "Renova {{frequency}}",
  "product_info.continues_until_cancelled": "Continua até ser cancelado",
  "product_info.cancel_anytime": "Cancelar a qualquer momento",
  "payment_entry_page.payment_step_title": "Pagamento seguro pela RevenueCat",
  "payment_entry_page.button_pay": "Pagar agora",
  "payment_entry_page.button_start_trial": "Iniciar Teste",
  "success_page.purchase_successful": "Pagamento concluído",
  "success_page.button_close": "Continuar",
  "error_page.if_error_persists": "Se o erro persistir, entre em contato com ",
  "error_page.error_title_already_subscribed": "Você já se inscreveu em {{productTitle}}",
  "error_page.error_title_already_purchased": "Você já comprou {{productTitle}}",
  "error_page.error_title_other_errors": "Algo deu errado",
  "error_page.error_message_already_subscribed": "Você não pode se inscrever neste produto novamente.",
  "error_page.error_message_already_purchased": "Você não pode comprar este produto novamente.",
  "error_page.error_message_missing_email_error": "Email é necessário para concluir a compra.",
  "error_page.error_message_network_error": "Erro de rede. Verifique sua conexão com a internet.",
  "error_page.error_message_error_charging_payment": "Pagamento falhou.",
  "error_page.error_message_error_setting_up_purchase": "Compra não iniciada devido a um erro (código de erro: {{errorCode}}).",
  "error_page.error_message_invalid_tax_location": "Não conseguimos verificar seu endereço de cobrança. Por favor, verifique se o código postal e o país estão corretos.",
  "error_page.error_message_unknown_error": "Ocorreu um erro desconhecido (código de erro: {{errorCode}}).",
  "error_page.button_try_again": "Tentar novamente",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}%",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "product_info.total_due_today": "Total a pagar hoje",
  "product_info.subscribe_to": "Subscrever",
  "navbar_header.details": "Detalhes",
  "navbar_header.back_button": "Voltar",
  "pricing_dropdown.show_details": "Mostrar detalhes",
  "pricing_dropdown.hide_details": "Ocultar detalhes",
  "pricing_table.tax": "Imposto",
  "pricing_table.trial_ends": "Após o término do período de avaliação, em {{formattedTrialEndDate}}",
  "pricing_table.total_due_today": "Total a pagar hoje",
  "pricing_table.total_excluding_tax": "Total sem impostos",
  "pricing_table.enter_billing_address_to_calculate": "Insira o endereço de cobrança para calcular",
  "pricing_table.enter_state_or_postal_code_to_calculate": "Insira o estado ou o CEP para calcular",
  "pricing_table.enter_postal_code_to_calculate": "Insira o CEP para calcular",
  "error_page.error_message_invalid_email_error": "O endereço de e-mail {{email}} não pôde ser verificado. Por favor, forneça um endereço de e-mail válido.",
  "payment_entry_page.button_payment_method": "Pagar {{formattedPrice}} com {{paymentMethod}}",
  "payment_entry_page.button_with_price": "Pagar {{formattedPrice}}",
  "price_update.title": "Atualização de preço",
  "price_update.base_message": "O preço total foi atualizado com impostos com base no seu endereço de cobrança. Por favor, revise e tente novamente. Seu cartão só será cobrado uma vez.",
  "price_update.trial_message": "O preço da assinatura foi atualizado para incluir impostos com base no seu endereço de faturação. O período de teste gratuito continua válido. Por favor, verifique e tente novamente.",
  "payment_entry_page.express_checkout_divider": "OU PAGUE COM CARTÃO",
  "error_page.trouble_accessing": "Se estiver com problemas para acessar sua compra, entre em contato com o suporte em ",
  "error_page.close_button_title": "Ir para {{appName}}",
  "error_page.error_title_stripe_missing_required_permission": "Permissão do Stripe em falta",
  "error_page.button_close": "Fechar",
  "error_page.error_message_stripe_invalid_tax_origin_address": "A compra falhou porque o endereço de origem fiscal é inválido. Em produção, as compras funcionarão sem impostos aplicados.",
  "error_page.error_message_stripe_tax_not_active": "A compra falhou porque o Stripe Tax não está ativado. Em produção, as compras funcionarão sem impostos aplicados.",
  "error_page.error_only_in_sandbox": "Esta mensagem aparece apenas na sandbox.",
  "error_page.error_message_stripe_missing_required_permission": "A compra falhou porque o aplicativo Stripe não tem uma permissão necessária. Em produção, as compras funcionarão sem impostos aplicados.",
  "error_page.error_title_stripe_tax_not_active": "Stripe Tax não está ativo",
  "error_page.error_title_stripe_invalid_tax_origin_address": "Endereço de origem fiscal inválido",
  "apple_pay.free_trial": "Teste Gratuito",
  "product_info.price_after_intro_price": "Após {{introPriceDuration}}, em {{renewalDate}}",
  "product_info.after_trial": "após o período de teste",
  "product_info.after": "após",
  "product_info.intro_price_phase_after_trial": "Depois, {{introPriceDuration}} por {{introPrice}}",
  "product_info.intro_price_phase": "Primeiro, {{introPriceDuration}} por {{introPrice}}",
  "product_info.intro_price_phase_paid_once": "pago uma vez",
  "payment_entry_page.trial_subscription_terms_info": "Após o término do período de avaliação, será cobrado o valor de {{price}} {{perFrequency}} a partir de {{renewalDate}}. Pode cancelar a qualquer momento antes desta data.",
  "payment_entry_page.subscription_info": "A subscrição é renovada automaticamente. Cancele a qualquer momento.",
  "payment_entry_page.otp_terms_info": "Ao comprar, você concorda em permitir que o {{appName}} cobre de acordo com os termos deles.",
  "payment_entry_page.terms_link_label": "Termos",
  "payment_entry_page.subscription_terms_info": "Ao subscrever, concorda em permitir que a {{appName}} lhe cobre de acordo com os seus termos até cancelar.",
  "loading_page.keep_page_open": "O processo está quase concluído. Mantenha esta página aberta.",
  "loading_page.processing_payment": "Processando o pagamento",
  "pricing_table.discount": "Desconto",
  "pricing_table.subtotal": "Subtotal"
}, Cg = {
  "periods.week": "{{amount}} săptămână",
  "periods.month": "{{amount}} lună",
  "periods.year": "{{amount}} an",
  "periods.day": "{{amount}} zi",
  "periods.weekShort": "{{amount}}săpt",
  "periods.monthShort": "{{amount}}lun",
  "periods.yearShort": "{{amount}}an",
  "periods.dayShort": "{{amount}}z",
  "periods.lifetime": "pe viață",
  "periods.weekPlural": "{{amount}} săptămâni",
  "periods.monthPlural": "{{amount}} luni",
  "periods.yearPlural": "{{amount}} ani",
  "periods.dayPlural": "{{amount}} zile",
  "periods.weekFrequency": "săptămânal",
  "periods.monthFrequency": "lunar",
  "periods.yearFrequency": "anual",
  "periods.dayFrequency": "zilnic",
  "periods.perWeekFrequency": "pe săptămână",
  "periods.perMonthFrequency": "pe lună",
  "periods.perYearFrequency": "pe an",
  "periods.perDayFrequency": "pe zi",
  "periods.unknownFrequency": "necunoscut",
  "periods.weekFrequencyPlural": "la fiecare {{amount}} săptămâni",
  "periods.monthFrequencyPlural": "la fiecare {{amount}} luni",
  "periods.yearFrequencyPlural": "la fiecare {{amount}} ani",
  "periods.dayFrequencyPlural": "la fiecare {{amount}} zile",
  "product_info.product_title": "{{productTitle}}",
  "product_info.product_description": "{{productDescription}}",
  "product_info.product_price": "{{productPrice}}",
  "product_info.free_trial_duration": "{{trialDuration}} perioadă de probă gratuită",
  "product_info.price_after_free_trial": "După terminarea perioadei de probă, pe {{renewalDate}}",
  "product_info.renewal_frequency": "Se reînnoiește {{frequency}}",
  "product_info.continues_until_cancelled": "Continuă până la anulare",
  "product_info.cancel_anytime": "Anulare oricând",
  "payment_entry_page.payment_step_title": "Plata securizată prin RevenueCat",
  "payment_entry_page.button_pay": "Plătește acum",
  "payment_entry_page.button_start_trial": "Începe perioada de probă",
  "success_page.purchase_successful": "Plata efectuată",
  "success_page.button_close": "Continuă",
  "error_page.if_error_persists": "Dacă eroarea persistă, vă rugăm să contactați ",
  "error_page.error_title_already_subscribed": "Sunteți deja abonat la {{productTitle}}",
  "error_page.error_title_already_purchased": "Ați achiziționat deja {{productTitle}}",
  "error_page.error_title_other_errors": "A apărut o eroare",
  "error_page.error_message_already_subscribed": "Nu vă puteți abona din nou la acest produs.",
  "error_page.error_message_already_purchased": "Nu puteți achiziționa din nou acest produs.",
  "error_page.error_message_missing_email_error": "Adresa de e-mail este necesară pentru a finaliza achiziția.",
  "error_page.error_message_network_error": "Eroare de rețea. Verificați conexiunea la internet.",
  "error_page.error_message_error_charging_payment": "Plata a eșuat.",
  "error_page.error_message_error_setting_up_purchase": "Achiziția nu a putut fi inițiată din cauza unei erori (cod de eroare: {{errorCode}}).",
  "error_page.error_message_invalid_tax_location": "Nu am putut verifica adresa de facturare. Vă rugăm să verificați dacă codul poștal și țara sunt corecte.",
  "error_page.error_message_unknown_error": "A apărut o eroare necunoscută (cod de eroare: {{errorCode}}).",
  "error_page.button_try_again": "Încearcă din nou",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}%",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "product_info.total_due_today": "Total de plată astăzi",
  "product_info.subscribe_to": "Abonare la",
  "navbar_header.details": "Detalii",
  "navbar_header.back_button": "Înapoi",
  "pricing_dropdown.show_details": "Arată detalii",
  "pricing_dropdown.hide_details": "Ascunde detalii",
  "pricing_table.tax": "Taxă",
  "pricing_table.trial_ends": "După ce perioada de probă se termină, pe {{formattedTrialEndDate}}",
  "pricing_table.total_due_today": "Total de plătit astăzi",
  "pricing_table.total_excluding_tax": "Total fără taxe",
  "pricing_table.enter_billing_address_to_calculate": "Introduceți adresa de facturare pentru a calcula",
  "pricing_table.enter_state_or_postal_code_to_calculate": "Introduceți statul sau codul poștal pentru a calcula",
  "pricing_table.enter_postal_code_to_calculate": "Introduceți codul poștal pentru a calcula",
  "error_page.error_message_invalid_email_error": "Adresa de e-mail {{email}} nu a putut fi verificată. Vă rugăm să furnizați o adresă de e-mail validă.",
  "payment_entry_page.button_payment_method": "Plătește {{formattedPrice}} cu {{paymentMethod}}",
  "payment_entry_page.button_with_price": "Plătește {{formattedPrice}}",
  "price_update.title": "Actualizare preț",
  "price_update.base_message": "Prețul total a fost actualizat cu taxe, în funcție de adresa dumneavoastră de facturare. Vă rugăm să revizuiți și să încercați din nou. Cardul dumneavoastră va fi debitat o singură dată.",
  "price_update.trial_message": "Prețul abonamentului a fost actualizat pentru a include taxele bazate pe adresa dvs. de facturare. Perioada de probă gratuită rămâne valabilă. Vă rugăm să verificați și să încercați din nou.",
  "payment_entry_page.express_checkout_divider": "SAU PLĂTEȘTE CU CARDUL",
  "error_page.trouble_accessing": "Dacă întâmpini probleme în accesarea achiziției tale, contactează serviciul de asistență la ",
  "error_page.close_button_title": "Mergi la {{appName}}",
  "error_page.error_title_stripe_missing_required_permission": "Permisiune Stripe lipsă",
  "error_page.button_close": "Închide",
  "error_page.error_message_stripe_invalid_tax_origin_address": "Achiziția a eșuat deoarece adresa de origine fiscală este nevalidă. În producție, achizițiile vor funcționa fără taxe aplicate.",
  "error_page.error_message_stripe_tax_not_active": "Achiziția a eșuat deoarece Stripe Tax nu este activat. În producție, achizițiile vor funcționa fără taxe aplicate.",
  "error_page.error_only_in_sandbox": "Acest mesaj apare doar în sandbox.",
  "error_page.error_message_stripe_missing_required_permission": "Achiziția a eșuat deoarece aplicației Stripe îi lipsește o permisiune necesară. În producție, achizițiile vor funcționa fără taxe aplicate.",
  "error_page.error_title_stripe_tax_not_active": "Stripe Tax nu este activ",
  "error_page.error_title_stripe_invalid_tax_origin_address": "Adresă de origine fiscală Stripe nevalidă",
  "apple_pay.free_trial": "Perioadă de probă gratuită",
  "product_info.price_after_intro_price": "După {{introPriceDuration}}, pe {{renewalDate}}",
  "product_info.after_trial": "după perioada de probă",
  "product_info.after": "după",
  "product_info.intro_price_phase_after_trial": "Apoi {{introPriceDuration}} pentru {{introPrice}}",
  "product_info.intro_price_phase": "Mai întâi {{introPriceDuration}} pentru {{introPrice}}",
  "product_info.intro_price_phase_paid_once": "plătit o singură dată",
  "payment_entry_page.trial_subscription_terms_info": "După ce perioada de probă se termină, veți fi taxat cu {{price}} {{perFrequency}} începând cu {{renewalDate}}. Puteți anula oricând înainte de această dată.",
  "payment_entry_page.subscription_info": "Abonamentul se reînnoiește automat. Anulați oricând.",
  "payment_entry_page.otp_terms_info": "Prin achiziționarea, sunteți de acord să permiteți {{appName}} să vă taxeze conform termenilor săi.",
  "payment_entry_page.terms_link_label": "Termeni",
  "payment_entry_page.subscription_terms_info": "Prin abonare, sunteți de acord să permiteți {{appName}} să vă taxeze conform termenilor săi până la anulare.",
  "loading_page.keep_page_open": "Procesul este aproape finalizat. Păstrați această pagină deschisă.",
  "loading_page.processing_payment": "Se procesează plata",
  "pricing_table.discount": "Reducere",
  "pricing_table.subtotal": "Subtotal"
}, Ag = {
  "periods.week": "{{amount}} неделя",
  "periods.month": "{{amount}} месяц",
  "periods.year": "{{amount}} год",
  "periods.day": "{{amount}} день",
  "periods.weekShort": "{{amount}}нед",
  "periods.monthShort": "{{amount}}мес",
  "periods.yearShort": "{{amount}}г",
  "periods.dayShort": "{{amount}}д",
  "periods.lifetime": "пожизненно",
  "periods.weekPlural": "{{amount}} недель",
  "periods.monthPlural": "{{amount}} месяцев",
  "periods.yearPlural": "{{amount}} лет",
  "periods.dayPlural": "{{amount}} дней",
  "periods.weekFrequency": "еженедельно",
  "periods.monthFrequency": "ежемесячно",
  "periods.yearFrequency": "ежегодно",
  "periods.dayFrequency": "ежедневно",
  "periods.perWeekFrequency": "в неделю",
  "periods.perMonthFrequency": "в месяц",
  "periods.perYearFrequency": "в год",
  "periods.perDayFrequency": "в день",
  "periods.unknownFrequency": "неизвестно",
  "periods.weekFrequencyPlural": "каждые {{amount}} недель",
  "periods.monthFrequencyPlural": "каждые {{amount}} месяцев",
  "periods.yearFrequencyPlural": "каждые {{amount}} лет",
  "periods.dayFrequencyPlural": "каждые {{amount}} дней",
  "product_info.product_title": "{{productTitle}}",
  "product_info.product_description": "{{productDescription}}",
  "product_info.product_price": "{{productPrice}}",
  "product_info.free_trial_duration": "{{trialDuration}} бесплатная пробная версия",
  "product_info.price_after_free_trial": "После окончания пробного периода, {{renewalDate}}",
  "product_info.renewal_frequency": "Продлевается {{frequency}}",
  "product_info.continues_until_cancelled": "Продолжается до отмены",
  "product_info.cancel_anytime": "Отменить в любое время",
  "payment_entry_page.payment_step_title": "Безопасная оплата через RevenueCat",
  "payment_entry_page.button_pay": "Оплатить сейчас",
  "payment_entry_page.button_start_trial": "Начать пробный период",
  "success_page.purchase_successful": "Оплата завершена",
  "success_page.button_close": "Продолжить",
  "error_page.if_error_persists": "Если ошибка сохраняется, пожалуйста, свяжитесь с ",
  "error_page.error_title_already_subscribed": "Вы уже подписаны на {{productTitle}}",
  "error_page.error_title_already_purchased": "Вы уже приобрели {{productTitle}}",
  "error_page.error_title_other_errors": "Что-то пошло не так",
  "error_page.error_message_already_subscribed": "Вы не можете подписаться на этот продукт повторно.",
  "error_page.error_message_already_purchased": "Вы не можете приобрести этот продукт повторно.",
  "error_page.error_message_missing_email_error": "Для завершения покупки необходим адрес электронной почты.",
  "error_page.error_message_network_error": "Ошибка сети. Проверьте ваше интернет-соединение.",
  "error_page.error_message_error_charging_payment": "Оплата не прошла.",
  "error_page.error_message_error_setting_up_purchase": "Покупка не была начата из-за ошибки (код ошибки: {{errorCode}}).",
  "error_page.error_message_invalid_tax_location": "Мы не смогли проверить ваш платежный адрес. Пожалуйста, проверьте, что почтовый индекс и страна указаны правильно.",
  "error_page.error_message_unknown_error": "Произошла неизвестная ошибка (код ошибки: {{errorCode}}).",
  "error_page.button_try_again": "Повторить попытку",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}%",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "product_info.total_due_today": "Всего к оплате сегодня",
  "product_info.subscribe_to": "Подписаться",
  "navbar_header.details": "Детали",
  "navbar_header.back_button": "Назад",
  "pricing_dropdown.show_details": "Показать детали",
  "pricing_dropdown.hide_details": "Скрыть детали",
  "pricing_table.tax": "Налог",
  "pricing_table.trial_ends": "После окончания пробного периода, {{formattedTrialEndDate}}",
  "pricing_table.total_due_today": "Итого к оплате сегодня",
  "pricing_table.total_excluding_tax": "Итого без учета налога",
  "pricing_table.enter_billing_address_to_calculate": "Введите платежный адрес для расчета",
  "pricing_table.enter_state_or_postal_code_to_calculate": "Введите штат или почтовый индекс для расчета",
  "pricing_table.enter_postal_code_to_calculate": "Введите почтовый индекс для расчета",
  "error_page.error_message_invalid_email_error": "Не удалось проверить адрес электронной почты {{email}}. Пожалуйста, укажите действительный адрес электронной почты.",
  "payment_entry_page.button_payment_method": "Оплатить {{formattedPrice}} через {{paymentMethod}}",
  "payment_entry_page.button_with_price": "Оплатить {{formattedPrice}}",
  "price_update.title": "Обновление цены",
  "price_update.base_message": "Общая цена была обновлена с учетом налога на основе вашего платежного адреса. Пожалуйста, проверьте и повторите попытку. С вашей карты будет списано только один раз.",
  "price_update.trial_message": "Цена подписки была обновлена с учетом налогов на основе вашего платежного адреса. Пробный период остается бесплатным. Пожалуйста, проверьте и попробуйте снова.",
  "payment_entry_page.express_checkout_divider": "ИЛИ ОПЛАТИТЕ КАРТОЙ",
  "error_page.trouble_accessing": "Если у вас возникли проблемы с доступом к вашей покупке, обратитесь в службу поддержки по адресу ",
  "error_page.close_button_title": "Перейти в {{appName}}",
  "error_page.error_title_stripe_missing_required_permission": "Отсутствует разрешение Stripe",
  "error_page.button_close": "Закрыть",
  "error_page.error_message_stripe_invalid_tax_origin_address": "Покупка не удалась, так как адрес отправления налога недействителен. В рабочей среде покупки будут работать без применения налогов.",
  "error_page.error_message_stripe_tax_not_active": "Покупка не удалась, так как Stripe Tax не включен. В рабочей среде покупки будут работать без применения налогов.",
  "error_page.error_only_in_sandbox": "Это сообщение появляется только в песочнице.",
  "error_page.error_message_stripe_missing_required_permission": "Покупка не удалась, так как у приложения Stripe отсутствует необходимое разрешение. В рабочей среде покупки будут работать без применения налогов.",
  "error_page.error_title_stripe_tax_not_active": "Stripe Tax не активен",
  "error_page.error_title_stripe_invalid_tax_origin_address": "Недействительный адрес отправления налога",
  "apple_pay.free_trial": "Бесплатная пробная версия",
  "product_info.price_after_intro_price": "После {{introPriceDuration}}, {{renewalDate}}",
  "product_info.after_trial": "после пробного периода",
  "product_info.after": "после",
  "product_info.intro_price_phase_after_trial": "Затем {{introPriceDuration}} за {{introPrice}}",
  "product_info.intro_price_phase": "Сначала {{introPriceDuration}} за {{introPrice}}",
  "product_info.intro_price_phase_paid_once": "единоразовый платеж",
  "payment_entry_page.trial_subscription_terms_info": "По окончании пробного периода с вас будет взиматься плата в размере {{price}} {{perFrequency}}, начиная с {{renewalDate}}. Вы можете отменить подписку в любое время до этой даты.",
  "payment_entry_page.subscription_info": "Подписка продлевается автоматически. Отменить можно в любое время.",
  "payment_entry_page.otp_terms_info": "Совершая покупку, вы соглашаетесь с тем, что {{appName}} будет взимать с вас плату в соответствии со своими условиями.",
  "payment_entry_page.terms_link_label": "Условия",
  "payment_entry_page.subscription_terms_info": "Подписываясь, вы соглашаетесь с тем, что {{appName}} будет взимать с вас плату в соответствии с их условиями до тех пор, пока вы не отмените подписку.",
  "loading_page.keep_page_open": "Процесс почти завершен. Не закрывайте эту страницу.",
  "loading_page.processing_payment": "Обработка платежа",
  "pricing_table.discount": "Скидка",
  "pricing_table.subtotal": "Итого"
}, qg = {
  "periods.week": "{{amount}} týždeň",
  "periods.month": "{{amount}} mesiac",
  "periods.year": "{{amount}} rok",
  "periods.day": "{{amount}} deň",
  "periods.weekShort": "{{amount}}týž",
  "periods.monthShort": "{{amount}}mes",
  "periods.yearShort": "{{amount}}rok",
  "periods.dayShort": "{{amount}}d",
  "periods.lifetime": "doživotne",
  "periods.weekPlural": "{{amount}} týždňov",
  "periods.monthPlural": "{{amount}} mesiacov",
  "periods.yearPlural": "{{amount}} rokov",
  "periods.dayPlural": "{{amount}} dní",
  "periods.weekFrequency": "týždenne",
  "periods.monthFrequency": "mesačne",
  "periods.yearFrequency": "ročne",
  "periods.dayFrequency": "denne",
  "periods.perWeekFrequency": "týždenne",
  "periods.perMonthFrequency": "mesačne",
  "periods.perYearFrequency": "ročne",
  "periods.perDayFrequency": "denne",
  "periods.unknownFrequency": "neznáme",
  "periods.weekFrequencyPlural": "každých {{amount}} týždňov",
  "periods.monthFrequencyPlural": "každých {{amount}} mesiacov",
  "periods.yearFrequencyPlural": "každých {{amount}} rokov",
  "periods.dayFrequencyPlural": "každých {{amount}} dní",
  "product_info.product_title": "{{productTitle}}",
  "product_info.product_description": "{{productDescription}}",
  "product_info.product_price": "{{productPrice}}",
  "product_info.free_trial_duration": "{{trialDuration}} bezplatné skúšobné obdobie",
  "product_info.price_after_free_trial": "Po skončení skúšobného obdobia, dňa {{renewalDate}}",
  "product_info.renewal_frequency": "Obnovuje sa {{frequency}}",
  "product_info.continues_until_cancelled": "Pokračuje, kým sa nezruší",
  "product_info.cancel_anytime": "Kedykoľvek zrušiť",
  "payment_entry_page.payment_step_title": "Bezpečný nákup prostredníctvom RevenueCat",
  "payment_entry_page.button_pay": "Zaplatiť teraz",
  "payment_entry_page.button_start_trial": "Spustiť skúšobné obdobie",
  "success_page.purchase_successful": "Platba dokončená",
  "success_page.button_close": "Pokračovať",
  "error_page.if_error_persists": "Ak chyba pretrváva, kontaktujte ",
  "error_page.error_title_already_subscribed": "Už ste si predplatili {{productTitle}}",
  "error_page.error_title_already_purchased": "Už ste si zakúpili {{productTitle}}",
  "error_page.error_title_other_errors": "Niečo sa pokazilo",
  "error_page.error_message_already_subscribed": "Na tento produkt sa nemôžete znova prihlásiť na odber.",
  "error_page.error_message_already_purchased": "Tento produkt si nemôžete znova zakúpiť.",
  "error_page.error_message_missing_email_error": "Na dokončenie nákupu je potrebný e-mail.",
  "error_page.error_message_network_error": "Chyba siete. Skontrolujte svoje internetové pripojenie.",
  "error_page.error_message_error_charging_payment": "Platba zlyhala.",
  "error_page.error_message_error_setting_up_purchase": "Nákup sa nespustil kvôli chybe (kód chyby: {{errorCode}}).",
  "error_page.error_message_invalid_tax_location": "Nepodarilo sa nám overiť vašu fakturačnú adresu. Skontrolujte, prosím, či je PSČ a krajina správne.",
  "error_page.error_message_unknown_error": "Vyskytla sa neznáma chyba (kód chyby: {{errorCode}}).",
  "error_page.button_try_again": "Skúsiť znova",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}%",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "product_info.total_due_today": "Celková suma splatná dnes",
  "product_info.subscribe_to": "Prihlásiť sa na odber",
  "navbar_header.details": "Podrobnosti",
  "navbar_header.back_button": "Späť",
  "pricing_dropdown.show_details": "Zobraziť podrobnosti",
  "pricing_dropdown.hide_details": "Skryť podrobnosti",
  "pricing_table.tax": "Daň",
  "pricing_table.trial_ends": "Po skončení skúšobnej verzie, dňa {{formattedTrialEndDate}}",
  "pricing_table.total_due_today": "Celková suma splatná dnes",
  "pricing_table.total_excluding_tax": "Celkom bez dane",
  "pricing_table.enter_billing_address_to_calculate": "Zadajte fakturačnú adresu pre výpočet",
  "pricing_table.enter_state_or_postal_code_to_calculate": "Zadajte štát alebo PSČ pre výpočet",
  "pricing_table.enter_postal_code_to_calculate": "Zadajte PSČ pre výpočet",
  "error_page.error_message_invalid_email_error": "E-mailová adresa {{email}} sa nedala overiť. Zadajte platnú e-mailovú adresu.",
  "payment_entry_page.button_payment_method": "Zaplatiť sumu {{formattedPrice}} pomocou {{paymentMethod}}",
  "payment_entry_page.button_with_price": "Zaplatiť {{formattedPrice}}",
  "price_update.title": "Aktualizácia ceny",
  "price_update.base_message": "Celková cena bola aktualizovaná o daň na základe vašej fakturačnej adresy. Skontrolujte to a skúste znova. Vaša karta bude zaťažená iba raz.",
  "price_update.trial_message": "Cena predplatného bola aktualizovaná o daňe na základe vašej fakturačnej adresy. Bezplatná skúšobná doba stále platí. Prosím, skontrolujte a skúste znova.",
  "payment_entry_page.express_checkout_divider": "ALEBO ZAPLATIŤ KARTOU",
  "error_page.trouble_accessing": "Ak máte problémy s prístupom k svojmu nákupu, kontaktujte podporu na ",
  "error_page.close_button_title": "Prejsť na {{appName}}",
  "error_page.error_title_stripe_missing_required_permission": "Chýbajúce povolenie Stripe",
  "error_page.button_close": "Zavrieť",
  "error_page.error_message_stripe_invalid_tax_origin_address": "Nákup sa nepodaril, pretože adresa pôvodu dane je neplatná. V produkčnom prostredí budú nákupy fungovať bez uplatnenia daní.",
  "error_page.error_message_stripe_tax_not_active": "Nákup sa nepodaril, pretože Stripe Tax nie je povolený. V produkčnom prostredí budú nákupy fungovať bez uplatnenia daní.",
  "error_page.error_only_in_sandbox": "Táto správa sa zobrazuje iba v testovacom prostredí (sandbox).",
  "error_page.error_message_stripe_missing_required_permission": "Nákup sa nepodaril, pretože aplikácii Stripe chýba požadované povolenie. V produkčnom prostredí budú nákupy fungovať bez uplatnenia daní.",
  "error_page.error_title_stripe_tax_not_active": "Stripe Tax nie je aktívny",
  "error_page.error_title_stripe_invalid_tax_origin_address": "Neplatná adresa pôvodu dane",
  "apple_pay.free_trial": "Skúšobná verzia zdarma",
  "product_info.price_after_intro_price": "Po {{introPriceDuration}}, dňa {{renewalDate}}",
  "product_info.after_trial": "po skúšobnej dobe",
  "product_info.after": "po",
  "product_info.intro_price_phase_after_trial": "Potom {{introPriceDuration}} za {{introPrice}}",
  "product_info.intro_price_phase": "Najprv {{introPriceDuration}} za {{introPrice}}",
  "product_info.intro_price_phase_paid_once": "zaplatené jednorazovo",
  "payment_entry_page.trial_subscription_terms_info": "Po skončení skúšobného obdobia vám bude účtovaná suma {{price}} {{perFrequency}} počnúc dňom {{renewalDate}}. Pred týmto dátumom môžete kedykoľvek zrušiť.",
  "payment_entry_page.subscription_info": "Predplatné sa automaticky obnovuje. Zrušiť môžete kedykoľvek.",
  "payment_entry_page.otp_terms_info": "Zakúpením súhlasíte s tým, že spoločnosti {{appName}} umožníte účtovať vám poplatky v súlade s jej podmienkami.",
  "payment_entry_page.terms_link_label": "Podmienky",
  "payment_entry_page.subscription_terms_info": "Prihlásením na odber súhlasíte s tým, že spoločnosť {{appName}} vám bude účtovať poplatky podľa svojich podmienok, až kým odber nezrušíte.",
  "loading_page.keep_page_open": "Proces sa takmer dokončil. Nechajte túto stránku otvorenú.",
  "loading_page.processing_payment": "Spracováva sa platba",
  "pricing_table.discount": "Zľava",
  "pricing_table.subtotal": "Medzisúčet"
}, Fg = {
  "periods.week": "{{amount}} vecka",
  "periods.month": "{{amount}} månad",
  "periods.year": "{{amount}} år",
  "periods.day": "{{amount}} dag",
  "periods.weekShort": "{{amount}}v",
  "periods.monthShort": "{{amount}}mån",
  "periods.yearShort": "{{amount}}år",
  "periods.dayShort": "{{amount}}d",
  "periods.lifetime": "livstid",
  "periods.weekPlural": "{{amount}} veckor",
  "periods.monthPlural": "{{amount}} månader",
  "periods.yearPlural": "{{amount}} år",
  "periods.dayPlural": "{{amount}} dagar",
  "periods.weekFrequency": "veckovis",
  "periods.monthFrequency": "månadsvis",
  "periods.yearFrequency": "årligen",
  "periods.dayFrequency": "dagligen",
  "periods.perWeekFrequency": "per vecka",
  "periods.perMonthFrequency": "per månad",
  "periods.perYearFrequency": "per år",
  "periods.perDayFrequency": "per dag",
  "periods.unknownFrequency": "okänd",
  "periods.weekFrequencyPlural": "varje {{amount}} veckor",
  "periods.monthFrequencyPlural": "varje {{amount}} månader",
  "periods.yearFrequencyPlural": "varje {{amount}} år",
  "periods.dayFrequencyPlural": "varje {{amount}} dagar",
  "product_info.product_title": "{{productTitle}}",
  "product_info.product_description": "{{productDescription}}",
  "product_info.product_price": "{{productPrice}}",
  "product_info.free_trial_duration": "{{trialDuration}} gratis provperiod",
  "product_info.price_after_free_trial": "Efter provperioden slutar, den {{renewalDate}}",
  "product_info.renewal_frequency": "Förnyas {{frequency}}",
  "product_info.continues_until_cancelled": "Gäller tills avbokad",
  "product_info.cancel_anytime": "Avboka när som helst",
  "payment_entry_page.payment_step_title": "Säker betalning via RevenueCat",
  "payment_entry_page.button_pay": "Betala nu",
  "payment_entry_page.button_start_trial": "Starta provperiod",
  "success_page.purchase_successful": "Betalningen är klar",
  "success_page.button_close": "Fortsätt",
  "error_page.if_error_persists": "Om felet kvarstår, vänligen kontakta ",
  "error_page.error_title_already_subscribed": "Du prenumererar redan på {{productTitle}}",
  "error_page.error_title_already_purchased": "Du har redan köpt {{productTitle}}",
  "error_page.error_title_other_errors": "Något gick fel",
  "error_page.error_message_already_subscribed": "Du kan inte prenumerera på den här produkten igen.",
  "error_page.error_message_already_purchased": "Du kan inte köpa den här produkten igen.",
  "error_page.error_message_missing_email_error": "E-post krävs för att slutföra köpet.",
  "error_page.error_message_network_error": "Nätverksfel. Kontrollera din internetanslutning.",
  "error_page.error_message_error_charging_payment": "Betalningen misslyckades.",
  "error_page.error_message_error_setting_up_purchase": "Köp kunde inte startas på grund av ett fel (felkod: {{errorCode}}).",
  "error_page.error_message_invalid_tax_location": "Vi kunde inte verifiera din faktureringsadress. Kontrollera att postnummer och land är korrekta.",
  "error_page.error_message_unknown_error": "Ett okänt fel inträffade (felkod: {{errorCode}}).",
  "error_page.button_try_again": "Försök igen",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}%",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}} ({{formattedPricePerMonth}}/{{monthPeriod}})",
  "product_info.total_due_today": "Totalt att betala idag",
  "product_info.subscribe_to": "Prenumerera på",
  "navbar_header.details": "Detaljer",
  "navbar_header.back_button": "Tillbaka",
  "pricing_dropdown.show_details": "Visa detaljer",
  "pricing_dropdown.hide_details": "Dölj detaljer",
  "pricing_table.tax": "Moms",
  "pricing_table.trial_ends": "Efter provperiodens slut, den {{formattedTrialEndDate}}",
  "pricing_table.total_due_today": "Total summa att betala idag",
  "pricing_table.total_excluding_tax": "Totalt exklusive moms",
  "pricing_table.enter_billing_address_to_calculate": "Ange faktureringsadress för att beräkna",
  "pricing_table.enter_state_or_postal_code_to_calculate": "Ange delstat eller postnummer för att beräkna",
  "pricing_table.enter_postal_code_to_calculate": "Ange postnummer för att beräkna",
  "error_page.error_message_invalid_email_error": "E-postadressen {{email}} kunde inte verifieras. Ange en giltig e-postadress.",
  "payment_entry_page.button_payment_method": "Betala {{formattedPrice}} med {{paymentMethod}}",
  "payment_entry_page.button_with_price": "Betala {{formattedPrice}}",
  "price_update.title": "Prisuppdatering",
  "price_update.base_message": "Det totala priset har uppdaterats med moms baserat på din faktureringsadress. Granska och försök igen. Ditt kort kommer endast att debiteras en gång.",
  "price_update.trial_message": "Prenumerationspriset har uppdaterats för att inkludera skatter baserat på din fakturaadress. Den kostnadsfria provperioden gäller fortfarande. Kontrollera och försök igen.",
  "payment_entry_page.express_checkout_divider": "ELLER BETALA MED KORT",
  "error_page.trouble_accessing": "Om du har problem med att komma åt ditt köp, kontakta support på ",
  "error_page.close_button_title": "Gå till {{appName}}",
  "error_page.error_title_stripe_missing_required_permission": "Saknar Stripe-behörighet",
  "error_page.button_close": "Stäng",
  "error_page.error_message_stripe_invalid_tax_origin_address": "Köpet misslyckades eftersom skatteursprungsadressen är ogiltig. I produktion kommer köp att fungera utan att skatter tillämpas.",
  "error_page.error_message_stripe_tax_not_active": "Köpet misslyckades eftersom Stripe Tax inte är aktiverat. I produktion kommer köp att fungera utan att skatter tillämpas.",
  "error_page.error_only_in_sandbox": "Det här meddelandet visas bara i sandlådan.",
  "error_page.error_message_stripe_missing_required_permission": "Köpet misslyckades eftersom Stripe-appen saknar en nödvändig behörighet. I produktion kommer köp att fungera utan att skatter tillämpas.",
  "error_page.error_title_stripe_tax_not_active": "Stripe Tax är inte aktivt",
  "error_page.error_title_stripe_invalid_tax_origin_address": "Ogiltig skatteursprungsadress",
  "apple_pay.free_trial": "Gratis provperiod",
  "product_info.price_after_intro_price": "Efter {{introPriceDuration}}, den {{renewalDate}}",
  "product_info.after_trial": "efter provperioden",
  "product_info.after": "efter",
  "product_info.intro_price_phase_after_trial": "Sedan {{introPriceDuration}} för {{introPrice}}",
  "product_info.intro_price_phase": "Först {{introPriceDuration}} för {{introPrice}}",
  "product_info.intro_price_phase_paid_once": "betalas en gång",
  "payment_entry_page.trial_subscription_terms_info": "Efter att din provperiod slutar debiteras du {{price}} {{perFrequency}} från och med {{renewalDate}}. Du kan avbryta när som helst före detta datum.",
  "payment_entry_page.subscription_info": "Prenumerationen förnyas automatiskt. Avbryt när som helst.",
  "payment_entry_page.otp_terms_info": "Genom att köpa godkänner du att {{appName}} debiterar dig i enlighet med deras villkor.",
  "payment_entry_page.terms_link_label": "Villkor",
  "payment_entry_page.subscription_terms_info": "Genom att prenumerera godkänner du att {{appName}} debiterar dig i enlighet med deras villkor tills du avbryter.",
  "loading_page.keep_page_open": "Processen är nästan klar. Håll den här sidan öppen.",
  "loading_page.processing_payment": "Behandlar betalning",
  "pricing_table.discount": "Rabatt",
  "pricing_table.subtotal": "Delsumma"
}, zg = {
  "periods.week": "{{amount}} สัปดาห์",
  "periods.month": "{{amount}} เดือน",
  "periods.year": "{{amount}} ปี",
  "periods.day": "{{amount}} วัน",
  "periods.weekShort": "{{amount}} สัปดาห์",
  "periods.monthShort": "{{amount}} เดือน",
  "periods.yearShort": "{{amount}} ปี",
  "periods.dayShort": "{{amount}} วัน",
  "periods.lifetime": "ตลอดชีพ",
  "periods.weekPlural": "{{amount}} สัปดาห์",
  "periods.monthPlural": "{{amount}} เดือน",
  "periods.yearPlural": "{{amount}} ปี",
  "periods.dayPlural": "{{amount}} วัน",
  "periods.weekFrequency": "รายสัปดาห์",
  "periods.monthFrequency": "รายเดือน",
  "periods.yearFrequency": "รายปี",
  "periods.dayFrequency": "รายวัน",
  "periods.perWeekFrequency": "ต่อสัปดาห์",
  "periods.perMonthFrequency": "ต่อเดือน",
  "periods.perYearFrequency": "ต่อปี",
  "periods.perDayFrequency": "ต่อวัน",
  "periods.unknownFrequency": "ไม่รู้จัก",
  "periods.weekFrequencyPlural": "ทุกๆ {{amount}} สัปดาห์",
  "periods.monthFrequencyPlural": "ทุกๆ {{amount}} เดือน",
  "periods.yearFrequencyPlural": "ทุกๆ {{amount}} ปี",
  "periods.dayFrequencyPlural": "ทุกๆ {{amount}} วัน",
  "product_info.product_title": "{{productTitle}}",
  "product_info.product_description": "{{productDescription}}",
  "product_info.product_price": "{{productPrice}}",
  "product_info.free_trial_duration": "{{trialDuration}} ทดลองใช้ฟรี",
  "product_info.price_after_free_trial": "หลังจากสิ้นสุดการทดลองใช้ ในวันที่ {{renewalDate}}",
  "product_info.renewal_frequency": "ต่ออายุ {{frequency}}",
  "product_info.continues_until_cancelled": "ต่อเนื่องจนกว่าจะยกเลิก",
  "product_info.cancel_anytime": "ยกเลิกได้ตลอดเวลา",
  "payment_entry_page.payment_step_title": "การชำระเงินอย่างปลอดภัยโดย RevenueCat",
  "payment_entry_page.button_pay": "ชำระเงินตอนนี้",
  "payment_entry_page.button_start_trial": "เริ่มทดลองใช้",
  "success_page.purchase_successful": "การชำระเงินเสร็จสมบูรณ์",
  "success_page.button_close": "ดำเนินการต่อ",
  "error_page.if_error_persists": "หากข้อผิดพลาดยังคงอยู่ โปรดติดต่อ ",
  "error_page.error_title_already_subscribed": "คุณได้สมัครสมาชิก {{productTitle}} แล้ว",
  "error_page.error_title_already_purchased": "คุณได้ซื้อ {{productTitle}} แล้ว",
  "error_page.error_title_other_errors": "มีบางอย่างผิดพลาด",
  "error_page.error_message_already_subscribed": "คุณไม่สามารถสมัครสมาชิกผลิตภัณฑ์นี้ได้อีก",
  "error_page.error_message_already_purchased": "คุณไม่สามารถซื้อผลิตภัณฑ์นี้ได้อีก",
  "error_page.error_message_missing_email_error": "ต้องใช้อีเมลเพื่อทำการซื้อให้เสร็จสมบูรณ์",
  "error_page.error_message_network_error": "ข้อผิดพลาดของเครือข่าย โปรดตรวจสอบการเชื่อมต่ออินเทอร์เน็ตของคุณ",
  "error_page.error_message_error_charging_payment": "การชำระเงินล้มเหลว",
  "error_page.error_message_error_setting_up_purchase": "ไม่สามารถเริ่มการซื้อได้เนื่องจากข้อผิดพลาด (รหัสข้อผิดพลาด: {{errorCode}})",
  "error_page.error_message_invalid_tax_location": "เราไม่สามารถยืนยันที่อยู่สำหรับออกใบแจ้งหนี้ของคุณได้ กรุณาตรวจสอบรหัสไปรษณีย์และประเทศให้ถูกต้อง",
  "error_page.error_message_unknown_error": "เกิดข้อผิดพลาดที่ไม่รู้จัก (รหัสข้อผิดพลาด: {{errorCode}})",
  "error_page.button_try_again": "ลองอีกครั้ง",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}%",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "product_info.total_due_today": "ยอดรวมที่ต้องชำระวันนี้",
  "product_info.subscribe_to": "สมัครสมาชิก",
  "navbar_header.details": "รายละเอียด",
  "navbar_header.back_button": "ย้อนกลับ",
  "pricing_dropdown.show_details": "แสดงรายละเอียด",
  "pricing_dropdown.hide_details": "ซ่อนรายละเอียด",
  "pricing_table.tax": "ภาษี",
  "pricing_table.trial_ends": "หลังจากช่วงทดลองใช้สิ้นสุด ในวันที่ {{formattedTrialEndDate}}",
  "pricing_table.total_due_today": "ยอดรวมที่ต้องชำระวันนี้",
  "pricing_table.total_excluding_tax": "ราคารวมก่อนภาษี",
  "pricing_table.enter_billing_address_to_calculate": "กรุณากรอกที่อยู่สำหรับเรียกเก็บเงินเพื่อคำนวณ",
  "pricing_table.enter_state_or_postal_code_to_calculate": "ใส่รัฐหรือรหัสไปรษณีย์เพื่อคำนวณ",
  "pricing_table.enter_postal_code_to_calculate": "ใส่รหัสไปรษณีย์เพื่อคำนวณ",
  "error_page.error_message_invalid_email_error": "ไม่สามารถยืนยันที่อยู่อีเมล {{email}} ได้ โปรดระบุที่อยู่อีเมลที่ถูกต้อง",
  "payment_entry_page.button_payment_method": "ชำระเงิน {{formattedPrice}} ด้วย {{paymentMethod}}",
  "payment_entry_page.button_with_price": "ชำระเงิน {{formattedPrice}}",
  "price_update.title": "อัปเดตราคา",
  "price_update.base_message": "ราคารวมได้รับการอัปเดตพร้อมภาษีตามที่อยู่สำหรับการเรียกเก็บเงินของคุณ โปรดตรวจสอบและลองอีกครั้ง บัตรของคุณจะถูกเรียกเก็บเงินเพียงครั้งเดียวเท่านั้น",
  "price_update.trial_message": "ราคาการสมัครสมาชิกได้รับการอัปเดตเพื่อรวมภาษีตามที่อยู่สำหรับการเรียกเก็บเงินของคุณ ระยะเวลาทดลองใช้ฟรียังคงมีผล โปรดตรวจสอบและลองอีกครั้ง",
  "payment_entry_page.express_checkout_divider": "หรือชำระด้วยบัตร",
  "error_page.trouble_accessing": "หากคุณมีปัญหาในการเข้าถึงการซื้อ โปรดติดต่อฝ่ายสนับสนุนที่ ",
  "error_page.close_button_title": "ไปที่ {{appName}}",
  "error_page.error_title_stripe_missing_required_permission": "ขาดสิทธิ์ Stripe ที่จำเป็น",
  "error_page.button_close": "ปิด",
  "error_page.error_message_stripe_invalid_tax_origin_address": "การซื้อล้มเหลวเนื่องจากที่อยู่ต้นทางภาษีไม่ถูกต้อง ในสภาพแวดล้อมจริง การซื้อจะทำงานได้โดยไม่มีการเรียกเก็บภาษี",
  "error_page.error_message_stripe_tax_not_active": "การซื้อล้มเหลวเนื่องจากไม่ได้เปิดใช้งาน Stripe Tax ในสภาพแวดล้อมจริง การซื้อจะทำงานได้โดยไม่มีการเรียกเก็บภาษี",
  "error_page.error_only_in_sandbox": "ข้อความนี้จะปรากฏเฉพาะใน sandbox เท่านั้น",
  "error_page.error_message_stripe_missing_required_permission": "การซื้อล้มเหลวเนื่องจากแอป Stripe ขาดสิทธิ์ที่จำเป็น ในสภาพแวดล้อมจริง การซื้อจะทำงานได้โดยไม่มีการเรียกเก็บภาษี",
  "error_page.error_title_stripe_tax_not_active": "Stripe Tax ไม่เปิดใช้งาน",
  "error_page.error_title_stripe_invalid_tax_origin_address": "ที่อยู่ต้นทางภาษีไม่ถูกต้อง",
  "apple_pay.free_trial": "ทดลองใช้ฟรี",
  "product_info.price_after_intro_price": "หลังจาก {{introPriceDuration}} ในวันที่ {{renewalDate}}",
  "product_info.after_trial": "หลังช่วงทดลองใช้",
  "product_info.after": "หลังจาก",
  "product_info.intro_price_phase_after_trial": "จากนั้น {{introPriceDuration}} ในราคา {{introPrice}}",
  "product_info.intro_price_phase": "ช่วงแรก {{introPriceDuration}} ในราคา {{introPrice}}",
  "product_info.intro_price_phase_paid_once": "ชำระครั้งเดียว",
  "payment_entry_page.trial_subscription_terms_info": "หลังจากช่วงทดลองใช้ของคุณสิ้นสุดลง คุณจะถูกเรียกเก็บเงิน {{price}} {{perFrequency}} เริ่มตั้งแต่วันที่ {{renewalDate}} คุณสามารถยกเลิกได้ตลอดเวลาก่อนวันดังกล่าว",
  "payment_entry_page.subscription_info": "การสมัครรับข้อมูลจะต่ออายุโดยอัตโนมัติ ยกเลิกได้ตลอดเวลา",
  "payment_entry_page.otp_terms_info": "เมื่อทำการซื้อ คุณตกลงที่จะอนุญาตให้ {{appName}} เรียกเก็บเงินจากคุณตามข้อกำหนดของพวกเขา",
  "payment_entry_page.terms_link_label": "ข้อกำหนด",
  "payment_entry_page.subscription_terms_info": "เมื่อสมัครรับข้อมูล แสดงว่าคุณยินยอมให้ {{appName}} เรียกเก็บเงินจากคุณตามข้อกำหนดจนกว่าคุณจะยกเลิก",
  "loading_page.keep_page_open": "กระบวนการเกือบเสร็จสมบูรณ์แล้ว โปรดเปิดหน้านี้ไว้",
  "loading_page.processing_payment": "กำลังดำเนินการชำระเงิน",
  "pricing_table.discount": "ส่วนลด",
  "pricing_table.subtotal": "ราคารวมย่อย"
}, Mg = {
  "periods.week": "{{amount}} hafta",
  "periods.month": "{{amount}} ay",
  "periods.year": "{{amount}} yıl",
  "periods.day": "{{amount}} gün",
  "periods.weekShort": "{{amount}}hf",
  "periods.monthShort": "{{amount}}ay",
  "periods.yearShort": "{{amount}}yl",
  "periods.dayShort": "{{amount}}g",
  "periods.lifetime": "ömür boyu",
  "periods.weekPlural": "{{amount}} hafta",
  "periods.monthPlural": "{{amount}} ay",
  "periods.yearPlural": "{{amount}} yıl",
  "periods.dayPlural": "{{amount}} gün",
  "periods.weekFrequency": "haftalık",
  "periods.monthFrequency": "aylık",
  "periods.yearFrequency": "yıllık",
  "periods.dayFrequency": "günlük",
  "periods.perWeekFrequency": "haftada",
  "periods.perMonthFrequency": "ayda",
  "periods.perYearFrequency": "yılda",
  "periods.perDayFrequency": "günde",
  "periods.unknownFrequency": "bilinmiyor",
  "periods.weekFrequencyPlural": "her {{amount}} haftada",
  "periods.monthFrequencyPlural": "her {{amount}} ayda",
  "periods.yearFrequencyPlural": "her {{amount}} yılda",
  "periods.dayFrequencyPlural": "her {{amount}} günde",
  "product_info.product_title": "{{productTitle}}",
  "product_info.product_description": "{{productDescription}}",
  "product_info.product_price": "{{productPrice}}",
  "product_info.free_trial_duration": "{{trialDuration}} ücretsiz deneme",
  "product_info.price_after_free_trial": "Deneme süresi sona erdiğinde, {{renewalDate}} tarihinde",
  "product_info.renewal_frequency": "{{frequency}} sıklığında yenilenir",
  "product_info.continues_until_cancelled": "İptal edilene kadar devam eder",
  "product_info.cancel_anytime": "İstediğiniz zaman iptal edebilirsiniz",
  "payment_entry_page.payment_step_title": "RevenueCat ile güvenli ödeme",
  "payment_entry_page.button_pay": "Şimdi öde",
  "payment_entry_page.button_start_trial": "Denemeyi başlat",
  "success_page.purchase_successful": "Ödeme tamamlandı",
  "success_page.button_close": "Devam et",
  "error_page.if_error_persists": "Hata devam ederse lütfen iletişime geçin ",
  "error_page.error_title_already_subscribed": "{{productTitle}} ürününe zaten abone oldunuz",
  "error_page.error_title_already_purchased": "{{productTitle}} ürününü zaten satın aldınız",
  "error_page.error_title_other_errors": "Bir şeyler ters gitti",
  "error_page.error_message_already_subscribed": "Bu ürüne tekrar abone olamazsınız.",
  "error_page.error_message_already_purchased": "Bu ürünü tekrar satın alamazsınız.",
  "error_page.error_message_missing_email_error": "Satın almayı tamamlamak için e-posta gereklidir.",
  "error_page.error_message_network_error": "Ağ hatası. Lütfen internet bağlantınızı kontrol edin.",
  "error_page.error_message_error_charging_payment": "Ödeme başarısız oldu.",
  "error_page.error_message_error_setting_up_purchase": "Bir hata nedeniyle satın alma başlatılamadı (hata kodu: {{errorCode}}).",
  "error_page.error_message_invalid_tax_location": "Fatura adresinizi doğrulayamadık. Lütfen posta kodu ve ülkenin doğru olduğunu kontrol edin.",
  "error_page.error_message_unknown_error": "Bilinmeyen bir hata oluştu (hata kodu: {{errorCode}}).",
  "error_page.button_try_again": "Tekrar dene",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}%",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "product_info.total_due_today": "Bugün ödenecek toplam tutar",
  "product_info.subscribe_to": "Abone Ol",
  "navbar_header.details": "Detaylar",
  "navbar_header.back_button": "Geri",
  "pricing_dropdown.show_details": "Detayları göster",
  "pricing_dropdown.hide_details": "Detayları gizle",
  "pricing_table.tax": "Vergi",
  "pricing_table.trial_ends": "Deneme süresi sona erdikten sonra, {{formattedTrialEndDate}} tarihinde",
  "pricing_table.total_due_today": "Bugün ödenecek toplam",
  "pricing_table.total_excluding_tax": "Vergi hariç toplam",
  "pricing_table.enter_billing_address_to_calculate": "Hesaplamak için fatura adresini girin",
  "pricing_table.enter_state_or_postal_code_to_calculate": "Hesaplamak için eyalet veya posta kodunu girin",
  "pricing_table.enter_postal_code_to_calculate": "Hesaplamak için posta kodunu girin",
  "error_page.error_message_invalid_email_error": "{{email}} e-posta adresi doğrulanamadı. Lütfen geçerli bir e-posta adresi girin.",
  "payment_entry_page.button_payment_method": "{{paymentMethod}} ile {{formattedPrice}} öde",
  "payment_entry_page.button_with_price": "{{formattedPrice}} öde",
  "price_update.title": "Fiyat güncellemesi",
  "price_update.base_message": "Toplam fiyat, fatura adresinize göre vergi dahil olacak şekilde güncellendi. Lütfen inceleyip tekrar deneyin. Kartınızdan yalnızca bir kez ücret alınacaktır.",
  "price_update.trial_message": "Abonelik fiyatı, fatura adresinize göre vergileri içerecek şekilde güncellendi. Ücretsiz deneme süresi hala geçerli. Lütfen kontrol edin ve tekrar deneyin.",
  "payment_entry_page.express_checkout_divider": "VEYA KARTLA ÖDEYİN",
  "error_page.trouble_accessing": "Satın alımınıza erişmekte sorun yaşıyorsanız, şu adresten destek ekibine ulaşın: ",
  "error_page.close_button_title": "{{appName}}'e Git",
  "error_page.error_title_stripe_missing_required_permission": "Eksik Stripe izni",
  "error_page.button_close": "Kapat",
  "error_page.error_message_stripe_invalid_tax_origin_address": "Vergi başlangıç adresi geçersiz olduğu için satın alma başarısız oldu. Üretimde, satın alımlar vergi uygulanmadan çalışacaktır.",
  "error_page.error_message_stripe_tax_not_active": "Stripe Vergi etkinleştirilmediği için satın alma başarısız oldu. Üretimde, satın alımlar vergi uygulanmadan çalışacaktır.",
  "error_page.error_only_in_sandbox": "Bu mesaj yalnızca sanal ortamda görünür.",
  "error_page.error_message_stripe_missing_required_permission": "Stripe uygulamasında gerekli bir izin eksik olduğu için satın alma başarısız oldu. Üretimde, satın alımlar vergi uygulanmadan çalışacaktır.",
  "error_page.error_title_stripe_tax_not_active": "Stripe Vergi aktif değil",
  "error_page.error_title_stripe_invalid_tax_origin_address": "Geçersiz vergi başlangıç adresi",
  "apple_pay.free_trial": "Ücretsiz Deneme",
  "product_info.price_after_intro_price": "{{introPriceDuration}} sonra, {{renewalDate}} tarihinde",
  "product_info.after_trial": "deneme süresinden sonra",
  "product_info.after": "sonra",
  "product_info.intro_price_phase_after_trial": "Sonra {{introPriceDuration}} boyunca {{introPrice}}",
  "product_info.intro_price_phase": "İlk {{introPriceDuration}} boyunca {{introPrice}}",
  "product_info.intro_price_phase_paid_once": "bir defaya mahsus ödenir",
  "payment_entry_page.trial_subscription_terms_info": "Deneme süreniz sona erdikten sonra, {{renewalDate}} tarihinden itibaren {{price}} {{perFrequency}} ücretlendirileceksiniz. Bu tarihten önce istediğiniz zaman iptal edebilirsiniz.",
  "payment_entry_page.subscription_info": "Abonelik otomatik olarak yenilenir. İstediğiniz zaman iptal edin.",
  "payment_entry_page.otp_terms_info": "Satın alarak, {{appName}}'in sizi şartlarına göre ücretlendirmesine izin vermeyi kabul edersiniz.",
  "payment_entry_page.terms_link_label": "Koşullar",
  "payment_entry_page.subscription_terms_info": "Abone olarak, iptal edene kadar {{appName}}'in sizi şartlarına göre ücretlendirmesine izin vermeyi kabul edersiniz.",
  "loading_page.keep_page_open": "İşlem neredeyse tamamlandı. Bu sayfayı açık tutun.",
  "loading_page.processing_payment": "Ödeme işleniyor",
  "pricing_table.discount": "İndirim",
  "pricing_table.subtotal": "Ara Toplam"
}, jg = {
  "periods.week": "{{amount}} тиждень",
  "periods.month": "{{amount}} місяць",
  "periods.year": "{{amount}} рік",
  "periods.day": "{{amount}} день",
  "periods.weekShort": "{{amount}}тиж",
  "periods.monthShort": "{{amount}}міс",
  "periods.yearShort": "{{amount}}рік",
  "periods.dayShort": "{{amount}}дн",
  "periods.lifetime": "пожиттєво",
  "periods.weekPlural": "{{amount}} тижнів",
  "periods.monthPlural": "{{amount}} місяців",
  "periods.yearPlural": "{{amount}} років",
  "periods.dayPlural": "{{amount}} днів",
  "periods.weekFrequency": "щотижня",
  "periods.monthFrequency": "щомісяця",
  "periods.yearFrequency": "щороку",
  "periods.dayFrequency": "щодня",
  "periods.perWeekFrequency": "на тиждень",
  "periods.perMonthFrequency": "на місяць",
  "periods.perYearFrequency": "на рік",
  "periods.perDayFrequency": "на день",
  "periods.unknownFrequency": "невідомо",
  "periods.weekFrequencyPlural": "кожні {{amount}} тижнів",
  "periods.monthFrequencyPlural": "кожні {{amount}} місяців",
  "periods.yearFrequencyPlural": "кожні {{amount}} років",
  "periods.dayFrequencyPlural": "кожні {{amount}} днів",
  "product_info.product_title": "{{productTitle}}",
  "product_info.product_description": "{{productDescription}}",
  "product_info.product_price": "{{productPrice}}",
  "product_info.free_trial_duration": "{{trialDuration}} безкоштовний пробний період",
  "product_info.price_after_free_trial": "Після закінчення пробного періоду, {{renewalDate}}",
  "product_info.renewal_frequency": "Продовжується {{frequency}}",
  "product_info.continues_until_cancelled": "Триває до скасування",
  "product_info.cancel_anytime": "Можна скасувати в будь-який час",
  "payment_entry_page.payment_step_title": "Безпечна оплата через RevenueCat",
  "payment_entry_page.button_pay": "Оплатити зараз",
  "payment_entry_page.button_start_trial": "Розпочати пробний період",
  "success_page.purchase_successful": "Оплата завершена",
  "success_page.button_close": "Продовжити",
  "error_page.if_error_persists": "Якщо помилка повторюється, зверніться до ",
  "error_page.error_title_already_subscribed": "Ви вже підписалися на {{productTitle}}",
  "error_page.error_title_already_purchased": "Ви вже придбали {{productTitle}}",
  "error_page.error_title_other_errors": "Щось пішло не так",
  "error_page.error_message_already_subscribed": "Ви не можете підписатися на цей продукт знову.",
  "error_page.error_message_already_purchased": "Ви не можете придбати цей продукт знову.",
  "error_page.error_message_missing_email_error": "Для завершення покупки потрібна електронна пошта.",
  "error_page.error_message_network_error": "Помилка мережі. Перевірте підключення до інтернету.",
  "error_page.error_message_error_charging_payment": "Оплата не пройшла.",
  "error_page.error_message_error_setting_up_purchase": "Помилка при ініціалізації покупки (код помилки: {{errorCode}}).",
  "error_page.error_message_invalid_tax_location": "Ми не змогли перевірити вашу платіжну адресу. Будь ласка, перевірте, чи правильні поштовий індекс та країна.",
  "error_page.error_message_unknown_error": "Сталася невідома помилка (код помилки: {{errorCode}}).",
  "error_page.button_try_again": "Спробувати ще раз",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}%",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "product_info.total_due_today": "Всього до сплати сьогодні",
  "product_info.subscribe_to": "Підписатися на",
  "navbar_header.details": "Деталі",
  "navbar_header.back_button": "Назад",
  "pricing_dropdown.show_details": "Показати деталі",
  "pricing_dropdown.hide_details": "Приховати деталі",
  "pricing_table.tax": "Податок",
  "pricing_table.trial_ends": "Після закінчення пробного періоду, {{formattedTrialEndDate}}",
  "pricing_table.total_due_today": "Загальна сума до сплати сьогодні",
  "pricing_table.total_excluding_tax": "Загальна сума без урахування податку",
  "pricing_table.enter_billing_address_to_calculate": "Введіть адресу виставлення рахунку для розрахунку",
  "pricing_table.enter_state_or_postal_code_to_calculate": "Введіть штат або поштовий індекс для розрахунку",
  "pricing_table.enter_postal_code_to_calculate": "Введіть поштовий індекс для розрахунку",
  "error_page.error_message_invalid_email_error": "Електронну адресу {{email}} не вдалося підтвердити. Будь ласка, вкажіть дійсну електронну адресу.",
  "payment_entry_page.button_payment_method": "Сплатити {{formattedPrice}} за допомогою {{paymentMethod}}",
  "payment_entry_page.button_with_price": "Сплатити {{formattedPrice}}",
  "price_update.title": "Оновлення ціни",
  "price_update.base_message": "Загальну ціну було оновлено з урахуванням податку на основі вашої платіжної адреси. Перегляньте та спробуйте ще раз. З вашої картки буде списано кошти лише один раз.",
  "price_update.trial_message": "Ціна підписки була оновлена для включення податків на основі вашої платіжної адреси. Безкоштовний пробний період все ще діє. Будь ласка, перевірте та спробуйте ще раз.",
  "payment_entry_page.express_checkout_divider": "АБО СПЛАТІТЬ КАРТКОЮ",
  "error_page.trouble_accessing": "Якщо у вас виникли проблеми з доступом до вашої покупки, зверніться до служби підтримки за адресою ",
  "error_page.close_button_title": "Перейти до {{appName}}",
  "error_page.error_title_stripe_missing_required_permission": "Відсутній дозвіл Stripe",
  "error_page.button_close": "Закрити",
  "error_page.error_message_stripe_invalid_tax_origin_address": "Покупка не вдалася, оскільки адреса походження податку недійсна. У виробництві покупки працюватимуть без застосування податків.",
  "error_page.error_message_stripe_tax_not_active": "Покупка не вдалася, оскільки Stripe Tax не ввімкнено. У виробництві покупки працюватимуть без застосування податків.",
  "error_page.error_only_in_sandbox": "Це повідомлення з’являється лише в пісочниці.",
  "error_page.error_message_stripe_missing_required_permission": "Покупка не вдалася, оскільки програмі Stripe не вистачає необхідного дозволу. У виробництві покупки працюватимуть без застосування податків.",
  "error_page.error_title_stripe_tax_not_active": "Stripe Tax не активовано",
  "error_page.error_title_stripe_invalid_tax_origin_address": "Недійсна адреса походження податку",
  "apple_pay.free_trial": "Безкоштовна пробна версія",
  "product_info.price_after_intro_price": "Після {{introPriceDuration}}, {{renewalDate}}",
  "product_info.after_trial": "після пробного періоду",
  "product_info.after": "після",
  "product_info.intro_price_phase_after_trial": "Потім {{introPriceDuration}} за {{introPrice}}",
  "product_info.intro_price_phase": "Спочатку {{introPriceDuration}} за {{introPrice}}",
  "product_info.intro_price_phase_paid_once": "сплачено один раз",
  "payment_entry_page.trial_subscription_terms_info": "Після закінчення пробного періоду з вас буде стягуватися плата в розмірі {{price}} {{perFrequency}} починаючи з {{renewalDate}}. Ви можете скасувати підписку в будь-який час до цієї дати.",
  "payment_entry_page.subscription_info": "Підписка поновлюється автоматично. Скасувати можна в будь-який час.",
  "payment_entry_page.otp_terms_info": "Купуючи, ви погоджуєтеся дозволити {{appName}} стягувати з вас плату відповідно до їхніх умов.",
  "payment_entry_page.terms_link_label": "Умови",
  "payment_entry_page.subscription_terms_info": "Підписуючись, ви погоджуєтеся дозволити {{appName}} стягувати з вас плату відповідно до їхніх умов, поки ви не скасуєте підписку.",
  "loading_page.keep_page_open": "Процес майже завершено. Залиште цю сторінку відкритою.",
  "loading_page.processing_payment": "Обробка платежу",
  "pricing_table.discount": "Знижка",
  "pricing_table.subtotal": "Сума до сплати"
}, Ng = {
  "periods.week": "{{amount}} tuần",
  "periods.month": "{{amount}} tháng",
  "periods.year": "{{amount}} năm",
  "periods.day": "{{amount}} ngày",
  "periods.weekShort": "{{amount}}tuần",
  "periods.monthShort": "{{amount}}tháng",
  "periods.yearShort": "{{amount}}năm",
  "periods.dayShort": "{{amount}}ngày",
  "periods.lifetime": "trọn đời",
  "periods.weekPlural": "{{amount}} tuần",
  "periods.monthPlural": "{{amount}} tháng",
  "periods.yearPlural": "{{amount}} năm",
  "periods.dayPlural": "{{amount}} ngày",
  "periods.weekFrequency": "hàng tuần",
  "periods.monthFrequency": "hàng tháng",
  "periods.yearFrequency": "hàng năm",
  "periods.dayFrequency": "hàng ngày",
  "periods.perWeekFrequency": "mỗi tuần",
  "periods.perMonthFrequency": "mỗi tháng",
  "periods.perYearFrequency": "mỗi năm",
  "periods.perDayFrequency": "mỗi ngày",
  "periods.unknownFrequency": "không xác định",
  "periods.weekFrequencyPlural": "cứ {{amount}} tuần",
  "periods.monthFrequencyPlural": "cứ {{amount}} tháng",
  "periods.yearFrequencyPlural": "cứ {{amount}} năm",
  "periods.dayFrequencyPlural": "cứ {{amount}} ngày",
  "product_info.product_title": "{{productTitle}}",
  "product_info.product_description": "{{productDescription}}",
  "product_info.product_price": "{{productPrice}}",
  "product_info.free_trial_duration": "{{trialDuration}} dùng thử miễn phí",
  "product_info.price_after_free_trial": "Sau khi dùng thử kết thúc, vào {{renewalDate}}",
  "product_info.renewal_frequency": "Gia hạn {{frequency}}",
  "product_info.continues_until_cancelled": "Tiếp tục cho đến khi hủy",
  "product_info.cancel_anytime": "Hủy bất cứ lúc nào",
  "payment_entry_page.payment_step_title": "Thanh toán an toàn bởi RevenueCat",
  "payment_entry_page.button_pay": "Thanh toán ngay",
  "payment_entry_page.button_start_trial": "Bắt đầu dùng thử",
  "success_page.purchase_successful": "Thanh toán hoàn tất",
  "success_page.button_close": "Tiếp tục",
  "error_page.if_error_persists": "Nếu lỗi vẫn tiếp diễn, vui lòng liên hệ ",
  "error_page.error_title_already_subscribed": "Bạn đã đăng ký {{productTitle}} rồi",
  "error_page.error_title_already_purchased": "Bạn đã mua {{productTitle}} rồi",
  "error_page.error_title_other_errors": "Có lỗi xảy ra",
  "error_page.error_message_already_subscribed": "Bạn không thể đăng ký sản phẩm này lần nữa.",
  "error_page.error_message_already_purchased": "Bạn không thể mua sản phẩm này lần nữa.",
  "error_page.error_message_missing_email_error": "Email bắt buộc để hoàn tất việc mua hàng.",
  "error_page.error_message_network_error": "Lỗi mạng. Vui lòng kiểm tra kết nối internet của bạn.",
  "error_page.error_message_error_charging_payment": "Thanh toán thất bại.",
  "error_page.error_message_error_setting_up_purchase": "Không thể bắt đầu mua do lỗi (mã lỗi: {{errorCode}}).",
  "error_page.error_message_invalid_tax_location": "Chúng tôi không thể xác minh địa chỉ thanh toán của bạn. Vui lòng kiểm tra lại mã bưu điện và quốc gia.",
  "error_page.error_message_unknown_error": "Đã xảy ra lỗi không xác định (mã lỗi: {{errorCode}}).",
  "error_page.button_try_again": "Thử lại",
  "paywall_variables.price_per_period": "{{formattedPrice}}/{{period}}",
  "paywall_variables.sub_relative_discount": "{{discount}}%",
  "paywall_variables.total_price_and_per_month": "{{formattedPrice}}/{{period}}({{formattedPricePerMonth}}/{{monthPeriod}})",
  "product_info.total_due_today": "Tổng số tiền phải trả hôm nay",
  "product_info.subscribe_to": "Đăng ký",
  "navbar_header.details": "Chi tiết",
  "navbar_header.back_button": "Quay lại",
  "pricing_dropdown.show_details": "Xem chi tiết",
  "pricing_dropdown.hide_details": "Ẩn chi tiết",
  "pricing_table.tax": "Thuế",
  "pricing_table.trial_ends": "Sau khi thời gian dùng thử kết thúc, vào {{formattedTrialEndDate}}",
  "pricing_table.total_due_today": "Tổng số tiền phải trả hôm nay",
  "pricing_table.total_excluding_tax": "Tổng cộng chưa bao gồm thuế",
  "pricing_table.enter_billing_address_to_calculate": "Nhập địa chỉ thanh toán để tính toán",
  "pricing_table.enter_state_or_postal_code_to_calculate": "Nhập tiểu bang hoặc mã bưu điện để tính toán",
  "pricing_table.enter_postal_code_to_calculate": "Nhập mã bưu điện để tính toán",
  "error_page.error_message_invalid_email_error": "Không thể xác minh địa chỉ email {{email}}. Vui lòng cung cấp một địa chỉ email hợp lệ.",
  "payment_entry_page.button_payment_method": "Thanh toán {{formattedPrice}} bằng {{paymentMethod}}",
  "payment_entry_page.button_with_price": "Thanh toán {{formattedPrice}}",
  "price_update.title": "Cập nhật giá",
  "price_update.base_message": "Tổng giá đã được cập nhật với thuế dựa trên địa chỉ thanh toán của bạn. Vui lòng xem lại và thử lại. Thẻ của bạn sẽ chỉ bị tính phí một lần.",
  "price_update.trial_message": "Giá đăng ký đã được cập nhật để bao gồm thuế dựa trên địa chỉ thanh toán của bạn. Thời gian dùng thử miễn phí vẫn được áp dụng. Vui lòng kiểm tra và thử lại.",
  "payment_entry_page.express_checkout_divider": "HOẶC THANH TOÁN BẰNG THẺ",
  "error_page.trouble_accessing": "Nếu bạn gặp sự cố khi truy cập giao dịch mua của mình, hãy liên hệ với bộ phận hỗ trợ theo địa chỉ ",
  "error_page.close_button_title": "Đi đến {{appName}}",
  "error_page.error_title_stripe_missing_required_permission": "Thiếu quyền Stripe",
  "error_page.button_close": "Đóng",
  "error_page.error_message_stripe_invalid_tax_origin_address": "Giao dịch mua không thành công vì địa chỉ gốc thuế không hợp lệ. Trong môi trường thực tế, giao dịch mua sẽ hoạt động mà không áp dụng thuế.",
  "error_page.error_message_stripe_tax_not_active": "Giao dịch mua không thành công vì Thuế Stripe chưa được bật. Trong môi trường thực tế, giao dịch mua sẽ hoạt động mà không áp dụng thuế.",
  "error_page.error_only_in_sandbox": "Thông báo này chỉ xuất hiện trong môi trường thử nghiệm.",
  "error_page.error_message_stripe_missing_required_permission": "Giao dịch mua không thành công vì ứng dụng Stripe thiếu một quyền cần thiết. Trong môi trường thực tế, giao dịch mua sẽ hoạt động mà không áp dụng thuế.",
  "error_page.error_title_stripe_tax_not_active": "Thuế Stripe chưa hoạt động",
  "error_page.error_title_stripe_invalid_tax_origin_address": "Địa chỉ gốc thuế không hợp lệ",
  "apple_pay.free_trial": "Dùng thử miễn phí",
  "product_info.price_after_intro_price": "Sau {{introPriceDuration}}, vào {{renewalDate}}",
  "product_info.after_trial": "sau khi dùng thử",
  "product_info.after": "sau",
  "product_info.intro_price_phase_after_trial": "Sau đó {{introPriceDuration}} với giá {{introPrice}}",
  "product_info.intro_price_phase": "{{introPriceDuration}} đầu tiên với giá {{introPrice}}",
  "product_info.intro_price_phase_paid_once": "trả một lần",
  "payment_entry_page.trial_subscription_terms_info": "Sau khi thời gian dùng thử của bạn kết thúc, bạn sẽ bị tính phí {{price}} {{perFrequency}} bắt đầu từ {{renewalDate}}. Bạn có thể hủy bất cứ lúc nào trước ngày này.",
  "payment_entry_page.subscription_info": "Gói đăng ký tự động gia hạn. Hủy bất cứ lúc nào.",
  "payment_entry_page.otp_terms_info": "Bằng cách mua, bạn đồng ý cho phép {{appName}} tính phí bạn theo các điều khoản của họ.",
  "payment_entry_page.terms_link_label": "Điều khoản",
  "payment_entry_page.subscription_terms_info": "Bằng cách đăng ký, bạn đồng ý cho phép {{appName}} tính phí bạn theo các điều khoản của họ cho đến khi bạn hủy.",
  "loading_page.keep_page_open": "Quá trình gần hoàn tất. Vui lòng giữ trang này mở.",
  "loading_page.processing_payment": "Đang xử lý thanh toán",
  "pricing_table.discount": "Giảm giá",
  "pricing_table.subtotal": "Tổng cộng"
};
var Z = /* @__PURE__ */ ((e) => (e.PeriodsWeek = "periods.week", e.PeriodsMonth = "periods.month", e.PeriodsYear = "periods.year", e.PeriodsDay = "periods.day", e.PeriodsWeekShort = "periods.weekShort", e.PeriodsMonthShort = "periods.monthShort", e.PeriodsYearShort = "periods.yearShort", e.PeriodsDayShort = "periods.dayShort", e.PeriodsLifetime = "periods.lifetime", e.PeriodsWeekPlural = "periods.weekPlural", e.PeriodsMonthPlural = "periods.monthPlural", e.PeriodsYearPlural = "periods.yearPlural", e.PeriodsDayPlural = "periods.dayPlural", e.PeriodsWeekFrequency = "periods.weekFrequency", e.PeriodsMonthFrequency = "periods.monthFrequency", e.PeriodsYearFrequency = "periods.yearFrequency", e.PeriodsDayFrequency = "periods.dayFrequency", e.PeriodsPerWeekFrequency = "periods.perWeekFrequency", e.PeriodsPerMonthFrequency = "periods.perMonthFrequency", e.PeriodsPerYearFrequency = "periods.perYearFrequency", e.PeriodsPerDayFrequency = "periods.perDayFrequency", e.PeriodsUnknownFrequency = "periods.unknownFrequency", e.PeriodsWeekFrequencyPlural = "periods.weekFrequencyPlural", e.PeriodsMonthFrequencyPlural = "periods.monthFrequencyPlural", e.PeriodsYearFrequencyPlural = "periods.yearFrequencyPlural", e.PeriodsDayFrequencyPlural = "periods.dayFrequencyPlural", e.ProductInfoProductTitle = "product_info.product_title", e.ProductInfoProductDescription = "product_info.product_description", e.ProductInfoProductPrice = "product_info.product_price", e.ProductInfoFreeTrialDuration = "product_info.free_trial_duration", e.ProductInfoPriceAfterFreeTrial = "product_info.price_after_free_trial", e.ProductInfoIntroPricePhaseAfterTrial = "product_info.intro_price_phase_after_trial", e.ProductInfoIntroPricePhasePaidOnce = "product_info.intro_price_phase_paid_once", e.ProductInfoIntroPricePhase = "product_info.intro_price_phase", e.ProductInfoPriceAfterIntroPrice = "product_info.price_after_intro_price", e.ProductInfoAfterTrial = "product_info.after_trial", e.ProductInfoAfter = "product_info.after", e.ProductInfoPriceTotalDueToday = "product_info.total_due_today", e.ProductInfoSubscribeTo = "product_info.subscribe_to", e.ProductInfoRenewalFrequency = "product_info.renewal_frequency", e.ProductInfoContinuesUntilCancelled = "product_info.continues_until_cancelled", e.ProductInfoCancelAnytime = "product_info.cancel_anytime", e.PaymentEntryPagePaymentStepTitle = "payment_entry_page.payment_step_title", e.PaymentEntryPageTrialSubscriptionTermsInfo = "payment_entry_page.trial_subscription_terms_info", e.PaymentEntryPageSubscriptionTermsInfo = "payment_entry_page.subscription_terms_info", e.PaymentEntryPageOtpTermsInfo = "payment_entry_page.otp_terms_info", e.PaymentEntryPageTermsLinkLabel = "payment_entry_page.terms_link_label", e.PaymentEntryPageSubscriptionInfo = "payment_entry_page.subscription_info", e.PaymentEntryPageButtonPay = "payment_entry_page.button_pay", e.PaymentEntryPageButtonStartTrial = "payment_entry_page.button_start_trial", e.PaymentEntryPageButtonWithPrice = "payment_entry_page.button_with_price", e.PaymentEntryPageButtonPaymentMethod = "payment_entry_page.button_payment_method", e.PaymentEntryPageExpressCheckoutDivider = "payment_entry_page.express_checkout_divider", e.SuccessPagePurchaseSuccessful = "success_page.purchase_successful", e.SuccessPageButtonClose = "success_page.button_close", e.LoadingPageProcessingPayment = "loading_page.processing_payment", e.LoadingPageKeepPageOpen = "loading_page.keep_page_open", e.ErrorPageCloseButtonTitle = "error_page.close_button_title", e.ErrorPageIfErrorPersists = "error_page.if_error_persists", e.ErrorPageTroubleAccessing = "error_page.trouble_accessing", e.ErrorPageErrorTitleAlreadySubscribed = "error_page.error_title_already_subscribed", e.ErrorPageErrorTitleAlreadyPurchased = "error_page.error_title_already_purchased", e.ErrorPageErrorTitleOtherErrors = "error_page.error_title_other_errors", e.ErrorPageErrorTitleStripeTaxNotActive = "error_page.error_title_stripe_tax_not_active", e.ErrorPageErrorTitleStripeInvalidTaxOriginAddress = "error_page.error_title_stripe_invalid_tax_origin_address", e.ErrorPageErrorTitleStripeMissingRequiredPermission = "error_page.error_title_stripe_missing_required_permission", e.ErrorPageErrorMessageAlreadySubscribed = "error_page.error_message_already_subscribed", e.ErrorPageErrorMessageAlreadyPurchased = "error_page.error_message_already_purchased", e.ErrorPageErrorMessageMissingEmailError = "error_page.error_message_missing_email_error", e.ErrorPageErrorMessageInvalidEmailError = "error_page.error_message_invalid_email_error", e.ErrorPageErrorMessageNetworkError = "error_page.error_message_network_error", e.ErrorPageErrorMessageErrorChargingPayment = "error_page.error_message_error_charging_payment", e.ErrorPageErrorMessageErrorSettingUpPurchase = "error_page.error_message_error_setting_up_purchase", e.ErrorPageErrorMessageUnknownError = "error_page.error_message_unknown_error", e.ErrorPageErrorMessageInvalidTaxLocation = "error_page.error_message_invalid_tax_location", e.ErrorPageErrorMessageStripeTaxNotActive = "error_page.error_message_stripe_tax_not_active", e.ErrorPageErrorMessageStripeInvalidTaxOriginAddress = "error_page.error_message_stripe_invalid_tax_origin_address", e.ErrorPageErrorMessageStripeMissingRequiredPermission = "error_page.error_message_stripe_missing_required_permission", e.ErrorPageErrorMessageOnlyInSandbox = "error_page.error_only_in_sandbox", e.ErrorButtonTryAgain = "error_page.button_try_again", e.ErrorButtonClose = "error_page.button_close", e.PaywallVariablesPricePerPeriod = "paywall_variables.price_per_period", e.PaywallVariablesSubRelativeDiscount = "paywall_variables.sub_relative_discount", e.PaywallVariablesTotalPriceAndPerMonth = "paywall_variables.total_price_and_per_month", e.PricingDropdownShowDetails = "pricing_dropdown.show_details", e.PricingDropdownHideDetails = "pricing_dropdown.hide_details", e.PricingTotalExcludingTax = "pricing_table.total_excluding_tax", e.PricingTableTrialEnds = "pricing_table.trial_ends", e.PricingTableTotalDueToday = "pricing_table.total_due_today", e.PricingTableSubtotal = "pricing_table.subtotal", e.PricingTableDiscount = "pricing_table.discount", e.PricingTableTax = "pricing_table.tax", e.PricingTableEnterBillingAddressToCalculate = "pricing_table.enter_billing_address_to_calculate", e.PricingTableEnterStateOrPostalCodeToCalculate = "pricing_table.enter_state_or_postal_code_to_calculate", e.PricingTableEnterPostalCodeToCalculate = "pricing_table.enter_postal_code_to_calculate", e.NavbarHeaderDetails = "navbar_header.details", e.NavbarBackButton = "navbar_header.back_button", e.PriceUpdateTitle = "price_update.title", e.PriceUpdateBaseMessage = "price_update.base_message", e.PriceUpdateTrialMessage = "price_update.trial_message", e.ApplePayFreeTrial = "apple_pay.free_trial", e))(Z || {});
const Og = {
  en: og,
  es: ig,
  it: sg,
  ar: lg,
  ca: cg,
  zh_Hans: ug,
  zh_Hant: dg,
  hr: pg,
  cs: _g,
  da: gg,
  nl: fg,
  fi: mg,
  fr: hg,
  de: yg,
  el: bg,
  he: vg,
  hi: kg,
  hu: wg,
  id: Pg,
  ja: xg,
  ko: Eg,
  ms: Sg,
  no: Tg,
  pl: Ig,
  pt: Dg,
  ro: Cg,
  ru: Ag,
  sk: qg,
  sv: Fg,
  th: zg,
  tr: Mg,
  uk: jg,
  vi: Ng
};
var ce = /* @__PURE__ */ ((e) => (e.Year = "year", e.Month = "month", e.Week = "week", e.Day = "day", e))(ce || {});
function qs(e) {
  const r = e.match(/^PT?([0-9]+)([MDYW])$/);
  if (!r || r.length < 3)
    return se.errorLog(`Invalid ISO 8601 duration format: ${e}`), null;
  const t = parseInt(r[1]);
  switch (r[2]) {
    case "Y":
      return {
        number: t,
        unit: "year"
        /* Year */
      };
    case "M":
      return {
        number: t,
        unit: "month"
        /* Month */
      };
    case "W":
      return {
        number: t,
        unit: "week"
        /* Week */
      };
    case "D":
      return {
        number: t,
        unit: "day"
        /* Day */
      };
    default:
      return se.errorLog(`Invalid ISO 8601 unit duration format: ${e}`), null;
  }
}
function Ki(e, r, t) {
  if (!t)
    return null;
  let n = new Date(e);
  switch (r.unit) {
    case "year":
      n.getDate() === 29 && n.getMonth() === 1 && r.number !== 4 ? n.setFullYear(
        n.getFullYear() + r.number,
        n.getMonth(),
        28
      ) : n.setFullYear(
        n.getFullYear() + r.number,
        n.getMonth(),
        n.getDate()
      );
      break;
    case "month":
      n.setMonth(n.getMonth() + r.number, n.getDate()), n.getDate() !== e.getDate() && (n = new Date(e), n.setMonth(n.getMonth() + r.number + 1, 0));
      break;
    case "week":
      n.setDate(n.getDate() + r.number * 7);
      break;
    case "day":
      n.setDate(n.getDate() + r.number);
      break;
  }
  return n;
}
const Wn = (e) => {
  if (!e)
    return e;
  const r = e.replace(/_/g, "-");
  try {
    const [n] = Intl.getCanonicalLocales(r);
    if (n)
      return n;
  } catch {
  }
  const t = r.split("-")[0];
  try {
    const [n] = Intl.getCanonicalLocales(t);
    if (n)
      return n;
  } catch {
  }
  return t;
}, Lg = (e) => e / 1e6, nn = (e, r, t, n = {}) => {
  const a = Lg(e), o = {
    style: "currency",
    currency: r,
    currencyDisplay: "symbol",
    ...n,
    // Some browsers require minimumFractionDigits to be set if maximumFractionDigits is set.
    minimumFractionDigits: n.maximumFractionDigits
  };
  return new Intl.NumberFormat(
    Wn(t),
    o
  ).format(a).replace("US$", "$");
}, Bg = (e, r) => {
  const t = qs(e);
  return t ? r.translatePeriod(t.number, t.unit) || `${t.number} ${t.unit}s` : e;
}, Ug = (e) => {
  try {
    return e.charAt(0).toUpperCase() + e.slice(1);
  } catch {
    return e;
  }
}, Yn = {
  noWhitespace: !1,
  short: !1
}, Lu = {
  useMultipleWords: !1
};
class En {
  constructor(r = {}, t = Ar, n = Ar) {
    U(this, "locales", {});
    this.selectedLocale = t, this.defaultLocale = n;
    const a = {};
    Object.entries(Og).forEach(([o, s]) => {
      a[o] = new El(s, o);
    }), this.locales = a, r && this.override(r);
  }
  static fallback() {
    return new En();
  }
  override(r) {
    Object.entries(r).forEach(([t, n]) => {
      this.locales[t] = new El(
        {
          ...this.locales[t].labels || {},
          ...n
        },
        this.getLanguageCodeString(t)
      );
    });
  }
  formatPrice(r, t) {
    const n = { currencyDisplay: "narrowSymbol" };
    r === 0 && (n.maximumFractionDigits = 0);
    try {
      return nn(
        r,
        t,
        this.bcp47Locale,
        n
      );
    } catch {
      se.errorLog(
        `Failed to create a price formatter for locale: ${this.bcp47Locale}`
      );
    }
    try {
      return nn(
        r,
        t,
        this.fallbackBcp47Locale,
        n
      );
    } catch {
      se.errorLog(
        `Failed to create a price formatter for locale: ${this.fallbackBcp47Locale}`
      );
    }
    return nn(
      r,
      t,
      Ar,
      n
    );
  }
  /**
   * Returns the locale in a format that is compatible with other JS libraries.
   * This is particularly important for zh_Hans and zh_Hant that are instead
   * represented as zh-Hans and zh-Hant in Intl.DateTimeFormat.
   */
  get bcp47Locale() {
    var r;
    return Wn((r = this.getLocaleInstance(this.selectedLocale)) == null ? void 0 : r.localeKey) || Wn(this.getLanguageCodeString(this.selectedLocale)) || Ar;
  }
  /**
   * Returns the fallback locale in a format that is compatible with other JS
   * libraries.
   * This is particularly important for zh_Hans and zh_Hant that are instead
   * represented as zh-Hans and zh-Hant in Intl.DateTimeFormat.
   */
  get fallbackBcp47Locale() {
    var r;
    return Wn((r = this.getLocaleInstance(this.defaultLocale)) == null ? void 0 : r.localeKey) || Wn(this.getLanguageCodeString(this.defaultLocale)) || Ar;
  }
  getLanguageCodeString(r) {
    return r.split("_")[0].split("-")[0];
  }
  getLocaleInstance(r) {
    const t = this.getLanguageCodeString(r);
    return this.locales[r] || this.locales[t];
  }
  translate(r, t) {
    const n = this.getLocaleInstance(this.selectedLocale), a = this.getLocaleInstance(this.defaultLocale);
    return (n == null ? void 0 : n.translate(r, t)) || (a == null ? void 0 : a.translate(r, t)) || "";
  }
  formatCountry(r) {
    return new Intl.DisplayNames([this.bcp47Locale], { type: "region" }).of(
      r
    ) || r;
  }
  translatePeriod(r, t, n = Yn) {
    const a = this.getLocaleInstance(this.selectedLocale), o = this.getLocaleInstance(this.defaultLocale);
    return (a == null ? void 0 : a.translatePeriod(r, t, n)) || (o == null ? void 0 : o.translatePeriod(r, t, n));
  }
  translatePeriodUnit(r, t = Yn) {
    const n = this.getLocaleInstance(this.selectedLocale), a = this.getLocaleInstance(this.defaultLocale);
    return (n == null ? void 0 : n.translatePeriodUnit(r, t)) || (a == null ? void 0 : a.translatePeriodUnit(r, t));
  }
  translatePeriodFrequency(r, t, n = Lu) {
    const a = this.getLocaleInstance(this.selectedLocale), o = this.getLocaleInstance(this.defaultLocale);
    return (a == null ? void 0 : a.translatePeriodFrequency(r, t, n)) || (o == null ? void 0 : o.translatePeriodFrequency(r, t, n));
  }
  translateDate(r, t = {}) {
    const n = this.getLocaleInstance(this.selectedLocale), a = this.getLocaleInstance(this.defaultLocale);
    return (n == null ? void 0 : n.translateDate(r, t)) || (a == null ? void 0 : a.translateDate(r, t));
  }
}
class El {
  constructor(r = {}, t) {
    this.labels = r, this.localeKey = t;
  }
  replaceVariables(r, t) {
    return Object.entries(t).reduce(
      (n, [a, o]) => n.replace(
        `{{${a}}}`,
        `${o ?? ""}`
      ),
      r
    );
  }
  translate(r, t) {
    const n = this.labels[r];
    if (n)
      return this.replaceVariables(n, t || {});
  }
  translatePeriod(r, t, n = Yn) {
    var l;
    const { noWhitespace: a, short: o } = {
      ...Yn,
      ...n
    }, s = o ? `periods.${t}Short` : Math.abs(r) === 1 ? `periods.${t}` : `periods.${t}Plural`;
    return (l = this.translate(s, {
      amount: r.toString()
    })) == null ? void 0 : l.replace(" ", a ? "" : " ");
  }
  translatePeriodUnit(r, t = Yn) {
    var s;
    const { noWhitespace: n, short: a } = {
      ...Yn,
      ...t
    }, o = `periods.${r}${a ? "Short" : ""}`;
    return (s = this.translate(o, { amount: "" })) == null ? void 0 : s.replace(
      " ",
      n ? "" : " "
    );
  }
  translatePeriodFrequency(r, t, n = Lu) {
    const a = n == null ? void 0 : n.useMultipleWords, o = Math.abs(r) === 1 ? `periods.${a === !0 ? "per" : ""}${a ? Ug(t.toString()) : t}Frequency` : `periods.${t}FrequencyPlural`;
    return this.translate(o, {
      amount: r.toString()
    });
  }
  translateDate(r, t = {}) {
    return r.toLocaleDateString(Wn(this.localeKey), t);
  }
}
Zp();
const Rg = `<svg viewBox="0 0 124 124" fill="var(--rc-color-grey-text-dark)" xmlns="http://www.w3.org/2000/svg">
    <circle cx="62" cy="62" r="62" fill="var(--rc-color-grey-text-dark)" opacity="0.2"/>
    <path d="M87.6668 41.504L82.4968 36.334L62.0002 56.8307L41.5035 36.334L36.3335 41.504L56.8302 62.0006L36.3335 82.4973L41.5035 87.6673L62.0002 67.1706L82.4968 87.6673L87.6668 82.4973L67.1702 62.0006L87.6668 41.504Z"
          />
</svg>
`;
var Vg = /* @__PURE__ */ B('<div style="color:var(--rc-color-primary);"><!></div>');
function Bu(e) {
  var r = Vg(), t = F(r);
  cn(t, () => Rg), T(e, r);
}
const Uu = Symbol("inputValidation"), Ru = Symbol("initialInputSelections");
function Hg() {
  const e = Vr(!0);
  return {
    isSatisfied: e,
    updateSatisfaction: (t) => {
      e.set(t);
    }
  };
}
function Wg(e) {
  ir(Uu, e);
}
function Fs() {
  return Be(Uu);
}
function Yg(e) {
  ir(Ru, e);
}
function Vu() {
  return Be(Ru) ?? {};
}
const Hu = Symbol("paywall");
function Wu(e) {
  ir(Hu, e);
}
function un() {
  const e = Be(Hu);
  if (e === void 0)
    throw new Error("Paywall context not found");
  return e;
}
const Yu = Symbol("selected");
function Ro(e) {
  ir(Yu, e);
}
function rt() {
  return Be(Yu) ?? Ct(!1);
}
function Gg({ stack: e, sticky_footer: r }) {
  const t = (a) => {
    if (a.type === "package" && a.is_selected_by_default)
      return a;
    if ("components" in a && Array.isArray(a.components))
      for (const o of a.components) {
        const s = t(o);
        if (s !== void 0)
          return s;
      }
    if ("stack" in a) {
      const o = t(a.stack);
      if (o !== void 0)
        return o;
    }
  }, n = t(e);
  if (n !== void 0)
    return n == null ? void 0 : n.package_id;
  if (r != null) {
    const a = t(r);
    if (a !== void 0)
      return a == null ? void 0 : a.package_id;
  }
}
const tt = (e, r) => {
  if (!e)
    return {};
  const t = r == null ? void 0 : r.find((n) => n.conditions.find((a) => a.type === "selected"));
  return (t == null ? void 0 : t.properties) ?? {};
}, Kg = (e, r) => {
  if (!e)
    return {};
  const t = r == null ? void 0 : r.find((n) => n.conditions.find((a) => a.type === "hover"));
  return (t == null ? void 0 : t.properties) ?? {};
}, $g = (e, r) => {
  if (!e)
    return {};
  const t = r == null ? void 0 : r.find((n) => n.conditions.find((a) => a.type === "intro_offer" || a.type === "introductory_offer"));
  return (t == null ? void 0 : t.properties) ?? {};
};
function Xg(e, r) {
  re(r, !0);
  const t = () => he(l, "$selectedState", a), n = () => he(g, "$inputSatisfied", a), [a, o] = je(), s = /* @__PURE__ */ cr(r, ["$$slots", "$$events", "$$legacy"]), l = rt(), c = /* @__PURE__ */ b(() => ({
    ...s,
    ...tt(t(), r.overrides)
  })), u = /* @__PURE__ */ b(() => i(c).action), { onButtonAction: d, hideBackButtons: p } = un(), _ = Fs(), g = (_ == null ? void 0 : _.isSatisfied) ?? Ct(!0), f = /* @__PURE__ */ b(() => i(u).type === "workflow" && !n()), w = () => {
    var S;
    if (i(f)) return;
    const E = (S = r.triggers) == null ? void 0 : S.on_press;
    d(r.action, E);
  }, k = /* @__PURE__ */ b(() => {
    switch (i(u).type) {
      case "workflow":
        return !0;
      case "restore_purchases":
        return !1;
      case "navigate_back":
        return !p;
      case "navigate_to":
        return i(u).destination !== "web_paywall_link";
      default:
        return !0;
    }
  }), m = /* @__PURE__ */ b(() => i(f) ? {
    opacity: "0.4",
    "pointer-events": "none",
    cursor: "not-allowed"
  } : {});
  var h = ve(), v = Q(h);
  {
    var y = (E) => {
      {
        let S = /* @__PURE__ */ b(() => `button-${i(u).type}`);
        dr(E, He(() => r.stack, {
          onclick: w,
          get style() {
            return i(m);
          },
          get testId() {
            return i(S);
          }
        }));
      }
    };
    W(v, (E) => {
      i(k) && E(y);
    });
  }
  T(e, h), te(), o();
}
const Gu = Symbol("inputChoice");
function Ku(e, r, t = !1, n = null, a = []) {
  const o = Vr(new Set(a)), s = lt(o, (d) => (n == null ? void 0 : n.max) == null ? !1 : d.size >= n.max), l = lt(o, (d) => {
    const p = d.size;
    return !t && n == null ? !0 : t && n == null ? p >= 1 : t && n != null ? n.min === n.max ? p === n.min : p >= n.min && p <= n.max : !0;
  });
  let c = !1;
  return s.subscribe((d) => c = d), {
    fieldId: e,
    mode: r,
    required: t,
    selectionRange: n,
    selectedOptionIds: o,
    selectOption: (d) => {
      o.update((p) => {
        if (r === "single")
          return /* @__PURE__ */ new Set([d]);
        const _ = new Set(p);
        return _.has(d) ? _.delete(d) : c || _.add(d), _;
      });
    },
    isAtMax: s,
    isSatisfied: l
  };
}
function $u(e) {
  ir(Gu, e);
}
function Zg() {
  return Be(Gu);
}
function Jg(e, r) {
  re(r, !0);
  const t = /* @__PURE__ */ cr(r, ["$$slots", "$$events", "$$legacy"]), { stack: n, field_id: a, required: o = !1, selection_range: s = null } = t, c = Vu()[a] ?? [], u = Ku(a, "multiple", o, s, c);
  $u(u);
  const d = Fs();
  if (d) {
    const p = u.isSatisfied.subscribe((_) => {
      d.updateSatisfaction(_);
    });
    ln(p);
  }
  Sa(e, {
    get nodeData() {
      return n;
    }
  }), te();
}
const Xu = Symbol("hover");
function Qg(e) {
  ir(Xu, e);
}
function ef() {
  return Be(Xu) ?? Ct(!1);
}
var rf = /* @__PURE__ */ B('<div class="option-wrapper svelte-i3lbxb"><!></div>');
const tf = {
  hash: "svelte-i3lbxb",
  code: ".option-wrapper.svelte-i3lbxb {display:contents;}"
};
function nf(e, r) {
  re(r, !0), ie(e, tf);
  const t = () => he(p, "$isDisabled", n), [n, a] = je(), o = /* @__PURE__ */ cr(r, ["$$slots", "$$events", "$$legacy"]), { stack: s, option_id: l } = o, { onButtonAction: c } = un(), u = Zg(), d = u ? lt(u.selectedOptionIds, (v) => v.has(l)) : Ct(!1);
  Ro(d);
  const p = u ? lt([d, u.isAtMax], ([v, y]) => !v && y) : Ct(!1), _ = Vr(!1);
  Qg(_);
  const g = () => _.set(!0), f = () => _.set(!1), w = () => {
    var y;
    if (t()) return;
    const v = (y = r.triggers) == null ? void 0 : y.on_press;
    u == null || u.selectOption(l), c({ type: "workflow" }, v);
  }, k = /* @__PURE__ */ b(() => t() ? { "pointer-events": "none", opacity: "0.4" } : void 0);
  var m = rf(), h = F(m);
  dr(h, He(() => s, {
    onclick: w,
    get style() {
      return i(k);
    }
  })), Ur("mouseenter", m, g), Ur("mouseleave", m, f), T(e, m), te(), a();
}
function af(e, r) {
  re(r, !0);
  const t = /* @__PURE__ */ cr(r, ["$$slots", "$$events", "$$legacy"]), { stack: n, field_id: a, required: o = !1, selection_range: s = null } = t, c = Vu()[a] ?? [], u = Ku(a, "single", o, s, c);
  $u(u);
  const d = Fs();
  if (d) {
    const p = u.isSatisfied.subscribe((_) => {
      d.updateSatisfaction(_);
    });
    ln(p);
  }
  Sa(e, {
    get nodeData() {
      return n;
    }
  }), te();
}
const Zu = Symbol("variables");
function zs(e) {
  ir(Zu, e);
}
function Vo() {
  const e = Be(Zu);
  if (e === void 0)
    throw new Error("Variables context not found");
  return e;
}
function of(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Ln = {}, ri, Sl;
function sf() {
  return Sl || (Sl = 1, ri = function() {
    return typeof Promise == "function" && Promise.prototype && Promise.prototype.then;
  }), ri;
}
var ti = {}, $t = {}, Tl;
function Cn() {
  if (Tl) return $t;
  Tl = 1;
  let e;
  const r = [
    0,
    // Not used
    26,
    44,
    70,
    100,
    134,
    172,
    196,
    242,
    292,
    346,
    404,
    466,
    532,
    581,
    655,
    733,
    815,
    901,
    991,
    1085,
    1156,
    1258,
    1364,
    1474,
    1588,
    1706,
    1828,
    1921,
    2051,
    2185,
    2323,
    2465,
    2611,
    2761,
    2876,
    3034,
    3196,
    3362,
    3532,
    3706
  ];
  return $t.getSymbolSize = function(n) {
    if (!n) throw new Error('"version" cannot be null or undefined');
    if (n < 1 || n > 40) throw new Error('"version" should be in range from 1 to 40');
    return n * 4 + 17;
  }, $t.getSymbolTotalCodewords = function(n) {
    return r[n];
  }, $t.getBCHDigit = function(t) {
    let n = 0;
    for (; t !== 0; )
      n++, t >>>= 1;
    return n;
  }, $t.setToSJISFunction = function(n) {
    if (typeof n != "function")
      throw new Error('"toSJISFunc" is not a valid function.');
    e = n;
  }, $t.isKanjiModeEnabled = function() {
    return typeof e < "u";
  }, $t.toSJIS = function(n) {
    return e(n);
  }, $t;
}
var ni = {}, Il;
function Ms() {
  return Il || (Il = 1, function(e) {
    e.L = { bit: 1 }, e.M = { bit: 0 }, e.Q = { bit: 3 }, e.H = { bit: 2 };
    function r(t) {
      if (typeof t != "string")
        throw new Error("Param is not a string");
      switch (t.toLowerCase()) {
        case "l":
        case "low":
          return e.L;
        case "m":
        case "medium":
          return e.M;
        case "q":
        case "quartile":
          return e.Q;
        case "h":
        case "high":
          return e.H;
        default:
          throw new Error("Unknown EC Level: " + t);
      }
    }
    e.isValid = function(n) {
      return n && typeof n.bit < "u" && n.bit >= 0 && n.bit < 4;
    }, e.from = function(n, a) {
      if (e.isValid(n))
        return n;
      try {
        return r(n);
      } catch {
        return a;
      }
    };
  }(ni)), ni;
}
var ai, Dl;
function lf() {
  if (Dl) return ai;
  Dl = 1;
  function e() {
    this.buffer = [], this.length = 0;
  }
  return e.prototype = {
    get: function(r) {
      const t = Math.floor(r / 8);
      return (this.buffer[t] >>> 7 - r % 8 & 1) === 1;
    },
    put: function(r, t) {
      for (let n = 0; n < t; n++)
        this.putBit((r >>> t - n - 1 & 1) === 1);
    },
    getLengthInBits: function() {
      return this.length;
    },
    putBit: function(r) {
      const t = Math.floor(this.length / 8);
      this.buffer.length <= t && this.buffer.push(0), r && (this.buffer[t] |= 128 >>> this.length % 8), this.length++;
    }
  }, ai = e, ai;
}
var oi, Cl;
function cf() {
  if (Cl) return oi;
  Cl = 1;
  function e(r) {
    if (!r || r < 1)
      throw new Error("BitMatrix size must be defined and greater than 0");
    this.size = r, this.data = new Uint8Array(r * r), this.reservedBit = new Uint8Array(r * r);
  }
  return e.prototype.set = function(r, t, n, a) {
    const o = r * this.size + t;
    this.data[o] = n, a && (this.reservedBit[o] = !0);
  }, e.prototype.get = function(r, t) {
    return this.data[r * this.size + t];
  }, e.prototype.xor = function(r, t, n) {
    this.data[r * this.size + t] ^= n;
  }, e.prototype.isReserved = function(r, t) {
    return this.reservedBit[r * this.size + t];
  }, oi = e, oi;
}
var ii = {}, Al;
function uf() {
  return Al || (Al = 1, function(e) {
    const r = Cn().getSymbolSize;
    e.getRowColCoords = function(n) {
      if (n === 1) return [];
      const a = Math.floor(n / 7) + 2, o = r(n), s = o === 145 ? 26 : Math.ceil((o - 13) / (2 * a - 2)) * 2, l = [o - 7];
      for (let c = 1; c < a - 1; c++)
        l[c] = l[c - 1] - s;
      return l.push(6), l.reverse();
    }, e.getPositions = function(n) {
      const a = [], o = e.getRowColCoords(n), s = o.length;
      for (let l = 0; l < s; l++)
        for (let c = 0; c < s; c++)
          l === 0 && c === 0 || // top-left
          l === 0 && c === s - 1 || // bottom-left
          l === s - 1 && c === 0 || a.push([o[l], o[c]]);
      return a;
    };
  }(ii)), ii;
}
var si = {}, ql;
function df() {
  if (ql) return si;
  ql = 1;
  const e = Cn().getSymbolSize, r = 7;
  return si.getPositions = function(n) {
    const a = e(n);
    return [
      // top-left
      [0, 0],
      // top-right
      [a - r, 0],
      // bottom-left
      [0, a - r]
    ];
  }, si;
}
var li = {}, Fl;
function pf() {
  return Fl || (Fl = 1, function(e) {
    e.Patterns = {
      PATTERN000: 0,
      PATTERN001: 1,
      PATTERN010: 2,
      PATTERN011: 3,
      PATTERN100: 4,
      PATTERN101: 5,
      PATTERN110: 6,
      PATTERN111: 7
    };
    const r = {
      N1: 3,
      N2: 3,
      N3: 40,
      N4: 10
    };
    e.isValid = function(a) {
      return a != null && a !== "" && !isNaN(a) && a >= 0 && a <= 7;
    }, e.from = function(a) {
      return e.isValid(a) ? parseInt(a, 10) : void 0;
    }, e.getPenaltyN1 = function(a) {
      const o = a.size;
      let s = 0, l = 0, c = 0, u = null, d = null;
      for (let p = 0; p < o; p++) {
        l = c = 0, u = d = null;
        for (let _ = 0; _ < o; _++) {
          let g = a.get(p, _);
          g === u ? l++ : (l >= 5 && (s += r.N1 + (l - 5)), u = g, l = 1), g = a.get(_, p), g === d ? c++ : (c >= 5 && (s += r.N1 + (c - 5)), d = g, c = 1);
        }
        l >= 5 && (s += r.N1 + (l - 5)), c >= 5 && (s += r.N1 + (c - 5));
      }
      return s;
    }, e.getPenaltyN2 = function(a) {
      const o = a.size;
      let s = 0;
      for (let l = 0; l < o - 1; l++)
        for (let c = 0; c < o - 1; c++) {
          const u = a.get(l, c) + a.get(l, c + 1) + a.get(l + 1, c) + a.get(l + 1, c + 1);
          (u === 4 || u === 0) && s++;
        }
      return s * r.N2;
    }, e.getPenaltyN3 = function(a) {
      const o = a.size;
      let s = 0, l = 0, c = 0;
      for (let u = 0; u < o; u++) {
        l = c = 0;
        for (let d = 0; d < o; d++)
          l = l << 1 & 2047 | a.get(u, d), d >= 10 && (l === 1488 || l === 93) && s++, c = c << 1 & 2047 | a.get(d, u), d >= 10 && (c === 1488 || c === 93) && s++;
      }
      return s * r.N3;
    }, e.getPenaltyN4 = function(a) {
      let o = 0;
      const s = a.data.length;
      for (let c = 0; c < s; c++) o += a.data[c];
      return Math.abs(Math.ceil(o * 100 / s / 5) - 10) * r.N4;
    };
    function t(n, a, o) {
      switch (n) {
        case e.Patterns.PATTERN000:
          return (a + o) % 2 === 0;
        case e.Patterns.PATTERN001:
          return a % 2 === 0;
        case e.Patterns.PATTERN010:
          return o % 3 === 0;
        case e.Patterns.PATTERN011:
          return (a + o) % 3 === 0;
        case e.Patterns.PATTERN100:
          return (Math.floor(a / 2) + Math.floor(o / 3)) % 2 === 0;
        case e.Patterns.PATTERN101:
          return a * o % 2 + a * o % 3 === 0;
        case e.Patterns.PATTERN110:
          return (a * o % 2 + a * o % 3) % 2 === 0;
        case e.Patterns.PATTERN111:
          return (a * o % 3 + (a + o) % 2) % 2 === 0;
        default:
          throw new Error("bad maskPattern:" + n);
      }
    }
    e.applyMask = function(a, o) {
      const s = o.size;
      for (let l = 0; l < s; l++)
        for (let c = 0; c < s; c++)
          o.isReserved(c, l) || o.xor(c, l, t(a, c, l));
    }, e.getBestMask = function(a, o) {
      const s = Object.keys(e.Patterns).length;
      let l = 0, c = 1 / 0;
      for (let u = 0; u < s; u++) {
        o(u), e.applyMask(u, a);
        const d = e.getPenaltyN1(a) + e.getPenaltyN2(a) + e.getPenaltyN3(a) + e.getPenaltyN4(a);
        e.applyMask(u, a), d < c && (c = d, l = u);
      }
      return l;
    };
  }(li)), li;
}
var to = {}, zl;
function Ju() {
  if (zl) return to;
  zl = 1;
  const e = Ms(), r = [
    // L  M  Q  H
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    2,
    1,
    2,
    2,
    4,
    1,
    2,
    4,
    4,
    2,
    4,
    4,
    4,
    2,
    4,
    6,
    5,
    2,
    4,
    6,
    6,
    2,
    5,
    8,
    8,
    4,
    5,
    8,
    8,
    4,
    5,
    8,
    11,
    4,
    8,
    10,
    11,
    4,
    9,
    12,
    16,
    4,
    9,
    16,
    16,
    6,
    10,
    12,
    18,
    6,
    10,
    17,
    16,
    6,
    11,
    16,
    19,
    6,
    13,
    18,
    21,
    7,
    14,
    21,
    25,
    8,
    16,
    20,
    25,
    8,
    17,
    23,
    25,
    9,
    17,
    23,
    34,
    9,
    18,
    25,
    30,
    10,
    20,
    27,
    32,
    12,
    21,
    29,
    35,
    12,
    23,
    34,
    37,
    12,
    25,
    34,
    40,
    13,
    26,
    35,
    42,
    14,
    28,
    38,
    45,
    15,
    29,
    40,
    48,
    16,
    31,
    43,
    51,
    17,
    33,
    45,
    54,
    18,
    35,
    48,
    57,
    19,
    37,
    51,
    60,
    19,
    38,
    53,
    63,
    20,
    40,
    56,
    66,
    21,
    43,
    59,
    70,
    22,
    45,
    62,
    74,
    24,
    47,
    65,
    77,
    25,
    49,
    68,
    81
  ], t = [
    // L  M  Q  H
    7,
    10,
    13,
    17,
    10,
    16,
    22,
    28,
    15,
    26,
    36,
    44,
    20,
    36,
    52,
    64,
    26,
    48,
    72,
    88,
    36,
    64,
    96,
    112,
    40,
    72,
    108,
    130,
    48,
    88,
    132,
    156,
    60,
    110,
    160,
    192,
    72,
    130,
    192,
    224,
    80,
    150,
    224,
    264,
    96,
    176,
    260,
    308,
    104,
    198,
    288,
    352,
    120,
    216,
    320,
    384,
    132,
    240,
    360,
    432,
    144,
    280,
    408,
    480,
    168,
    308,
    448,
    532,
    180,
    338,
    504,
    588,
    196,
    364,
    546,
    650,
    224,
    416,
    600,
    700,
    224,
    442,
    644,
    750,
    252,
    476,
    690,
    816,
    270,
    504,
    750,
    900,
    300,
    560,
    810,
    960,
    312,
    588,
    870,
    1050,
    336,
    644,
    952,
    1110,
    360,
    700,
    1020,
    1200,
    390,
    728,
    1050,
    1260,
    420,
    784,
    1140,
    1350,
    450,
    812,
    1200,
    1440,
    480,
    868,
    1290,
    1530,
    510,
    924,
    1350,
    1620,
    540,
    980,
    1440,
    1710,
    570,
    1036,
    1530,
    1800,
    570,
    1064,
    1590,
    1890,
    600,
    1120,
    1680,
    1980,
    630,
    1204,
    1770,
    2100,
    660,
    1260,
    1860,
    2220,
    720,
    1316,
    1950,
    2310,
    750,
    1372,
    2040,
    2430
  ];
  return to.getBlocksCount = function(a, o) {
    switch (o) {
      case e.L:
        return r[(a - 1) * 4 + 0];
      case e.M:
        return r[(a - 1) * 4 + 1];
      case e.Q:
        return r[(a - 1) * 4 + 2];
      case e.H:
        return r[(a - 1) * 4 + 3];
      default:
        return;
    }
  }, to.getTotalCodewordsCount = function(a, o) {
    switch (o) {
      case e.L:
        return t[(a - 1) * 4 + 0];
      case e.M:
        return t[(a - 1) * 4 + 1];
      case e.Q:
        return t[(a - 1) * 4 + 2];
      case e.H:
        return t[(a - 1) * 4 + 3];
      default:
        return;
    }
  }, to;
}
var ci = {}, va = {}, Ml;
function _f() {
  if (Ml) return va;
  Ml = 1;
  const e = new Uint8Array(512), r = new Uint8Array(256);
  return function() {
    let n = 1;
    for (let a = 0; a < 255; a++)
      e[a] = n, r[n] = a, n <<= 1, n & 256 && (n ^= 285);
    for (let a = 255; a < 512; a++)
      e[a] = e[a - 255];
  }(), va.log = function(n) {
    if (n < 1) throw new Error("log(" + n + ")");
    return r[n];
  }, va.exp = function(n) {
    return e[n];
  }, va.mul = function(n, a) {
    return n === 0 || a === 0 ? 0 : e[r[n] + r[a]];
  }, va;
}
var jl;
function gf() {
  return jl || (jl = 1, function(e) {
    const r = _f();
    e.mul = function(n, a) {
      const o = new Uint8Array(n.length + a.length - 1);
      for (let s = 0; s < n.length; s++)
        for (let l = 0; l < a.length; l++)
          o[s + l] ^= r.mul(n[s], a[l]);
      return o;
    }, e.mod = function(n, a) {
      let o = new Uint8Array(n);
      for (; o.length - a.length >= 0; ) {
        const s = o[0];
        for (let c = 0; c < a.length; c++)
          o[c] ^= r.mul(a[c], s);
        let l = 0;
        for (; l < o.length && o[l] === 0; ) l++;
        o = o.slice(l);
      }
      return o;
    }, e.generateECPolynomial = function(n) {
      let a = new Uint8Array([1]);
      for (let o = 0; o < n; o++)
        a = e.mul(a, new Uint8Array([1, r.exp(o)]));
      return a;
    };
  }(ci)), ci;
}
var ui, Nl;
function ff() {
  if (Nl) return ui;
  Nl = 1;
  const e = gf();
  function r(t) {
    this.genPoly = void 0, this.degree = t, this.degree && this.initialize(this.degree);
  }
  return r.prototype.initialize = function(n) {
    this.degree = n, this.genPoly = e.generateECPolynomial(this.degree);
  }, r.prototype.encode = function(n) {
    if (!this.genPoly)
      throw new Error("Encoder not initialized");
    const a = new Uint8Array(n.length + this.degree);
    a.set(n);
    const o = e.mod(a, this.genPoly), s = this.degree - o.length;
    if (s > 0) {
      const l = new Uint8Array(this.degree);
      return l.set(o, s), l;
    }
    return o;
  }, ui = r, ui;
}
var di = {}, pi = {}, _i = {}, Ol;
function Qu() {
  return Ol || (Ol = 1, _i.isValid = function(r) {
    return !isNaN(r) && r >= 1 && r <= 40;
  }), _i;
}
var pt = {}, Ll;
function ed() {
  if (Ll) return pt;
  Ll = 1;
  const e = "[0-9]+", r = "[A-Z $%*+\\-./:]+";
  let t = "(?:[u3000-u303F]|[u3040-u309F]|[u30A0-u30FF]|[uFF00-uFFEF]|[u4E00-u9FAF]|[u2605-u2606]|[u2190-u2195]|u203B|[u2010u2015u2018u2019u2025u2026u201Cu201Du2225u2260]|[u0391-u0451]|[u00A7u00A8u00B1u00B4u00D7u00F7])+";
  t = t.replace(/u/g, "\\u");
  const n = "(?:(?![A-Z0-9 $%*+\\-./:]|" + t + `)(?:.|[\r
]))+`;
  pt.KANJI = new RegExp(t, "g"), pt.BYTE_KANJI = new RegExp("[^A-Z0-9 $%*+\\-./:]+", "g"), pt.BYTE = new RegExp(n, "g"), pt.NUMERIC = new RegExp(e, "g"), pt.ALPHANUMERIC = new RegExp(r, "g");
  const a = new RegExp("^" + t + "$"), o = new RegExp("^" + e + "$"), s = new RegExp("^[A-Z0-9 $%*+\\-./:]+$");
  return pt.testKanji = function(c) {
    return a.test(c);
  }, pt.testNumeric = function(c) {
    return o.test(c);
  }, pt.testAlphanumeric = function(c) {
    return s.test(c);
  }, pt;
}
var Bl;
function An() {
  return Bl || (Bl = 1, function(e) {
    const r = Qu(), t = ed();
    e.NUMERIC = {
      id: "Numeric",
      bit: 1,
      ccBits: [10, 12, 14]
    }, e.ALPHANUMERIC = {
      id: "Alphanumeric",
      bit: 2,
      ccBits: [9, 11, 13]
    }, e.BYTE = {
      id: "Byte",
      bit: 4,
      ccBits: [8, 16, 16]
    }, e.KANJI = {
      id: "Kanji",
      bit: 8,
      ccBits: [8, 10, 12]
    }, e.MIXED = {
      bit: -1
    }, e.getCharCountIndicator = function(o, s) {
      if (!o.ccBits) throw new Error("Invalid mode: " + o);
      if (!r.isValid(s))
        throw new Error("Invalid version: " + s);
      return s >= 1 && s < 10 ? o.ccBits[0] : s < 27 ? o.ccBits[1] : o.ccBits[2];
    }, e.getBestModeForData = function(o) {
      return t.testNumeric(o) ? e.NUMERIC : t.testAlphanumeric(o) ? e.ALPHANUMERIC : t.testKanji(o) ? e.KANJI : e.BYTE;
    }, e.toString = function(o) {
      if (o && o.id) return o.id;
      throw new Error("Invalid mode");
    }, e.isValid = function(o) {
      return o && o.bit && o.ccBits;
    };
    function n(a) {
      if (typeof a != "string")
        throw new Error("Param is not a string");
      switch (a.toLowerCase()) {
        case "numeric":
          return e.NUMERIC;
        case "alphanumeric":
          return e.ALPHANUMERIC;
        case "kanji":
          return e.KANJI;
        case "byte":
          return e.BYTE;
        default:
          throw new Error("Unknown mode: " + a);
      }
    }
    e.from = function(o, s) {
      if (e.isValid(o))
        return o;
      try {
        return n(o);
      } catch {
        return s;
      }
    };
  }(pi)), pi;
}
var Ul;
function mf() {
  return Ul || (Ul = 1, function(e) {
    const r = Cn(), t = Ju(), n = Ms(), a = An(), o = Qu(), s = 7973, l = r.getBCHDigit(s);
    function c(_, g, f) {
      for (let w = 1; w <= 40; w++)
        if (g <= e.getCapacity(w, f, _))
          return w;
    }
    function u(_, g) {
      return a.getCharCountIndicator(_, g) + 4;
    }
    function d(_, g) {
      let f = 0;
      return _.forEach(function(w) {
        const k = u(w.mode, g);
        f += k + w.getBitsLength();
      }), f;
    }
    function p(_, g) {
      for (let f = 1; f <= 40; f++)
        if (d(_, f) <= e.getCapacity(f, g, a.MIXED))
          return f;
    }
    e.from = function(g, f) {
      return o.isValid(g) ? parseInt(g, 10) : f;
    }, e.getCapacity = function(g, f, w) {
      if (!o.isValid(g))
        throw new Error("Invalid QR Code version");
      typeof w > "u" && (w = a.BYTE);
      const k = r.getSymbolTotalCodewords(g), m = t.getTotalCodewordsCount(g, f), h = (k - m) * 8;
      if (w === a.MIXED) return h;
      const v = h - u(w, g);
      switch (w) {
        case a.NUMERIC:
          return Math.floor(v / 10 * 3);
        case a.ALPHANUMERIC:
          return Math.floor(v / 11 * 2);
        case a.KANJI:
          return Math.floor(v / 13);
        case a.BYTE:
        default:
          return Math.floor(v / 8);
      }
    }, e.getBestVersionForData = function(g, f) {
      let w;
      const k = n.from(f, n.M);
      if (Array.isArray(g)) {
        if (g.length > 1)
          return p(g, k);
        if (g.length === 0)
          return 1;
        w = g[0];
      } else
        w = g;
      return c(w.mode, w.getLength(), k);
    }, e.getEncodedBits = function(g) {
      if (!o.isValid(g) || g < 7)
        throw new Error("Invalid QR Code version");
      let f = g << 12;
      for (; r.getBCHDigit(f) - l >= 0; )
        f ^= s << r.getBCHDigit(f) - l;
      return g << 12 | f;
    };
  }(di)), di;
}
var gi = {}, Rl;
function hf() {
  if (Rl) return gi;
  Rl = 1;
  const e = Cn(), r = 1335, t = 21522, n = e.getBCHDigit(r);
  return gi.getEncodedBits = function(o, s) {
    const l = o.bit << 3 | s;
    let c = l << 10;
    for (; e.getBCHDigit(c) - n >= 0; )
      c ^= r << e.getBCHDigit(c) - n;
    return (l << 10 | c) ^ t;
  }, gi;
}
var fi = {}, mi, Vl;
function yf() {
  if (Vl) return mi;
  Vl = 1;
  const e = An();
  function r(t) {
    this.mode = e.NUMERIC, this.data = t.toString();
  }
  return r.getBitsLength = function(n) {
    return 10 * Math.floor(n / 3) + (n % 3 ? n % 3 * 3 + 1 : 0);
  }, r.prototype.getLength = function() {
    return this.data.length;
  }, r.prototype.getBitsLength = function() {
    return r.getBitsLength(this.data.length);
  }, r.prototype.write = function(n) {
    let a, o, s;
    for (a = 0; a + 3 <= this.data.length; a += 3)
      o = this.data.substr(a, 3), s = parseInt(o, 10), n.put(s, 10);
    const l = this.data.length - a;
    l > 0 && (o = this.data.substr(a), s = parseInt(o, 10), n.put(s, l * 3 + 1));
  }, mi = r, mi;
}
var hi, Hl;
function bf() {
  if (Hl) return hi;
  Hl = 1;
  const e = An(), r = [
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
    " ",
    "$",
    "%",
    "*",
    "+",
    "-",
    ".",
    "/",
    ":"
  ];
  function t(n) {
    this.mode = e.ALPHANUMERIC, this.data = n;
  }
  return t.getBitsLength = function(a) {
    return 11 * Math.floor(a / 2) + 6 * (a % 2);
  }, t.prototype.getLength = function() {
    return this.data.length;
  }, t.prototype.getBitsLength = function() {
    return t.getBitsLength(this.data.length);
  }, t.prototype.write = function(a) {
    let o;
    for (o = 0; o + 2 <= this.data.length; o += 2) {
      let s = r.indexOf(this.data[o]) * 45;
      s += r.indexOf(this.data[o + 1]), a.put(s, 11);
    }
    this.data.length % 2 && a.put(r.indexOf(this.data[o]), 6);
  }, hi = t, hi;
}
var yi, Wl;
function vf() {
  if (Wl) return yi;
  Wl = 1;
  const e = An();
  function r(t) {
    this.mode = e.BYTE, typeof t == "string" ? this.data = new TextEncoder().encode(t) : this.data = new Uint8Array(t);
  }
  return r.getBitsLength = function(n) {
    return n * 8;
  }, r.prototype.getLength = function() {
    return this.data.length;
  }, r.prototype.getBitsLength = function() {
    return r.getBitsLength(this.data.length);
  }, r.prototype.write = function(t) {
    for (let n = 0, a = this.data.length; n < a; n++)
      t.put(this.data[n], 8);
  }, yi = r, yi;
}
var bi, Yl;
function kf() {
  if (Yl) return bi;
  Yl = 1;
  const e = An(), r = Cn();
  function t(n) {
    this.mode = e.KANJI, this.data = n;
  }
  return t.getBitsLength = function(a) {
    return a * 13;
  }, t.prototype.getLength = function() {
    return this.data.length;
  }, t.prototype.getBitsLength = function() {
    return t.getBitsLength(this.data.length);
  }, t.prototype.write = function(n) {
    let a;
    for (a = 0; a < this.data.length; a++) {
      let o = r.toSJIS(this.data[a]);
      if (o >= 33088 && o <= 40956)
        o -= 33088;
      else if (o >= 57408 && o <= 60351)
        o -= 49472;
      else
        throw new Error(
          "Invalid SJIS character: " + this.data[a] + `
Make sure your charset is UTF-8`
        );
      o = (o >>> 8 & 255) * 192 + (o & 255), n.put(o, 13);
    }
  }, bi = t, bi;
}
var vi = { exports: {} }, Gl;
function wf() {
  return Gl || (Gl = 1, function(e) {
    var r = {
      single_source_shortest_paths: function(t, n, a) {
        var o = {}, s = {};
        s[n] = 0;
        var l = r.PriorityQueue.make();
        l.push(n, 0);
        for (var c, u, d, p, _, g, f, w, k; !l.empty(); ) {
          c = l.pop(), u = c.value, p = c.cost, _ = t[u] || {};
          for (d in _)
            _.hasOwnProperty(d) && (g = _[d], f = p + g, w = s[d], k = typeof s[d] > "u", (k || w > f) && (s[d] = f, l.push(d, f), o[d] = u));
        }
        if (typeof a < "u" && typeof s[a] > "u") {
          var m = ["Could not find a path from ", n, " to ", a, "."].join("");
          throw new Error(m);
        }
        return o;
      },
      extract_shortest_path_from_predecessor_list: function(t, n) {
        for (var a = [], o = n; o; )
          a.push(o), t[o], o = t[o];
        return a.reverse(), a;
      },
      find_path: function(t, n, a) {
        var o = r.single_source_shortest_paths(t, n, a);
        return r.extract_shortest_path_from_predecessor_list(
          o,
          a
        );
      },
      /**
       * A very naive priority queue implementation.
       */
      PriorityQueue: {
        make: function(t) {
          var n = r.PriorityQueue, a = {}, o;
          t = t || {};
          for (o in n)
            n.hasOwnProperty(o) && (a[o] = n[o]);
          return a.queue = [], a.sorter = t.sorter || n.default_sorter, a;
        },
        default_sorter: function(t, n) {
          return t.cost - n.cost;
        },
        /**
         * Add a new item to the queue and ensure the highest priority element
         * is at the front of the queue.
         */
        push: function(t, n) {
          var a = { value: t, cost: n };
          this.queue.push(a), this.queue.sort(this.sorter);
        },
        /**
         * Return the highest priority element in the queue.
         */
        pop: function() {
          return this.queue.shift();
        },
        empty: function() {
          return this.queue.length === 0;
        }
      }
    };
    e.exports = r;
  }(vi)), vi.exports;
}
var Kl;
function Pf() {
  return Kl || (Kl = 1, function(e) {
    const r = An(), t = yf(), n = bf(), a = vf(), o = kf(), s = ed(), l = Cn(), c = wf();
    function u(m) {
      return unescape(encodeURIComponent(m)).length;
    }
    function d(m, h, v) {
      const y = [];
      let E;
      for (; (E = m.exec(v)) !== null; )
        y.push({
          data: E[0],
          index: E.index,
          mode: h,
          length: E[0].length
        });
      return y;
    }
    function p(m) {
      const h = d(s.NUMERIC, r.NUMERIC, m), v = d(s.ALPHANUMERIC, r.ALPHANUMERIC, m);
      let y, E;
      return l.isKanjiModeEnabled() ? (y = d(s.BYTE, r.BYTE, m), E = d(s.KANJI, r.KANJI, m)) : (y = d(s.BYTE_KANJI, r.BYTE, m), E = []), h.concat(v, y, E).sort(function(P, x) {
        return P.index - x.index;
      }).map(function(P) {
        return {
          data: P.data,
          mode: P.mode,
          length: P.length
        };
      });
    }
    function _(m, h) {
      switch (h) {
        case r.NUMERIC:
          return t.getBitsLength(m);
        case r.ALPHANUMERIC:
          return n.getBitsLength(m);
        case r.KANJI:
          return o.getBitsLength(m);
        case r.BYTE:
          return a.getBitsLength(m);
      }
    }
    function g(m) {
      return m.reduce(function(h, v) {
        const y = h.length - 1 >= 0 ? h[h.length - 1] : null;
        return y && y.mode === v.mode ? (h[h.length - 1].data += v.data, h) : (h.push(v), h);
      }, []);
    }
    function f(m) {
      const h = [];
      for (let v = 0; v < m.length; v++) {
        const y = m[v];
        switch (y.mode) {
          case r.NUMERIC:
            h.push([
              y,
              { data: y.data, mode: r.ALPHANUMERIC, length: y.length },
              { data: y.data, mode: r.BYTE, length: y.length }
            ]);
            break;
          case r.ALPHANUMERIC:
            h.push([
              y,
              { data: y.data, mode: r.BYTE, length: y.length }
            ]);
            break;
          case r.KANJI:
            h.push([
              y,
              { data: y.data, mode: r.BYTE, length: u(y.data) }
            ]);
            break;
          case r.BYTE:
            h.push([
              { data: y.data, mode: r.BYTE, length: u(y.data) }
            ]);
        }
      }
      return h;
    }
    function w(m, h) {
      const v = {}, y = { start: {} };
      let E = ["start"];
      for (let S = 0; S < m.length; S++) {
        const P = m[S], x = [];
        for (let I = 0; I < P.length; I++) {
          const q = P[I], N = "" + S + I;
          x.push(N), v[N] = { node: q, lastCount: 0 }, y[N] = {};
          for (let M = 0; M < E.length; M++) {
            const D = E[M];
            v[D] && v[D].node.mode === q.mode ? (y[D][N] = _(v[D].lastCount + q.length, q.mode) - _(v[D].lastCount, q.mode), v[D].lastCount += q.length) : (v[D] && (v[D].lastCount = q.length), y[D][N] = _(q.length, q.mode) + 4 + r.getCharCountIndicator(q.mode, h));
          }
        }
        E = x;
      }
      for (let S = 0; S < E.length; S++)
        y[E[S]].end = 0;
      return { map: y, table: v };
    }
    function k(m, h) {
      let v;
      const y = r.getBestModeForData(m);
      if (v = r.from(h, y), v !== r.BYTE && v.bit < y.bit)
        throw new Error('"' + m + '" cannot be encoded with mode ' + r.toString(v) + `.
 Suggested mode is: ` + r.toString(y));
      switch (v === r.KANJI && !l.isKanjiModeEnabled() && (v = r.BYTE), v) {
        case r.NUMERIC:
          return new t(m);
        case r.ALPHANUMERIC:
          return new n(m);
        case r.KANJI:
          return new o(m);
        case r.BYTE:
          return new a(m);
      }
    }
    e.fromArray = function(h) {
      return h.reduce(function(v, y) {
        return typeof y == "string" ? v.push(k(y, null)) : y.data && v.push(k(y.data, y.mode)), v;
      }, []);
    }, e.fromString = function(h, v) {
      const y = p(h, l.isKanjiModeEnabled()), E = f(y), S = w(E, v), P = c.find_path(S.map, "start", "end"), x = [];
      for (let I = 1; I < P.length - 1; I++)
        x.push(S.table[P[I]].node);
      return e.fromArray(g(x));
    }, e.rawSplit = function(h) {
      return e.fromArray(
        p(h, l.isKanjiModeEnabled())
      );
    };
  }(fi)), fi;
}
var $l;
function xf() {
  if ($l) return ti;
  $l = 1;
  const e = Cn(), r = Ms(), t = lf(), n = cf(), a = uf(), o = df(), s = pf(), l = Ju(), c = ff(), u = mf(), d = hf(), p = An(), _ = Pf();
  function g(S, P) {
    const x = S.size, I = o.getPositions(P);
    for (let q = 0; q < I.length; q++) {
      const N = I[q][0], M = I[q][1];
      for (let D = -1; D <= 7; D++)
        if (!(N + D <= -1 || x <= N + D))
          for (let j = -1; j <= 7; j++)
            M + j <= -1 || x <= M + j || (D >= 0 && D <= 6 && (j === 0 || j === 6) || j >= 0 && j <= 6 && (D === 0 || D === 6) || D >= 2 && D <= 4 && j >= 2 && j <= 4 ? S.set(N + D, M + j, !0, !0) : S.set(N + D, M + j, !1, !0));
    }
  }
  function f(S) {
    const P = S.size;
    for (let x = 8; x < P - 8; x++) {
      const I = x % 2 === 0;
      S.set(x, 6, I, !0), S.set(6, x, I, !0);
    }
  }
  function w(S, P) {
    const x = a.getPositions(P);
    for (let I = 0; I < x.length; I++) {
      const q = x[I][0], N = x[I][1];
      for (let M = -2; M <= 2; M++)
        for (let D = -2; D <= 2; D++)
          M === -2 || M === 2 || D === -2 || D === 2 || M === 0 && D === 0 ? S.set(q + M, N + D, !0, !0) : S.set(q + M, N + D, !1, !0);
    }
  }
  function k(S, P) {
    const x = S.size, I = u.getEncodedBits(P);
    let q, N, M;
    for (let D = 0; D < 18; D++)
      q = Math.floor(D / 3), N = D % 3 + x - 8 - 3, M = (I >> D & 1) === 1, S.set(q, N, M, !0), S.set(N, q, M, !0);
  }
  function m(S, P, x) {
    const I = S.size, q = d.getEncodedBits(P, x);
    let N, M;
    for (N = 0; N < 15; N++)
      M = (q >> N & 1) === 1, N < 6 ? S.set(N, 8, M, !0) : N < 8 ? S.set(N + 1, 8, M, !0) : S.set(I - 15 + N, 8, M, !0), N < 8 ? S.set(8, I - N - 1, M, !0) : N < 9 ? S.set(8, 15 - N - 1 + 1, M, !0) : S.set(8, 15 - N - 1, M, !0);
    S.set(I - 8, 8, 1, !0);
  }
  function h(S, P) {
    const x = S.size;
    let I = -1, q = x - 1, N = 7, M = 0;
    for (let D = x - 1; D > 0; D -= 2)
      for (D === 6 && D--; ; ) {
        for (let j = 0; j < 2; j++)
          if (!S.isReserved(q, D - j)) {
            let Y = !1;
            M < P.length && (Y = (P[M] >>> N & 1) === 1), S.set(q, D - j, Y), N--, N === -1 && (M++, N = 7);
          }
        if (q += I, q < 0 || x <= q) {
          q -= I, I = -I;
          break;
        }
      }
  }
  function v(S, P, x) {
    const I = new t();
    x.forEach(function(j) {
      I.put(j.mode.bit, 4), I.put(j.getLength(), p.getCharCountIndicator(j.mode, S)), j.write(I);
    });
    const q = e.getSymbolTotalCodewords(S), N = l.getTotalCodewordsCount(S, P), M = (q - N) * 8;
    for (I.getLengthInBits() + 4 <= M && I.put(0, 4); I.getLengthInBits() % 8 !== 0; )
      I.putBit(0);
    const D = (M - I.getLengthInBits()) / 8;
    for (let j = 0; j < D; j++)
      I.put(j % 2 ? 17 : 236, 8);
    return y(I, S, P);
  }
  function y(S, P, x) {
    const I = e.getSymbolTotalCodewords(P), q = l.getTotalCodewordsCount(P, x), N = I - q, M = l.getBlocksCount(P, x), D = I % M, j = M - D, Y = Math.floor(I / M), A = Math.floor(N / M), C = A + 1, z = Y - A, G = new c(z);
    let H = 0;
    const J = new Array(M), le = new Array(M);
    let fe = 0;
    const pe = new Uint8Array(S.buffer);
    for (let Ce = 0; Ce < M; Ce++) {
      const ye = Ce < j ? A : C;
      J[Ce] = pe.slice(H, H + ye), le[Ce] = G.encode(J[Ce]), H += ye, fe = Math.max(fe, ye);
    }
    const xe = new Uint8Array(I);
    let de = 0, ue, Se;
    for (ue = 0; ue < fe; ue++)
      for (Se = 0; Se < M; Se++)
        ue < J[Se].length && (xe[de++] = J[Se][ue]);
    for (ue = 0; ue < z; ue++)
      for (Se = 0; Se < M; Se++)
        xe[de++] = le[Se][ue];
    return xe;
  }
  function E(S, P, x, I) {
    let q;
    if (Array.isArray(S))
      q = _.fromArray(S);
    else if (typeof S == "string") {
      let Y = P;
      if (!Y) {
        const A = _.rawSplit(S);
        Y = u.getBestVersionForData(A, x);
      }
      q = _.fromString(S, Y || 40);
    } else
      throw new Error("Invalid data");
    const N = u.getBestVersionForData(q, x);
    if (!N)
      throw new Error("The amount of data is too big to be stored in a QR Code");
    if (!P)
      P = N;
    else if (P < N)
      throw new Error(
        `
The chosen QR Code version cannot contain this amount of data.
Minimum version required to store current data is: ` + N + `.
`
      );
    const M = v(P, x, q), D = e.getSymbolSize(P), j = new n(D);
    return g(j, P), f(j), w(j, P), m(j, x, 0), P >= 7 && k(j, P), h(j, M), isNaN(I) && (I = s.getBestMask(
      j,
      m.bind(null, j, x)
    )), s.applyMask(I, j), m(j, x, I), {
      modules: j,
      version: P,
      errorCorrectionLevel: x,
      maskPattern: I,
      segments: q
    };
  }
  return ti.create = function(P, x) {
    if (typeof P > "u" || P === "")
      throw new Error("No input text");
    let I = r.M, q, N;
    return typeof x < "u" && (I = r.from(x.errorCorrectionLevel, r.M), q = u.from(x.version), N = s.from(x.maskPattern), x.toSJISFunc && e.setToSJISFunction(x.toSJISFunc)), E(P, q, I, N);
  }, ti;
}
var ki = {}, wi = {}, Xl;
function rd() {
  return Xl || (Xl = 1, function(e) {
    function r(t) {
      if (typeof t == "number" && (t = t.toString()), typeof t != "string")
        throw new Error("Color should be defined as hex string");
      let n = t.slice().replace("#", "").split("");
      if (n.length < 3 || n.length === 5 || n.length > 8)
        throw new Error("Invalid hex color: " + t);
      (n.length === 3 || n.length === 4) && (n = Array.prototype.concat.apply([], n.map(function(o) {
        return [o, o];
      }))), n.length === 6 && n.push("F", "F");
      const a = parseInt(n.join(""), 16);
      return {
        r: a >> 24 & 255,
        g: a >> 16 & 255,
        b: a >> 8 & 255,
        a: a & 255,
        hex: "#" + n.slice(0, 6).join("")
      };
    }
    e.getOptions = function(n) {
      n || (n = {}), n.color || (n.color = {});
      const a = typeof n.margin > "u" || n.margin === null || n.margin < 0 ? 4 : n.margin, o = n.width && n.width >= 21 ? n.width : void 0, s = n.scale || 4;
      return {
        width: o,
        scale: o ? 4 : s,
        margin: a,
        color: {
          dark: r(n.color.dark || "#000000ff"),
          light: r(n.color.light || "#ffffffff")
        },
        type: n.type,
        rendererOpts: n.rendererOpts || {}
      };
    }, e.getScale = function(n, a) {
      return a.width && a.width >= n + a.margin * 2 ? a.width / (n + a.margin * 2) : a.scale;
    }, e.getImageWidth = function(n, a) {
      const o = e.getScale(n, a);
      return Math.floor((n + a.margin * 2) * o);
    }, e.qrToImageData = function(n, a, o) {
      const s = a.modules.size, l = a.modules.data, c = e.getScale(s, o), u = Math.floor((s + o.margin * 2) * c), d = o.margin * c, p = [o.color.light, o.color.dark];
      for (let _ = 0; _ < u; _++)
        for (let g = 0; g < u; g++) {
          let f = (_ * u + g) * 4, w = o.color.light;
          if (_ >= d && g >= d && _ < u - d && g < u - d) {
            const k = Math.floor((_ - d) / c), m = Math.floor((g - d) / c);
            w = p[l[k * s + m] ? 1 : 0];
          }
          n[f++] = w.r, n[f++] = w.g, n[f++] = w.b, n[f] = w.a;
        }
    };
  }(wi)), wi;
}
var Zl;
function Ef() {
  return Zl || (Zl = 1, function(e) {
    const r = rd();
    function t(a, o, s) {
      a.clearRect(0, 0, o.width, o.height), o.style || (o.style = {}), o.height = s, o.width = s, o.style.height = s + "px", o.style.width = s + "px";
    }
    function n() {
      try {
        return document.createElement("canvas");
      } catch {
        throw new Error("You need to specify a canvas element");
      }
    }
    e.render = function(o, s, l) {
      let c = l, u = s;
      typeof c > "u" && (!s || !s.getContext) && (c = s, s = void 0), s || (u = n()), c = r.getOptions(c);
      const d = r.getImageWidth(o.modules.size, c), p = u.getContext("2d"), _ = p.createImageData(d, d);
      return r.qrToImageData(_.data, o, c), t(p, u, d), p.putImageData(_, 0, 0), u;
    }, e.renderToDataURL = function(o, s, l) {
      let c = l;
      typeof c > "u" && (!s || !s.getContext) && (c = s, s = void 0), c || (c = {});
      const u = e.render(o, s, c), d = c.type || "image/png", p = c.rendererOpts || {};
      return u.toDataURL(d, p.quality);
    };
  }(ki)), ki;
}
var Pi = {}, Jl;
function Sf() {
  if (Jl) return Pi;
  Jl = 1;
  const e = rd();
  function r(a, o) {
    const s = a.a / 255, l = o + '="' + a.hex + '"';
    return s < 1 ? l + " " + o + '-opacity="' + s.toFixed(2).slice(1) + '"' : l;
  }
  function t(a, o, s) {
    let l = a + o;
    return typeof s < "u" && (l += " " + s), l;
  }
  function n(a, o, s) {
    let l = "", c = 0, u = !1, d = 0;
    for (let p = 0; p < a.length; p++) {
      const _ = Math.floor(p % o), g = Math.floor(p / o);
      !_ && !u && (u = !0), a[p] ? (d++, p > 0 && _ > 0 && a[p - 1] || (l += u ? t("M", _ + s, 0.5 + g + s) : t("m", c, 0), c = 0, u = !1), _ + 1 < o && a[p + 1] || (l += t("h", d), d = 0)) : c++;
    }
    return l;
  }
  return Pi.render = function(o, s, l) {
    const c = e.getOptions(s), u = o.modules.size, d = o.modules.data, p = u + c.margin * 2, _ = c.color.light.a ? "<path " + r(c.color.light, "fill") + ' d="M0 0h' + p + "v" + p + 'H0z"/>' : "", g = "<path " + r(c.color.dark, "stroke") + ' d="' + n(d, u, c.margin) + '"/>', f = 'viewBox="0 0 ' + p + " " + p + '"', k = '<svg xmlns="http://www.w3.org/2000/svg" ' + (c.width ? 'width="' + c.width + '" height="' + c.width + '" ' : "") + f + ' shape-rendering="crispEdges">' + _ + g + `</svg>
`;
    return typeof l == "function" && l(null, k), k;
  }, Pi;
}
var Ql;
function Tf() {
  if (Ql) return Ln;
  Ql = 1;
  const e = sf(), r = xf(), t = Ef(), n = Sf();
  function a(o, s, l, c, u) {
    const d = [].slice.call(arguments, 1), p = d.length, _ = typeof d[p - 1] == "function";
    if (!_ && !e())
      throw new Error("Callback required as last argument");
    if (_) {
      if (p < 2)
        throw new Error("Too few arguments provided");
      p === 2 ? (u = l, l = s, s = c = void 0) : p === 3 && (s.getContext && typeof u > "u" ? (u = c, c = void 0) : (u = c, c = l, l = s, s = void 0));
    } else {
      if (p < 1)
        throw new Error("Too few arguments provided");
      return p === 1 ? (l = s, s = c = void 0) : p === 2 && !s.getContext && (c = l, l = s, s = void 0), new Promise(function(g, f) {
        try {
          const w = r.create(l, c);
          g(o(w, s, c));
        } catch (w) {
          f(w);
        }
      });
    }
    try {
      const g = r.create(l, c);
      u(null, o(g, s, c));
    } catch (g) {
      u(g);
    }
  }
  return Ln.create = r.create, Ln.toCanvas = a.bind(null, t.render), Ln.toDataURL = a.bind(null, t.renderToDataURL), Ln.toString = a.bind(null, function(o, s, l) {
    return n.render(o, l);
  }), Ln;
}
var If = Tf();
const Df = /* @__PURE__ */ of(If);
var Cf = /* @__PURE__ */ B('<div class="qr-wrapper svelte-qky52f"><img alt="Redemption QR Code" class="qr-code svelte-qky52f"/></div>');
const Af = {
  hash: "svelte-qky52f",
  code: ".qr-wrapper.svelte-qky52f {display:flex;justify-content:center;align-items:center;align-self:center;width:fit-content;margin:0 auto;background-color:#ffffff;border-radius:8px;padding:16px;}.qr-code.svelte-qky52f {display:block;width:128px;height:128px;image-rendering:-webkit-optimize-contrast;image-rendering:crisp-edges;}"
};
function qf(e, r) {
  re(r, !0), ie(e, Af);
  const t = () => he(o, "$variables", n), [n, a] = je(), o = Vo(), s = /* @__PURE__ */ b(() => {
    var f;
    return (f = t()) == null ? void 0 : f["success.redemption_url"];
  });
  let l = /* @__PURE__ */ X(!0), c = /* @__PURE__ */ X(""), u = /* @__PURE__ */ X(!1);
  _r(() => {
    const f = window.matchMedia("(max-width: 767px)");
    L(l, f.matches, !0);
    const w = (k) => {
      L(l, k.matches, !0);
    };
    return f.addEventListener("change", w), () => {
      f.removeEventListener("change", w);
    };
  }), xr(() => {
    !i(l) && i(s) && (L(u, !1), Df.toDataURL(i(s), {
      width: 512,
      margin: 2,
      errorCorrectionLevel: "M",
      color: { dark: "#000000", light: "#ffffff" }
    }).then((f) => {
      L(c, f, !0);
    }).catch((f) => {
      console.warn("Failed to generate QR code:", f), L(u, !0);
    }));
  });
  var d = ve(), p = Q(d);
  {
    var _ = (f) => {
      dr(f, He(() => r.stack, {
        onclick: () => {
          window.location.href = i(s);
        }
      }));
    }, g = (f) => {
      var w = ve(), k = Q(w);
      {
        var m = (h) => {
          var v = Cf(), y = F(v);
          R(() => oe(y, "src", i(c))), T(h, v);
        };
        W(
          k,
          (h) => {
            i(c) && h(m);
          },
          !0
        );
      }
      T(f, w);
    };
    W(p, (f) => {
      (i(l) || i(u)) && i(s) ? f(_) : f(g, !1);
    });
  }
  T(e, d), te(), a();
}
var ec;
(function(e) {
  e.body_s = "p", e.body_m = "p", e.body_l = "p", e.body_xl = "p", e.heading_xs = "h6", e.heading_s = "h5", e.heading_m = "h4", e.heading_l = "h3", e.heading_xl = "h2", e.heading_xxl = "h1";
})(ec || (ec = {}));
var ko;
(function(e) {
  e[e.extra_light = 100] = "extra_light", e[e.thin = 200] = "thin", e[e.light = 300] = "light", e[e.regular = 400] = "regular", e[e.medium = 500] = "medium", e[e.semibold = 600] = "semibold", e[e.bold = 700] = "bold", e[e.extra_bold = 800] = "extra_bold", e[e.black = 900] = "black";
})(ko || (ko = {}));
var wo;
(function(e) {
  e.body_s = "13px", e.body_m = "14px", e.body_l = "15px", e.body_xl = "16px", e.heading_xs = "14px", e.heading_s = "16px", e.heading_m = "18px", e.heading_l = "20px", e.heading_xl = "26px", e.heading_xxl = "32px";
})(wo || (wo = {}));
var Po;
(function(e) {
  e.leading = "start", e.center = "center", e.trailing = "end";
})(Po || (Po = {}));
var rc;
(function(e) {
  e.vertical = "column", e.horizontal = "row", e.zlayer = "zstack";
})(rc || (rc = {}));
var tc;
(function(e) {
  e.top = "flex-start", e.leading = "flex-start", e.center = "center", e.bottom = "flex-end", e.trailing = "flex-end";
})(tc || (tc = {}));
var nc;
(function(e) {
  e.space_between = "space-between", e.space_around = "space-around", e.space_evenly = "space-evenly", e.start = "flex-start", e.center = "center", e.end = "flex-end";
})(nc || (nc = {}));
const $i = "light", Ff = "#000000", Ca = {
  top: 0,
  bottom: 0,
  leading: 0,
  trailing: 0
};
function Re(e) {
  return Object.entries(e).map(([r, t]) => `${r}:${t}`).join(";");
}
function gr(e) {
  return `${e}px`;
}
function td(...e) {
  return e.map(gr).join(" ");
}
function Vt(e, r) {
  return r[e] ?? r.light;
}
function lr(e) {
  switch (e.type) {
    case "fill":
      return navigator.userAgent.includes("Firefox") ? "-moz-available" : "-webkit-fill-available";
    case "fit":
      return "fit-content";
    case "fixed":
      return gr(e.value);
    case "relative":
      return `${e.value * 100}%`;
  }
}
function tr(e) {
  const { top: r, bottom: t, leading: n, trailing: a } = e ?? Ca;
  return td(r, a, t, n);
}
function nd(e) {
  if (e.type === "alias" || e.type === "hex")
    return e.value;
  const r = e.points.map((t) => `${t.color} ${t.percent}%`).join(", ");
  switch (e.type) {
    case "linear":
      return `linear-gradient(${e.degrees}deg, ${r})`;
    case "radial":
      return `radial-gradient(circle, ${r})`;
  }
}
function mr(e, r) {
  if (r == null)
    return "transparent";
  const t = Vt(e, r);
  return nd(t);
}
function zf(e, r) {
  return r == null ? "transparent" : mr(e, r);
}
function Sn(e, r) {
  if (r == null)
    return "none";
  const t = mr(e, r.color);
  return `${r.width}px solid ${t}`;
}
function Mf(e) {
  if (e == null)
    return "0";
  const { top_leading: r, top_trailing: t, bottom_trailing: n, bottom_leading: a } = e;
  return td(r, t, n, a);
}
function ga(e) {
  switch (e == null ? void 0 : e.type) {
    case void 0:
    case "concave":
    case "convex":
      return "0";
    case "rectangle":
      return `${Mf(e.corners)}`;
    case "circle":
    case "pill":
      return "9999px";
  }
}
function fa(e, r) {
  if (r == null)
    return "none";
  const { x: t, y: n, radius: a } = r, o = mr(e, r.color);
  return `${t}px ${n}px ${a}px ${o}`;
}
function xo(e) {
  switch (e) {
    case "fill":
      return "cover";
    case "fit":
      return "contain";
  }
}
function jf(e, r) {
  return `url(${Vt(e, r).webp})`;
}
function Nf(e, r) {
  return console.error("Not supported yet"), `url(${Vt(e, r)})`;
}
function Of(e, r, t) {
  return t == null ? r == null ? "none" : mr(e, r) : t.type === "color" ? mr(e, r ?? t.value) : t.type === "image" ? jf(e, t.value) : Nf(e, t.value);
}
function qn(e, r, t) {
  const n = Of(e, r, t);
  if ((t == null ? void 0 : t.type) !== "image")
    return { background: n };
  const { fit_mode: a, color_overlay: o } = t;
  return {
    background: n,
    "background-size": xo(a),
    "background-position": a === "fill" ? "center" : "top center",
    "background-repeat": "no-repeat",
    "--overlay": zf(e, o)
  };
}
function Lf(e) {
  return e.startsWith("RCFM:");
}
function Xi(e) {
  return `RevCatPaywall-${e}`;
}
async function Bf(e) {
  var t;
  if (!e.app.fonts || typeof document > "u")
    return;
  const r = [];
  for (const [n, a] of Object.entries(e.app.fonts)) {
    const o = a.web;
    if (!o || !o.url || !o.family) {
      console.warn(`[Font Registration] Skipping font ${n}: missing web config or required fields`);
      continue;
    }
    try {
      const s = `${Xi(o.family)}-${o.style}-${o.weight}`, l = new FontFace(s, `url(${o.url})`, {
        weight: ((t = o.weight) == null ? void 0 : t.toString()) || "400",
        style: o.style || "normal"
      });
      l.family = Xi(o.family);
      const c = l.load().then(() => {
        document.fonts.add(l), console.debug(`[Font Registration] Successfully registered font: ${s} (${o.family}, ${o.weight}, ${o.style})`);
      }).catch((u) => {
        console.warn(`[Font Registration] Failed to load font ${o.family}:`, u);
      });
      r.push(c);
    } catch (s) {
      console.warn(`[Font Registration] Failed to create FontFace for ${n}:`, s);
    }
  }
  try {
    await Promise.allSettled(r), console.debug(`[Font Registration] Font registration complete. Processed ${r.length} fonts.`);
  } catch (n) {
    console.warn("[Font Registration] Unexpected error during font registration:", n);
  }
}
const Uf = {
  light: { type: "hex", value: Ff }
};
function Rf(e, r) {
  const t = Vt(e, r), n = nd(t);
  switch (t.type) {
    case "alias":
    case "hex":
      return { color: n };
    case "linear":
    case "radial":
      return {
        color: "transparent",
        background: n,
        "-webkit-background-clip": "text",
        "background-clip": "text"
      };
  }
}
const Vf = (e, r, t) => {
  var f;
  const { font_name: n, font_size: a, font_weight: o, font_weight_int: s, horizontal_alignment: l, color: c = Uf, padding: u, margin: d, size: p } = r, _ = t[n ?? ""], g = (f = _ == null ? void 0 : _.web) == null ? void 0 : f.family;
  return Re({
    display: "block",
    width: lr(p.width),
    height: lr(p.height),
    margin: tr(d),
    padding: tr(u),
    ...Rf(e, c),
    "text-align": Po[l] || Po.leading,
    "font-weight": s ?? ko[o] ?? ko.regular,
    "font-size": Number.isInteger(Number(a)) ? `${a}px` : wo[a] || wo.body_m,
    "font-family": Lf(n ?? "") ? Xi(g ?? "") : "sans-serif"
  });
};
function Hf(e, r, t, n) {
  return Re({
    display: "block",
    position: "relative",
    width: lr(t.width),
    height: lr(t.height),
    ...qn(e, n, null)
  });
}
function Wf(e) {
  return e ? Object.values({
    newLine: { regexp: /\\\n/g, output: "<br/>" },
    bold: { regexp: /\*\*(.*?)\*\*/g, output: "<b>$1</b>" },
    italic: { regexp: /\*(.*?)\*/g, output: "<i>$1</i>" },
    strikethrough: { regexp: /~(.*?)~/g, output: "<s>$1</s>" },
    code: {
      regexp: /`(.*?)`/g,
      output: "<span style='font-family: monospace'>$1</span>"
    },
    link: {
      regexp: /\[(.*?)\]\((.*?)\)/g,
      output: "<a href=$2 target='_blank' rel='noopener noreferrer'>$1</a>"
    }
  }).reduce((t, { regexp: n, output: a }) => t.replaceAll(n, a), e) : "";
}
function Yf(e, r) {
  const t = K(r, "style", 3, ""), n = K(r, "component", 3, "p");
  var a = ve(), o = Q(a);
  Ts(o, n, !1, (s, l) => {
    Ds(s, () => ({ style: t() }));
    var c = ve(), u = Q(c);
    Xe(u, () => r.children ?? Fe), T(l, c);
  }), T(e, a);
}
var Ua, Ra;
class Gf {
  /**
   *
   * @param {() => T} fn
   * @param {(update: () => void) => void} onsubscribe
   */
  constructor(r, t) {
    ke(this, Ua);
    ke(this, Ra);
    be(this, Ua, r), be(this, Ra, Jc(t));
  }
  get current() {
    return O(this, Ra).call(this), O(this, Ua).call(this);
  }
}
Ua = new WeakMap(), Ra = new WeakMap();
const Kf = /\(.+\)/, $f = /* @__PURE__ */ new Set(["all", "print", "screen", "and", "or", "not", "only"]);
class Xf extends Gf {
  /**
   * @param {string} query A media query string
   * @param {boolean} [fallback] Fallback value for the server
   */
  constructor(r, t) {
    let n = Kf.test(r) || // we need to use `some` here because technically this `window.matchMedia('random,screen')` still returns true
    r.split(/[\s,]+/).some((o) => $f.has(o.trim())) ? r : `(${r})`;
    const a = window.matchMedia(n);
    super(
      () => a.matches,
      (o) => x_(a, "change", o)
    );
  }
}
const ad = Symbol("color-mode");
function Zf(e) {
  const r = new Xf("prefers-color-scheme: dark", ((e == null ? void 0 : e()) ?? $i) === "dark"), t = () => (e == null ? void 0 : e()) ?? (r.current ? "dark" : $i);
  return ir(ad, t), t;
}
function nt() {
  return Be(ad) ?? (() => $i);
}
const od = Symbol("localization");
function Jf(e) {
  const t = {
    getLocalizedString: (n) => {
      var d, p;
      if (!n)
        return "";
      const { selectedLocale: a, defaultLocale: o, localizations: s } = e(), c = (d = s[a ?? o]) == null ? void 0 : d[n], u = (p = s[o]) == null ? void 0 : p[n];
      return c ?? u;
    }
  };
  return ir(od, t), t;
}
function Qf() {
  const e = Be(od);
  if (e === void 0)
    throw new Error("Localization context not found");
  return e;
}
function em(e) {
  return e.charAt(0).toUpperCase() + e.slice(1).toLowerCase();
}
const rm = {
  uppercase: (e) => String(e ?? "").toUpperCase(),
  lowercase: (e) => String(e ?? "").toLowerCase(),
  capitalize: (e) => String(e ?? "").replaceAll(new RegExp("(\\p{Letter}+)", "giu"), em)
}, tm = /^\$?custom\./;
function nm(e, r) {
  const t = /\{\{\s*([$a-z0-9._-]+)(?:\s*\|\s*([^}]*))?\s*\}\}/gi;
  return e.replace(t, (n, a, o) => {
    var d;
    const s = (d = a == null ? void 0 : a.trim()) == null ? void 0 : d.replace(tm, ""), l = s && r[s];
    if (l === void 0)
      return "";
    const c = o == null ? void 0 : o.trim();
    if (c === void 0)
      return l;
    const u = rm[c];
    return u ? u(l) : l;
  });
}
function am(e = "", r) {
  return nm(e, r ?? {});
}
const id = Symbol("packageInfo");
function sd(e) {
  ir(id, e);
}
function ld() {
  const e = Be(id);
  if (e === void 0)
    throw new Error("PackageInfo context not found");
  return e;
}
var om = /* @__PURE__ */ B("<span><!></span>");
function Zi(e, r) {
  re(r, !0);
  const t = () => he(c, "$selectedState", o), n = () => he(u, "$packageInfo", o), a = () => he(k, "$variables", o), [o, s] = je(), l = /* @__PURE__ */ cr(r, ["$$slots", "$$events", "$$legacy"]), c = rt(), u = ld(), d = /* @__PURE__ */ b(() => {
    var S, P;
    return {
      ...l,
      ...tt(t(), r.overrides),
      ...$g(!!((S = n()) != null && S.hasIntroOffer) || !!((P = n()) != null && P.hasTrial), r.overrides)
    };
  }), p = nt(), _ = /* @__PURE__ */ b(p), { uiConfig: g } = un();
  let f = /* @__PURE__ */ b(() => Vf(i(_), i(d), g.app.fonts));
  const w = /* @__PURE__ */ b(() => Hf(i(_), i(d), i(d).size, i(d).background_color)), k = Vo(), { getLocalizedString: m } = Qf(), h = /* @__PURE__ */ b(() => am(m(i(d).text_lid), a())), v = /* @__PURE__ */ b(() => Wf(i(h)));
  var y = om(), E = F(y);
  Yf(E, {
    get style() {
      return i(f);
    },
    component: "span",
    children: (S, P) => {
      var x = ve(), I = Q(x);
      cn(I, () => i(v)), T(S, x);
    },
    $$slots: { default: !0 }
  }), R(() => Pe(y, i(w))), T(e, y), te(), s();
}
function im(e) {
  switch (e) {
    case "top":
      return "flex-start";
    case "center":
      return "center";
    case "bottom":
      return "flex-end";
  }
}
function sm(e, r, t) {
  return Math.max(r, Math.min(e, t));
}
function no(e) {
  if (e === null)
    return 0;
  const r = window.getComputedStyle(e);
  return new WebKitCSSMatrix(r.transform).m41;
}
var lm = /* @__PURE__ */ B('<div class="page svelte-yasjj1" role="group" aria-roledescription="slide"><!></div>');
const cm = {
  hash: "svelte-yasjj1",
  code: "div.svelte-yasjj1 {flex:0 0 100%;scroll-snap-align:center;scroll-snap-stop:always;}"
};
function xi(e, r) {
  ie(e, cm);
  const t = K(r, "hidden", 3, !1);
  var n = lm(), a = F(n);
  dr(a, He(() => r.page)), R(() => {
    oe(n, "aria-label", `Slide ${r.index + 1} of ${r.pages}`), oe(n, "aria-current", r.selected), oe(n, "aria-hidden", t());
  }), T(e, n);
}
var um = /* @__PURE__ */ B("<div></div>"), dm = /* @__PURE__ */ B('<div class="control svelte-111rmjq"></div>');
const pm = {
  hash: "svelte-111rmjq",
  code: ".control.svelte-111rmjq {align-self:center;display:flex;flex-direction:row;align-items:center;justify-content:center;}"
};
function _m(e, r) {
  re(r, !0), ie(e, pm);
  const t = K(r, "background_color", 3, null), n = K(r, "border", 3, null), a = K(r, "shape", 3, null), o = K(r, "shadow", 3, null), s = nt(), l = /* @__PURE__ */ b(s);
  function c(f) {
    return f.stroke_width == null || f.stroke_color == null ? "none" : Sn(i(l), { width: f.stroke_width, color: f.stroke_color });
  }
  function u(f) {
    return Re({
      width: gr(f.width),
      height: gr(f.height),
      background: mr(i(l), f.color),
      border: c(f),
      "border-radius": "9999px"
    });
  }
  const d = /* @__PURE__ */ b(() => u(r.default)), p = /* @__PURE__ */ b(() => u(r.active)), _ = /* @__PURE__ */ b(() => Re({
    order: r.position === "top" ? -1 : 1,
    gap: gr(r.spacing),
    margin: tr(r.margin),
    padding: tr(r.padding),
    ...qn(i(l), t(), null),
    border: Sn(i(l), n()),
    "border-radius": ga(a()),
    "box-shadow": fa(i(l), o())
  }));
  var g = dm();
  Dt(g, 21, () => ({ length: r.length }), Rt, (f, w, k) => {
    var m = um();
    R(() => Pe(m, k === r.selected ? i(p) : i(d))), T(f, m);
  }), R(() => Pe(g, i(_))), T(e, g), te();
}
var gm = /* @__PURE__ */ B('<div class="carousel svelte-m18axg"><div class="slider svelte-m18axg" role="region" aria-label="Feature carousel" aria-roledescription="carousel" aria-live="polite"><!> <!> <!></div> <!></div>');
const fm = {
  hash: "svelte-m18axg",
  code: ".carousel.svelte-m18axg {max-width:100%;display:flex;flex-direction:column;overflow:hidden;flex-shrink:0;}.slider.svelte-m18axg {display:flex;flex-direction:row;flex-wrap:nowrap;transition-property:transform;transition-duration:500ms;transition-timing-function:ease-in-out;transition-delay:2500ms;transform:translateX(0);cursor:grab;&:active {cursor:grabbing;user-select:none;}}"
};
function mm(e, r) {
  re(r, !0), ie(e, fm);
  const t = () => he(s, "$selectedState", n), [n, a] = je(), o = /* @__PURE__ */ cr(r, ["$$slots", "$$events", "$$legacy"]), s = rt(), l = /* @__PURE__ */ b(() => ({
    ...o,
    ...tt(t(), r.overrides)
  })), c = /* @__PURE__ */ b(() => i(l).pages), u = /* @__PURE__ */ b(() => i(l).padding), d = /* @__PURE__ */ b(() => i(l).margin), p = /* @__PURE__ */ b(() => i(l).background), _ = /* @__PURE__ */ b(() => i(l).shape), g = /* @__PURE__ */ b(() => i(l).border), f = /* @__PURE__ */ b(() => i(l).shadow), w = /* @__PURE__ */ b(() => i(l).page_alignment), k = /* @__PURE__ */ b(() => i(l).page_spacing), m = /* @__PURE__ */ b(() => i(l).page_peek), h = /* @__PURE__ */ b(() => i(l).page_control), v = /* @__PURE__ */ b(() => i(l).initial_page_index), y = /* @__PURE__ */ b(() => i(l).loop), E = /* @__PURE__ */ b(() => i(l).auto_advance), S = nt(), P = /* @__PURE__ */ b(S), x = /* @__PURE__ */ b(() => {
    var ne;
    return Re({
      margin: tr(i(d)),
      padding: tr(i(u)),
      ...qn(i(P), null, i(p)),
      border: Sn(i(P), i(g)),
      "border-radius": ga(i(_)),
      "box-shadow": fa(i(P), i(f)),
      "transition-duration": `${((ne = i(E)) == null ? void 0 : ne.ms_transition_time) ?? 0}ms`
    });
  }), I = /* @__PURE__ */ b(() => Re({
    gap: gr(i(k)),
    padding: `0 ${i(m) + i(k)}px`,
    "align-items": im(i(w))
  })), q = /* @__PURE__ */ b(() => {
    if (!i(y))
      return [];
    const ne = i(c).length - 1;
    switch (i(c).length) {
      case 0:
        return [];
      case 1:
        return [0, 0];
      case 2:
        return [0, ne];
      default:
        return [ne - 1, ne];
    }
  }), N = /* @__PURE__ */ b(() => {
    if (!i(y))
      return [];
    switch (i(c).length) {
      case 0:
        return [];
      case 1:
        return [0, 0];
      default:
        return [0, 1];
    }
  });
  let M = null, D = /* @__PURE__ */ X(0), j = /* @__PURE__ */ X(0), Y = /* @__PURE__ */ b(() => 2 * i(m) + i(k)), A = /* @__PURE__ */ b(() => i(j) - i(Y));
  function C(ne = !0, Ne) {
    var wr, Wr;
    if (M === null)
      return;
    const Ke = ne ? ((wr = i(E)) == null ? void 0 : wr.ms_time_per_page) ?? 0 : 0;
    Ne ?? (Ne = ((Wr = i(E)) == null ? void 0 : Wr.ms_transition_time) ?? 0), M.style.transition = `transform ${Ne}ms ease-in-out ${Ke}ms`;
  }
  function z() {
    M !== null && (M.style.transition = "none");
  }
  const G = /* @__PURE__ */ b(() => i(y) ? 2 : 0);
  function H(ne) {
    M !== null && (M.style.transform = `translateX(${ne}px)`);
  }
  function J(ne) {
    if (M === null)
      return;
    ne += i(G);
    const Ne = ne * -i(A);
    H(Ne);
  }
  function le(ne) {
    ne %= i(c).length + i(G), C(!0), J(ne);
  }
  function fe() {
    i(E) != null && requestAnimationFrame(() => {
      le(i(D) + 1);
    });
  }
  _r(() => {
    const ne = i(c).at(i(v)) !== void 0 ? i(v) : 0;
    L(D, ne, !0), z(), J(i(D)), fe();
  });
  function pe(ne) {
    return Math.round(ne / -i(A)) - i(G);
  }
  function xe() {
    const ne = no(M), Ne = pe(ne);
    L(D, (Ne + i(c).length) % i(c).length), z(), J(i(D)), requestAnimationFrame(() => {
      fe();
    });
  }
  let de = /* @__PURE__ */ X(0);
  function ue(ne) {
    ne.currentTarget.setPointerCapture(ne.pointerId), L(de, no(M), !0);
  }
  function Se(ne) {
    ne.currentTarget.releasePointerCapture(ne.pointerId);
    const Ke = no(M), wr = pe(Ke);
    C(!1, 500), J(wr);
  }
  function Ce(ne) {
    if (!ne.currentTarget.hasPointerCapture(ne.pointerId))
      return;
    const [Ke, wr] = i(y) ? [
      i(de) - i(j),
      i(de) + i(j)
    ] : [-(i(c).length - 1) * i(A), 0], Wr = no(M), Yt = sm(Wr + ne.movementX, Ke, wr), at = pe(Yt);
    L(D, (at + i(c).length) % i(c).length), H(Yt), z();
  }
  var ye = gm(), Te = F(ye);
  Te.__pointerdown = ue, Te.__pointerup = Se, Te.__pointermove = Ce;
  var ar = F(Te);
  Dt(ar, 17, () => i(q), Rt, (ne, Ne) => {
    {
      let Ke = /* @__PURE__ */ b(() => i(D) === i(Ne));
      xi(ne, {
        get page() {
          return i(c)[i(Ne)];
        },
        get index() {
          return i(Ne);
        },
        get pages() {
          return i(c).length;
        },
        get selected() {
          return i(Ke);
        },
        hidden: !0
      });
    }
  });
  var Ze = V(ar, 2);
  Dt(Ze, 17, () => i(c), Rt, (ne, Ne, Ke) => {
    {
      let wr = /* @__PURE__ */ b(() => i(D) === Ke);
      xi(ne, {
        get page() {
          return i(Ne);
        },
        index: Ke,
        get pages() {
          return i(c).length;
        },
        get selected() {
          return i(wr);
        }
      });
    }
  });
  var _e = V(Ze, 2);
  Dt(_e, 17, () => i(N), Rt, (ne, Ne) => {
    {
      let Ke = /* @__PURE__ */ b(() => i(D) === i(Ne));
      xi(ne, {
        get page() {
          return i(c)[i(Ne)];
        },
        get index() {
          return i(Ne);
        },
        get pages() {
          return i(c).length;
        },
        get selected() {
          return i(Ke);
        },
        hidden: !0
      });
    }
  }), Uo(Te, (ne) => M = ne, () => M);
  var Me = V(Te, 2);
  {
    var Ir = (ne) => {
      _m(ne, He(() => i(h), {
        get length() {
          return i(c).length;
        },
        get selected() {
          return i(D);
        }
      }));
    };
    W(Me, (ne) => {
      i(h) != null && ne(Ir);
    });
  }
  R(() => {
    Pe(ye, i(x)), Pe(Te, i(I));
  }), Ur("transitionend", Te, xe), Cs(Te, "clientWidth", (ne) => L(j, ne)), T(e, ye), te(), a();
}
$a(["pointerdown", "pointerup", "pointermove"]);
var hm = /* @__PURE__ */ B("<div><div></div></div>");
function cd(e, r) {
  re(r, !0);
  const t = () => he(s, "$selectedState", n), [n, a] = je(), o = /* @__PURE__ */ cr(r, ["$$slots", "$$events", "$$legacy"]), s = rt(), l = /* @__PURE__ */ b(() => ({
    ...o,
    ...tt(t(), r.overrides)
  })), c = /* @__PURE__ */ b(() => i(l).base_url), u = /* @__PURE__ */ b(() => i(l).formats), d = /* @__PURE__ */ b(() => i(l).size), p = /* @__PURE__ */ b(() => i(l).margin), _ = /* @__PURE__ */ b(() => i(l).padding), g = /* @__PURE__ */ b(() => i(l).color), f = /* @__PURE__ */ b(() => i(l).icon_background), w = nt(), k = /* @__PURE__ */ b(w), m = /* @__PURE__ */ b(() => {
    var S, P, x, I;
    return Re({
      width: lr(i(d).width),
      height: lr(i(d).height),
      margin: tr(i(p)),
      padding: tr(i(_)),
      "background-color": mr(i(k), (S = i(f)) == null ? void 0 : S.color),
      border: Sn(i(k), (P = i(f)) == null ? void 0 : P.border),
      "border-radius": ga((x = i(f)) == null ? void 0 : x.shape),
      "box-shadow": fa(i(k), (I = i(f)) == null ? void 0 : I.shadow),
      flex: "0 0 auto"
    });
  }), h = /* @__PURE__ */ b(() => `${i(c)}/${i(u).webp}`), v = /* @__PURE__ */ b(() => Re({
    width: "100%",
    height: "100%",
    position: "relative",
    "z-index": 1,
    overflow: "hidden",
    "background-color": mr(i(k), i(g)),
    "mask-image": `url(${i(h)})`,
    "-webkit-mask-image": `url(${i(h)})`,
    "mask-size": "contain",
    "-webkit-mask-size": "contain",
    "mask-position": "center",
    "-webkit-mask-position": "center",
    "mask-repeat": "no-repeat",
    "-webkit-mask-repeat": "no-repeat"
  }));
  var y = hm(), E = F(y);
  R(() => {
    Pe(y, i(m)), Pe(E, i(v));
  }), T(e, y), te(), a();
}
const ud = Symbol("selected");
function ym(e) {
  ir(ud, e);
}
function js() {
  const e = Be(ud);
  if (e === void 0)
    throw new Error("Tabs context not found");
  return e;
}
function bm(e, r) {
  re(r, !0);
  const t = () => he(o, "$control", n), [n, a] = je(), { control: o } = js();
  dr(e, He(() => t().stack)), te(), a();
}
function vm(e, r) {
  re(r, !0);
  const { selectedTabId: t, selectTab: n } = js();
  Ro(lt(t, (o) => o === r.tab_id)), dr(e, He(() => r.stack, { onclick: () => {
    n(r.tab_id, r.tab_index);
  } })), te();
}
var km = /* @__PURE__ */ B('<div role="button" tabindex="0" aria-label="Toggle" class="toggle svelte-oe1ul8"><div class="thumb svelte-oe1ul8"></div></div>');
const wm = {
  hash: "svelte-oe1ul8",
  code: `.toggle.svelte-oe1ul8 {appearance:none;--height: 31px;position:relative;width:51px;height:var(--height);border-radius:calc(var(--height) / 2);cursor:pointer;user-select:none;transition:background-color 300ms ease;}.thumb.svelte-oe1ul8 {--size: 27px;position:absolute;top:2px;width:var(--size);height:var(--size);border-radius:50%;box-shadow:0 1px 3px rgba(0, 0, 0, 0.2),
      0 1px 2px rgba(0, 0, 0, 0.12);transition:left 300ms cubic-bezier(0.25, 0.46, 0.45, 0.94),
      background-color 300ms ease;}`
};
function Pm(e, r) {
  re(r, !0), ie(e, wm);
  const t = () => he(l, "$selectedState", a), n = () => he(g, "$isActive", a), [a, o] = je(), s = /* @__PURE__ */ cr(r, ["$$slots", "$$events", "$$legacy"]), l = rt(), c = /* @__PURE__ */ b(() => ({
    ...s,
    ...tt(t(), r.overrides)
  })), u = /* @__PURE__ */ b(() => i(c).thumb_color_on), d = /* @__PURE__ */ b(() => i(c).thumb_color_off), p = /* @__PURE__ */ b(() => i(c).track_color_on), _ = /* @__PURE__ */ b(() => i(c).track_color_off), { isActive: g, selectTab: f } = js();
  Ro(g);
  const w = nt(), k = /* @__PURE__ */ b(w), m = /* @__PURE__ */ b(() => Re({
    background: n() ? mr(i(k), i(p)) : mr(i(k), i(_))
  })), h = /* @__PURE__ */ b(() => Re({
    left: n() ? "22px" : "2px",
    background: n() ? mr(i(k), i(u)) : mr(i(k), i(d))
  })), v = () => {
    f("", n() ? 0 : 1);
  }, y = (P) => {
    (P.code === "Enter" || P.code === "Space") && v();
  };
  var E = km();
  E.__click = v, E.__keydown = y;
  var S = F(E);
  R(() => {
    Pe(E, i(m)), Pe(S, i(h));
  }), T(e, E), te(), o();
}
$a(["click", "keydown"]);
var xm = /* @__PURE__ */ B("<div><!></div>");
function Em(e, r) {
  re(r, !0);
  const t = () => he(d, "$selectedState", a), n = () => he(P, "$tab", a), [a, o] = je(), s = /* @__PURE__ */ cr(r, ["$$slots", "$$events", "$$legacy"]), { control: l, tabs: c, default_tab_id: u } = s, d = rt(), p = /* @__PURE__ */ b(() => ({
    ...s,
    ...tt(t(), r.overrides)
  })), _ = /* @__PURE__ */ b(() => i(p).size), g = /* @__PURE__ */ b(() => i(p).padding), f = /* @__PURE__ */ b(() => i(p).margin), w = /* @__PURE__ */ b(() => i(p).background), k = /* @__PURE__ */ b(() => i(p).shape), m = /* @__PURE__ */ b(() => i(p).border), h = /* @__PURE__ */ b(() => i(p).shadow), v = nt(), y = /* @__PURE__ */ b(v), E = /* @__PURE__ */ b(() => Re({
    width: lr(i(_).width),
    height: lr(i(_).height),
    margin: tr(i(f)),
    padding: tr(i(g)),
    ...qn(i(y), null, i(w)),
    border: Sn(i(y), i(m)),
    "border-radius": ga(i(k)),
    "box-shadow": fa(i(y), i(h))
  })), S = Vr(Math.max(0, c.findIndex((M) => M.id === u))), P = lt(S, (M) => c[M]), x = (M, D) => {
    const j = c.findIndex((A) => A.id === M), Y = j !== -1 ? j : D;
    Y >= 0 && Y < c.length && S.set(D);
  };
  ym({
    control: Ct(l),
    selectedTabId: lt(P, (M) => M.id),
    selectTab: x,
    isActive: lt(S, (M) => M === 1)
  });
  var I = xm(), q = F(I);
  {
    var N = (M) => {
      dr(M, He(() => n().stack));
    };
    W(q, (M) => {
      n() !== void 0 && M(N);
    });
  }
  R(() => Pe(I, i(E))), T(e, I), te(), o();
}
const Sm = Object.freeze({
  leading: "flex-start",
  top: "flex-start",
  center: "center",
  trailing: "flex-end",
  bottom: "flex-end"
}), Tm = Object.freeze({
  space_between: "space-between",
  space_around: "space-around",
  space_evenly: "space-evenly",
  start: "flex-start",
  center: "center",
  end: "flex-end"
});
function Ns(e) {
  if (e.type === "zlayer")
    return {};
  const r = e.type === "vertical" ? "column" : "row", t = Tm[e.distribution] || "center", n = Sm[e.alignment] || "center";
  return {
    "flex-direction": r,
    "justify-content": t,
    "align-items": n
  };
}
const Im = Object.freeze({
  top_leading: { justifyContent: "flex-start", alignItems: "flex-start" },
  top: { justifyContent: "center", alignItems: "flex-start" },
  top_trailing: { justifyContent: "flex-end", alignItems: "flex-start" },
  leading: { justifyContent: "flex-start", alignItems: "center" },
  center: { justifyContent: "center", alignItems: "center" },
  trailing: { justifyContent: "flex-end", alignItems: "center" },
  bottom_leading: { justifyContent: "flex-start", alignItems: "flex-end" },
  bottom: { justifyContent: "center", alignItems: "flex-end" },
  bottom_trailing: { justifyContent: "flex-end", alignItems: "flex-end" }
});
function Dm(e) {
  return Im[e];
}
function Cm(e, r) {
  if (e == null)
    return {};
  const { style: t, alignment: n } = e, a = n.startsWith("top"), o = n.endsWith("leading"), s = n.endsWith("trailing"), l = !o && !s, c = r ?? 0;
  if (t === "overlay") {
    const u = l ? "translateX(-50%)" : "", d = a ? "translateY(-50%)" : "translateY(50%)";
    return {
      "z-index": 10,
      position: "absolute",
      width: "max-content",
      top: a ? gr(-c / 2) : "initial",
      bottom: a ? "initial" : gr(-c / 2),
      left: o ? gr(-c) : l ? "50%" : "initial",
      right: s ? gr(-c) : "initial",
      transform: `${u} ${d}`
    };
  }
  return t === "nested" ? {
    "z-index": 10,
    position: "absolute",
    inset: 0,
    display: "flex",
    top: a ? gr(c) : "initial",
    bottom: a ? "initial" : gr(c),
    left: o ? gr(c) : l ? "50%" : "initial",
    right: s ? gr(c) : "initial",
    transform: l ? "translateX(-50%)" : "initial"
  } : {};
}
var Am = /* @__PURE__ */ B('<div><div style="flex-grow: 1; width:100%;"></div></div>');
function qm(e, r) {
  re(r, !0);
  const t = () => he(l, "$selectedPackageId", n), [n, a] = je(), { walletButtonRender: o, onWalletButtonReady: s, selectedPackageId: l } = un(), c = { width: { type: "fill" }, height: { type: "fit" } }, u = {
    type: "vertical",
    alignment: "center",
    distribution: "center"
  }, d = /* @__PURE__ */ b(() => ({
    size: r.size ?? c,
    dimension: r.dimension ?? u,
    spacing: r.spacing ?? 0,
    margin: r.margin ?? Ca,
    border: r.border ?? null,
    shape: r.shape ?? null,
    shadow: r.shadow ?? null,
    style: r.style
  })), p = /* @__PURE__ */ b(() => i(d).size), _ = /* @__PURE__ */ b(() => i(d).dimension), g = /* @__PURE__ */ b(() => i(d).spacing), f = /* @__PURE__ */ b(() => i(d).margin), w = /* @__PURE__ */ b(() => i(d).style), k = /* @__PURE__ */ b(() => ({
    ...i(w),
    display: "flex",
    position: "relative",
    width: lr(i(p).width),
    height: lr(i(p).height),
    ...Ns(i(_)),
    gap: gr(i(g)),
    margin: tr({
      ...i(f) ? { ...i(f) } : { ...Ca }
    })
  })), m = /* @__PURE__ */ b(() => Re(i(k)));
  var h = ve(), v = Q(h);
  {
    var y = (E) => {
      var S = Am(), P = F(S);
      V_(P, (x, I) => o == null ? void 0 : o(x, I), () => ({
        selectedPackageId: t(),
        onReady: r.onWalletButtonReady ?? s
      })), R(() => Pe(S, i(m))), T(E, S);
    };
    W(v, (E) => {
      o && t() && E(y);
    });
  }
  T(e, h), te(), a();
}
var Fm = /* @__PURE__ */ B('<div class="wallet-skeleton svelte-1e2r0bl">&nbsp;</div>');
const zm = {
  hash: "svelte-1e2r0bl",
  code: `.wallet-skeleton.svelte-1e2r0bl {position:relative;overflow:hidden;border-radius:9999px;background-color:rgba(128, 128, 128, 0.16);backdrop-filter:blur(18px);min-height:48px;content:" ";flex-grow:1;width:100%;}.wallet-skeleton.svelte-1e2r0bl::before {content:"";position:absolute;inset:0;background:linear-gradient(
      135deg,
      rgba(255, 255, 255, 0.2),
      rgba(255, 255, 255, 0.01)
    );opacity:0.9;mix-blend-mode:screen;}.wallet-skeleton.svelte-1e2r0bl::after {content:"";position:absolute;inset:0;transform:translateX(-100%);background:linear-gradient(
      120deg,
      transparent 0%,
      rgba(255, 255, 255, 0.6) 20%,
      transparent 40%
    );opacity:0.8;
    animation: svelte-1e2r0bl-wallet-skeleton-shimmer 1.4s ease-in-out infinite;}

  @keyframes svelte-1e2r0bl-wallet-skeleton-shimmer {
    100% {
      transform: translateX(100%);
    }
  }`
};
function Mm(e, r) {
  re(r, !0), ie(e, zm);
  const t = { width: { type: "fill" }, height: { type: "fit" } }, n = {
    type: "vertical",
    alignment: "center",
    distribution: "center"
  }, a = /* @__PURE__ */ b(() => ({
    size: r.size ?? t,
    dimension: r.dimension ?? n,
    spacing: r.spacing ?? 0,
    margin: r.margin ?? Ca,
    border: r.border ?? null,
    shape: r.shape ?? null,
    shadow: r.shadow ?? null,
    style: r.style
  })), o = /* @__PURE__ */ b(() => i(a).size), s = /* @__PURE__ */ b(() => i(a).dimension), l = /* @__PURE__ */ b(() => i(a).spacing), c = /* @__PURE__ */ b(() => i(a).margin), u = /* @__PURE__ */ b(() => i(a).border), d = /* @__PURE__ */ b(() => i(a).shape), p = /* @__PURE__ */ b(() => i(a).shadow), _ = /* @__PURE__ */ b(() => i(a).style), g = 10, f = nt(), w = /* @__PURE__ */ b(f), k = /* @__PURE__ */ b(() => ({
    ...i(_),
    display: "flex",
    position: "relative",
    width: lr(i(o).width),
    height: lr(i(o).height),
    ...Ns(i(s)),
    gap: gr(i(l)),
    margin: tr({
      ...i(c) ? {
        ...i(c),
        bottom: Math.max(i(c).bottom, g)
      } : {
        ...Ca,
        bottom: g
      }
    })
  })), m = /* @__PURE__ */ b(() => Re({
    ...i(k),
    border: Sn(i(w), i(u)),
    "border-radius": ga(i(d)),
    "box-shadow": fa(i(w), i(p))
  }));
  var h = Fm();
  oe(h, "aria-hidden", !0), R(() => Pe(h, i(m))), T(e, h), te();
}
var jm = /* @__PURE__ */ B("<!> <!>", 1);
function Nm(e, r) {
  re(r, !0);
  const t = /* @__PURE__ */ cr(r, ["$$slots", "$$events", "$$legacy"]), {
    wallet_unknown_stack: n,
    wallet_available_stack: a,
    wallet_unavailable_stack: o,
    type: s,
    ...l
  } = t, { walletButtonRender: c, ...u } = un();
  let d = /* @__PURE__ */ X(void 0), p = /* @__PURE__ */ X(!!c);
  Wu({ walletButtonRender: c, ...u, onWalletButtonReady: (k) => {
    L(d, k, !0), L(p, !1);
  } });
  const g = /* @__PURE__ */ b(() => !i(d) || !a), f = /* @__PURE__ */ b(() => !!(a && i(d) && !i(p))), w = {
    components: [],
    type: "stack",
    visible: null,
    dimension: { type: "vertical", distribution: "start", alignment: "center" },
    background_color: null,
    spacing: 0,
    ...l
  };
  dr(e, He(() => w, {
    children: (k, m) => {
      var h = jm(), v = Q(h);
      {
        let P = /* @__PURE__ */ b(() => ({
          ...a,
          visible: i(f)
        }));
        dr(v, He(() => i(P)));
      }
      var y = V(v, 2);
      {
        var E = (P) => {
          dr(P, He(() => n));
        }, S = (P) => {
          var x = ve(), I = Q(x);
          {
            var q = (N) => {
              dr(N, He(() => o));
            };
            W(
              I,
              (N) => {
                i(g) && N(q);
              },
              !0
            );
          }
          T(P, x);
        };
        W(y, (P) => {
          i(p) ? P(E) : P(S, !1);
        });
      }
      T(k, h);
    },
    $$slots: { default: !0 }
  })), te();
}
function Sa(e, r) {
  re(r, !0);
  const t = {
    button: Xg,
    carousel: mm,
    countdown: Vm,
    express_purchase_button: Nm,
    footer: dd,
    icon: cd,
    image: lh,
    input_multiple_choice: Jg,
    input_option: nf,
    input_single_choice: af,
    package: ch,
    purchase_button: hh,
    redemption_button: qf,
    skeleton_loader: Mm,
    stack: dr,
    tab_control_button: vm,
    tab_control_toggle: Pm,
    tab_control: bm,
    tabs: Em,
    text: Zi,
    timeline: xh,
    video: qh,
    wallet_button: qm
  }, n = (g) => {
    if (t[g.type])
      return [t[g.type], g];
    const { fallback: f } = g;
    if (f && t[f == null ? void 0 : f.type])
      return [t[f.type], f];
  }, a = /* @__PURE__ */ cr(r, ["$$slots", "$$events", "$$legacy", "nodeData"]), o = /* @__PURE__ */ b(() => n(r.nodeData) ?? []), s = /* @__PURE__ */ b(() => Oo(i(o), 2)), l = /* @__PURE__ */ b(() => i(s)[0]), c = /* @__PURE__ */ b(() => i(s)[1]);
  var u = { getComponentClass: n }, d = ve(), p = Q(d);
  {
    var _ = (g) => {
      var f = ve(), w = Q(f);
      O_(w, () => i(l), (k, m) => {
        m(k, He(() => i(c) || {}, () => a));
      }), T(g, f);
    };
    W(p, (g) => {
      i(l) && g(_);
    });
  }
  return T(e, d), te(u);
}
var Om = /* @__PURE__ */ B("<div><!></div>"), Lm = /* @__PURE__ */ B("<div><!></div>"), Bm = /* @__PURE__ */ B('<div style="position: relative; width: 100%; height: 100%;"></div>'), Um = /* @__PURE__ */ B("<!> <!> <!>", 1);
const Rm = {
  hash: "svelte-1n58h32",
  code: '.stack.svelte-1n58h32 {appearance:none;position:relative;&[role="button"] {cursor:pointer;}&::before {content:"";position:absolute;top:0;left:0;width:100%;height:100%;background:var(--overlay);}}'
};
function dr(e, r) {
  re(r, !0), ie(e, Rm);
  const t = () => he(_, "$hoverState", a), n = () => he(p, "$selectedState", a), [a, o] = je(), s = /* @__PURE__ */ cr(r, ["$$slots", "$$events", "$$legacy"]), { onclick: l, children: c, class: u, testId: d } = s, p = rt(), _ = ef(), g = /* @__PURE__ */ b(() => ({
    ...s,
    ...Kg(t(), r.overrides),
    ...tt(n(), r.overrides)
  })), f = /* @__PURE__ */ b(() => i(g).components), w = /* @__PURE__ */ b(() => i(g).size), k = /* @__PURE__ */ b(() => i(g).dimension), m = /* @__PURE__ */ b(() => i(g).spacing), h = /* @__PURE__ */ b(() => i(g).margin), v = /* @__PURE__ */ b(() => i(g).padding), y = /* @__PURE__ */ b(() => i(g).background_color), E = /* @__PURE__ */ b(() => i(g).background), S = /* @__PURE__ */ b(() => i(g).border), P = /* @__PURE__ */ b(() => i(g).shape), x = /* @__PURE__ */ b(() => i(g).shadow), I = /* @__PURE__ */ b(() => i(g).badge), q = nt(), N = /* @__PURE__ */ b(q), M = /* @__PURE__ */ b(() => Re({
    display: r.visible === !1 ? "none" : "flex",
    position: "relative",
    width: lr(i(w).width),
    height: lr(i(w).height),
    ...Ns(i(k)),
    gap: gr(i(m)),
    margin: tr(i(h)),
    padding: tr(i(v)),
    ...qn(i(N), i(y), i(E)),
    border: Sn(i(N), i(S)),
    "border-radius": ga(i(P)),
    "box-shadow": fa(i(N), i(x)),
    // Read from props proxy so $derived re-evaluates when parent updates style
    ...r.style
  })), D = (C) => {
    if (C === 0 || i(k).type !== "zlayer")
      return "";
    const { justifyContent: z, alignItems: G } = Dm(i(k).alignment);
    return Re({
      position: "absolute",
      inset: 0,
      display: "flex",
      "justify-content": z,
      "align-items": G,
      "z-index": C + 1
    });
  }, j = /* @__PURE__ */ b(() => {
    var C;
    return Re(Cm(i(I), (C = i(S)) == null ? void 0 : C.width));
  });
  var Y = ve(), A = Q(Y);
  Ts(A, () => l !== void 0 ? "button" : "div", !1, (C, z) => {
    Ds(
      C,
      (de) => ({
        role: l !== void 0 ? "button" : void 0,
        onclick: l,
        style: i(M),
        class: de,
        "data-testid": d
      }),
      [() => ["stack", u].filter(Boolean).join(" ")],
      void 0,
      void 0,
      "svelte-1n58h32"
    );
    var G = Um(), H = Q(G);
    {
      var J = (de) => {
        var ue = Om(), Se = F(ue);
        Sa(Se, {
          get nodeData() {
            return i(I).stack;
          }
        }), R(() => Pe(ue, i(j))), T(de, ue);
      };
      W(H, (de) => {
        i(I) && de(J);
      });
    }
    var le = V(H, 2);
    {
      var fe = (de) => {
        var ue = Bm();
        Dt(ue, 21, () => i(f), Rt, (Se, Ce, ye) => {
          var Te = Lm(), ar = F(Te);
          Sa(ar, {
            get nodeData() {
              return i(Ce);
            }
          }), R((Ze) => Pe(Te, Ze), [() => D(ye)]), T(Se, Te);
        }), T(de, ue);
      }, pe = (de) => {
        var ue = ve(), Se = Q(ue);
        Dt(Se, 17, () => i(f), Rt, (Ce, ye) => {
          Sa(Ce, {
            get nodeData() {
              return i(ye);
            }
          });
        }), T(de, ue);
      };
      W(le, (de) => {
        i(k).type === "zlayer" ? de(fe) : de(pe, !1);
      });
    }
    var xe = V(le, 2);
    c == null || c(xe), T(z, G);
  }), T(e, Y), te(), o();
}
function ao(e) {
  return e < 10 ? `0${e}` : `${e}`;
}
function oo(e) {
  return `${e}`;
}
function ac(e) {
  const r = /* @__PURE__ */ new Date(), n = new Date(e).getTime() - r.getTime();
  if (n <= 0)
    return {
      count_days_with_zero: "00",
      count_days_without_zero: "0",
      count_hours_with_zero: "00",
      count_hours_without_zero: "0",
      count_minutes_with_zero: "00",
      count_minutes_without_zero: "0",
      count_seconds_with_zero: "00",
      count_seconds_without_zero: "0"
    };
  const a = Math.floor(n / 1e3), o = Math.floor(a / 60), s = Math.floor(o / 60), c = Math.floor(s / 24), u = s % 24, d = o % 60, p = a % 60;
  return {
    count_days_with_zero: ao(c),
    count_days_without_zero: oo(c),
    count_hours_with_zero: ao(u),
    count_hours_without_zero: oo(u),
    count_minutes_with_zero: ao(d),
    count_minutes_without_zero: oo(d),
    count_seconds_with_zero: ao(p),
    count_seconds_without_zero: oo(p)
  };
}
function oc(e) {
  const r = /* @__PURE__ */ new Date();
  return new Date(e).getTime() <= r.getTime();
}
function Vm(e, r) {
  re(r, !0);
  const t = /* @__PURE__ */ cr(r, ["$$slots", "$$events", "$$legacy"]), { countdown_stack: n, end_stack: a } = t;
  let o = /* @__PURE__ */ X($e(ac(r.style.date))), s = /* @__PURE__ */ X($e(oc(r.style.date)));
  const l = Vo(), c = Vr(i(o)), u = lt([l, c], ([p, _]) => ({ ...p, ..._ }));
  zs(u), xr(() => {
    const p = setInterval(
      () => {
        L(o, ac(r.style.date), !0), L(s, oc(r.style.date), !0), c.set(i(o));
      },
      1e3
    );
    return () => clearInterval(p);
  });
  const d = /* @__PURE__ */ b(() => i(s) && a ? a : n);
  dr(e, He(() => i(d))), te();
}
var Hm = /* @__PURE__ */ B('<div class="svelte-1fpto9e"><!></div>');
const Wm = {
  hash: "svelte-1fpto9e",
  code: "div.svelte-1fpto9e {position:sticky;bottom:0;width:100%;z-index:1000;display:flex;flex-direction:row;justify-content:center;}"
};
function dd(e, r) {
  ie(e, Wm);
  var t = Hm(), n = F(t);
  dr(n, He(() => r.stack)), T(e, t);
}
var Ym = /* @__PURE__ */ nr("<circle></circle>"), Gm = /* @__PURE__ */ nr("<path></path>"), Km = /* @__PURE__ */ nr("<path></path>"), $m = /* @__PURE__ */ nr("<path></path>"), Xm = /* @__PURE__ */ nr("<!><!><!><!>", 1);
function Eo(e, r) {
  re(r, !0);
  const t = /* @__PURE__ */ b(() => {
    var h;
    if (((h = r.shape) == null ? void 0 : h.type) !== "rectangle")
      return [0, 0, 0, 0];
    const { corners: m } = r.shape;
    return [
      (m == null ? void 0 : m.top_leading) ?? 0,
      (m == null ? void 0 : m.top_trailing) ?? 0,
      (m == null ? void 0 : m.bottom_trailing) ?? 0,
      (m == null ? void 0 : m.bottom_leading) ?? 0
    ];
  }), n = /* @__PURE__ */ b(() => Oo(i(t), 4)), a = /* @__PURE__ */ b(() => i(n)[0]), o = /* @__PURE__ */ b(() => i(n)[1]), s = /* @__PURE__ */ b(() => i(n)[2]), l = /* @__PURE__ */ b(() => i(n)[3]);
  var c = Xm(), u = Q(c);
  {
    var d = (m) => {
      var h = Ym();
      R(
        (v) => {
          oe(h, "cx", r.width / 2), oe(h, "cy", r.height / 2), oe(h, "r", v);
        },
        [() => Math.min(r.width, r.height) / 2]
      ), T(m, h);
    };
    W(u, (m) => {
      var h;
      ((h = r.shape) == null ? void 0 : h.type) === "circle" && m(d);
    });
  }
  var p = V(u);
  {
    var _ = (m) => {
      var h = Gm();
      R(() => oe(h, "d", `M 0 0 L ${r.width} 0 L ${r.width}  ${r.height} Q ${r.width / 2} ${r.height - 54} 0 ${r.height} Z`)), T(m, h);
    };
    W(p, (m) => {
      var h;
      ((h = r.shape) == null ? void 0 : h.type) === "concave" && m(_);
    });
  }
  var g = V(p);
  {
    var f = (m) => {
      var h = Km();
      R(() => oe(h, "d", `M 0 0 L ${r.width} 0 L ${r.width} ${r.height - 27} Q ${r.width / 2} ${r.height + 27} 0 ${r.height - 27} Z`)), T(m, h);
    };
    W(g, (m) => {
      var h;
      ((h = r.shape) == null ? void 0 : h.type) === "convex" && m(f);
    });
  }
  var w = V(g);
  {
    var k = (m) => {
      var h = $m();
      R(() => oe(h, "d", `M ${i(a)} 0 H ${r.width - i(o)} A ${i(o)} ${i(o)} 0 0 1 ${r.width} ${i(o)}
        V ${r.height - i(s)} A ${i(s)} ${i(s)} 0 0 1 ${r.width - i(s)} ${r.height}
        H ${i(l)} A ${i(l)} ${i(l)} 0 0 1 0 ${r.height - i(l)}
        V ${i(a)} A ${i(a)} ${i(a)} 0 0 1 ${i(a)} 0 Z`)), T(m, h);
    };
    W(w, (m) => {
      var h, v;
      (((h = r.shape) == null ? void 0 : h.type) === "rectangle" || ((v = r.shape) == null ? void 0 : v.type) === void 0) && m(k);
    });
  }
  T(e, c), te();
}
var Zm = /* @__PURE__ */ nr('<linearGradient x1="0" y1="0" x2="100%" y2="100%"><stop offset="0%"></stop><stop offset="100%"></stop></linearGradient>'), Jm = /* @__PURE__ */ nr("<stop></stop>"), Qm = /* @__PURE__ */ nr("<linearGradient></linearGradient>"), eh = /* @__PURE__ */ nr("<stop></stop>"), rh = /* @__PURE__ */ nr("<radialGradient></radialGradient>"), th = /* @__PURE__ */ nr("<!><!><!>", 1);
function pd(e, r) {
  re(r, !0);
  var t = th(), n = Q(t);
  {
    var a = (u) => {
      var d = Zm(), p = F(d), _ = V(p);
      R(() => {
        oe(d, "id", r.id), oe(p, "stop-color", r.overlay.value), oe(_, "stop-color", r.overlay.value);
      }), T(u, d);
    };
    W(n, (u) => {
      var d;
      ((d = r.overlay) == null ? void 0 : d.type) === "hex" && u(a);
    });
  }
  var o = V(n);
  {
    var s = (u) => {
      var d = Qm();
      Dt(d, 21, () => r.overlay.points, Rt, (p, _) => {
        var g = Jm();
        R(() => {
          oe(g, "offset", `${i(_).percent}%`), oe(g, "stop-color", i(_).color);
        }), T(p, g);
      }), R(() => {
        oe(d, "id", r.id), oe(d, "gradientTransform", `rotate(${r.overlay.degrees - 90}, 0.5, 0.5)`);
      }), T(u, d);
    };
    W(o, (u) => {
      var d;
      ((d = r.overlay) == null ? void 0 : d.type) === "linear" && u(s);
    });
  }
  var l = V(o);
  {
    var c = (u) => {
      var d = rh();
      Dt(d, 21, () => r.overlay.points, Rt, (p, _) => {
        var g = eh();
        R(() => {
          oe(g, "offset", `${i(_).percent}%`), oe(g, "stop-color", i(_).color);
        }), T(p, g);
      }), R(() => oe(d, "id", r.id)), T(u, d);
    };
    W(l, (u) => {
      var d;
      ((d = r.overlay) == null ? void 0 : d.type) === "radial" && u(c);
    });
  }
  T(e, t), te();
}
var nh = /* @__PURE__ */ nr('<use fill="transparent"></use>'), ah = /* @__PURE__ */ nr('<rect x="0" y="0" height="100%" width="100%"></rect>'), oh = /* @__PURE__ */ nr('<use fill="none"></use>'), ih = /* @__PURE__ */ B('<div><svg width="100%" height="100%"><defs><clipPath><!></clipPath><g><!></g><!></defs><!><g><foreignObject x="0" y="0" width="100%" height="100%"><img alt="" class="svelte-1eofasi"/></foreignObject><!><!></g></svg></div>');
const sh = {
  hash: "svelte-1eofasi",
  code: "img.svelte-1eofasi {width:100%;height:100%;object-fit:contain;object-position:center;}"
};
function lh(e, r) {
  re(r, !0), ie(e, sh);
  const t = () => he(s, "$selectedState", n), [n, a] = je(), o = /* @__PURE__ */ cr(r, ["$$slots", "$$events", "$$legacy"]), s = rt(), l = /* @__PURE__ */ b(() => ({
    ...o,
    ...tt(t(), r.overrides)
  })), c = /* @__PURE__ */ b(() => i(l).id), u = /* @__PURE__ */ b(() => i(l).source), d = /* @__PURE__ */ b(() => i(l).size), p = /* @__PURE__ */ b(() => i(l).mask_shape), _ = /* @__PURE__ */ b(() => i(l).fit_mode), g = /* @__PURE__ */ b(() => i(l).padding), f = /* @__PURE__ */ b(() => i(l).margin), w = /* @__PURE__ */ b(() => i(l).color_overlay), k = /* @__PURE__ */ b(() => i(l).border), m = /* @__PURE__ */ b(() => i(l).shadow), h = nt(), v = /* @__PURE__ */ b(h), y = /* @__PURE__ */ b(() => Vt(i(v), i(u)));
  let E = /* @__PURE__ */ X(0), S = /* @__PURE__ */ X($e({ height: 0, width: 0 }));
  xr(() => {
    if (i(y).width || i(y).height) {
      L(S, { height: i(y).height, width: i(y).width }, !0);
      return;
    }
    const _e = new window.Image();
    _e.src = i(y).original;
    const Me = () => {
      L(S, { height: _e.height, width: _e.width }, !0);
    };
    return _e.addEventListener("load", Me), () => {
      _e.removeEventListener("load", Me);
    };
  });
  const P = /* @__PURE__ */ b(() => i(d).height.type === "fixed" ? i(d).height.value : Math.round(i(E) * (i(S).height / i(S).width))), x = /* @__PURE__ */ b(() => Re({
    width: lr(i(d).width),
    height: `${i(P)}px`,
    margin: tr(i(f)),
    padding: tr(i(g)),
    "line-height": 0,
    "flex-shrink": i(d).width.type === "fixed" ? 0 : 1
  }));
  let I = /* @__PURE__ */ X(null);
  const q = /* @__PURE__ */ b(() => {
    var _e, Me;
    return [((_e = i(I)) == null ? void 0 : _e.width) ?? 0, ((Me = i(I)) == null ? void 0 : Me.height) ?? 0];
  }), N = /* @__PURE__ */ b(() => Oo(i(q), 2)), M = /* @__PURE__ */ b(() => i(N)[0]), D = /* @__PURE__ */ b(() => i(N)[1]), j = /* @__PURE__ */ b(() => `0 0 ${i(M)} ${i(D)}`), Y = /* @__PURE__ */ b(() => {
    var Ke;
    if (!((Ke = i(m)) != null && Ke.color))
      return "";
    const { x: _e, y: Me, radius: Ir, color: ne } = i(m), Ne = mr(i(v), ne);
    return `filter: drop-shadow(${_e}px ${Me}px ${Ir}px ${Ne})`;
  }), A = /* @__PURE__ */ b(() => i(w) && Vt(i(v), i(w)));
  var C = ih(), z = F(C), G = F(z), H = F(G), J = F(H);
  Eo(J, {
    get shape() {
      return i(p);
    },
    get width() {
      return i(M);
    },
    get height() {
      return i(D);
    }
  });
  var le = V(H), fe = F(le);
  Eo(fe, {
    get shape() {
      return i(p);
    },
    get width() {
      return i(M);
    },
    get height() {
      return i(D);
    }
  });
  var pe = V(le);
  {
    let _e = /* @__PURE__ */ b(() => `${i(c)}-overlay`);
    pd(pe, {
      get id() {
        return i(_e);
      },
      get overlay() {
        return i(A);
      }
    });
  }
  var xe = V(G);
  {
    var de = (_e) => {
      var Me = nh();
      R(() => oe(Me, "href", `#${i(c)}-border`)), T(_e, Me);
    };
    W(xe, (_e) => {
      i(k) && i(k).width > 0 && _e(de);
    });
  }
  var ue = V(xe), Se = F(ue), Ce = F(Se), ye = V(Se);
  {
    var Te = (_e) => {
      var Me = ah();
      R(() => oe(Me, "fill", `url(#${i(c)}-overlay)`)), T(_e, Me);
    };
    W(ye, (_e) => {
      i(A) && _e(Te);
    });
  }
  var ar = V(ye);
  {
    var Ze = (_e) => {
      var Me = oh();
      R(
        (Ir) => {
          oe(Me, "href", `#${i(c)}-border`), oe(Me, "stroke", Ir), oe(Me, "stroke-width", i(k).width);
        },
        [() => mr(i(v), i(k).color)]
      ), T(_e, Me);
    };
    W(ar, (_e) => {
      i(k) && i(k).width > 0 && _e(Ze);
    });
  }
  R(
    (_e) => {
      Pe(C, i(x)), oe(z, "viewBox", i(j)), Pe(z, i(Y)), oe(H, "id", `${i(c)}-path`), oe(le, "id", `${i(c)}-border`), oe(ue, "clip-path", `url(#${i(c)}-path)`), oe(Ce, "src", i(y).original), Pe(Ce, `object-fit:${_e ?? ""}`);
    },
    [() => xo(i(_))]
  ), Mu(z, "contentRect", (_e) => L(I, _e)), Cs(C, "clientWidth", (_e) => L(E, _e)), T(e, C), te(), a();
}
function ch(e, r) {
  re(r, !0);
  const t = () => he(d, "$selectedPackageId", c), n = () => he(p, "$variablesPerPackage", c), a = () => he(m, "$fallbackVariables", c), o = () => he(_, "$baseVariables", c), s = () => he(g, "$infoPerPackage", c), l = () => he(y, "$fallbackPackageInfo", c), [c, u] = je(), {
    selectedPackageId: d,
    variablesPerPackage: p,
    baseVariables: _,
    infoPerPackage: g
  } = un();
  _r(() => {
    r.is_selected_by_default && xl(d, r.package_id);
  });
  const f = /* @__PURE__ */ b(() => t() === r.package_id), w = Vr(i(f));
  xr(() => {
    w.set(i(f));
  }), Ro(w);
  const k = () => {
    xl(d, r.package_id);
  }, m = Vo(), h = /* @__PURE__ */ b(() => {
    var x;
    const P = (x = n()) == null ? void 0 : x[r.package_id];
    return P === void 0 ? a() : { ...o(), ...P };
  }), v = Vr(i(h));
  xr(() => {
    v.set(i(h));
  }), zs(v);
  const y = ld(), E = /* @__PURE__ */ b(() => {
    var P;
    return ((P = s()) == null ? void 0 : P[r.package_id]) ?? l();
  }), S = Vr(i(E));
  xr(() => {
    S.set(i(E));
  }), sd(S), dr(e, He(() => r.stack, { onclick: k })), te(), u();
}
var ic;
(function(e) {
  e.weekly = "$rc_weekly", e.monthly = "$rc_monthly", e.two_month = "$rc_two_month", e.three_month = "$rc_three_month", e.six_month = "$rc_six_month", e.annual = "$rc_annual", e.lifetime = "$rc_lifetime";
})(ic || (ic = {}));
const o1 = {
  /**
   * Creates a string custom variable value.
   * @param value The string value for the custom variable.
   * @returns A CustomVariableValue containing the string.
   */
  string: (e) => ({ type: "string", value: e }),
  /**
   * Creates a number custom variable value.
   * @param value The number value for the custom variable.
   * @returns A CustomVariableValue containing the number.
   */
  number: (e) => ({ type: "number", value: e }),
  /**
   * Creates a boolean custom variable value.
   * @param value The boolean value for the custom variable.
   * @returns A CustomVariableValue containing the boolean.
   */
  boolean: (e) => ({
    type: "boolean",
    value: e
  })
};
function uh(e, r) {
  const t = Object.fromEntries(Object.entries(e).map(([a, { value: o }]) => [
    a,
    String(o)
  ]));
  return r ? {
    ...Object.fromEntries(Object.entries(r.custom_variables ?? {}).map(([a, { default_value: o }]) => [
      a,
      String(o)
    ])),
    ...t
  } : t;
}
var dh = /* @__PURE__ */ B('<div class="backdrop svelte-1g411v9" role="presentation" tabindex="-1" aria-hidden="true"><div role="dialog" aria-modal="true"><!></div></div>');
const ph = {
  hash: "svelte-1g411v9",
  code: ".backdrop.svelte-1g411v9 {position:absolute;inset:0 0 0 0;width:100%;height:100%;background-color:#0000003f;display:flex;flex-direction:column;}.sheet.svelte-1g411v9 {position:absolute;inset:auto 0 0 0;transition-property:transform;transition-duration:225ms;transition-timing-function:cubic-bezier(0, 0, 0.2, 1);transform:translateY(100%);&.visible {transform:translateY(0);}}"
};
function _h(e, r) {
  re(r, !0), ie(e, ph);
  const t = () => he(l, "$selectedState", n), [n, a] = je(), o = /* @__PURE__ */ cr(r, ["$$slots", "$$events", "$$legacy"]), { stack: s } = o, l = rt(), c = /* @__PURE__ */ b(() => ({
    ...o,
    ...tt(t(), r.overrides)
  })), u = /* @__PURE__ */ b(() => i(c).size), d = /* @__PURE__ */ b(() => i(c).background), p = /* @__PURE__ */ b(() => i(c).background_blur), _ = nt(), g = /* @__PURE__ */ b(_), f = /* @__PURE__ */ b(() => Re({ background: i(p) ? "#0000003f" : "" })), w = /* @__PURE__ */ b(() => Re({
    height: lr(i(u).height),
    ...qn(i(g), null, i(d))
  })), { onButtonAction: k } = un();
  let m, h = /* @__PURE__ */ X(!1);
  _r(() => {
    requestAnimationFrame(() => {
      L(h, !0);
    });
  });
  const v = () => {
    L(h, !1);
  }, y = () => {
    i(h) || k({ type: "navigate_to", destination: "sheet", sheet: null });
  }, E = (N) => {
    N.target === N.currentTarget && v();
  }, S = (N) => {
    N.key === "Escape" && v();
  };
  let P = /* @__PURE__ */ b(() => `sheet ${i(h) ? "visible" : ""}`);
  var x = dh();
  x.__click = E, x.__keydown = S;
  var I = F(x), q = F(I);
  dr(q, He(() => s)), Uo(I, (N) => m = N, () => m), R(() => {
    Pe(x, i(f)), rr(I, 1, Is(i(P)), "svelte-1g411v9"), Pe(I, i(w));
  }), Ur("transitionend", I, y), T(e, x), te(), a();
}
$a(["click", "keydown"]);
var gh = /* @__PURE__ */ B('<div><div class="paywall-content svelte-14ombta"><!> <!></div></div> <!>', 1);
const fh = {
  hash: "svelte-14ombta",
  code: `.paywall.svelte-14ombta {position:relative;display:flex;flex-direction:column;align-items:stretch;height:100%;transition-property:filter, transform;transition-duration:0.1s;transition-timing-function:ease-in-out;transform-origin:center;&.blur {filter:blur(10px) brightness(0.8);transform:scale(1.045);}}.paywall-content.svelte-14ombta {width:100%;flex:1;display:flex;flex-direction:column;min-height:0;& > .paywall-content-scroll {flex-grow:1;min-height:0;overflow-y:auto;}}
    /* Scoped reset - same as original but only affects .paywall descendants */.paywall *,
    .paywall *::before,
    .paywall *::after {box-sizing:border-box;margin:0;padding:0;font-family:sans-serif;}.paywall {line-height:1.5;-webkit-font-smoothing:antialiased;}.paywall img,
    .paywall picture,
    .paywall video,
    .paywall canvas,
    .paywall svg {display:block;max-width:100%;}.paywall input,
    .paywall button,
    .paywall textarea,
    .paywall select {font:inherit;}.paywall p,
    .paywall h1,
    .paywall h2,
    .paywall h3,
    .paywall h4,
    .paywall h5,
    .paywall h6 {overflow-wrap:break-word;}.paywall p {text-wrap:pretty;}.paywall h1,
    .paywall h2,
    .paywall h3,
    .paywall h4,
    .paywall h5,
    .paywall h6 {text-wrap:balance;}`
};
function mh(e, r) {
  re(r, !0), ie(e, fh);
  const t = () => he(h, "$selectedPackageId", n), [n, a] = je(), o = K(r, "variablesPerPackage", 19, () => ({})), s = K(r, "globalVariables", 19, () => ({})), l = K(r, "infoPerPackage", 19, () => ({})), c = K(r, "hideBackButtons", 3, !1), u = K(r, "initialInputSelections", 19, () => ({})), d = K(r, "customVariables", 19, () => ({})), p = Zf(() => r.preferredColorMode), _ = /* @__PURE__ */ b(p), { default_locale: g, components_config: f, components_localizations: w } = r.paywallData, { base: k } = f, { getLocalizedString: m } = Jf(() => ({
    defaultLocale: g,
    selectedLocale: r.selectedLocale,
    localizations: w
  })), h = Vr(Gg(k)), v = (A) => {
    var z;
    const C = t();
    C !== void 0 && ((z = r.onPurchaseClicked) == null || z.call(r, C, A ?? ""));
  };
  let y = /* @__PURE__ */ X(void 0);
  const E = (A, C) => {
    var z, G, H, J, le, fe;
    switch (A.type) {
      case "workflow":
        C && ((z = r.onActionTriggered) == null || z.call(r, C));
        return;
      case "navigate_back":
        (G = r.onBackClicked) == null || G.call(r);
        return;
      case "restore_purchases":
        (H = r.onRestorePurchasesClicked) == null || H.call(r);
        return;
    }
    switch (A.destination) {
      case "customer_center":
        (J = r.onVisitCustomerCenterClicked) == null || J.call(r);
        return;
      case "screen_redirect":
        (le = r.onActionTriggered) == null || le.call(r, "screen_redirect");
        return;
      case "privacy_policy":
      case "terms":
      case "url":
        const pe = m(A.url.url_lid);
        pe && ((fe = r.onNavigateToUrlClicked) == null || fe.call(r, pe));
        return;
      case "sheet":
        L(y, A.sheet ?? void 0, !0);
        return;
      case "offer_code":
      case "web_paywall_link":
        return;
    }
  }, S = uh(d(), r.uiConfig);
  Wu({
    selectedPackageId: h,
    variablesPerPackage: Ct(o()),
    baseVariables: Ct({ ...s(), ...S }),
    infoPerPackage: Ct(l()),
    onPurchase: v,
    onButtonAction: E,
    walletButtonRender: r.walletButtonRender,
    uiConfig: r.uiConfig,
    hideBackButtons: c()
  });
  const P = Hg();
  Wg(P), Yg(u());
  const x = lt(h, (A) => {
    const C = o()[A || ""];
    return { ...s(), ...S, ...C };
  });
  zs(x);
  const I = lt(h, (A) => l()[A || ""]);
  sd(I);
  const q = /* @__PURE__ */ b(() => Re(qn(i(_), null, k.background)));
  _r(() => {
    Bf(r.uiConfig);
  });
  const N = /* @__PURE__ */ b(() => i(y) ? "paywall blur" : "paywall"), { stack: M, sticky_footer: D } = k;
  var j = ve(), Y = Q(j);
  Qc(
    Y,
    {
      get onerror() {
        return r.onError;
      }
    },
    (A) => {
      var C = gh(), z = Q(C), G = F(z), H = F(G);
      dr(H, He(() => M, { class: "paywall-content-scroll" }));
      var J = V(H, 2);
      {
        var le = (xe) => {
          dd(xe, He(() => D));
        };
        W(J, (xe) => {
          D && xe(le);
        });
      }
      var fe = V(z, 2);
      {
        var pe = (xe) => {
          _h(xe, He(() => i(y)));
        };
        W(fe, (xe) => {
          i(y) && xe(pe);
        });
      }
      R(() => {
        rr(z, 1, Is(i(N)), "svelte-14ombta"), Pe(z, i(q)), Pe(G, r.maxContentWidth ? `max-width: ${r.maxContentWidth}; margin-inline: auto;` : "");
      }), T(A, C);
    }
  ), T(e, j), te(), a();
}
function hh(e, r) {
  re(r, !0);
  const t = /* @__PURE__ */ cr(r, ["$$slots", "$$events", "$$legacy"]), { stack: n } = t, { onPurchase: a } = un();
  dr(e, He(() => n, { onclick: () => {
    var l;
    const s = (l = r.triggers) == null ? void 0 : l.on_purchase_press;
    a(s);
  } })), te();
}
function yh(e) {
  return {
    display: "grid",
    "grid-template-columns": "auto 1fr",
    "column-gap": `${e.column_gutter}px`,
    "align-items": "stretch",
    position: "relative",
    flex: "0 1 auto",
    width: lr(e.size.width),
    height: lr(e.size.height),
    padding: tr(e.padding),
    margin: tr(e.margin)
  };
}
function bh(e, r) {
  return {
    display: "flex",
    "flex-direction": "column",
    "justify-content": "flex-start",
    "align-items": "flex-start",
    gap: `${r.text_spacing}px`,
    height: "fit-content",
    "margin-bottom": `${r.item_spacing}px`
  };
}
var vh = /* @__PURE__ */ B("<div><div></div></div>"), kh = /* @__PURE__ */ B("<div><!> <div><!></div></div> <div><!> <!></div>", 1);
function wh(e, r) {
  re(r, !0);
  const t = () => he(s, "$selectedState", n), [n, a] = je(), o = /* @__PURE__ */ cr(r, ["$$slots", "$$events", "$$legacy"]), s = rt(), l = /* @__PURE__ */ b(() => ({
    ...o,
    ...tt(t(), r.overrides)
  })), c = /* @__PURE__ */ b(() => i(l).icon), u = /* @__PURE__ */ b(() => i(l).title), d = /* @__PURE__ */ b(() => i(l).description), p = /* @__PURE__ */ b(() => i(l).connector), _ = /* @__PURE__ */ b(() => i(l).text_spacing), g = /* @__PURE__ */ b(() => i(l).item_spacing), f = nt(), w = /* @__PURE__ */ b(f), k = Re({ position: "relative" }), m = Re({ position: "relative", "z-index": "2" }), h = /* @__PURE__ */ b(() => Re(bh(i(w), {
    text_spacing: i(_),
    item_spacing: i(g)
  }))), v = /* @__PURE__ */ b(() => {
    var Y;
    return i(p) ? Re({
      position: "absolute",
      left: "50%",
      top: `${(((Y = i(c)) == null ? void 0 : Y.size.width.value) ?? 24) / 2}px`,
      transform: "translateX(-50%)",
      "z-index": "1",
      width: `${i(p).width}px`,
      height: "100%",
      // Extend beyond icon
      "padding-top": `${i(p).margin.top}px`,
      "padding-bottom": `${i(p).margin.bottom}px`
    }) : "";
  }), y = /* @__PURE__ */ b(() => {
    if (!i(p)) return "";
    const Y = mr(i(w), i(p).color);
    return Re({ width: "100%", height: "100%", background: Y });
  });
  var E = kh(), S = Q(E), P = F(S);
  {
    var x = (Y) => {
      var A = vh(), C = F(A);
      R(() => {
        Pe(A, i(v)), Pe(C, i(y));
      }), T(Y, A);
    };
    W(P, (Y) => {
      i(p) && Y(x);
    });
  }
  var I = V(P, 2), q = F(I);
  cd(q, He(() => i(c)));
  var N = V(S, 2), M = F(N);
  Zi(M, He(() => i(u)));
  var D = V(M, 2);
  {
    var j = (Y) => {
      Zi(Y, He(() => i(d)));
    };
    W(D, (Y) => {
      i(d) && Y(j);
    });
  }
  R(() => {
    Pe(S, k), Pe(I, m), Pe(N, i(h));
  }), T(e, E), te(), a();
}
var Ph = /* @__PURE__ */ B("<div></div>");
function xh(e, r) {
  re(r, !0);
  const t = () => he(s, "$selectedState", n), [n, a] = je(), o = /* @__PURE__ */ cr(r, ["$$slots", "$$events", "$$legacy"]), s = rt(), l = /* @__PURE__ */ b(() => ({
    ...o,
    ...tt(t(), r.overrides)
  })), c = /* @__PURE__ */ b(() => i(l).items), u = /* @__PURE__ */ b(() => i(l).text_spacing), d = /* @__PURE__ */ b(() => i(l).item_spacing), p = /* @__PURE__ */ b(() => i(l).column_gutter), _ = /* @__PURE__ */ b(() => i(l).icon_alignment), g = /* @__PURE__ */ b(() => i(l).size), f = /* @__PURE__ */ b(() => i(l).padding), w = /* @__PURE__ */ b(() => i(l).margin), k = /* @__PURE__ */ b(() => P_(i(l), [
    "items",
    "text_spacing",
    "item_spacing",
    "column_gutter",
    "icon_alignment",
    "size",
    "padding",
    "margin"
  ])), m = /* @__PURE__ */ b(() => Re(yh({
    items: i(c),
    text_spacing: i(u),
    item_spacing: i(d),
    column_gutter: i(p),
    icon_alignment: i(_),
    size: i(g),
    padding: i(f),
    margin: i(w),
    ...i(k)
  })));
  var h = ve(), v = Q(h);
  {
    var y = (E) => {
      var S = Ph();
      Dt(S, 21, () => i(c), (P) => P.id, (P, x) => {
        wh(P, He(() => i(x), {
          get text_spacing() {
            return i(u);
          },
          get item_spacing() {
            return i(d);
          }
        }));
      }), R(() => Pe(S, i(m))), T(E, S);
    };
    W(v, (E) => {
      i(c).length && E(y);
    });
  }
  T(e, h), te(), a();
}
var Eh = /* @__PURE__ */ nr('<use fill="transparent"></use>'), Sh = /* @__PURE__ */ B('<img alt="" class="svelte-1syndva"/>'), Th = /* @__PURE__ */ B('<video playsinline="" class="svelte-1syndva"><track kind="captions"/></video>', 2), Ih = /* @__PURE__ */ nr('<rect x="0" y="0" height="100%" width="100%"></rect>'), Dh = /* @__PURE__ */ nr('<use fill="none"></use>'), Ch = /* @__PURE__ */ B('<div><svg width="100%" height="100%"><defs><clipPath><!></clipPath><g><!></g><!></defs><!><g><foreignObject x="0" y="0" width="100%" height="100%"><!></foreignObject><!><!></g></svg></div>');
const Ah = {
  hash: "svelte-1syndva",
  code: `video.svelte-1syndva,
  img.svelte-1syndva {width:100%;height:100%;object-fit:contain;object-position:center;}`
};
function qh(e, r) {
  re(r, !0), ie(e, Ah);
  const t = () => he(s, "$selectedState", n), [n, a] = je(), o = /* @__PURE__ */ cr(r, ["$$slots", "$$events", "$$legacy"]), s = rt(), l = /* @__PURE__ */ b(() => ({
    ...o,
    ...tt(t(), r.overrides)
  })), c = /* @__PURE__ */ b(() => i(l).id), u = /* @__PURE__ */ b(() => i(l).source), d = /* @__PURE__ */ b(() => i(l).fallback_source), p = /* @__PURE__ */ b(() => i(l).size), _ = /* @__PURE__ */ b(() => i(l).mask_shape), g = /* @__PURE__ */ b(() => i(l).fit_mode), f = /* @__PURE__ */ b(() => i(l).padding), w = /* @__PURE__ */ b(() => i(l).margin), k = /* @__PURE__ */ b(() => i(l).color_overlay), m = /* @__PURE__ */ b(() => i(l).border), h = /* @__PURE__ */ b(() => i(l).shadow), v = /* @__PURE__ */ b(() => i(l).auto_play), y = /* @__PURE__ */ b(() => i(l).loop), E = /* @__PURE__ */ b(() => i(l).mute_audio), S = /* @__PURE__ */ b(() => i(l).show_controls), P = nt(), x = /* @__PURE__ */ b(P), I = /* @__PURE__ */ b(() => i(u) ? Vt(i(x), i(u)) : null), q = /* @__PURE__ */ b(() => i(d) ? Vt(i(x), i(d)) : null);
  let N = /* @__PURE__ */ X(0), M = /* @__PURE__ */ X($e({ height: 0, width: 0 })), D = /* @__PURE__ */ X(null), j = /* @__PURE__ */ X(!1);
  xr(() => {
    if (i(I)) {
      if (i(I).width && i(I).height) {
        L(M, { height: i(I).height, width: i(I).width }, !0);
        return;
      }
      if (i(D)) {
        const ge = () => {
          var kr, Yr;
          L(
            M,
            {
              height: ((kr = i(D)) == null ? void 0 : kr.videoHeight) ?? 0,
              width: ((Yr = i(D)) == null ? void 0 : Yr.videoWidth) ?? 0
            },
            !0
          );
        }, Ae = () => {
          L(j, !0);
        };
        return i(D).addEventListener("loadedmetadata", ge), i(D).addEventListener("error", Ae), () => {
          var kr, Yr;
          (kr = i(D)) == null || kr.removeEventListener("loadedmetadata", ge), (Yr = i(D)) == null || Yr.removeEventListener("error", Ae);
        };
      }
    } else if (i(q)) {
      if (i(q).width && i(q).height) {
        L(
          M,
          {
            height: i(q).height,
            width: i(q).width
          },
          !0
        );
        return;
      }
      const ge = new window.Image();
      ge.src = i(q).original;
      const Ae = () => {
        L(M, { height: ge.height, width: ge.width }, !0);
      };
      return ge.addEventListener("load", Ae), () => {
        ge.removeEventListener("load", Ae);
      };
    }
  });
  const Y = /* @__PURE__ */ b(() => i(p).height.type === "fixed" ? i(p).height.value : Math.round(i(N) * (i(M).height / i(M).width))), A = /* @__PURE__ */ b(() => Re({
    width: lr(i(p).width),
    height: `${i(Y)}px`,
    margin: tr(i(w)),
    padding: tr(i(f)),
    "line-height": 0,
    "flex-shrink": i(p).width.type === "fixed" ? 0 : 1
  }));
  let C = /* @__PURE__ */ X(null);
  const z = /* @__PURE__ */ b(() => {
    var ge, Ae;
    return [((ge = i(C)) == null ? void 0 : ge.width) ?? 0, ((Ae = i(C)) == null ? void 0 : Ae.height) ?? 0];
  }), G = /* @__PURE__ */ b(() => Oo(i(z), 2)), H = /* @__PURE__ */ b(() => i(G)[0]), J = /* @__PURE__ */ b(() => i(G)[1]), le = /* @__PURE__ */ b(() => `0 0 ${i(H)} ${i(J)}`), fe = /* @__PURE__ */ b(() => {
    var zr;
    if (!((zr = i(h)) != null && zr.color))
      return "";
    const { x: ge, y: Ae, radius: kr, color: Yr } = i(h), dn = mr(i(x), Yr);
    return `filter: drop-shadow(${ge}px ${Ae}px ${kr}px ${dn})`;
  }), pe = /* @__PURE__ */ b(() => i(k) && Vt(i(x), i(k))), xe = /* @__PURE__ */ b(() => i(j) || !i(I));
  var de = Ch(), ue = F(de), Se = F(ue), Ce = F(Se), ye = F(Ce);
  Eo(ye, {
    get shape() {
      return i(_);
    },
    get width() {
      return i(H);
    },
    get height() {
      return i(J);
    }
  });
  var Te = V(Ce), ar = F(Te);
  Eo(ar, {
    get shape() {
      return i(_);
    },
    get width() {
      return i(H);
    },
    get height() {
      return i(J);
    }
  });
  var Ze = V(Te);
  {
    let ge = /* @__PURE__ */ b(() => `${i(c)}-overlay`);
    pd(Ze, {
      get id() {
        return i(ge);
      },
      get overlay() {
        return i(pe);
      }
    });
  }
  var _e = V(Se);
  {
    var Me = (ge) => {
      var Ae = Eh();
      R(() => oe(Ae, "href", `#${i(c)}-border`)), T(ge, Ae);
    };
    W(_e, (ge) => {
      i(m) && i(m).width > 0 && ge(Me);
    });
  }
  var Ir = V(_e), ne = F(Ir), Ne = F(ne);
  {
    var Ke = (ge) => {
      var Ae = Sh();
      R(
        (kr) => {
          oe(Ae, "src", i(q).original), Pe(Ae, `object-fit:${kr ?? ""}`);
        },
        [() => xo(i(g))]
      ), T(ge, Ae);
    }, wr = (ge) => {
      var Ae = ve(), kr = Q(Ae);
      {
        var Yr = (dn) => {
          var zr = Th();
          Uo(zr, (Mn) => L(D, Mn), () => i(D)), R(
            (Mn) => {
              oe(zr, "src", i(I).url), Pe(zr, `object-fit:${Mn ?? ""}`), zr.autoplay = i(v), zr.loop = i(y), zr.muted = i(E), zr.controls = i(S);
            },
            [() => xo(i(g))]
          ), T(dn, zr);
        };
        W(
          kr,
          (dn) => {
            i(I) && dn(Yr);
          },
          !0
        );
      }
      T(ge, Ae);
    };
    W(Ne, (ge) => {
      i(xe) && i(q) ? ge(Ke) : ge(wr, !1);
    });
  }
  var Wr = V(ne);
  {
    var Yt = (ge) => {
      var Ae = Ih();
      R(() => oe(Ae, "fill", `url(#${i(c)}-overlay)`)), T(ge, Ae);
    };
    W(Wr, (ge) => {
      i(pe) && ge(Yt);
    });
  }
  var at = V(Wr);
  {
    var zn = (ge) => {
      var Ae = Dh();
      R(
        (kr) => {
          oe(Ae, "href", `#${i(c)}-border`), oe(Ae, "stroke", kr), oe(Ae, "stroke-width", i(m).width);
        },
        [() => mr(i(x), i(m).color)]
      ), T(ge, Ae);
    };
    W(at, (ge) => {
      i(m) && i(m).width > 0 && ge(zn);
    });
  }
  R(() => {
    Pe(de, i(A)), oe(ue, "viewBox", i(le)), Pe(ue, i(fe)), oe(Ce, "id", `${i(c)}-path`), oe(Te, "id", `${i(c)}-border`), oe(Ir, "clip-path", `url(#${i(c)}-path)`);
  }), Mu(ue, "contentRect", (ge) => L(C, ge)), Cs(de, "clientWidth", (ge) => L(N, ge)), T(e, de), te(), a();
}
var Fh = /* @__PURE__ */ B("<span><!></span>");
const zh = {
  hash: "svelte-jy0f4r",
  code: `
  /* svelte-ignore css-unused-selector */.rcb-typography-heading-2xl.svelte-jy0f4r {font:var(--rc-text-heading2xl-mobile);}

  /* svelte-ignore css-unused-selector */.rcb-typography-heading-xl.svelte-jy0f4r {font:var(--rc-text-headingXl-mobile);}

  /* svelte-ignore css-unused-selector */.rcb-typography-heading-lg.svelte-jy0f4r {font:var(--rc-text-headingLg-mobile);}

  /* svelte-ignore css-unused-selector */.rcb-typography-heading-md.svelte-jy0f4r {font:var(--rc-text-headingMd-mobile);}

  /* svelte-ignore css-unused-selector */.rcb-typography-body-base.svelte-jy0f4r {font:var(--rc-text-bodyBase-mobile);}

  /* svelte-ignore css-unused-selector */.rcb-typography-body-small.svelte-jy0f4r {font:var(--rc-text-bodySmall-mobile);}

  /* svelte-ignore css-unused-selector */.rcb-typography-label-button.svelte-jy0f4r {font:var(--rc-text-labelButton-mobile);}

  /* svelte-ignore css-unused-selector */.rcb-typography-label-default.svelte-jy0f4r {font:var(--rc-text-labelDefault-mobile);}

  /* svelte-ignore css-unused-selector */.rcb-typography-caption-default.svelte-jy0f4r {font:var(--rc-text-captionDefault-mobile);}

  /* svelte-ignore css-unused-selector */.rcb-typography-caption-link.svelte-jy0f4r {font:var(--rc-text-captionLink-mobile);}

  @container layout-query-container (width >= 768px) {
    /* svelte-ignore css-unused-selector */.rcb-typography-heading-2xl.svelte-jy0f4r {font:var(--rc-text-heading2xl-desktop);}

    /* svelte-ignore css-unused-selector */.rcb-typography-heading-xl.svelte-jy0f4r {font:var(--rc-text-headingXl-desktop);}

    /* svelte-ignore css-unused-selector */.rcb-typography-heading-lg.svelte-jy0f4r {font:var(--rc-text-headingLg-desktop);}

    /* svelte-ignore css-unused-selector */.rcb-typography-heading-md.svelte-jy0f4r {font:var(--rc-text-headingMd-desktop);}

    /* svelte-ignore css-unused-selector */.rcb-typography-body-base.svelte-jy0f4r {font:var(--rc-text-bodyBase-desktop);}

    /* svelte-ignore css-unused-selector */.rcb-typography-body-small.svelte-jy0f4r {font:var(--rc-text-bodySmall-desktop);}

    /* svelte-ignore css-unused-selector */.rcb-typography-label-button.svelte-jy0f4r {font:var(--rc-text-labelButton-desktop);}

    /* svelte-ignore css-unused-selector */.rcb-typography-label-default.svelte-jy0f4r {font:var(--rc-text-labelDefault-desktop);}

    /* svelte-ignore css-unused-selector */.rcb-typography-caption-default.svelte-jy0f4r {font:var(--rc-text-captionDefault-desktop);}

    /* svelte-ignore css-unused-selector */.rcb-typography-caption-link.svelte-jy0f4r {font:var(--rc-text-captionLink-desktop);}
  }`
};
function Mh(e, r) {
  ie(e, zh);
  const t = K(r, "size", 3, "body-base");
  var n = Fh(), a = F(n);
  Xe(a, () => r.children ?? Fe), R(() => rr(n, 1, `rcb-typography rcb-typography-${t() ?? ""}`, "svelte-jy0f4r")), T(e, n);
}
const jh = {
  outerPadding: {
    mobile: "clamp(1.3125rem, 5.6vw, 1.5rem)",
    desktop: "clamp(1.5rem, 9.44vw, 5rem)"
  },
  outerPaddingSmall: {
    mobile: "clamp(0.75rem, 4.2vw, 1rem)",
    desktop: "clamp(1.5rem, 9.44vw, 5rem)"
  },
  gapSmall: {
    mobile: "0.25rem",
    desktop: "0.375rem"
  },
  gapMedium: {
    mobile: "0.5rem",
    desktop: "0.75rem"
  },
  gapLarge: {
    mobile: "0.75rem",
    desktop: "0.75rem"
  },
  gapXLarge: {
    mobile: "1rem",
    desktop: "1.5rem"
  },
  gapXXLarge: {
    mobile: "1.25rem",
    desktop: "2.25rem"
  },
  gapXXXLarge: {
    mobile: "2.25rem",
    desktop: "4.5rem"
  },
  inputHeight: {
    mobile: "3rem",
    desktop: "3rem"
  },
  gapStripeElement: {
    mobile: "0.70rem",
    desktop: "1rem"
  }
}, sc = "-apple-system, BlinkMacSystemFont, avenir next, avenir, segoe ui, helvetica neue, helvetica, Cantarell, Ubuntu, roboto, noto, arial, sans-serif", _t = {
  regular: "400",
  medium: "500",
  semibold: "600"
}, Zr = {
  12: "12px",
  14: "14px",
  16: "16px",
  18: "18px",
  24: "24px",
  28: "28px",
  32: "32px",
  36: "36px"
}, gt = {
  120: "120%",
  130: "130%",
  140: "140%"
}, ft = {
  tight: "0.20%",
  regular: "0"
}, Qe = {
  heading2xl: {
    fontSize: Zr[28],
    lineHeight: gt[120],
    fontWeight: _t.semibold,
    letterSpacing: ft.tight
  },
  headingXl: {
    fontSize: Zr[24],
    lineHeight: gt[130],
    fontWeight: _t.semibold,
    letterSpacing: ft.regular
  },
  headingLg: {
    fontSize: "20px",
    lineHeight: gt[130],
    fontWeight: _t.semibold,
    letterSpacing: ft.regular
  },
  headingMd: {
    fontSize: "16px",
    lineHeight: gt[140],
    fontWeight: _t.medium,
    letterSpacing: ft.regular
  },
  bodyBase: {
    fontSize: Zr[16],
    lineHeight: gt[140],
    fontWeight: _t.regular,
    letterSpacing: ft.regular
  },
  bodySmall: {
    fontSize: Zr[14],
    lineHeight: gt[140],
    fontWeight: _t.regular,
    letterSpacing: ft.regular
  },
  labelButton: {
    fontSize: Zr[16],
    lineHeight: gt[140],
    fontWeight: _t.regular,
    letterSpacing: ft.tight
  },
  labelDefault: {
    fontSize: Zr[14],
    lineHeight: gt[140],
    fontWeight: _t.regular,
    letterSpacing: ft.tight
  },
  captionDefault: {
    fontSize: Zr[12],
    lineHeight: gt[140],
    fontWeight: _t.regular,
    letterSpacing: ft.regular
  },
  captionLink: {
    fontSize: Zr[12],
    lineHeight: gt[140],
    fontWeight: _t.regular,
    letterSpacing: ft.regular
  }
}, mt = {
  heading2xl: {
    ...Qe.heading2xl,
    fontSize: Zr[36]
  },
  headingXl: {
    ...Qe.headingXl,
    fontSize: Zr[32]
  },
  headingLg: {
    ...Qe.headingLg,
    fontSize: Zr[24]
  },
  headingMd: {
    ...Qe.headingMd,
    fontSize: Zr[18]
  },
  bodyBase: {
    ...Qe.bodyBase
  },
  bodySmall: {
    ...Qe.bodySmall
  },
  labelButton: {
    ...Qe.labelButton
  },
  labelDefault: {
    ...Qe.labelDefault
  },
  captionDefault: {
    ...Qe.captionDefault
  },
  captionLink: {
    ...Qe.captionLink
  }
}, Nh = {
  heading2xl: {
    mobile: Qe.heading2xl,
    desktop: mt.heading2xl
  },
  headingXl: {
    desktop: mt.headingXl,
    mobile: Qe.headingXl
  },
  headingLg: {
    desktop: mt.headingLg,
    mobile: Qe.headingLg
  },
  headingMd: {
    desktop: mt.headingMd,
    mobile: Qe.headingMd
  },
  bodyBase: {
    desktop: mt.bodyBase,
    mobile: Qe.bodyBase
  },
  bodySmall: {
    desktop: mt.bodySmall,
    mobile: Qe.bodySmall
  },
  labelButton: {
    desktop: mt.labelButton,
    mobile: Qe.labelButton
  },
  labelDefault: {
    desktop: mt.labelDefault,
    mobile: Qe.labelDefault
  },
  captionDefault: {
    desktop: mt.captionDefault,
    mobile: Qe.captionDefault
  },
  captionLink: {
    desktop: mt.captionLink,
    mobile: Qe.captionLink
  }
}, Oh = {
  error: "#B0171F",
  warning: "#f4e971",
  focus: "#1148B8",
  accent: "#767676",
  primary: "#576CDB",
  "primary-hover": "rgba(87, 108, 219, .8)",
  "primary-pressed": "rgba(87, 108, 219, .9)",
  "primary-text": "#ffffff",
  white: "#ffffff",
  "grey-text-dark": "rgba(0,0,0,1)",
  "grey-text-light": "rgba(0,0,0,0.7)",
  "grey-ui-dark": "rgba(0,0,0,0.3)",
  "grey-ui-light": "rgba(0,0,0,0.1)",
  "input-background": "white",
  background: "white"
}, Lh = {
  error: "#B0171F",
  warning: "#f4e971",
  focus: "#1148B8",
  accent: "#767676",
  primary: "#576CDB",
  "primary-hover": "rgba(87, 108, 219, .8)",
  "primary-pressed": "rgba(87, 108, 219, .9)",
  "primary-text": "#ffffff",
  white: "#ffffff",
  "grey-text-dark": "rgba(0,0,0,1)",
  "grey-text-light": "rgba(0,0,0,0.7)",
  "grey-ui-dark": "rgba(0,0,0,0.3)",
  "grey-ui-light": "rgba(0,0,0,0.1)",
  "input-background": "white",
  background: "#EFF3FA"
}, _d = {
  error: "color_error",
  focus: "color_accent",
  accent: "color_accent",
  primary: "color_buttons_primary"
}, Bh = {
  ..._d,
  "input-background": "color_form_bg",
  background: "color_form_bg"
}, Uh = {
  ..._d,
  "input-background": "color_product_info_bg",
  background: "color_product_info_bg"
}, gd = {
  "input-border-radius": "4px",
  "input-button-border-radius": "8px"
}, Rh = {
  "input-border-radius": "0px",
  "input-button-border-radius": "0px"
}, Vh = {
  "input-border-radius": "12px",
  "input-button-border-radius": "9999px"
}, lc = gd, Aa = (e) => e.length == 7 ? {
  r: parseInt(e.slice(1, 3), 16),
  g: parseInt(e.slice(3, 5), 16),
  b: parseInt(e.slice(5, 7), 16)
} : e.length == 4 ? {
  r: parseInt(e[1], 16),
  g: parseInt(e[2], 16),
  b: parseInt(e[3], 16)
} : null, Os = ({ r: e, g: r, b: t, luminanceThreshold: n }) => {
  const a = (s) => (s = s / 255, s <= 0.03928 ? s / 12.92 : Math.pow((s + 0.055) / 1.055, 2.4));
  return 0.2126 * a(e) + 0.7152 * a(r) + 0.0722 * a(t) > n;
}, Ls = 0.37, Hh = (e, r = Ls) => {
  const t = Os({ ...e, luminanceThreshold: r }) ? "0,0,0" : "255,255,255";
  return {
    "grey-text-dark": `rgb(${t})`,
    "grey-text-light": `rgba(${t},0.70)`,
    "grey-ui-dark": `rgba(${t},0.3)`,
    "grey-ui-light": `rgba(${t},0.1)`
  };
};
function Wh(e, r, t) {
  const n = Aa(e) || { r: 0, g: 0, b: 0 }, a = Aa(r) || { r: 255, g: 255, b: 255 }, o = Math.round(a.r * t + n.r * (1 - t)), s = Math.round(a.g * t + n.g * (1 - t)), l = Math.round(a.b * t + n.b * (1 - t));
  return `#${Ei(o)}${Ei(s)}${Ei(l)}`;
}
function cc(e, r) {
  const t = { r: 255, g: 255, b: 255 }, n = Math.max(0, Math.min(1, r));
  let a = e, o = Aa(e) || t;
  (isNaN(o.r) || isNaN(o.g) || isNaN(o.b)) && (o = t, a = "#FFFFFF");
  const l = Os({
    ...o,
    luminanceThreshold: Ls
  }) ? "#000000" : "#FFFFFF";
  return Wh(a, l, n);
}
function Ei(e) {
  return e.toString(16).padStart(2, "0").toUpperCase();
}
const Yh = (e, r, t, n = Ls) => {
  const a = {
    "grey-text-dark": t["grey-text-dark"],
    "grey-text-light": t["grey-text-light"],
    "grey-ui-dark": t["grey-ui-dark"],
    "grey-ui-light": t["grey-ui-light"],
    "primary-text": t["primary-text"]
  };
  if (e != null && e.startsWith("#")) {
    const o = Aa(e);
    o !== null && Object.assign(a, Hh(o));
  }
  if (r != null && r.startsWith("#")) {
    const o = Aa(r);
    o !== null && (a["primary-text"] = Os({ ...o, luminanceThreshold: n }) ? "black" : "white");
  }
  return a;
}, Gh = (e) => ({
  "primary-hover": cc(e, 0.1),
  "primary-pressed": cc(e, 0.15)
}), Kh = (e, r) => e || r, $h = (e, r, t) => {
  const n = Object.entries(e).map(([a, o]) => [
    a,
    Kh(t ? t[o] : null, r[a])
  ]);
  return Object.fromEntries(n);
}, fd = (e, r, t) => {
  const n = $h(e, r, t);
  return t ? {
    ...r,
    ...n,
    ...Yh(n.background, n.primary, r),
    ...Gh(n.primary)
  } : { ...r };
}, Xh = (e) => fd(Uh, Lh, e), md = (e) => fd(Bh, Oh, e), Bs = (e) => {
  if (!e)
    return lc;
  switch (e.shapes) {
    case "rounded":
      return gd;
    case "rectangle":
      return Rh;
    case "pill":
      return Vh;
    default:
      return lc;
  }
}, So = (e = "", r) => r.map(([t, n]) => `--rc-${e}-${t}: ${n}`).join("; "), Zh = (e) => {
  const r = So("color", Object.entries(Xh(e))), t = So("shape", Object.entries(Bs(e)));
  return [r, t].join("; ");
}, Jh = (e) => {
  const r = So("color", Object.entries(md(e))), t = So("shape", Object.entries(Bs(e)));
  return [r, t].join("; ");
}, Qh = (e = "", r) => Object.entries(r).flatMap(([t, { desktop: n, mobile: a }]) => [
  `--rc-${e}-${t}-desktop: normal normal ${n.fontWeight} ${n.fontSize}/${n.lineHeight} ${sc}`,
  `--rc-${e}-${t}-mobile: normal normal ${a.fontWeight} ${a.fontSize}/${a.lineHeight} ${sc}`,
  `--rc-${e}-${t}-desktop-font-size: ${n.fontSize}`,
  `--rc-${e}-${t}-mobile-font-size: ${a.fontSize}`
]).join("; "), ey = (e = "", r) => Object.entries(r).map(([t, { mobile: n, desktop: a }]) => `--rc-${e}-${t}-mobile: ${n};  --rc-${e}-${t}-desktop: ${a};`).join(" ");
let ry = class {
  constructor(r) {
    U(this, "brandingAppearance");
    r ? this.brandingAppearance = r : this.brandingAppearance = void 0;
  }
  get shape() {
    return Bs(this.brandingAppearance);
  }
  get formColors() {
    return md(this.brandingAppearance);
  }
  get formStyleVars() {
    return Jh(this.brandingAppearance);
  }
  get productInfoStyleVars() {
    return Zh(this.brandingAppearance);
  }
  get spacing() {
    return jh;
  }
  get textStyles() {
    return Nh;
  }
  get textStyleVars() {
    return Qh("text", this.textStyles);
  }
  get spacingStyleVars() {
    return ey("spacing", this.spacing);
  }
};
var ty = /* @__PURE__ */ B('<div class="rcb-processing svelte-2hs0gb"></div>');
const ny = {
  hash: "svelte-2hs0gb",
  code: `.rcb-processing.svelte-2hs0gb {width:var(--width, 12px);aspect-ratio:1;border-radius:50%;
    animation: svelte-2hs0gb-l5 1.5s infinite linear;}

  @keyframes svelte-2hs0gb-l5 {
    0% {
      box-shadow:
        var(--shadow-offset) 0 #fff2,
        calc(-1 * var(--shadow-offset)) 0 #fff2;
      background: #fff2;
    }
    25% {
      box-shadow:
        var(--shadow-offset) 0 #fff2,
        calc(-1 * var(--shadow-offset)) 0 #ffff;
      background: #fff2;
    }
    50% {
      box-shadow:
        var(--shadow-offset) 0 #fff2,
        calc(-1 * var(--shadow-offset)) 0 #fff2;
      background: #ffff;
    }
    75% {
      box-shadow:
        var(--shadow-offset) 0 #ffff,
        calc(-1 * var(--shadow-offset)) 0 #fff2;
      background: #fff2;
    }
    100% {
      box-shadow:
        var(--shadow-offset) 0 #fff2,
        calc(-1 * var(--shadow-offset)) 0 #fff2;
      background: #fff2;
    }
  }`
};
function ay(e, r) {
  ie(e, ny);
  let t = K(r, "size", 8, "medium");
  const n = {
    small: { width: "8px", offset: "10px" },
    medium: { width: "12px", offset: "20px" },
    large: { width: "16px", offset: "30px" }
  };
  var a = ty();
  R(() => Pe(a, `--shadow-offset: ${Ye(t()), Ue(() => n[t()].offset) ?? ""}; --width: ${Ye(t()), Ue(() => n[t()].width) ?? ""};`)), T(e, a);
}
var oy = /* @__PURE__ */ B("<button><!></button>");
const iy = {
  hash: "svelte-c87n0b",
  code: `button.svelte-c87n0b {border:none;border-radius:var(--rc-shape-input-button-border-radius);cursor:pointer;height:var(--rc-spacing-inputHeight-mobile);color:var(--rc-color-grey-text-dark);background-color:var(--rc-color-grey-ui-dark);display:flex;align-items:center;justify-content:center;-webkit-tap-highlight-color:rgba(0, 0, 0, 0);-webkit-tap-highlight-color:transparent;transition:background-color 0.15s ease-in-out;user-select:none;}

  @container layout-query-container (width >= 768px) {button.svelte-c87n0b {height:var(--rc-spacing-inputHeight-desktop);}
  }

  /* focus-visible is triggered only when focused with keyboard/reader */button.svelte-c87n0b:focus-visible {outline:2px solid var(--rc-color-focus);}button.intent-primary.svelte-c87n0b {background-color:var(--rc-color-primary);color:var(--rc-color-primary-text);}button.svelte-c87n0b:disabled {color:var(--rc-color-grey-text-light);background-color:var(--rc-color-grey-ui-dark);outline:none;}button.intent-primary.svelte-c87n0b:not(:disabled):hover {background-color:var(--rc-color-primary-hover);}button.intent-primary.svelte-c87n0b:not(:disabled):active,
  button.svelte-c87n0b:active {background-color:var(--rc-color-primary-pressed);outline:none;}button.intent-primary.svelte-c87n0b:disabled {color:var(--rc-color-grey-text-light);background-color:var(--rc-color-grey-ui-dark);}`
};
function hd(e, r) {
  re(r, !0), ie(e, iy);
  const t = K(r, "intent", 3, "primary"), n = K(r, "disabled", 3, !1), a = K(r, "loading", 3, !1), o = /* @__PURE__ */ b(() => new ry(r.brandingAppearance)), s = /* @__PURE__ */ b(() => i(o).textStyleVars), l = /* @__PURE__ */ b(() => i(o).spacingStyleVars), c = /* @__PURE__ */ b(() => i(o).productInfoStyleVars), u = /* @__PURE__ */ b(() => i(o).formStyleVars), d = /* @__PURE__ */ b(() => [
    r.styleOverrides,
    i(s),
    i(l),
    i(c),
    i(u)
  ].join("; "));
  var p = oy();
  p.__click = function(...w) {
    var k;
    (k = r.onclick) == null || k.apply(this, w);
  };
  var _ = F(p);
  {
    var g = (w) => {
      ay(w, { size: "small" });
    }, f = (w) => {
      Mh(w, {
        size: "body-base",
        children: (k, m) => {
          var h = ve(), v = Q(h);
          Xe(v, () => r.children ?? Fe), T(k, h);
        },
        $$slots: { default: !0 }
      });
    };
    W(_, (w) => {
      a() ? w(g) : w(f, !1);
    });
  }
  R(() => {
    rr(p, 1, `intent-${t()}`, "svelte-c87n0b"), p.disabled = n(), oe(p, "data-testid", r.testId), oe(p, "type", r.type), Pe(p, i(d));
  }), T(e, p), te();
}
$a(["click"]);
var sy = /* @__PURE__ */ B('<footer class="rcb-modal-footer svelte-gz2zuy"><!></footer>');
const ly = {
  hash: "svelte-gz2zuy",
  code: "footer.svelte-gz2zuy {display:flex;flex-direction:column;}"
};
function cy(e, r) {
  ie(e, ly);
  let t = K(r, "children", 8);
  var n = sy(), a = F(n);
  Xe(a, () => t() ?? Fe), T(e, n);
}
const uy = {
  hash: "svelte-1lkpm18",
  code: ".rcb-modal-section.svelte-1lkpm18 {padding:8px 0px;display:flex;}section.rcb-modal-section.svelte-1lkpm18 {flex-grow:1;}.rcb-modal-section.svelte-1lkpm18:last-of-type {padding:0;}"
};
function dy(e, r) {
  ie(e, uy);
  let t = K(r, "as", 8, "section"), n = K(r, "children", 8);
  var a = ve(), o = Q(a);
  Ts(o, t, !1, (s, l) => {
    Ds(s, () => ({ class: "rcb-modal-section" }), void 0, void 0, void 0, "svelte-1lkpm18");
    var c = ve(), u = Q(c);
    Xe(u, () => n() ?? Fe), T(l, c);
  }), T(e, a);
}
var py = /* @__PURE__ */ B("<div><!></div>");
const _y = {
  hash: "svelte-7lmlfa",
  code: `.rcb-column.svelte-7lmlfa {display:flex;flex-direction:column;justify-content:flex-start;flex-grow:1;min-width:100%;}.rcb-column.justify-center.svelte-7lmlfa {justify-content:center;}.rcb-column.justify-end.svelte-7lmlfa {justify-content:flex-end;}.rcb-column.align-center.svelte-7lmlfa {align-items:center;}.rcb-column.align-end.svelte-7lmlfa {align-items:flex-end;}.rcb-column.gap-small.svelte-7lmlfa {gap:var(--rc-spacing-gapSmall-mobile);}.rcb-column.gap-medium.svelte-7lmlfa {gap:var(--rc-spacing-gapXLarge-mobile);}.rcb-column.gap-large.svelte-7lmlfa {gap:var(--rc-spacing-gapXXLarge-mobile);}

  @container layout-query-container (width >= 768px) {.rcb-column.gap-small.svelte-7lmlfa {gap:var(--rc-spacing-gapSmall-desktop);}.rcb-column.gap-medium.svelte-7lmlfa {gap:var(--rc-spacing-gapLarge-desktop);}.rcb-column.gap-large.svelte-7lmlfa {gap:var(--rc-spacing-gapXXLarge-desktop);}
  }`
};
function Us(e, r) {
  ie(e, _y);
  let t = K(r, "gap", 8, "small"), n = K(r, "justify", 8, "start"), a = K(r, "align", 8, "start"), o = K(r, "children", 8);
  var s = py(), l = F(s);
  Xe(l, () => o() ?? Fe), R(() => rr(s, 1, `rcb-column gap-${t() ?? ""} justify-${n() ?? ""} align-${a() ?? ""}`, "svelte-7lmlfa")), T(e, s);
}
var gy = /* @__PURE__ */ B('<div class="rcb-row svelte-130pyos"><!></div>');
const fy = {
  hash: "svelte-130pyos",
  code: ".rcb-row.svelte-130pyos {display:flex;flex-direction:row;justify-content:flex-start;}"
};
function my(e, r) {
  ie(e, fy);
  let t = K(r, "children", 8);
  var n = gy(), a = F(n);
  Xe(a, () => t() ?? Fe), T(e, n);
}
var hy = /* @__PURE__ */ B("<span><!></span>");
const yy = {
  hash: "svelte-y2q9vo",
  code: `.rcb-typography.svelte-y2q9vo {display:inline-block;line-height:normal;}

  /* svelte-ignore css-unused-selector */.rcb-typography-heading-2xl.svelte-y2q9vo {font:var(--rc-text-heading2xl-mobile);}.rcb-typography-heading-2xl.rcb-typography-branded.svelte-y2q9vo {font:var(--rc-text-heading2xl-branded-mobile);}

  /* svelte-ignore css-unused-selector */.rcb-typography-heading-xl.svelte-y2q9vo {font:var(--rc-text-headingXl-mobile);}.rcb-typography-heading-xl.rcb-typography-branded.svelte-y2q9vo {font:var(--rc-text-headingXl-branded-mobile);}

  /* svelte-ignore css-unused-selector */.rcb-typography-heading-lg.svelte-y2q9vo {font:var(--rc-text-headingLg-mobile);}.rcb-typography-heading-lg.rcb-typography-branded.svelte-y2q9vo {font:var(--rc-text-headingLg-branded-mobile);}

  /* svelte-ignore css-unused-selector */.rcb-typography-heading-md.svelte-y2q9vo {font:var(--rc-text-headingMd-mobile);}.rcb-typography-heading-md.rcb-typography-branded.svelte-y2q9vo {font:var(--rc-text-headingMd-branded-mobile);}

  /* svelte-ignore css-unused-selector */.rcb-typography-body-base.svelte-y2q9vo {font:var(--rc-text-bodyBase-mobile);}.rcb-typography-body-base.rcb-typography-branded.svelte-y2q9vo {font:var(--rc-text-bodyBase-branded-mobile);}

  /* svelte-ignore css-unused-selector */.rcb-typography-body-small.svelte-y2q9vo {font:var(--rc-text-bodySmall-mobile);}.rcb-typography-body-small.rcb-typography-branded.svelte-y2q9vo {font:var(--rc-text-bodySmall-branded-mobile);}

  /* svelte-ignore css-unused-selector */.rcb-typography-label-button.svelte-y2q9vo {font:var(--rc-text-labelButton-mobile);}.rcb-typography-label-button.rcb-typography-branded.svelte-y2q9vo {font:var(--rc-text-labelButton-branded-mobile);}

  /* svelte-ignore css-unused-selector */.rcb-typography-label-default.svelte-y2q9vo {font:var(--rc-text-labelDefault-mobile);}.rcb-typography-label-default.rcb-typography-branded.svelte-y2q9vo {font:var(--rc-text-labelDefault-branded-mobile);}

  /* svelte-ignore css-unused-selector */.rcb-typography-caption-default.svelte-y2q9vo {font:var(--rc-text-captionDefault-mobile);}.rcb-typography-caption-default.rcb-typography-branded.svelte-y2q9vo {font:var(--rc-text-captionDefault-branded-mobile);}

  /* svelte-ignore css-unused-selector */.rcb-typography-caption-link.svelte-y2q9vo {font:var(--rc-text-captionLink-mobile);}.rcb-typography-caption-link.rcb-typography-branded.svelte-y2q9vo {font:var(--rc-text-captionLink-branded-mobile);}

  @container layout-query-container (width >= 768px) {span.rcb-typography-branded.svelte-y2q9vo {font:var(--rc-text-brandedText-font-style-desktop);}

    /* svelte-ignore css-unused-selector */.rcb-typography-heading-2xl.svelte-y2q9vo {font:var(--rc-text-heading2xl-desktop);}.rcb-typography-heading-2xl.rcb-typography-branded.svelte-y2q9vo {font:var(--rc-text-heading2xl-branded-desktop);}

    /* svelte-ignore css-unused-selector */.rcb-typography-heading-xl.svelte-y2q9vo {font:var(--rc-text-headingXl-desktop);}.rcb-typography-heading-xl.rcb-typography-branded.svelte-y2q9vo {font:var(--rc-text-headingXl-branded-desktop);}

    /* svelte-ignore css-unused-selector */.rcb-typography-heading-lg.svelte-y2q9vo {font:var(--rc-text-headingLg-desktop);}.rcb-typography-heading-lg.rcb-typography-branded.svelte-y2q9vo {font:var(--rc-text-headingLg-branded-desktop);}

    /* svelte-ignore css-unused-selector */.rcb-typography-heading-md.svelte-y2q9vo {font:var(--rc-text-headingMd-desktop);}.rcb-typography-heading-md.rcb-typography-branded.svelte-y2q9vo {font:var(--rc-text-headingMd-branded-desktop);}

    /* svelte-ignore css-unused-selector */.rcb-typography-body-base.svelte-y2q9vo {font:var(--rc-text-bodyBase-desktop);}.rcb-typography-body-base.rcb-typography-branded.svelte-y2q9vo {font:var(--rc-text-bodyBase-branded-desktop);}

    /* svelte-ignore css-unused-selector */.rcb-typography-body-small.svelte-y2q9vo {font:var(--rc-text-bodySmall-desktop);}.rcb-typography-body-small.rcb-typography-branded.svelte-y2q9vo {font:var(--rc-text-bodySmall-branded-desktop);}

    /* svelte-ignore css-unused-selector */.rcb-typography-label-button.svelte-y2q9vo {font:var(--rc-text-labelButton-desktop);}.rcb-typography-label-button.rcb-typography-branded.svelte-y2q9vo {font:var(--rc-text-labelButton-branded-desktop);}

    /* svelte-ignore css-unused-selector */.rcb-typography-label-default.svelte-y2q9vo {font:var(--rc-text-labelDefault-desktop);}.rcb-typography-label-default.rcb-typography-branded.svelte-y2q9vo {font:var(--rc-text-labelDefault-branded-desktop);}

    /* svelte-ignore css-unused-selector */.rcb-typography-caption-default.svelte-y2q9vo {font:var(--rc-text-captionDefault-desktop);}.rcb-typography-caption-default.rcb-typography-branded.svelte-y2q9vo {font:var(--rc-text-captionDefault-branded-desktop);}

    /* svelte-ignore css-unused-selector */.rcb-typography-caption-link.svelte-y2q9vo {font:var(--rc-text-captionLink-desktop);}.rcb-typography-caption-link.rcb-typography-branded.svelte-y2q9vo {font:var(--rc-text-captionLink-branded-desktop);}
  }`
};
function we(e, r) {
  ie(e, yy);
  const t = K(r, "size", 3, "body-base"), n = K(r, "branded", 3, !1);
  var a = hy(), o = F(a);
  Xe(o, () => r.children ?? Fe), R(() => rr(a, 1, `rcb-typography rcb-typography-${t() ?? ""} ${n() ? "rcb-typography-branded" : ""}`, "svelte-y2q9vo")), T(e, a);
}
var by = /* @__PURE__ */ B("<div><!></div>"), vy = /* @__PURE__ */ B('<span style="display: block;"><!></span>'), ky = /* @__PURE__ */ B("<!> <!>", 1), wy = /* @__PURE__ */ B("<!> <!>", 1), Py = /* @__PURE__ */ B('<div class="rcb-modal-message svelte-1ldqsgm" data-type="error"><!></div>');
const xy = {
  hash: "svelte-1ldqsgm",
  code: `.rcb-modal-message-icon.svelte-1ldqsgm {flex-shrink:0;align-self:center;margin-right:16px;}.rcb-modal-message.svelte-1ldqsgm {width:100%;min-height:160px;display:flex;justify-content:center;align-items:center;flex-direction:column;text-align:left;margin-top:4px;}.rcb-modal-message[data-has-title="false"].svelte-1ldqsgm {margin-top:var(--rc-spacing-gapXXLarge-mobile);}.rcb-modal-message-icon.small.svelte-1ldqsgm {height:var(--rc-text-headingLg-mobile-font-size);width:var(--rc-text-headingLg-mobile-font-size);}.rcb-modal-message-icon.large.svelte-1ldqsgm {height:calc(2 * var(--rc-text-headingMd-mobile-font-size));width:calc(2 * var(--rc-text-headingMd-mobile-font-size));}

  @container layout-query-container (width >= 768px) {.rcb-modal-message-icon.small.svelte-1ldqsgm {height:var(--rc-text-headingLg-desktop-font-size);width:var(--rc-text-headingLg-desktop-font-size);}.rcb-modal-message-icon.large.svelte-1ldqsgm {height:calc(2 * var(--rc-text-headingMd-desktop-font-size));width:calc(2 * var(--rc-text-headingMd-desktop-font-size));}.rcb-modal-message[data-has-title="false"].svelte-1ldqsgm {margin-top:var(--rc-spacing-gapXXLarge-desktop);}
  }`
};
function Ey(e, r) {
  re(r, !0), ie(e, xy);
  const t = K(r, "title", 3, null), n = K(r, "icon", 3, null), a = 32;
  let o = /* @__PURE__ */ X(null), s = /* @__PURE__ */ X(!1), l;
  _r(() => (i(o) && (l = new ResizeObserver(() => {
    var d;
    L(s, (((d = i(o)) == null ? void 0 : d.offsetHeight) ?? 0) > a);
  }), l.observe(i(o))), () => {
    l == null || l.disconnect();
  }));
  var c = Py(), u = F(c);
  Us(u, {
    gap: "medium",
    justify: "start",
    children: (d, p) => {
      var _ = wy(), g = Q(_);
      my(g, {
        children: (k, m) => {
          var h = ky(), v = Q(h);
          {
            var y = (P) => {
              var x = by(), I = F(x);
              Xe(I, n), R(() => rr(x, 1, `rcb-modal-message-icon ${i(s) ? "large" : "small"}`, "svelte-1ldqsgm")), T(P, x);
            };
            W(v, (P) => {
              n() && P(y);
            });
          }
          var E = V(v, 2);
          {
            var S = (P) => {
              var x = vy(), I = F(x);
              we(I, {
                size: "heading-md",
                children: (q, N) => {
                  var M = De();
                  R(() => me(M, t())), T(q, M);
                },
                $$slots: { default: !0 }
              }), Uo(x, (q) => L(o, q), () => i(o)), T(P, x);
            };
            W(E, (P) => {
              t() && P(S);
            });
          }
          T(k, h);
        },
        $$slots: { default: !0 }
      });
      var f = V(g, 2);
      {
        var w = (k) => {
          we(k, {
            size: "body-small",
            children: (m, h) => {
              var v = ve(), y = Q(v);
              Xe(y, () => r.message ?? Fe), T(m, v);
            },
            $$slots: { default: !0 }
          });
        };
        W(f, (k) => {
          r.message && k(w);
        });
      }
      T(d, _);
    },
    $$slots: { default: !0 }
  }), R(() => oe(c, "data-has-title", !!t())), T(e, c), te();
}
var Sy = /* @__PURE__ */ B('<div class="rcb-modal-message-icon svelte-1h8pwwr"><!></div>'), Ty = /* @__PURE__ */ B("<!> <!>", 1), Iy = /* @__PURE__ */ B('<div class="rcb-modal-message svelte-1h8pwwr" data-type="success"><!></div>');
const Dy = {
  hash: "svelte-1h8pwwr",
  code: `.rcb-modal-message-icon.svelte-1h8pwwr {height:54px;width:54px;margin:0 auto;}.rcb-modal-message[data-has-title="false"].svelte-1h8pwwr {margin-top:var(--rc-spacing-gapXXLarge-mobile);}.rcb-modal-message.svelte-1h8pwwr {width:100%;min-height:160px;display:flex;justify-content:center;align-items:center;flex-direction:column;text-align:center;}

  @container layout-query-container (width >= 768px) {.rcb-modal-message[data-has-title="false"].svelte-1h8pwwr {margin-top:var(--rc-spacing-gapXXLarge-desktop);}
  }`
};
function Cy(e, r) {
  ie(e, Dy);
  const t = K(r, "title", 3, null), n = K(r, "icon", 3, null);
  var a = Iy(), o = F(a);
  Us(o, {
    gap: "large",
    justify: "center",
    children: (s, l) => {
      var c = Ty(), u = Q(c);
      {
        var d = (g) => {
          var f = Sy(), w = F(f);
          Xe(w, n), T(g, f);
        };
        W(u, (g) => {
          n() && g(d);
        });
      }
      var p = V(u, 2);
      {
        var _ = (g) => {
          we(g, {
            size: "heading-md",
            children: (f, w) => {
              var k = De();
              R(() => me(k, t())), T(f, k);
            },
            $$slots: { default: !0 }
          });
        };
        W(p, (g) => {
          t() && g(_);
        });
      }
      T(s, c);
    },
    $$slots: { default: !0 }
  }), R(() => oe(a, "data-has-title", !!t())), T(e, a);
}
const Ho = "rcb-ui-events-tracker", Xa = "branding";
var Ay = /* @__PURE__ */ B('<div><div class="message-layout-content svelte-clabfx"><!></div> <div class="message-layout-footer"><!></div></div>');
const qy = {
  hash: "svelte-clabfx",
  code: `.message-layout.svelte-clabfx {display:flex;flex-direction:column;}.message-layout-content.svelte-clabfx {flex-grow:1;display:flex;flex-direction:column;justify-content:center;}

  @container layout-query-container (width < 768px) {.message-layout.svelte-clabfx {flex-grow:1;gap:var(--rc-spacing-gapXXLarge-mobile);}
  }

  @container layout-query-container (width >= 768px) {.message-layout.svelte-clabfx {min-height:354px;gap:var(--rc-spacing-gapXXLarge-desktop);}.message-layout-content.svelte-clabfx {justify-content:flex-start;flex-grow:1;}
  }.message-layout-full-width.svelte-clabfx {width:100%;}

  @media (min-width: 768px) {.message-layout-full-width.svelte-clabfx {width:544px;}
  }`
};
function Rs(e, r) {
  re(r, !0), ie(e, qy);
  let t = K(r, "title", 3, null), n = K(r, "closeButtonTitle", 3, "Go back to app"), a = K(r, "icon", 3, null), o = K(r, "message", 3, null), s = K(r, "fullWidth", 3, !1);
  const l = Be(Xa);
  function c() {
    r.onDismiss();
  }
  var u = Ay();
  let d;
  var p = F(u), _ = F(p);
  dy(_, {
    children: (w, k) => {
      var m = ve(), h = Q(m);
      {
        var v = (E) => {
          Cy(E, {
            get title() {
              return t();
            },
            get icon() {
              return a();
            }
          });
        }, y = (E) => {
          Ey(E, {
            get title() {
              return t();
            },
            get icon() {
              return a();
            },
            get message() {
              return o();
            }
          });
        };
        W(h, (E) => {
          r.type === "success" ? E(v) : E(y, !1);
        });
      }
      T(w, m);
    },
    $$slots: { default: !0 }
  });
  var g = V(p, 2), f = F(g);
  cy(f, {
    children: (w, k) => {
      hd(w, {
        onclick: c,
        type: "submit",
        get brandingAppearance() {
          return l;
        },
        children: (m, h) => {
          var v = De();
          R(() => me(v, n())), T(m, v);
        },
        $$slots: { default: !0 }
      });
    },
    $$slots: { default: !0 }
  }), R(() => d = rr(u, 1, "message-layout svelte-clabfx", null, d, { "message-layout-full-width": s() })), T(e, u), te();
}
function Hr(e, r) {
  re(r, !0);
  const t = () => he(s, "$translator", n), [n, a] = je(), o = K(r, "key", 3, ""), s = Be(vr), l = /* @__PURE__ */ b(() => o() ? t().translate(o() || "", r.variables) : void 0);
  var c = ve(), u = Q(c);
  {
    var d = (_) => {
      var g = De();
      R(() => me(g, i(l))), T(_, g);
    }, p = (_) => {
      var g = ve(), f = Q(g);
      Xe(f, () => r.children ?? Fe), T(_, g);
    };
    W(u, (_) => {
      i(l) ? _(d) : _(p, !1);
    });
  }
  T(e, c), te(), a();
}
var Fy = /* @__PURE__ */ B('<p class="footer-caption svelte-1fu2zos"><!></p>'), zy = /* @__PURE__ */ B('<p class="footer-caption svelte-1fu2zos"><!></p>'), My = /* @__PURE__ */ B('<a class="terms-link svelte-1fu2zos" rel="noopener noreferrer" target="_blank"><!></a> <span class="terms-divider svelte-1fu2zos"></span>', 1), jy = /* @__PURE__ */ B("<!> <!>", 1), Ny = /* @__PURE__ */ B('<div class="footer-caption-container svelte-1fu2zos"><!> <!> <p class="footer-caption svelte-1fu2zos"><!></p></div>');
const Oy = {
  hash: "svelte-1fu2zos",
  code: `.footer-caption-container.svelte-1fu2zos {display:flex;flex-direction:column;gap:var(--rc-spacing-gapLarge-mobile);}.footer-caption.svelte-1fu2zos {color:var(--rc-color-grey-text-light);text-align:center;margin:0;}.terms-link.svelte-1fu2zos {color:inherit;}.terms-divider.svelte-1fu2zos {margin:0 4px;}

  @container layout-query-container (width >= 768px) {.footer-caption-container.svelte-1fu2zos {gap:var(--rc-spacing-gapLarge-desktop);}
  }`
};
function Ly(e, r) {
  re(r, !1), ie(e, Oy);
  const t = () => he(h, "$translator", n), [n, a] = je(), o = /* @__PURE__ */ Or(), s = /* @__PURE__ */ Or(), l = /* @__PURE__ */ Or(), c = /* @__PURE__ */ Or(), u = /* @__PURE__ */ Or(), d = /* @__PURE__ */ Or(), p = /* @__PURE__ */ Or(), _ = /* @__PURE__ */ Or(), g = /* @__PURE__ */ Or(), f = /* @__PURE__ */ Or();
  let w = K(r, "brandingInfo", 8, null), k = K(r, "purchaseOption", 8, null), m = K(r, "termsAndConditionsUrl", 8, null);
  const h = Be(vr);
  function v(D) {
    return D != null && "base" in D;
  }
  function y(D) {
    return D != null && "basePrice" in D;
  }
  function E(D) {
    return D ? D.trial ? Z.PaymentEntryPageTrialSubscriptionTermsInfo : Z.PaymentEntryPageSubscriptionTermsInfo : Z.PaymentEntryPageOtpTermsInfo;
  }
  dt(() => Ye(k()), () => {
    L(o, v(k()) ? k() : null);
  }), dt(() => Ye(k()), () => {
    L(s, y(k()) ? k() : null);
  }), dt(() => i(o), () => {
    L(l, E(i(o)));
  }), dt(() => i(o), () => {
    var D, j, Y;
    L(c, ((D = i(o)) == null ? void 0 : D.discount) ?? ((j = i(o)) == null ? void 0 : j.introPrice) ?? ((Y = i(o)) == null ? void 0 : Y.base) ?? null);
  }), dt(
    () => (i(s), i(c)),
    () => {
      var D, j, Y, A;
      L(u, ((j = (D = i(s)) == null ? void 0 : D.discount) == null ? void 0 : j.price) || ((Y = i(s)) == null ? void 0 : Y.basePrice) || ((A = i(c)) == null ? void 0 : A.price));
    }
  ), dt(() => (i(u), t()), () => {
    L(d, i(u) ? nn(i(u).amountMicros, i(u).currency, t().bcp47Locale || t().fallbackBcp47Locale) : null);
  }), dt(() => (i(c), t()), () => {
    var D, j, Y, A, C;
    L(p, (D = i(c)) != null && D.period ? t().translatePeriodFrequency(((Y = (j = i(c)) == null ? void 0 : j.period) == null ? void 0 : Y.number) || 1, (C = (A = i(c)) == null ? void 0 : A.period) == null ? void 0 : C.unit, { useMultipleWords: !0 }) : null);
  }), dt(() => (i(o), t(), Ki), () => {
    var D, j;
    L(_, (j = (D = i(o)) == null ? void 0 : D.trial) != null && j.period ? t().translateDate(Ki(/* @__PURE__ */ new Date(), i(o).trial.period, !0), { year: "numeric", month: "long", day: "numeric" }) : null);
  }), dt(
    () => (Ye(w()), i(u), t(), i(l), i(d), i(p), i(_)),
    () => {
      var D;
      L(g, w() && i(u) ? t().translate(i(l), {
        appName: (D = w()) == null ? void 0 : D.app_name,
        price: i(d),
        perFrequency: i(p),
        renewalDate: i(_)
      }) : null);
    }
  ), dt(() => (i(o), t(), Z), () => {
    L(f, i(o) ? t().translate(Z.PaymentEntryPageSubscriptionInfo) : null);
  }), y_(), Dn();
  var S = Ny(), P = F(S);
  {
    var x = (D) => {
      var j = Fy(), Y = F(j);
      we(Y, {
        size: "caption-default",
        children: (A, C) => {
          var z = De();
          R(() => me(z, i(g))), T(A, z);
        },
        $$slots: { default: !0 }
      }), T(D, j);
    };
    W(P, (D) => {
      i(g) && D(x);
    });
  }
  var I = V(P, 2);
  {
    var q = (D) => {
      var j = zy(), Y = F(j);
      we(Y, {
        size: "caption-default",
        children: (A, C) => {
          var z = De();
          R(() => me(z, i(f))), T(A, z);
        },
        $$slots: { default: !0 }
      }), T(D, j);
    };
    W(I, (D) => {
      i(f) && D(q);
    });
  }
  var N = V(I, 2), M = F(N);
  we(M, {
    size: "caption-default",
    children: (D, j) => {
      var Y = jy(), A = Q(Y);
      {
        var C = (G) => {
          var H = My(), J = Q(H), le = F(J);
          Hr(le, {
            get key() {
              return Ye(Z), Ue(() => Z.PaymentEntryPageTermsLinkLabel);
            }
          });
          var fe = V(J, 2);
          fe.textContent = "|", R(() => oe(J, "href", m())), T(G, H);
        };
        W(A, (G) => {
          m() && G(C);
        });
      }
      var z = V(A, 2);
      Hr(z, {
        get key() {
          return Ye(Z), Ue(() => Z.PaymentEntryPagePaymentStepTitle);
        }
      }), T(D, Y);
    },
    $$slots: { default: !0 }
  }), T(e, S), te(), a();
}
var Fr = /* @__PURE__ */ ((e) => (e.SDKInitialized = "sdk_initialized", e.CheckoutSessionStart = "checkout_session_start", e.CheckoutSessionEnd = "checkout_session_end", e.CheckoutFlowError = "checkout_flow_error", e.CheckoutPaymentTaxCalculation = "checkout_payment_tax_calculation", e.CheckoutPaymentFormImpression = "checkout_payment_form_impression", e.CheckoutPaymentFormError = "checkout_payment_form_error", e.CheckoutPaymentFormDismiss = "checkout_payment_form_dismiss", e.CheckoutPaymentFormSubmit = "checkout_payment_form_submit", e.CheckoutPaymentFormGatewayError = "checkout_payment_form_gateway_error", e.CheckoutPurchaseSuccessfulImpression = "checkout_purchase_successful_impression", e.CheckoutPurchaseSuccessfulDismiss = "checkout_purchase_successful_dismiss", e))(Fr || {}), Vs = /* @__PURE__ */ ((e) => (e.tax_collection_disabled = "tax_collection_disabled", e.invalid_tax_location = "invalid_tax_location", e.rate_limit_exceeded = "rate_limit_exceeded", e.missing_required_permission = "missing_required_permission", e.invalid_origin_address = "invalid_origin_address", e.taxes_not_active = "taxes_not_active", e.unexpected_gateway_error = "unexpected_gateway_error", e))(Vs || {});
function yd(e) {
  const r = {};
  for (const t in e)
    if (Object.prototype.hasOwnProperty.call(e, t)) {
      const n = t.replace(/([A-Z])/g, "_$1").toLowerCase(), a = e[t];
      a && typeof a == "object" && !Array.isArray(a) ? r[n] = yd(
        a
      ) : r[n] = a;
    }
  return r;
}
function uc(e) {
  for (let r = 0; r < e.length; r++)
    e[r] = Math.floor(Math.random() * 256);
}
function qa() {
  const e = typeof crypto < "u" ? crypto : globalThis.crypto;
  if (e && e.randomUUID)
    return e.randomUUID();
  const r = new Uint8Array(16);
  try {
    e && e.getRandomValues ? e.getRandomValues(r) : uc(r);
  } catch (n) {
    console.log(
      `Error using crypto.getRandomValues(), falling back to Math.random. + ${n}`
    ), uc(r);
  }
  r[6] = r[6] & 15 | 64, r[8] = r[8] & 63 | 128;
  const t = Array.from(r).map((n) => n.toString(16).padStart(2, "0"));
  return [
    t.slice(0, 4).join(""),
    t.slice(4, 6).join(""),
    t.slice(6, 8).join(""),
    t.slice(8, 10).join(""),
    t.slice(10, 16).join("")
  ].join("-");
}
const Tr = "sdk_checkout";
class By {
  constructor(r) {
    U(this, "EVENT_TYPE", "web_billing");
    U(this, "id");
    U(this, "timestampMs");
    U(this, "data");
    this.id = qa(), this.timestampMs = Date.now(), this.data = r;
  }
  toJSON() {
    return yd({
      id: this.id,
      timestampMs: this.timestampMs,
      type: this.EVENT_TYPE,
      eventName: this.data.eventName,
      appUserId: this.data.appUserId,
      context: {
        ...this.data.context
      },
      properties: {
        ...this.data.properties,
        traceId: this.data.traceId,
        ...this.data.workflowIdentifier !== void 0 ? { workflowIdentifier: this.data.workflowIdentifier } : {}
      }
    });
  }
}
function bd({
  errorCode: e,
  errorMessage: r,
  mode: t = Tr
}) {
  return {
    eventName: Fr.CheckoutFlowError,
    properties: {
      mode: t,
      errorCode: e,
      errorMessage: r
    }
  };
}
function Uy({
  errorCode: e,
  errorMessage: r,
  mode: t = Tr
}) {
  return {
    eventName: Fr.CheckoutPaymentFormError,
    properties: {
      mode: t,
      errorCode: e,
      errorMessage: r
    }
  };
}
function Ji({
  appearance: e,
  rcPackage: r,
  purchaseOptionToUse: t,
  customerEmail: n,
  mode: a = Tr
}) {
  return {
    eventName: Fr.CheckoutSessionStart,
    properties: {
      mode: a,
      customizationColorButtonsPrimary: (e == null ? void 0 : e.color_buttons_primary) ?? null,
      customizationColorAccent: (e == null ? void 0 : e.color_accent) ?? null,
      customizationColorError: (e == null ? void 0 : e.color_error) ?? null,
      customizationColorProductInfoBg: (e == null ? void 0 : e.color_product_info_bg) ?? null,
      customizationColorFormBg: (e == null ? void 0 : e.color_form_bg) ?? null,
      customizationColorPageBg: (e == null ? void 0 : e.color_page_bg) ?? null,
      customizationFont: (e == null ? void 0 : e.font) ?? null,
      customizationShapes: (e == null ? void 0 : e.shapes) ?? null,
      customizationShowProductDescription: (e == null ? void 0 : e.show_product_description) ?? null,
      productInterval: r.webBillingProduct.normalPeriodDuration,
      productPrice: r.webBillingProduct.price.amountMicros,
      productCurrency: r.webBillingProduct.price.currency,
      selectedProductId: r.webBillingProduct.identifier,
      selectedPackageId: r.identifier,
      selectedPurchaseOption: t.id,
      customerEmailProvidedByDeveloper: !!n
    }
  };
}
function dc({
  redemptionInfo: e,
  mode: r = Tr
}) {
  return {
    eventName: Fr.CheckoutSessionEnd,
    properties: {
      mode: r,
      outcome: "finished",
      withRedemptionInfo: !!e
    }
  };
}
function vd(e) {
  return {
    eventName: Fr.CheckoutSessionEnd,
    properties: {
      mode: (e == null ? void 0 : e.mode) ?? Tr,
      outcome: "closed"
    }
  };
}
function pc({
  errorCode: e,
  errorMessage: r,
  mode: t = Tr
}) {
  return {
    eventName: Fr.CheckoutSessionEnd,
    properties: {
      mode: t,
      outcome: "errored",
      errorCode: e,
      errorMessage: r
    }
  };
}
function kd({
  taxCalculation: e,
  taxCustomerDetails: r,
  mode: t = Tr
}) {
  const n = e.failed_reason === Vs.tax_collection_disabled ? "disabled" : e.failed_reason ? "failed" : e.tax_amount_in_micros === 0 ? "not-taxed" : "taxed", a = r === null ? "auto" : "form";
  return {
    eventName: Fr.CheckoutPaymentTaxCalculation,
    properties: {
      mode: t,
      outcome: n,
      ui_element: a,
      tax_inclusive: e.tax_inclusive,
      error_code: e.failed_reason ?? null
    }
  };
}
function wd({
  selectedPaymentMethod: e,
  mode: r = Tr
}) {
  return {
    eventName: Fr.CheckoutPaymentFormSubmit,
    properties: {
      mode: r,
      selectedPaymentMethod: e ?? null
    }
  };
}
function Qi({
  errorCode: e,
  errorMessage: r,
  mode: t = Tr
}) {
  return {
    eventName: Fr.CheckoutPaymentFormGatewayError,
    properties: {
      mode: t,
      errorCode: e,
      errorMessage: r
    }
  };
}
function Ry(e, r = Tr) {
  return {
    eventName: Fr.CheckoutPurchaseSuccessfulDismiss,
    properties: {
      mode: r,
      ui_element: e
    }
  };
}
function Vy(e = Tr) {
  return {
    eventName: Fr.CheckoutPurchaseSuccessfulImpression,
    properties: {
      mode: e
    }
  };
}
const Hy = `<svg width="80" height="80" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
  <g transform="scale(0.5)" transform-origin="center">
  <path d="M12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 16.6944 7.30558 20.5 12 20.5C16.6944 20.5 20.5 16.6944 20.5 12C20.5 11.5858 20.8358 11.25 21.25 11.25C21.6642 11.25 22 11.5858 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C12.4142 2 12.75 2.33579 12.75 2.75C12.75 3.16421 12.4142 3.5 12 3.5Z" fill="currentColor"/>
  </g>
</svg>`;
var Wy = /* @__PURE__ */ B('<div class="rcb-ui-asset-icon svelte-6k29hu"><!></div>');
const Yy = {
  hash: "svelte-6k29hu",
  code: `
  @-webkit-keyframes svelte-6k29hu-rotating /* Safari and Chrome */ {
    from {
      -webkit-transform: rotate(0deg);
      -o-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    to {
      -webkit-transform: rotate(360deg);
      -o-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  @keyframes svelte-6k29hu-rotating {
    from {
      -ms-transform: rotate(0deg);
      -moz-transform: rotate(0deg);
      -webkit-transform: rotate(0deg);
      -o-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    to {
      -ms-transform: rotate(360deg);
      -moz-transform: rotate(360deg);
      -webkit-transform: rotate(360deg);
      -o-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }div.svelte-6k29hu {width:80px;height:80px;
    -webkit-animation: svelte-6k29hu-rotating 2s ease-in-out infinite;
    -moz-animation: svelte-6k29hu-rotating 2s ease-in-out infinite;
    -ms-animation: svelte-6k29hu-rotating 2s ease-in-out infinite;
    -o-animation: svelte-6k29hu-rotating 2s ease-in-out infinite;
    animation: svelte-6k29hu-rotating 2s ease-in-out infinite;}`
};
function Pd(e, r) {
  ie(e, Yy);
  const t = K(r, "color", 3, "var(--rc-color-accent)");
  var n = Wy(), a = F(n);
  cn(a, () => Hy), R(() => Pe(n, `color:${t() ?? ""};`)), T(e, n);
}
var Gy = /* @__PURE__ */ B('<div class="rcb-modal-loader svelte-rhstd0"><!></div>');
const Ky = {
  hash: "svelte-rhstd0",
  code: `.rcb-modal-loader.svelte-rhstd0 {width:100%;flex-grow:1;display:flex;justify-content:center;align-items:center;}

  @container layout-query-container (width >= 768px) {.rcb-modal-loader.svelte-rhstd0 {align-items:flex-start;margin-top:calc(var(--rc-spacing-gapXXLarge-desktop) * 6);}
  }`
};
function xd(e) {
  ie(e, Ky);
  var r = Gy(), t = F(r);
  Pd(t, {}), T(e, r);
}
function $y(e, r) {
  var d, p;
  re(r, !0);
  const t = () => he(o, "$translator", n), [n, a] = je(), o = Be(vr), s = Be(Xa), l = /* @__PURE__ */ b(() => r.priceBreakdown ? t().formatPrice(r.priceBreakdown.totalAmountInMicros, r.priceBreakdown.currency) : null), c = (p = (d = r.subscriptionOption) == null ? void 0 : d.trial) == null ? void 0 : p.period, u = /* @__PURE__ */ b(() => c ? t().translatePeriod(c.number, c.unit) : null);
  hd(e, {
    get disabled() {
      return r.disabled;
    },
    testId: "PayButton",
    get brandingAppearance() {
      return s;
    },
    children: (_, g) => {
      var f = ve(), w = Q(f);
      {
        var k = (h) => {
          {
            let v = /* @__PURE__ */ b(() => ({ trialPeriodLabel: i(u) }));
            Hr(h, {
              get key() {
                return Z.PaymentEntryPageButtonStartTrial;
              },
              get variables() {
                return i(v);
              }
            });
          }
        }, m = (h) => {
          var v = ve(), y = Q(v);
          {
            var E = (P) => {
              {
                let x = /* @__PURE__ */ b(() => ({ formattedPrice: i(l) }));
                Hr(P, {
                  get key() {
                    return Z.PaymentEntryPageButtonWithPrice;
                  },
                  get variables() {
                    return i(x);
                  }
                });
              }
            }, S = (P) => {
              Hr(P, {
                get key() {
                  return Z.PaymentEntryPageButtonPay;
                }
              });
            };
            W(
              y,
              (P) => {
                i(l) ? P(E) : P(S, !1);
              },
              !0
            );
          }
          T(h, v);
        };
        W(w, (h) => {
          var v;
          (v = r.subscriptionOption) != null && v.trial ? h(k) : h(m, !1);
        });
      }
      T(_, f);
    },
    $$slots: { default: !0 }
  }), te(), a();
}
const Xy = {
  error: "#B0171F",
  warning: "#f4e971",
  focus: "#1148B8",
  accent: "#767676",
  primary: "#576CDB",
  "primary-hover": "rgba(87, 108, 219, .8)",
  "primary-pressed": "rgba(87, 108, 219, .9)",
  "primary-text": "#ffffff",
  white: "#ffffff",
  "grey-text-dark": "rgba(0,0,0,1)",
  "grey-text-light": "rgba(0,0,0,0.7)",
  "grey-ui-dark": "rgba(0,0,0,0.3)",
  "grey-ui-light": "rgba(0,0,0,0.1)",
  "input-background": "white",
  background: "white"
}, Zy = {
  error: "#B0171F",
  warning: "#f4e971",
  focus: "#1148B8",
  accent: "#767676",
  primary: "#576CDB",
  "primary-hover": "rgba(87, 108, 219, .8)",
  "primary-pressed": "rgba(87, 108, 219, .9)",
  "primary-text": "#ffffff",
  white: "#ffffff",
  "grey-text-dark": "rgba(0,0,0,1)",
  "grey-text-light": "rgba(0,0,0,0.7)",
  "grey-ui-dark": "rgba(0,0,0,0.3)",
  "grey-ui-light": "rgba(0,0,0,0.1)",
  "input-background": "white",
  background: "#EFF3FA"
}, Jy = {
  error: "#B0171F",
  warning: "#f4e971",
  focus: "#1148B8",
  accent: "#767676",
  primary: "#576CDB",
  "primary-hover": "rgba(87, 108, 219, .8)",
  "primary-pressed": "rgba(87, 108, 219, .9)",
  "primary-text": "#ffffff",
  white: "#ffffff",
  "grey-text-dark": "rgba(0,0,0,1)",
  "grey-text-light": "rgba(0,0,0,0.7)",
  "grey-ui-dark": "rgba(0,0,0,0.3)",
  "grey-ui-light": "rgba(0,0,0,0.1)",
  "input-background": "white",
  background: "#ffffff"
}, Hs = {
  error: "color_error",
  focus: "color_accent",
  accent: "color_accent",
  primary: "color_buttons_primary"
}, Qy = {
  ...Hs,
  "input-background": "color_form_bg",
  background: "color_form_bg"
}, eb = {
  ...Hs,
  "input-background": "color_product_info_bg",
  background: "color_product_info_bg"
}, rb = {
  ...Hs,
  "input-background": "color_page_bg",
  background: "color_page_bg"
}, Ed = {
  "input-border-radius": "4px",
  "input-button-border-radius": "8px"
}, tb = {
  "input-border-radius": "0px",
  "input-button-border-radius": "0px"
}, nb = {
  "input-border-radius": "12px",
  "input-button-border-radius": "9999px"
}, _c = Ed, Fa = "-apple-system, BlinkMacSystemFont, avenir next, avenir, segoe ui, helvetica neue, helvetica, Cantarell, Ubuntu, roboto, noto, arial, sans-serif", Sd = "BrandCustomFont", gc = `${Sd}, ${Fa}`, ht = {
  regular: "400",
  medium: "500",
  semibold: "600"
}, Jr = {
  12: "12px",
  14: "14px",
  16: "16px",
  18: "18px",
  24: "24px",
  28: "28px",
  32: "32px",
  36: "36px"
}, yt = {
  130: "130%",
  140: "140%"
}, bt = {
  tight: "0.20%",
  regular: "0",
  loose: "0.20%"
}, er = {
  heading2xl: {
    fontSize: Jr[28],
    lineHeight: yt[130],
    fontWeight: ht.semibold,
    letterSpacing: bt.loose
  },
  headingXl: {
    fontSize: Jr[24],
    lineHeight: yt[130],
    fontWeight: ht.semibold,
    letterSpacing: bt.loose
  },
  headingLg: {
    fontSize: "20px",
    lineHeight: yt[130],
    fontWeight: ht.semibold,
    letterSpacing: bt.loose
  },
  headingMd: {
    fontSize: "16px",
    lineHeight: yt[140],
    fontWeight: ht.medium,
    letterSpacing: bt.regular
  },
  bodyBase: {
    fontSize: Jr[16],
    lineHeight: yt[140],
    fontWeight: ht.regular,
    letterSpacing: bt.regular
  },
  bodySmall: {
    fontSize: Jr[14],
    lineHeight: yt[140],
    fontWeight: ht.regular,
    letterSpacing: bt.regular
  },
  labelButton: {
    fontSize: Jr[16],
    lineHeight: yt[140],
    fontWeight: ht.semibold,
    letterSpacing: bt.tight
  },
  labelDefault: {
    fontSize: Jr[14],
    lineHeight: yt[140],
    fontWeight: ht.regular,
    letterSpacing: bt.tight
  },
  captionDefault: {
    fontSize: Jr[12],
    lineHeight: yt[140],
    fontWeight: ht.regular,
    letterSpacing: bt.regular
  },
  captionLink: {
    fontSize: Jr[12],
    lineHeight: yt[140],
    fontWeight: ht.regular,
    letterSpacing: bt.regular
  }
}, vt = {
  heading2xl: {
    ...er.heading2xl,
    fontSize: Jr[36]
  },
  headingXl: {
    ...er.headingXl,
    fontSize: Jr[32]
  },
  headingLg: {
    ...er.headingLg,
    fontSize: Jr[24]
  },
  headingMd: {
    ...er.headingMd,
    fontSize: Jr[18]
  },
  bodyBase: {
    ...er.bodyBase
  },
  bodySmall: {
    ...er.bodySmall
  },
  labelButton: {
    ...er.labelButton
  },
  labelDefault: {
    ...er.labelDefault
  },
  captionDefault: {
    ...er.captionDefault
  },
  captionLink: {
    ...er.captionLink
  }
}, es = {
  heading2xl: {
    mobile: er.heading2xl,
    desktop: vt.heading2xl
  },
  headingXl: {
    desktop: vt.headingXl,
    mobile: er.headingXl
  },
  headingLg: {
    desktop: vt.headingLg,
    mobile: er.headingLg
  },
  headingMd: {
    desktop: vt.headingMd,
    mobile: er.headingMd
  },
  bodyBase: {
    desktop: vt.bodyBase,
    mobile: er.bodyBase
  },
  bodySmall: {
    desktop: vt.bodySmall,
    mobile: er.bodySmall
  },
  labelButton: {
    desktop: vt.labelButton,
    mobile: er.labelButton
  },
  labelDefault: {
    desktop: vt.labelDefault,
    mobile: er.labelDefault
  },
  captionDefault: {
    desktop: vt.captionDefault,
    mobile: er.captionDefault
  },
  captionLink: {
    desktop: vt.captionLink,
    mobile: er.captionLink
  }
}, za = (e) => e.length == 7 ? {
  r: parseInt(e.slice(1, 3), 16),
  g: parseInt(e.slice(3, 5), 16),
  b: parseInt(e.slice(5, 7), 16)
} : e.length == 4 ? {
  r: parseInt(e[1], 16),
  g: parseInt(e[2], 16),
  b: parseInt(e[3], 16)
} : null, Ws = ({
  r: e,
  g: r,
  b: t,
  luminanceThreshold: n
}) => {
  const a = (s) => (s = s / 255, s <= 0.03928 ? s / 12.92 : Math.pow((s + 0.055) / 1.055, 2.4));
  return 0.2126 * a(e) + 0.7152 * a(r) + 0.0722 * a(t) > n;
}, Ys = 0.37, ab = (e, r = Ys) => {
  const t = Ws({ ...e, luminanceThreshold: r }) ? "0,0,0" : "255,255,255";
  return {
    "grey-text-dark": `rgb(${t})`,
    "grey-text-light": `rgba(${t},0.70)`,
    "grey-ui-dark": `rgba(${t},0.3)`,
    "grey-ui-light": `rgba(${t},0.1)`
  };
};
function ob(e, r, t) {
  const n = za(e) || { r: 0, g: 0, b: 0 }, a = za(r) || { r: 255, g: 255, b: 255 }, o = Math.round(a.r * t + n.r * (1 - t)), s = Math.round(a.g * t + n.g * (1 - t)), l = Math.round(a.b * t + n.b * (1 - t));
  return `#${Si(o)}${Si(s)}${Si(l)}`;
}
function fc(e, r) {
  const t = { r: 255, g: 255, b: 255 }, n = Math.max(0, Math.min(1, r));
  let a = e, o = za(e) || t;
  (isNaN(o.r) || isNaN(o.g) || isNaN(o.b)) && (o = t, a = "#FFFFFF");
  const l = Ws({
    ...o,
    luminanceThreshold: Ys
  }) ? "#000000" : "#FFFFFF";
  return ob(a, l, n);
}
function Si(e) {
  return e.toString(16).padStart(2, "0").toUpperCase();
}
const ib = (e, r, t, n = Ys) => {
  const a = {
    "grey-text-dark": t["grey-text-dark"],
    "grey-text-light": t["grey-text-light"],
    "grey-ui-dark": t["grey-ui-dark"],
    "grey-ui-light": t["grey-ui-light"],
    "primary-text": t["primary-text"]
  };
  if (e != null && e.startsWith("#")) {
    const o = za(e);
    o !== null && Object.assign(a, ab(o));
  }
  if (r != null && r.startsWith("#")) {
    const o = za(r);
    o !== null && (a["primary-text"] = Ws({ ...o, luminanceThreshold: n }) ? "black" : "white");
  }
  return a;
}, sb = (e) => ({
  "primary-hover": fc(e, 0.1),
  "primary-pressed": fc(e, 0.15)
}), lb = (e, r) => e || r, cb = (e, r, t) => {
  const n = Object.entries(e).map(([a, o]) => [
    a,
    lb(
      t ? t[o] : null,
      r[a]
    )
  ]);
  return Object.fromEntries(n);
}, Gs = (e, r, t) => {
  const n = cb(
    e,
    r,
    t
  );
  return t ? {
    ...r,
    ...n,
    ...ib(
      n.background,
      n.primary,
      r
    ),
    ...sb(n.primary)
  } : { ...r };
}, ub = (e) => Gs(
  eb,
  Zy,
  e
), Td = (e) => Gs(
  Qy,
  Xy,
  e
), db = (e) => Gs(
  rb,
  Jy,
  e
), Wo = (e) => {
  if (!e)
    return _c;
  switch (e.shapes) {
    case "rounded":
      return Ed;
    case "rectangle":
      return tb;
    case "pill":
      return nb;
    default:
      return _c;
  }
}, sa = (e = "", r) => r.map(([t, n]) => `--rc-${e}-${t}: ${n}`).join("; "), Id = (e) => {
  const r = sa(
    "color",
    Object.entries(ub(e))
  ), t = sa(
    "shape",
    Object.entries(Wo(e))
  );
  return [r, t].join("; ");
}, pb = (e) => {
  const r = sa(
    "color",
    Object.entries(Td(e))
  ), t = sa(
    "shape",
    Object.entries(Wo(e))
  );
  return [r, t].join("; ");
}, _b = (e) => {
  const r = sa(
    "color",
    Object.entries(db(e))
  ), t = sa(
    "shape",
    Object.entries(Wo(e))
  );
  return [r, t].join("; ");
}, gb = (e = "", r, t) => Object.entries(r).flatMap(([n, { desktop: a, mobile: o }]) => {
  const s = `normal normal ${a.fontWeight} ${a.fontSize}/${a.lineHeight} ${Fa}`, l = `normal normal ${o.fontWeight} ${o.fontSize}/${o.lineHeight} ${Fa}`, c = `normal normal ${t == null ? void 0 : t.desktop.font_weight} ${t == null ? void 0 : t.desktop.font_size} ${gc}`, u = `normal normal ${t == null ? void 0 : t.mobile.font_weight} ${t == null ? void 0 : t.mobile.font_size} ${gc}`;
  return [
    `--rc-${e}-${n}-desktop: ${s}`,
    `--rc-${e}-${n}-mobile: ${l}`,
    `--rc-${e}-${n}-branded-desktop: ${t ? c : s}`,
    `--rc-${e}-${n}-branded-mobile: ${t ? u : l}`,
    `--rc-${e}-${n}-desktop-font-size: ${a.fontSize}`,
    `--rc-${e}-${n}-mobile-font-size: ${o.fontSize}`
  ];
}).join("; "), fb = (e = "", r) => Object.entries(r).map(
  ([t, { mobile: n, desktop: a }]) => `--rc-${e}-${t}-mobile: ${n};  --rc-${e}-${t}-desktop: ${a};`
).join(" "), mb = {
  outerPaddingTop: {
    mobile: "0.25rem",
    // 4px
    desktop: "clamp(1rem, 8.44vw, 7.5rem)"
    // 16px to 128px
  },
  outerPadding: {
    mobile: "clamp(1.3125rem, 5.6vw, 1.5rem)",
    // 21px to 24px
    desktop: "clamp(3rem, 6.44vw, 4.5rem)"
    // 48px to 72px
  },
  gapSmall: {
    mobile: "0.25rem",
    // 4px
    desktop: "0.5rem"
    // 8px
  },
  gapMedium: {
    mobile: "0.5rem",
    // 8px
    desktop: "0.75rem"
    // 12px
  },
  gapLarge: {
    mobile: "0.75rem",
    // 12px
    desktop: "1rem"
    // 16px
  },
  gapXLarge: {
    mobile: "1rem",
    // 16px
    desktop: "2rem"
    // 32px
  },
  gapXXLarge: {
    mobile: "1.25rem",
    // 20px
    desktop: "2.25rem"
    // 36px
  },
  gapXXXLarge: {
    mobile: "2.25rem",
    // 36px
    desktop: "5rem"
    // 80px
  },
  inputHeight: {
    // Only used with button
    // Inconsistent with design system
    // Should rely on padding spacings
    mobile: "3rem",
    // 48px
    desktop: "3rem"
    // 48px
  }
};
class la {
  constructor(r) {
    U(this, "brandingAppearance");
    r ? this.brandingAppearance = r : this.brandingAppearance = void 0;
  }
  get shape() {
    return Wo(this.brandingAppearance);
  }
  get formColors() {
    return Td(this.brandingAppearance);
  }
  get formStyleVars() {
    return pb(this.brandingAppearance);
  }
  get productInfoStyleVars() {
    return Id(this.brandingAppearance);
  }
  get pageStyleVars() {
    return _b(this.brandingAppearance);
  }
  get spacing() {
    return mb;
  }
  get textStyles() {
    return es;
  }
  getTextStyleVars(r) {
    return gb("text", this.textStyles, r);
  }
  get spacingStyleVars() {
    return fb("spacing", this.spacing);
  }
}
var rs = /* @__PURE__ */ ((e) => (e[e.ErrorLoadingStripe = 0] = "ErrorLoadingStripe", e[e.HandledFormError = 1] = "HandledFormError", e[e.UnhandledFormError = 2] = "UnhandledFormError", e))(rs || {});
class Gn {
  constructor(r, t, n) {
    this.code = r, this.gatewayErrorCode = t, this.message = n;
  }
}
const Nr = class Nr {
  /* eslint-enable @typescript-eslint/consistent-type-imports */
  static preloadStripeModule() {
    Nr.stripeModulePromise || (Nr.stripeModulePromise = import("./index-DuKHkfLn.js"));
  }
  static async getLoadStripe() {
    Nr.stripeModulePromise || (Nr.stripeModulePromise = import("./index-DuKHkfLn.js"));
    const { loadStripe: r } = await Nr.stripeModulePromise.catch(() => {
      throw new Gn(
        0,
        void 0,
        "Failed to load Stripe library"
      );
    });
    return r;
  }
  /**
   * This function converts some particular locales to the ones that stripe supports.
   * Finally falls back to 'auto' if the initialLocale is not supported by stripe.
   * @param locale
   */
  static getStripeLocale(r) {
    if (["ca", "hi", "uk"].includes(r))
      return "auto";
    const n = {
      zh_Hans: "zh",
      "zh-Hans": "zh",
      zh_Hant: "zh-TW",
      "zh-Hant": "zh-TW"
    };
    return Object.keys(n).includes(r) ? n[r] : r;
  }
  static async initializeStripe(r, t, n, a, o, s, l) {
    if (!t || !r || !n)
      throw {
        code: 0,
        gatewayErrorCode: void 0,
        message: "Stripe configuration is missing"
      };
    const u = await (await Nr.getLoadStripe())(t, {
      stripeAccount: r
    }).catch((k) => {
      throw this.mapInitializationError(k);
    });
    if (!u)
      throw {
        code: 0,
        gatewayErrorCode: void 0,
        message: "Stripe client not found"
      };
    const d = new la(a == null ? void 0 : a.appearance), p = d.shape, _ = d.formColors, g = d.textStyles, f = es.bodyBase[l].fontSize || es.bodyBase.mobile.fontSize;
    let w;
    try {
      w = u.elements({
        mode: n.mode,
        paymentMethodTypes: n.payment_method_types,
        setupFutureUsage: n.setup_future_usage,
        amount: n.amount,
        currency: n.currency,
        loader: "always",
        locale: o,
        appearance: {
          theme: "stripe",
          labels: "floating",
          variables: {
            borderRadius: p["input-border-radius"],
            focusBoxShadow: "none",
            colorDanger: _.error,
            colorTextPlaceholder: _["grey-text-light"],
            colorText: _["grey-text-dark"],
            colorTextSecondary: _["grey-text-light"],
            fontSizeBase: f,
            ...s
          },
          rules: {
            ".Input": {
              boxShadow: "none",
              paddingTop: "6px",
              paddingBottom: "6px",
              fontSize: f,
              border: `1px solid ${_["grey-ui-dark"]}`,
              backgroundColor: _["input-background"],
              color: _["grey-text-dark"]
            },
            ".Input:focus": {
              border: `1px solid ${_.focus}`,
              outline: "none"
            },
            ".Label": {
              fontWeight: g.labelDefault[l].fontWeight,
              lineHeight: "22px",
              color: _["grey-text-dark"]
            },
            ".Label--floating": {
              opacity: "1"
            },
            ".Input--invalid": {
              boxShadow: "none"
            }
          }
        }
      });
    } catch (k) {
      throw this.mapInitializationError(k);
    }
    return { stripe: u, elements: w };
  }
  static updateElementsConfiguration(r, t) {
    r.update({
      mode: t.mode,
      paymentMethodTypes: t.payment_method_types,
      setupFutureUsage: t.setup_future_usage,
      amount: t.amount,
      currency: t.currency
    });
  }
  static isStripeHandledFormError(r) {
    const t = r.type === "validation_error", n = r.type === "card_error" && r.code && this.FORM_VALIDATED_CARD_ERROR_CODES.includes(r.code);
    return t || n;
  }
  static createPaymentElement(r, t) {
    return r.create("payment", {
      business: t ? { name: t } : void 0,
      layout: {
        type: "tabs"
      },
      terms: {
        applePay: "never",
        auBecsDebit: "never",
        bancontact: "never",
        card: "never",
        cashapp: "never",
        googlePay: "never",
        ideal: "never",
        paypal: "never",
        sepaDebit: "never",
        sofort: "never",
        usBankAccount: "never"
      }
    });
  }
  static createExpressCheckoutElement(r, t, n, a) {
    const o = {
      billingAddressRequired: t,
      emailRequired: !0,
      ...n ? {
        paymentMethods: {
          applePay: "always",
          googlePay: "always"
        }
      } : {},
      ...a || {}
    };
    return r.create("expressCheckout", o);
  }
  static createLinkAuthenticationElement(r, t) {
    return r.create("linkAuthentication", {
      defaultValues: {
        email: t ?? ""
      }
    });
  }
  static async submitElements(r) {
    const { error: t } = await r.submit();
    if (t)
      throw this.mapError(t);
  }
  static mapInitializationError(r) {
    return new Gn(
      0,
      r.code,
      r.message
    );
  }
  static mapError(r) {
    return this.isStripeHandledFormError(r) ? new Gn(
      1,
      r.code,
      r.message
    ) : new Gn(
      2,
      r.code,
      r.message
    );
  }
  static async confirmElements(r, t, n, a) {
    const o = {
      clientSecret: n,
      redirect: "if_required"
    }, s = a ? {
      ...o,
      confirmParams: { confirmation_token: a }
    } : {
      ...o,
      elements: t
    }, l = n.startsWith("seti_");
    let c;
    if (l ? c = await r.confirmSetup(s) : c = await r.confirmPayment(s), c != null && c.error)
      throw this.mapError(c.error);
  }
  static async extractTaxCustomerDetails(r, t) {
    var s, l;
    const { error: n, confirmationToken: a } = await t.createConfirmationToken({
      elements: r
    });
    if (n)
      throw this.mapError(n);
    const o = (l = (s = a.payment_method_preview) == null ? void 0 : s.billing_details) == null ? void 0 : l.address;
    return {
      customerDetails: {
        countryCode: (o == null ? void 0 : o.country) ?? void 0,
        postalCode: (o == null ? void 0 : o.postal_code) ?? void 0
      },
      confirmationTokenId: a.id
    };
  }
  static nextDateForPeriod(r, t) {
    return r.unit === ce.Year ? (t.setFullYear(t.getFullYear() + r.number), t) : r.unit === ce.Month ? (t.setMonth(t.getMonth() + r.number), t) : r.unit === ce.Week ? (t.setDate(t.getDate() + r.number * 7), t) : (r.unit === ce.Day && t.setDate(t.getDate() + r.number), t);
  }
  static applePayPeriod(r) {
    return r.unit === ce.Week ? {
      recurringPaymentIntervalUnit: "day",
      recurringPaymentIntervalCount: r.number * 7
    } : {
      recurringPaymentIntervalUnit: r.unit,
      recurringPaymentIntervalCount: r.number
    };
  }
  // https://docs.stripe.com/js/elements_object/create_without_intent#stripe_elements_no_intent-options-amount
  static microsToMinimumAmountPrice(r, t) {
    return [
      "BIF",
      "CLP",
      "DJF",
      "GNF",
      "JPY",
      "KMF",
      "KRW",
      "MGA",
      "PYG",
      "RWF",
      "UGX",
      "VND",
      "VUV",
      "XAF",
      "XOF",
      "XPF"
    ].includes(t) ? Math.floor(r / 1e6) : Math.floor(r / 1e4);
  }
  static buildStripeExpressCheckoutOptionsForSubscription(r, t, n, a, o, s, l, c) {
    var w;
    const u = Nr.microsToMinimumAmountPrice(
      t.totalAmountInMicros,
      t.currency
    ), d = n.trial, p = (w = n.trial) == null ? void 0 : w.period, _ = n.base.period, g = d && p ? Nr.nextDateForPeriod(p, /* @__PURE__ */ new Date()) : void 0, f = _ ? Nr.applePayPeriod(_) : {};
    return {
      layout: {
        maxRows: s,
        maxColumns: l,
        overflow: c
      },
      applePay: {
        recurringPaymentRequest: {
          paymentDescription: r.title,
          managementURL: o,
          trialBilling: d ? {
            label: a.translate(Z.ApplePayFreeTrial),
            amount: 0
          } : void 0,
          regularBilling: {
            label: r.title,
            amount: u,
            recurringPaymentStartDate: g,
            ...f
          }
        }
      }
    };
  }
};
/* eslint-disable @typescript-eslint/consistent-type-imports */
U(Nr, "stripeModulePromise", null), U(Nr, "FORM_VALIDATED_CARD_ERROR_CODES", [
  "card_declined",
  "expired_card",
  "incorrect_cvc",
  "incorrect_number"
]);
let We = Nr;
var hb = /* @__PURE__ */ B("<div></div>");
function yb(e, r) {
  re(r, !0);
  let t = null;
  const n = "payment-element", a = async (s) => {
    await r.onError(We.mapInitializationError(s.error));
  };
  _r(() => {
    var s;
    try {
      t = We.createPaymentElement(r.elements, (s = r.brandingInfo) == null ? void 0 : s.app_name), t.mount(`#${n}`), t.on("ready", r.onReady), t.on("change", r.onChange), t.on("loaderror", a);
    } catch (l) {
      r.onError(We.mapInitializationError(l));
    }
  }), ln(() => {
    t == null || t.destroy(), t = null;
  });
  var o = hb();
  oe(o, "id", n), T(e, o), te();
}
var bb = /* @__PURE__ */ B("<div></div>");
function vb(e, r) {
  re(r, !0);
  let t = null;
  const n = "link-authentication-element", a = async (s) => {
    await r.onError(We.mapInitializationError(s.error));
  };
  _r(() => {
    try {
      t = We.createLinkAuthenticationElement(r.elements, r.email), t.mount(`#${n}`), t.on("ready", r.onReady), t.on("change", r.onChange), t.on("loaderror", a);
    } catch (s) {
      r.onError(We.mapInitializationError(s));
    }
  }), ln(() => {
    t == null || t.destroy(), t = null;
  });
  var o = bb();
  oe(o, "id", n), T(e, o), te();
}
var kb = /* @__PURE__ */ B('<div class="text-separator svelte-3efq78"><hr class="line svelte-3efq78"/> <span class="text svelte-3efq78"><!></span> <hr class="line svelte-3efq78"/></div>');
const wb = {
  hash: "svelte-3efq78",
  code: `.text-separator.svelte-3efq78 {display:flex;align-items:center;justify-content:center;gap:var(--rc-spacing-gapSmall-mobile);}

  @container layout-query-container (width >= 768px) {.text-separator.svelte-3efq78 {gap:var(--rc-spacing-gapSmall-desktop);}
  }.line.svelte-3efq78 {flex:1;height:1px;background-color:var(--rc-color-grey-ui-dark);border:none;}.text.svelte-3efq78 {color:var(--rc-color-grey-text-light);text-transform:uppercase;white-space:nowrap;}`
};
function Pb(e, r) {
  ie(e, wb);
  let t = K(r, "text", 8);
  var n = kb(), a = V(F(n), 2), o = F(a);
  we(o, {
    size: "caption-default",
    children: (s, l) => {
      var c = De();
      R(() => me(c, t())), T(s, c);
    },
    $$slots: { default: !0 }
  }), T(e, n);
}
var xb = /* @__PURE__ */ B("<div></div> <!>", 1);
function Dd(e, r) {
  re(r, !0);
  const t = () => he(s, "$translator", n), [n, a] = je(), o = K(r, "hideCheckoutSeparator", 3, !1), s = Be(vr);
  let l = null, c = /* @__PURE__ */ X(!1);
  const u = `express-checkout-element-${(/* @__PURE__ */ new Date()).getTime()}`, d = async () => {
    r.onCancel && r.onCancel();
  }, p = async (h) => {
    const v = {
      ...r.expressCheckoutOptions ? r.expressCheckoutOptions : {}
    };
    r.onClick && r.onClick(h), h.resolve(v);
  }, _ = async (h) => {
    await r.onError(We.mapInitializationError(h.error));
  }, g = async (h) => {
    var v;
    return r.onSubmit(h.expressPaymentType, ((v = h.billingDetails) == null ? void 0 : v.email) ?? "", h);
  }, f = async (h) => {
    L(c, !h.availablePaymentMethods), r.onReady && r.onReady(h);
  };
  _r(() => {
    try {
      l = We.createExpressCheckoutElement(r.elements, r.billingAddressRequired, r.forceEnableWalletMethods, r.expressCheckoutOptions), l.mount(`#${u}`), l.on("ready", f), l.on("confirm", g), l.on("loaderror", _), l.on("click", p), l.on("cancel", d);
    } catch (h) {
      r.onError(We.mapInitializationError(h));
    }
  }), ln(() => {
    l == null || l.destroy(), l = null;
  });
  var w = ve(), k = Q(w);
  {
    var m = (h) => {
      var v = xb(), y = Q(v), E = V(y, 2);
      {
        var S = (P) => {
          {
            let x = /* @__PURE__ */ b(() => t().translate(Z.PaymentEntryPageExpressCheckoutDivider));
            Pb(P, {
              get text() {
                return i(x);
              }
            });
          }
        };
        W(E, (P) => {
          o() || P(S);
        });
      }
      R(() => oe(y, "id", u)), T(h, v);
    };
    W(k, (h) => {
      i(c) || h(m);
    });
  }
  T(e, w), te(), a();
}
var Eb = /* @__PURE__ */ B('<div class="rc-elements svelte-kvz7kd"><!> <!> <!></div>');
const Sb = {
  hash: "svelte-kvz7kd",
  code: `.rc-elements.svelte-kvz7kd {display:flex;flex-direction:column;gap:var(--rc-spacing-gapXLarge-mobile);}

  @container layout-query-container (width >= 768px) {.rc-elements.svelte-kvz7kd {gap:var(--rc-spacing-gapLarge-desktop);}
  }`
};
function Tb(e, r) {
  re(r, !0), ie(e, Sb);
  const t = () => he(l, "$translator", n), [n, a] = je();
  let o = K(r, "stripe", 15, null), s = K(r, "elements", 15, null);
  const l = Be(vr), c = We.getStripeLocale(t().bcp47Locale || t().fallbackBcp47Locale);
  let u = /* @__PURE__ */ X(!1), d = /* @__PURE__ */ X($e(r.skipEmail)), p = /* @__PURE__ */ X(!1), _ = /* @__PURE__ */ X(void 0), g = /* @__PURE__ */ X("mobile"), f = /* @__PURE__ */ X(void 0);
  function w() {
    window.matchMedia && window.matchMedia("(max-width: 767px)").matches ? L(g, "mobile") : L(g, "desktop"), L(
      _,
      {
        // Floating labels size cannot be overriden in Stripe since `!important` is being used.
        // There we set fontSizeBase to the desired label size
        // and update the input font size to 16px.
        fontSizeBase: "14px",
        fontFamily: Fa,
        // Spacing is hardcoded to 16px to match the desired gaps in mobile/desktop
        // which do not match the design system spacing. Also we cannot use "rem" units
        // since the fontSizeBase is set to 14px per the comment above.
        spacingGridRow: "16px"
      },
      !0
    );
  }
  function k() {
    clearTimeout(i(f)), L(
      f,
      setTimeout(
        () => {
          w();
        },
        150
      ),
      !0
    );
  }
  const m = (q) => {
    r.onError(q), r.onLoadingComplete();
  }, h = async () => {
    i(d) || (L(d, !0), i(d) && i(u) && i(p) && r.onLoadingComplete());
  }, v = async () => {
    i(p) || (L(p, !0), i(d) && i(u) && i(p) && r.onLoadingComplete());
  }, y = async () => {
    i(u) || (L(u, !0), i(d) && i(u) && i(p) && r.onLoadingComplete());
  }, E = async (q) => {
    r.onPaymentInfoChange({
      complete: q.complete,
      paymentMethod: q.complete ? q.value.type : void 0
    });
  }, S = async (q) => {
    r.onEmailChange(q.complete, q.value.email);
  };
  _r(() => (window.addEventListener("resize", k), () => {
    window.removeEventListener("resize", k);
  })), _r(async () => {
    w(), !o() && (s() || !r.stripeAccountId || !r.publishableApiKey || !r.elementsConfiguration || await We.initializeStripe(r.stripeAccountId, r.publishableApiKey, r.elementsConfiguration, r.brandingInfo, c, i(_), i(g)).then(({ stripe: q, elements: N }) => {
      o(q), s(N);
    }).catch((q) => {
      r.onError(q);
    }));
  }), xr(() => {
    r.elementsConfiguration && s() && We.updateElementsConfiguration(s(), r.elementsConfiguration);
  });
  var P = ve(), x = Q(P);
  {
    var I = (q) => {
      var N = Eb(), M = F(N);
      Dd(M, {
        get elements() {
          return s();
        },
        onError: m,
        onReady: v,
        get onSubmit() {
          return r.onExpressCheckoutElementSubmit;
        },
        get expressCheckoutOptions() {
          return r.expressCheckoutOptions;
        },
        get forceEnableWalletMethods() {
          return r.forceEnableWalletMethods;
        },
        get billingAddressRequired() {
          return r.billingAddressRequired;
        }
      });
      var D = V(M, 2);
      {
        var j = (A) => {
          vb(A, {
            get elements() {
              return s();
            },
            onReady: h,
            onChange: S,
            onError: m
          });
        };
        W(D, (A) => {
          r.skipEmail || A(j);
        });
      }
      var Y = V(D, 2);
      yb(Y, {
        get elements() {
          return s();
        },
        get brandingInfo() {
          return r.brandingInfo;
        },
        onReady: y,
        onChange: E,
        onError: m
      }), T(q, N);
    };
    W(x, (q) => {
      s() && q(I);
    });
  }
  T(e, P), te(), a();
}
const Ib = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
  <path fill-rule="evenodd" d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm0 6.5a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5zm1.25 4.5a1.25 1.25 0 10-2.5 0v4.5a1.25 1.25 0 102.5 0v-4.5z" clip-rule="evenodd" />
</svg> `;
var Db = /* @__PURE__ */ B('<div class="rcb-ui-asset-icon svelte-a15aei"><!></div>');
const Cb = {
  hash: "svelte-a15aei",
  code: ".rcb-ui-asset-icon.svelte-a15aei {display:inline-block;width:1em;height:1em;}"
};
function Cd(e) {
  ie(e, Cb);
  var r = Db(), t = F(r);
  cn(t, () => Ib), T(e, r);
}
var Ab = /* @__PURE__ */ B('<div class="rcb-info svelte-jea5iu"><div class="rcb-info-icon-wrapper svelte-jea5iu"><!></div> <div class="rcb-info-content svelte-jea5iu"><div class="rcb-info-title svelte-jea5iu"><!></div> <div class="rcb-info-message svelte-jea5iu"><!></div></div></div>');
const qb = {
  hash: "svelte-jea5iu",
  code: `.rcb-info.svelte-jea5iu {display:flex;align-items:flex-start;background-color:var(--rc-color-grey-ui-light);border-radius:var(--rc-shape-input-border-radius);gap:var(--rc-spacing-gapLarge-mobile);padding:var(--rc-spacing-gapLarge-mobile);}.rcb-info-content.svelte-jea5iu {flex:1;}.rcb-info-icon-wrapper.svelte-jea5iu {flex-shrink:0;color:var(--rc-color-accent-primary);}.rcb-info-title.svelte-jea5iu {color:var(--rc-color-grey-text-dark);margin-bottom:var(--rc-spacing-gapSmall-mobile);display:flex;}.rcb-info-message.svelte-jea5iu {color:var(--rc-color-grey-text-light);}

  @container layout-query-container (width >= 768px) {.rcb-info.svelte-jea5iu {gap:var(--rc-spacing-gapLarge-desktop);padding:var(--rc-spacing-gapLarge-desktop);}.rcb-info-title.svelte-jea5iu {margin-bottom:var(--rc-spacing-gapSmall-desktop);}
  }`
};
function Fb(e, r) {
  ie(e, qb);
  var t = Ab(), n = F(t), a = F(n);
  Cd(a);
  var o = V(n, 2), s = F(o), l = F(s);
  we(l, {
    size: "body-small",
    children: (d, p) => {
      var _ = De();
      R(() => me(_, r.title)), T(d, _);
    },
    $$slots: { default: !0 }
  });
  var c = V(s, 2), u = F(c);
  we(u, {
    size: "body-small",
    children: (d, p) => {
      var _ = De();
      R(() => me(_, r.message)), T(d, _);
    },
    $$slots: { default: !0 }
  }), T(e, t);
}
function zb(e, r) {
  re(r, !0);
  const t = () => he(o, "$translator", n), [n, a] = je(), o = Be(vr);
  {
    let s = /* @__PURE__ */ b(() => t().translate(Z.PriceUpdateTitle)), l = /* @__PURE__ */ b(() => {
      var c;
      return t().translate((c = r.subscriptionOption) != null && c.trial ? Z.PriceUpdateTrialMessage : Z.PriceUpdateBaseMessage);
    });
    Fb(e, {
      get title() {
        return i(s);
      },
      get message() {
        return i(l);
      }
    });
  }
  te(), a();
}
function Ks(e, r) {
  var n, a, o;
  if (e.productType === "subscription") {
    const s = r, l = ((n = s.discount) == null ? void 0 : n.price) ?? ((a = s.introPrice) == null ? void 0 : a.price) ?? s.base.price;
    if (l)
      return l;
  } else {
    const s = r;
    return ((o = s.discount) == null ? void 0 : o.price) ?? s.basePrice;
  }
  return e.price;
}
class mc extends Error {
}
var Mb = /* @__PURE__ */ B('<div class="rc-loading svelte-zfhfge"><!></div>'), jb = /* @__PURE__ */ B('<div class="rc-checkout-container svelte-zfhfge"><!> <!> <form data-testid="payment-form" class="rc-checkout-form svelte-zfhfge"><div><div class="rc-elements-container svelte-zfhfge"><!></div> <div><!></div> <div><!> <div class="rc-checkout-secure-container svelte-zfhfge"><!></div></div></div></form></div>');
const Nb = {
  hash: "svelte-zfhfge",
  code: `.rc-checkout-secure-container.svelte-zfhfge {margin-top:var(--rc-spacing-gapXLarge-mobile);}.rc-checkout-container.svelte-zfhfge {display:flex;flex-direction:column;gap:var(--rc-spacing-gapXLarge-mobile);user-select:none;position:relative;}.rc-checkout-price-update-info-container.svelte-zfhfge {margin-top:var(--rc-spacing-gapXLarge-mobile);}.fully-hidden.svelte-zfhfge {display:none;height:0;}.rc-checkout-pay-container.svelte-zfhfge {display:flex;flex-direction:column;margin-top:var(--rc-spacing-gapXLarge-mobile);}.rc-checkout-pay-container.fully-hidden.svelte-zfhfge {display:none;}.rc-checkout-form-container.svelte-zfhfge {width:100%;}.rc-elements-container.svelte-zfhfge {
    /* The standard height of the payment form from Stripe */
    /* Added to avoid the card getting smaller while loading */min-height:210px;}.rc-checkout-form-container.invisible.svelte-zfhfge {visibility:hidden;}.rc-loading.svelte-zfhfge {width:100%;height:100%;display:flex;justify-content:center;align-items:center;}

  @container layout-query-container (width <= 767px) {.rc-checkout-pay-container.svelte-zfhfge {flex-grow:1;justify-content:flex-end;}.rc-checkout-form.svelte-zfhfge {flex-grow:1;}.rc-checkout-form-container.svelte-zfhfge {height:100%;display:flex;flex-direction:column;}.rc-checkout-container.svelte-zfhfge {flex-grow:1;}.rc-loading.svelte-zfhfge {position:absolute;top:0;left:0;}
  }

  @container layout-query-container (width >= 768px) {.rc-checkout-secure-container.svelte-zfhfge {margin-top:var(--rc-spacing-gapXLarge-desktop);}.rc-checkout-container.svelte-zfhfge {gap:var(--rc-spacing-gapXLarge-desktop);}.rc-checkout-pay-container.svelte-zfhfge {margin-top:var(--rc-spacing-gapXLarge-desktop);}.rc-checkout-price-update-info-container.svelte-zfhfge {margin-top:var(--rc-spacing-gapXLarge-desktop);}
  }form.svelte-zfhfge {display:flex;flex-direction:column;flex-grow:1;}`
};
function Ob(e, r) {
  var Mn, el, rl;
  re(r, !0), ie(e, Nb);
  const t = () => he(s, "$translator", n), [n, a] = je(), o = Be(Ho), s = Be(vr), l = (Mn = r.productDetails.subscriptionOptions) == null ? void 0 : Mn[r.purchaseOption.id], c = Ks(r.productDetails, r.purchaseOption);
  let u = /* @__PURE__ */ X($e(((el = r.defaultPriceBreakdown) == null ? void 0 : el.taxCalculationStatus) ?? ((rl = r.brandingInfo) != null && rl.gateway_tax_collection_enabled ? "unavailable" : "disabled"))), d = /* @__PURE__ */ X(null), p = /* @__PURE__ */ X(null), _ = /* @__PURE__ */ X($e(c.amountMicros)), g = /* @__PURE__ */ X($e(c.amountMicros)), f = /* @__PURE__ */ b(() => r.defaultPriceBreakdown ?? {
    currency: c.currency,
    totalAmountInMicros: i(g),
    totalExcludingTaxInMicros: i(_),
    taxCalculationStatus: i(u),
    taxAmountInMicros: i(d),
    taxBreakdown: i(p)
  }), w = /* @__PURE__ */ X($e(r.gatewayParams.elements_configuration)), k = /* @__PURE__ */ X(null), m = /* @__PURE__ */ X(null), h = /* @__PURE__ */ X(null), v = /* @__PURE__ */ X($e(r.customerEmail ?? void 0)), y = /* @__PURE__ */ X($e(!!r.customerEmail)), E = /* @__PURE__ */ X(!0), S = /* @__PURE__ */ X(!1), P = /* @__PURE__ */ X(void 0), x = /* @__PURE__ */ X(void 0), I = /* @__PURE__ */ X(void 0), q = /* @__PURE__ */ X(!1), N = /* @__PURE__ */ X(null), M = /* @__PURE__ */ b(() => i(E) || i(q) ? "loading" : i(x) ? "error" : "form"), D = /* @__PURE__ */ X("unavailable"), j = /* @__PURE__ */ b(() => !i(q) && i(S) && i(y) && (i(u) === "disabled" || i(u) === "calculated" || i(u) === "miss-match")), Y = /* @__PURE__ */ b(() => l && r.managementUrl && i(f) ? We.buildStripeExpressCheckoutOptionsForSubscription(r.productDetails, i(f), l, t(), r.managementUrl) : void 0);
  xr(() => {
    r.onPriceBreakdownUpdated(i(f));
  }), _r(async () => {
    i(u) === "unavailable" && await A(null).catch(ye);
  }), ln(() => {
    i(N) && (i(N).abort(), L(N, null));
  });
  async function A($, Ee) {
    await r.purchaseOperationHelper.checkoutCalculateTax($ == null ? void 0 : $.countryCode, $ == null ? void 0 : $.postalCode, Ee).then((qe) => {
      const Gt = kd({ taxCalculation: qe, taxCustomerDetails: $ });
      o.trackSDKEvent(Gt), Ee == null || Ee.throwIfAborted(), qe.failed_reason ? !$ && qe.failed_reason === Vs.invalid_tax_location ? L(u, "pending") : L(u, "disabled") : L(u, "calculated"), L(d, qe.tax_amount_in_micros, !0), L(_, qe.total_excluding_tax_in_micros, !0), L(g, qe.total_amount_in_micros, !0), L(p, qe.tax_breakdown, !0), L(w, qe.gateway_params.elements_configuration, !0), L(k, $, !0);
    });
  }
  function C() {
    o.trackSDKEvent({
      eventName: Fr.CheckoutPaymentFormImpression,
      properties: { mode: Tr }
    }), L(E, !1);
  }
  async function z($, Ee) {
    L(v, Ee, !0), L(y, $, !0), await le();
  }
  async function G({ complete: $, paymentMethod: Ee }) {
    L(P, Ee, !0), L(S, $, !0), await le();
  }
  async function H($) {
    if ($ == null || $.preventDefault(), i(q)) return;
    const Ee = wd({ selectedPaymentMethod: i(P) ?? null });
    o.trackSDKEvent(Ee), L(q, !0), await fe() ? r.onContinue() : L(q, !1);
  }
  async function J($, Ee) {
    L(P, $, !0), L(v, r.customerEmail ?? Ee, !0), await H();
  }
  async function le() {
    i(P) !== "card" || !i(y) || !i(S) || i(q) || i(u) === "disabled" || (i(u) !== "loading" && (L(D, i(u), !0), L(u, "loading")), await pe(async ($) => {
      await xe().then(() => $.throwIfAborted()).then(() => de($)).then(() => $.throwIfAborted()).catch((Ee) => {
        $.aborted || ye(Ee);
      }).finally(() => {
        i(u) === "loading" && !$.aborted && L(u, i(D), !0);
      });
    }));
  }
  async function fe() {
    return await pe(async ($) => {
      const Ee = i(g);
      let qe;
      return await xe().then(() => $.throwIfAborted()).then(() => de($)).then((Gt) => {
        qe = Gt;
      }).then(() => $.throwIfAborted()).then(ue(Ee)).then(() => $.throwIfAborted()).then(Se).then(() => $.throwIfAborted()).then(() => Ce(qe)).then(() => $.throwIfAborted()).then(() => !0).catch((Gt) => ($.aborted || ye(Gt), !1));
    });
  }
  async function pe($) {
    i(N) && i(N).abort(), L(N, new AbortController(), !0);
    const Ee = i(N).signal;
    try {
      return await $(Ee);
    } catch (qe) {
      if (qe instanceof DOMException && qe.name === "AbortError")
        return Promise.resolve(void 0);
      throw qe;
    }
  }
  async function xe() {
    i(h) && await We.submitElements(i(h));
  }
  async function de($) {
    var pn, ma;
    if (i(u) === "unavailable" || i(u) === "disabled" || !i(h) || !i(m))
      return;
    const {
      customerDetails: Ee,
      confirmationTokenId: qe
    } = await We.extractTaxCustomerDetails(i(h), i(m));
    return $ == null || $.throwIfAborted(), Ee.postalCode === ((pn = i(k)) == null ? void 0 : pn.postalCode) && Ee.countryCode === ((ma = i(k)) == null ? void 0 : ma.countryCode) || await A(Ee, $), qe && i(P) !== "card" ? qe : void 0;
  }
  function ue($) {
    return () => {
      if (i(g) !== $)
        throw new mc();
    };
  }
  async function Se() {
    var qe;
    const $ = await r.purchaseOperationHelper.checkoutComplete(i(v)), Ee = (qe = $ == null ? void 0 : $.gateway_params) == null ? void 0 : qe.client_secret;
    Ee && L(I, Ee, !0);
  }
  async function Ce($) {
    !i(m) || !i(h) || !i(I) || await We.confirmElements(i(m), i(h), i(I), $);
  }
  async function ye($) {
    if ($ instanceof mc)
      L(u, "miss-match");
    else if ($ instanceof ae) {
      const Ee = Uy({
        errorCode: $.errorCode.toString(),
        errorMessage: $.message
      });
      o.trackSDKEvent(Ee), $.errorCode === ee.MissingEmailError ? L(x, t().translate(Z.ErrorPageErrorMessageInvalidEmailError, { email: i(v) }), !0) : r.onError($);
    } else if ($ instanceof Gn)
      await Te($);
    else
      throw $;
  }
  async function Te($) {
    const Ee = Qi({
      errorCode: $.gatewayErrorCode ?? "",
      errorMessage: $.message ?? ""
    });
    o.trackSDKEvent(Ee), $.code === rs.HandledFormError || ($.code === rs.UnhandledFormError ? L(x, $.message, !0) : r.onError(new ae(ee.ErrorSettingUpPurchase, "Failed to initialize payment form", $.message)));
  }
  const ar = () => {
    L(x, void 0);
  };
  var Ze = jb(), _e = F(Ze);
  {
    var Me = ($) => {
      var Ee = Mb(), qe = F(Ee);
      xd(qe), T($, Ee);
    };
    W(_e, ($) => {
      i(M) === "loading" && $(Me);
    });
  }
  var Ir = V(_e, 2);
  {
    var ne = ($) => {
      {
        const Ee = (pn) => {
          Bu(pn);
        }, qe = (pn) => {
          var ma = De();
          R(() => me(ma, i(x))), T(pn, ma);
        };
        let Gt = /* @__PURE__ */ b(() => t().translate(Z.ErrorButtonTryAgain));
        Rs($, {
          title: null,
          type: "error",
          get closeButtonTitle() {
            return i(Gt);
          },
          onDismiss: ar,
          icon: Ee,
          message: qe,
          $$slots: { icon: !0, message: !0 }
        });
      }
    };
    W(Ir, ($) => {
      i(M) === "error" && $(ne);
    });
  }
  var Ne = V(Ir, 2), Ke = F(Ne);
  let wr;
  var Wr = F(Ke), Yt = F(Wr);
  {
    let $ = /* @__PURE__ */ b(() => !!r.customerEmail), Ee = /* @__PURE__ */ b(() => i(u) !== "disabled");
    Tb(Yt, {
      get stripeAccountId() {
        return r.gatewayParams.stripe_account_id;
      },
      get publishableApiKey() {
        return r.gatewayParams.publishable_api_key;
      },
      get elementsConfiguration() {
        return i(w);
      },
      get brandingInfo() {
        return r.brandingInfo;
      },
      get forceEnableWalletMethods() {
        return r.forceEnableWalletMethods;
      },
      get skipEmail() {
        return i($);
      },
      get billingAddressRequired() {
        return i(Ee);
      },
      onLoadingComplete: C,
      onError: Te,
      onEmailChange: z,
      onPaymentInfoChange: G,
      onExpressCheckoutElementSubmit: J,
      get expressCheckoutOptions() {
        return i(Y);
      },
      get stripe() {
        return i(m);
      },
      set stripe(qe) {
        L(m, qe, !0);
      },
      get elements() {
        return i(h);
      },
      set elements(qe) {
        L(h, qe, !0);
      }
    });
  }
  var at = V(Wr, 2);
  let zn;
  var ge = F(at);
  zb(ge, {
    get subscriptionOption() {
      return l;
    }
  });
  var Ae = V(at, 2);
  let kr;
  var Yr = F(Ae);
  {
    let $ = /* @__PURE__ */ b(() => !i(j)), Ee = /* @__PURE__ */ b(() => {
      var qe;
      return (qe = r.brandingInfo) != null && qe.gateway_tax_collection_enabled ? i(f) : void 0;
    });
    $y(Yr, {
      get disabled() {
        return i($);
      },
      get subscriptionOption() {
        return l;
      },
      get priceBreakdown() {
        return i(Ee);
      }
    });
  }
  var dn = V(Yr, 2), zr = F(dn);
  Ly(zr, {
    get brandingInfo() {
      return r.brandingInfo;
    },
    get purchaseOption() {
      return r.purchaseOption;
    },
    get termsAndConditionsUrl() {
      return r.termsAndConditionsUrl;
    }
  }), R(() => {
    wr = rr(Ke, 1, "rc-checkout-form-container svelte-zfhfge", null, wr, { invisible: i(M) !== "form" }), zn = rr(at, 1, "rc-checkout-price-update-info-container svelte-zfhfge", null, zn, {
      "fully-hidden": i(u) !== "miss-match" || i(M) !== "form"
    }), kr = rr(Ae, 1, "rc-checkout-pay-container svelte-zfhfge", null, kr, { "fully-hidden": i(M) !== "form" });
  }), Ur("submit", Ne, H), T(e, Ze), te(), a();
}
function Lb(e) {
  return e != null;
}
var Bb = /* @__PURE__ */ ((e) => (e.Unknown = "unknown", e.Custom = "custom", e.Lifetime = "$rc_lifetime", e.Annual = "$rc_annual", e.SixMonth = "$rc_six_month", e.ThreeMonth = "$rc_three_month", e.TwoMonth = "$rc_two_month", e.Monthly = "$rc_monthly", e.Weekly = "$rc_weekly", e))(Bb || {}), ct = /* @__PURE__ */ ((e) => (e.Subscription = "subscription", e.Consumable = "consumable", e.NonConsumable = "non_consumable", e))(ct || {});
const ts = (e, r) => ({
  amount: e / 1e4,
  amountMicros: e,
  currency: r,
  formattedPrice: nn(e, r)
}), Ad = (e) => ts(e.amount_micros, e.currency), Ti = (e) => {
  const r = e.period_duration, t = e.price ? Ad(e.price) : null, n = r ? qs(r) : null;
  let a = null, o = null, s = null;
  if (t !== null && n !== null) {
    const l = Ub(n), c = 1e4, u = Math.round(t.amountMicros * l.toWeek);
    a = {
      amount: u / c,
      amountMicros: u,
      currency: t.currency,
      formattedPrice: nn(u, t.currency)
    };
    const d = Math.round(t.amountMicros * l.toMonth);
    o = {
      amount: d / c,
      amountMicros: d,
      currency: t.currency,
      formattedPrice: nn(d, t.currency)
    };
    const p = Math.round(t.amountMicros * l.toYear);
    s = {
      amount: p / c,
      amountMicros: p,
      currency: t.currency,
      formattedPrice: nn(p, t.currency)
    };
  }
  return {
    periodDuration: r,
    period: n,
    cycleCount: e.cycle_count,
    price: t,
    pricePerWeek: a,
    pricePerMonth: o,
    pricePerYear: s
  };
}, qd = (e, r) => {
  const t = e.duration_mode ?? "one_time";
  let n = e.time_window ?? null;
  (t === "one_time" || t === "forever") && n === null && r !== null && (n = r);
  let a = null, o = null;
  const s = n ? qs(n) : null;
  return s && (a = { number: 1, unit: s.unit }, o = t === "forever" ? 0 : s.number), {
    timeWindow: e.time_window,
    durationMode: t,
    price: ts(e.amount_micros, e.currency),
    name: e.name,
    period: a,
    cycleCount: o ?? 0,
    periodDuration: n,
    discountType: e.discount_type,
    percentage: e.percentage ?? null,
    fixedAmount: e.fixed_amount_micros != null ? ts(
      e.fixed_amount_micros,
      e.currency
    ) : null
  };
};
function Ub(e) {
  const { number: r, unit: t } = e, n = 7, a = 30, o = 365;
  let s;
  switch (t) {
    case ce.Day:
      s = r;
      break;
    case ce.Week:
      s = r * n;
      break;
    case ce.Month:
      s = r * a;
      break;
    case ce.Year:
      s = r * o;
      break;
    default:
      s = 0, se.errorLog(`Unknown period unit: ${t}`);
  }
  const l = s > 0 ? n / s : 0, c = s > 0 ? a / s : 0, u = s > 0 ? o / s : 0;
  return { toWeek: l, toMonth: c, toYear: u };
}
const Rb = (e) => {
  var r;
  return e.base == null ? (se.debugLog("Missing base phase for subscription option. Ignoring."), null) : {
    id: e.id,
    priceId: e.price_id,
    base: Ti(e.base),
    trial: e.trial ? Ti(e.trial) : null,
    introPrice: e.intro_price ? Ti(e.intro_price) : null,
    discount: e.discount ? qd(e.discount, (r = e.base) == null ? void 0 : r.period_duration) : null
  };
}, Vb = (e) => e.base_price == null ? (se.debugLog(
  "Missing base price for non-subscription option. Ignoring."
), null) : {
  id: e.id,
  priceId: e.price_id,
  basePrice: Ad(e.base_price),
  discount: e.discount ? qd(e.discount, null) : null
}, Hb = (e, r) => {
  const t = e.product_type;
  return t === "subscription" ? Yb(
    e,
    r,
    t
  ) : Wb(
    e,
    r,
    t
  );
}, Wb = (e, r, t) => {
  const n = {};
  if (Object.entries(e.purchase_options).forEach(
    ([s, l]) => {
      const c = Vb(
        l
      );
      c != null && (n[s] = c);
    }
  ), Object.keys(n).length === 0)
    return se.debugLog(
      `Product ${e.identifier} has no purchase options. Ignoring.`
    ), null;
  const a = e.default_purchase_option_id, o = a && a in e.purchase_options ? n[a] : null;
  return o == null ? (se.debugLog(
    `Product ${e.identifier} has no default purchase option. Ignoring.`
  ), null) : {
    identifier: e.identifier,
    displayName: e.title,
    title: e.title,
    description: e.description,
    productType: t,
    currentPrice: o.basePrice,
    normalPeriodDuration: null,
    presentedOfferingIdentifier: r.offeringIdentifier,
    presentedOfferingContext: r,
    defaultPurchaseOption: o,
    defaultSubscriptionOption: null,
    subscriptionOptions: {},
    defaultNonSubscriptionOption: o,
    price: o.basePrice,
    period: null,
    freeTrialPhase: null,
    introPricePhase: null,
    discountPhase: o.discount
  };
}, Yb = (e, r, t) => {
  const n = {};
  if (Object.entries(e.purchase_options).forEach(
    ([l, c]) => {
      const u = Rb(c);
      u != null && (n[l] = u);
    }
  ), Object.keys(n).length === 0)
    return se.debugLog(
      `Product ${e.identifier} has no subscription options. Ignoring.`
    ), null;
  const a = e.default_purchase_option_id, o = a && a in n ? n[a] : null;
  if (o == null)
    return se.debugLog(
      `Product ${e.identifier} has no default subscription option. Ignoring.`
    ), null;
  const s = o.base.price;
  return s == null ? (se.debugLog(
    `Product ${e.identifier} default option has no base price. Ignoring.`
  ), null) : {
    identifier: e.identifier,
    displayName: e.title,
    title: e.title,
    description: e.description,
    productType: t,
    currentPrice: s,
    normalPeriodDuration: o.base.periodDuration,
    presentedOfferingIdentifier: r.offeringIdentifier,
    presentedOfferingContext: r,
    defaultPurchaseOption: o,
    defaultSubscriptionOption: o,
    subscriptionOptions: n,
    defaultNonSubscriptionOption: null,
    price: s,
    period: o.base.period,
    freeTrialPhase: o.trial,
    introPricePhase: o.introPrice,
    discountPhase: o.discount
  };
}, Gb = (e, r, t) => {
  const n = t[r.platform_product_identifier];
  if (n === void 0) return null;
  const a = Hb(n, e);
  return a === null ? null : {
    identifier: r.identifier,
    rcBillingProduct: a,
    webBillingProduct: a,
    packageType: $b(r.identifier)
  };
}, Kb = (e, r, t, n, a) => {
  const o = {
    offeringIdentifier: r.identifier,
    targetingContext: e && n ? {
      ruleId: n.rule_id,
      revision: n.revision
    } : null,
    placementIdentifier: null
  }, s = r.packages.map(
    (c) => Gb(o, c, t)
  ).filter(Lb), l = {};
  for (const c of s)
    c != null && (l[c.identifier] = c);
  return s.length == 0 ? null : {
    identifier: r.identifier,
    serverDescription: r.description,
    metadata: r.metadata,
    packagesById: l,
    availablePackages: s,
    lifetime: l.$rc_lifetime ?? null,
    annual: l.$rc_annual ?? null,
    sixMonth: l.$rc_six_month ?? null,
    threeMonth: l.$rc_three_month ?? null,
    twoMonth: l.$rc_two_month ?? null,
    monthly: l.$rc_monthly ?? null,
    weekly: l.$rc_weekly ?? null,
    paywallComponents: r.paywall_components,
    uiConfig: a
  };
};
function $b(e) {
  switch (e) {
    case "$rc_lifetime":
      return "$rc_lifetime";
    case "$rc_annual":
      return "$rc_annual";
    case "$rc_six_month":
      return "$rc_six_month";
    case "$rc_three_month":
      return "$rc_three_month";
    case "$rc_two_month":
      return "$rc_two_month";
    case "$rc_monthly":
      return "$rc_monthly";
    case "$rc_weekly":
      return "$rc_weekly";
    default:
      return e.startsWith("$rc_") ? "unknown" : "custom";
  }
}
var Xb = /* @__PURE__ */ nr('<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.94 5.72656L8 8.7799L11.06 5.72656L12 6.66656L8 10.6666L4 6.66656L4.94 5.72656Z" class="arrow-fill svelte-1eerlbf" fill-opacity="0.7"></path></svg>');
const Zb = {
  hash: "svelte-1eerlbf",
  code: ".arrow.svelte-1eerlbf {transition:transform 0.3s ease;}.arrow-fill.svelte-1eerlbf {fill:var(--rc-color-grey-text-dark);}.arrow.left.svelte-1eerlbf {transform:rotate(90deg);}.arrow.up.svelte-1eerlbf {transform:rotate(180deg);}.arrow.right.svelte-1eerlbf {transform:rotate(-90deg);}.arrow.down.svelte-1eerlbf {transform:rotate(0deg);}"
};
function io(e, r) {
  ie(e, Zb);
  let t = K(r, "direction", 8);
  var n = Xb();
  R(() => rr(n, 0, `arrow ${t() ?? ""}`, "svelte-1eerlbf")), T(e, n);
}
var Jb = /* @__PURE__ */ nr('<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="arrow"><path d="M15.41 7.41L14 6L8 12L14 18L15.41 16.59L10.83 12L15.41 7.41Z" class="arrow-fill svelte-159d2rl" fill-opacity="0.7"></path></svg>');
const Qb = {
  hash: "svelte-159d2rl",
  code: ".arrow-fill.svelte-159d2rl {fill:var(--rc-color-grey-text-dark);}"
};
function ev(e) {
  ie(e, Qb);
  var r = Jb();
  T(e, r);
}
const rv = `<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor"
     xmlns="http://www.w3.org/2000/svg">
    <g opacity="0.5" clip-path="url(#clip0_344_3390)">
        <path d="M7 18C5.9 18 5.01 18.9 5.01 20C5.01 21.1 5.9 22 7 22C8.1 22 9 21.1 9 20C9 18.9 8.1 18 7 18ZM1 2V4H3L6.6 11.59L5.25 14.04C5.09 14.32 5 14.65 5 15C5 16.1 5.9 17 7 17H19V15H7.42C7.28 15 7.17 14.89 7.17 14.75L7.2 14.63L8.1 13H15.55C16.3 13 16.96 12.59 17.3 11.97L20.88 5.48C20.96 5.34 21 5.17 21 5C21 4.45 20.55 4 20 4H5.21L4.27 2H1ZM17 18C15.9 18 15.01 18.9 15.01 20C15.01 21.1 15.9 22 17 22C18.1 22 19 21.1 19 20C19 18.9 18.1 18 17 18Z"
              fill="currentColor"/>
    </g>
    <defs>
        <clipPath id="clip0_344_3390">
            <rect width="24" height="24" fill="currentColor"/>
        </clipPath>
    </defs>
</svg>
`;
var tv = /* @__PURE__ */ B('<div style="color:var(--rc-color-gray-text-dark);"><!></div>');
function nv(e) {
  var r = tv(), t = F(r);
  cn(t, () => rv), T(e, r);
}
const av = `<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor"
     xmlns="http://www.w3.org/2000/svg">
    <path d="M18 8H17V6C17 3.24 14.76 1 12 1C9.24 1 7 3.24 7 6V8H6C4.9 8 4 8.9 4 10V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V10C20 8.9 19.1 8 18 8ZM12 17C10.9 17 10 16.1 10 15C10 13.9 10.9 13 12 13C13.1 13 14 13.9 14 15C14 16.1 13.1 17 12 17ZM15.1 8H8.9V6C8.9 4.29 10.29 2.9 12 2.9C13.71 2.9 15.1 4.29 15.1 6V8Z"
          fill="currentColor"/>
</svg>
`;
var ov = /* @__PURE__ */ B('<div style="color:var(--rc-color-accent);" class="rcb-ui-asset-icon svelte-1dhcigx"><!></div>');
const iv = {
  hash: "svelte-1dhcigx",
  code: "div.svelte-1dhcigx {height:24px;width:24px;}"
};
function sv(e) {
  ie(e, iv);
  var r = ov(), t = F(r);
  cn(t, () => av), T(e, r);
}
const lv = `<svg viewBox="0 0 124 124" fill="var(--rc-color-grey-text-dark)" xmlns="http://www.w3.org/2000/svg">
    <circle cx="62" cy="62" r="62" fill="var(--rc-color-grey-text-dark)" opacity="0.2"/>
    <rect x="44.1116" y="56" width="27.5" height="11" transform="rotate(45 44.1116 56)" fill="var(--rc-color-grey-text-dark)"/>
    <rect x="79.1133" y="44.334" width="11" height="44" transform="rotate(45 79.1133 44.334)" fill="var(--rc-color-grey-text-dark)"/>
</svg>
`;
var cv = /* @__PURE__ */ B('<div style="color:var(--rc-color-primary)"><!></div>');
function Fd(e) {
  var r = cv(), t = F(r);
  cn(t, () => lv), T(e, r);
}
var uv = /* @__PURE__ */ nr('<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" class="arrow-fill svelte-1prqhxu" fill-opacity="0.7"></path></svg>');
const dv = {
  hash: "svelte-1prqhxu",
  code: ".arrow-fill.svelte-1prqhxu {fill:var(--arrow-fill-color, var(--rc-color-grey-text-dark));}"
};
function pv(e) {
  ie(e, dv);
  var r = uv();
  T(e, r);
}
const _v = {
  cart: nv,
  error: Bu,
  lock: sv,
  success: Fd,
  back: ev,
  info: Cd,
  close: pv,
  "chevron-left": io,
  "chevron-right": io,
  "chevron-up": io,
  "chevron-down": io
};
function Ma(e, r) {
  re(r, !0);
  const t = _v[r.name];
  let n = /* @__PURE__ */ X($e({}));
  if (r.name.startsWith("chevron")) {
    const a = r.name.split("-")[1];
    L(n, { direction: a }, !0);
  }
  t(e, He(() => i(n))), te();
}
var gv = /* @__PURE__ */ B('<span class="rc-sandbox-only-error svelte-1dod9xz"><!></span> <br/> <br/>', 1), fv = /* @__PURE__ */ B('<!> <a class="svelte-1dod9xz"> </a>.', 1), mv = /* @__PURE__ */ B("<!> <!>", 1);
const hv = {
  hash: "svelte-1dod9xz",
  code: "a.svelte-1dod9xz {color:var(--rc-color-grey-text-dark);}.rc-sandbox-only-error.svelte-1dod9xz {font-weight:bold;}"
};
function zd(e, r) {
  re(r, !0), ie(e, hv);
  const t = () => he(l, "$translator", n), [n, a] = je(), o = K(r, "fullWidth", 3, !1), s = /* @__PURE__ */ b(() => r.lastError ?? new ae(ee.UnknownError, "Unknown error without state set.")), l = Be(vr), c = /* @__PURE__ */ b(() => i(s).errorCode === ee.StripeTaxNotActive || i(s).errorCode === ee.StripeInvalidTaxOriginAddress || i(s).errorCode === ee.StripeMissingRequiredPermission);
  _r(() => {
    se.errorLog(`Displayed error: ${ee[i(s).errorCode]}. Message: ${i(s).message ?? "None"}. Underlying error: ${i(s).underlyingErrorMessage ?? "None"}`);
  });
  function u() {
    return i(s).errorCode === ee.AlreadyPurchasedError ? t().translate(Z.ErrorPageCloseButtonTitle, { appName: r.appName ?? "App" }) : i(c) ? t().translate(Z.ErrorButtonClose) : t().translate(Z.ErrorButtonTryAgain);
  }
  function d() {
    switch (i(s).errorCode) {
      case ee.AlreadyPurchasedError:
        return r.productDetails.productType === ct.Subscription ? t().translate(Z.ErrorPageErrorTitleAlreadySubscribed, { productTitle: r.productDetails.title }) : t().translate(Z.ErrorPageErrorTitleAlreadyPurchased, { productTitle: r.productDetails.title });
      case ee.StripeTaxNotActive:
        return t().translate(Z.ErrorPageErrorTitleStripeTaxNotActive);
      case ee.StripeInvalidTaxOriginAddress:
        return t().translate(Z.ErrorPageErrorTitleStripeInvalidTaxOriginAddress);
      case ee.StripeMissingRequiredPermission:
        return t().translate(Z.ErrorPageErrorTitleStripeMissingRequiredPermission);
      default:
        return t().translate(Z.ErrorPageErrorTitleOtherErrors);
    }
  }
  function p() {
    const f = i(s).getErrorCode();
    switch (i(s).errorCode) {
      case ee.ErrorSettingUpPurchase:
      case ee.InvalidPaddleAPIKeyError:
        return t().translate(Z.ErrorPageErrorMessageErrorSettingUpPurchase, { errorCode: f });
      case ee.ErrorChargingPayment:
        return t().translate(Z.ErrorPageErrorMessageErrorChargingPayment, { errorCode: f });
      case ee.AlreadyPurchasedError:
        return r.productDetails.productType === ct.Subscription ? t().translate(Z.ErrorPageErrorMessageAlreadySubscribed, { errorCode: f }) : t().translate(Z.ErrorPageErrorMessageAlreadyPurchased, { errorCode: f });
      case ee.StripeTaxNotActive:
        return t().translate(Z.ErrorPageErrorMessageStripeTaxNotActive, { errorCode: f });
      case ee.StripeInvalidTaxOriginAddress:
        return t().translate(Z.ErrorPageErrorMessageStripeInvalidTaxOriginAddress, { errorCode: f });
      case ee.StripeMissingRequiredPermission:
        return t().translate(Z.ErrorPageErrorMessageStripeMissingRequiredPermission, { errorCode: f });
      case ee.NetworkError:
        return t().translate(Z.ErrorPageErrorMessageNetworkError, { errorCode: f });
      default:
        return t().translate(Z.ErrorPageErrorMessageUnknownError, { errorCode: f });
    }
  }
  function _() {
    return i(s).errorCode === ee.AlreadyPurchasedError ? Z.ErrorPageTroubleAccessing : Z.ErrorPageIfErrorPersists;
  }
  function g() {
    return i(s).errorCode === ee.AlreadyPurchasedError ? "success" : "error";
  }
  {
    const f = (h) => {
      {
        let v = /* @__PURE__ */ b(g);
        Ma(h, {
          get name() {
            return i(v);
          }
        });
      }
    }, w = (h) => {
      var v = mv(), y = Q(v);
      {
        var E = (I) => {
          var q = gv(), N = Q(q), M = F(N);
          Hr(M, {
            get key() {
              return Z.ErrorPageErrorMessageOnlyInSandbox;
            }
          }), T(I, q);
        };
        W(y, (I) => {
          i(c) && I(E);
        });
      }
      var S = V(y), P = V(S);
      {
        var x = (I) => {
          var q = fv(), N = Q(q);
          {
            let j = /* @__PURE__ */ b(_);
            Hr(N, {
              get key() {
                return i(j);
              }
            });
          }
          var M = V(N, 2), D = F(M);
          R(() => {
            oe(M, "href", `mailto:${r.supportEmail ?? ""}`), me(D, r.supportEmail);
          }), T(I, q);
        };
        W(P, (I) => {
          !i(c) && r.supportEmail && I(x);
        });
      }
      R((I) => me(S, ` ${I ?? ""} `), [p]), T(h, v);
    };
    let k = /* @__PURE__ */ b(d), m = /* @__PURE__ */ b(u);
    Rs(e, {
      get title() {
        return i(k);
      },
      get onDismiss() {
        return r.onDismiss;
      },
      type: "error",
      get closeButtonTitle() {
        return i(m);
      },
      get fullWidth() {
        return o();
      },
      icon: f,
      message: w,
      $$slots: { icon: !0, message: !0 }
    });
  }
  te(), a();
}
function Md(e, r) {
  re(r, !1);
  const t = () => he(u, "$translator", n), [n, a] = je();
  let o = K(r, "onContinue", 8), s = K(r, "title", 8, void 0), l = K(r, "closeButtonTitle", 8, void 0), c = K(r, "fullWidth", 8, !1);
  const u = Be(vr), d = Be(Ho);
  function p() {
    d.trackSDKEvent(Ry("go_back_to_app", Tr)), o()();
  }
  _r(() => {
    d.trackSDKEvent(Vy(Tr));
  }), Dn();
  {
    const _ = (w) => {
      Fd(w);
    };
    let g = /* @__PURE__ */ Ut(() => (Ye(s()), t(), Ye(Z), Ue(() => s() ?? t().translate(Z.SuccessPagePurchaseSuccessful)))), f = /* @__PURE__ */ Ut(() => (Ye(l()), t(), Ye(Z), Ue(() => l() ?? t().translate(Z.SuccessPageButtonClose))));
    Rs(e, {
      type: "success",
      get title() {
        return i(g);
      },
      onDismiss: p,
      get closeButtonTitle() {
        return i(f);
      },
      get fullWidth() {
        return c();
      },
      icon: _,
      $$slots: { icon: !0 }
    });
  }
  te(), a();
}
function yv(e) {
  xd(e);
}
var bv = /* @__PURE__ */ B('<div class="rcb-pricing-dropdown svelte-v5skdw"><div class="rcb-pricing-dropdown-header svelte-v5skdw" tabindex="0" role="button"><!> <span class="rcb-pricing-dropdown-toggle svelte-v5skdw"><!></span></div> <div><div class="rcb-pricing-dropdown-content-inner svelte-v5skdw"><!></div></div></div>');
const vv = {
  hash: "svelte-v5skdw",
  code: `.rcb-pricing-dropdown.svelte-v5skdw {width:100%;overflow:hidden;display:flex;flex-direction:column;}.rcb-pricing-dropdown-header.svelte-v5skdw {padding-top:var(--rc-spacing-gapSmall-mobile);padding-bottom:var(--rc-spacing-gapSmall-mobile);padding-left:var(--rc-spacing-gapLarge-mobile);padding-right:var(--rc-spacing-gapMedium-mobile);color:var(--rc-color-grey-text-light);border-radius:var(--rc-shape-input-button-border-radius);cursor:pointer;display:inline-flex;align-items:center;background-color:var(--rc-color-grey-ui-light);width:fit-content;user-select:none;}.rcb-pricing-dropdown-toggle.svelte-v5skdw {display:flex;align-items:center;margin-left:var(--rc-spacing-gapSmall-mobile);}.rcb-pricing-dropdown-content.svelte-v5skdw {display:flex;flex-direction:column;overflow:hidden;}

  @container layout-query-container (width < 768px) {.rcb-pricing-dropdown-content.svelte-v5skdw {max-height:1000px; /* Set a large max-height for animation */transition:max-height 0.2s ease-in-out;}.rcb-pricing-dropdown-content.collapsed.svelte-v5skdw {max-height:0;}.rcb-pricing-dropdown-content-inner.svelte-v5skdw {padding-top:var(--rc-spacing-gapMedium-mobile);}
  }

  @container layout-query-container (width >= 768px) {.rcb-pricing-dropdown-header.svelte-v5skdw {display:none;}
  }`
};
function kv(e, r) {
  re(r, !1), ie(e, vv);
  const t = () => he(l, "$translator", n), [n, a] = je();
  let o = K(r, "isExpanded", 12, !0), s = K(r, "children", 8);
  const l = Be(vr);
  function c() {
    o(!o());
  }
  Dn();
  var u = bv(), d = F(u), p = F(d);
  we(p, {
    size: "label-default",
    children: (y, E) => {
      var S = ve(), P = Q(S);
      {
        var x = (q) => {
          var N = De();
          R((M) => me(N, M), [
            () => (t(), Ye(Z), Ue(() => t().translate(Z.PricingDropdownHideDetails)))
          ]), T(q, N);
        }, I = (q) => {
          var N = De();
          R((M) => me(N, M), [
            () => (t(), Ye(Z), Ue(() => t().translate(Z.PricingDropdownShowDetails)))
          ]), T(q, N);
        };
        W(P, (q) => {
          o() ? q(x) : q(I, !1);
        });
      }
      T(y, S);
    },
    $$slots: { default: !0 }
  });
  var _ = V(p, 2), g = F(_);
  {
    var f = (y) => {
      Ma(y, { name: "chevron-up" });
    }, w = (y) => {
      Ma(y, { name: "chevron-down" });
    };
    W(g, (y) => {
      o() ? y(f) : y(w, !1);
    });
  }
  var k = V(d, 2);
  let m;
  var h = F(k), v = F(h);
  Xe(v, () => s() ?? Fe), R(() => {
    oe(d, "aria-expanded", o()), m = rr(k, 1, "rcb-pricing-dropdown-content svelte-v5skdw", null, m, { collapsed: !o() });
  }), Ur("click", d, c), Ur("keydown", d, (y) => y.key === "Enter" || y.key === " " ? c() : null), T(e, u), te(), a();
}
var wv = /* @__PURE__ */ B('<div class="rcb-pricing-table-value-loading svelte-w1kcbi"><!></div>');
const Pv = {
  hash: "svelte-w1kcbi",
  code: `.rcb-pricing-table-value-loading.svelte-w1kcbi {color:transparent;
    animation: svelte-w1kcbi-rcb-pricing-table-value-loading 1.5s ease-in-out 0s infinite
      normal none running;cursor:progress;background-color:var(--rc-color-grey-text-dark);user-select:none;border-radius:var(--rc-shape-input-border-radius);}

  @keyframes svelte-w1kcbi-rcb-pricing-table-value-loading {
    0%,
    100% {
      opacity: 0.5;
    }
    50% {
      opacity: 0.3;
    }
  }`
};
function xv(e, r) {
  ie(e, Pv);
  let t = K(r, "children", 8);
  var n = wv(), a = F(n);
  Xe(a, () => t() ?? Fe), T(e, n);
}
const $s = 7, Yo = 30, Xs = 365, Go = 4.33, Zs = 52, Ko = 12;
function ns(e) {
  switch (e.unit) {
    case ce.Year:
      return e.number * Xs;
    case ce.Month:
      return e.number * Yo;
    case ce.Week:
      return e.number * $s;
    case ce.Day:
      return e.number;
  }
}
function Ev(e) {
  switch (e.unit) {
    case ce.Year:
      return e.number * Zs;
    case ce.Month:
      return e.number * Go;
    case ce.Week:
      return e.number;
    case ce.Day:
      return 0;
  }
}
function Sv(e) {
  switch (e.unit) {
    case ce.Year:
      return e.number * Ko;
    case ce.Month:
      return e.number;
    case ce.Week:
    case ce.Day:
      return 0;
  }
}
function Tv(e) {
  switch (e.unit) {
    case ce.Year:
      return e.number;
    case ce.Month:
    case ce.Week:
    case ce.Day:
      return 0;
  }
}
function as(e, r) {
  const { unit: t, number: n } = e;
  return {
    period: r.translatePeriodUnit(t, { noWhitespace: !0 }) ?? "",
    periodAbbreviated: r.translatePeriodUnit(t, {
      noWhitespace: !0,
      short: !0
    }) ?? "",
    periodWithUnit: r.translatePeriod(n, t) ?? "",
    periodInDays: ns(e).toString(),
    periodInWeeks: Ev(e).toString(),
    periodInMonths: Sv(e).toString(),
    periodInYears: Tv(e).toString()
  };
}
var Iv = /* @__PURE__ */ B('<div class="rcb-pricing-table-row svelte-1cr4unj"><div class="rcb-pricing-table-header svelte-1cr4unj"><div class="rcb-pricing-table-value"><!></div></div> <div class="rcb-pricing-table-value svelte-1cr4unj"><!></div></div> <div class="rcb-pricing-table-row svelte-1cr4unj"><div class="rcb-pricing-table-header svelte-1cr4unj"><div class="rcb-pricing-table-value"><!></div></div> <div class="rcb-pricing-table-value svelte-1cr4unj"><!></div></div> <div class="rcb-pricing-table-separator svelte-1cr4unj"></div>', 1), Dv = /* @__PURE__ */ B('<div class="rcb-pricing-table-row svelte-1cr4unj" data-testid="tax-loading-skeleton"><div class="rcb-pricing-table-header svelte-1cr4unj"><!></div> <div class="rcb-pricing-table-value svelte-1cr4unj"><!></div></div>'), Cv = /* @__PURE__ */ B('<div class="rcb-pricing-table-row svelte-1cr4unj"><div class="rcb-pricing-table-header svelte-1cr4unj"> </div> <div class="rcb-pricing-table-value svelte-1cr4unj"><!></div></div>'), Av = /* @__PURE__ */ B('<div class="rcb-pricing-table-row svelte-1cr4unj"><div class="rcb-pricing-table-header svelte-1cr4unj"><!></div> <div class="rcb-pricing-table-value svelte-1cr4unj"><!></div></div>'), qv = /* @__PURE__ */ B('<div class="rcb-pricing-table-row svelte-1cr4unj"><div class="rcb-pricing-table-header svelte-1cr4unj"><!></div> <div class="rcb-pricing-table-value svelte-1cr4unj"><!></div></div> <!> <div class="rcb-pricing-table-separator svelte-1cr4unj"></div>', 1), Fv = /* @__PURE__ */ B('<div class="rcb-pricing-table-row svelte-1cr4unj"><div class="rcb-pricing-table-header svelte-1cr4unj"><!></div> <div class="rcb-pricing-table-value svelte-1cr4unj"><!></div></div>'), zv = /* @__PURE__ */ B('<div class="rcb-pricing-table svelte-1cr4unj"><!> <!> <!> <div class="rcb-pricing-table-row rcb-header svelte-1cr4unj"><div class="rcb-pricing-table-header svelte-1cr4unj"><!></div> <div class="rcb-pricing-table-value svelte-1cr4unj"><!></div></div></div>');
const Mv = {
  hash: "svelte-1cr4unj",
  code: `.rcb-pricing-table.svelte-1cr4unj {display:flex;flex-direction:column;gap:var(--rc-spacing-gapSmall-mobile);}.rcb-pricing-table-row.svelte-1cr4unj {display:flex;flex-direction:row;align-items:center;justify-content:space-between;}.rcb-pricing-table-separator.svelte-1cr4unj {height:1px;background-color:var(--rc-color-grey-ui-dark);}.rcb-pricing-table-row.svelte-1cr4unj > .rcb-pricing-table-header:where(.svelte-1cr4unj) {color:var(--rc-color-grey-text-light);}.rcb-pricing-table-row.svelte-1cr4unj > .rcb-pricing-table-value:where(.svelte-1cr4unj) {color:var(--rc-color-grey-text-dark);}.rcb-pricing-table-row.svelte-1cr4unj:last-child > .rcb-pricing-table-header:where(.svelte-1cr4unj),
  .rcb-pricing-table-row.svelte-1cr4unj:last-child > .rcb-pricing-table-value:where(.svelte-1cr4unj) {color:var(--rc-color-grey-text-dark);}

  @container layout-query-container (width >= 768px) {.rcb-pricing-table-separator.svelte-1cr4unj {display:none;}.rcb-pricing-table.svelte-1cr4unj {gap:var(--rc-spacing-gapSmall-desktop);}.rcb-pricing-table-row.svelte-1cr4unj > .rcb-pricing-table-header:where(.svelte-1cr4unj),
    .rcb-pricing-table-row.svelte-1cr4unj > .rcb-pricing-table-value:where(.svelte-1cr4unj) {color:var(--rc-color-grey-text-light);}
  }`
};
function jv(e, r) {
  re(r, !0), ie(e, Mv);
  const t = () => he(l, "$translator", n), [n, a] = je(), o = (m) => {
    var h = zv(), v = F(h);
    {
      var y = (j) => {
        var Y = Iv(), A = Q(Y), C = F(A), z = F(C), G = F(z);
        we(G, {
          size: "body-small",
          children: (Se, Ce) => {
            var ye = De();
            R((Te) => me(ye, Te), [
              () => t().translate(Z.PricingTableSubtotal)
            ]), T(Se, ye);
          },
          $$slots: { default: !0 }
        });
        var H = V(C, 2), J = F(H);
        we(J, {
          size: "body-small",
          children: (Se, Ce) => {
            var ye = De();
            R((Te) => me(ye, Te), [
              () => t().formatPrice(i(u), r.priceBreakdown.currency)
            ]), T(Se, ye);
          },
          $$slots: { default: !0 }
        });
        var le = V(A, 2), fe = F(le), pe = F(fe), xe = F(pe);
        we(xe, {
          size: "body-small",
          children: (Se, Ce) => {
            var ye = De();
            R((Te) => me(ye, `${Te ?? ""}${r.promotionalPricePhase && "name" in r.promotionalPricePhase && r.promotionalPricePhase.name ? `: ${r.promotionalPricePhase.name}` : ""}${i(_) ?? ""}`), [
              () => t().translate(Z.PricingTableDiscount)
            ]), T(Se, ye);
          },
          $$slots: { default: !0 }
        });
        var de = V(fe, 2), ue = F(de);
        we(ue, {
          size: "body-small",
          children: (Se, Ce) => {
            var ye = De();
            R((Te) => me(ye, `-${Te ?? ""}`), [
              () => t().formatPrice(i(d), r.priceBreakdown.currency)
            ]), T(Se, ye);
          },
          $$slots: { default: !0 }
        }), T(j, Y);
      };
      W(v, (j) => {
        r.hasDiscount && j(y);
      });
    }
    var E = V(v, 2);
    {
      var S = (j) => {
        var Y = qv(), A = Q(Y), C = F(A), z = F(C);
        we(z, {
          size: "body-small",
          children: (pe, xe) => {
            var de = De();
            R((ue) => me(de, ue), [
              () => t().translate(Z.PricingTotalExcludingTax)
            ]), T(pe, de);
          },
          $$slots: { default: !0 }
        });
        var G = V(C, 2), H = F(G);
        we(H, {
          size: "body-small",
          children: (pe, xe) => {
            var de = De();
            R((ue) => me(de, ue), [
              () => t().formatPrice(r.priceBreakdown.totalExcludingTaxInMicros, r.priceBreakdown.currency)
            ]), T(pe, de);
          },
          $$slots: { default: !0 }
        });
        var J = V(A, 2);
        {
          var le = (pe) => {
            var xe = Dv(), de = F(xe), ue = F(de);
            we(ue, {
              size: "body-small",
              children: (ye, Te) => {
                var ar = De();
                R((Ze) => me(ar, Ze), [
                  () => t().translate(Z.PricingTableTax)
                ]), T(ye, ar);
              },
              $$slots: { default: !0 }
            });
            var Se = V(de, 2), Ce = F(Se);
            we(Ce, {
              size: "body-small",
              children: (ye, Te) => {
                xv(ye, {
                  children: (ar, Ze) => {
                    var _e = De();
                    R((Me) => me(_e, Me), [
                      () => t().formatPrice(1234e4, r.priceBreakdown.currency)
                    ]), T(ar, _e);
                  },
                  $$slots: { default: !0 }
                });
              },
              $$slots: { default: !0 }
            }), T(pe, xe);
          }, fe = (pe) => {
            var xe = ve(), de = Q(xe);
            {
              var ue = (Ce) => {
                var ye = Cv(), Te = F(ye), ar = F(Te), Ze = V(Te, 2), _e = F(Ze);
                we(_e, {
                  size: "body-small",
                  children: (Me, Ir) => {
                    var ne = De();
                    R((Ne) => me(ne, Ne), [
                      () => t().translate(Z.PricingTableEnterBillingAddressToCalculate)
                    ]), T(Me, ne);
                  },
                  $$slots: { default: !0 }
                }), R((Me) => me(ar, Me), [
                  () => t().translate(Z.PricingTableTax)
                ]), T(Ce, ye);
              }, Se = (Ce) => {
                var ye = ve(), Te = Q(ye);
                {
                  var ar = (Ze) => {
                    var _e = ve(), Me = Q(_e);
                    Dt(Me, 17, () => r.priceBreakdown.taxBreakdown, Rt, (Ir, ne) => {
                      var Ne = Av(), Ke = F(Ne), wr = F(Ke);
                      we(wr, {
                        size: "body-small",
                        children: (at, zn) => {
                          var ge = De();
                          R(() => me(ge, i(ne).display_name)), T(at, ge);
                        },
                        $$slots: { default: !0 }
                      });
                      var Wr = V(Ke, 2), Yt = F(Wr);
                      we(Yt, {
                        size: "body-small",
                        children: (at, zn) => {
                          var ge = De();
                          R((Ae) => me(ge, Ae), [
                            () => t().formatPrice(i(ne).tax_amount_in_micros, r.priceBreakdown.currency)
                          ]), T(at, ge);
                        },
                        $$slots: { default: !0 }
                      }), T(Ir, Ne);
                    }), T(Ze, _e);
                  };
                  W(
                    Te,
                    (Ze) => {
                      r.priceBreakdown.taxBreakdown !== null && Ze(ar);
                    },
                    !0
                  );
                }
                T(Ce, ye);
              };
              W(
                de,
                (Ce) => {
                  r.priceBreakdown.taxCalculationStatus === "pending" ? Ce(ue) : Ce(Se, !1);
                },
                !0
              );
            }
            T(pe, xe);
          };
          W(J, (pe) => {
            r.priceBreakdown.taxCalculationStatus === "loading" ? pe(le) : pe(fe, !1);
          });
        }
        T(j, Y);
      };
      W(E, (j) => {
        i(c) && j(S);
      });
    }
    var P = V(E, 2);
    {
      var x = (j) => {
        var Y = Fv(), A = F(Y), C = F(A);
        we(C, {
          size: "body-small",
          children: (H, J) => {
            var le = De();
            R((fe) => me(le, fe), [
              () => t().translate(Z.PricingTableTrialEnds, {
                formattedTrialEndDate: t().translateDate(i(s), { dateStyle: "medium" })
              })
            ]), T(H, le);
          },
          $$slots: { default: !0 }
        });
        var z = V(A, 2), G = F(z);
        we(G, {
          size: "body-small",
          children: (H, J) => {
            var le = De();
            R((fe) => me(le, fe), [
              () => t().formatPrice(r.priceBreakdown.totalAmountInMicros, r.priceBreakdown.currency)
            ]), T(H, le);
          },
          $$slots: { default: !0 }
        }), T(j, Y);
      };
      W(P, (j) => {
        i(s) && j(x);
      });
    }
    var I = V(P, 2), q = F(I), N = F(q);
    we(N, {
      size: "body-small",
      children: (j, Y) => {
        var A = De();
        R((C) => me(A, C), [
          () => t().translate(Z.PricingTableTotalDueToday)
        ]), T(j, A);
      },
      $$slots: { default: !0 }
    });
    var M = V(q, 2), D = F(M);
    we(D, {
      size: "body-small",
      children: (j, Y) => {
        var A = De();
        R((C) => me(A, C), [
          () => t().formatPrice(i(p), r.priceBreakdown.currency)
        ]), T(j, A);
      },
      $$slots: { default: !0 }
    }), T(m, h);
  }, s = /* @__PURE__ */ b(() => {
    var m;
    return (m = r.trialPhase) != null && m.period ? Ki(/* @__PURE__ */ new Date(), r.trialPhase.period, !0) : null;
  }), l = Be(vr), c = /* @__PURE__ */ b(() => r.priceBreakdown.taxCalculationStatus !== "unavailable" && r.priceBreakdown.taxCalculationStatus !== "disabled" && r.priceBreakdown.taxBreakdown && r.priceBreakdown.taxBreakdown.length > 0), u = /* @__PURE__ */ b(() => {
    var m, h;
    return ((h = (m = r.basePhase) == null ? void 0 : m.price) == null ? void 0 : h.amountMicros) ?? r.priceBreakdown.totalAmountInMicros;
  }), d = /* @__PURE__ */ b(() => {
    var v, y, E, S;
    if (!r.hasDiscount) return 0;
    const m = (y = (v = r.basePhase) == null ? void 0 : v.price) == null ? void 0 : y.amountMicros, h = (S = (E = r.promotionalPricePhase) == null ? void 0 : E.price) == null ? void 0 : S.amountMicros;
    return m == null || h == null ? 0 : m - h;
  }), p = /* @__PURE__ */ b(() => i(s) ? 0 : r.priceBreakdown.totalAmountInMicros), _ = /* @__PURE__ */ b(() => {
    var S;
    if (!r.promotionalPricePhase || !("durationMode" in r.promotionalPricePhase) || r.promotionalPricePhase.durationMode !== "time_window")
      return "";
    const m = (S = r.basePhase) == null ? void 0 : S.period, h = r.promotionalPricePhase.period;
    if (!m || !h || r.promotionalPricePhase.cycleCount <= 0)
      return "";
    const v = ns(m), y = ns({
      number: h.number * r.promotionalPricePhase.cycleCount,
      unit: h.unit
    });
    if (v <= 0 || y <= v)
      return "";
    const E = t().translatePeriod(h.number * r.promotionalPricePhase.cycleCount, h.unit);
    return E ? ` (${E})` : "";
  });
  var g = ve(), f = Q(g);
  {
    var w = (m) => {
      kv(m, {
        children: (h, v) => {
          o(h);
        },
        $$slots: { default: !0 }
      });
    }, k = (m) => {
      o(m);
    };
    W(f, (m) => {
      i(c) ? m(w) : m(k, !1);
    });
  }
  T(e, g), te(), a();
}
var Nv = /* @__PURE__ */ B('<div class="rcb-subscribe-to svelte-sdtx9l"><!></div>'), Ov = /* @__PURE__ */ B('<span class="rcb-product-description svelte-sdtx9l"><!></span>'), Lv = /* @__PURE__ */ B('<div class="rcb-pricing-info-header svelte-sdtx9l"><!> <div class="rcb-product-title svelte-sdtx9l"><!></div> <!></div>');
const Bv = {
  hash: "svelte-sdtx9l",
  code: `.rcb-pricing-info-header.svelte-sdtx9l {display:flex;flex-direction:column;gap:var(--rc-spacing-gapMedium-mobile);}.rcb-product-title.svelte-sdtx9l {color:var(--rc-color-grey-text-dark);}.rcb-product-description.svelte-sdtx9l {color:var(--rc-color-grey-text-light);}.rcb-subscribe-to.svelte-sdtx9l {display:none;}

  @container layout-query-container (width >= 768px) {.rcb-subscribe-to.svelte-sdtx9l {display:block;}.rcb-pricing-info-header.svelte-sdtx9l {display:flex;flex-direction:column;gap:var(--rc-spacing-gapMedium-desktop);}
  }`
};
function Uv(e, r) {
  re(r, !1), ie(e, Bv);
  let t = K(r, "productDetails", 8), n = K(r, "showProductDescription", 8);
  const a = t().productType === ct.Subscription;
  Dn();
  var o = Lv(), s = F(o);
  {
    var l = (_) => {
      var g = Nv(), f = F(g);
      we(f, {
        size: "body-base",
        children: (w, k) => {
          {
            let m = /* @__PURE__ */ Ut(() => (Ye(t()), Ue(() => ({ productTitle: t().title }))));
            Hr(w, {
              get key() {
                return Ye(Z), Ue(() => Z.ProductInfoSubscribeTo);
              },
              get variables() {
                return i(m);
              }
            });
          }
        },
        $$slots: { default: !0 }
      }), T(_, g);
    };
    W(s, (_) => {
      a && _(l);
    });
  }
  var c = V(s, 2), u = F(c);
  we(u, {
    size: "heading-lg",
    branded: !0,
    children: (_, g) => {
      {
        let f = /* @__PURE__ */ Ut(() => (Ye(t()), Ue(() => ({ productTitle: t().title }))));
        Hr(_, {
          get key() {
            return Ye(Z), Ue(() => Z.ProductInfoProductTitle);
          },
          get variables() {
            return i(f);
          }
        });
      }
    },
    $$slots: { default: !0 }
  });
  var d = V(c, 2);
  {
    var p = (_) => {
      var g = Ov(), f = F(g);
      we(f, {
        size: "body-small",
        children: (w, k) => {
          {
            let m = /* @__PURE__ */ Ut(() => (Ye(t()), Ue(() => ({ productDescription: t().description }))));
            Hr(w, {
              get key() {
                return Ye(Z), Ue(() => Z.ProductInfoProductDescription);
              },
              get variables() {
                return i(m);
              }
            });
          }
        },
        $$slots: { default: !0 }
      }), T(_, g);
    };
    W(d, (_) => {
      Ye(n()), Ye(t()), Ue(() => n() && t().description) && _(p);
    });
  }
  T(e, o), te();
}
var Rv = /* @__PURE__ */ B("<div><!></div>"), Vv = /* @__PURE__ */ B("<div><!> <!></div>"), Hv = /* @__PURE__ */ B('<div class="rcb-product-price-container svelte-17etw2v"><!> <!> <div><!> <!> <!></div></div>');
const Wv = {
  hash: "svelte-17etw2v",
  code: ".rcb-product-price-container.svelte-17etw2v {display:flex;flex-direction:column;justify-content:space-between;gap:var(--rc-spacing-gapMedium-mobile);color:var(--rc-color-grey-text-dark);}"
};
function Yv(e, r) {
  re(r, !0), ie(e, Wv);
  const t = () => he(o, "$translator", n), [n, a] = je(), o = Be(vr), s = /* @__PURE__ */ b(() => {
    var D;
    return !!((D = r.trialPhase) != null && D.periodDuration);
  }), l = /* @__PURE__ */ b(() => {
    var D;
    return ((D = r.introPricePhase) == null ? void 0 : D.cycleCount) === 1;
  }), c = /* @__PURE__ */ b(() => !!r.introPricePhase), u = /* @__PURE__ */ b(() => {
    var Y, A;
    if (!i(c) || !((Y = r.introPricePhase) != null && Y.period)) return "";
    const D = r.introPricePhase.period.number * ((A = r.introPricePhase) == null ? void 0 : A.cycleCount), j = r.introPricePhase.period.unit;
    return D == null || j == null ? "" : D === 1 && !i(s) && t().selectedLocale === Ar ? t().translatePeriodUnit(j) || "" : t().translatePeriod(D, j) || "";
  }), d = /* @__PURE__ */ b(() => {
    var D, j;
    return (D = r.introPricePhase) != null && D.period ? i(l) ? t().translate(Z.ProductInfoIntroPricePhasePaidOnce) : r.introPricePhase && ((j = r.introPricePhase) != null && j.period) && t().translatePeriodFrequency(r.introPricePhase.period.number, r.introPricePhase.period.unit, { useMultipleWords: !0 }) || "" : "";
  }), p = /* @__PURE__ */ b(() => i(s) ? Z.ProductInfoIntroPricePhaseAfterTrial : Z.ProductInfoIntroPricePhase), _ = /* @__PURE__ */ b(() => t().formatPrice(r.priceBreakdown.totalAmountInMicros, r.priceBreakdown.currency)), g = /* @__PURE__ */ b(() => {
    var j, Y;
    const D = r.introPricePhase || r.discountPhase ? ((Y = (j = r.basePhase) == null ? void 0 : j.price) == null ? void 0 : Y.amountMicros) ?? 0 : r.priceBreakdown.totalAmountInMicros;
    return t().formatPrice(D, r.priceBreakdown.currency);
  }), f = /* @__PURE__ */ b(() => i(c) ? Z.ProductInfoAfter : i(s) ? Z.ProductInfoAfterTrial : null), w = "heading-lg", k = /* @__PURE__ */ b(() => i(s) ? "heading-md" : "heading-lg"), m = /* @__PURE__ */ b(() => i(s) || i(c) ? "heading-md" : "heading-lg");
  var h = Hv(), v = F(h);
  {
    var y = (D) => {
      var j = Rv(), Y = F(j);
      we(Y, {
        size: w,
        children: (A, C) => {
          {
            let z = /* @__PURE__ */ b(() => ({
              trialDuration: Bg(r.trialPhase.periodDuration, t())
            }));
            Hr(A, {
              get key() {
                return Z.ProductInfoFreeTrialDuration;
              },
              get variables() {
                return i(z);
              }
            });
          }
        },
        $$slots: { default: !0 }
      }), T(D, j);
    };
    W(v, (D) => {
      i(s) && D(y);
    });
  }
  var E = V(v, 2);
  {
    var S = (D) => {
      var j = Vv(), Y = F(j);
      we(Y, {
        get size() {
          return i(k);
        },
        children: (z, G) => {
          {
            let H = /* @__PURE__ */ b(() => ({
              introPriceDuration: i(u),
              introPrice: i(_)
            }));
            Hr(z, {
              get key() {
                return i(p);
              },
              get variables() {
                return i(H);
              }
            });
          }
        },
        $$slots: { default: !0 }
      });
      var A = V(Y, 2);
      {
        var C = (z) => {
          we(z, {
            size: "body-small",
            children: (G, H) => {
              var J = De();
              R(() => me(J, i(d))), T(G, J);
            },
            $$slots: { default: !0 }
          });
        };
        W(A, (z) => {
          i(d) && z(C);
        });
      }
      T(D, j);
    };
    W(E, (D) => {
      i(c) && D(S);
    });
  }
  var P = V(E, 2), x = F(P);
  we(x, {
    get size() {
      return i(m);
    },
    children: (D, j) => {
      var Y = De();
      R(() => me(Y, i(g))), T(D, Y);
    },
    $$slots: { default: !0 }
  });
  var I = V(x, 2);
  {
    var q = (D) => {
      we(D, {
        size: "body-small",
        children: (j, Y) => {
          var A = De();
          R((C) => me(A, C), [
            () => t().translatePeriodFrequency(r.basePhase.period.number, r.basePhase.period.unit, { useMultipleWords: !0 })
          ]), T(j, A);
        },
        $$slots: { default: !0 }
      });
    };
    W(I, (D) => {
      var j;
      (j = r.basePhase) != null && j.period && D(q);
    });
  }
  var N = V(I, 2);
  {
    var M = (D) => {
      we(D, {
        size: "body-small",
        children: (j, Y) => {
          Hr(j, {
            get key() {
              return i(f);
            }
          });
        },
        $$slots: { default: !0 }
      });
    };
    W(N, (D) => {
      i(f) && D(M);
    });
  }
  T(e, h), te(), a();
}
var Gv = /* @__PURE__ */ B("<div><!></div>");
function Kv(e, r) {
  re(r, !0);
  const t = () => he(o, "$translator", n), [n, a] = je(), o = Be(vr), s = /* @__PURE__ */ b(() => {
    var d, p;
    return t().formatPrice(((p = (d = r.basePhase) == null ? void 0 : d.price) == null ? void 0 : p.amountMicros) ?? 0, r.priceBreakdown.currency);
  }), l = "heading-lg";
  var c = Gv(), u = F(c);
  we(u, {
    size: l,
    children: (d, p) => {
      var _ = De();
      R(() => me(_, i(s))), T(d, _);
    },
    $$slots: { default: !0 }
  }), T(e, c), te(), a();
}
var $v = /* @__PURE__ */ B('<div class="rcb-pricing-info svelte-1jzyaxi"><div class="rcb-pricing-info-header svelte-1jzyaxi"><!> <!></div> <!></div>');
const Xv = {
  hash: "svelte-1jzyaxi",
  code: `.rcb-pricing-info.svelte-1jzyaxi {display:flex;flex-direction:column;user-select:none;gap:var(--rc-spacing-gapXXLarge-mobile);}.rcb-pricing-info-header.svelte-1jzyaxi {display:flex;flex-direction:column;gap:var(--rc-spacing-gapLarge-mobile);}

  @container layout-query-container (width >= 768px) {.rcb-pricing-info.svelte-1jzyaxi {gap:var(--rc-spacing-gapXXXLarge-desktop);}.rcb-pricing-info-header.svelte-1jzyaxi {gap:var(--rc-spacing-gapLarge-desktop);}
  }`
};
function Zv(e, r) {
  re(r, !1), ie(e, Xv);
  let t = K(r, "productDetails", 8), n = K(r, "purchaseOption", 8), a = K(r, "showProductDescription", 8), o = K(r, "priceBreakdown", 8);
  const s = t().productType === "subscription", l = s ? n() : null, c = s ? null : n(), u = s ? (l == null ? void 0 : l.base) ?? null : c != null && c.basePrice ? {
    periodDuration: null,
    period: null,
    cycleCount: 1,
    price: c.basePrice,
    pricePerWeek: null,
    pricePerMonth: null,
    pricePerYear: null
  } : null, d = (l == null ? void 0 : l.trial) ?? null, p = (l == null ? void 0 : l.discount) ?? (c == null ? void 0 : c.discount) ?? null, _ = (l == null ? void 0 : l.introPrice) ?? null, g = (l == null ? void 0 : l.discount) ?? (l == null ? void 0 : l.introPrice) ?? (c == null ? void 0 : c.discount) ?? null;
  Dn();
  var f = $v(), w = F(f), k = F(w);
  Uv(k, {
    get productDetails() {
      return t();
    },
    get showProductDescription() {
      return a();
    }
  });
  var m = V(k, 2);
  {
    var h = (E) => {
      Yv(E, {
        get priceBreakdown() {
          return o();
        },
        get basePhase() {
          return u;
        },
        get trialPhase() {
          return d;
        },
        get discountPhase() {
          return p;
        },
        get introPricePhase() {
          return _;
        }
      });
    }, v = (E) => {
      Kv(E, {
        get priceBreakdown() {
          return o();
        },
        get basePhase() {
          return u;
        }
      });
    };
    W(m, (E) => {
      s ? E(h) : E(v, !1);
    });
  }
  var y = V(w, 2);
  {
    let E = /* @__PURE__ */ Ut(() => !!p);
    jv(y, {
      get priceBreakdown() {
        return o();
      },
      get trialPhase() {
        return d;
      },
      get basePhase() {
        return u;
      },
      get promotionalPricePhase() {
        return g;
      },
      get hasDiscount() {
        return i(E);
      }
    });
  }
  T(e, f), te();
}
const Pa = (e) => `https://da08ctfrofx1b.cloudfront.net/${e}`;
var Jv = /* @__PURE__ */ B("<div><!></div>");
const Qv = {
  hash: "svelte-18ddpt0",
  code: `.rcb-ui-container.svelte-18ddpt0 {display:flex;flex-direction:column;inset:0;color-scheme:none;line-height:1.5em;font-family:-apple-system,
      BlinkMacSystemFont,
      avenir next,
      avenir,
      segoe ui,
      helvetica neue,
      helvetica,
      Cantarell,
      Ubuntu,
      roboto,
      noto,
      arial,
      sans-serif;overflow-x:hidden;overflow-y:auto;}.rcb-ui-container.fullscreen.svelte-18ddpt0 {position:fixed;top:0;left:0;right:0;bottom:0;overscroll-behavior:none;z-index:1000001;}.rcb-ui-container.inside.svelte-18ddpt0 {position:relative;width:100%;z-index:unset;height:100%;top:0;left:0;}`
};
function jd(e, r) {
  re(r, !0), ie(e, Qv);
  const t = K(r, "brandingAppearance", 3, void 0), n = K(r, "brandFontConfig", 3, void 0), a = K(r, "isInElement", 3, !1), o = /* @__PURE__ */ b(() => new la(t()).getTextStyleVars(n())), s = /* @__PURE__ */ b(() => new la(t()).spacingStyleVars), l = /* @__PURE__ */ b(() => [i(o), i(s)].join("; ")), c = /* @__PURE__ */ b(() => {
    var g;
    return (g = n()) != null && g.font_url ? Pa(n().font_url) : null;
  }), u = async (g) => {
    try {
      const f = new FontFace(Sd, `url(${g})`);
      await f.load(), document.fonts.add(f);
    } catch (f) {
      console.error("Failed to set brand font:", f);
    }
  };
  xr(() => {
    i(c) && u(i(c));
  });
  var d = Jv();
  let p;
  var _ = F(d);
  Xe(_, () => r.children ?? Fe), R(() => {
    p = rr(d, 1, "rcb-ui-container svelte-18ddpt0", null, p, { fullscreen: !a(), inside: a() }), Pe(d, i(l));
  }), T(e, d), te();
}
var ek = /* @__PURE__ */ B('<div id="layout-query-container" class="svelte-1ewgunr"><div class="rcb-ui-layout svelte-1ewgunr"><!></div></div>');
const rk = {
  hash: "svelte-1ewgunr",
  code: `#layout-query-container.svelte-1ewgunr {width:100%;height:100%;container-type:size;container-name:layout-query-container;overflow-y:auto;overscroll-behavior:none;}.rcb-ui-layout.svelte-1ewgunr {width:100%;min-height:100%;display:flex;box-sizing:border-box;flex-direction:column;overscroll-behavior:none;}

  @container layout-query-container (width < 768px) {.rcb-ui-layout.svelte-1ewgunr {flex-grow:1;}
  }

  @container layout-query-container (width >= 768px) {.rcb-ui-layout.svelte-1ewgunr {flex-direction:row;}
  }`
};
function tk(e, r) {
  ie(e, rk);
  let t = K(r, "style", 8, ""), n = K(r, "children", 8);
  var a = ek(), o = F(a), s = F(o);
  Xe(s, () => n() ?? Fe), R(() => Pe(o, t())), T(e, a);
}
const nk = (e) => e;
function ak(e) {
  const r = e - 1;
  return r * r * r + 1;
}
function hc(e) {
  const r = typeof e == "string" && e.match(/^\s*(-?[\d.]+)([^\s]*)\s*$/);
  return r ? [parseFloat(r[1]), r[2] || "px"] : [
    /** @type {number} */
    e,
    "px"
  ];
}
function ok(e, { delay: r = 0, duration: t = 400, easing: n = nk } = {}) {
  const a = +getComputedStyle(e).opacity;
  return {
    delay: r,
    duration: t,
    easing: n,
    css: (o) => `opacity: ${o * a}`
  };
}
function ik(e, { delay: r = 0, duration: t = 400, easing: n = ak, x: a = 0, y: o = 0, opacity: s = 0 } = {}) {
  const l = getComputedStyle(e), c = +l.opacity, u = l.transform === "none" ? "" : l.transform, d = c * (1 - s), [p, _] = hc(a), [g, f] = hc(o);
  return {
    delay: r,
    duration: t,
    easing: n,
    css: (w, k) => `
			transform: ${u} translate(${(1 - w) * p}${_}, ${(1 - w) * g}${f});
			opacity: ${c - d * k}`
  };
}
var sk = /* @__PURE__ */ B('<div><div class="layout-wrapper svelte-13h5jq9"><div><!></div></div></div>');
const lk = {
  hash: "svelte-13h5jq9",
  code: `.layout-wrapper-outer.svelte-13h5jq9 {flex:1;display:flex;background-color:var(--rc-color-background);}.layout-wrapper-outer.rcb-navbar.svelte-13h5jq9 {justify-content:flex-end;}.layout-wrapper.svelte-13h5jq9 {width:100%;}.layout-content.svelte-13h5jq9 {box-sizing:border-box;background-color:var(--rc-color-background);color:var(--rc-color-grey-text-dark);display:flex;flex-direction:column;}.layout-content.rcb-navbar.svelte-13h5jq9 {display:flex;flex-direction:column;gap:var(--rc-spacing-gapXLarge-mobile);}

  @container layout-query-container (width < 768px) {.layout-wrapper.svelte-13h5jq9 {width:100%;min-width:300px;display:flex;flex-grow:1;}.layout-content.svelte-13h5jq9 {flex-grow:1;height:100%;}.layout-content.rcb-navbar.svelte-13h5jq9 {padding-bottom:var(--rc-spacing-outerPadding-mobile);}.layout-content.rcb-main-block.svelte-13h5jq9 {padding:var(--rc-spacing-outerPadding-mobile);}
  }

  @container layout-query-container (width >= 768px) {.layout-wrapper.svelte-13h5jq9 {flex-basis:544px;}.layout-content.rcb-main-block.svelte-13h5jq9 {padding-left:var(--rc-spacing-outerPadding-desktop);padding-right:var(--rc-spacing-outerPadding-desktop);}.layout-content.rcb-navbar.svelte-13h5jq9 {gap:var(--rc-spacing-gapXXLarge-desktop);}.layout-wrapper-outer.svelte-13h5jq9 {padding-top:var(--rc-spacing-outerPaddingTop-desktop);padding-bottom:var(--rc-spacing-outerPadding-desktop);}
  }`
};
function Nd(e, r) {
  ie(e, lk);
  const t = `rcb-${r.location}`;
  var n = sk(), a = F(n), o = F(a), s = F(o);
  Xe(s, () => r.children ?? Fe), R(() => {
    rr(n, 1, `layout-wrapper-outer ${t}`, "svelte-13h5jq9"), rr(o, 1, `layout-content ${t}`, "svelte-13h5jq9");
  }), Iu(3, o, () => ok, () => ({ duration: 500, delay: 50 })), T(e, n);
}
var ck = /* @__PURE__ */ B('<div class="navbar-body svelte-191m2u3"><!></div>'), uk = /* @__PURE__ */ B('<div class="navbar-header svelte-191m2u3"><!></div> <!>', 1), dk = /* @__PURE__ */ B('<div class="rcb-ui-navbar svelte-191m2u3"><!></div>');
const pk = {
  hash: "svelte-191m2u3",
  code: `.rcb-ui-navbar.svelte-191m2u3 {width:100%;max-width:none;flex-shrink:0;background-color:var(--rc-color-background);}

  @container layout-query-container (width < 768px) {.navbar-body.svelte-191m2u3 {padding-left:var(--rc-spacing-outerPadding-mobile);padding-right:var(--rc-spacing-outerPadding-mobile);}
  }

  @container layout-query-container (width >= 768px) {.rcb-ui-navbar.svelte-191m2u3 {width:50vw;display:flex;justify-content:flex-end;}.navbar-header.svelte-191m2u3 {padding-left:var(--rc-spacing-outerPadding-desktop);padding-right:var(--rc-spacing-outerPadding-desktop);}.navbar-body.svelte-191m2u3 {padding-left:var(--rc-spacing-outerPadding-desktop);padding-right:var(--rc-spacing-outerPadding-desktop);}
  }`
};
function _k(e, r) {
  re(r, !0), ie(e, pk);
  const t = K(r, "brandingAppearance", 3, void 0), n = /* @__PURE__ */ b(() => new la(t()).productInfoStyleVars);
  var a = dk(), o = F(a);
  Nd(o, {
    location: "navbar",
    children: (s, l) => {
      var c = uk(), u = Q(c), d = F(u);
      Xe(d, () => r.headerContent ?? Fe);
      var p = V(u, 2);
      {
        var _ = (g) => {
          var f = ck(), w = F(f);
          Xe(w, () => r.bodyContent ?? Fe), T(g, f);
        };
        W(p, (g) => {
          r.bodyContent && g(_);
        });
      }
      T(s, c);
    }
  }), R(() => Pe(a, i(n))), T(e, a), te();
}
var gk = /* @__PURE__ */ B('<button class="rcb-close-button svelte-8qlvu1" data-testid="close-button"><!></button>');
const fk = {
  hash: "svelte-8qlvu1",
  code: ".rcb-close-button.svelte-8qlvu1 {padding:10px;border:none;cursor:pointer;background-color:transparent;border-radius:50%;color:var(--rc-color-grey-text-dark);display:inline-flex;align-items:center;justify-content:center;width:fit-content;height:fit-content;}.rcb-close-button.svelte-8qlvu1:active {transition:outline 0.1s ease-in-out;outline:2px solid var(--rc-color-focus);}.rcb-close-button.svelte-8qlvu1:hover {color:var(--rc-color-grey-text-dark);}"
};
function Od(e, r) {
  ie(e, fk);
  var t = gk(), n = F(t);
  Ma(n, { name: "close" }), Ur("click", t, function(a) {
    ju.call(this, r, a);
  }), T(e, t);
}
const mk = `<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
    <g clip-path="url(#clip0_6333_13826)">
    <rect opacity="0.2" width="12" height="12" rx="2.25" fill="black"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M8.53206 2.06972C9.28201 2.17252 9.88339 2.78615 9.96146 3.52824L10.2298 6.07852C10.2893 6.64453 9.87503 7.12287 9.30441 7.14692C8.73379 7.17097 8.22294 6.73163 8.16339 6.16562L8.08036 5.37641L6.00414 7.35193C5.6039 7.73275 4.94623 7.70146 4.53518 7.28205C4.12413 6.86263 4.11537 6.2139 4.51561 5.83307L6.59182 3.85756L5.79425 3.74823C5.22225 3.66982 4.79448 3.15142 4.83881 2.59036C4.88313 2.02929 5.38276 1.63802 5.95476 1.71643L8.53206 2.06972Z" fill="black"/>
    </g>
    <defs>
    <clipPath id="clip0_6333_13826">
    <rect width="12" height="12" fill="white"/>
    </clipPath>
    </defs>
    </svg>
`;
var hk = /* @__PURE__ */ B('<div style="color:var(--rc-color-accent);" class="rcb-ui-asset-icon svelte-w5b346"><!></div>');
const yk = {
  hash: "svelte-w5b346",
  code: "div.svelte-w5b346 {height:12px;width:12px;}"
};
function bk(e) {
  ie(e, yk);
  var r = hk(), t = F(r);
  cn(t, () => mk), T(e, r);
}
var vk = /* @__PURE__ */ B('<span class="rcb-sandbox-text svelte-bwwvt4">SANDBOX</span>'), kk = /* @__PURE__ */ B('<span class="rcb-sandbox-text svelte-bwwvt4">Share feedback</span>'), wk = /* @__PURE__ */ B('<a class="rcb-ui-sandbox-banner-link svelte-bwwvt4" target="_blank"><!> <!></a>'), Pk = /* @__PURE__ */ B('<div><div class="rcb-sandbox-banner-spacer svelte-bwwvt4"></div> <div class="rcb-sandbox-banner-title-wrapper svelte-bwwvt4"><!></div> <div class="rcb-sandbox-banner-actions-wrapper svelte-bwwvt4" style="--arrow-fill-color: black"><!> <!></div></div>');
const xk = {
  hash: "svelte-bwwvt4",
  code: `.rcb-ui-sandbox-banner.svelte-bwwvt4 {position:static;background-color:var(--rc-color-warning);color:black;padding:var(--rc-spacing-gapMedium-mobile) 0;display:flex;justify-content:space-between;align-items:center;height:24px;}.rcb-sandbox-text.svelte-bwwvt4 {font-weight:bold;color:black;line-height:2;}.rcb-sandbox-banner-spacer.svelte-bwwvt4 {flex:1;}.rcb-sandbox-banner-title-wrapper.svelte-bwwvt4 {flex:0;text-align:center;}

  @media (max-width: 768px) {.rcb-sandbox-banner-spacer.svelte-bwwvt4 {flex:0;}.rcb-sandbox-banner-title-wrapper.svelte-bwwvt4 {padding-left:var(--rc-spacing-gapXXLarge-mobile);}
  }.rcb-sandbox-banner-actions-wrapper.svelte-bwwvt4 {flex:1;display:flex;justify-content:flex-end;align-items:center;}.rcb-ui-sandbox-banner-link.svelte-bwwvt4 {display:flex;align-items:center;gap:var(--rc-spacing-gapSmall-mobile);line-height:12px;}`
};
function Ld(e, r) {
  re(r, !1), ie(e, xk);
  let t = K(r, "style", 8, ""), n = K(r, "isInElement", 8, !1), a = K(r, "brandingInfo", 8, null), o = /* @__PURE__ */ Or(!0);
  function s() {
    se.debugLog("closeBanner"), L(o, !1);
  }
  Dn();
  var l = ve(), c = Q(l);
  {
    var u = (d) => {
      var p = Pk();
      let _;
      var g = V(F(p), 2), f = F(g);
      we(f, {
        size: "caption-default",
        children: (v, y) => {
          var E = vk();
          T(v, E);
        },
        $$slots: { default: !0 }
      });
      var w = V(g, 2), k = F(w);
      {
        var m = (v) => {
          var y = wk(), E = F(y);
          bk(E);
          var S = V(E, 2);
          we(S, {
            size: "caption-link",
            children: (P, x) => {
              var I = kk();
              T(P, I);
            },
            $$slots: { default: !0 }
          }), R(() => oe(y, "href", (Ye(a()), Ue(() => a().sandbox_configuration.checkout_feedback_form_url)))), T(v, y);
        };
        W(k, (v) => {
          Ye(a()), Ue(() => {
            var y;
            return (y = a()) == null ? void 0 : y.sandbox_configuration;
          }) && v(m);
        });
      }
      var h = V(k, 2);
      Od(h, { $$events: { click: s } }), R(() => {
        _ = rr(p, 1, "rcb-ui-sandbox-banner svelte-bwwvt4", null, _, { isInElement: n() }), Pe(p, t());
      }), Iu(2, p, () => ik, () => ({ y: -100, duration: 300 })), T(d, p);
    };
    W(c, (d) => {
      i(o) && d(u);
    });
  }
  T(e, l), te();
}
var Ek = /* @__PURE__ */ B('<div class="rcb-ui-main svelte-iuk1gs"><!></div>');
const Sk = {
  hash: "svelte-iuk1gs",
  code: ".rcb-ui-main.svelte-iuk1gs {flex:1;display:flex;background-color:var(--rc-color-background);}"
};
function Tk(e, r) {
  re(r, !0), ie(e, Sk);
  const t = /* @__PURE__ */ b(() => new la(r.brandingAppearance).formStyleVars);
  var n = Ek(), a = F(n);
  Nd(a, {
    location: "main-block",
    children: (o, s) => {
      var l = ve(), c = Q(l);
      Xe(c, () => r.children ?? Fe), T(o, l);
    }
  }), R(() => Pe(n, i(t))), T(e, n), te();
}
var Ik = /* @__PURE__ */ B("<!> <!>", 1), Dk = /* @__PURE__ */ B("<!> <!>", 1);
function Ck(e, r) {
  re(r, !0);
  const t = /* @__PURE__ */ b(() => {
    var n;
    return Id((n = r.brandingInfo) == null ? void 0 : n.appearance) ?? "";
  });
  {
    let n = /* @__PURE__ */ b(() => {
      var o;
      return (o = r.brandingInfo) == null ? void 0 : o.appearance;
    }), a = /* @__PURE__ */ b(() => {
      var o;
      return (o = r.brandingInfo) == null ? void 0 : o.brand_font_config;
    });
    jd(e, {
      get brandingAppearance() {
        return i(n);
      },
      get brandFontConfig() {
        return i(a);
      },
      get isInElement() {
        return r.isInElement;
      },
      children: (o, s) => {
        var l = Dk(), c = Q(l);
        {
          var u = (p) => {
            Ld(p, {
              get style() {
                return i(t);
              },
              get isInElement() {
                return r.isInElement;
              },
              get brandingInfo() {
                return r.brandingInfo;
              }
            });
          };
          W(c, (p) => {
            r.isSandbox && p(u);
          });
        }
        var d = V(c, 2);
        tk(d, {
          get style() {
            return i(t);
          },
          children: (p, _) => {
            var g = Ik(), f = Q(g);
            {
              var w = (m) => {
                {
                  let h = /* @__PURE__ */ b(() => {
                    var v;
                    return (v = r.brandingInfo) == null ? void 0 : v.appearance;
                  });
                  _k(m, {
                    get brandingAppearance() {
                      return i(h);
                    },
                    get headerContent() {
                      return r.navbarHeaderContent;
                    },
                    get bodyContent() {
                      return r.navbarBodyContent;
                    }
                  });
                }
              };
              W(f, (m) => {
                (r.navbarHeaderContent || r.navbarBodyContent) && m(w);
              });
            }
            var k = V(f, 2);
            {
              let m = /* @__PURE__ */ b(() => {
                var h;
                return (h = r.brandingInfo) == null ? void 0 : h.appearance;
              });
              Tk(k, {
                get brandingAppearance() {
                  return i(m);
                },
                children: (h, v) => {
                  var y = ve(), E = Q(y);
                  Xe(E, () => r.mainContent ?? Fe), T(h, y);
                },
                $$slots: { default: !0 }
              });
            }
            T(p, g);
          },
          $$slots: { default: !0 }
        }), T(o, l);
      },
      $$slots: { default: !0 }
    });
  }
  te();
}
var Ak = /* @__PURE__ */ B('<source type="image/webp"/>'), qk = /* @__PURE__ */ B('<picture class="rcb-app-icon-picture-container svelte-15hivnw"><!> <img class="rcb-app-icon svelte-15hivnw" alt="App icon"/></picture>'), Fk = /* @__PURE__ */ B('<div class="rcb-app-icon loading svelte-15hivnw"></div>');
const zk = {
  hash: "svelte-15hivnw",
  code: ".rcb-app-icon.svelte-15hivnw {width:32px;height:32px;border-radius:12px;box-shadow:0px 1px 10px 0px rgba(0, 0, 0, 0.1);}.rcb-app-icon-picture-container.svelte-15hivnw {height:32px;}.rcb-app-icon.loading.svelte-15hivnw {background-color:gray;}"
};
function Bd(e, r) {
  ie(e, zk);
  var t = ve(), n = Q(t);
  {
    var a = (s) => {
      var l = qk(), c = F(l);
      {
        var u = (p) => {
          var _ = Ak();
          R(() => oe(_, "srcset", r.srcWebp)), T(p, _);
        };
        W(c, (p) => {
          r.srcWebp && p(u);
        });
      }
      var d = V(c, 2);
      R(() => oe(d, "src", r.src)), T(s, l);
    }, o = (s) => {
      var l = Fk();
      T(s, l);
    };
    W(n, (s) => {
      r.src ? s(a) : s(o, !1);
    });
  }
  T(e, t);
}
const so = (e) => !e || e.trim() === "" ? null : e, Mk = {
  icon: null,
  iconWebp: null,
  wordmark: null,
  wordmarkWebp: null,
  src: null,
  srcWebp: null,
  wordmarkSrc: null,
  wordmarkSrcWebp: null
}, Ud = (e) => {
  if (!e)
    return Mk;
  const r = so(e.app_icon), t = so(e.app_icon_webp), n = so(e.app_wordmark), a = so(e.app_wordmark_webp);
  return {
    src: r ? Pa(r) : null,
    srcWebp: t ? Pa(t) : null,
    wordmarkSrc: n ? Pa(n) : null,
    wordmarkSrcWebp: a ? Pa(a) : null
  };
};
var jk = /* @__PURE__ */ B('<button class="rcb-back-button svelte-7773d6" data-testid="close-button"><!></button>');
const Nk = {
  hash: "svelte-7773d6",
  code: ".rcb-back-button.svelte-7773d6 {padding:8px;border:none;cursor:pointer;background-color:transparent;border-radius:50%;color:var(--rc-color-grey-text-dark);display:inline-flex;align-items:center;justify-content:center;width:fit-content;height:fit-content;}"
};
function Ok(e, r) {
  ie(e, Nk);
  let t = K(r, "disabled", 3, !1);
  var n = jk(), a = F(n);
  Ma(a, { name: "back" }), R(() => n.disabled = t()), Ur("click", n, function(o) {
    ju.call(this, r, o);
  }), T(e, n);
}
var Lk = /* @__PURE__ */ B('<source type="image/webp" class="rcb-app-icon svelte-7clux6"/>'), Bk = /* @__PURE__ */ B('<picture class="rcb-app-icon svelte-7clux6"><!> <img class="rcb-app-icon svelte-7clux6" alt="App icon"/></picture>');
const Uk = {
  hash: "svelte-7clux6",
  code: ".rcb-app-icon.svelte-7clux6 {height:32px;}"
};
function Rd(e, r) {
  ie(e, Uk);
  var t = Bk(), n = F(t);
  {
    var a = (s) => {
      var l = Lk();
      R(() => oe(l, "srcset", r.srcWebp)), T(s, l);
    };
    W(n, (s) => {
      r.srcWebp && s(a);
    });
  }
  var o = V(n, 2);
  R(() => oe(o, "src", r.src)), T(e, t);
}
var Rk = /* @__PURE__ */ B('<div class="rcb-back-wrapper svelte-11a99mf"><!></div>'), Vk = /* @__PURE__ */ B('<div class="rcb-close-wrapper svelte-11a99mf"><!></div>'), Hk = /* @__PURE__ */ B('<div><!> <div class="rcb-header svelte-11a99mf"><div class="rcb-title svelte-11a99mf"><!> <!></div></div> <!></div>');
const Wk = {
  hash: "svelte-11a99mf",
  code: `.rcb-header-wrapper.svelte-11a99mf {display:flex;position:relative;justify-content:space-between;align-items:center;}.rcb-header.svelte-11a99mf {display:flex;flex-direction:row;align-items:center;padding-top:var(--rc-spacing-gapSmall-mobile);padding-bottom:var(--rc-spacing-gapSmall-mobile);height:40px;justify-content:space-between;}.rcb-title.svelte-11a99mf {display:flex;align-items:center;position:relative;gap:var(--rc-spacing-gapMedium-mobile);}.rcb-close-wrapper.svelte-11a99mf,
  .rcb-back-wrapper.svelte-11a99mf {padding:var(--rc-spacing-gapSmall-mobile);}

  @container layout-query-container (width < 768px) {.rcb-header.svelte-11a99mf {padding-top:var(--rc-spacing-gapMedium-mobile);}.rcb-close-wrapper.svelte-11a99mf {padding-top:var(--rc-spacing-gapMedium-mobile);}.rcb-header-wrapper.svelte-11a99mf {padding-top:var(--rc-spacing-gapSmall-mobile);padding-bottom:var(--rc-spacing-gapSmall-mobile);padding-left:var(--rc-spacing-outerPadding-mobile);padding-right:var(--rc-spacing-outerPadding-mobile);}.rcb-header-wrapper.rcb-with-close-button.svelte-11a99mf {padding-right:var(--rc-spacing-gapSmall-mobile);}.rcb-back-wrapper.svelte-11a99mf {display:none;}.rcb-header-wrapper.svelte-11a99mf {padding-left:var(--rc-spacing-outerPadding-mobile);padding-right:var(--rc-spacing-outerPadding-mobile);}
  }

  @container layout-query-container (width >= 768px) {.rcb-close-wrapper.svelte-11a99mf {display:none;}.rcb-back-wrapper.svelte-11a99mf {position:absolute;left:-48px;margin-left:0;}
  }`
};
function Yk(e, r) {
  re(r, !0), ie(e, Wk);
  const t = /* @__PURE__ */ b(() => Ud(r.brandingInfo)), n = /* @__PURE__ */ b(() => i(t).wordmarkSrc), a = /* @__PURE__ */ b(() => i(t).wordmarkSrcWebp), o = /* @__PURE__ */ b(() => i(t).src), s = /* @__PURE__ */ b(() => i(t).srcWebp), l = () => {
    r.onClose && r.onClose();
  };
  var c = Hk();
  let u;
  var d = F(c);
  {
    var p = (E) => {
      var S = Rk(), P = F(S);
      Ok(P, { $$events: { click: l } }), T(E, S);
    };
    W(d, (E) => {
      r.showCloseButton && E(p);
    });
  }
  var _ = V(d, 2), g = F(_), f = F(g);
  {
    var w = (E) => {
      Rd(E, {
        get src() {
          return i(n);
        },
        get srcWebp() {
          return i(a);
        }
      });
    }, k = (E) => {
      var S = ve(), P = Q(S);
      {
        var x = (I) => {
          Bd(I, {
            get src() {
              return i(o);
            },
            get srcWebp() {
              return i(s);
            }
          });
        };
        W(
          P,
          (I) => {
            i(o) !== null && i(s) !== null && I(x);
          },
          !0
        );
      }
      T(E, S);
    };
    W(f, (E) => {
      i(n) !== null ? E(w) : E(k, !1);
    });
  }
  var m = V(f, 2);
  {
    var h = (E) => {
      we(E, {
        size: "body-base",
        children: (S, P) => {
          var x = De();
          R(() => {
            var I;
            return me(x, (I = r.brandingInfo) == null ? void 0 : I.app_name);
          }), T(S, x);
        },
        $$slots: { default: !0 }
      });
    };
    W(m, (E) => {
      i(n) === null && E(h);
    });
  }
  var v = V(_, 2);
  {
    var y = (E) => {
      var S = Vk(), P = F(S);
      Od(P, { $$events: { click: l } }), T(E, S);
    };
    W(v, (E) => {
      r.showCloseButton && E(y);
    });
  }
  R(() => u = rr(c, 1, "rcb-header-wrapper svelte-11a99mf", null, u, { "rcb-with-close-button": r.showCloseButton })), T(e, c), te();
}
var Gk = /* @__PURE__ */ B("<!> <!> <!> <!>", 1);
function Kk(e, r) {
  re(r, !0);
  const t = K(r, "onClose", 3, void 0), n = Ks(r.productDetails, r.purchaseOptionToUse);
  let a = /* @__PURE__ */ X($e(r.defaultPriceBreakdown ?? {
    currency: n.currency,
    totalAmountInMicros: n.amountMicros,
    totalExcludingTaxInMicros: n.amountMicros,
    taxCalculationStatus: "unavailable",
    taxAmountInMicros: null,
    taxBreakdown: null
  }));
  const o = (s) => {
    L(a, s, !0);
  };
  Ck(e, {
    get brandingInfo() {
      return r.brandingInfo;
    },
    get isInElement() {
      return r.isInElement;
    },
    get isSandbox() {
      return r.isSandbox;
    },
    get onClose() {
      return t();
    },
    navbarHeaderContent: (u) => {
      {
        let d = /* @__PURE__ */ b(() => !r.isInElement && !!t());
        Yk(u, {
          get brandingInfo() {
            return r.brandingInfo;
          },
          get onClose() {
            return t();
          },
          get showCloseButton() {
            return i(d);
          }
        });
      }
    },
    navbarBodyContent: (u) => {
      {
        let d = /* @__PURE__ */ b(() => {
          var p, _;
          return ((_ = (p = r.brandingInfo) == null ? void 0 : p.appearance) == null ? void 0 : _.show_product_description) ?? !1;
        });
        Zv(u, {
          get productDetails() {
            return r.productDetails;
          },
          get purchaseOption() {
            return r.purchaseOptionToUse;
          },
          get showProductDescription() {
            return i(d);
          },
          get priceBreakdown() {
            return i(a);
          }
        });
      }
    },
    mainContent: (u) => {
      var d = Gk(), p = Q(d);
      {
        var _ = (v) => {
          yv(v);
        };
        W(p, (v) => {
          r.currentPage === "payment-entry-loading" && v(_);
        });
      }
      var g = V(p, 2);
      {
        var f = (v) => {
          Ob(v, {
            get productDetails() {
              return r.productDetails;
            },
            get purchaseOption() {
              return r.purchaseOptionToUse;
            },
            get brandingInfo() {
              return r.brandingInfo;
            },
            get purchaseOperationHelper() {
              return r.purchaseOperationHelper;
            },
            get gatewayParams() {
              return r.gatewayParams;
            },
            get managementUrl() {
              return r.managementUrl;
            },
            get customerEmail() {
              return r.customerEmail;
            },
            get forceEnableWalletMethods() {
              return r.forceEnableWalletMethods;
            },
            get defaultPriceBreakdown() {
              return r.defaultPriceBreakdown;
            },
            get termsAndConditionsUrl() {
              return r.termsAndConditionsUrl;
            },
            get onContinue() {
              return r.onContinue;
            },
            get onError() {
              return r.onError;
            },
            onPriceBreakdownUpdated: o
          });
        };
        W(g, (v) => {
          r.currentPage === "payment-entry" && v(f);
        });
      }
      var w = V(g, 2);
      {
        var k = (v) => {
          {
            let y = /* @__PURE__ */ b(() => {
              var S;
              return ((S = r.brandingInfo) == null ? void 0 : S.support_email) ?? null;
            }), E = /* @__PURE__ */ b(() => {
              var S;
              return ((S = r.brandingInfo) == null ? void 0 : S.app_name) ?? null;
            });
            zd(v, {
              get lastError() {
                return r.lastError;
              },
              get productDetails() {
                return r.productDetails;
              },
              get supportEmail() {
                return i(y);
              },
              get onDismiss() {
                return r.closeWithError;
              },
              get appName() {
                return i(E);
              }
            });
          }
        };
        W(w, (v) => {
          r.currentPage === "error" && v(k);
        });
      }
      var m = V(w, 2);
      {
        var h = (v) => {
          Md(v, {
            get onContinue() {
              return r.onContinue;
            }
          });
        };
        W(m, (v) => {
          r.currentPage === "success" && v(h);
        });
      }
      T(u, d);
    },
    $$slots: {
      navbarHeaderContent: !0,
      navbarBodyContent: !0,
      mainContent: !0
    }
  }), te();
}
function $k(e) {
  return e.trim() === "" ? "You need to provide your email address to continue." : e.match(/^[^@]+@[^@]+\.[^@]+$/) ? null : "Email is not valid. Please provide a valid email address.";
}
function Xk(e) {
  if (e && !e.match(/^[A-Z]{3}$/)) {
    const r = `Currency code ${e} is not valid. Please provide a valid ISO 4217 currency code.`;
    throw se.errorLog(r), new Oe(Ge.ConfigurationError, r);
  }
}
function Zk(e, r) {
  var S;
  re(r, !0);
  const t = K(r, "customTranslations", 19, () => ({})), n = K(r, "skipSuccessPage", 3, !1), a = r.customerEmail ? $k(r.customerEmail) : null;
  let o = /* @__PURE__ */ X($e(a ? void 0 : r.customerEmail)), s = r.rcPackage.webBillingProduct, l = /* @__PURE__ */ X(null);
  const c = r.rcPackage.webBillingProduct.identifier ?? null;
  let u = /* @__PURE__ */ X("payment-entry-loading"), d = /* @__PURE__ */ X(null), p = /* @__PURE__ */ X($e({})), _ = /* @__PURE__ */ X(null), g = /* @__PURE__ */ X(null), f = /* @__PURE__ */ X(null), w = /* @__PURE__ */ X(null), k = new En(t(), r.selectedLocale, r.defaultLocale), m = Vr(k);
  ir(vr, m), ir(Xa, (S = r.brandingInfo) == null ? void 0 : S.appearance), _r(() => {
    r.isInElement || (L(g, document.documentElement.style.height, !0), L(f, document.documentElement.style.overflow, !0), L(w, document.body.style.height, !0), document.documentElement.style.height = "100%", document.body.style.height = "100%", document.documentElement.style.overflow = "hidden");
  }), ln(() => {
    if (!r.isInElement) {
      const P = (x, I, q) => {
        q === "" ? x.style.removeProperty(I) : x.style.setProperty(I, q);
      };
      P(document.documentElement, "height", i(g)), P(document.body, "height", i(w)), P(document.documentElement, "overflow", i(f));
    }
  }), ir(Ho, r.eventsTracker);
  let h = $e(typeof r.purchases._shouldForceEnableWalletMethods == "function" ? r.purchases._shouldForceEnableWalletMethods() : !1);
  _r(async () => {
    if (c === null) {
      y(new ae(ee.ErrorSettingUpPurchase, "Product ID was not set before purchase."));
      return;
    }
    r.purchaseOperationHelper.checkoutStart(r.appUserId, c, r.purchaseOption, r.rcPackage.webBillingProduct.presentedOfferingContext, i(o), r.metadata, r.workflowPurchaseContext, r.paywallId).then((P) => {
      L(l, null), L(u, "payment-entry"), L(p, P.gateway_params, !0), L(_, P.management_url, !0);
    }).catch((P) => {
      if (P.errorCode === ee.MissingEmailError)
        return L(o, void 0), r.purchaseOperationHelper.checkoutStart(r.appUserId, c, r.purchaseOption, r.rcPackage.webBillingProduct.presentedOfferingContext, i(o), r.metadata, r.workflowPurchaseContext, r.paywallId).then((x) => {
          L(l, null), L(u, "payment-entry"), L(p, x.gateway_params, !0), L(_, x.management_url, !0);
        }).catch((x) => {
          y(x);
        });
      y(P);
    });
  });
  const v = () => {
    if (i(u) === "payment-entry") {
      r.purchaseOperationHelper.pollCurrentPurchaseForCompletion().then((P) => {
        L(d, P, !0), n() ? r.onFinished(P) : L(u, "success");
      }).catch((P) => {
        y(P);
      });
      return;
    }
    if (i(u) === "success" || i(u) === "error") {
      r.onFinished(i(d));
      return;
    }
    L(u, "success");
  }, y = (P) => {
    const x = bd({
      errorCode: P.getErrorCode().toString(),
      errorMessage: P.message
    });
    r.eventsTracker.trackSDKEvent(x), L(l, P, !0), L(u, "error");
  }, E = () => {
    r.onError(i(l) ?? new ae(ee.UnknownError, "Unknown error without state set."));
  };
  {
    let P = /* @__PURE__ */ b(() => r.purchases.isSandbox()), x = /* @__PURE__ */ b(() => i(o) ?? null);
    Kk(e, {
      get isSandbox() {
        return i(P);
      },
      get currentPage() {
        return i(u);
      },
      get brandingInfo() {
        return r.brandingInfo;
      },
      get productDetails() {
        return s;
      },
      get purchaseOptionToUse() {
        return r.purchaseOption;
      },
      get lastError() {
        return i(l);
      },
      get gatewayParams() {
        return i(p);
      },
      get managementUrl() {
        return i(_);
      },
      get purchaseOperationHelper() {
        return r.purchaseOperationHelper;
      },
      get isInElement() {
        return r.isInElement;
      },
      get termsAndConditionsUrl() {
        return r.termsAndConditionsUrl;
      },
      get forceEnableWalletMethods() {
        return h;
      },
      get customerEmail() {
        return i(x);
      },
      closeWithError: E,
      onContinue: v,
      onError: y,
      get onClose() {
        return r.onClose;
      }
    });
  }
  te();
}
function yc(e, r, t, n, a, o, s) {
  try {
    var l = e[o](s), c = l.value;
  } catch (u) {
    return void t(u);
  }
  l.done ? r(c) : Promise.resolve(c).then(n, a);
}
function Jk(e) {
  return function() {
    var r = this, t = arguments;
    return new Promise(function(n, a) {
      var o = e.apply(r, t);
      function s(c) {
        yc(o, n, a, s, l, "next", c);
      }
      function l(c) {
        yc(o, n, a, s, l, "throw", c);
      }
      s(void 0);
    });
  };
}
function Qk(e, r, t) {
  return (r = tw(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function bc(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    r && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), t.push.apply(t, n);
  }
  return t;
}
function os(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = arguments[r] != null ? arguments[r] : {};
    r % 2 ? bc(Object(t), !0).forEach(function(n) {
      Qk(e, n, t[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : bc(Object(t)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n));
    });
  }
  return e;
}
function Vd(e, r) {
  if (e == null) return {};
  var t, n, a = ew(e, r);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (n = 0; n < o.length; n++) t = o[n], r.includes(t) || {}.propertyIsEnumerable.call(e, t) && (a[t] = e[t]);
  }
  return a;
}
function ew(e, r) {
  if (e == null) return {};
  var t = {};
  for (var n in e) if ({}.hasOwnProperty.call(e, n)) {
    if (r.includes(n)) continue;
    t[n] = e[n];
  }
  return t;
}
function is() {
  is = function() {
    return r;
  };
  var e, r = {}, t = Object.prototype, n = t.hasOwnProperty, a = Object.defineProperty || function(A, C, z) {
    A[C] = z.value;
  }, o = typeof Symbol == "function" ? Symbol : {}, s = o.iterator || "@@iterator", l = o.asyncIterator || "@@asyncIterator", c = o.toStringTag || "@@toStringTag";
  function u(A, C, z) {
    return Object.defineProperty(A, C, {
      value: z,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), A[C];
  }
  try {
    u({}, "");
  } catch {
    u = function(C, z, G) {
      return C[z] = G;
    };
  }
  function d(A, C, z, G) {
    var H = C && C.prototype instanceof m ? C : m, J = Object.create(H.prototype), le = new j(G || []);
    return a(J, "_invoke", {
      value: q(A, z, le)
    }), J;
  }
  function p(A, C, z) {
    try {
      return {
        type: "normal",
        arg: A.call(C, z)
      };
    } catch (G) {
      return {
        type: "throw",
        arg: G
      };
    }
  }
  r.wrap = d;
  var _ = "suspendedStart", g = "suspendedYield", f = "executing", w = "completed", k = {};
  function m() {
  }
  function h() {
  }
  function v() {
  }
  var y = {};
  u(y, s, function() {
    return this;
  });
  var E = Object.getPrototypeOf, S = E && E(E(Y([])));
  S && S !== t && n.call(S, s) && (y = S);
  var P = v.prototype = m.prototype = Object.create(y);
  function x(A) {
    ["next", "throw", "return"].forEach(function(C) {
      u(A, C, function(z) {
        return this._invoke(C, z);
      });
    });
  }
  function I(A, C) {
    function z(H, J, le, fe) {
      var pe = p(A[H], A, J);
      if (pe.type !== "throw") {
        var xe = pe.arg, de = xe.value;
        return de && typeof de == "object" && n.call(de, "__await") ? C.resolve(de.__await).then(function(ue) {
          z("next", ue, le, fe);
        }, function(ue) {
          z("throw", ue, le, fe);
        }) : C.resolve(de).then(function(ue) {
          xe.value = ue, le(xe);
        }, function(ue) {
          return z("throw", ue, le, fe);
        });
      }
      fe(pe.arg);
    }
    var G;
    a(this, "_invoke", {
      value: function(H, J) {
        function le() {
          return new C(function(fe, pe) {
            z(H, J, fe, pe);
          });
        }
        return G = G ? G.then(le, le) : le();
      }
    });
  }
  function q(A, C, z) {
    var G = _;
    return function(H, J) {
      if (G === f) throw Error("Generator is already running");
      if (G === w) {
        if (H === "throw") throw J;
        return {
          value: e,
          done: !0
        };
      }
      for (z.method = H, z.arg = J; ; ) {
        var le = z.delegate;
        if (le) {
          var fe = N(le, z);
          if (fe) {
            if (fe === k) continue;
            return fe;
          }
        }
        if (z.method === "next") z.sent = z._sent = z.arg;
        else if (z.method === "throw") {
          if (G === _) throw G = w, z.arg;
          z.dispatchException(z.arg);
        } else z.method === "return" && z.abrupt("return", z.arg);
        G = f;
        var pe = p(A, C, z);
        if (pe.type === "normal") {
          if (G = z.done ? w : g, pe.arg === k) continue;
          return {
            value: pe.arg,
            done: z.done
          };
        }
        pe.type === "throw" && (G = w, z.method = "throw", z.arg = pe.arg);
      }
    };
  }
  function N(A, C) {
    var z = C.method, G = A.iterator[z];
    if (G === e) return C.delegate = null, z === "throw" && A.iterator.return && (C.method = "return", C.arg = e, N(A, C), C.method === "throw") || z !== "return" && (C.method = "throw", C.arg = new TypeError("The iterator does not provide a '" + z + "' method")), k;
    var H = p(G, A.iterator, C.arg);
    if (H.type === "throw") return C.method = "throw", C.arg = H.arg, C.delegate = null, k;
    var J = H.arg;
    return J ? J.done ? (C[A.resultName] = J.value, C.next = A.nextLoc, C.method !== "return" && (C.method = "next", C.arg = e), C.delegate = null, k) : J : (C.method = "throw", C.arg = new TypeError("iterator result is not an object"), C.delegate = null, k);
  }
  function M(A) {
    var C = {
      tryLoc: A[0]
    };
    1 in A && (C.catchLoc = A[1]), 2 in A && (C.finallyLoc = A[2], C.afterLoc = A[3]), this.tryEntries.push(C);
  }
  function D(A) {
    var C = A.completion || {};
    C.type = "normal", delete C.arg, A.completion = C;
  }
  function j(A) {
    this.tryEntries = [{
      tryLoc: "root"
    }], A.forEach(M, this), this.reset(!0);
  }
  function Y(A) {
    if (A || A === "") {
      var C = A[s];
      if (C) return C.call(A);
      if (typeof A.next == "function") return A;
      if (!isNaN(A.length)) {
        var z = -1, G = function H() {
          for (; ++z < A.length; ) if (n.call(A, z)) return H.value = A[z], H.done = !1, H;
          return H.value = e, H.done = !0, H;
        };
        return G.next = G;
      }
    }
    throw new TypeError(typeof A + " is not iterable");
  }
  return h.prototype = v, a(P, "constructor", {
    value: v,
    configurable: !0
  }), a(v, "constructor", {
    value: h,
    configurable: !0
  }), h.displayName = u(v, c, "GeneratorFunction"), r.isGeneratorFunction = function(A) {
    var C = typeof A == "function" && A.constructor;
    return !!C && (C === h || (C.displayName || C.name) === "GeneratorFunction");
  }, r.mark = function(A) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(A, v) : (A.__proto__ = v, u(A, c, "GeneratorFunction")), A.prototype = Object.create(P), A;
  }, r.awrap = function(A) {
    return {
      __await: A
    };
  }, x(I.prototype), u(I.prototype, l, function() {
    return this;
  }), r.AsyncIterator = I, r.async = function(A, C, z, G, H) {
    H === void 0 && (H = Promise);
    var J = new I(d(A, C, z, G), H);
    return r.isGeneratorFunction(C) ? J : J.next().then(function(le) {
      return le.done ? le.value : J.next();
    });
  }, x(P), u(P, c, "Generator"), u(P, s, function() {
    return this;
  }), u(P, "toString", function() {
    return "[object Generator]";
  }), r.keys = function(A) {
    var C = Object(A), z = [];
    for (var G in C) z.push(G);
    return z.reverse(), function H() {
      for (; z.length; ) {
        var J = z.pop();
        if (J in C) return H.value = J, H.done = !1, H;
      }
      return H.done = !0, H;
    };
  }, r.values = Y, j.prototype = {
    constructor: j,
    reset: function(A) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = e, this.done = !1, this.delegate = null, this.method = "next", this.arg = e, this.tryEntries.forEach(D), !A) for (var C in this) C.charAt(0) === "t" && n.call(this, C) && !isNaN(+C.slice(1)) && (this[C] = e);
    },
    stop: function() {
      this.done = !0;
      var A = this.tryEntries[0].completion;
      if (A.type === "throw") throw A.arg;
      return this.rval;
    },
    dispatchException: function(A) {
      if (this.done) throw A;
      var C = this;
      function z(pe, xe) {
        return J.type = "throw", J.arg = A, C.next = pe, xe && (C.method = "next", C.arg = e), !!xe;
      }
      for (var G = this.tryEntries.length - 1; G >= 0; --G) {
        var H = this.tryEntries[G], J = H.completion;
        if (H.tryLoc === "root") return z("end");
        if (H.tryLoc <= this.prev) {
          var le = n.call(H, "catchLoc"), fe = n.call(H, "finallyLoc");
          if (le && fe) {
            if (this.prev < H.catchLoc) return z(H.catchLoc, !0);
            if (this.prev < H.finallyLoc) return z(H.finallyLoc);
          } else if (le) {
            if (this.prev < H.catchLoc) return z(H.catchLoc, !0);
          } else {
            if (!fe) throw Error("try statement without catch or finally");
            if (this.prev < H.finallyLoc) return z(H.finallyLoc);
          }
        }
      }
    },
    abrupt: function(A, C) {
      for (var z = this.tryEntries.length - 1; z >= 0; --z) {
        var G = this.tryEntries[z];
        if (G.tryLoc <= this.prev && n.call(G, "finallyLoc") && this.prev < G.finallyLoc) {
          var H = G;
          break;
        }
      }
      H && (A === "break" || A === "continue") && H.tryLoc <= C && C <= H.finallyLoc && (H = null);
      var J = H ? H.completion : {};
      return J.type = A, J.arg = C, H ? (this.method = "next", this.next = H.finallyLoc, k) : this.complete(J);
    },
    complete: function(A, C) {
      if (A.type === "throw") throw A.arg;
      return A.type === "break" || A.type === "continue" ? this.next = A.arg : A.type === "return" ? (this.rval = this.arg = A.arg, this.method = "return", this.next = "end") : A.type === "normal" && C && (this.next = C), k;
    },
    finish: function(A) {
      for (var C = this.tryEntries.length - 1; C >= 0; --C) {
        var z = this.tryEntries[C];
        if (z.finallyLoc === A) return this.complete(z.completion, z.afterLoc), D(z), k;
      }
    },
    catch: function(A) {
      for (var C = this.tryEntries.length - 1; C >= 0; --C) {
        var z = this.tryEntries[C];
        if (z.tryLoc === A) {
          var G = z.completion;
          if (G.type === "throw") {
            var H = G.arg;
            D(z);
          }
          return H;
        }
      }
      throw Error("illegal catch attempt");
    },
    delegateYield: function(A, C, z) {
      return this.delegate = {
        iterator: Y(A),
        resultName: C,
        nextLoc: z
      }, this.method === "next" && (this.arg = e), k;
    }
  }, r;
}
function rw(e, r) {
  if (typeof e != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var n = t.call(e, r);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(e);
}
function tw(e) {
  var r = rw(e, "string");
  return typeof r == "symbol" ? r : r + "";
}
var ja = {
  CLASSIC: "classic",
  V1: "v1"
}, nw = ja.V1, aw = "https://cdn.paddle.com/paddle/paddle.js", ow = "https://cdn.paddle.com/paddle/v2/paddle.js", iw = {
  url: aw
}, sw = {
  url: ow
};
function lw(e) {
  return document.querySelector('script[src="'.concat(e, '"]')) || void 0;
}
function cw(e) {
  var r = document.createElement("script");
  r.src = e;
  var t = document.head || document.body;
  if (!t)
    throw new Error("Cannot inject Paddle.js. It needs a <head> or <body> element.");
  return t.appendChild(r), r;
}
var Ii = {
  classic: void 0,
  v1: void 0
}, uw = {
  classic: "PaddleClassic",
  v1: "PaddleBillingV1"
};
function dw(e) {
  var r, t = (r = pw(e)) === null || r === void 0 ? void 0 : r.url;
  if (t) {
    var n = Ii[e], a = uw[e];
    return n !== void 0 ? n : (Ii[e] = new Promise(function(o, s) {
      if (typeof window > "u") {
        o(void 0);
        return;
      }
      if (window[a]) {
        o(window[a]);
        return;
      }
      try {
        var l = lw(t);
        l || (l = cw(t)), l.addEventListener("load", function() {
          window[a] ? o(window[a]) : s(new Error("Paddle.js not available"));
        }), l.addEventListener("error", function() {
          s(new Error("Failed to load Paddle.js - ".concat(e)));
        });
      } catch (c) {
        s(c);
        return;
      }
    }), Ii[e]);
  }
}
function pw(e) {
  if (e === ja.CLASSIC)
    return iw;
  if (e === ja.V1)
    return sw;
  console.error("[Paddle] Unknown Paddle Version");
}
var _w = ["environment", "version"], gw = ["environment", "version"];
function fw(e, r) {
  var t = e.environment;
  e.version;
  var n = Vd(e, _w);
  try {
    t && r.Environment.set(t), r.Initialized ? r.Update(os({}, n)) : r.Initialize(os({}, n));
  } catch (a) {
    console.warn("[Paddle] Paddle Initialization failed. Please check the inputs", a);
  }
}
function mw(e, r) {
  var t = e.environment;
  e.version;
  var n = Vd(e, gw);
  try {
    t && r.Environment.set(t), r.Setup(os({}, n));
  } catch (a) {
    console.warn("[Paddle] Paddle Initialization failed. Please check the inputs", a);
  }
}
var Ta;
(function(e) {
  e.CHECKOUT_LOADED = "checkout.loaded", e.CHECKOUT_CLOSED = "checkout.closed", e.CHECKOUT_UPDATED = "checkout.updated", e.CHECKOUT_COMPLETED = "checkout.completed", e.CHECKOUT_ERROR = "checkout.error", e.CHECKOUT_FAILED = "checkout.failed", e.CHECKOUT_ITEMS_UPDATED = "checkout.items.updated", e.CHECKOUT_ITEMS_REMOVED = "checkout.items.removed", e.CHECKOUT_CUSTOMER_CREATED = "checkout.customer.created", e.CHECKOUT_CUSTOMER_UPDATED = "checkout.customer.updated", e.CHECKOUT_CUSTOMER_REMOVED = "checkout.customer.removed", e.CHECKOUT_PAYMENT_SELECTED = "checkout.payment.selected", e.CHECKOUT_PAYMENT_INITIATED = "checkout.payment.initiated", e.CHECKOUT_PAYMENT_FAILED = "checkout.payment.failed", e.CHECKOUT_DISCOUNT_APPLIED = "checkout.discount.applied", e.CHECKOUT_DISCOUNT_REMOVED = "checkout.discount.removed", e.CHECKOUT_UPSELL_CANCELED = "checkout.upsell.canceled";
})(Ta || (Ta = {}));
var vc;
(function(e) {
  e.DAY = "day", e.WEEK = "week", e.MONTH = "month", e.YEAR = "year";
})(vc || (vc = {}));
var kc;
(function(e) {
  e.ALIPAY = "alipay", e.APPLE_PAY = "apple-pay", e.CARD = "card", e.GOOGLE_PAY = "google-pay", e.IDEAL = "ideal", e.PAYPAL = "paypal", e.WIRE_TRANSFER = "wire-transfer", e.NONE = "none";
})(kc || (kc = {}));
var wc;
(function(e) {
  e.AMERICAN_EXPRESS = "american_express", e.DINERS_CLUB = "diners_club", e.DISCOVER = "discover", e.JCB = "jcb", e.MADA = "mada", e.MAESTRO = "maestro", e.MASTER_CARD = "mastercard", e.UNION_PAY = "union_pay", e.VISA = "visa", e.UNKNOWN = "unknown";
})(wc || (wc = {}));
var Pc;
(function(e) {
  e.DRAFT = "draft", e.READY = "ready", e.COMPLETED = "completed", e.BILLED = "billed", e.canceled = "canceled", e.PAST_DUE = "past_due";
})(Pc || (Pc = {}));
function hw(e) {
  return ss.apply(this, arguments);
}
function ss() {
  return ss = Jk(/* @__PURE__ */ is().mark(function e(r) {
    var t, n;
    return is().wrap(function(o) {
      for (; ; ) switch (o.prev = o.next) {
        case 0:
          return t = (r == null ? void 0 : r.version) || nw, o.next = 3, dw(t);
        case 3:
          if (n = o.sent, !n) {
            o.next = 9;
            break;
          }
          return r && (t === ja.V1 ? fw(r, n) : t === ja.CLASSIC && mw(r, n)), o.abrupt("return", n);
        case 9:
          return console.error("[Paddle] Error Loading Paddle"), o.abrupt("return");
        case 11:
        case "end":
          return o.stop();
      }
    }, e);
  })), ss.apply(this, arguments);
}
class yw {
  constructor(r, t, n = 10) {
    U(this, "paddleInstance");
    U(this, "backend");
    U(this, "eventsTracker");
    U(this, "maxNumberAttempts");
    U(this, "waitMSBetweenAttempts", 1e3);
    this.backend = r, this.eventsTracker = t, this.maxNumberAttempts = n;
  }
  async initializePaddle(r, t) {
    var a;
    if ((a = this.paddleInstance) != null && a.Initialized)
      return se.debugLog(
        "Paddle already initialized, returning existing instance"
      ), this.paddleInstance;
    const n = t ? "sandbox" : "production";
    try {
      const o = await hw({
        token: r,
        version: "v1",
        environment: n
      });
      if (!o)
        throw new ae(
          ee.UnknownError,
          "Paddle client not found"
        );
      return this.paddleInstance = o, se.debugLog(`Paddle initialized with environment: ${n}`), o;
    } catch (o) {
      throw o instanceof ae ? o : new ae(
        ee.UnknownError,
        `Error initializing Paddle: ${o}`
      );
    }
  }
  getPaddleInstance() {
    var r;
    if (!((r = this.paddleInstance) != null && r.Initialized))
      throw new ae(
        ee.UnknownError,
        "Paddle not initialized."
      );
    return this.paddleInstance;
  }
  async startCheckout({
    appUserId: r,
    productId: t,
    presentedOfferingContext: n,
    purchaseOption: a,
    customerEmail: o,
    metadata: s
  }) {
    try {
      const l = this.eventsTracker.getTraceId(), c = await this.backend.postCheckoutStart(
        r,
        t,
        n,
        a,
        l,
        o ?? void 0,
        s
      );
      return await this.initializePaddle(
        c.paddle_billing_params.client_side_token,
        c.paddle_billing_params.is_sandbox
      ), c;
    } catch (l) {
      throw l instanceof Oe ? ae.fromPurchasesError(
        l,
        ee.ErrorSettingUpPurchase,
        l.errorCode === Ge.InvalidCredentialsError
      ) : new ae(
        ee.UnknownError,
        `Error starting Paddle checkout: ${l}`
      );
    }
  }
  async purchase({
    operationSessionId: r,
    transactionId: t,
    onCheckoutLoaded: n,
    onClose: a,
    params: o
  }) {
    const s = this.getPaddleInstance(), { customerEmail: l, locale: c = "en" } = o;
    return new Promise((u, d) => {
      s.Update({
        eventCallback: async (_) => {
          const g = _.name, f = _.data;
          try {
            if (g === Ta.CHECKOUT_LOADED)
              n();
            else if (g === Ta.CHECKOUT_COMPLETED) {
              s.Checkout.close();
              const w = await this.pollOperationStatus(r);
              u(w);
            } else g === Ta.CHECKOUT_CLOSED && (f != null && f.status) && a();
          } catch (w) {
            s.Checkout.close(), w instanceof ae ? d(w) : w instanceof Oe ? d(
              ae.fromPurchasesError(
                w,
                ee.UnknownError
              )
            ) : d(
              new ae(
                ee.UnknownError,
                `Paddle event handler error: ${w}`
              )
            );
          }
        }
      });
      const p = {
        transactionId: t,
        settings: {
          displayMode: "overlay",
          theme: "light",
          variant: "one-page",
          locale: c,
          allowLogout: !1,
          showAddDiscounts: !1,
          showAddTaxId: !1,
          allowDiscountRemoval: !1
        },
        ...l && { customer: { email: l } }
      };
      try {
        s.Checkout.open(p);
      } catch (_) {
        d(
          new ae(
            ee.UnknownError,
            `Failed to open Paddle checkout: ${_}`
          )
        );
      }
    });
  }
  async pollOperationStatus(r) {
    if (!r)
      throw new ae(
        ee.ErrorSettingUpPurchase,
        "No purchase in progress"
      );
    return new Promise((t, n) => {
      const a = (o = 1) => {
        if (o > this.maxNumberAttempts) {
          n(
            new ae(
              ee.UnknownError,
              "Max attempts reached trying to get successful purchase status"
            )
          );
          return;
        }
        this.backend.getCheckoutStatus(r).then((s) => {
          const l = s.operation.store_transaction_identifier, c = s.operation.product_identifier, u = s.operation.purchase_date ? isNaN(Date.parse(s.operation.purchase_date)) ? null : new Date(s.operation.purchase_date) : null;
          switch (s.operation.status) {
            case Lt.Started:
            case Lt.InProgress:
              setTimeout(
                () => a(o + 1),
                this.waitMSBetweenAttempts
              );
              break;
            case Lt.Succeeded:
              if (!l || !c || !u) {
                n(
                  new ae(
                    ee.UnknownError,
                    "Missing required fields in operation response."
                  )
                );
                return;
              }
              t({
                redemptionInfo: Nu(s),
                operationSessionId: r,
                storeTransactionIdentifier: l ?? "",
                productIdentifier: c,
                purchaseDate: u ?? /* @__PURE__ */ new Date()
              });
              return;
            case Lt.Failed:
              Ou(
                s.operation.error,
                n
              );
          }
        }).catch((s) => {
          if (s instanceof Oe) {
            const l = ae.fromPurchasesError(
              s,
              ee.NetworkError
            );
            n(l);
          } else
            n(
              new ae(
                ee.NetworkError,
                `Failed to get checkout status: ${s}`
              )
            );
        });
      };
      a();
    });
  }
}
var bw = /* @__PURE__ */ B('<!> <div class="rcb-fullscreen-wrapper svelte-skuziz"><div><!></div> <div class="rcb-fullscreen-content svelte-skuziz"><!></div></div>', 1);
const vw = {
  hash: "svelte-skuziz",
  code: `.rcb-fullscreen-wrapper.svelte-skuziz {width:100%;height:100%;display:flex;flex-direction:column;align-items:center;}.rcb-fullscreen-header.svelte-skuziz {display:flex;justify-content:center;align-items:center;padding-top:var(--rc-spacing-gapXXLarge-mobile);padding-bottom:var(--rc-spacing-gapMedium-mobile);flex-shrink:0;position:absolute;}.rcb-fullscreen-header.static-header.svelte-skuziz {position:static;}.rcb-fullscreen-content.svelte-skuziz {flex:1;width:100%;box-sizing:border-box;display:flex;flex-direction:column;align-items:center;justify-content:center;padding:0 var(--rc-spacing-outerPadding-mobile)
      var(--rc-spacing-outerPadding-mobile);color:var(--rc-color-grey-text-dark);}

  /* On short screens, don't position the header on top of the content */
  @media (max-height: 500px) {.rcb-fullscreen-header.svelte-skuziz {position:static;}
  }

  @media (min-width: 768px) {.rcb-fullscreen-header.svelte-skuziz {padding-top:var(--rc-spacing-gapXXLarge-desktop);}.rcb-fullscreen-content.svelte-skuziz {padding:0 var(--rc-spacing-outerPadding-desktop)
        var(--rc-spacing-outerPadding-desktop);}
  }`
};
function kw(e, r) {
  re(r, !0), ie(e, vw);
  const t = /* @__PURE__ */ b(() => {
    var u;
    return new la((u = r.brandingInfo) == null ? void 0 : u.appearance).pageStyleVars;
  }), n = /* @__PURE__ */ b(() => {
    var u, d;
    return ((d = (u = r.brandingInfo) == null ? void 0 : u.appearance) == null ? void 0 : d.color_page_bg) ?? "#ffffff";
  }), a = /* @__PURE__ */ b(() => Ud(r.brandingInfo)), o = /* @__PURE__ */ b(() => i(a).wordmarkSrc), s = /* @__PURE__ */ b(() => i(a).wordmarkSrcWebp), l = /* @__PURE__ */ b(() => i(a).src), c = /* @__PURE__ */ b(() => i(a).srcWebp);
  {
    let u = /* @__PURE__ */ b(() => {
      var p;
      return (p = r.brandingInfo) == null ? void 0 : p.appearance;
    }), d = /* @__PURE__ */ b(() => {
      var p;
      return (p = r.brandingInfo) == null ? void 0 : p.brand_font_config;
    });
    jd(e, {
      get brandingAppearance() {
        return i(u);
      },
      get brandFontConfig() {
        return i(d);
      },
      get isInElement() {
        return r.isInElement;
      },
      children: (p, _) => {
        var g = bw(), f = Q(g);
        {
          var w = (x) => {
            Ld(x, {
              get style() {
                return i(t);
              },
              get isInElement() {
                return r.isInElement;
              },
              get brandingInfo() {
                return r.brandingInfo;
              }
            });
          };
          W(f, (x) => {
            r.isSandbox && x(w);
          });
        }
        var k = V(f, 2), m = F(k);
        let h;
        var v = F(m);
        {
          var y = (x) => {
            Rd(x, {
              get src() {
                return i(o);
              },
              get srcWebp() {
                return i(s);
              }
            });
          }, E = (x) => {
            var I = ve(), q = Q(I);
            {
              var N = (D) => {
                Bd(D, {
                  get src() {
                    return i(l);
                  },
                  get srcWebp() {
                    return i(c);
                  }
                });
              }, M = (D) => {
                var j = ve(), Y = Q(j);
                {
                  var A = (C) => {
                    we(C, {
                      size: "body-base",
                      children: (z, G) => {
                        var H = De();
                        R(() => me(H, r.brandingInfo.app_name)), T(z, H);
                      },
                      $$slots: { default: !0 }
                    });
                  };
                  W(
                    Y,
                    (C) => {
                      var z;
                      (z = r.brandingInfo) != null && z.app_name && C(A);
                    },
                    !0
                  );
                }
                T(D, j);
              };
              W(
                q,
                (D) => {
                  i(l) !== null && i(c) !== null ? D(N) : D(M, !1);
                },
                !0
              );
            }
            T(x, I);
          };
          W(v, (x) => {
            i(o) !== null ? x(y) : x(E, !1);
          });
        }
        var S = V(m, 2), P = F(S);
        Xe(P, () => r.mainContent ?? Fe), R(() => {
          Pe(k, `${i(t) ?? ""}; background-color: ${i(n) ?? ""}`), h = rr(m, 1, "rcb-fullscreen-header svelte-skuziz", null, h, { "static-header": r.isInElement });
        }), T(p, g);
      },
      $$slots: { default: !0 }
    });
  }
  te();
}
var ww = /* @__PURE__ */ B("<!> <!> <!>", 1), Pw = /* @__PURE__ */ B('<div class="rcb-ui-loading-container svelte-1r889ax"><!></div>');
const xw = {
  hash: "svelte-1r889ax",
  code: ".rcb-ui-loading-container.svelte-1r889ax {display:flex;flex-direction:column;align-items:center;}"
};
function Ew(e, r) {
  re(r, !0), ie(e, xw);
  const t = () => he(o, "$translator", n), [n, a] = je(), o = Be(vr);
  kw(e, {
    get brandingInfo() {
      return r.brandingInfo;
    },
    get isInElement() {
      return r.isInElement;
    },
    get isSandbox() {
      return r.isSandbox;
    },
    mainContent: (l) => {
      var c = ve(), u = Q(c);
      {
        var d = (_) => {
          var g = Pw(), f = F(g);
          Us(f, {
            gap: "medium",
            align: "center",
            children: (w, k) => {
              var m = ww(), h = Q(m);
              Pd(h, { color: "var(--rc-color-grey-text-dark)" });
              var v = V(h, 2);
              we(v, {
                size: "heading-md",
                children: (E, S) => {
                  var P = De();
                  R((x) => me(P, x), [
                    () => t().translate(Z.LoadingPageProcessingPayment)
                  ]), T(E, P);
                },
                $$slots: { default: !0 }
              });
              var y = V(v, 2);
              we(y, {
                size: "body-small",
                children: (E, S) => {
                  var P = De();
                  R((x) => me(P, x), [
                    () => t().translate(Z.LoadingPageKeepPageOpen)
                  ]), T(E, P);
                },
                $$slots: { default: !0 }
              }), T(w, m);
            },
            $$slots: { default: !0 }
          }), T(_, g);
        }, p = (_) => {
          var g = ve(), f = Q(g);
          {
            var w = (m) => {
              Md(m, {
                get onContinue() {
                  return r.onContinue;
                },
                fullWidth: !0
              });
            }, k = (m) => {
              var h = ve(), v = Q(h);
              {
                var y = (E) => {
                  {
                    let S = /* @__PURE__ */ b(() => {
                      var x;
                      return ((x = r.brandingInfo) == null ? void 0 : x.support_email) ?? null;
                    }), P = /* @__PURE__ */ b(() => {
                      var x;
                      return ((x = r.brandingInfo) == null ? void 0 : x.app_name) ?? null;
                    });
                    zd(E, {
                      get lastError() {
                        return r.lastError;
                      },
                      get productDetails() {
                        return r.productDetails;
                      },
                      get supportEmail() {
                        return i(S);
                      },
                      get onDismiss() {
                        return r.closeWithError;
                      },
                      get appName() {
                        return i(P);
                      },
                      fullWidth: !0
                    });
                  }
                };
                W(
                  v,
                  (E) => {
                    r.currentPage === "error" && E(y);
                  },
                  !0
                );
              }
              T(m, h);
            };
            W(
              f,
              (m) => {
                r.currentPage === "success" ? m(w) : m(k, !1);
              },
              !0
            );
          }
          T(_, g);
        };
        W(u, (_) => {
          r.currentPage === "loading" ? _(d) : _(p, !1);
        });
      }
      T(l, c);
    },
    $$slots: { mainContent: !0 }
  }), te(), a();
}
function Sw(e, r) {
  var v;
  re(r, !0);
  const t = K(r, "customTranslations", 19, () => ({})), n = K(r, "skipSuccessPage", 3, !1);
  let a = new En(t(), r.selectedLocale, r.defaultLocale), o = Vr(a);
  ir(vr, o), ir(Xa, (v = r.brandingInfo) == null ? void 0 : v.appearance), ir(Ho, r.eventsTracker);
  let s = /* @__PURE__ */ X(!1), l = /* @__PURE__ */ X(null), c = /* @__PURE__ */ X(null), u = /* @__PURE__ */ X("waiting");
  xr(() => {
    i(u) === "success" && i(l) && n() && r.onFinished(i(l));
  });
  const d = () => {
    i(u) === "success" && i(l) && r.onFinished(i(l));
  }, p = () => {
    r.onError(i(c) ?? new ae(ee.UnknownError, "Unknown error without state set.")), r.unmountPaddlePurchaseUi();
  }, _ = (y, E) => y instanceof ae ? y : y instanceof Oe ? ae.fromPurchasesError(y, ee.UnknownError) : new ae(ee.UnknownError, E);
  let g = null, f = null, w = null;
  _r(async () => {
    var P;
    r.isInElement || (g = document.documentElement.style.height, f = document.documentElement.style.overflow, w = document.body.style.height, document.documentElement.style.height = "100%", document.body.style.height = "100%", document.documentElement.style.overflow = "hidden");
    const y = () => {
      L(u, "loading");
    }, E = {
      offeringIdentifier: r.productDetails.presentedOfferingContext.offeringIdentifier,
      targetingContext: null,
      placementIdentifier: null
    };
    let S;
    try {
      S = await r.paddleService.startCheckout({
        appUserId: r.appUserId,
        productId: r.productDetails.identifier,
        presentedOfferingContext: E,
        purchaseOption: r.purchaseOption,
        customerEmail: r.customerEmail,
        metadata: r.metadata
      }), L(s, S.paddle_billing_params.is_sandbox, !0);
    } catch (x) {
      const I = _(x, `Start Paddle checkout failed: ${x}`);
      L(c, I, !0), L(u, "error"), r.onError(I);
      return;
    }
    try {
      const x = await r.paddleService.purchase({
        operationSessionId: S.operation_session_id,
        transactionId: (P = S.paddle_billing_params) == null ? void 0 : P.transaction_id,
        onCheckoutLoaded: y,
        onClose: r.onClose,
        params: {
          rcPackage: r.rcPackage,
          purchaseOption: r.purchaseOption,
          appUserId: r.appUserId,
          presentedOfferingIdentifier: r.productDetails.presentedOfferingContext.offeringIdentifier,
          customerEmail: r.customerEmail,
          locale: r.selectedLocale || r.defaultLocale
        }
      });
      n() ? r.onFinished(x) : (L(l, x, !0), L(u, "success"));
    } catch (x) {
      const I = _(x, `Paddle purchase failed: ${x}`);
      L(c, I, !0), L(u, "error"), r.onError(I);
    }
  }), ln(() => {
    if (!r.isInElement) {
      const y = (E, S, P) => {
        P === "" ? E.style.removeProperty(S) : E.style.setProperty(S, P);
      };
      y(document.documentElement, "height", g), y(document.body, "height", w), y(document.documentElement, "overflow", f);
    }
  });
  var k = ve(), m = Q(k);
  {
    var h = (y) => {
      Ew(y, {
        get currentPage() {
          return i(u);
        },
        get brandingInfo() {
          return r.brandingInfo;
        },
        get productDetails() {
          return r.productDetails;
        },
        get isSandbox() {
          return i(s);
        },
        get lastError() {
          return i(c);
        },
        get isInElement() {
          return r.isInElement;
        },
        onContinue: d,
        closeWithError: p
      });
    };
    W(m, (y) => {
      i(u) !== "waiting" && y(h);
    });
  }
  T(e, k), te();
}
function Hd(e) {
  return e == null ? !0 : new Date(e) > /* @__PURE__ */ new Date();
}
function Tw(e, r, t, n) {
  const a = r.product_identifier;
  if (a in t)
    return Iw(
      e,
      r,
      t[a]
    );
  if (a in n)
    return Dw(
      e,
      r,
      n[a]
    );
  throw new Oe(
    Ge.CustomerInfoError,
    "Could not find entitlement product in subscriptions or non-subscriptions."
  );
}
function Iw(e, r, t) {
  return {
    identifier: e,
    isActive: Hd(r.expires_date),
    willRenew: Wd(
      r.expires_date,
      t
    ),
    store: (t == null ? void 0 : t.store) ?? "unknown",
    latestPurchaseDate: new Date(r.purchase_date),
    originalPurchaseDate: new Date(r.purchase_date),
    expirationDate: wt(r.expires_date),
    productIdentifier: r.product_identifier,
    productPlanIdentifier: r.product_plan_identifier ?? null,
    unsubscribeDetectedAt: wt(
      t == null ? void 0 : t.unsubscribe_detected_at
    ),
    billingIssueDetectedAt: wt(
      t == null ? void 0 : t.billing_issues_detected_at
    ),
    isSandbox: (t == null ? void 0 : t.is_sandbox) ?? !1,
    periodType: (t == null ? void 0 : t.period_type) ?? "normal",
    ownershipType: (t == null ? void 0 : t.ownership_type) ?? "UNKNOWN"
  };
}
function Dw(e, r, t) {
  return {
    identifier: e,
    isActive: !0,
    willRenew: !1,
    store: t.store,
    latestPurchaseDate: new Date(r.purchase_date),
    originalPurchaseDate: new Date(
      t.original_purchase_date
    ),
    expirationDate: null,
    productIdentifier: r.product_identifier,
    productPlanIdentifier: null,
    unsubscribeDetectedAt: null,
    billingIssueDetectedAt: null,
    isSandbox: t.is_sandbox,
    periodType: "normal",
    ownershipType: "UNKNOWN"
  };
}
function Cw(e, r, t) {
  const n = {}, a = {};
  for (const o in e) {
    const s = Tw(
      o,
      e[o],
      r,
      t
    );
    n[o] = s, s.isActive && (a[o] = s);
  }
  return {
    all: n,
    active: a
  };
}
function wt(e) {
  return e == null ? null : new Date(e);
}
function ls(e) {
  const r = qw(e), t = e.subscriber, n = zw(
    t.non_subscriptions
  ), a = Object.entries(e.subscriber.non_subscriptions).flatMap(
    ([l, c]) => c.map((u) => ({
      transactionIdentifier: u.id,
      productIdentifier: l,
      purchaseDate: new Date(
        u.purchase_date || u.original_purchase_date
      ),
      storeTransactionId: u.store_transaction_id || null,
      store: u.store
    }))
  ), o = new Date(e.request_date), s = Object.fromEntries(
    Object.entries(e.subscriber.subscriptions).map(
      ([l, c]) => [
        l,
        {
          productIdentifier: l,
          purchaseDate: new Date(c.purchase_date),
          originalPurchaseDate: wt(
            c.original_purchase_date
          ),
          expiresDate: wt(c.expires_date),
          store: c.store,
          unsubscribeDetectedAt: wt(
            c.unsubscribe_detected_at
          ),
          isSandbox: c.is_sandbox,
          billingIssuesDetectedAt: wt(
            c.billing_issues_detected_at
          ),
          gracePeriodExpiresDate: wt(
            c.grace_period_expires_date
          ),
          ownershipType: c.ownership_type ?? "UNKNOWN",
          periodType: c.period_type,
          refundedAt: wt(c.refunded_at),
          storeTransactionId: c.store_transaction_id || null,
          managementURL: c.management_url ?? null,
          isActive: Hd(c.expires_date),
          willRenew: Wd(c.expires_date, c)
        }
      ]
    )
  );
  return {
    entitlements: Cw(
      t.entitlements,
      t.subscriptions,
      n
    ),
    allExpirationDatesByProduct: r,
    allPurchaseDatesByProduct: Aw(
      e,
      n
    ),
    activeSubscriptions: Fw(r),
    managementURL: t.management_url,
    requestDate: o,
    firstSeenDate: new Date(t.first_seen),
    originalPurchaseDate: wt(
      t.original_purchase_date
    ),
    originalAppUserId: e.subscriber.original_app_user_id,
    nonSubscriptionTransactions: a,
    subscriptionsByProductIdentifier: s
  };
}
function Wd(e, r) {
  if (r == null) return !1;
  const t = r.store == "promotional", n = e == null, a = r.unsubscribe_detected_at != null, o = r.billing_issues_detected_at != null;
  return !(t || n || a || o);
}
function Aw(e, r) {
  const t = {};
  for (const n in e.subscriber.subscriptions) {
    const a = e.subscriber.subscriptions[n];
    t[n] = new Date(
      a.purchase_date
    );
  }
  for (const n in r) {
    const a = r[n].purchase_date;
    a == null ? t[n] = null : t[n] = new Date(a);
  }
  return t;
}
function qw(e) {
  const r = {};
  for (const t in e.subscriber.subscriptions) {
    const n = e.subscriber.subscriptions[t];
    n.expires_date == null ? r[t] = null : r[t] = new Date(
      n.expires_date
    );
  }
  return r;
}
function Fw(e) {
  const r = /* @__PURE__ */ new Set(), t = /* @__PURE__ */ new Date();
  for (const n in e) {
    const a = e[n];
    (a == null || a > t) && r.add(n);
  }
  return r;
}
function zw(e) {
  const r = {};
  for (const t in e) {
    if (e[t].length === 0) continue;
    const n = e[t].length;
    r[t] = e[t][n - 1];
  }
  return r;
}
const Yd = "1.28.0", Mw = "https://api.revenuecat.com", jw = "https://e.revenue.cat";
var To;
(function(e) {
  e[e.CONTINUE = 100] = "CONTINUE", e[e.SWITCHING_PROTOCOLS = 101] = "SWITCHING_PROTOCOLS", e[e.PROCESSING = 102] = "PROCESSING", e[e.EARLY_HINTS = 103] = "EARLY_HINTS", e[e.OK = 200] = "OK", e[e.CREATED = 201] = "CREATED", e[e.ACCEPTED = 202] = "ACCEPTED", e[e.NON_AUTHORITATIVE_INFORMATION = 203] = "NON_AUTHORITATIVE_INFORMATION", e[e.NO_CONTENT = 204] = "NO_CONTENT", e[e.RESET_CONTENT = 205] = "RESET_CONTENT", e[e.PARTIAL_CONTENT = 206] = "PARTIAL_CONTENT", e[e.MULTI_STATUS = 207] = "MULTI_STATUS", e[e.MULTIPLE_CHOICES = 300] = "MULTIPLE_CHOICES", e[e.MOVED_PERMANENTLY = 301] = "MOVED_PERMANENTLY", e[e.MOVED_TEMPORARILY = 302] = "MOVED_TEMPORARILY", e[e.SEE_OTHER = 303] = "SEE_OTHER", e[e.NOT_MODIFIED = 304] = "NOT_MODIFIED", e[e.USE_PROXY = 305] = "USE_PROXY", e[e.TEMPORARY_REDIRECT = 307] = "TEMPORARY_REDIRECT", e[e.PERMANENT_REDIRECT = 308] = "PERMANENT_REDIRECT", e[e.BAD_REQUEST = 400] = "BAD_REQUEST", e[e.UNAUTHORIZED = 401] = "UNAUTHORIZED", e[e.PAYMENT_REQUIRED = 402] = "PAYMENT_REQUIRED", e[e.FORBIDDEN = 403] = "FORBIDDEN", e[e.NOT_FOUND = 404] = "NOT_FOUND", e[e.METHOD_NOT_ALLOWED = 405] = "METHOD_NOT_ALLOWED", e[e.NOT_ACCEPTABLE = 406] = "NOT_ACCEPTABLE", e[e.PROXY_AUTHENTICATION_REQUIRED = 407] = "PROXY_AUTHENTICATION_REQUIRED", e[e.REQUEST_TIMEOUT = 408] = "REQUEST_TIMEOUT", e[e.CONFLICT = 409] = "CONFLICT", e[e.GONE = 410] = "GONE", e[e.LENGTH_REQUIRED = 411] = "LENGTH_REQUIRED", e[e.PRECONDITION_FAILED = 412] = "PRECONDITION_FAILED", e[e.REQUEST_TOO_LONG = 413] = "REQUEST_TOO_LONG", e[e.REQUEST_URI_TOO_LONG = 414] = "REQUEST_URI_TOO_LONG", e[e.UNSUPPORTED_MEDIA_TYPE = 415] = "UNSUPPORTED_MEDIA_TYPE", e[e.REQUESTED_RANGE_NOT_SATISFIABLE = 416] = "REQUESTED_RANGE_NOT_SATISFIABLE", e[e.EXPECTATION_FAILED = 417] = "EXPECTATION_FAILED", e[e.IM_A_TEAPOT = 418] = "IM_A_TEAPOT", e[e.INSUFFICIENT_SPACE_ON_RESOURCE = 419] = "INSUFFICIENT_SPACE_ON_RESOURCE", e[e.METHOD_FAILURE = 420] = "METHOD_FAILURE", e[e.MISDIRECTED_REQUEST = 421] = "MISDIRECTED_REQUEST", e[e.UNPROCESSABLE_ENTITY = 422] = "UNPROCESSABLE_ENTITY", e[e.LOCKED = 423] = "LOCKED", e[e.FAILED_DEPENDENCY = 424] = "FAILED_DEPENDENCY", e[e.UPGRADE_REQUIRED = 426] = "UPGRADE_REQUIRED", e[e.PRECONDITION_REQUIRED = 428] = "PRECONDITION_REQUIRED", e[e.TOO_MANY_REQUESTS = 429] = "TOO_MANY_REQUESTS", e[e.REQUEST_HEADER_FIELDS_TOO_LARGE = 431] = "REQUEST_HEADER_FIELDS_TOO_LARGE", e[e.UNAVAILABLE_FOR_LEGAL_REASONS = 451] = "UNAVAILABLE_FOR_LEGAL_REASONS", e[e.INTERNAL_SERVER_ERROR = 500] = "INTERNAL_SERVER_ERROR", e[e.NOT_IMPLEMENTED = 501] = "NOT_IMPLEMENTED", e[e.BAD_GATEWAY = 502] = "BAD_GATEWAY", e[e.SERVICE_UNAVAILABLE = 503] = "SERVICE_UNAVAILABLE", e[e.GATEWAY_TIMEOUT = 504] = "GATEWAY_TIMEOUT", e[e.HTTP_VERSION_NOT_SUPPORTED = 505] = "HTTP_VERSION_NOT_SUPPORTED", e[e.INSUFFICIENT_STORAGE = 507] = "INSUFFICIENT_STORAGE", e[e.NETWORK_AUTHENTICATION_REQUIRED = 511] = "NETWORK_AUTHENTICATION_REQUIRED";
})(To || (To = {}));
const Nw = /^rcb_[a-zA-Z0-9_.-]+$/, Ow = /^pdl_[a-zA-Z0-9_.-]+$/, Lw = /^test_[a-zA-Z0-9_.-]+$/;
function Io(e) {
  return e ? e.startsWith("rcb_sb_") : !1;
}
function cs(e) {
  return e ? Nw.test(e) : !1;
}
function Gd(e) {
  return e ? Ow.test(e) : !1;
}
function gn(e) {
  return e ? Lw.test(e) : !1;
}
async function Gr(e, r, t) {
  return (await Kd(
    e,
    r,
    t
  )).data;
}
async function Kd(e, r, t) {
  const { apiKey: n, body: a, headers: o, httpConfig: s } = r, c = `${(s == null ? void 0 : s.proxyURL) ?? Mw}${e.urlPath()}`;
  try {
    const u = await fetch(c, {
      method: e.method,
      headers: np(n, o, s == null ? void 0 : s.additionalHeaders),
      body: Uw(a),
      signal: t
    });
    await Bw(u, e);
    const d = u.status;
    return { data: await u.json(), statusCode: d };
  } catch (u) {
    throw u instanceof TypeError ? new Oe(
      Ge.NetworkError,
      Kn.getPublicMessage(Ge.NetworkError),
      u.message
    ) : u;
  }
}
async function Bw(e, r) {
  const t = e.status;
  if (t >= To.INTERNAL_SERVER_ERROR)
    Di(r, t, await e.text());
  else if (t >= To.BAD_REQUEST) {
    const n = await e.json(), a = n ? JSON.stringify(n) : null, o = n == null ? void 0 : n.code, s = n == null ? void 0 : n.message;
    if (o != null) {
      const l = Kn.convertCodeToBackendErrorCode(o);
      if (l == null)
        Di(
          r,
          t,
          a,
          o
        );
      else
        throw Oe.getForBackendError(
          l,
          s
        );
    } else
      Di(r, t, a);
  }
}
function Di(e, r, t, n) {
  throw new Oe(
    Ge.UnknownBackendError,
    "Unknown backend error.",
    `Request: ${e.name}. Status code: ${r}. Body: ${t}.`,
    { backendErrorCode: n }
  );
}
function Uw(e) {
  return e == null ? null : JSON.stringify(e);
}
const $d = "Authorization", Xd = "Content-Type", Zd = "Accept", Jd = "X-Platform", Qd = "X-Version", ep = "X-Platform-Flavor", rp = "X-Platform-Flavor-Version", tp = "X-Is-Sandbox", Rw = /* @__PURE__ */ new Set([
  $d,
  Xd,
  Zd,
  Jd,
  Qd,
  tp,
  ep,
  rp
]);
function np(e, r, t) {
  let n = {
    [$d]: `Bearer ${e}`,
    [Xd]: "application/json",
    [Zd]: "application/json",
    [Jd]: "web",
    [Qd]: Yd,
    [tp]: `${Io(e)}`
  };
  const a = ps.getPlatformInfo();
  if (a) {
    const o = {
      [ep]: a.flavor,
      [rp]: a.version
    };
    n = { ...n, ...o };
  }
  return r && (n = { ...n, ...r }), t && (n = { ...t, ...n }), n;
}
const Za = "/v1/subscribers", Fn = "/rcbilling/v1";
class Vw {
  constructor(r) {
    U(this, "appUserId");
    U(this, "method", "GET");
    U(this, "name", "getOfferings");
    this.appUserId = r;
  }
  urlPath() {
    const r = encodeURIComponent(this.appUserId);
    return `${Za}/${r}/offerings`;
  }
}
class Hw {
  constructor(r, t, n, a) {
    U(this, "method", "GET");
    U(this, "name", "getProducts");
    U(this, "appUserId");
    U(this, "productIds");
    U(this, "currency");
    U(this, "discountCode");
    this.appUserId = r, this.productIds = t, this.currency = n, this.discountCode = a;
  }
  urlPath() {
    const r = encodeURIComponent(this.appUserId), t = this.productIds.map(encodeURIComponent).join("&id="), n = this.currency ? `&currency=${this.currency}` : "", a = this.discountCode ? `&discount_code=${encodeURIComponent(this.discountCode)}` : "";
    return `${Fn}/subscribers/${r}/products?id=${t}${n}${a}`;
  }
}
class Ww {
  constructor(r) {
    U(this, "method", "GET");
    U(this, "name", "getCustomerInfo");
    U(this, "appUserId");
    this.appUserId = r;
  }
  urlPath() {
    const r = encodeURIComponent(this.appUserId);
    return `${Za}/${r}`;
  }
}
class Yw {
  constructor() {
    U(this, "method", "POST");
    U(this, "name", "identify");
  }
  urlPath() {
    return `${Za}/identify`;
  }
}
class Gw {
  constructor() {
    U(this, "method", "GET");
    U(this, "name", "getBrandingInfo");
  }
  urlPath() {
    return `${Fn}/branding`;
  }
}
class Kw {
  constructor() {
    U(this, "method", "POST");
    U(this, "name", "postCheckoutPrepare");
  }
  urlPath() {
    return `${Fn}/checkout/prepare`;
  }
}
class $w {
  constructor() {
    U(this, "method", "POST");
    U(this, "name", "postCheckoutStart");
  }
  urlPath() {
    return `${Fn}/checkout/start`;
  }
}
class Xw {
  constructor(r) {
    U(this, "method", "POST");
    U(this, "name", "postCheckoutCalculateTax");
    U(this, "operationSessionId");
    this.operationSessionId = r;
  }
  urlPath() {
    return `${Fn}/checkout/${this.operationSessionId}/calculate_taxes`;
  }
}
class Zw {
  constructor(r) {
    U(this, "method", "POST");
    U(this, "name", "postCheckoutComplete");
    U(this, "operationSessionId");
    this.operationSessionId = r;
  }
  urlPath() {
    return `${Fn}/checkout/${this.operationSessionId}/complete`;
  }
}
class Jw {
  constructor(r) {
    U(this, "method", "GET");
    U(this, "name", "getCheckoutStatus");
    U(this, "operationSessionId");
    this.operationSessionId = r;
  }
  urlPath() {
    return `${Fn}/checkout/${this.operationSessionId}`;
  }
}
class Qw {
  constructor(r) {
    U(this, "method", "POST");
    U(this, "name", "setAttributes");
    U(this, "appUserId");
    this.appUserId = r;
  }
  urlPath() {
    const r = encodeURIComponent(this.appUserId);
    return `${Za}/${r}/attributes`;
  }
}
class eP {
  constructor() {
    U(this, "method", "POST");
    U(this, "name", "postReceipt");
  }
  urlPath() {
    return "/v1/receipts";
  }
}
class rP {
  constructor(r) {
    U(this, "method", "GET");
    U(this, "name", "getVirtualCurrencies");
    U(this, "appUserId");
    this.appUserId = r;
  }
  urlPath() {
    const r = encodeURIComponent(this.appUserId);
    return `${Za}/${r}/virtual_currencies`;
  }
}
const us = {};
class tP {
  constructor(r, t = us, n) {
    U(this, "API_KEY");
    U(this, "httpConfig");
    U(this, "isSandbox");
    U(this, "purchasesContext");
    this.API_KEY = r, this.httpConfig = t, this.isSandbox = Io(r), this.purchasesContext = n;
  }
  getIsSandbox() {
    return this.isSandbox;
  }
  async getOfferings(r) {
    return await Gr(
      new Vw(r),
      {
        apiKey: this.API_KEY,
        httpConfig: this.httpConfig
      }
    );
  }
  async getCustomerInfo(r) {
    return await Gr(
      new Ww(r),
      {
        apiKey: this.API_KEY,
        httpConfig: this.httpConfig
      }
    );
  }
  async identify(r, t) {
    const n = {
      app_user_id: r,
      new_app_user_id: t
    }, a = await Kd(new Yw(), {
      apiKey: this.API_KEY,
      body: n,
      httpConfig: this.httpConfig
    }), o = a.statusCode === 201;
    return {
      ...a.data,
      was_created: o
    };
  }
  async getProducts(r, t, n, a) {
    return await Gr(
      new Hw(r, t, n, a),
      {
        apiKey: this.API_KEY,
        httpConfig: this.httpConfig
      }
    );
  }
  async getBrandingInfo() {
    return await Gr(
      new Gw(),
      {
        apiKey: this.API_KEY,
        httpConfig: this.httpConfig
      }
    );
  }
  async postCheckoutPrepare(r, t) {
    const n = {
      product_id: r,
      price_id: t.priceId
    };
    return t.id !== "base_option" && (n.offer_id = t.id), await Gr(
      new Kw(),
      {
        apiKey: this.API_KEY,
        body: n,
        httpConfig: this.httpConfig
      }
    );
  }
  async postCheckoutStart(r, t, n, a, o, s, l = void 0, c, u) {
    var p, _;
    const d = {
      app_user_id: r,
      product_id: t,
      email: s,
      price_id: a.priceId,
      presented_offering_identifier: n.offeringIdentifier,
      trace_id: o
    };
    return l && (d.metadata = l), a.id !== "base_option" && (d.offer_id = a.id), n.targetingContext && (d.applied_targeting_rule = {
      rule_id: n.targetingContext.ruleId,
      revision: n.targetingContext.revision
    }), n.placementIdentifier && (d.presented_placement_identifier = n.placementIdentifier), (_ = (p = this.purchasesContext) == null ? void 0 : p.workflowContext) != null && _.workflowIdentifier && (d.presented_workflow_id = this.purchasesContext.workflowContext.workflowIdentifier), c && (d.presented_step_id = c), u && (d.paywall = {
      paywall_id: u
    }), await Gr(
      new $w(),
      {
        apiKey: this.API_KEY,
        body: d,
        httpConfig: this.httpConfig
      }
    );
  }
  async postCheckoutCalculateTax(r, t, n, a) {
    const o = {
      country_code: t,
      postal_code: n
    };
    return await Gr(
      new Xw(r),
      {
        apiKey: this.API_KEY,
        body: o,
        httpConfig: this.httpConfig
      },
      a
    );
  }
  async postCheckoutComplete(r, t) {
    const n = {
      email: t
    };
    return await Gr(new Zw(r), {
      apiKey: this.API_KEY,
      body: n,
      httpConfig: this.httpConfig
    });
  }
  async getCheckoutStatus(r) {
    return await Gr(
      new Jw(r),
      {
        apiKey: this.API_KEY,
        httpConfig: this.httpConfig
      }
    );
  }
  async setAttributes(r, t) {
    const n = Date.now(), a = {};
    for (const [s, l] of Object.entries(t))
      a[s] = {
        value: l,
        updated_at_ms: n
      };
    const o = {
      attributes: a
    };
    return await Gr(
      new Qw(r),
      {
        apiKey: this.API_KEY,
        body: o,
        httpConfig: this.httpConfig
      }
    );
  }
  async postReceipt(r, t, n, a, o, s, l) {
    var d, p;
    let c = null;
    o.targetingContext && (c = {
      rule_id: o.targetingContext.ruleId,
      revision: o.targetingContext.revision
    });
    const u = {
      fetch_token: a,
      product_id: t,
      currency: n,
      app_user_id: r,
      presented_offering_identifier: o.offeringIdentifier,
      presented_placement_identifier: o.placementIdentifier,
      presented_workflow_id: (p = (d = this.purchasesContext) == null ? void 0 : d.workflowContext) == null ? void 0 : p.workflowIdentifier,
      applied_targeting_rule: c,
      initiation_source: s
    };
    return l && (u.paywall = {
      paywall_id: l
    }), await Gr(
      new eP(),
      {
        apiKey: this.API_KEY,
        body: u,
        httpConfig: this.httpConfig
      }
    );
  }
  async getVirtualCurrencies(r) {
    return await Gr(
      new rP(r),
      {
        apiKey: this.API_KEY,
        httpConfig: this.httpConfig
      }
    );
  }
}
function nP(e) {
  if (!(cs(e) || gn(e) || Gd(e)))
    throw new Oe(
      Ge.InvalidCredentialsError,
      "Invalid API key. Use your Web Billing API key."
    );
}
function Ci(e) {
  if (!e || (/* @__PURE__ */ new Set([
    "no_user",
    "null",
    "none",
    "nil",
    "(null)",
    "NaN",
    "\\x00",
    "",
    "unidentified",
    "undefined",
    "unknown"
  ])).has(e) || e.includes("/"))
    throw new Oe(
      Ge.InvalidAppUserIdError,
      'Provided user id: "' + (e ?? "[Not provided]") + '" is not valid. See https://www.revenuecat.com/docs/customers/user-ids#tips-for-setting-app-user-ids for more information.'
    );
}
function aP(e) {
  if (e != null && e.endsWith("/"))
    throw new Oe(
      Ge.ConfigurationError,
      "Invalid proxy URL. The proxy URL should not end with a trailing slash."
    );
}
function oP(e) {
  if (e) {
    for (const r in e)
      if (Rw.has(r))
        throw new Oe(
          Ge.ConfigurationError,
          "Invalid additional headers. Some headers are reserved for internal use."
        );
  }
}
var ap = /* @__PURE__ */ ((e) => (e.Current = "current", e))(ap || {});
function xc(e, r) {
  async function t(...n) {
    return await this.preload(), await e.call(this, ...n);
  }
  return t;
}
const op = (e, r) => {
  const t = {
    ...e.webBillingProduct,
    presentedOfferingContext: {
      ...e.webBillingProduct.presentedOfferingContext,
      placementIdentifier: r
    }
  };
  return {
    ...e,
    webBillingProduct: t,
    rcBillingProduct: t
  };
}, _n = (e, r) => e == null ? null : op(e, r), iP = (e, r, t) => {
  const n = e.offering_ids_by_placement ?? null;
  if (n == null)
    return null;
  const a = e.fallback_offering_id ?? null;
  let o;
  if (t in n) {
    const l = n[t] ?? null;
    if (l == null)
      return null;
    o = r[l], o == null && (o = r[a]);
  } else
    o = r[a];
  if (o == null)
    return null;
  const s = Object.fromEntries(
    Object.entries(o.packagesById).map(([l, c]) => [
      l,
      op(c, t)
    ])
  );
  return {
    ...o,
    packagesById: s,
    availablePackages: Object.values(s),
    weekly: _n(o.weekly, t),
    monthly: _n(
      o.monthly,
      t
    ),
    twoMonth: _n(
      o.twoMonth,
      t
    ),
    threeMonth: _n(
      o.threeMonth,
      t
    ),
    sixMonth: _n(
      o.sixMonth,
      t
    ),
    annual: _n(o.annual, t),
    lifetime: _n(
      o.lifetime,
      t
    )
  };
};
function sP(e, r) {
  const t = {};
  r.product_details.forEach((o) => {
    t[o.identifier] = o;
  });
  const n = {};
  e.offerings.forEach((o) => {
    const s = o.identifier === e.current_offering_id, l = Kb(
      s,
      o,
      t,
      e.targeting,
      e.ui_config
    );
    l != null && (n[o.identifier] = l);
  });
  const a = e.current_offering_id ? n[e.current_offering_id] ?? null : null;
  return Object.keys(n).length == 0 && se.debugLog(
    "Empty offerings. Please make sure you've configured offerings correctly in the RevenueCat dashboard and that the products are properly configured."
  ), {
    all: n,
    current: a
  };
}
const lP = 1000001;
function cP(e, r, t) {
  const n = t.formatPrice(e.amountMicros, e.currency);
  return r ? r.unit === ce.Year ? t.formatPrice(
    e.amountMicros / Xs / r.number,
    e.currency
  ) : r.unit === ce.Month ? t.formatPrice(
    e.amountMicros / Yo / r.number,
    e.currency
  ) : r.unit === ce.Week ? t.formatPrice(
    e.amountMicros / $s / r.number,
    e.currency
  ) : r.unit === ce.Day ? t.formatPrice(
    e.amountMicros / r.number,
    e.currency
  ) : n : n;
}
function uP(e, r, t) {
  const n = t.formatPrice(e.amountMicros, e.currency);
  return r ? r.unit === ce.Year ? t.formatPrice(
    e.amountMicros / Zs / r.number,
    e.currency
  ) : r.unit === ce.Month ? t.formatPrice(
    e.amountMicros / Go / r.number,
    e.currency
  ) : r.unit === ce.Week ? t.formatPrice(
    e.amountMicros / r.number,
    e.currency
  ) : r.unit === ce.Day ? t.formatPrice(
    e.amountMicros * $s / r.number,
    e.currency
  ) : n : n;
}
function dP(e, r, t) {
  return r ? r.unit === ce.Year ? t.formatPrice(
    e.amountMicros / Ko,
    e.currency
  ) : r.unit === ce.Month ? t.formatPrice(
    e.amountMicros / r.number,
    e.currency
  ) : r.unit === ce.Week ? t.formatPrice(
    e.amountMicros * Go / r.number,
    e.currency
  ) : r.unit === ce.Day ? t.formatPrice(
    e.amountMicros * Yo / r.number,
    e.currency
  ) : t.formatPrice(
    e.amountMicros / (r.number || 1),
    e.currency
  ) : t.formatPrice(e.amountMicros, e.currency);
}
function pP(e, r, t) {
  const n = t.formatPrice(e.amountMicros, e.currency);
  return r ? r.unit === ce.Year ? t.formatPrice(
    e.amountMicros / r.number,
    e.currency
  ) : r.unit === ce.Month ? t.formatPrice(
    e.amountMicros * Ko / r.number,
    e.currency
  ) : r.unit === ce.Week ? t.formatPrice(
    e.amountMicros * Zs / r.number,
    e.currency
  ) : r.unit === ce.Day ? t.formatPrice(
    e.amountMicros * Xs / r.number,
    e.currency
  ) : n : n;
}
function ip(e, r, t) {
  return {
    pricePerDay: cP(e, r, t),
    pricePerWeek: uP(e, r, t),
    pricePerMonth: dP(e, r, t),
    pricePerYear: pP(e, r, t)
  };
}
function _P(e, r) {
  const t = /* @__PURE__ */ new Date();
  switch (e.unit) {
    case ce.Year:
      t.setFullYear(t.getFullYear() + e.number);
      break;
    case ce.Month:
      t.setMonth(t.getMonth() + e.number);
      break;
    case ce.Week:
      t.setDate(t.getDate() + e.number * 7);
      break;
    case ce.Day:
      t.setDate(t.getDate() + e.number);
      break;
  }
  return r.translateDate(t, { dateStyle: "long" }) ?? "";
}
function gP(e, r, t) {
  const n = e.discount ?? e.trial ?? e.introPrice, a = e.trial && !e.discount ? e.introPrice : null;
  if (n === null)
    return;
  const { period: o, price: s } = n;
  if (s !== null) {
    const l = ip(s, o, r);
    t["product.offer_price"] = r.formatPrice(
      s.amountMicros,
      s.currency
    ), t["product.offer_price_per_day"] = l.pricePerDay, t["product.offer_price_per_week"] = l.pricePerWeek, t["product.offer_price_per_month"] = l.pricePerMonth, t["product.offer_price_per_year"] = l.pricePerYear;
  }
  if (o !== null) {
    const l = as(o, r);
    t["product.offer_period"] = l.period, t["product.offer_period_abbreviated"] = l.periodAbbreviated, t["product.offer_period_with_unit"] = l.periodWithUnit, t["product.offer_period_in_days"] = l.periodInDays, t["product.offer_period_in_weeks"] = l.periodInWeeks, t["product.offer_period_in_months"] = l.periodInMonths, t["product.offer_period_in_years"] = l.periodInYears, t["product.offer_end_date"] = _P(o, r);
  }
  if (a !== null && (a.price !== null && (t["product.secondary_offer_price"] = r.formatPrice(
    a.price.amountMicros,
    a.price.currency
  )), a.period !== null)) {
    const l = as(a.period, r);
    t["product.secondary_offer_period"] = l.period, t["product.secondary_offer_period_abbreviated"] = l.periodAbbreviated;
  }
}
function fP(e, r, t) {
  var a;
  const n = ((a = e.discount) == null ? void 0 : a.price) ?? null;
  n !== null && (t["product.offer_price"] = r.formatPrice(
    n.amountMicros,
    n.currency
  ));
}
function Ec(e, r = {}) {
  var a;
  if (r.translator)
    return Tc(e, r.translator);
  const t = ((a = e.paywallComponents) == null ? void 0 : a.default_locale) || Ar, n = new En(
    r.customTranslations ?? {},
    r.selectedLocale ?? t,
    r.fallbackLocale ?? t
  );
  return Tc(e, n);
}
function Do(e) {
  var a;
  const r = e.webBillingProduct.price, t = sp(e), n = e.webBillingProduct.period || ((a = t == null ? void 0 : t.base) == null ? void 0 : a.period);
  if (!n || !n.number || n.number <= 0)
    return r.amountMicros;
  switch (n.unit) {
    case ce.Year:
      return r.amountMicros / Ko;
    case ce.Month:
      return r.amountMicros / n.number;
    case ce.Week:
      return r.amountMicros * Go / n.number;
    case ce.Day:
      return r.amountMicros * Yo / n.number;
    default:
      return r.amountMicros / (n.number || 1);
  }
}
function sp(e) {
  return e.webBillingProduct.productType === ct.Subscription ? e.webBillingProduct.defaultSubscriptionOption : e.webBillingProduct.productType === ct.NonConsumable || e.webBillingProduct.productType === ct.Consumable ? e.webBillingProduct.defaultNonSubscriptionOption : e.webBillingProduct.defaultPurchaseOption;
}
function mP(e, r) {
  return e === ct.Subscription && r != null;
}
function hP(e, r) {
  return e !== ct.Subscription && r != null;
}
function Sc(e, r, t, n = !1) {
  return t.translate(Z.PaywallVariablesPricePerPeriod, {
    formattedPrice: e,
    period: r.base.period ? r.base.period.number === 1 ? t.translatePeriodUnit(r.base.period.unit, {
      noWhitespace: !0,
      short: !n
    }) : t.translatePeriod(
      r.base.period.number,
      r.base.period.unit,
      {
        noWhitespace: !0,
        short: !n
      }
    ) : ""
  });
}
function Tc(e, r) {
  const t = e.availablePackages, n = t.filter(
    (o) => o.webBillingProduct.productType === ct.Subscription
  ), a = n.length > 0 ? n.reduce((o, s) => {
    const l = Do(o), c = Do(s);
    return l > c ? o : s;
  }) : null;
  return t.reduce(
    (o, s) => (o[s.identifier] = yP(
      s,
      a,
      r
    ), o),
    {}
  );
}
function yP(e, r, t) {
  const n = e.webBillingProduct, a = n.price, o = t.formatPrice(
    a.amountMicros,
    a.currency
  ), s = sp(e), l = n.productType, c = {
    "product.store_product_name": n.title,
    "product.price": o,
    "product.price_per_period": "",
    "product.price_per_period_abbreviated": "",
    "product.price_per_day": "",
    "product.price_per_week": "",
    "product.price_per_month": "",
    "product.price_per_year": "",
    "product.period": "",
    "product.period_abbreviated": "",
    "product.periodly": "",
    "product.period_in_days": "",
    "product.period_in_weeks": "",
    "product.period_in_months": "",
    "product.period_in_years": "",
    "product.period_with_unit": "",
    "product.currency_code": a.currency,
    "product.currency_symbol": t.formatPrice(0, a.currency).replace("0", ""),
    "product.offer_price": "",
    "product.offer_price_per_day": "",
    "product.offer_price_per_week": "",
    "product.offer_price_per_month": "",
    "product.offer_price_per_year": "",
    "product.offer_period": "",
    "product.offer_period_abbreviated": "",
    "product.offer_period_in_days": "",
    "product.offer_period_in_weeks": "",
    "product.offer_period_in_months": "",
    "product.offer_period_in_years": "",
    "product.offer_period_with_unit": "",
    "product.offer_end_date": "",
    "product.secondary_offer_price": "",
    "product.secondary_offer_period": "",
    "product.secondary_offer_period_abbreviated": "",
    "product.relative_discount": ""
  };
  if (mP(l, s)) {
    c["product.price_per_period_abbreviated"] = Sc(
      o,
      s,
      t
    ), c["product.price_per_period"] = Sc(
      o,
      s,
      t,
      !0
    );
    const u = n.period || s.base.period, d = ip(
      a,
      u,
      t
    );
    if (c["product.price_per_day"] = d.pricePerDay, c["product.price_per_week"] = d.pricePerWeek, c["product.price_per_month"] = d.pricePerMonth, c["product.price_per_year"] = d.pricePerYear, u) {
      const p = as(u, t);
      c["product.period"] = p.period, c["product.period_abbreviated"] = p.periodAbbreviated, c["product.period_with_unit"] = p.periodWithUnit, c["product.period_in_days"] = p.periodInDays, c["product.period_in_weeks"] = p.periodInWeeks, c["product.period_in_months"] = p.periodInMonths, c["product.period_in_years"] = p.periodInYears, c["product.periodly"] = t.translatePeriodFrequency(
        u.number,
        u.unit
      ) || "";
    }
    if (r) {
      const p = Do(e), _ = Do(r), g = (_ - p) * 100 / _;
      c["product.relative_discount"] = g < 1 ? "" : t.translate(
        Z.PaywallVariablesSubRelativeDiscount,
        {
          discount: g.toFixed(0)
        }
      );
    }
    gP(s, t, c);
  }
  return hP(l, s) && (c["product.price"] = o, c["product.price_per_period"] = o, c["product.price_per_period_abbreviated"] = o, c["product.price_per_month"] = o, c["product.period_with_unit"] = t.translate(
    Z.PeriodsLifetime
  ), c["product.period_in_months"] = t.translate(
    Z.PeriodsLifetime
  ), c["product.periodly"] = t.translate(
    Z.PeriodsLifetime
  ), c["product.price_per_week"] = "", c["product.relative_discount"] = "", c["product.period"] = "", c["product.period_abbreviated"] = "", fP(s, t, c)), c;
}
var bP = /(%?)(%([sdijo]))/g;
function vP(e, r) {
  switch (r) {
    case "s":
      return e;
    case "d":
    case "i":
      return Number(e);
    case "j":
      return JSON.stringify(e);
    case "o": {
      if (typeof e == "string")
        return e;
      const t = JSON.stringify(e);
      return t === "{}" || t === "[]" || /^\[object .+?\]$/.test(t) ? e : t;
    }
  }
}
function Js(e, ...r) {
  if (r.length === 0)
    return e;
  let t = 0, n = e.replace(
    bP,
    (a, o, s, l) => {
      const c = r[t], u = vP(c, l);
      return o ? a : (t++, u);
    }
  );
  return t < r.length && (n += ` ${r.slice(t).join(" ")}`), n = n.replace(/%{2,2}/g, "%"), n;
}
var kP = 2;
function wP(e) {
  if (!e.stack)
    return;
  const r = e.stack.split(`
`);
  r.splice(1, kP), e.stack = r.join(`
`);
}
var PP = class extends Error {
  constructor(e, ...r) {
    super(e), this.message = e, this.name = "Invariant Violation", this.message = Js(e, ...r), wP(this);
  }
}, lp = (e, r, ...t) => {
  if (!e)
    throw new PP(r, ...t);
};
lp.as = (e, r, t, ...n) => {
  if (!r) {
    const a = n.length === 0 ? t : Js(t, ...n);
    let o;
    try {
      o = Reflect.construct(e, [
        a
      ]);
    } catch {
      o = e(a);
    }
    throw o;
  }
};
const xP = "[MSW]";
function Qs(e, ...r) {
  const t = Js(e, ...r);
  return `${xP} ${t}`;
}
function EP(e, ...r) {
  console.warn(Qs(e, ...r));
}
function SP(e, ...r) {
  console.error(Qs(e, ...r));
}
const TP = {
  formatMessage: Qs,
  warn: EP,
  error: SP
};
function IP() {
  lp(
    typeof URL < "u",
    TP.formatMessage(
      `Global "URL" class is not defined. This likely means that you're running MSW in an environment that doesn't support all Node.js standard API (e.g. React Native). If that's the case, please use an appropriate polyfill for the "URL" class, like "react-native-url-polyfill".`
    )
  );
}
var cp = /* @__PURE__ */ ((e) => (e.HEAD = "HEAD", e.GET = "GET", e.POST = "POST", e.PUT = "PUT", e.PATCH = "PATCH", e.OPTIONS = "OPTIONS", e.DELETE = "DELETE", e))(cp || {});
IP();
class DP {
  constructor(r, t, n, a) {
    U(this, "initialDelay");
    U(this, "maxDelay");
    U(this, "jitterPercent");
    U(this, "callback");
    U(this, "currentDelay");
    U(this, "timeoutId");
    U(this, "executingCallback", !1);
    U(this, "stopped", !1);
    U(this, "currentFlushPromise", null);
    this.initialDelay = r, this.currentDelay = r, this.maxDelay = t, this.jitterPercent = n, this.callback = a;
  }
  tryFlush() {
    if (!this.stopped) {
      if (this.backingOff()) {
        se.debugLog("Backing off, not flushing");
        return;
      }
      this.clearTimeout(), this.executeCallbackWithRetries().catch(() => {
      });
    }
  }
  start() {
    this.stopped = !1, this.currentDelay = this.initialDelay;
  }
  stop() {
    this.stopped = !0, this.clearTimeout();
  }
  /**
   * Clears any scheduled flush and runs the callback once.
   * Returns the callback result (true = queue empty).
   * Runs the callback even when stopped (used by flushUntilDrain).
   */
  flushImmediately(r) {
    return this.clearTimeout(), this.executeCallbackWithRetries(r);
  }
  /**
   * Waits for any in-flight flush, then stops scheduling, runs the callback until it reports queue empty (or throws), then starts again.
   */
  async flushUntilDrain(r) {
    const t = this.currentFlushPromise;
    if (t)
      try {
        await t;
      } catch {
      }
    this.stop();
    try {
      let n = !1;
      for (; !n; )
        n = await this.flushImmediately(r);
    } finally {
      this.start();
    }
  }
  schedule(r) {
    if (this.stopped || this.timeoutId !== void 0)
      return;
    const t = this.addJitter(r || this.currentDelay);
    this.timeoutId = setTimeout(() => {
      this.timeoutId = void 0, this.executeCallbackWithRetries().catch(() => {
      });
    }, t);
  }
  backoff() {
    const r = this.currentDelay, t = Math.min(this.currentDelay * 2, this.maxDelay);
    se.debugLog(`Backing next off to ${r}ms delay`), this.clearTimeout(), this.currentDelay = t, this.schedule(r);
  }
  reset() {
    this.currentDelay !== this.initialDelay && (this.clearTimeout(), this.currentDelay = this.initialDelay);
  }
  async executeCallbackWithRetries(r) {
    if (this.executingCallback)
      return se.debugLog("Callback already running, rescheduling"), this.schedule(), !0;
    this.executingCallback = !0;
    let t;
    try {
      t = Promise.resolve(this.callback(r));
    } catch (n) {
      t = Promise.reject(n);
    }
    this.currentFlushPromise = t.then(
      () => {
      },
      () => {
      }
    );
    try {
      const n = await t;
      return this.reset(), n;
    } catch {
      return this.backoff(), !0;
    } finally {
      this.executingCallback = !1, this.currentFlushPromise = null;
    }
  }
  backingOff() {
    return this.currentDelay > this.initialDelay;
  }
  clearTimeout() {
    clearTimeout(this.timeoutId), this.timeoutId = void 0;
  }
  addJitter(r) {
    const t = r * this.jitterPercent, n = r - t, a = r + t;
    return Math.floor(Math.random() * (a - n + 1) + n);
  }
}
function lo() {
  if (typeof window < "u")
    return window;
  throw new Oe(
    Ge.UnsupportedError,
    "window is not available. This SDK requires a browser environment for this operation."
  );
}
function Co() {
  if (typeof window < "u")
    return window;
}
function ds() {
  if (typeof document < "u")
    return document;
  throw new Oe(
    Ge.UnsupportedError,
    "document is not available. This SDK requires a browser environment for this operation."
  );
}
function CP() {
  if (typeof document < "u")
    return document;
}
function AP(e, r) {
  const t = Co(), n = t != null && t.location ? new URLSearchParams(t.location.search) : new URLSearchParams();
  let a = null, o = null;
  typeof screen < "u" && screen && (a = screen.width, o = screen.height);
  const s = CP(), l = (s == null ? void 0 : s.referrer) ?? null, c = (s == null ? void 0 : s.title) ?? null;
  return {
    libraryName: "purchases-js",
    libraryVersion: Yd,
    locale: navigator.language,
    userAgent: navigator.userAgent,
    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    screenWidth: a,
    screenHeight: o,
    utmSource: n.get("utm_source") ?? null,
    utmMedium: n.get("utm_medium") ?? null,
    utmCampaign: n.get("utm_campaign") ?? null,
    utmContent: n.get("utm_content") ?? null,
    utmTerm: n.get("utm_term") ?? null,
    pageReferrer: l,
    pageUrl: t != null && t.location ? `${t.location.origin}${t.location.pathname}` : "",
    pageTitle: c,
    source: e,
    rcSource: r
  };
}
const qP = 2e3, FP = 5 * 6e4, zP = 0.1, Ic = 50 * 1024;
class MP {
  constructor(r) {
    U(this, "apiKey");
    U(this, "eventsQueue", []);
    U(this, "eventsUrl");
    U(this, "flushManager");
    U(this, "traceId");
    U(this, "appUserId");
    U(this, "isSilent");
    U(this, "rcSource");
    U(this, "workflowContext");
    U(this, "isDisposed", !1);
    var t;
    this.apiKey = r.apiKey, this.eventsUrl = `${((t = r.httpConfig) == null ? void 0 : t.eventsURL) ?? jw}/v1/events`, this.appUserId = r.appUserId, this.isSilent = r.silent || !1, this.rcSource = r.rcSource, this.workflowContext = r.workflowContext, this.traceId = r.trace_id || qa(), this.flushManager = new DP(
      qP,
      FP,
      zP,
      this.doFlush.bind(this)
    );
  }
  async updateUser(r) {
    this.appUserId = r;
  }
  getTraceId() {
    return this.traceId;
  }
  trackSDKEvent(r) {
    this.trackEvent({ ...r, source: "sdk" });
  }
  trackExternalEvent(r) {
    this.trackEvent({ ...r });
  }
  trackEvent(r) {
    var t;
    if (this.isSilent) {
      se.verboseLog("Skipping event tracking, the EventsTracker is silent");
      return;
    }
    try {
      const n = new By({
        eventName: r.eventName,
        traceId: this.traceId,
        appUserId: this.appUserId,
        context: AP(r.source, this.rcSource),
        workflowIdentifier: (t = this.workflowContext) == null ? void 0 : t.workflowIdentifier,
        properties: r.properties || {
          mode: Tr
        }
      });
      this.eventsQueue.push(n), this.flushManager.tryFlush();
    } catch (n) {
      se.errorLog(
        `Error while tracking event ${r.eventName}: ${n}`
      );
    }
  }
  dispose() {
    this.isDisposed || (this.flushManager.stop(), this.eventsQueue.length > 0 && this.flushManager.flushUntilDrain({ ignoreDisposed: !0 }).catch((r) => {
      se.debugLog(`Failed to flush events on dispose: ${r}`);
    }), this.isDisposed = !0);
  }
  async flushAllEvents() {
    this.isDisposed || (await this.flushManager.flushUntilDrain(), !this.isDisposed && this.eventsQueue.length > 0 && this.flushManager.schedule());
  }
  estimateSingleEventSize(r) {
    try {
      return JSON.stringify(r).length;
    } catch {
      return Ic;
    }
  }
  /**
   * Builds a batch of events that fits within browser keepalive size limit.
   * Browsers impose ~64KB limit on fetch() requests with keepalive:true.
   * https://developer.mozilla.org/en-US/docs/Web/API/RequestInit#keepalive
   * Returns null if the first event exceeds the limit (and removes it from queue).
   */
  batchEventsForKeepalive() {
    const r = [];
    let t = 16;
    for (const n of this.eventsQueue) {
      const a = this.estimateSingleEventSize(n), o = r.length > 0 ? 1 : 0, s = t + a + o;
      if (s <= Ic)
        r.push(n), t = s;
      else {
        if (r.length === 0)
          return se.warnLog(
            `Event exceeds keepalive size limit (${a} bytes): ${n.data.eventName}`
          ), this.eventsQueue.shift(), null;
        break;
      }
    }
    return r;
  }
  doFlush(r) {
    if (!(r != null && r.ignoreDisposed) && this.isDisposed || this.eventsQueue.length === 0)
      return Promise.resolve(!0);
    const t = this.batchEventsForKeepalive();
    return t ? fetch(this.eventsUrl, {
      method: cp.POST,
      headers: np(this.apiKey),
      body: JSON.stringify({ events: t }),
      keepalive: !0
    }).then((n) => {
      if (n.status === 200 || n.status === 201)
        return this.eventsQueue.splice(0, t.length), this.eventsQueue.length > 0 && this.flushManager.schedule(), this.eventsQueue.length === 0;
      throw se.debugLog("Events failed to flush due to server error"), new Error("Events failed to flush due to server error");
    }).catch((n) => {
      throw se.debugLog("Error while flushing events"), n;
    }) : Promise.resolve(this.eventsQueue.length === 0);
  }
}
const Ai = () => {
  const e = Co(), r = e != null && e.location ? new URLSearchParams(e.location.search) : new URLSearchParams(), t = [
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_term",
    "utm_content"
  ], n = {};
  return t.forEach((a) => {
    const o = r.get(a);
    o !== null && (n[a] = o);
  }), n;
}, jP = ["app", "embedded"], qi = {
  autoCollectUTMAsMetadata: !0,
  collectAnalyticsEvents: !0
};
var NP = /* @__PURE__ */ B('<p class="svelte-17914yi"><strong>Free Trial:</strong> </p>'), OP = /* @__PURE__ */ B('<p class="svelte-17914yi"><strong>Intro Price:</strong> </p>'), LP = /* @__PURE__ */ B('<p class="svelte-17914yi"><strong>Discount Price:</strong> </p>'), BP = /* @__PURE__ */ B('<div class="rc-simulated-store-modal-overlay svelte-17914yi"><div class="rc-simulated-store-modal svelte-17914yi"><div class="rc-simulated-store-modal-content svelte-17914yi"><h2 class="rc-simulated-store-modal-title svelte-17914yi">Test Store Purchase</h2> <div class="rc-simulated-store-modal-details svelte-17914yi"><div><p class="svelte-17914yi"><strong>Product:</strong> </p> <p class="svelte-17914yi"><strong>Type:</strong> </p> <p class="svelte-17914yi"><strong>Price:</strong> </p> <!> <!> <!></div></div> <div class="rc-simulated-store-modal-buttons svelte-17914yi"><button type="button" class="rc-simulated-store-modal-button rc-simulated-store-modal-button-primary svelte-17914yi">Test valid purchase</button> <button type="button" class="rc-simulated-store-modal-button rc-simulated-store-modal-button-secondary svelte-17914yi">Test failed purchase</button> <button type="button" class="rc-simulated-store-modal-button rc-simulated-store-modal-button-cancel svelte-17914yi">Cancel</button></div></div></div></div>');
const UP = {
  hash: "svelte-17914yi",
  code: `.rc-simulated-store-modal-overlay.svelte-17914yi {position:fixed;top:0;left:0;width:100%;height:100%;background-color:rgba(0, 0, 0, 0.5);display:flex;justify-content:center;align-items:center;
    /** One more than the paywall */z-index:1000002;}.rc-simulated-store-modal.svelte-17914yi {background:white;border-radius:8px;padding:0;max-width:500px;width:90%;max-height:90%;overflow-y:auto;box-shadow:0 4px 20px rgba(0, 0, 0, 0.15);}.rc-simulated-store-modal-content.svelte-17914yi {padding:24px;}.rc-simulated-store-modal-title.svelte-17914yi {margin:0 0 20px 0;font-size:24px;font-weight:600;color:#333;}.rc-simulated-store-modal-details.svelte-17914yi {margin-bottom:24px;}.rc-simulated-store-modal-details.svelte-17914yi p:where(.svelte-17914yi) {margin:8px 0;color:#666;line-height:1.5;}.rc-simulated-store-modal-buttons.svelte-17914yi {display:flex;flex-direction:column;gap:12px;}.rc-simulated-store-modal-button.svelte-17914yi {padding:12px 24px;border:none;border-radius:6px;font-size:16px;font-weight:500;cursor:pointer;transition:background-color 0.2s ease;}.rc-simulated-store-modal-button-primary.svelte-17914yi {background-color:#007aff;color:white;}.rc-simulated-store-modal-button-primary.svelte-17914yi:hover {background-color:#0056cc;}.rc-simulated-store-modal-button-secondary.svelte-17914yi {background-color:#ff3b30;color:white;}.rc-simulated-store-modal-button-secondary.svelte-17914yi:hover {background-color:#cc2e24;}.rc-simulated-store-modal-button-cancel.svelte-17914yi {background-color:#f2f2f7;color:#333;}.rc-simulated-store-modal-button-cancel.svelte-17914yi:hover {background-color:#e5e5ea;}

  /* Mobile responsive - full screen on small screens */
  @media (max-width: 768px) {.rc-simulated-store-modal-overlay.svelte-17914yi {padding:0;}.rc-simulated-store-modal.svelte-17914yi {width:100%;height:100%;border-radius:0;max-width:none;max-height:none;}.rc-simulated-store-modal-content.svelte-17914yi {height:100%;display:flex;flex-direction:column;justify-content:center;}
  }`
};
function RP(e, r) {
  re(r, !1), ie(e, UP);
  let t = K(r, "productIdentifier", 8), n = K(r, "productType", 8), a = K(r, "basePrice", 8), o = K(r, "freeTrialPeriod", 8, void 0), s = K(r, "introPriceFormatted", 8, void 0), l = K(r, "discountFormatted", 8, void 0), c = K(r, "onValidPurchase", 8), u = K(r, "onFailedPurchase", 8), d = K(r, "onCancel", 8);
  function p(C) {
    C.target === C.currentTarget && d()();
  }
  Dn();
  var _ = BP(), g = F(_), f = F(g), w = V(F(f), 2), k = F(w), m = F(k), h = V(F(m)), v = V(m, 2), y = V(F(v)), E = V(v, 2), S = V(F(E)), P = V(E, 2);
  {
    var x = (C) => {
      var z = NP(), G = V(F(z));
      R(() => me(G, ` ${o() ?? ""}`)), T(C, z);
    };
    W(P, (C) => {
      o() && C(x);
    });
  }
  var I = V(P, 2);
  {
    var q = (C) => {
      var z = OP(), G = V(F(z));
      R(() => me(G, ` ${s() ?? ""}`)), T(C, z);
    };
    W(I, (C) => {
      s() && C(q);
    });
  }
  var N = V(I, 2);
  {
    var M = (C) => {
      var z = LP(), G = V(F(z));
      R(() => me(G, ` ${l() ?? ""}`)), T(C, z);
    };
    W(N, (C) => {
      l() && C(M);
    });
  }
  var D = V(w, 2), j = F(D), Y = V(j, 2), A = V(Y, 2);
  R(() => {
    me(h, ` ${t() ?? ""}`), me(y, ` ${n() ?? ""}`), me(S, ` ${a() ?? ""}`);
  }), Ur("click", j, function(...C) {
    var z;
    (z = c()) == null || z.apply(this, C);
  }), Ur("click", Y, function(...C) {
    var z;
    (z = u()) == null || z.apply(this, C);
  }), Ur("click", A, function(...C) {
    var z;
    (z = d()) == null || z.apply(this, C);
  }), Ur("click", _, p), T(e, _), te();
}
async function up(e, r, t, n) {
  const a = /* @__PURE__ */ new Date(), o = `test_${a.getTime()}_${qa()}`, s = `test_store_operation_session_${qa()}`, c = {
    storeTransactionId: o,
    productIdentifier: e.identifier,
    purchaseDate: a
  }, u = await r.postReceipt(
    t,
    e.identifier,
    e.price.currency,
    o,
    e.presentedOfferingContext,
    "purchase",
    n
  );
  return {
    customerInfo: ls(u),
    redemptionInfo: null,
    operationSessionId: s,
    storeTransaction: c
  };
}
function VP(e, r, t) {
  const n = e.rcPackage.webBillingProduct, a = n.productType, o = n.freeTrialPhase, s = n.introPricePhase, l = n.discountPhase, c = n.price, u = (d) => d ? `${d.number} ${d.unit}${d.number > 1 ? "s" : ""}` : "N/A";
  return new Promise((d, p) => {
    var k, m;
    const _ = ds(), g = _.createElement("div");
    _.body.appendChild(g);
    const f = () => {
      w && _o(w), _.body.removeChild(g);
    };
    let w = null;
    w = Ea(RP, {
      target: g,
      props: {
        productIdentifier: n.identifier,
        productType: a,
        basePrice: c.formattedPrice,
        freeTrialPeriod: o ? u(o.period) : void 0,
        introPriceFormatted: (k = s == null ? void 0 : s.price) == null ? void 0 : k.formattedPrice,
        discountFormatted: (m = l == null ? void 0 : l.price) == null ? void 0 : m.formattedPrice,
        onValidPurchase: async () => {
          f(), se.debugLog(
            "[Test store] Performing test purchase. This purchase won't appear in production."
          );
          try {
            d(
              await up(
                n,
                r,
                t,
                e.paywallId
              )
            );
          } catch (h) {
            p(h);
          }
        },
        onFailedPurchase: () => {
          f(), se.debugLog(
            "[Test store] Purchase failure simulated successfully in Test Store."
          ), p(
            new Oe(
              Ge.TestStoreSimulatedPurchaseError,
              Kn.getPublicMessage(
                Ge.TestStoreSimulatedPurchaseError
              ),
              "Simulated error successfully."
            )
          );
        },
        onCancel: () => {
          f(), p(new Oe(Ge.UserCancelledError));
        }
      }
    });
  });
}
class HP {
  constructor() {
    U(this, "virtualCurrenciesCache", /* @__PURE__ */ new Map());
    U(this, "CACHE_EXPIRY_MS", 5 * 60 * 1e3);
  }
  // 5 minutes
  invalidateAllCaches() {
    this.virtualCurrenciesCache.clear();
  }
  cacheVirtualCurrencies(r, t) {
    this.virtualCurrenciesCache.set(r, {
      data: t,
      lastUpdatedAt: Date.now()
    });
  }
  /**
   * Retrieves cached virtual currencies for a given app user.
   *
   * @param appUserID - The unique identifier for the app user
   * @param allowStaleCache - If true, returns cached data regardless of age; if false, respects cache expiry
   * @returns The cached virtual currencies or null if not found or expired
   */
  getCachedVirtualCurrencies(r, t = !1) {
    const n = this.virtualCurrenciesCache.get(r);
    return this.getCachedData(n ?? null, t);
  }
  invalidateVirtualCurrenciesCache(r) {
    this.virtualCurrenciesCache.delete(r);
  }
  /**
   * Generic method to retrieve cached data with expiry checking.
   *
   * @param entry - The cache entry containing the data and timestamp
   * @param allowStaleCache - If true, bypasses expiry checks and returns data regardless of age
   * @returns The cached data or null if not found or expired (when allowStaleCache is false)
   */
  getCachedData(r, t = !1) {
    return r ? t ? r.data : Date.now() - r.lastUpdatedAt >= this.CACHE_EXPIRY_MS ? null : r.data : null;
  }
}
function WP(e) {
  return {
    balance: e.balance,
    name: e.name,
    code: e.code,
    serverDescription: e.description ?? null
  };
}
function YP(e) {
  const r = {};
  for (const [t, n] of Object.entries(
    e.virtual_currencies
  ))
    r[t] = WP(n);
  return {
    all: r
  };
}
function GP(e) {
  const r = e.webBillingProduct, t = r.productType === ct.Subscription, n = r.defaultSubscriptionOption;
  if (t && n)
    return {
      hasTrial: n.trial !== null,
      hasIntroOffer: n.discount !== null || n.introPrice !== null
    };
  const a = r.defaultNonSubscriptionOption;
  return !t && a ? {
    hasTrial: !1,
    hasIntroOffer: a.discount !== null
  } : {};
}
function KP(e) {
  const r = Object.entries(e.packagesById).map(
    ([t, n]) => [t, GP(n)]
  );
  return Object.fromEntries(r);
}
const $P = (e, r) => {
  var n;
  const t = ((n = e.subscriptionOptions) == null ? void 0 : n[r]) || e.defaultSubscriptionOption;
  if (!t)
    throw new ae(ee.ErrorSettingUpPurchase);
  return t;
}, XP = (e, r) => {
  const t = Ks(
    e,
    r
  );
  return {
    currency: t.currency,
    taxCalculationStatus: "unavailable",
    totalAmountInMicros: t.amountMicros,
    totalExcludingTaxInMicros: t.amountMicros,
    taxAmountInMicros: null,
    taxBreakdown: null
  };
}, ZP = (e, r) => {
  const t = $P(
    e,
    r
  ), n = XP(
    e,
    t
  );
  return { subscriptionOption: t, priceBreakdown: n };
}, dp = (e, r, t, n) => {
  const a = e.webBillingProduct, { subscriptionOption: o, priceBreakdown: s } = ZP(a, r.id);
  return We.buildStripeExpressCheckoutOptionsForSubscription(
    a,
    s,
    o,
    n,
    t,
    2,
    1
  );
}, Dc = (e, r, t, n, a, o) => {
  if (!r.elements_configuration)
    throw new ae(ee.ErrorSettingUpPurchase);
  return We.updateElementsConfiguration(
    e,
    r.elements_configuration
  ), { expOptions: dp(
    n,
    a,
    t,
    o
  ) };
}, JP = async (e, r, t, n, a, o) => {
  var k, m;
  if (!e.elements_configuration)
    throw new ae(ee.ErrorSettingUpPurchase);
  const s = e.stripe_account_id, l = e.publishable_api_key, c = We.getStripeLocale(
    a.bcp47Locale || a.fallbackBcp47Locale
  ), u = {
    // Floating labels size cannot be overriden in Stripe since `!important` is being used.
    // There we set fontSizeBase to the desired label size
    // and update the input font size to 16px.
    fontSizeBase: "14px",
    fontFamily: Fa,
    // Spacing is hardcoded to 16px to match the desired gaps in mobile/desktop
    // which do not match the design system spacing. Also we cannot use "rem" units
    // since the fontSizeBase is set to 14px per the comment above.
    spacingGridRow: "16px"
  }, d = ((k = Co()) == null ? void 0 : k.matchMedia) && ((m = Co()) == null ? void 0 : m.matchMedia("(max-width: 767px)").matches);
  let p = "mobile";
  if (d ? p = "mobile" : p = "desktop", !s || !l)
    throw new ae(ee.ErrorSettingUpPurchase);
  const _ = e.elements_configuration, { stripe: g, elements: f } = await We.initializeStripe(
    s,
    l,
    _,
    o,
    c,
    u,
    p
  ), w = dp(
    t,
    n,
    r,
    a
  );
  return { stripeInstance: g, elementsInstance: f, expOptions: w };
};
var QP = /* @__PURE__ */ B("<div><!></div>");
function e1(e, r) {
  var P;
  re(r, !0);
  const t = "express_purchase_button";
  let n = Vr(r.translator);
  ir(vr, n), ir(Xa, (P = r.brandingInfo) == null ? void 0 : P.appearance);
  let a = /* @__PURE__ */ X(!0), o = /* @__PURE__ */ X(!1), s = /* @__PURE__ */ X(null), l = /* @__PURE__ */ X(null), c = /* @__PURE__ */ X(null);
  const u = (x) => {
    const I = bd({
      errorCode: x.getErrorCode().toString(),
      errorMessage: x.message,
      mode: t
    });
    r.eventsTracker.trackSDKEvent(I), r.onError(x);
  };
  let d = !1;
  const p = async () => {
    if (d)
      return;
    d = !0;
    let x;
    try {
      x = await r.purchaseOperationHelper.prepareCheckout(r.rcPackage.webBillingProduct.identifier, r.purchaseOption);
    } catch (q) {
      u(q);
      return;
    }
    if (!x.stripe_gateway_params) {
      const q = new ae(ee.ErrorSettingUpPurchase, "We couldn’t download Stripe params for this purchase. Please try again.");
      u(q);
      return;
    }
    const I = "http://blank";
    try {
      if (!i(l) || !i(s)) {
        const { stripeInstance: q, elementsInstance: N, expOptions: M } = await JP(x.stripe_gateway_params, I, r.rcPackage, r.purchaseOption, r.translator, r.brandingInfo);
        L(l, q, !0), L(s, N, !0), L(c, M, !0);
      } else {
        const { expOptions: q } = Dc(i(s), x.stripe_gateway_params, I, r.rcPackage, r.purchaseOption, r.translator);
        L(c, q, !0);
      }
    } catch (q) {
      u(q);
      return;
    }
    L(a, !1);
  };
  xr(() => {
    d = !1, p().then(() => {
    });
  });
  const _ = (x) => {
    const I = Qi({
      errorCode: x.gatewayErrorCode ?? null,
      errorMessage: x.message ?? "",
      mode: t
    });
    r.eventsTracker.trackSDKEvent(I), u(new ae(ee.ErrorSettingUpPurchase, "Failed to initialize payment form", x.message));
  }, g = async (x, I) => {
    var M;
    const {
      customerDetails: q,
      confirmationTokenId: N
    } = await We.extractTaxCustomerDetails(x, I);
    if ((M = r.brandingInfo) != null && M.gateway_tax_collection_enabled) {
      const D = await r.purchaseOperationHelper.checkoutCalculateTax(q.countryCode, q.postalCode), j = kd({ taxCalculation: D, taxCustomerDetails: q, mode: t });
      r.eventsTracker.trackSDKEvent(j);
    }
    return N;
  };
  async function f(x) {
    var M, D;
    if (!i(s) || !i(l)) return !1;
    await We.submitElements(i(s));
    const I = await r.purchaseOperationHelper.checkoutComplete(x), q = (M = I == null ? void 0 : I.gateway_params) == null ? void 0 : M.client_secret;
    if (!q)
      return !1;
    const N = (D = r.brandingInfo) != null && D.gateway_tax_collection_enabled ? await g(i(s), i(l)) : void 0;
    return await We.confirmElements(i(l), i(s), q, N), !0;
  }
  const w = async (x, I, q) => {
    if (i(o))
      return;
    const N = wd({ selectedPaymentMethod: x ?? null, mode: t });
    r.eventsTracker.trackSDKEvent(N), L(o, !0);
    try {
      const M = await f(I);
      if (L(o, !1), !M)
        return;
      const D = await r.purchaseOperationHelper.pollCurrentPurchaseForCompletion();
      r.onFinished(D), L(o, !1);
    } catch (M) {
      if (M instanceof ae)
        u(M);
      else if (M instanceof Gn) {
        const D = Qi({
          errorCode: M.gatewayErrorCode ?? null,
          errorMessage: M.message ?? "",
          mode: t
        });
        r.eventsTracker.trackSDKEvent(D), u(new ae(ee.ErrorSettingUpPurchase, "Failed to complete payment", M.message));
      }
      q.paymentFailed(), L(o, !1);
    }
  }, k = async () => {
    var I;
    const x = Ji({
      appearance: (I = r.brandingInfo) == null ? void 0 : I.appearance,
      rcPackage: r.rcPackage,
      purchaseOptionToUse: r.purchaseOption,
      customerEmail: r.customerEmail,
      mode: "express_purchase_button"
    });
    r.eventsTracker.trackSDKEvent(x);
    try {
      const q = await r.purchaseOperationHelper.checkoutStart(r.appUserId, r.rcPackage.webBillingProduct.identifier, r.purchaseOption, r.rcPackage.webBillingProduct.presentedOfferingContext, r.customerEmail, r.metadata), N = q.management_url;
      if (!i(s))
        throw new ae(ee.ErrorSettingUpPurchase);
      const { expOptions: M } = Dc(i(s), q.gateway_params, N, r.rcPackage, r.purchaseOption, r.translator);
      return { applePay: M.applePay };
    } catch (q) {
      throw u(q instanceof ae ? q : new ae(ee.ErrorSettingUpPurchase)), q;
    }
  }, m = (x) => {
    k().then((I) => x.resolve(I));
  }, h = () => {
    r.eventsTracker.trackSDKEvent(vd({ mode: "express_purchase_button" }));
  };
  function v(x) {
    var q, N;
    const I = ((q = x.availablePaymentMethods) == null ? void 0 : q.applePay) || ((N = x.availablePaymentMethods) == null ? void 0 : N.googlePay);
    r.onReady && r.onReady(!!I);
  }
  var y = QP(), E = F(y);
  {
    var S = (x) => {
      {
        let I = /* @__PURE__ */ b(() => {
          var q;
          return (q = r.brandingInfo) == null ? void 0 : q.gateway_tax_collection_enabled;
        });
        Dd(x, {
          get elements() {
            return i(s);
          },
          onError: _,
          onSubmit: w,
          onClick: m,
          onCancel: h,
          onReady: v,
          get expressCheckoutOptions() {
            return i(c);
          },
          forceEnableWalletMethods: !1,
          get billingAddressRequired() {
            return i(I);
          },
          hideCheckoutSeparator: !0
        });
      }
    };
    W(E, (x) => {
      !i(a) && i(s) && i(c) && r.brandingInfo && x(S);
    });
  }
  T(e, y), te();
}
var ta;
class r1 {
  constructor(r, t, n) {
    ke(this, ta);
    U(this, "button");
    be(this, ta, /* @__PURE__ */ X($e({ props: n })));
    const o = { updatePurchase: (s, l) => {
      this.changePackage(s, l);
    } };
    this.state.props.onReady = (s) => {
      t(o, s);
    }, this.button = Ea(e1, { target: r, props: this.state.props });
  }
  get state() {
    return i(O(this, ta));
  }
  set state(r) {
    L(O(this, ta), r, !0);
  }
  changePackage(r, t) {
    this.state.props && (this.state.props.rcPackage = r, this.state.props.purchaseOption = t ?? r.webBillingProduct.defaultPurchaseOption);
  }
}
ta = new WeakMap();
var t1 = /* @__PURE__ */ ((e) => (e.DisplayName = "$displayName", e.Email = "$email", e.PhoneNumber = "$phoneNumber", e.IDFA = "$idfa", e.IDFV = "$idfv", e.GPSAdId = "$gpsAdId", e.AndroidId = "$androidId", e.AmazonAdId = "$amazonAdId", e.IP = "$ip", e.AdjustId = "$adjustId", e.AmplitudeDeviceId = "$amplitudeDeviceId", e.AmplitudeUserId = "$amplitudeUserId", e.AppsflyerId = "$appsflyerId", e.AppsflyerSharingFilter = "$appsflyerSharingFilter", e.BranchId = "$branchId", e.BrazeAliasName = "$brazeAliasName", e.BrazeAliasLabel = "$brazeAliasLabel", e.ClevertapId = "$clevertapId", e.FbAnonId = "$fbAnonId", e.MparticleId = "$mparticleId", e.OnesignalId = "$onesignalId", e.OnesignalUserId = "$onesignalUserId", e.IntercomContactId = "$intercomContactId", e.MediaSource = "$mediaSource", e.Campaign = "$campaign", e.AdGroup = "$adGroup", e.AdId = "$ad", e.Keyword = "$keyword", e.Creative = "$creative", e.APNSTokens = "$apnsTokens", e.FCMTokens = "$fcmTokens", e.AirshipChannelId = "$airshipChannelId", e.SegmentId = "$segmentId", e.IterableUserId = "$iterableUserId", e.IterableCampaignId = "$iterableCampaignId", e.IterableTemplateId = "$iterableTemplateId", e.FirebaseAppInstanceId = "$firebaseAppInstanceId", e.MixpanelDistinctId = "$mixpanelDistinctId", e.ATTConsentStatus = "$attConsentStatus", e.KochavaDeviceId = "$kochavaDeviceId", e.DeviceVersion = "$deviceVersion", e.PosthogUserId = "$posthogUserId", e.TelemetryDeckUserId = "$telemetryDeckUserId", e.TelemetryDeckAppId = "$telemetryDeckAppId", e.AppleRefundHandlingPreference = "$appleRefundHandlingPreference", e.CustomerioId = "$customerioId", e.TenjinId = "$tenjinId", e))(t1 || {});
const Cc = "$RCAnonymousID:";
var qc, Fc, co;
Fc = [xc], qc = [xc];
const Je = class Je {
  /** @internal */
  constructor(r, t, n = us, a = qi, o, s) {
    sl(co, 5, this);
    /** @internal */
    U(this, "_API_KEY");
    /** @internal */
    U(this, "_appUserId");
    /** @internal */
    U(this, "_brandingInfo", null);
    /** @internal */
    U(this, "_loadingResourcesPromise", null);
    /** @internal */
    U(this, "_flags");
    /** @internal */
    U(this, "_context");
    /** @internal */
    U(this, "backend");
    /** @internal */
    U(this, "purchaseOperationHelper");
    /** @internal */
    U(this, "eventsTracker");
    /** @internal */
    U(this, "inMemoryCache");
    var l;
    this._API_KEY = r, this._appUserId = t, this._flags = { ...qi, ...a }, this._context = o, Io(r) ? se.debugLog(
      "Initializing Purchases SDK with Web billing sandbox API Key"
    ) : gn(r) && se.debugLog("Initializing Purchases SDK with RC Test store API Key."), this.eventsTracker = new MP({
      apiKey: this._API_KEY,
      appUserId: this._appUserId,
      silent: !this._flags.collectAnalyticsEvents,
      rcSource: this._flags.rcSource ?? null,
      workflowContext: (l = this._context) == null ? void 0 : l.workflowContext,
      trace_id: s,
      httpConfig: n
    }), this.backend = new tP(this._API_KEY, n, this._context), this.inMemoryCache = new HP(), this.purchaseOperationHelper = new ag(
      this.backend,
      this.eventsTracker
    ), this.eventsTracker.trackSDKEvent({
      eventName: Fr.SDKInitialized
    });
  }
  /**
   * Set the log level. Logs of the given level and below will be printed
   * in the console.
   * Default is `LogLevel.Silent` so no logs will be printed in the console.
   * @param logLevel - LogLevel to set.
   */
  static setLogLevel(r) {
    se.setLogLevel(r);
  }
  /**
   * Set a custom log handler to handle SDK log messages with your own logging system.
   * If set to null, the SDK will use the default console logging.
   * @param handler - LogHandler function or null to use default console logging.
   */
  static setLogHandler(r) {
    se.setLogHandler(r);
  }
  /**
   * Meant to be used by RevenueCat hybrids SDKS only.
   * @experimental
   * */
  static setPlatformInfo(r) {
    Je._platformInfo = r;
  }
  /**
   * Build variables for each package in an offering.
   * Used to support Paywalls in Workflows.
   * @internal
   */
  static buildVariablesPerPackage(r, t = {}) {
    return Ec(r, t);
  }
  /** @internal */
  static getPlatformInfo() {
    return Je._platformInfo;
  }
  /**
   * Get the singleton instance of Purchases. It's preferred to use the instance
   * obtained from the `configure` method when possible.
   * @throws {@link UninitializedPurchasesError} if the instance has not been initialized yet.
   */
  static getSharedInstance() {
    if (Je.isConfigured())
      return Je.instance;
    throw new ng();
  }
  /**
   * Returns whether the Purchases SDK is configured or not.
   */
  static isConfigured() {
    return Je.instance !== void 0;
  }
  static configure(r, t, n, a) {
    Je.instance !== void 0 && se.warnLog(
      "Purchases is already initialized. You normally should only configure Purchases once. Creating and returning new instance."
    );
    let o;
    if (typeof r == "object" && r !== null)
      o = r;
    else {
      if (typeof r != "string")
        throw new Oe(
          Ge.ConfigurationError,
          "API key must be provided as a string"
        );
      if (typeof t != "string")
        throw new Oe(
          Ge.ConfigurationError,
          "App user ID must be provided as a string"
        );
      o = {
        apiKey: r,
        appUserId: t,
        httpConfig: n,
        flags: a
      };
    }
    return Je.configureInternal(o), Je.getSharedInstance();
  }
  static configureInternal(r) {
    const { apiKey: t, appUserId: n, httpConfig: a, flags: o, context: s, trace_id: l } = r, c = a ?? us, u = o ?? qi;
    Je.validateConfig(r), We.preloadStripeModule(), Je.instance = new Je(
      t,
      n,
      c,
      u,
      s,
      l
    );
  }
  static validateConfig(r) {
    var t, n;
    nP(r.apiKey), Ci(r.appUserId), aP((t = r.httpConfig) == null ? void 0 : t.proxyURL), oP((n = r.httpConfig) == null ? void 0 : n.additionalHeaders);
  }
  /**
   * Loads and caches some optional data in the Purchases SDK.
   * Currently only fetching branding information.
   * You can call this method after configuring the SDK to speed
   * up the first call to {@link Purchases.purchase}.
   */
  async preload() {
    if (this.hasLoadedResources()) {
      se.verboseLog("Purchases resources are loaded. Skipping.");
      return;
    }
    if (this._loadingResourcesPromise !== null) {
      se.verboseLog("Purchases resources are loading. Waiting."), await this._loadingResourcesPromise;
      return;
    }
    return this._loadingResourcesPromise = this.fetchAndCacheBrandingInfo().catch((r) => {
      let t = `${r}`;
      r instanceof Oe && (t = `${r.message}. ${r.underlyingErrorMessage ? `Underlying error: ${r.underlyingErrorMessage}` : ""}`), se.errorLog(`Error fetching branding info: ${t}`);
    }).finally(() => {
      this._loadingResourcesPromise = null;
    }), this._loadingResourcesPromise;
  }
  /** @internal */
  async fetchAndCacheBrandingInfo() {
    if (gn(this._API_KEY)) {
      se.warnLog(
        "Branding info is not available for RC Test Store API keys."
      );
      return;
    }
    this._brandingInfo = await this.backend.getBrandingInfo();
  }
  /** @internal */
  hasLoadedResources() {
    return this._brandingInfo !== null;
  }
  /**
   * Renders an RC Paywall and allows the user to purchase from it using Web Billing.
   * @param paywallParams - The parameters object to customise the paywall render. Check {@link PresentPaywallParams}
   * @returns Promise<PurchaseResult>
   */
  async presentPaywall(r) {
    const t = r.htmlTarget;
    let n = !1;
    const a = ds();
    let o = t ?? a.getElementById("rcb-ui-pw-root");
    if (o === null) {
      n = !0;
      const h = a.createElement("div");
      h.id = "rcb-ui-pw-root", h.className = "rcb-ui-pw-root", h.style.zIndex = `${lP}`, h.style.position = "fixed", h.style.top = "0", h.style.left = "0", h.style.width = "100%", h.style.height = "100%", h.style.overflow = "auto", h.style.backgroundColor = "rgba(0, 0, 0, 0.4)", a.body.offsetWidth > 968 && (h.style.display = "flex", h.style.justifyContent = "center", h.style.alignItems = "center"), h.style.transition = "opacity 0.3s", h.style.opacity = "0", a.body.appendChild(h), o = h;
    }
    if (o === null)
      throw new Error(
        "Could not generate a mount point for the paywall widget"
      );
    const s = o, l = r.offering ? r.offering : (await this.getOfferings()).current;
    if (!l)
      throw new Error("No offering found.");
    if (!l.paywallComponents)
      throw new Error("This offering doesn't have a paywall attached.");
    if (!l.uiConfig)
      throw new Error(
        "No ui_config found for this offering, please contact support!"
      );
    const c = (h, v) => {
      const y = {}, E = (x) => x.toLowerCase().split("_")[0];
      Object.keys(h.components_localizations).forEach((x) => {
        y[E(x)] === void 0 && (y[E(x)] = []), y[E(x)].push(x);
      });
      const S = y[E(v)];
      if (!S)
        return h.default_locale;
      const P = S.find(
        (x) => x.toLowerCase() === v
      );
      return P || S[0];
    }, u = r.selectedLocale ? r.selectedLocale : navigator.language, d = c(
      l.paywallComponents,
      u
    ), p = new En(
      {},
      d,
      l.paywallComponents.default_locale
    ), _ = async (h) => {
      var E, S;
      const v = l.availablePackages.find(
        (P) => P.identifier === h
      );
      if (v === void 0)
        throw new Error(`No package found for ${h}`);
      return { ...await this.purchase({
        rcPackage: v,
        htmlTarget: r.purchaseHtmlTarget,
        customerEmail: r.customerEmail,
        selectedLocale: d,
        defaultLocale: ((E = l.paywallComponents) == null ? void 0 : E.default_locale) || Ar,
        paywallId: (S = l.paywallComponents) == null ? void 0 : S.id
      }), selectedPackage: v };
    }, g = (h) => {
      var y;
      if (r.onNavigateToUrl) {
        r.onNavigateToUrl(h);
        return;
      }
      (y = lo().open(h, "_blank")) == null || y.focus();
    }, f = () => {
    }, w = () => {
      if (r.onVisitCustomerCenter) {
        r.onVisitCustomerCenter();
        return;
      }
    }, k = Ec(l, {
      translator: p
    }), m = KP(l);
    return new Promise((h, v) => {
      let y = null;
      const E = () => {
        y && _o(y), s.innerHTML = "", n && s.parentNode && s.parentNode.removeChild(s);
      }, S = () => {
        se.debugLog("Purchase cancelled by user"), E(), v(new Oe(Ge.UserCancelledError));
      }, P = cs(this._API_KEY) ? (x, {
        selectedPackageId: I,
        onReady: q
      }) => {
        const N = l.packagesById[I];
        if (!N)
          return {};
        let M = null;
        return this.presentExpressPurchaseButton({
          rcPackage: N,
          customerEmail: r.customerEmail,
          htmlTarget: x,
          onButtonReady: (D, j) => {
            M = D, q == null || q(j);
          }
        }).then((D) => {
          E(), h({ ...D, selectedPackage: N });
        }).catch((D) => {
          se.errorLog(
            `Error presenting express purchase button: ${D}`
          ), r.onPurchaseError && r.onPurchaseError(D);
        }), {
          destroy() {
            x.innerHTML = "";
          },
          update({
            selectedPackageId: D
          }) {
            if (M) {
              const j = l.packagesById[D];
              if (!j)
                return;
              const Y = j.webBillingProduct.defaultPurchaseOption;
              M.updatePurchase(j, Y);
            }
          }
        };
      } : void 0;
      s.innerHTML = "", y = Ea(mh, {
        target: s,
        props: {
          paywallData: l.paywallComponents,
          selectedLocale: d,
          onNavigateToUrlClicked: g,
          onVisitCustomerCenterClicked: w,
          uiConfig: l.uiConfig,
          onBackClicked: () => {
            if (r.onBack) {
              r.onBack(S);
              return;
            }
            S();
          },
          onRestorePurchasesClicked: f,
          onPurchaseClicked: (x) => {
            _(x).then((I) => {
              E(), h(I);
            }).catch((I) => {
              se.errorLog(`Error performing purchase: ${I}`), r.onPurchaseError && r.onPurchaseError(I);
            });
          },
          onError: (x) => {
            E(), v(x);
          },
          variablesPerPackage: k,
          infoPerPackage: m,
          hideBackButtons: r.hideBackButtons,
          walletButtonRender: P,
          customVariables: r.customVariables
        }
      }), s.style.opacity === "0" && (s.style.opacity = "1");
    });
  }
  /**
   * Fetch the configured offerings for this user. You can configure these
   * in the RevenueCat dashboard.
   * @param params - The parameters object to customise the offerings fetch. Check {@link GetOfferingsParams}
   */
  async getOfferings(r) {
    Xk(r == null ? void 0 : r.currency);
    const t = this._appUserId, n = await this.backend.getOfferings(t), a = (r == null ? void 0 : r.offeringIdentifier) === ap.Current ? n.current_offering_id : r == null ? void 0 : r.offeringIdentifier;
    return a && (n.offerings = n.offerings.filter(
      (o) => o.identifier === a
    )), await this.getAllOfferings(n, t, r);
  }
  /**
   * Retrieves a specific offering by a placement identifier.
   * For more info see https://www.revenuecat.com/docs/tools/targeting
   * @param placementIdentifier - The placement identifier to retrieve the offering for.
   * @param params - The parameters object to customise the offerings fetch. Check {@link GetOfferingsParams}
   */
  async getCurrentOfferingForPlacement(r, t) {
    const n = this._appUserId, a = await this.backend.getOfferings(n), o = await this.getAllOfferings(
      a,
      n,
      t
    ), s = a.placements ?? null;
    return s == null ? null : iP(
      s,
      o.all,
      r
    );
  }
  async getAllOfferings(r, t, n) {
    const a = r.offerings.flatMap((s) => s.packages).map((s) => s.platform_product_identifier), o = await this.backend.getProducts(
      t,
      a,
      n == null ? void 0 : n.currency,
      n == null ? void 0 : n.discountCode
    );
    return this.logMissingProductIds(a, o.product_details), sP(r, o);
  }
  /**
   * Convenience method to check whether a user is entitled to a specific
   * entitlement. This will use {@link Purchases.getCustomerInfo} under the hood.
   * @param entitlementIdentifier - The entitlement identifier you want to check.
   * @returns Whether the user is entitled to the specified entitlement
   * @throws {@link PurchasesError} if there is an error while fetching the customer info.
   * @see {@link Purchases.getCustomerInfo}
   */
  async isEntitledTo(r) {
    const t = await this.getCustomerInfo();
    return r in t.entitlements.active;
  }
  /**
   * Method to perform a purchase for a given package. You can obtain the
   * package from {@link Purchases.getOfferings}. This method will present the purchase
   * form on your site, using the given HTML element as the mount point, if
   * provided, or as a modal if not.
   * @deprecated - please use .purchase
   * @param rcPackage - The package you want to purchase. Obtained from {@link Purchases.getOfferings}.
   * @param customerEmail - The email of the user. If undefined, RevenueCat will ask the customer for their email.
   * @param htmlTarget - The HTML element where the billing view should be added. If undefined, a new div will be created at the root of the page and appended to the body.
   * @returns a Promise for the customer info after the purchase is completed successfully.
   * @throws {@link PurchasesError} if there is an error while performing the purchase. If the {@link PurchasesError.errorCode} is {@link ErrorCode.UserCancelledError}, the user cancelled the purchase.
   */
  purchasePackage(r, t, n) {
    return this.purchase({
      rcPackage: r,
      customerEmail: t,
      htmlTarget: n
    });
  }
  async presentExpressPurchaseButton(r) {
    const {
      rcPackage: t,
      purchaseOption: n,
      htmlTarget: a,
      customerEmail: o,
      selectedLocale: s = Ar,
      defaultLocale: l = Ar,
      onButtonReady: c = () => {
      }
    } = r;
    if (a === void 0)
      throw new Error(
        "htmlTarget is required for presentExpressPurchaseButton"
      );
    const u = this._appUserId;
    if (!cs(this._API_KEY))
      throw new Error(
        "The Express Purchase button is only available with Web Billing API Keys."
      );
    const d = n ?? t.webBillingProduct.defaultPurchaseOption, _ = { ...this._flags.autoCollectUTMAsMetadata ? Ai() : {}, ...r.metadata || {} }, g = new En({}, s, l);
    return new Promise((f, w) => {
      const k = async (h) => {
        const v = dc({
          redemptionInfo: h.redemptionInfo,
          mode: "express_purchase_button"
        });
        this.eventsTracker.trackSDKEvent(v), se.debugLog("Purchase finished");
        const y = {
          customerInfo: await this._getCustomerInfoForUserId(u),
          redemptionInfo: h.redemptionInfo,
          operationSessionId: h.operationSessionId,
          storeTransaction: {
            storeTransactionId: h.storeTransactionIdentifier,
            productIdentifier: t.webBillingProduct.identifier,
            purchaseDate: h.purchaseDate
          }
        };
        f(y);
      }, m = (h) => {
        var y;
        const v = pc({
          errorCode: (y = h.errorCode) == null ? void 0 : y.toString(),
          errorMessage: h.message,
          mode: "express_purchase_button"
        });
        this.eventsTracker.trackSDKEvent(v), w(h);
      };
      new r1(a, c, {
        appUserId: u,
        rcPackage: t,
        purchaseOption: d,
        customerEmail: o,
        purchases: this,
        eventsTracker: this.eventsTracker,
        brandingInfo: this._brandingInfo,
        purchaseOperationHelper: this.purchaseOperationHelper,
        metadata: _,
        customTranslations: r.labelsOverride,
        translator: g,
        onFinished: k,
        onError: m
      });
    });
  }
  async purchase(r) {
    if (gn(this._API_KEY)) {
      const n = await VP(
        r,
        this.backend,
        this._appUserId
      );
      return this.inMemoryCache.invalidateAllCaches(), n;
    }
    return Gd(this._API_KEY) ? await this.performPaddlePurchase(r) : await this.performWebBillingPurchase(r);
  }
  async performWebBillingPurchase(r) {
    var y;
    const {
      rcPackage: t,
      purchaseOption: n,
      htmlTarget: a,
      customerEmail: o,
      workflowPurchaseContext: s,
      selectedLocale: l = Ar,
      defaultLocale: c = Ar,
      skipSuccessPage: u = !1
    } = r, d = this.resolveHTMLTarget(a), p = this._appUserId;
    se.debugLog(
      `Presenting purchase form for package ${t.identifier}`
    );
    const _ = l || c, g = n ?? t.webBillingProduct.defaultPurchaseOption, f = Ji({
      appearance: (y = this._brandingInfo) == null ? void 0 : y.appearance,
      rcPackage: t,
      purchaseOptionToUse: g,
      customerEmail: o
    });
    this.eventsTracker.trackSDKEvent(f);
    const k = { ...this._flags.autoCollectUTMAsMetadata ? Ai() : {}, ...r.metadata || {} };
    let m = null;
    const h = this._brandingInfo;
    h && r.brandingAppearanceOverride && (h.appearance = r.brandingAppearanceOverride);
    const v = a !== void 0;
    return new Promise((E, S) => {
      const P = lo();
      v || P.history.pushState({ checkoutOpen: !0 }, "");
      const x = () => {
        m && _o(m), d.innerHTML = "";
      }, I = this.createCheckoutOnCloseHandler(
        S,
        x
      );
      !v && I && P.addEventListener("popstate", I);
      const q = this.createCheckoutOnFinishedHandler(
        E,
        p,
        t,
        x
      ), N = this.createCheckoutOnErrorHandler(
        S,
        x
      );
      m = Ea(Zk, {
        target: d,
        props: {
          isInElement: v,
          appUserId: p,
          rcPackage: t,
          purchaseOption: g,
          customerEmail: o,
          workflowPurchaseContext: s,
          paywallId: r.paywallId,
          onFinished: q,
          onClose: I,
          onError: N,
          purchases: this,
          eventsTracker: this.eventsTracker,
          brandingInfo: this._brandingInfo,
          purchaseOperationHelper: this.purchaseOperationHelper,
          selectedLocale: _,
          metadata: k,
          defaultLocale: c,
          customTranslations: r.labelsOverride,
          termsAndConditionsUrl: r.termsAndConditionsUrl,
          skipSuccessPage: u
        }
      });
    });
  }
  async performPaddlePurchase(r) {
    var v;
    const {
      rcPackage: t,
      purchaseOption: n,
      customerEmail: a,
      selectedLocale: o = Ar,
      defaultLocale: s = Ar,
      skipSuccessPage: l = !1,
      htmlTarget: c
    } = r, u = this.resolveHTMLTarget(c), d = this._appUserId;
    se.debugLog(
      `Presenting Paddle checkout for package ${t.identifier}`
    );
    const p = n ?? t.webBillingProduct.defaultPurchaseOption, g = {
      source: "paddle",
      ...this._flags.autoCollectUTMAsMetadata ? Ai() : {},
      ...r.metadata || {}
    }, f = this._brandingInfo;
    f && r.brandingAppearanceOverride && (f.appearance = r.brandingAppearanceOverride);
    const w = Ji({
      appearance: (v = this._brandingInfo) == null ? void 0 : v.appearance,
      rcPackage: t,
      purchaseOptionToUse: p,
      customerEmail: a
    });
    this.eventsTracker.trackSDKEvent(w);
    const k = new yw(this.backend, this.eventsTracker);
    let m = null;
    const h = c !== void 0;
    return new Promise((y, E) => {
      const S = lo();
      h || S.history.pushState({ checkoutOpen: !0 }, "");
      const P = () => {
        m && _o(m), u.innerHTML = "";
      }, x = this.createCheckoutOnCloseHandler(E, P) ?? // Always unmount PaddlePurchaseUi when the user closes the checkout modal
      (() => {
        P();
      }), I = this.createCheckoutOnFinishedHandler(
        y,
        d,
        t,
        P
      ), q = this.createCheckoutOnErrorHandler(E);
      m || (m = Ea(Sw, {
        target: u,
        props: {
          eventsTracker: this.eventsTracker,
          brandingInfo: this._brandingInfo,
          selectedLocale: o || s,
          defaultLocale: s,
          customTranslations: r.labelsOverride,
          isInElement: h,
          onClose: x,
          onFinished: I,
          onError: q,
          skipSuccessPage: l,
          productDetails: t.webBillingProduct,
          rcPackage: t,
          appUserId: d,
          purchaseOption: p,
          customerEmail: a,
          metadata: g,
          unmountPaddlePurchaseUi: P,
          paddleService: k
        }
      }));
    });
  }
  /**
   * Uses htmlTarget if provided. Otherwise, looks for an element with id "rcb-ui-root".
   * If no element is found, creates a new div with className "rcb-ui-root".
   */
  resolveHTMLTarget(r) {
    const t = ds();
    let n = r ?? t.getElementById("rcb-ui-root");
    if (n === null) {
      const a = t.createElement("div");
      a.className = "rcb-ui-root", t.body.appendChild(a), n = a;
    }
    if (n === null)
      throw new Error(
        "Could not generate a mount point for the billing widget"
      );
    return n;
  }
  createCheckoutOnCloseHandler(r, t) {
    if (this._flags.rcSource && jP.includes(this._flags.rcSource))
      return;
    const a = () => {
      const o = vd();
      this.eventsTracker.trackSDKEvent(o), lo().removeEventListener("popstate", a), t == null || t(), se.debugLog("Purchase cancelled by user"), r(new Oe(Ge.UserCancelledError));
    };
    return a;
  }
  createCheckoutOnFinishedHandler(r, t, n, a) {
    return async (s) => {
      const l = dc({
        redemptionInfo: s.redemptionInfo
      });
      this.eventsTracker.trackSDKEvent(l), this.inMemoryCache.invalidateAllCaches(), se.debugLog("Purchase finished"), a == null || a();
      const c = {
        customerInfo: await this._getCustomerInfoForUserId(t),
        redemptionInfo: s.redemptionInfo,
        operationSessionId: s.operationSessionId,
        storeTransaction: {
          storeTransactionId: s.storeTransactionIdentifier,
          productIdentifier: n.webBillingProduct.identifier,
          purchaseDate: s.purchaseDate
        }
      };
      r(c);
    };
  }
  createCheckoutOnErrorHandler(r, t) {
    return (a) => {
      var s;
      const o = pc({
        errorCode: (s = a.errorCode) == null ? void 0 : s.toString(),
        errorMessage: a.message
      });
      this.eventsTracker.trackSDKEvent(o), t == null || t(), r(Oe.getForPurchasesFlowError(a));
    };
  }
  /**
   * Used by internal RC code to detect if used a test store API key.
   * @internal
   */
  _isConfiguredWithSimulatedStore() {
    return gn(this._API_KEY);
  }
  /**
   * Whether wallet methods should be force-enabled in the Express Checkout Element.
   * @internal
   */
  _shouldForceEnableWalletMethods() {
    return !!this._flags.forceEnableWalletMethods;
  }
  /**
   * Posts a simulated store receipt to the server.
   * @internal
   * @param product - The product for which we want to post the receipt for.
   * @returns Promise<PurchaseResult>
   */
  async _postSimulatedStoreReceipt(r) {
    if (!gn(this._API_KEY))
      throw new Oe(
        Ge.ConfigurationError,
        "Posting a test store receipt is only available for RC Test Store API keys."
      );
    return await up(
      r,
      this.backend,
      this._appUserId,
      void 0
    );
  }
  /**
   * Gets latest available {@link CustomerInfo}.
   * @returns The latest {@link CustomerInfo}.
   * @throws {@link PurchasesError} if there is an error while fetching the customer info.
   */
  async getCustomerInfo() {
    return await this._getCustomerInfoForUserId(this._appUserId);
  }
  /**
   * Gets the current app user id.
   */
  getAppUserId() {
    return this._appUserId;
  }
  /**
   * Sets attributes for the current user. Attributes are useful for storing additional, structured information on a customer that can be used elsewhere in the system.
   * For example, you could store your customer's email address or additional system identifiers through the applicable reserved attributes, or store arbitrary facts like onboarding survey responses, feature usage, or other dimensions as custom attributes.
   *
   * Note: Unlike our mobile SDKs, the web SDK does not cache or retry sending attributes if the request fails. If the request fails, the attributes will not be saved and you will need to retry the operation.
   *
   * @param attributes - A dictionary of attributes to set for the current user.
   * @throws {@link PurchasesError} if there is an error while setting the attributes or if the customer doesn't exist.
   */
  async setAttributes(r) {
    return await this.getCustomerInfo(), await this.backend.setAttributes(this._appUserId, r);
  }
  /**
   * Change the current app user id. Returns the customer info for the new
   * user id.
   * @param newAppUserId - The user id to change to.
   */
  async changeUser(r) {
    return await this.replaceUserId(r), await this.getCustomerInfo();
  }
  /**
   * Identifies the current user ID with the provided appUserId, as long as the
   * previous user ID is an anonymous user ID. This will create an alias
   * between the two user ids in RevenueCat and replace the current user ID used.
   * If the old user ID is not anonymous, this method will change the current
   * user ID to the given appUserId without creating an alias.
   * @returns The customer info for the new user ID.
   * @throws {@link PurchasesError} if there is an error while performing the aliasing or fetching the customer info.
   * @param appUserId - The new user ID to identify the current user as.
   * @experimental
   */
  async identifyUser(r) {
    if (Ci(r), r === this._appUserId)
      return se.debugLog(
        `aliasUser called with the current appUserID: ${r}. Ignoring.`
      ), {
        customerInfo: await this.getCustomerInfo(),
        wasCreated: !1
      };
    const t = await this.backend.identify(this._appUserId, r);
    return await this.replaceUserId(r), {
      customerInfo: ls(t),
      wasCreated: t.was_created
    };
  }
  async replaceUserId(r) {
    Ci(r), this._appUserId = r, await this.eventsTracker.updateUser(r), this.inMemoryCache.invalidateAllCaches();
  }
  /** @internal */
  logMissingProductIds(r, t) {
    const n = {};
    t.forEach(
      (o) => n[o.identifier] = o
    );
    const a = [];
    r.forEach((o) => {
      n[o] === void 0 && a.push(o);
    }), a.length > 0 && se.debugLog(
      `Could not find product data for product ids:
        ${a.join()}.
        Please check that your product configuration is correct.`
    );
  }
  /**
   * @returns Whether the SDK is using a sandbox API Key.
   */
  isSandbox() {
    return Io(this._API_KEY) || gn(this._API_KEY);
  }
  /**
   * @returns Whether the current user is anonymous.
   */
  isAnonymous() {
    return this._appUserId.startsWith(Cc);
  }
  /**
   * Fetches the virtual currencies for the current subscriber.
   *
   * @returns {Promise<VirtualCurrencies>} A VirtualCurrencies object containing the subscriber's virtual currencies.
   */
  async getVirtualCurrencies() {
    return await this._getVirtualCurrenciesForUserId(this._appUserId);
  }
  /**
   * The currently cached {@link VirtualCurrencies} if one is available.
   * This value will remain null until virtual currencies have been fetched at
   * least once with {@link Purchases.getVirtualCurrencies} or an equivalent function.
   *
   * @returns {VirtualCurrencies | null} A {@link VirtualCurrencies} object containing the subscriber's virtual currencies,
   * or null if no cached data is available.
   */
  getCachedVirtualCurrencies() {
    return this.inMemoryCache.getCachedVirtualCurrencies(this._appUserId, !0);
  }
  /**
   * Invalidates the cache for virtual currencies.
   *
   * This is useful for cases where a virtual currency's balance might have been updated
   * in a different part of your system, like if you decreased a user's balance from the user spending a virtual currency,
   * or if you increased the balance from your backend using the server APIs.
   */
  invalidateVirtualCurrenciesCache() {
    this.inMemoryCache.invalidateVirtualCurrenciesCache(this._appUserId);
  }
  /**
   * Closes the Purchases instance. You should never have to do this normally.
   */
  close() {
    Je.instance === this ? (this.eventsTracker && this.eventsTracker.dispose(), Je.instance = void 0) : se.warnLog(
      "Trying to close a Purchases instance that is not the current instance. Ignoring."
    );
  }
  /** @internal */
  async _getCustomerInfoForUserId(r) {
    const t = await this.backend.getCustomerInfo(r);
    return ls(t);
  }
  /** @internal  */
  async _getVirtualCurrenciesForUserId(r) {
    const t = this.inMemoryCache.getCachedVirtualCurrencies(r);
    if (t)
      return se.debugLog("Vending VirtualCurrencies from cache."), t;
    const n = await this.backend.getVirtualCurrencies(r), a = YP(n);
    return se.debugLog("VirtualCurrencies updated from the network."), this.inMemoryCache.cacheVirtualCurrencies(r, a), a;
  }
  /**
   * Generates an anonymous app user ID that follows RevenueCat's format.
   * This can be used when you don't have a user identifier system in place.
   * The generated ID will be in the format: $RCAnonymousID:\<UUID without dashes\>
   * Example: $RCAnonymousID:123e4567e89b12d3a456426614174000
   * @returns A new anonymous app user ID string
   * @public
   */
  static generateRevenueCatAnonymousAppUserId() {
    return `${Cc}${qa().replace(/-/g, "")}`;
  }
  /**
   * Track an event.
   * @param props - The properties of the event.
   * @internal
   */
  _trackEvent(r) {
    this.eventsTracker.trackExternalEvent(r);
  }
  /**
   * Immediately flush all pending events to the server.
   *
   * This method is useful before programmatic navigation to ensure events are delivered.
   * The SDK uses fetch with keepalive:true to allow delivery during navigation, but
   * calling this method before navigation provides additional reliability.
   *
   * Notes:
   * - Temporarily stops automatic event flushing, then restarts after completion
   * - Events are sent in batches if the payload exceeds the keepalive size limit (50KB)
   * - If a batch fails, remaining batches will not be attempted
   * - Safe to call multiple times; concurrent calls will be serialized
   * - Returns immediately if tracker is disposed
   *
   * @returns Promise that resolves when all events have been flushed or an error occurs
   * @internal
   */
  _flushAllEvents() {
    return this.eventsTracker.flushAllEvents();
  }
};
co = ol(null), Zo(co, 1, "presentExpressPurchaseButton", Fc, Je), Zo(co, 1, "purchase", qc, Je), Xo(co, Je), /** @internal */
U(Je, "_platformInfo"), /** @internal */
U(Je, "instance");
let ps = Je;
export {
  o1 as CustomVariableValue,
  Ge as ErrorCode,
  Mr as LogLevel,
  ap as OfferingKeyword,
  Bb as PackageType,
  ce as PeriodUnit,
  ct as ProductType,
  ps as Purchases,
  Oe as PurchasesError,
  t1 as ReservedCustomerAttribute,
  ng as UninitializedPurchasesError
};
